function zf() {
  const s = document.createElement("div");
  s.style.visibility = "hidden", s.style.overflow = "scroll", document.body.appendChild(s);
  const e = document.createElement("div");
  s.appendChild(e);
  const t = s.offsetWidth - e.offsetWidth;
  return s.parentNode?.removeChild(s), t;
}
const Vf = zf();
document.documentElement.style.setProperty(
  "--vh-scrollbar-width",
  `${Vf}px`
);
const ya = globalThis, yc = ya.ShadowRoot && (ya.ShadyCSS === void 0 || ya.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, bc = /* @__PURE__ */ Symbol(), Sh = /* @__PURE__ */ new WeakMap();
let uu = class {
  constructor(e, t, i) {
    if (this._$cssResult$ = !0, i !== bc) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
    this.cssText = e, this.t = t;
  }
  get styleSheet() {
    let e = this.o;
    const t = this.t;
    if (yc && e === void 0) {
      const i = t !== void 0 && t.length === 1;
      i && (e = Sh.get(t)), e === void 0 && ((this.o = e = new CSSStyleSheet()).replaceSync(this.cssText), i && Sh.set(t, e));
    }
    return e;
  }
  toString() {
    return this.cssText;
  }
};
const We = (s) => new uu(typeof s == "string" ? s : s + "", void 0, bc), Je = (s, ...e) => {
  const t = s.length === 1 ? s[0] : e.reduce((i, n, r) => i + ((a) => {
    if (a._$cssResult$ === !0) return a.cssText;
    if (typeof a == "number") return a;
    throw Error("Value passed to 'css' function must be a 'css' function result: " + a + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
  })(n) + s[r + 1], s[0]);
  return new uu(t, s, bc);
}, Hf = (s, e) => {
  if (yc) s.adoptedStyleSheets = e.map((t) => t instanceof CSSStyleSheet ? t : t.styleSheet);
  else for (const t of e) {
    const i = document.createElement("style"), n = ya.litNonce;
    n !== void 0 && i.setAttribute("nonce", n), i.textContent = t.cssText, s.appendChild(i);
  }
}, Mh = yc ? (s) => s : (s) => s instanceof CSSStyleSheet ? ((e) => {
  let t = "";
  for (const i of e.cssRules) t += i.cssText;
  return We(t);
})(s) : s;
const { is: $f, defineProperty: Gf, getOwnPropertyDescriptor: qf, getOwnPropertyNames: Wf, getOwnPropertySymbols: Xf, getPrototypeOf: jf } = Object, io = globalThis, Th = io.trustedTypes, Yf = Th ? Th.emptyScript : "", Kf = io.reactiveElementPolyfillSupport, fr = (s, e) => s, Da = { toAttribute(s, e) {
  switch (e) {
    case Boolean:
      s = s ? Yf : null;
      break;
    case Object:
    case Array:
      s = s == null ? s : JSON.stringify(s);
  }
  return s;
}, fromAttribute(s, e) {
  let t = s;
  switch (e) {
    case Boolean:
      t = s !== null;
      break;
    case Number:
      t = s === null ? null : Number(s);
      break;
    case Object:
    case Array:
      try {
        t = JSON.parse(s);
      } catch {
        t = null;
      }
  }
  return t;
} }, wc = (s, e) => !$f(s, e), Eh = { attribute: !0, type: String, converter: Da, reflect: !1, useDefault: !1, hasChanged: wc };
Symbol.metadata ??= /* @__PURE__ */ Symbol("metadata"), io.litPropertyMetadata ??= /* @__PURE__ */ new WeakMap();
let Ss = class extends HTMLElement {
  static addInitializer(e) {
    this._$Ei(), (this.l ??= []).push(e);
  }
  static get observedAttributes() {
    return this.finalize(), this._$Eh && [...this._$Eh.keys()];
  }
  static createProperty(e, t = Eh) {
    if (t.state && (t.attribute = !1), this._$Ei(), this.prototype.hasOwnProperty(e) && ((t = Object.create(t)).wrapped = !0), this.elementProperties.set(e, t), !t.noAccessor) {
      const i = /* @__PURE__ */ Symbol(), n = this.getPropertyDescriptor(e, i, t);
      n !== void 0 && Gf(this.prototype, e, n);
    }
  }
  static getPropertyDescriptor(e, t, i) {
    const { get: n, set: r } = qf(this.prototype, e) ?? { get() {
      return this[t];
    }, set(a) {
      this[t] = a;
    } };
    return { get: n, set(a) {
      const o = n?.call(this);
      r?.call(this, a), this.requestUpdate(e, o, i);
    }, configurable: !0, enumerable: !0 };
  }
  static getPropertyOptions(e) {
    return this.elementProperties.get(e) ?? Eh;
  }
  static _$Ei() {
    if (this.hasOwnProperty(fr("elementProperties"))) return;
    const e = jf(this);
    e.finalize(), e.l !== void 0 && (this.l = [...e.l]), this.elementProperties = new Map(e.elementProperties);
  }
  static finalize() {
    if (this.hasOwnProperty(fr("finalized"))) return;
    if (this.finalized = !0, this._$Ei(), this.hasOwnProperty(fr("properties"))) {
      const t = this.properties, i = [...Wf(t), ...Xf(t)];
      for (const n of i) this.createProperty(n, t[n]);
    }
    const e = this[Symbol.metadata];
    if (e !== null) {
      const t = litPropertyMetadata.get(e);
      if (t !== void 0) for (const [i, n] of t) this.elementProperties.set(i, n);
    }
    this._$Eh = /* @__PURE__ */ new Map();
    for (const [t, i] of this.elementProperties) {
      const n = this._$Eu(t, i);
      n !== void 0 && this._$Eh.set(n, t);
    }
    this.elementStyles = this.finalizeStyles(this.styles);
  }
  static finalizeStyles(e) {
    const t = [];
    if (Array.isArray(e)) {
      const i = new Set(e.flat(1 / 0).reverse());
      for (const n of i) t.unshift(Mh(n));
    } else e !== void 0 && t.push(Mh(e));
    return t;
  }
  static _$Eu(e, t) {
    const i = t.attribute;
    return i === !1 ? void 0 : typeof i == "string" ? i : typeof e == "string" ? e.toLowerCase() : void 0;
  }
  constructor() {
    super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
  }
  _$Ev() {
    this._$ES = new Promise((e) => this.enableUpdating = e), this._$AL = /* @__PURE__ */ new Map(), this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((e) => e(this));
  }
  addController(e) {
    (this._$EO ??= /* @__PURE__ */ new Set()).add(e), this.renderRoot !== void 0 && this.isConnected && e.hostConnected?.();
  }
  removeController(e) {
    this._$EO?.delete(e);
  }
  _$E_() {
    const e = /* @__PURE__ */ new Map(), t = this.constructor.elementProperties;
    for (const i of t.keys()) this.hasOwnProperty(i) && (e.set(i, this[i]), delete this[i]);
    e.size > 0 && (this._$Ep = e);
  }
  createRenderRoot() {
    const e = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
    return Hf(e, this.constructor.elementStyles), e;
  }
  connectedCallback() {
    this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(!0), this._$EO?.forEach((e) => e.hostConnected?.());
  }
  enableUpdating(e) {
  }
  disconnectedCallback() {
    this._$EO?.forEach((e) => e.hostDisconnected?.());
  }
  attributeChangedCallback(e, t, i) {
    this._$AK(e, i);
  }
  _$ET(e, t) {
    const i = this.constructor.elementProperties.get(e), n = this.constructor._$Eu(e, i);
    if (n !== void 0 && i.reflect === !0) {
      const r = (i.converter?.toAttribute !== void 0 ? i.converter : Da).toAttribute(t, i.type);
      this._$Em = e, r == null ? this.removeAttribute(n) : this.setAttribute(n, r), this._$Em = null;
    }
  }
  _$AK(e, t) {
    const i = this.constructor, n = i._$Eh.get(e);
    if (n !== void 0 && this._$Em !== n) {
      const r = i.getPropertyOptions(n), a = typeof r.converter == "function" ? { fromAttribute: r.converter } : r.converter?.fromAttribute !== void 0 ? r.converter : Da;
      this._$Em = n;
      const o = a.fromAttribute(t, r.type);
      this[n] = o ?? this._$Ej?.get(n) ?? o, this._$Em = null;
    }
  }
  requestUpdate(e, t, i, n = !1, r) {
    if (e !== void 0) {
      const a = this.constructor;
      if (n === !1 && (r = this[e]), i ??= a.getPropertyOptions(e), !((i.hasChanged ?? wc)(r, t) || i.useDefault && i.reflect && r === this._$Ej?.get(e) && !this.hasAttribute(a._$Eu(e, i)))) return;
      this.C(e, t, i);
    }
    this.isUpdatePending === !1 && (this._$ES = this._$EP());
  }
  C(e, t, { useDefault: i, reflect: n, wrapped: r }, a) {
    i && !(this._$Ej ??= /* @__PURE__ */ new Map()).has(e) && (this._$Ej.set(e, a ?? t ?? this[e]), r !== !0 || a !== void 0) || (this._$AL.has(e) || (this.hasUpdated || i || (t = void 0), this._$AL.set(e, t)), n === !0 && this._$Em !== e && (this._$Eq ??= /* @__PURE__ */ new Set()).add(e));
  }
  async _$EP() {
    this.isUpdatePending = !0;
    try {
      await this._$ES;
    } catch (t) {
      Promise.reject(t);
    }
    const e = this.scheduleUpdate();
    return e != null && await e, !this.isUpdatePending;
  }
  scheduleUpdate() {
    return this.performUpdate();
  }
  performUpdate() {
    if (!this.isUpdatePending) return;
    if (!this.hasUpdated) {
      if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
        for (const [n, r] of this._$Ep) this[n] = r;
        this._$Ep = void 0;
      }
      const i = this.constructor.elementProperties;
      if (i.size > 0) for (const [n, r] of i) {
        const { wrapped: a } = r, o = this[n];
        a !== !0 || this._$AL.has(n) || o === void 0 || this.C(n, void 0, r, o);
      }
    }
    let e = !1;
    const t = this._$AL;
    try {
      e = this.shouldUpdate(t), e ? (this.willUpdate(t), this._$EO?.forEach((i) => i.hostUpdate?.()), this.update(t)) : this._$EM();
    } catch (i) {
      throw e = !1, this._$EM(), i;
    }
    e && this._$AE(t);
  }
  willUpdate(e) {
  }
  _$AE(e) {
    this._$EO?.forEach((t) => t.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(e)), this.updated(e);
  }
  _$EM() {
    this._$AL = /* @__PURE__ */ new Map(), this.isUpdatePending = !1;
  }
  get updateComplete() {
    return this.getUpdateComplete();
  }
  getUpdateComplete() {
    return this._$ES;
  }
  shouldUpdate(e) {
    return !0;
  }
  update(e) {
    this._$Eq &&= this._$Eq.forEach((t) => this._$ET(t, this[t])), this._$EM();
  }
  updated(e) {
  }
  firstUpdated(e) {
  }
};
Ss.elementStyles = [], Ss.shadowRootOptions = { mode: "open" }, Ss[fr("elementProperties")] = /* @__PURE__ */ new Map(), Ss[fr("finalized")] = /* @__PURE__ */ new Map(), Kf?.({ ReactiveElement: Ss }), (io.reactiveElementVersions ??= []).push("2.1.2");
const Sc = globalThis, Ah = (s) => s, Na = Sc.trustedTypes, Rh = Na ? Na.createPolicy("lit-html", { createHTML: (s) => s }) : void 0, fu = "$lit$", wn = `lit$${Math.random().toFixed(9).slice(2)}$`, pu = "?" + wn, Zf = `<${pu}>`, Zn = document, vr = () => Zn.createComment(""), _r = (s) => s === null || typeof s != "object" && typeof s != "function", Mc = Array.isArray, Jf = (s) => Mc(s) || typeof s?.[Symbol.iterator] == "function", bo = `[ 	
\f\r]`, Qs = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, Ch = /-->/g, Ih = />/g, On = RegExp(`>|${bo}(?:([^\\s"'>=/]+)(${bo}*=${bo}*(?:[^ 	
\f\r"'\`<>=]|("|')|))|$)`, "g"), Ph = /'/g, Lh = /"/g, mu = /^(?:script|style|textarea|title)$/i, gu = (s) => (e, ...t) => ({ _$litType$: s, strings: e, values: t }), $ = gu(1), Dh = gu(2), An = /* @__PURE__ */ Symbol.for("lit-noChange"), Tt = /* @__PURE__ */ Symbol.for("lit-nothing"), Nh = /* @__PURE__ */ new WeakMap(), jn = Zn.createTreeWalker(Zn, 129);
function vu(s, e) {
  if (!Mc(s) || !s.hasOwnProperty("raw")) throw Error("invalid template strings array");
  return Rh !== void 0 ? Rh.createHTML(e) : e;
}
const Qf = (s, e) => {
  const t = s.length - 1, i = [];
  let n, r = e === 2 ? "<svg>" : e === 3 ? "<math>" : "", a = Qs;
  for (let o = 0; o < t; o++) {
    const l = s[o];
    let c, h, d = -1, u = 0;
    for (; u < l.length && (a.lastIndex = u, h = a.exec(l), h !== null); ) u = a.lastIndex, a === Qs ? h[1] === "!--" ? a = Ch : h[1] !== void 0 ? a = Ih : h[2] !== void 0 ? (mu.test(h[2]) && (n = RegExp("</" + h[2], "g")), a = On) : h[3] !== void 0 && (a = On) : a === On ? h[0] === ">" ? (a = n ?? Qs, d = -1) : h[1] === void 0 ? d = -2 : (d = a.lastIndex - h[2].length, c = h[1], a = h[3] === void 0 ? On : h[3] === '"' ? Lh : Ph) : a === Lh || a === Ph ? a = On : a === Ch || a === Ih ? a = Qs : (a = On, n = void 0);
    const f = a === On && s[o + 1].startsWith("/>") ? " " : "";
    r += a === Qs ? l + Zf : d >= 0 ? (i.push(c), l.slice(0, d) + fu + l.slice(d) + wn + f) : l + wn + (d === -2 ? o : f);
  }
  return [vu(s, r + (s[t] || "<?>") + (e === 2 ? "</svg>" : e === 3 ? "</math>" : "")), i];
};
let rl = class _u {
  constructor({ strings: e, _$litType$: t }, i) {
    let n;
    this.parts = [];
    let r = 0, a = 0;
    const o = e.length - 1, l = this.parts, [c, h] = Qf(e, t);
    if (this.el = _u.createElement(c, i), jn.currentNode = this.el.content, t === 2 || t === 3) {
      const d = this.el.content.firstChild;
      d.replaceWith(...d.childNodes);
    }
    for (; (n = jn.nextNode()) !== null && l.length < o; ) {
      if (n.nodeType === 1) {
        if (n.hasAttributes()) for (const d of n.getAttributeNames()) if (d.endsWith(fu)) {
          const u = h[a++], f = n.getAttribute(d).split(wn), g = /([.?@])?(.*)/.exec(u);
          l.push({ type: 1, index: r, name: g[2], strings: f, ctor: g[1] === "." ? tp : g[1] === "?" ? ip : g[1] === "@" ? np : no }), n.removeAttribute(d);
        } else d.startsWith(wn) && (l.push({ type: 6, index: r }), n.removeAttribute(d));
        if (mu.test(n.tagName)) {
          const d = n.textContent.split(wn), u = d.length - 1;
          if (u > 0) {
            n.textContent = Na ? Na.emptyScript : "";
            for (let f = 0; f < u; f++) n.append(d[f], vr()), jn.nextNode(), l.push({ type: 2, index: ++r });
            n.append(d[u], vr());
          }
        }
      } else if (n.nodeType === 8) if (n.data === pu) l.push({ type: 2, index: r });
      else {
        let d = -1;
        for (; (d = n.data.indexOf(wn, d + 1)) !== -1; ) l.push({ type: 7, index: r }), d += wn.length - 1;
      }
      r++;
    }
  }
  static createElement(e, t) {
    const i = Zn.createElement("template");
    return i.innerHTML = e, i;
  }
};
function Rs(s, e, t = s, i) {
  if (e === An) return e;
  let n = i !== void 0 ? t._$Co?.[i] : t._$Cl;
  const r = _r(e) ? void 0 : e._$litDirective$;
  return n?.constructor !== r && (n?._$AO?.(!1), r === void 0 ? n = void 0 : (n = new r(s), n._$AT(s, t, i)), i !== void 0 ? (t._$Co ??= [])[i] = n : t._$Cl = n), n !== void 0 && (e = Rs(s, n._$AS(s, e.values), n, i)), e;
}
let ep = class {
  constructor(e, t) {
    this._$AV = [], this._$AN = void 0, this._$AD = e, this._$AM = t;
  }
  get parentNode() {
    return this._$AM.parentNode;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  u(e) {
    const { el: { content: t }, parts: i } = this._$AD, n = (e?.creationScope ?? Zn).importNode(t, !0);
    jn.currentNode = n;
    let r = jn.nextNode(), a = 0, o = 0, l = i[0];
    for (; l !== void 0; ) {
      if (a === l.index) {
        let c;
        l.type === 2 ? c = new Tc(r, r.nextSibling, this, e) : l.type === 1 ? c = new l.ctor(r, l.name, l.strings, this, e) : l.type === 6 && (c = new sp(r, this, e)), this._$AV.push(c), l = i[++o];
      }
      a !== l?.index && (r = jn.nextNode(), a++);
    }
    return jn.currentNode = Zn, n;
  }
  p(e) {
    let t = 0;
    for (const i of this._$AV) i !== void 0 && (i.strings !== void 0 ? (i._$AI(e, i, t), t += i.strings.length - 2) : i._$AI(e[t])), t++;
  }
}, Tc = class xu {
  get _$AU() {
    return this._$AM?._$AU ?? this._$Cv;
  }
  constructor(e, t, i, n) {
    this.type = 2, this._$AH = Tt, this._$AN = void 0, this._$AA = e, this._$AB = t, this._$AM = i, this.options = n, this._$Cv = n?.isConnected ?? !0;
  }
  get parentNode() {
    let e = this._$AA.parentNode;
    const t = this._$AM;
    return t !== void 0 && e?.nodeType === 11 && (e = t.parentNode), e;
  }
  get startNode() {
    return this._$AA;
  }
  get endNode() {
    return this._$AB;
  }
  _$AI(e, t = this) {
    e = Rs(this, e, t), _r(e) ? e === Tt || e == null || e === "" ? (this._$AH !== Tt && this._$AR(), this._$AH = Tt) : e !== this._$AH && e !== An && this._(e) : e._$litType$ !== void 0 ? this.$(e) : e.nodeType !== void 0 ? this.T(e) : Jf(e) ? this.k(e) : this._(e);
  }
  O(e) {
    return this._$AA.parentNode.insertBefore(e, this._$AB);
  }
  T(e) {
    this._$AH !== e && (this._$AR(), this._$AH = this.O(e));
  }
  _(e) {
    this._$AH !== Tt && _r(this._$AH) ? this._$AA.nextSibling.data = e : this.T(Zn.createTextNode(e)), this._$AH = e;
  }
  $(e) {
    const { values: t, _$litType$: i } = e, n = typeof i == "number" ? this._$AC(e) : (i.el === void 0 && (i.el = rl.createElement(vu(i.h, i.h[0]), this.options)), i);
    if (this._$AH?._$AD === n) this._$AH.p(t);
    else {
      const r = new ep(n, this), a = r.u(this.options);
      r.p(t), this.T(a), this._$AH = r;
    }
  }
  _$AC(e) {
    let t = Nh.get(e.strings);
    return t === void 0 && Nh.set(e.strings, t = new rl(e)), t;
  }
  k(e) {
    Mc(this._$AH) || (this._$AH = [], this._$AR());
    const t = this._$AH;
    let i, n = 0;
    for (const r of e) n === t.length ? t.push(i = new xu(this.O(vr()), this.O(vr()), this, this.options)) : i = t[n], i._$AI(r), n++;
    n < t.length && (this._$AR(i && i._$AB.nextSibling, n), t.length = n);
  }
  _$AR(e = this._$AA.nextSibling, t) {
    for (this._$AP?.(!1, !0, t); e !== this._$AB; ) {
      const i = Ah(e).nextSibling;
      Ah(e).remove(), e = i;
    }
  }
  setConnected(e) {
    this._$AM === void 0 && (this._$Cv = e, this._$AP?.(e));
  }
};
class no {
  get tagName() {
    return this.element.tagName;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  constructor(e, t, i, n, r) {
    this.type = 1, this._$AH = Tt, this._$AN = void 0, this.element = e, this.name = t, this._$AM = n, this.options = r, i.length > 2 || i[0] !== "" || i[1] !== "" ? (this._$AH = Array(i.length - 1).fill(new String()), this.strings = i) : this._$AH = Tt;
  }
  _$AI(e, t = this, i, n) {
    const r = this.strings;
    let a = !1;
    if (r === void 0) e = Rs(this, e, t, 0), a = !_r(e) || e !== this._$AH && e !== An, a && (this._$AH = e);
    else {
      const o = e;
      let l, c;
      for (e = r[0], l = 0; l < r.length - 1; l++) c = Rs(this, o[i + l], t, l), c === An && (c = this._$AH[l]), a ||= !_r(c) || c !== this._$AH[l], c === Tt ? e = Tt : e !== Tt && (e += (c ?? "") + r[l + 1]), this._$AH[l] = c;
    }
    a && !n && this.j(e);
  }
  j(e) {
    e === Tt ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, e ?? "");
  }
}
let tp = class extends no {
  constructor() {
    super(...arguments), this.type = 3;
  }
  j(e) {
    this.element[this.name] = e === Tt ? void 0 : e;
  }
};
class ip extends no {
  constructor() {
    super(...arguments), this.type = 4;
  }
  j(e) {
    this.element.toggleAttribute(this.name, !!e && e !== Tt);
  }
}
let np = class extends no {
  constructor(e, t, i, n, r) {
    super(e, t, i, n, r), this.type = 5;
  }
  _$AI(e, t = this) {
    if ((e = Rs(this, e, t, 0) ?? Tt) === An) return;
    const i = this._$AH, n = e === Tt && i !== Tt || e.capture !== i.capture || e.once !== i.once || e.passive !== i.passive, r = e !== Tt && (i === Tt || n);
    n && this.element.removeEventListener(this.name, this, i), r && this.element.addEventListener(this.name, this, e), this._$AH = e;
  }
  handleEvent(e) {
    typeof this._$AH == "function" ? this._$AH.call(this.options?.host ?? this.element, e) : this._$AH.handleEvent(e);
  }
};
class sp {
  constructor(e, t, i) {
    this.element = e, this.type = 6, this._$AN = void 0, this._$AM = t, this.options = i;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AI(e) {
    Rs(this, e);
  }
}
const rp = Sc.litHtmlPolyfillSupport;
rp?.(rl, Tc), (Sc.litHtmlVersions ??= []).push("3.3.2");
const ap = (s, e, t) => {
  const i = t?.renderBefore ?? e;
  let n = i._$litPart$;
  if (n === void 0) {
    const r = t?.renderBefore ?? null;
    i._$litPart$ = n = new Tc(e.insertBefore(vr(), r), r, void 0, t ?? {});
  }
  return n._$AI(s), n;
};
const Ec = globalThis;
let Ie = class extends Ss {
  constructor() {
    super(...arguments), this.renderOptions = { host: this }, this._$Do = void 0;
  }
  createRenderRoot() {
    const e = super.createRenderRoot();
    return this.renderOptions.renderBefore ??= e.firstChild, e;
  }
  update(e) {
    const t = this.render();
    this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(e), this._$Do = ap(t, this.renderRoot, this.renderOptions);
  }
  connectedCallback() {
    super.connectedCallback(), this._$Do?.setConnected(!0);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this._$Do?.setConnected(!1);
  }
  render() {
    return An;
  }
};
Ie._$litElement$ = !0, Ie.finalized = !0, Ec.litElementHydrateSupport?.({ LitElement: Ie });
const op = Ec.litElementPolyfillSupport;
op?.({ LitElement: Ie });
(Ec.litElementVersions ??= []).push("4.2.2");
const Oe = (s) => (e, t) => {
  t !== void 0 ? t.addInitializer(() => {
    customElements.define(s, e);
  }) : customElements.define(s, e);
};
const lp = { attribute: !0, type: String, converter: Da, reflect: !1, hasChanged: wc }, cp = (s = lp, e, t) => {
  const { kind: i, metadata: n } = t;
  let r = globalThis.litPropertyMetadata.get(n);
  if (r === void 0 && globalThis.litPropertyMetadata.set(n, r = /* @__PURE__ */ new Map()), i === "setter" && ((s = Object.create(s)).wrapped = !0), r.set(t.name, s), i === "accessor") {
    const { name: a } = t;
    return { set(o) {
      const l = e.get.call(this);
      e.set.call(this, o), this.requestUpdate(a, l, s, !0, o);
    }, init(o) {
      return o !== void 0 && this.C(a, void 0, s, o), o;
    } };
  }
  if (i === "setter") {
    const { name: a } = t;
    return function(o) {
      const l = this[a];
      e.call(this, o), this.requestUpdate(a, l, s, !0, o);
    };
  }
  throw Error("Unsupported decorator location: " + i);
};
function D(s) {
  return (e, t) => typeof t == "object" ? cp(s, e, t) : ((i, n, r) => {
    const a = n.hasOwnProperty(r);
    return n.constructor.createProperty(r, i), a ? Object.getOwnPropertyDescriptor(n, r) : void 0;
  })(s, e, t);
}
function ft(s) {
  return D({ ...s, state: !0, attribute: !1 });
}
const yu = (s, e, t) => (t.configurable = !0, t.enumerable = !0, Reflect.decorate && typeof e != "object" && Object.defineProperty(s, e, t), t);
function Gs(s, e) {
  return (t, i, n) => {
    const r = (a) => a.renderRoot?.querySelector(s) ?? null;
    return yu(t, i, { get() {
      return r(this);
    } });
  };
}
let hp;
function dp(s) {
  return (e, t) => yu(e, t, { get() {
    return (this.renderRoot ?? (hp ??= document.createDocumentFragment())).querySelectorAll(s);
  } });
}
const bu = { ATTRIBUTE: 1, CHILD: 2 }, Ac = (s) => (...e) => ({ _$litDirective$: s, values: e });
let Rc = class {
  constructor(e) {
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AT(e, t, i) {
    this._$Ct = e, this._$AM = t, this._$Ci = i;
  }
  _$AS(e, t) {
    return this.update(e, t);
  }
  update(e, t) {
    return this.render(...t);
  }
};
const Ze = Ac(class extends Rc {
  constructor(s) {
    if (super(s), s.type !== bu.ATTRIBUTE || s.name !== "class" || s.strings?.length > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
  }
  render(s) {
    return " " + Object.keys(s).filter((e) => s[e]).join(" ") + " ";
  }
  update(s, [e]) {
    if (this.st === void 0) {
      this.st = /* @__PURE__ */ new Set(), s.strings !== void 0 && (this.nt = new Set(s.strings.join(" ").split(/\s/).filter((i) => i !== "")));
      for (const i in e) e[i] && !this.nt?.has(i) && this.st.add(i);
      return this.render(e);
    }
    const t = s.element.classList;
    for (const i of this.st) i in e || (t.remove(i), this.st.delete(i));
    for (const i in e) {
      const n = !!e[i];
      n === this.st.has(i) || this.nt?.has(i) || (n ? (t.add(i), this.st.add(i)) : (t.remove(i), this.st.delete(i)));
    }
    return An;
  }
});
let al = class extends Rc {
  constructor(e) {
    if (super(e), this.it = Tt, e.type !== bu.CHILD) throw Error(this.constructor.directiveName + "() can only be used in child bindings");
  }
  render(e) {
    if (e === Tt || e == null) return this._t = void 0, this.it = e;
    if (e === An) return e;
    if (typeof e != "string") throw Error(this.constructor.directiveName + "() called with a non-string value");
    if (e === this.it) return this._t;
    this.it = e;
    const t = [e];
    return t.raw = t, this._t = { _$litType$: this.constructor.resultType, strings: t, values: [] };
  }
};
al.directiveName = "unsafeHTML", al.resultType = 1;
const Qe = Ac(al), up = ".vh-microsite-tout{padding:80px 24px;overflow:hidden}@media screen and (min-width:810px){.vh-microsite-tout{overflow:visible;padding:100px 24px}}.vh-microsite-tout__inner{margin:0 auto;text-align:center;display:flex;flex-direction:column;gap:24px;max-width:960px}@media screen and (min-width:810px){.vh-microsite-tout__inner{gap:40px}}.vh-microsite-tout__heading{font-family:var(--vh-font-feature-display-condensed);font-size:54px;font-style:normal;font-weight:400;line-height:1}@media screen and (min-width:810px){.vh-microsite-tout__heading{font-size:62px}}.vh-microsite-tout__heading{color:var(--vh-color-navy);margin:0;padding:0}.vh-microsite-tout__heading strong{font-style:italic}h1.vh-microsite-tout__heading{font-family:var(--vh-font-feature-display-condensed);font-size:44px;font-style:normal;font-weight:400;line-height:1}@media screen and (min-width:810px){h1.vh-microsite-tout__heading{font-size:92px}}.vh-microsite-tout__body{color:var(--vh-color-navy);font-family:var(--vh-font-poppins);font-size:16px;font-style:normal;font-weight:400;line-height:1.5}.vh-microsite-tout__body p{margin-top:0}.vh-microsite-tout__content{display:flex;flex-direction:column;gap:16px}.vh-microsite-tout__list{list-style:none;padding:0;margin:0;display:flex;flex-direction:column;gap:8px;align-items:center}@media screen and (min-width:810px){.vh-microsite-tout__list{gap:16px;flex-direction:row;justify-content:center}}.vh-microsite-tout__list-item{font-family:var(--vh-font-poppins);font-size:16px;font-style:normal;font-weight:400;line-height:1.5;display:flex;align-items:center;gap:8px;color:var(--vh-color-navy)}.vh-microsite-tout__inner--pre-animate .vh-microsite-tout__heading,.vh-microsite-tout__inner--pre-animate .vh-microsite-tout__body,.vh-microsite-tout__inner--pre-animate .vh-microsite-tout__list-item{opacity:0}.vh-microsite-tout__list-item--animate{opacity:0;animation:fadeInFromRight 1s ease-out forwards;animation-delay:calc(.5s + var(--animation-order) * .2s)}.vh-microsite-tout__inner--animate-text .vh-microsite-tout__heading{opacity:0;animation:fadeInFromRight 1s ease-out forwards}.vh-microsite-tout__inner--animate-text .vh-microsite-tout__body{opacity:0;animation:fadeInFromRight 1s ease-out forwards;animation-delay:1.2s}@keyframes fadeInFromRight{0%{opacity:0;transform:translate(50px)}to{opacity:1;transform:translate(0)}}";
var fp = Object.defineProperty, pp = Object.getOwnPropertyDescriptor, is = (s, e, t, i) => {
  for (var n = i > 1 ? void 0 : i ? pp(e, t) : e, r = s.length - 1, a; r >= 0; r--)
    (a = s[r]) && (n = (i ? a(e, t, n) : a(n)) || n);
  return i && n && fp(e, t, n), n;
};
let ln = class extends Ie {
  constructor() {
    super(...arguments), this.headingLevel = 2, this.animateIn = !1, this.isVisible = !1;
  }
  connectedCallback() {
    super.connectedCallback(), this.animateIn && this.setupIntersectionObserver();
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.observer?.disconnect();
  }
  setupIntersectionObserver() {
    this.observer = new IntersectionObserver(
      (s) => {
        s.forEach((e) => {
          e.isIntersecting && !this.isVisible && (this.isVisible = !0);
        });
      },
      {
        threshold: 0.3
      }
    );
  }
  firstUpdated() {
    if (this.animateIn) {
      const s = this.shadowRoot?.querySelector(".vh-microsite-tout");
      s && this.observer && this.observer.observe(s);
    }
  }
  render() {
    const s = this.animateIn && this.isVisible;
    return $`
      <section class="vh-microsite-tout">
      <div class=${Ze({
      "vh-microsite-tout__inner": !0,
      "vh-microsite-tout__inner--pre-animate": this.animateIn,
      "vh-microsite-tout__inner--animate-text": s
    })}>
          ${this.headingLevel === 1 ? $`<h1 class="vh-microsite-tout__heading">${Qe(this.heading)}</h1>` : this.headingLevel === 2 ? $`<h2 class="vh-microsite-tout__heading">${Qe(this.heading)}</h2>` : this.headingLevel === 3 ? $`<h3 class="vh-microsite-tout__heading">${Qe(this.heading)}</h3>` : this.headingLevel === 4 ? $`<h4 class="vh-microsite-tout__heading">${Qe(this.heading)}</h4>` : this.headingLevel === 5 ? $`<h5 class="vh-microsite-tout__heading">${Qe(this.heading)}</h5>` : $`<h6 class="vh-microsite-tout__heading">${Qe(this.heading)}</h6>`}
          <div class="vh-microsite-tout__content">
            ${this.list?.length ? $`<ul class="vh-microsite-tout__list">${this.list.map((e, t) => $`<li class=${Ze({ "vh-microsite-tout__list-item": !0, "vh-microsite-tout__list-item--animate": s })} style="--animation-order: ${t + 1}"><vh-icon-checkmark></vh-icon-checkmark> ${Qe(e)}</li>`)}</ul>` : ""}
            <div class="vh-microsite-tout__body">${Qe(this.body)}</div>
          </div>
      </div>
      </section>
    `;
  }
};
ln.styles = Je`
    ${We(up)}
  `;
is([
  D()
], ln.prototype, "heading", 2);
is([
  D({ type: Number })
], ln.prototype, "headingLevel", 2);
is([
  D({ type: Array })
], ln.prototype, "list", 2);
is([
  D()
], ln.prototype, "body", 2);
is([
  D({ type: Boolean })
], ln.prototype, "animateIn", 2);
is([
  D({ type: Boolean })
], ln.prototype, "isVisible", 2);
ln = is([
  Oe("vh-microsite-tout")
], ln);
const mp = (s) => s ?? Tt, Cc = `.vh-microsite-button{display:inline-flex;align-items:center;justify-content:center;border-radius:60px;border:1px solid transparent;cursor:pointer;transition:all .2s ease-in-out;text-decoration:none;margin:0;padding:24px 32px;width:auto;overflow:visible;background:var(--vh-color-navy);color:var(--vh-color-white);font-family:var(--vh-font-poppins);font-size:24px;font-style:normal;font-weight:300;line-height:1}.vh-microsite-button--small{padding:12px 40px;font-size:14px;font-weight:600}.vh-microsite-button--with-arrow:after{content:"";display:block;width:24px;height:24px;background:url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="%23fff" d="M18 11.999a2 2 0 0 0-.59-1.4l-4.29-4.3a1 1 0 1 0-1.41 1.42l3.29 3.28H7a1 1 0 0 0 0 2h8l-3.29 3.29a1 1 0 0 0 1.41 1.42l4.29-4.3a2 2 0 0 0 .59-1.41"/></svg>');background-size:contain;background-repeat:no-repeat;background-position:center;margin-left:4px}.vh-microsite-button--with-download{font-weight:500}.vh-microsite-button--with-download:after{content:"";display:block;width:16px;height:16px;background:url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"><path stroke="%23fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.333" d="M8 10V2M14 10v2.667A1.334 1.334 0 0 1 12.667 14H3.333A1.334 1.334 0 0 1 2 12.667V10"/><path stroke="%23fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.333" d="M4.666 6.667 7.999 10l3.334-3.333"/></svg>');background-size:contain;background-repeat:no-repeat;background-position:center;margin-left:8px}.vh-microsite-button--green{background:var(--vh-color-green);color:var(--vh-color-white)}.vh-microsite-button--navy{background:var(--vh-color-navy);color:var(--vh-color-white)}.vh-microsite-button--transparent{background:transparent;color:var(--vh-color-navy);border-color:var(--vh-color-navy)}.vh-microsite-button--transparent.vh-microsite-button--with-arrow:after{background:url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="%23002C4E" d="M18 11.999a2 2 0 0 0-.59-1.4l-4.29-4.3a1 1 0 1 0-1.41 1.42l3.29 3.28H7a1 1 0 0 0 0 2h8l-3.29 3.29a1 1 0 0 0 1.41 1.42l4.29-4.3a2 2 0 0 0 .59-1.41"/></svg>')}.vh-microsite-button strong{font-weight:600}.vh-microsite-button:disabled{opacity:.5;cursor:not-allowed}`;
var gp = Object.defineProperty, vp = Object.getOwnPropertyDescriptor, ns = (s, e, t, i) => {
  for (var n = i > 1 ? void 0 : i ? vp(e, t) : e, r = s.length - 1, a; r >= 0; r--)
    (a = s[r]) && (n = (i ? a(e, t, n) : a(n)) || n);
  return i && n && gp(e, t, n), n;
};
let cn = class extends Ie {
  constructor() {
    super(...arguments), this.label = "", this.size = "large";
  }
  _dispatchClick() {
    this.dispatchEvent(
      new CustomEvent("button-click", {
        detail: { label: this.label },
        // Pass data to parent
        bubbles: !0,
        composed: !0
      })
    );
  }
  render() {
    const s = Ze({
      "vh-microsite-button": !0,
      [`vh-microsite-button--${this.color}`]: !!this.color,
      [`vh-microsite-button--${this.size}`]: this.size !== "large",
      "vh-microsite-button--with-arrow": this.icon === "arrow",
      "vh-microsite-button--with-download": this.icon === "download"
    });
    return this.href ? $`
      <a
        class=${s}
        href=${mp(this.href)}
        target=${this.target || "_self"}
        role="button"
      >
        ${Qe(this.label)}
      </a>
    ` : $`
        <button
          class=${s}
          type="button"
          @click=${this._dispatchClick}
        >
          ${Qe(this.label)}
        </button>
      `;
  }
};
cn.styles = Je`
    ${We(Cc)}
  `;
ns([
  D({ type: String })
], cn.prototype, "href", 2);
ns([
  D({ type: String })
], cn.prototype, "target", 2);
ns([
  D({ type: String })
], cn.prototype, "label", 2);
ns([
  D({ type: String })
], cn.prototype, "color", 2);
ns([
  D({ type: String })
], cn.prototype, "size", 2);
ns([
  D({ type: String })
], cn.prototype, "icon", 2);
cn = ns([
  Oe("vh-microsite-button")
], cn);
const _p = ".vh-microsite-badge{width:340px;border-radius:50%;background:#84c12f1a;border:2px solid var(--vh-color-white);display:flex;align-items:center;justify-content:center;flex-direction:column;box-sizing:border-box;-webkit-backdrop-filter:blur(30px);backdrop-filter:blur(30px);max-width:100%;aspect-ratio:1}@media screen and (min-width:1280px){.vh-microsite-badge--medium{width:400px}.vh-microsite-badge--medium .vh-microsite-badge__text{max-width:260px}.vh-microsite-badge--medium .vh-microsite-badge__title{font-size:48px}}@media screen and (min-width:1440px){.vh-microsite-badge--large{width:400px}}.vh-microsite-badge--large .vh-microsite-badge__text{max-width:260px}.vh-microsite-badge--large .vh-microsite-badge__title{font-size:48px}.vh-microsite-badge__text{display:flex;flex-direction:column;align-items:center;text-align:center;max-width:260px;padding:16px 0;position:relative;border-top:1px solid var(--vh-color-white);border-bottom:1px solid var(--vh-color-white);z-index:2}.vh-microsite-badge__title{font-family:var(--vh-font-feature-display-condensed);color:var(--vh-color-navy);line-height:1;font-size:48px}.vh-microsite-badge__title strong{font-style:italic;font-weight:700}";
var xp = Object.defineProperty, yp = Object.getOwnPropertyDescriptor, Ic = (s, e, t, i) => {
  for (var n = i > 1 ? void 0 : i ? yp(e, t) : e, r = s.length - 1, a; r >= 0; r--)
    (a = s[r]) && (n = (i ? a(e, t, n) : a(n)) || n);
  return i && n && xp(e, t, n), n;
};
let xr = class extends Ie {
  constructor() {
    super(...arguments), this.breakpoint = "large", this.text = "";
  }
  render() {
    return $`
      <div class=${Ze({
      "vh-microsite-badge": !0,
      "vh-microsite-badge--large": this.breakpoint === "large",
      "vh-microsite-badge--medium": this.breakpoint !== "large"
    })}>
        <div class="vh-microsite-badge__text">
          <span class="vh-microsite-badge__title">${Qe(this.text)}</span>
        </div>
      </div>
    `;
  }
};
xr.styles = Je`
    ${We(_p)}
  `;
Ic([
  D()
], xr.prototype, "breakpoint", 2);
Ic([
  D({ type: String })
], xr.prototype, "text", 2);
xr = Ic([
  Oe("vh-microsite-badge")
], xr);
const bp = "@keyframes animateUp{0%{transform:translate3d(var(--vh-balloon-x-start, 0),110vh,0)}to{transform:translate3d(var(--vh-balloon-x-end, 0),-100vh,0)}}.vh-microsite-balloon{position:absolute;transform:translate3d(var(--vh-balloon-x-start, 0),110vh,0);animation-name:animateUp;animation-duration:var(--vh-balloon-duration, 4.2s);animation-fill-mode:forwards;animation-timing-function:cubic-bezier(.25,1,.5,1);animation-delay:var(--vh-balloon-delay, 0s)}.vh-microsite-balloon__image{transform:scale(var(--vh-random-scale, 1))}";
var wp = Object.defineProperty, Sp = Object.getOwnPropertyDescriptor, Pc = (s, e, t, i) => {
  for (var n = i > 1 ? void 0 : i ? Sp(e, t) : e, r = s.length - 1, a; r >= 0; r--)
    (a = s[r]) && (n = (i ? a(e, t, n) : a(n)) || n);
  return i && n && wp(e, t, n), n;
};
let yr = class extends Ie {
  render() {
    const e = Math.random() * (this.delay ?? 0), t = Math.max(Math.random() * 7, 3.5);
    this.style.setProperty("--vh-balloon-duration", `${t}s`), this.style.setProperty("--vh-balloon-delay", `${e}s`);
    const n = Math.min(Math.random() + 0.25, 0.9).toFixed(2);
    this.style.setProperty("--vh-random-scale", n);
    const r = Math.random() * 150 - 25, a = (Math.random() - 1 + Math.random()) * 75, o = (r - a).toFixed(2);
    return this.style.setProperty(
      "--vh-balloon-x-start",
      `${r.toFixed(2)}vw`
    ), this.style.setProperty("--vh-balloon-x-end", `${o}vw`), $`
      <div class="vh-microsite-balloon">
        ${this.image ? $`<img src="${this.image}" alt="" class="vh-microsite-balloon__image" />` : null}
      </div>
    `;
  }
};
yr.styles = Je`
    ${We(bp)}
  `;
Pc([
  D()
], yr.prototype, "image", 2);
Pc([
  D({ type: Number })
], yr.prototype, "delay", 2);
yr = Pc([
  Oe("vh-microsite-balloon")
], yr);
const Mp = ".vh-microsite-balloons{position:fixed;top:0;left:0;width:100%;height:100%;overflow:hidden;pointer-events:none;z-index:9999}";
var Tp = Object.defineProperty, Ep = Object.getOwnPropertyDescriptor, Lc = (s, e, t, i) => {
  for (var n = i > 1 ? void 0 : i ? Ep(e, t) : e, r = s.length - 1, a; r >= 0; r--)
    (a = s[r]) && (n = (i ? a(e, t, n) : a(n)) || n);
  return i && n && Tp(e, t, n), n;
};
let br = class extends Ie {
  constructor() {
    super(...arguments), this.images = [];
  }
  render() {
    const s = this.total ?? 50;
    return $`
      <div class="vh-microsite-balloons">
        ${Array.from({ length: this.total ?? 50 }, (e, t) => {
      const i = Math.floor(
        Math.random() * (this.images?.length ?? 0)
      ), n = this.images?.[i], r = Math.random() * 7, a = t / s, o = r * a + a * 1;
      return $`<vh-microsite-balloon .image=${n} .delay=${o}></vh-microsite-balloon>`;
    })}
      </div>
    `;
  }
};
br.styles = Je`
    ${We(Mp)}
  `;
Lc([
  D({ type: Array })
], br.prototype, "images", 2);
Lc([
  D({ type: Number })
], br.prototype, "total", 2);
br = Lc([
  Oe("vh-microsite-balloons")
], br);
const Ap = ".vh-microsite-steps{display:flex;overflow:hidden;flex-direction:column;gap:40px;align-items:center;padding:80px 24px 40px}@media screen and (min-width:810px){.vh-microsite-steps{overflow:visible;gap:100px;padding:100px 24px}}.vh-microsite-steps__header{display:flex;flex-direction:column;gap:20px;align-items:center}.vh-microsite-steps__heading{font-family:var(--vh-font-feature-display-condensed);font-size:54px;font-style:normal;font-weight:400;line-height:1}@media screen and (min-width:810px){.vh-microsite-steps__heading{font-size:62px}}.vh-microsite-steps__heading{color:var(--vh-color-navy);text-align:center;margin:0}.vh-microsite-steps__heading strong{font-family:var(--vh-font-feature-display-condensed);font-style:italic;font-weight:700}.vh-microsite-steps__date{font-family:var(--vh-font-poppins);font-size:24px;font-style:normal;font-weight:400;line-height:1.2;color:var(--vh-color-navy);max-width:960px;text-align:center}.vh-microsite-steps__body{font-family:var(--vh-font-poppins);font-size:16px;font-style:normal;font-weight:400;line-height:1.5;color:var(--vh-color-navy);max-width:960px;text-align:center}.vh-microsite-steps__body strong{font-weight:600}.vh-microsite-steps__steps{display:flex;flex-direction:column;gap:40px;max-width:100%}@media screen and (min-width:1280px){.vh-microsite-steps__steps{flex-direction:row;gap:40px}}.vh-microsite-steps__step-container{display:flex;flex-direction:column;gap:20px}.vh-microsite-steps__step{display:flex;flex-direction:column;gap:20px;width:320px;padding:74px 40px 99px;box-sizing:border-box;justify-content:center;align-items:center;border-radius:340px;overflow:hidden;border:2px solid var(--vh-color-light-green);background:#84c12f0d;aspect-ratio:1;max-width:100%}@media screen and (min-width:810px){.vh-microsite-steps__step{width:340px}}.vh-microsite-steps__step-number{font-family:var(--vh-font-poppins);font-size:18px;font-style:normal;font-weight:400;line-height:1.2;color:var(--vh-color-navy);font-weight:600}.vh-microsite-steps__step-text{font-family:var(--vh-font-feature-display-condensed);font-size:28px;font-style:normal;font-weight:400;line-height:1.2}@media screen and (min-width:810px){.vh-microsite-steps__step-text{font-size:32px}}.vh-microsite-steps__step-text{text-align:center;color:var(--vh-color-navy);border-top:1px solid var(--vh-color-light-green);border-bottom:1px solid var(--vh-color-light-green);padding:16px 0}.vh-microsite-steps__step-text--large{font-family:var(--vh-font-feature-display-condensed);font-size:48px;font-style:normal;font-weight:400;line-height:1}@media screen and (min-width:810px){.vh-microsite-steps__step-text--large{font-size:52px}}.vh-microsite-steps__step-description{font-family:var(--vh-font-poppins);font-size:16px;font-style:normal;font-weight:400;line-height:1.5;color:var(--vh-color-navy);width:320px;flex:1;text-align:center;max-width:100%}.vh-microsite-steps__button{display:flex;justify-content:center}.vh-microsite-steps--pre-animate .vh-microsite-steps__heading,.vh-microsite-steps--pre-animate .vh-microsite-steps__date,.vh-microsite-steps--pre-animate .vh-microsite-steps__body,.vh-microsite-steps--pre-animate .vh-microsite-steps__step,.vh-microsite-steps--pre-animate .vh-microsite-steps__step-description,.vh-microsite-steps--pre-animate .vh-microsite-steps__button{opacity:0}.vh-microsite-steps--animate .vh-microsite-steps__heading{opacity:0;animation:fadeInFromRight 1s ease-out forwards}.vh-microsite-steps--animate .vh-microsite-steps__date{opacity:0;animation:fadeInFromRight 1s ease-out forwards;animation-delay:.2s}.vh-microsite-steps--animate .vh-microsite-steps__body{opacity:0;animation:fadeInFromRight 1s ease-out forwards;animation-delay:.4s}.vh-microsite-steps__step--animate,.vh-microsite-steps__step-description--animate,.vh-microsite-steps__button--animate{opacity:0;animation:fadeInFromRight .7s ease-out forwards;animation-delay:calc(.5s + var(--animation-order) * .4s)}@keyframes fadeInFromRight{0%{opacity:0;transform:translate(50px)}to{opacity:1;transform:translate(0)}}";
var Rp = Object.defineProperty, Cp = Object.getOwnPropertyDescriptor, Ii = (s, e, t, i) => {
  for (var n = i > 1 ? void 0 : i ? Cp(e, t) : e, r = s.length - 1, a; r >= 0; r--)
    (a = s[r]) && (n = (i ? a(e, t, n) : a(n)) || n);
  return i && n && Rp(e, t, n), n;
};
let ai = class extends Ie {
  constructor() {
    super(...arguments), this.heading = "", this.date = "", this.body = "", this.steps = [], this.buttonLabel = "", this.buttonHref = "", this.animateIn = !1, this.isVisible = !1, this.isMobile = !1, this.visibleItems = [], this.itemObservers = [], this.mediaHandler = (s) => {
      this.isMobile = !s.matches;
    };
  }
  connectedCallback() {
    super.connectedCallback(), this.mediaQuery = window.matchMedia("(min-width: 1280px)"), this.isMobile = !this.mediaQuery.matches, this.mediaQuery.addEventListener("change", this.mediaHandler), this.animateIn && this.setupIntersectionObserver();
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.observer?.disconnect(), this.itemObservers.forEach((s) => {
      s.disconnect();
    }), this.mediaQuery?.removeEventListener("change", this.mediaHandler);
  }
  setupIntersectionObserver() {
    this.observer = new IntersectionObserver(
      (s) => {
        s.forEach((e) => {
          e.isIntersecting && !this.isVisible && (this.isVisible = !0);
        });
      },
      {
        threshold: 0.2
      }
    );
  }
  setupItemObservers() {
    this.itemObservers.forEach((e) => {
      e.disconnect();
    }), this.itemObservers = [];
    const s = this.shadowRoot?.querySelectorAll(
      ".vh-microsite-steps__step-container"
    );
    s && (this.visibleItems = new Array(s.length).fill(!1), s.forEach((e, t) => {
      const i = new IntersectionObserver(
        (n) => {
          n.forEach((r) => {
            r.isIntersecting && !this.visibleItems[t] && (this.visibleItems = [
              ...this.visibleItems.slice(0, t),
              !0,
              ...this.visibleItems.slice(t + 1)
            ], this.requestUpdate());
          });
        },
        { threshold: 0.3 }
      );
      i.observe(e), this.itemObservers.push(i);
    }));
  }
  firstUpdated() {
    if (this.animateIn) {
      const s = this.shadowRoot?.querySelector(".vh-microsite-steps");
      s && this.observer && this.observer.observe(s), this.setupItemObservers();
    }
  }
  render() {
    const s = this.animateIn && this.isVisible;
    return $`
      <div class=${Ze({
      "vh-microsite-steps": !0,
      "vh-microsite-steps--pre-animate": this.animateIn,
      "vh-microsite-steps--animate": s
    })}>
        <div class="vh-microsite-steps__header">
          <h2 class="vh-microsite-steps__heading">
            ${Qe(this.heading)}
          </h2>
          ${this.date ? $`<div class="vh-microsite-steps__date">
            ${Qe(this.date)}
          </div>` : ""}
          ${this.body ? $`<div class="vh-microsite-steps__body">
            ${Qe(this.body)}
          </div>` : ""}
        </div>
        <div class="vh-microsite-steps__steps">
          ${this.steps.map((e, t) => {
      const i = this.isMobile ? this.visibleItems[t] ?? !1 : s;
      return $`
            <div class="vh-microsite-steps__step-container">
            <div class=${Ze({
        "vh-microsite-steps__step": !0,
        "vh-microsite-steps__step--animate": i
      })} style="--animation-order: ${this.isMobile ? 1 : t * 2 + 1}">
              <div class="vh-microsite-steps__step-number">${e.step}</div>
              <div class=${Ze({
        "vh-microsite-steps__step-text": !0,
        "vh-microsite-steps__step-text--large": !!e.large
      })}>${Qe(e.text)}</div>
            </div>
            ${e.description ? $`<div class=${Ze({
        "vh-microsite-steps__step-description": !0,
        "vh-microsite-steps__step-description--animate": i
      })} style="--animation-order: ${this.isMobile ? 2 : t * 2 + 2}">${Qe(e.description)}</div>` : ""}
          </div>
          `;
    })}
        </div>
        ${this.buttonLabel ? $`<div class=${Ze({
      "vh-microsite-steps__button": !0,
      "vh-microsite-steps__button--animate": s
    })} style="--animation-order: ${this.steps.length * 2 + 1}"><vh-microsite-button href="${this.buttonHref}" target="_blank" label="${this.buttonLabel}" icon="download" color="green" /></div>` : ""}
      </div>
    `;
  }
};
ai.styles = Je`
    ${We(Ap)}
  `;
Ii([
  D()
], ai.prototype, "heading", 2);
Ii([
  D()
], ai.prototype, "date", 2);
Ii([
  D()
], ai.prototype, "body", 2);
Ii([
  D({ type: Array })
], ai.prototype, "steps", 2);
Ii([
  D()
], ai.prototype, "buttonLabel", 2);
Ii([
  D()
], ai.prototype, "buttonHref", 2);
Ii([
  D({ type: Boolean })
], ai.prototype, "animateIn", 2);
Ii([
  D({ type: Boolean })
], ai.prototype, "isVisible", 2);
Ii([
  D({ type: Boolean })
], ai.prototype, "isMobile", 2);
Ii([
  D({ type: Array })
], ai.prototype, "visibleItems", 2);
ai = Ii([
  Oe("vh-microsite-steps")
], ai);
const Ip = `.vh-microsite-marquee{width:var(--vh-fullscreen-max-width);margin-left:calc(50% - 50vw);margin-right:calc(50% - 50vw);overflow:hidden;white-space:nowrap;display:flex;background-color:var(--vh-color-navy);padding:16px 0}.vh-microsite-marquee__content{font-family:var(--vh-font-ibm-plex-sans);font-size:12px;font-style:normal;font-weight:700;line-height:1.2;display:flex;animation:marquee-scroll 10s linear infinite;gap:48px;color:var(--vh-color-white);padding-right:48px}.vh-microsite-marquee__item{display:flex;align-items:center;gap:8px}.vh-microsite-marquee__item:before{content:"";background:url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="none" viewBox="0 0 48 48"><path fill="%23002c4e" d="M0 0h48v48H0z"/><path fill="%23fff" stroke="%23fff" stroke-width=".206" d="M25.972 35.472c-.212 0-.344-.005-.383-.007a.49.49 0 0 1-.4-.243c-2.326-4.018-2.96-7.855-1.882-11.406 1.197-3.947 4.343-6.684 6.673-7.83 2.918-1.435 4.519-3.14 5.346-4.317.896-1.271 1.108-2.221 1.11-2.231a.488.488 0 0 1 .945-.033c2.967 10.298 3.944 15.728.105 21.013-3.441 4.738-9.867 5.052-11.516 5.052zm10.868-24.41c-.766 1.493-2.525 3.88-6.43 5.802-2.155 1.06-5.066 3.592-6.171 7.238-.975 3.211-.416 6.706 1.657 10.395 1.358 0 7.612-.258 10.801-4.649 3.416-4.705 2.704-9.688.14-18.787z"/><path fill="%23fff" stroke="%23fff" stroke-width=".206" d="M20.585 38.948a.49.49 0 0 1-.186-.94c.017-.007 1.47-.625 3.298-2.021 2.144-1.64 5.034-4.537 6.635-9.025a.49.49 0 0 1 .623-.296.49.49 0 0 1 .296.623c-1.682 4.713-4.715 7.753-6.962 9.471-1.94 1.484-3.454 2.122-3.518 2.147a.5.5 0 0 1-.186.039zM18.782 32.58c-1.264 0-6.199-.242-8.846-3.887-2.946-4.057-2.2-8.203.061-16.063a.487.487 0 0 1 .947.036c0 .005.161.712.832 1.662.623.88 1.823 2.154 4.009 3.229 1.792.88 4.21 2.984 5.128 6.02.828 2.729.343 5.675-1.44 8.756a.5.5 0 0 1-.4.243c-.028 0-.13.005-.294.005zm-8.226-18.352c-1.871 6.696-2.364 10.406.169 13.89 2.34 3.222 6.9 3.472 8.041 3.483 1.532-2.75 1.94-5.354 1.216-7.743-.83-2.735-3.01-4.634-4.626-5.428-2.778-1.366-4.144-3.046-4.797-4.202z"/><path fill="%23fff" stroke="%23fff" stroke-width=".206" d="M20.815 34.026a.47.47 0 0 1-.278-.09 16.5 16.5 0 0 1-1.966-1.618 15.6 15.6 0 0 1-3.913-6.032.487.487 0 1 1 .919-.327 14.6 14.6 0 0 0 3.67 5.657 15.5 15.5 0 0 0 1.85 1.522.49.49 0 0 1 .12.679.49.49 0 0 1-.402.207z"/></svg>');width:48px;height:48px;display:inline-block}@keyframes marquee-scroll{0%{transform:translate(0)}to{transform:translate(-100%)}}`;
var Pp = Object.defineProperty, Lp = Object.getOwnPropertyDescriptor, wu = (s, e, t, i) => {
  for (var n = i > 1 ? void 0 : i ? Lp(e, t) : e, r = s.length - 1, a; r >= 0; r--)
    (a = s[r]) && (n = (i ? a(e, t, n) : a(n)) || n);
  return i && n && Pp(e, t, n), n;
};
let Oa = class extends Ie {
  render() {
    return $`
    <div class="vh-microsite-marquee">
      <div class="vh-microsite-marquee__content">${this.items?.map((s) => $`<span class="vh-microsite-marquee__item">${s}</span>`)}</div>
      <div class="vh-microsite-marquee__content">${this.items?.map((s) => $`<span class="vh-microsite-marquee__item">${s}</span>`)}</div>
      <div class="vh-microsite-marquee__content">${this.items?.map((s) => $`<span class="vh-microsite-marquee__item">${s}</span>`)}</div>
      <div class="vh-microsite-marquee__content">${this.items?.map((s) => $`<span class="vh-microsite-marquee__item">${s}</span>`)}</div>
      <div class="vh-microsite-marquee__content">${this.items?.map((s) => $`<span class="vh-microsite-marquee__item">${s}</span>`)}</div>
      <div class="vh-microsite-marquee__content">${this.items?.map((s) => $`<span class="vh-microsite-marquee__item">${s}</span>`)}</div>
    </div>
    `;
  }
};
Oa.styles = Je`
    ${We(Ip)}
  `;
wu([
  D({ type: Array })
], Oa.prototype, "items", 2);
Oa = wu([
  Oe("vh-microsite-marquee")
], Oa);
const Dp = ".vh-microsite-circle-marquee{display:flex;flex-direction:column;align-items:center;background-color:var(--vh-color-light-gray);overflow:hidden;width:100%;max-width:var(--vh-fullscreen-max-width)}.vh-microsite-circle-marquee__header{display:flex;flex-direction:column;align-items:center;text-align:center;padding:60px 24px 0;gap:24px;max-width:960px}@media screen and (min-width:810px){.vh-microsite-circle-marquee__header{padding:100px 24px 0;gap:40px}}.vh-microsite-circle-marquee__heading{font-family:var(--vh-font-feature-display-condensed);font-size:54px;font-style:normal;font-weight:400;line-height:1}@media screen and (min-width:810px){.vh-microsite-circle-marquee__heading{font-size:62px}}.vh-microsite-circle-marquee__heading{color:var(--vh-color-navy);margin:0;padding:0}.vh-microsite-circle-marquee__heading strong{font-style:italic}.vh-microsite-circle-marquee__subtitle{font-family:var(--vh-font-poppins);font-size:16px;font-style:normal;font-weight:400;line-height:1.5;color:var(--vh-color-navy);margin:0}.vh-microsite-circle-marquee__track{display:flex;align-items:center;padding:60px 0;width:100%}@media screen and (min-width:810px){.vh-microsite-circle-marquee__track{padding:100px 0}}.vh-microsite-circle-marquee__content{display:flex;align-items:center;gap:16px;padding-right:16px;animation:circle-marquee-scroll 20s linear infinite;flex-shrink:0}@media screen and (min-width:810px){.vh-microsite-circle-marquee__content{gap:24px;padding-right:24px}}.vh-microsite-circle-marquee__circle{width:200px;height:200px;border-radius:50%;border:1px solid var(--vh-color-light-green);background:var(--vh-color-white);overflow:hidden;flex-shrink:0;display:flex;align-items:center;justify-content:center}@media screen and (min-width:810px){.vh-microsite-circle-marquee__circle{width:330px;height:330px}}.vh-microsite-circle-marquee__image{width:100%;height:100%;object-fit:cover}.vh-microsite-circle-marquee__header--pre-animate .vh-microsite-circle-marquee__heading,.vh-microsite-circle-marquee__header--pre-animate .vh-microsite-circle-marquee__subtitle{opacity:0}.vh-microsite-circle-marquee__header--animate .vh-microsite-circle-marquee__heading{opacity:0;animation:fadeInFromRight 1s ease-out forwards}.vh-microsite-circle-marquee__header--animate .vh-microsite-circle-marquee__subtitle{opacity:0;animation:fadeInFromRight 1s ease-out forwards;animation-delay:.3s}@keyframes circle-marquee-scroll{0%{transform:translate(0)}to{transform:translate(-100%)}}@keyframes fadeInFromRight{0%{opacity:0;transform:translate(50px)}to{opacity:1;transform:translate(0)}}";
var Np = Object.defineProperty, Op = Object.getOwnPropertyDescriptor, Nr = (s, e, t, i) => {
  for (var n = i > 1 ? void 0 : i ? Op(e, t) : e, r = s.length - 1, a; r >= 0; r--)
    (a = s[r]) && (n = (i ? a(e, t, n) : a(n)) || n);
  return i && n && Np(e, t, n), n;
};
let Jn = class extends Ie {
  constructor() {
    super(...arguments), this.items = [], this.isVisible = !1;
  }
  connectedCallback() {
    super.connectedCallback(), this.setupIntersectionObserver();
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.observer?.disconnect();
  }
  setupIntersectionObserver() {
    this.observer = new IntersectionObserver(
      (s) => {
        s.forEach((e) => {
          e.isIntersecting && !this.isVisible && (this.isVisible = !0);
        });
      },
      {
        threshold: 0.3
      }
    );
  }
  firstUpdated() {
    const s = this.shadowRoot?.querySelector(
      ".vh-microsite-circle-marquee__header"
    );
    s && this.observer && this.observer.observe(s);
  }
  render() {
    const s = this.isVisible, e = this.items.map(
      (t) => $`
        <div class="vh-microsite-circle-marquee__circle">
          <img
            class="vh-microsite-circle-marquee__image"
            src=${t.src}
            alt=${t.alt}
          />
        </div>
      `
    );
    return $`
      <section class="vh-microsite-circle-marquee">
        <div
          class=${Ze({
      "vh-microsite-circle-marquee__header": !0,
      "vh-microsite-circle-marquee__header--pre-animate": !s,
      "vh-microsite-circle-marquee__header--animate": s
    })}
        >
          ${this.heading ? $`<h2
                class="vh-microsite-circle-marquee__heading"
              >
                ${Qe(this.heading)}
              </h2>` : ""}
          ${this.subtitle ? $`<p
                class="vh-microsite-circle-marquee__subtitle"
              >
                ${this.subtitle}
              </p>` : ""}
        </div>
        <div class="vh-microsite-circle-marquee__track">
          <div class="vh-microsite-circle-marquee__content">
            ${e}
          </div>
          <div class="vh-microsite-circle-marquee__content">
            ${e}
          </div>
          <div class="vh-microsite-circle-marquee__content">
            ${e}
          </div>
        </div>
      </section>
    `;
  }
};
Jn.styles = Je`
    ${We(Dp)}
  `;
Nr([
  D()
], Jn.prototype, "heading", 2);
Nr([
  D()
], Jn.prototype, "subtitle", 2);
Nr([
  D({ type: Array })
], Jn.prototype, "items", 2);
Nr([
  D({ type: Boolean })
], Jn.prototype, "isVisible", 2);
Jn = Nr([
  Oe("vh-microsite-circle-marquee")
], Jn);
const Up = ".vh-microsite-countdown{width:100%;display:flex;flex-direction:column;justify-content:center}@media screen and (min-width:810px){.vh-microsite-countdown{flex-direction:row}}.vh-microsite-countdown__content{display:flex;flex-direction:column;justify-content:center;align-items:center;padding:64px 40px;background-size:cover;box-sizing:border-box}@media screen and (min-width:1280px){.vh-microsite-countdown__content{padding:24px}}.vh-microsite-countdown__content--desktop{display:none}@media screen and (min-width:1280px){.vh-microsite-countdown__content--desktop{display:flex;flex:1}}.vh-microsite-countdown__content--mobile{display:flex}@media screen and (min-width:810px){.vh-microsite-countdown__content--mobile{flex:1}}@media screen and (min-width:1280px){.vh-microsite-countdown__content--mobile{display:none}}.vh-microsite-countdown__box{display:flex;flex-direction:column;justify-content:center;align-items:center;border-radius:8px;border:2px solid var(--vh-color-white);background:#84c12f0d;-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px);padding:24px;gap:16px}@media screen and (min-width:1280px){.vh-microsite-countdown__box{padding:32px;gap:32px}}.vh-microsite-countdown__heading{font-family:var(--vh-font-poppins);font-size:16px;font-style:normal;font-weight:400;line-height:1.5;color:var(--vh-color-navy)}@media screen and (min-width:1280px){.vh-microsite-countdown__heading{font-family:var(--vh-font-poppins);font-size:28px;font-style:normal;font-weight:500;line-height:1}}@media screen and (min-width:1280px)and (min-width:810px){.vh-microsite-countdown__heading{font-size:32px}}.vh-microsite-countdown__video{flex:1;display:flex;background-color:var(--vh-color-video-gray)}.vh-microsite-countdown__video video{width:100%;display:block}@media screen and (min-width:1280px){.vh-microsite-countdown__video{max-width:780px}}.vh-microsite-countdown__countdown{display:flex;flex-direction:row;gap:8px;justify-content:center;color:var(--vh-color-navy)}.vh-microsite-countdown__countdown-number,.vh-microsite-countdown__countdown-separator{font-family:var(--vh-font-feature-display-condensed);font-size:28px;font-style:normal;font-weight:400;line-height:1.2}@media screen and (min-width:810px){.vh-microsite-countdown__countdown-number,.vh-microsite-countdown__countdown-separator{font-size:32px}}.vh-microsite-countdown__countdown-number,.vh-microsite-countdown__countdown-separator{text-align:center}@media screen and (min-width:1280px){.vh-microsite-countdown__countdown-number,.vh-microsite-countdown__countdown-separator{font-family:var(--vh-font-feature-display-condensed);font-size:48px;font-style:normal;font-weight:400;line-height:1}}@media screen and (min-width:1280px)and (min-width:810px){.vh-microsite-countdown__countdown-number,.vh-microsite-countdown__countdown-separator{font-size:52px}}.vh-microsite-countdown__countdown-label{font-family:var(--vh-font-poppins);font-size:14px;font-style:normal;font-weight:300;line-height:1.3;font-weight:600;text-align:center}@media screen and (min-width:1280px){.vh-microsite-countdown__countdown-label{font-family:var(--vh-font-poppins);font-size:18px;font-style:normal;font-weight:400;line-height:1.2;font-weight:600}}.vh-microsite-countdown__balloons{position:fixed;bottom:0;left:0;right:0;width:100%;height:100vh;pointer-events:none;z-index:1000;display:flex;justify-content:space-around;align-items:flex-end;padding:0 20px;box-sizing:border-box}.vh-microsite-countdown__balloon{width:80px;height:auto;transform:translateY(100vh)}@media screen and (min-width:1280px){.vh-microsite-countdown__balloon{width:120px}}.vh-microsite-countdown__balloons--active .vh-microsite-countdown__balloon{animation:floatUp 8s ease-in forwards}.vh-microsite-countdown__balloons--active .vh-microsite-countdown__balloon:nth-child(12n+1){animation-delay:0s;animation-duration:4s}.vh-microsite-countdown__balloons--active .vh-microsite-countdown__balloon:nth-child(12n+2){animation-delay:.3s;animation-duration:3.5s}.vh-microsite-countdown__balloons--active .vh-microsite-countdown__balloon:nth-child(12n+3){animation-delay:.6s;animation-duration:4.2s}.vh-microsite-countdown__balloons--active .vh-microsite-countdown__balloon:nth-child(12n+4){animation-delay:.9s;animation-duration:3.8s}.vh-microsite-countdown__balloons--active .vh-microsite-countdown__balloon:nth-child(12n+5){animation-delay:1.2s;animation-duration:4.3s}.vh-microsite-countdown__balloons--active .vh-microsite-countdown__balloon:nth-child(12n+6){animation-delay:1.5s;animation-duration:3.7s}.vh-microsite-countdown__balloons--active .vh-microsite-countdown__balloon:nth-child(12n+7){animation-delay:1.8s;animation-duration:4.1s}.vh-microsite-countdown__balloons--active .vh-microsite-countdown__balloon:nth-child(12n+8){animation-delay:2.1s;animation-duration:3.9s}.vh-microsite-countdown__balloons--active .vh-microsite-countdown__balloon:nth-child(12n+9){animation-delay:.2s;animation-duration:4.4s}.vh-microsite-countdown__balloons--active .vh-microsite-countdown__balloon:nth-child(12n+10){animation-delay:.5s;animation-duration:3.6s}.vh-microsite-countdown__balloons--active .vh-microsite-countdown__balloon:nth-child(12n+11){animation-delay:1s;animation-duration:4.2s}.vh-microsite-countdown__balloons--active .vh-microsite-countdown__balloon:nth-child(12n+12){animation-delay:2.5s;animation-duration:3.4s}@keyframes floatUp{0%{transform:translateY(0) translate(0) rotate(0)}10%{transform:translateY(-10vh) translate(-8px) rotate(1deg)}20%{transform:translateY(-20vh) translate(12px) rotate(-2deg)}30%{transform:translateY(-30vh) translate(-15px) rotate(2deg)}40%{transform:translateY(-40vh) translate(10px) rotate(-1deg)}50%{transform:translateY(-50vh) translate(-12px) rotate(2deg)}60%{transform:translateY(-60vh) translate(8px) rotate(-2deg)}70%{transform:translateY(-70vh) translate(-10px) rotate(3deg)}80%{transform:translateY(-80vh) translate(12px) rotate(-3deg)}90%{transform:translateY(-90vh) translate(-8px) rotate(4deg)}to{transform:translateY(-100vh) translate(0) rotate(3deg)}}";
var Fp = Object.defineProperty, Bp = Object.getOwnPropertyDescriptor, $i = (s, e, t, i) => {
  for (var n = i > 1 ? void 0 : i ? Bp(e, t) : e, r = s.length - 1, a; r >= 0; r--)
    (a = s[r]) && (n = (i ? a(e, t, n) : a(n)) || n);
  return i && n && Fp(e, t, n), n;
};
const kp = (s) => {
  if (!s)
    return {
      days: "00",
      hours: "00",
      minutes: "00",
      seconds: "00"
    };
  const e = +new Date(s) - Date.now();
  let t = {
    days: "00",
    hours: "00",
    minutes: "00",
    seconds: "00"
  };
  return e > 0 && (t = {
    days: String(Math.floor(e / (1e3 * 60 * 60 * 24))).padStart(
      2,
      "0"
    ),
    hours: String(Math.floor(e / (1e3 * 60 * 60) % 24)).padStart(
      2,
      "0"
    ),
    minutes: String(Math.floor(e / 1e3 / 60 % 60)).padStart(
      2,
      "0"
    ),
    seconds: String(Math.floor(e / 1e3 % 60)).padStart(2, "0")
  }), t;
};
let vi = class extends Ie {
  constructor() {
    super(), this._videoEnded = !1, this._countDown();
  }
  _countDown() {
    setInterval(() => {
      this._timeLeft = kp(this.targetDate);
    }, 1e3);
  }
  handleVideoEnded() {
    this._videoEnded = !0;
  }
  render() {
    const s = $`
      <div class="vh-microsite-countdown__box">
        <div class="vh-microsite-countdown__heading">${this.heading}</div>
        <div class="vh-microsite-countdown__countdown">
          <div class="vh-microsite-countdown__countdown-days">
            <div class="vh-microsite-countdown__countdown-number">
              ${this._timeLeft?.days}
            </div>
            <div class="vh-microsite-countdown__countdown-label">Days</div>
          </div>
          <div class="vh-microsite-countdown__countdown-separator">:</div>
          <div class="vh-microsite-countdown__countdown-hours">
            <div class="vh-microsite-countdown__countdown-number">
              ${this._timeLeft?.hours}
            </div>
            <div class="vh-microsite-countdown__countdown-label">Hours</div>
          </div>
          <div class="vh-microsite-countdown__countdown-separator">:</div>
          <div class="vh-microsite-countdown__countdown-minutes">
            <div class="vh-microsite-countdown__countdown-number">
              ${this._timeLeft?.minutes}
            </div>
            <div class="vh-microsite-countdown__countdown-label">Minutes</div>
          </div>
          <div class="vh-microsite-countdown__countdown-separator">:</div>
          <div class="vh-microsite-countdown__countdown-seconds">
            <div class="vh-microsite-countdown__countdown-number">
              ${this._timeLeft?.seconds}
            </div>
            <div class="vh-microsite-countdown__countdown-label">Seconds</div>
          </div>
        </div>
      </div>
    `;
    return $`
      <section class="vh-microsite-countdown">
        <div
          class="vh-microsite-countdown__content vh-microsite-countdown__content--desktop"
          style="background-image: url(${this.image})"
        >
          ${s}
        </div>
        <div
          class="vh-microsite-countdown__content vh-microsite-countdown__content--mobile"
          style="background-image: url(${this.imageMobile})"
        >
          ${s}
        </div>
        <div class="vh-microsite-countdown__video">
          ${this.video ? $`<video
                src="${this.video}"
                alt=""
                autoplay
                muted
                @ended="${this.handleVideoEnded}"
              ></video>` : null}
        </div>
      </section>
      ${this._videoEnded ? $`<vh-microsite-balloons
            .images=${this.balloons}
            .total=${this.balloonsTotal ?? 67}
          ></vh-microsite-balloons>` : null}
    `;
  }
};
vi.styles = Je`
    ${We(Up)}
  `;
$i([
  D()
], vi.prototype, "heading", 2);
$i([
  D()
], vi.prototype, "image", 2);
$i([
  D()
], vi.prototype, "imageMobile", 2);
$i([
  D()
], vi.prototype, "video", 2);
$i([
  D()
], vi.prototype, "targetDate", 2);
$i([
  D({ type: Number })
], vi.prototype, "balloonsTotal", 2);
$i([
  D({ type: Array })
], vi.prototype, "balloons", 2);
$i([
  ft()
], vi.prototype, "_timeLeft", 2);
$i([
  ft()
], vi.prototype, "_videoEnded", 2);
vi = $i([
  Oe("vh-microsite-countdown")
], vi);
function Oh(s, e) {
  var t = Object.keys(s);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(s);
    e && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(s, n).enumerable;
    })), t.push.apply(t, i);
  }
  return t;
}
function Uh(s) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Oh(Object(t), !0).forEach(function(i) {
      Vp(s, i, t[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(s, Object.getOwnPropertyDescriptors(t)) : Oh(Object(t)).forEach(function(i) {
      Object.defineProperty(s, i, Object.getOwnPropertyDescriptor(t, i));
    });
  }
  return s;
}
function ba(s) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? ba = function(e) {
    return typeof e;
  } : ba = function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, ba(s);
}
function so(s, e) {
  if (!(s instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function zp(s, e) {
  for (var t = 0; t < e.length; t++) {
    var i = e[t];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(s, i.key, i);
  }
}
function ro(s, e, t) {
  return e && zp(s.prototype, e), s;
}
function Vp(s, e, t) {
  return e in s ? Object.defineProperty(s, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : s[e] = t, s;
}
function Hp(s, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  s.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: s,
      writable: !0,
      configurable: !0
    }
  }), e && ol(s, e);
}
function Cs(s) {
  return Cs = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, Cs(s);
}
function ol(s, e) {
  return ol = Object.setPrototypeOf || function(i, n) {
    return i.__proto__ = n, i;
  }, ol(s, e);
}
function $p() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Gp(s) {
  if (s === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return s;
}
function qp(s, e) {
  if (e && (typeof e == "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Gp(s);
}
function Wp(s) {
  var e = $p();
  return function() {
    var i = Cs(s), n;
    if (e) {
      var r = Cs(this).constructor;
      n = Reflect.construct(i, arguments, r);
    } else
      n = i.apply(this, arguments);
    return qp(this, n);
  };
}
function Xp(s, e) {
  for (; !Object.prototype.hasOwnProperty.call(s, e) && (s = Cs(s), s !== null); )
    ;
  return s;
}
function wa() {
  return typeof Reflect < "u" && Reflect.get ? wa = Reflect.get : wa = function(e, t, i) {
    var n = Xp(e, t);
    if (n) {
      var r = Object.getOwnPropertyDescriptor(n, t);
      return r.get ? r.get.call(arguments.length < 3 ? e : i) : r.value;
    }
  }, wa.apply(this, arguments);
}
var jp = {
  /**
   * Type of the movement.
   *
   * Available types:
   * `slider` - Rewinds slider to the start/end when it reaches the first or last slide.
   * `carousel` - Changes slides without starting over when it reaches the first or last slide.
   *
   * @type {String}
   */
  type: "slider",
  /**
   * Start at specific slide number defined with zero-based index.
   *
   * @type {Number}
   */
  startAt: 0,
  /**
   * A number of slides visible on the single viewport.
   *
   * @type {Number}
   */
  perView: 1,
  /**
   * Focus currently active slide at a specified position in the track.
   *
   * Available inputs:
   * `center` - Current slide will be always focused at the center of a track.
   * `0,1,2,3...` - Current slide will be focused on the specified zero-based index.
   *
   * @type {String|Number}
   */
  focusAt: 0,
  /**
   * A size of the gap added between slides.
   *
   * @type {Number}
   */
  gap: 10,
  /**
   * Change slides after a specified interval. Use `false` for turning off autoplay.
   *
   * @type {Number|Boolean}
   */
  autoplay: !1,
  /**
   * Stop autoplay on mouseover event.
   *
   * @type {Boolean}
   */
  hoverpause: !0,
  /**
   * Allow for changing slides with left and right keyboard arrows.
   *
   * @type {Boolean}
   */
  keyboard: !0,
  /**
   * Stop running `perView` number of slides from the end. Use this
   * option if you don't want to have an empty space after
   * a slider. Works only with `slider` type and a
   * non-centered `focusAt` setting.
   *
   * @type {Boolean}
   */
  bound: !1,
  /**
   * Minimal swipe distance needed to change the slide. Use `false` for turning off a swiping.
   *
   * @type {Number|Boolean}
   */
  swipeThreshold: 80,
  /**
   * Minimal mouse drag distance needed to change the slide. Use `false` for turning off a dragging.
   *
   * @type {Number|Boolean}
   */
  dragThreshold: 120,
  /**
   * A number of slides moved on single swipe.
   *
   * Available types:
   * `` - Moves slider by one slide per swipe
   * `|` - Moves slider between views per swipe (number of slides defined in `perView` options)
   *
   * @type {String}
   */
  perSwipe: "",
  /**
   * Moving distance ratio of the slides on a swiping and dragging.
   *
   * @type {Number}
   */
  touchRatio: 0.5,
  /**
   * Angle required to activate slides moving on swiping or dragging.
   *
   * @type {Number}
   */
  touchAngle: 45,
  /**
   * Duration of the animation in milliseconds.
   *
   * @type {Number}
   */
  animationDuration: 400,
  /**
   * Allows looping the `slider` type. Slider will rewind to the first/last slide when it's at the start/end.
   *
   * @type {Boolean}
   */
  rewind: !0,
  /**
   * Duration of the rewinding animation of the `slider` type in milliseconds.
   *
   * @type {Number}
   */
  rewindDuration: 800,
  /**
   * Easing function for the animation.
   *
   * @type {String}
   */
  animationTimingFunc: "cubic-bezier(.165, .840, .440, 1)",
  /**
   * Wait for the animation to finish until the next user input can be processed
   *
   * @type {boolean}
   */
  waitForTransition: !0,
  /**
   * Throttle costly events at most once per every wait milliseconds.
   *
   * @type {Number}
   */
  throttle: 10,
  /**
   * Moving direction mode.
   *
   * Available inputs:
   * - 'ltr' - left to right movement,
   * - 'rtl' - right to left movement.
   *
   * @type {String}
   */
  direction: "ltr",
  /**
   * The distance value of the next and previous viewports which
   * have to peek in the current view. Accepts number and
   * pixels as a string. Left and right peeking can be
   * set up separately with a directions object.
   *
   * For example:
   * `100` - Peek 100px on the both sides.
   * { before: 100, after: 50 }` - Peek 100px on the left side and 50px on the right side.
   *
   * @type {Number|String|Object}
   */
  peek: 0,
  /**
   * Defines how many clones of current viewport will be generated.
   *
   * @type {Number}
   */
  cloningRatio: 1,
  /**
   * Collection of options applied at specified media breakpoints.
   * For example: display two slides per view under 800px.
   * `{
   *   '800px': {
   *     perView: 2
   *   }
   * }`
   */
  breakpoints: {},
  /**
   * Collection of internally used HTML classes.
   *
   * @todo Refactor `slider` and `carousel` properties to single `type: { slider: '', carousel: '' }` object
   * @type {Object}
   */
  classes: {
    swipeable: "glide--swipeable",
    dragging: "glide--dragging",
    direction: {
      ltr: "glide--ltr",
      rtl: "glide--rtl"
    },
    type: {
      slider: "glide--slider",
      carousel: "glide--carousel"
    },
    slide: {
      clone: "glide__slide--clone",
      active: "glide__slide--active"
    },
    arrow: {
      disabled: "glide__arrow--disabled"
    },
    nav: {
      active: "glide__bullet--active"
    }
  }
};
function an(s) {
  console.error("[Glide warn]: ".concat(s));
}
function Ut(s) {
  return parseInt(s);
}
function Yp(s) {
  return parseFloat(s);
}
function ll(s) {
  return typeof s == "string";
}
function Is(s) {
  var e = ba(s);
  return e === "function" || e === "object" && !!s;
}
function Ua(s) {
  return typeof s == "function";
}
function Su(s) {
  return typeof s > "u";
}
function cl(s) {
  return s.constructor === Array;
}
function Kp(s, e, t) {
  var i = {};
  for (var n in e)
    Ua(e[n]) ? i[n] = e[n](s, i, t) : an("Extension must be a function");
  for (var r in i)
    Ua(i[r].mount) && i[r].mount();
  return i;
}
function xt(s, e, t) {
  Object.defineProperty(s, e, t);
}
function Zp(s) {
  return Object.keys(s).sort().reduce(function(e, t) {
    return e[t] = s[t], e[t], e;
  }, {});
}
function hl(s, e) {
  var t = Object.assign({}, s, e);
  if (e.hasOwnProperty("classes")) {
    t.classes = Object.assign({}, s.classes, e.classes);
    var i = ["direction", "type", "slide", "arrow", "nav"];
    i.forEach(function(n) {
      e.classes.hasOwnProperty(n) && (t.classes[n] = Uh(Uh({}, s.classes[n]), e.classes[n]));
    });
  }
  return e.hasOwnProperty("breakpoints") && (t.breakpoints = Object.assign({}, s.breakpoints, e.breakpoints)), t;
}
var Jp = /* @__PURE__ */ (function() {
  function s() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    so(this, s), this.events = e, this.hop = e.hasOwnProperty;
  }
  return ro(s, [{
    key: "on",
    value: function(t, i) {
      if (cl(t)) {
        for (var n = 0; n < t.length; n++)
          this.on(t[n], i);
        return;
      }
      this.hop.call(this.events, t) || (this.events[t] = []);
      var r = this.events[t].push(i) - 1;
      return {
        remove: function() {
          delete this.events[t][r];
        }
      };
    }
    /**
     * Runs registered handlers for specified event.
     *
     * @param {String|Array} event
     * @param {Object=} context
     */
  }, {
    key: "emit",
    value: function(t, i) {
      if (cl(t)) {
        for (var n = 0; n < t.length; n++)
          this.emit(t[n], i);
        return;
      }
      this.hop.call(this.events, t) && this.events[t].forEach(function(r) {
        r(i || {});
      });
    }
  }]), s;
})(), Qp = /* @__PURE__ */ (function() {
  function s(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    so(this, s), this._c = {}, this._t = [], this._e = new Jp(), this.disabled = !1, this.selector = e, this.settings = hl(jp, t), this.index = this.settings.startAt;
  }
  return ro(s, [{
    key: "mount",
    value: function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      return this._e.emit("mount.before"), Is(t) ? this._c = Kp(this, t, this._e) : an("You need to provide a object on `mount()`"), this._e.emit("mount.after"), this;
    }
    /**
     * Collects an instance `translate` transformers.
     *
     * @param  {Array} transformers Collection of transformers.
     * @return {Void}
     */
  }, {
    key: "mutate",
    value: function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
      return cl(t) ? this._t = t : an("You need to provide a array on `mutate()`"), this;
    }
    /**
     * Updates glide with specified settings.
     *
     * @param {Object} settings
     * @return {Glide}
     */
  }, {
    key: "update",
    value: function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      return this.settings = hl(this.settings, t), t.hasOwnProperty("startAt") && (this.index = t.startAt), this._e.emit("update"), this;
    }
    /**
     * Change slide with specified pattern. A pattern must be in the special format:
     * `>` - Move one forward
     * `<` - Move one backward
     * `={i}` - Go to {i} zero-based slide (eq. '=1', will go to second slide)
     * `>>` - Rewinds to end (last slide)
     * `<<` - Rewinds to start (first slide)
     * `|>` - Move one viewport forward
     * `|<` - Move one viewport backward
     *
     * @param {String} pattern
     * @return {Glide}
     */
  }, {
    key: "go",
    value: function(t) {
      return this._c.Run.make(t), this;
    }
    /**
     * Move track by specified distance.
     *
     * @param {String} distance
     * @return {Glide}
     */
  }, {
    key: "move",
    value: function(t) {
      return this._c.Transition.disable(), this._c.Move.make(t), this;
    }
    /**
     * Destroy instance and revert all changes done by this._c.
     *
     * @return {Glide}
     */
  }, {
    key: "destroy",
    value: function() {
      return this._e.emit("destroy"), this;
    }
    /**
     * Start instance autoplaying.
     *
     * @param {Boolean|Number} interval Run autoplaying with passed interval regardless of `autoplay` settings
     * @return {Glide}
     */
  }, {
    key: "play",
    value: function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
      return t && (this.settings.autoplay = t), this._e.emit("play"), this;
    }
    /**
     * Stop instance autoplaying.
     *
     * @return {Glide}
     */
  }, {
    key: "pause",
    value: function() {
      return this._e.emit("pause"), this;
    }
    /**
     * Sets glide into a idle status.
     *
     * @return {Glide}
     */
  }, {
    key: "disable",
    value: function() {
      return this.disabled = !0, this;
    }
    /**
     * Sets glide into a active status.
     *
     * @return {Glide}
     */
  }, {
    key: "enable",
    value: function() {
      return this.disabled = !1, this;
    }
    /**
     * Adds cuutom event listener with handler.
     *
     * @param  {String|Array} event
     * @param  {Function} handler
     * @return {Glide}
     */
  }, {
    key: "on",
    value: function(t, i) {
      return this._e.on(t, i), this;
    }
    /**
     * Checks if glide is a precised type.
     *
     * @param  {String} name
     * @return {Boolean}
     */
  }, {
    key: "isType",
    value: function(t) {
      return this.settings.type === t;
    }
    /**
     * Gets value of the core options.
     *
     * @return {Object}
     */
  }, {
    key: "settings",
    get: function() {
      return this._o;
    },
    set: function(t) {
      Is(t) ? this._o = t : an("Options must be an `object` instance.");
    }
    /**
     * Gets current index of the slider.
     *
     * @return {Object}
     */
  }, {
    key: "index",
    get: function() {
      return this._i;
    },
    set: function(t) {
      this._i = Ut(t);
    }
    /**
     * Gets type name of the slider.
     *
     * @return {String}
     */
  }, {
    key: "type",
    get: function() {
      return this.settings.type;
    }
    /**
     * Gets value of the idle status.
     *
     * @return {Boolean}
     */
  }, {
    key: "disabled",
    get: function() {
      return this._d;
    },
    set: function(t) {
      this._d = !!t;
    }
  }]), s;
})();
function em(s, e, t) {
  var i = {
    /**
     * Initializes autorunning of the glide.
     *
     * @return {Void}
     */
    mount: function() {
      this._o = !1;
    },
    /**
     * Makes glides running based on the passed moving schema.
     *
     * @param {String} move
     */
    make: function(c) {
      var h = this;
      s.disabled || (!s.settings.waitForTransition || s.disable(), this.move = c, t.emit("run.before", this.move), this.calculate(), t.emit("run", this.move), e.Transition.after(function() {
        h.isStart() && t.emit("run.start", h.move), h.isEnd() && t.emit("run.end", h.move), h.isOffset() && (h._o = !1, t.emit("run.offset", h.move)), t.emit("run.after", h.move), s.enable();
      }));
    },
    /**
     * Calculates current index based on defined move.
     *
     * @return {Number|Undefined}
     */
    calculate: function() {
      var c = this.move, h = this.length, d = c.steps, u = c.direction, f = 1;
      if (u === "=") {
        if (s.settings.bound && Ut(d) > h) {
          s.index = h;
          return;
        }
        s.index = d;
        return;
      }
      if (u === ">" && d === ">") {
        s.index = h;
        return;
      }
      if (u === "<" && d === "<") {
        s.index = 0;
        return;
      }
      if (u === "|" && (f = s.settings.perView || 1), u === ">" || u === "|" && d === ">") {
        var g = n(f);
        g > h && (this._o = !0), s.index = r(g, f);
        return;
      }
      if (u === "<" || u === "|" && d === "<") {
        var v = a(f);
        v < 0 && (this._o = !0), s.index = o(v, f);
        return;
      }
      an("Invalid direction pattern [".concat(u).concat(d, "] has been used"));
    },
    /**
     * Checks if we are on the first slide.
     *
     * @return {Boolean}
     */
    isStart: function() {
      return s.index <= 0;
    },
    /**
     * Checks if we are on the last slide.
     *
     * @return {Boolean}
     */
    isEnd: function() {
      return s.index >= this.length;
    },
    /**
     * Checks if we are making a offset run.
     *
     * @param {String} direction
     * @return {Boolean}
     */
    isOffset: function() {
      var c = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : void 0;
      return c ? this._o ? c === "|>" ? this.move.direction === "|" && this.move.steps === ">" : c === "|<" ? this.move.direction === "|" && this.move.steps === "<" : this.move.direction === c : !1 : this._o;
    },
    /**
     * Checks if bound mode is active
     *
     * @return {Boolean}
     */
    isBound: function() {
      return s.isType("slider") && s.settings.focusAt !== "center" && s.settings.bound;
    }
  };
  function n(l) {
    var c = s.index;
    return s.isType("carousel") ? c + l : c + (l - c % l);
  }
  function r(l, c) {
    var h = i.length;
    return l <= h ? l : s.isType("carousel") ? l - (h + 1) : s.settings.rewind ? i.isBound() && !i.isEnd() ? h : 0 : i.isBound() ? h : Math.floor(h / c) * c;
  }
  function a(l) {
    var c = s.index;
    if (s.isType("carousel"))
      return c - l;
    var h = Math.ceil(c / l);
    return (h - 1) * l;
  }
  function o(l, c) {
    var h = i.length;
    return l >= 0 ? l : s.isType("carousel") ? l + (h + 1) : s.settings.rewind ? i.isBound() && i.isStart() ? h : Math.floor(h / c) * c : 0;
  }
  return xt(i, "move", {
    /**
     * Gets value of the move schema.
     *
     * @returns {Object}
     */
    get: function() {
      return this._m;
    },
    /**
     * Sets value of the move schema.
     *
     * @returns {Object}
     */
    set: function(c) {
      var h = c.substr(1);
      this._m = {
        direction: c.substr(0, 1),
        steps: h ? Ut(h) ? Ut(h) : h : 0
      };
    }
  }), xt(i, "length", {
    /**
     * Gets value of the running distance based
     * on zero-indexing number of slides.
     *
     * @return {Number}
     */
    get: function() {
      var c = s.settings, h = e.Html.slides.length;
      return this.isBound() ? h - 1 - (Ut(c.perView) - 1) + Ut(c.focusAt) : h - 1;
    }
  }), xt(i, "offset", {
    /**
     * Gets status of the offsetting flag.
     *
     * @return {Boolean}
     */
    get: function() {
      return this._o;
    }
  }), i;
}
function Fh() {
  return (/* @__PURE__ */ new Date()).getTime();
}
function ao(s, e) {
  var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, i, n, r, a, o = 0, l = function() {
    o = t.leading === !1 ? 0 : Fh(), i = null, a = s.apply(n, r), i || (n = r = null);
  }, c = function() {
    var d = Fh();
    !o && t.leading === !1 && (o = d);
    var u = e - (d - o);
    return n = this, r = arguments, u <= 0 || u > e ? (i && (clearTimeout(i), i = null), o = d, a = s.apply(n, r), i || (n = r = null)) : !i && t.trailing !== !1 && (i = setTimeout(l, u)), a;
  };
  return c.cancel = function() {
    clearTimeout(i), o = 0, i = n = r = null;
  }, c;
}
var $r = {
  ltr: ["marginLeft", "marginRight"],
  rtl: ["marginRight", "marginLeft"]
};
function tm(s, e, t) {
  var i = {
    /**
     * Applies gaps between slides. First and last
     * slides do not receive it's edge margins.
     *
     * @param {HTMLCollection} slides
     * @return {Void}
     */
    apply: function(r) {
      for (var a = 0, o = r.length; a < o; a++) {
        var l = r[a].style, c = e.Direction.value;
        a !== 0 ? l[$r[c][0]] = "".concat(this.value / 2, "px") : l[$r[c][0]] = "", a !== r.length - 1 ? l[$r[c][1]] = "".concat(this.value / 2, "px") : l[$r[c][1]] = "";
      }
    },
    /**
     * Removes gaps from the slides.
     *
     * @param {HTMLCollection} slides
     * @returns {Void}
    */
    remove: function(r) {
      for (var a = 0, o = r.length; a < o; a++) {
        var l = r[a].style;
        l.marginLeft = "", l.marginRight = "";
      }
    }
  };
  return xt(i, "value", {
    /**
     * Gets value of the gap.
     *
     * @returns {Number}
     */
    get: function() {
      return Ut(s.settings.gap);
    }
  }), xt(i, "grow", {
    /**
     * Gets additional dimensions value caused by gaps.
     * Used to increase width of the slides wrapper.
     *
     * @returns {Number}
     */
    get: function() {
      return i.value * e.Sizes.length;
    }
  }), xt(i, "reductor", {
    /**
     * Gets reduction value caused by gaps.
     * Used to subtract width of the slides.
     *
     * @returns {Number}
     */
    get: function() {
      var r = s.settings.perView;
      return i.value * (r - 1) / r;
    }
  }), t.on(["build.after", "update"], ao(function() {
    i.apply(e.Html.wrapper.children);
  }, 30)), t.on("destroy", function() {
    i.remove(e.Html.wrapper.children);
  }), i;
}
function Mu(s) {
  if (s && s.parentNode) {
    for (var e = s.parentNode.firstChild, t = []; e; e = e.nextSibling)
      e.nodeType === 1 && e !== s && t.push(e);
    return t;
  }
  return [];
}
function dl(s) {
  return Array.prototype.slice.call(s);
}
var im = '[data-glide-el="track"]';
function nm(s, e, t) {
  var i = {
    /**
     * Setup slider HTML nodes.
     *
     * @param {Glide} glide
     */
    mount: function() {
      this.root = s.selector, this.track = this.root.querySelector(im), this.collectSlides();
    },
    /**
     * Collect slides
     */
    collectSlides: function() {
      this.slides = dl(this.wrapper.children).filter(function(r) {
        return !r.classList.contains(s.settings.classes.slide.clone);
      });
    }
  };
  return xt(i, "root", {
    /**
     * Gets node of the glide main element.
     *
     * @return {Object}
     */
    get: function() {
      return i._r;
    },
    /**
     * Sets node of the glide main element.
     *
     * @return {Object}
     */
    set: function(r) {
      ll(r) && (r = document.querySelector(r)), r !== null ? i._r = r : an("Root element must be a existing Html node");
    }
  }), xt(i, "track", {
    /**
     * Gets node of the glide track with slides.
     *
     * @return {Object}
     */
    get: function() {
      return i._t;
    },
    /**
     * Sets node of the glide track with slides.
     *
     * @return {Object}
     */
    set: function(r) {
      i._t = r;
    }
  }), xt(i, "wrapper", {
    /**
     * Gets node of the slides wrapper.
     *
     * @return {Object}
     */
    get: function() {
      return i.track.children[0];
    }
  }), t.on("update", function() {
    i.collectSlides();
  }), i;
}
function sm(s, e, t) {
  var i = {
    /**
     * Setups how much to peek based on settings.
     *
     * @return {Void}
     */
    mount: function() {
      this.value = s.settings.peek;
    }
  };
  return xt(i, "value", {
    /**
     * Gets value of the peek.
     *
     * @returns {Number|Object}
     */
    get: function() {
      return i._v;
    },
    /**
     * Sets value of the peek.
     *
     * @param {Number|Object} value
     * @return {Void}
     */
    set: function(r) {
      Is(r) ? (r.before = Ut(r.before), r.after = Ut(r.after)) : r = Ut(r), i._v = r;
    }
  }), xt(i, "reductor", {
    /**
     * Gets reduction value caused by peek.
     *
     * @returns {Number}
     */
    get: function() {
      var r = i.value, a = s.settings.perView;
      return Is(r) ? r.before / a + r.after / a : r * 2 / a;
    }
  }), t.on(["resize", "update"], function() {
    i.mount();
  }), i;
}
function rm(s, e, t) {
  var i = {
    /**
     * Constructs move component.
     *
     * @returns {Void}
     */
    mount: function() {
      this._o = 0;
    },
    /**
     * Calculates a movement value based on passed offset and currently active index.
     *
     * @param  {Number} offset
     * @return {Void}
     */
    make: function() {
      var r = this, a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
      this.offset = a, t.emit("move", {
        movement: this.value
      }), e.Transition.after(function() {
        t.emit("move.after", {
          movement: r.value
        });
      });
    }
  };
  return xt(i, "offset", {
    /**
     * Gets an offset value used to modify current translate.
     *
     * @return {Object}
     */
    get: function() {
      return i._o;
    },
    /**
     * Sets an offset value used to modify current translate.
     *
     * @return {Object}
     */
    set: function(r) {
      i._o = Su(r) ? 0 : Ut(r);
    }
  }), xt(i, "translate", {
    /**
     * Gets a raw movement value.
     *
     * @return {Number}
     */
    get: function() {
      return e.Sizes.slideWidth * s.index;
    }
  }), xt(i, "value", {
    /**
     * Gets an actual movement value corrected by offset.
     *
     * @return {Number}
     */
    get: function() {
      var r = this.offset, a = this.translate;
      return e.Direction.is("rtl") ? a + r : a - r;
    }
  }), t.on(["build.before", "run"], function() {
    i.make();
  }), i;
}
function am(s, e, t) {
  var i = {
    /**
     * Setups dimensions of slides.
     *
     * @return {Void}
     */
    setupSlides: function() {
      for (var r = "".concat(this.slideWidth, "px"), a = e.Html.slides, o = 0; o < a.length; o++)
        a[o].style.width = r;
    },
    /**
     * Setups dimensions of slides wrapper.
     *
     * @return {Void}
     */
    setupWrapper: function() {
      e.Html.wrapper.style.width = "".concat(this.wrapperSize, "px");
    },
    /**
     * Removes applied styles from HTML elements.
     *
     * @returns {Void}
     */
    remove: function() {
      for (var r = e.Html.slides, a = 0; a < r.length; a++)
        r[a].style.width = "";
      e.Html.wrapper.style.width = "";
    }
  };
  return xt(i, "length", {
    /**
     * Gets count number of the slides.
     *
     * @return {Number}
     */
    get: function() {
      return e.Html.slides.length;
    }
  }), xt(i, "width", {
    /**
     * Gets width value of the slider (visible area).
     *
     * @return {Number}
     */
    get: function() {
      return e.Html.track.offsetWidth;
    }
  }), xt(i, "wrapperSize", {
    /**
     * Gets size of the slides wrapper.
     *
     * @return {Number}
     */
    get: function() {
      return i.slideWidth * i.length + e.Gaps.grow + e.Clones.grow;
    }
  }), xt(i, "slideWidth", {
    /**
     * Gets width value of a single slide.
     *
     * @return {Number}
     */
    get: function() {
      return i.width / s.settings.perView - e.Peek.reductor - e.Gaps.reductor;
    }
  }), t.on(["build.before", "resize", "update"], function() {
    i.setupSlides(), i.setupWrapper();
  }), t.on("destroy", function() {
    i.remove();
  }), i;
}
function om(s, e, t) {
  var i = {
    /**
     * Init glide building. Adds classes, sets
     * dimensions and setups initial state.
     *
     * @return {Void}
     */
    mount: function() {
      t.emit("build.before"), this.typeClass(), this.activeClass(), t.emit("build.after");
    },
    /**
     * Adds `type` class to the glide element.
     *
     * @return {Void}
     */
    typeClass: function() {
      e.Html.root.classList.add(s.settings.classes.type[s.settings.type]);
    },
    /**
     * Sets active class to current slide.
     *
     * @return {Void}
     */
    activeClass: function() {
      var r = s.settings.classes, a = e.Html.slides[s.index];
      a && (a.classList.add(r.slide.active), Mu(a).forEach(function(o) {
        o.classList.remove(r.slide.active);
      }));
    },
    /**
     * Removes HTML classes applied at building.
     *
     * @return {Void}
     */
    removeClasses: function() {
      var r = s.settings.classes, a = r.type, o = r.slide;
      e.Html.root.classList.remove(a[s.settings.type]), e.Html.slides.forEach(function(l) {
        l.classList.remove(o.active);
      });
    }
  };
  return t.on(["destroy", "update"], function() {
    i.removeClasses();
  }), t.on(["resize", "update"], function() {
    i.mount();
  }), t.on("move.after", function() {
    i.activeClass();
  }), i;
}
function lm(s, e, t) {
  var i = {
    /**
     * Create pattern map and collect slides to be cloned.
     */
    mount: function() {
      this.items = [], s.isType("carousel") && (this.items = this.collect());
    },
    /**
     * Collect clones with pattern.
     *
     * @return {[]}
     */
    collect: function() {
      var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], a = e.Html.slides, o = s.settings, l = o.perView, c = o.classes, h = o.cloningRatio;
      if (a.length > 0)
        for (var d = +!!s.settings.peek, u = l + d + Math.round(l / 2), f = a.slice(0, u).reverse(), g = a.slice(u * -1), v = 0; v < Math.max(h, Math.floor(l / a.length)); v++) {
          for (var m = 0; m < f.length; m++) {
            var p = f[m].cloneNode(!0);
            p.classList.add(c.slide.clone), r.push(p);
          }
          for (var w = 0; w < g.length; w++) {
            var M = g[w].cloneNode(!0);
            M.classList.add(c.slide.clone), r.unshift(M);
          }
        }
      return r;
    },
    /**
     * Append cloned slides with generated pattern.
     *
     * @return {Void}
     */
    append: function() {
      for (var r = this.items, a = e.Html, o = a.wrapper, l = a.slides, c = Math.floor(r.length / 2), h = r.slice(0, c).reverse(), d = r.slice(c * -1).reverse(), u = "".concat(e.Sizes.slideWidth, "px"), f = 0; f < d.length; f++)
        o.appendChild(d[f]);
      for (var g = 0; g < h.length; g++)
        o.insertBefore(h[g], l[0]);
      for (var v = 0; v < r.length; v++)
        r[v].style.width = u;
    },
    /**
     * Remove all cloned slides.
     *
     * @return {Void}
     */
    remove: function() {
      for (var r = this.items, a = 0; a < r.length; a++)
        e.Html.wrapper.removeChild(r[a]);
    }
  };
  return xt(i, "grow", {
    /**
     * Gets additional dimensions value caused by clones.
     *
     * @return {Number}
     */
    get: function() {
      return (e.Sizes.slideWidth + e.Gaps.value) * i.items.length;
    }
  }), t.on("update", function() {
    i.remove(), i.mount(), i.append();
  }), t.on("build.before", function() {
    s.isType("carousel") && i.append();
  }), t.on("destroy", function() {
    i.remove();
  }), i;
}
var Pn = /* @__PURE__ */ (function() {
  function s() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    so(this, s), this.listeners = e;
  }
  return ro(s, [{
    key: "on",
    value: function(t, i, n) {
      var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
      ll(t) && (t = [t]);
      for (var a = 0; a < t.length; a++)
        this.listeners[t[a]] = n, i.addEventListener(t[a], this.listeners[t[a]], r);
    }
    /**
     * Removes event listeners from arrows HTML elements.
     *
     * @param  {String|Array} events
     * @param  {Element|Window|Document} el
     * @param  {Boolean|Object} capture
     * @return {Void}
     */
  }, {
    key: "off",
    value: function(t, i) {
      var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
      ll(t) && (t = [t]);
      for (var r = 0; r < t.length; r++)
        i.removeEventListener(t[r], this.listeners[t[r]], n);
    }
    /**
     * Destroy collected listeners.
     *
     * @returns {Void}
     */
  }, {
    key: "destroy",
    value: function() {
      delete this.listeners;
    }
  }]), s;
})();
function cm(s, e, t) {
  var i = new Pn(), n = {
    /**
     * Initializes window bindings.
     */
    mount: function() {
      this.bind();
    },
    /**
     * Binds `rezsize` listener to the window.
     * It's a costly event, so we are debouncing it.
     *
     * @return {Void}
     */
    bind: function() {
      i.on("resize", window, ao(function() {
        t.emit("resize");
      }, s.settings.throttle));
    },
    /**
     * Unbinds listeners from the window.
     *
     * @return {Void}
     */
    unbind: function() {
      i.off("resize", window);
    }
  };
  return t.on("destroy", function() {
    n.unbind(), i.destroy();
  }), n;
}
var hm = ["ltr", "rtl"], dm = {
  ">": "<",
  "<": ">",
  "=": "="
};
function um(s, e, t) {
  var i = {
    /**
     * Setups gap value based on settings.
     *
     * @return {Void}
     */
    mount: function() {
      this.value = s.settings.direction;
    },
    /**
     * Resolves pattern based on direction value
     *
     * @param {String} pattern
     * @returns {String}
     */
    resolve: function(r) {
      var a = r.slice(0, 1);
      return this.is("rtl") ? r.split(a).join(dm[a]) : r;
    },
    /**
     * Checks value of direction mode.
     *
     * @param {String} direction
     * @returns {Boolean}
     */
    is: function(r) {
      return this.value === r;
    },
    /**
     * Applies direction class to the root HTML element.
     *
     * @return {Void}
     */
    addClass: function() {
      e.Html.root.classList.add(s.settings.classes.direction[this.value]);
    },
    /**
     * Removes direction class from the root HTML element.
     *
     * @return {Void}
     */
    removeClass: function() {
      e.Html.root.classList.remove(s.settings.classes.direction[this.value]);
    }
  };
  return xt(i, "value", {
    /**
     * Gets value of the direction.
     *
     * @returns {Number}
     */
    get: function() {
      return i._v;
    },
    /**
     * Sets value of the direction.
     *
     * @param {String} value
     * @return {Void}
     */
    set: function(r) {
      hm.indexOf(r) > -1 ? i._v = r : an("Direction value must be `ltr` or `rtl`");
    }
  }), t.on(["destroy", "update"], function() {
    i.removeClass();
  }), t.on("update", function() {
    i.mount();
  }), t.on(["build.before", "update"], function() {
    i.addClass();
  }), i;
}
function fm(s, e) {
  return {
    /**
     * Negates the passed translate if glide is in RTL option.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function(i) {
      return e.Direction.is("rtl") ? -i : i;
    }
  };
}
function pm(s, e) {
  return {
    /**
     * Modifies passed translate value with number in the `gap` settings.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function(i) {
      var n = Math.floor(i / e.Sizes.slideWidth);
      return i + e.Gaps.value * n;
    }
  };
}
function mm(s, e) {
  return {
    /**
     * Adds to the passed translate width of the half of clones.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function(i) {
      return i + e.Clones.grow / 2;
    }
  };
}
function gm(s, e) {
  return {
    /**
     * Modifies passed translate value with a `peek` setting.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function(i) {
      if (s.settings.focusAt >= 0) {
        var n = e.Peek.value;
        return Is(n) ? i - n.before : i - n;
      }
      return i;
    }
  };
}
function vm(s, e) {
  return {
    /**
     * Modifies passed translate value with index in the `focusAt` setting.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function(i) {
      var n = e.Gaps.value, r = e.Sizes.width, a = s.settings.focusAt, o = e.Sizes.slideWidth;
      return a === "center" ? i - (r / 2 - o / 2) : i - o * a - n * a;
    }
  };
}
function _m(s, e, t) {
  var i = [pm, mm, gm, vm].concat(s._t, [fm]);
  return {
    /**
     * Piplines translate value with registered transformers.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    mutate: function(r) {
      for (var a = 0; a < i.length; a++) {
        var o = i[a];
        Ua(o) && Ua(o().modify) ? r = o(s, e, t).modify(r) : an("Transformer should be a function that returns an object with `modify()` method");
      }
      return r;
    }
  };
}
function xm(s, e, t) {
  var i = {
    /**
     * Sets value of translate on HTML element.
     *
     * @param {Number} value
     * @return {Void}
     */
    set: function(r) {
      var a = _m(s, e).mutate(r), o = "translate3d(".concat(-1 * a, "px, 0px, 0px)");
      e.Html.wrapper.style.mozTransform = o, e.Html.wrapper.style.webkitTransform = o, e.Html.wrapper.style.transform = o;
    },
    /**
     * Removes value of translate from HTML element.
     *
     * @return {Void}
     */
    remove: function() {
      e.Html.wrapper.style.transform = "";
    },
    /**
     * @return {number}
     */
    getStartIndex: function() {
      var r = e.Sizes.length, a = s.index, o = s.settings.perView;
      return e.Run.isOffset(">") || e.Run.isOffset("|>") ? r + (a - o) : (a + o) % r;
    },
    /**
     * @return {number}
     */
    getTravelDistance: function() {
      var r = e.Sizes.slideWidth * s.settings.perView;
      return e.Run.isOffset(">") || e.Run.isOffset("|>") ? r * -1 : r;
    }
  };
  return t.on("move", function(n) {
    if (!s.isType("carousel") || !e.Run.isOffset())
      return i.set(n.movement);
    e.Transition.after(function() {
      t.emit("translate.jump"), i.set(e.Sizes.slideWidth * s.index);
    });
    var r = e.Sizes.slideWidth * e.Translate.getStartIndex();
    return i.set(r - e.Translate.getTravelDistance());
  }), t.on("destroy", function() {
    i.remove();
  }), i;
}
function ym(s, e, t) {
  var i = !1, n = {
    /**
     * Composes string of the CSS transition.
     *
     * @param {String} property
     * @return {String}
     */
    compose: function(a) {
      var o = s.settings;
      return i ? "".concat(a, " 0ms ").concat(o.animationTimingFunc) : "".concat(a, " ").concat(this.duration, "ms ").concat(o.animationTimingFunc);
    },
    /**
     * Sets value of transition on HTML element.
     *
     * @param {String=} property
     * @return {Void}
     */
    set: function() {
      var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "transform";
      e.Html.wrapper.style.transition = this.compose(a);
    },
    /**
     * Removes value of transition from HTML element.
     *
     * @return {Void}
     */
    remove: function() {
      e.Html.wrapper.style.transition = "";
    },
    /**
     * Runs callback after animation.
     *
     * @param  {Function} callback
     * @return {Void}
     */
    after: function(a) {
      setTimeout(function() {
        a();
      }, this.duration);
    },
    /**
     * Enable transition.
     *
     * @return {Void}
     */
    enable: function() {
      i = !1, this.set();
    },
    /**
     * Disable transition.
     *
     * @return {Void}
     */
    disable: function() {
      i = !0, this.set();
    }
  };
  return xt(n, "duration", {
    /**
     * Gets duration of the transition based
     * on currently running animation type.
     *
     * @return {Number}
     */
    get: function() {
      var a = s.settings;
      return s.isType("slider") && e.Run.offset ? a.rewindDuration : a.animationDuration;
    }
  }), t.on("move", function() {
    n.set();
  }), t.on(["build.before", "resize", "translate.jump"], function() {
    n.disable();
  }), t.on("run", function() {
    n.enable();
  }), t.on("destroy", function() {
    n.remove();
  }), n;
}
var Tu = !1;
try {
  var Bh = Object.defineProperty({}, "passive", {
    get: function() {
      Tu = !0;
    }
  });
  window.addEventListener("testPassive", null, Bh), window.removeEventListener("testPassive", null, Bh);
} catch {
}
var ul = Tu, Gr = ["touchstart", "mousedown"], kh = ["touchmove", "mousemove"], zh = ["touchend", "touchcancel", "mouseup", "mouseleave"], Vh = ["mousedown", "mousemove", "mouseup", "mouseleave"];
function bm(s, e, t) {
  var i = new Pn(), n = 0, r = 0, a = 0, o = !1, l = ul ? {
    passive: !0
  } : !1, c = {
    /**
     * Initializes swipe bindings.
     *
     * @return {Void}
     */
    mount: function() {
      this.bindSwipeStart();
    },
    /**
     * Handler for `swipestart` event. Calculates entry points of the user's tap.
     *
     * @param {Object} event
     * @return {Void}
     */
    start: function(d) {
      if (!o && !s.disabled) {
        this.disable();
        var u = this.touches(d);
        n = null, r = Ut(u.pageX), a = Ut(u.pageY), this.bindSwipeMove(), this.bindSwipeEnd(), t.emit("swipe.start");
      }
    },
    /**
     * Handler for `swipemove` event. Calculates user's tap angle and distance.
     *
     * @param {Object} event
     */
    move: function(d) {
      if (!s.disabled) {
        var u = s.settings, f = u.touchAngle, g = u.touchRatio, v = u.classes, m = this.touches(d), p = Ut(m.pageX) - r, w = Ut(m.pageY) - a, M = Math.abs(p << 2), T = Math.abs(w << 2), E = Math.sqrt(M + T), A = Math.sqrt(T);
        if (n = Math.asin(A / E), n * 180 / Math.PI < f)
          d.stopPropagation(), e.Move.make(p * Yp(g)), e.Html.root.classList.add(v.dragging), t.emit("swipe.move");
        else
          return !1;
      }
    },
    /**
     * Handler for `swipeend` event. Finitializes user's tap and decides about glide move.
     *
     * @param {Object} event
     * @return {Void}
     */
    end: function(d) {
      if (!s.disabled) {
        var u = s.settings, f = u.perSwipe, g = u.touchAngle, v = u.classes, m = this.touches(d), p = this.threshold(d), w = m.pageX - r, M = n * 180 / Math.PI;
        this.enable(), w > p && M < g ? e.Run.make(e.Direction.resolve("".concat(f, "<"))) : w < -p && M < g ? e.Run.make(e.Direction.resolve("".concat(f, ">"))) : e.Move.make(), e.Html.root.classList.remove(v.dragging), this.unbindSwipeMove(), this.unbindSwipeEnd(), t.emit("swipe.end");
      }
    },
    /**
     * Binds swipe's starting event.
     *
     * @return {Void}
     */
    bindSwipeStart: function() {
      var d = this, u = s.settings, f = u.swipeThreshold, g = u.dragThreshold;
      f && i.on(Gr[0], e.Html.wrapper, function(v) {
        d.start(v);
      }, l), g && i.on(Gr[1], e.Html.wrapper, function(v) {
        d.start(v);
      }, l);
    },
    /**
     * Unbinds swipe's starting event.
     *
     * @return {Void}
     */
    unbindSwipeStart: function() {
      i.off(Gr[0], e.Html.wrapper, l), i.off(Gr[1], e.Html.wrapper, l);
    },
    /**
     * Binds swipe's moving event.
     *
     * @return {Void}
     */
    bindSwipeMove: function() {
      var d = this;
      i.on(kh, e.Html.wrapper, ao(function(u) {
        d.move(u);
      }, s.settings.throttle), l);
    },
    /**
     * Unbinds swipe's moving event.
     *
     * @return {Void}
     */
    unbindSwipeMove: function() {
      i.off(kh, e.Html.wrapper, l);
    },
    /**
     * Binds swipe's ending event.
     *
     * @return {Void}
     */
    bindSwipeEnd: function() {
      var d = this;
      i.on(zh, e.Html.wrapper, function(u) {
        d.end(u);
      });
    },
    /**
     * Unbinds swipe's ending event.
     *
     * @return {Void}
     */
    unbindSwipeEnd: function() {
      i.off(zh, e.Html.wrapper);
    },
    /**
     * Normalizes event touches points accorting to different types.
     *
     * @param {Object} event
     */
    touches: function(d) {
      return Vh.indexOf(d.type) > -1 ? d : d.touches[0] || d.changedTouches[0];
    },
    /**
     * Gets value of minimum swipe distance settings based on event type.
     *
     * @return {Number}
     */
    threshold: function(d) {
      var u = s.settings;
      return Vh.indexOf(d.type) > -1 ? u.dragThreshold : u.swipeThreshold;
    },
    /**
     * Enables swipe event.
     *
     * @return {self}
     */
    enable: function() {
      return o = !1, e.Transition.enable(), this;
    },
    /**
     * Disables swipe event.
     *
     * @return {self}
     */
    disable: function() {
      return o = !0, e.Transition.disable(), this;
    }
  };
  return t.on("build.after", function() {
    e.Html.root.classList.add(s.settings.classes.swipeable);
  }), t.on("destroy", function() {
    c.unbindSwipeStart(), c.unbindSwipeMove(), c.unbindSwipeEnd(), i.destroy();
  }), c;
}
function wm(s, e, t) {
  var i = new Pn(), n = {
    /**
     * Binds listener to glide wrapper.
     *
     * @return {Void}
     */
    mount: function() {
      this.bind();
    },
    /**
     * Binds `dragstart` event on wrapper to prevent dragging images.
     *
     * @return {Void}
     */
    bind: function() {
      i.on("dragstart", e.Html.wrapper, this.dragstart);
    },
    /**
     * Unbinds `dragstart` event on wrapper.
     *
     * @return {Void}
     */
    unbind: function() {
      i.off("dragstart", e.Html.wrapper);
    },
    /**
     * Event handler. Prevents dragging.
     *
     * @return {Void}
     */
    dragstart: function(a) {
      a.preventDefault();
    }
  };
  return t.on("destroy", function() {
    n.unbind(), i.destroy();
  }), n;
}
function Sm(s, e, t) {
  var i = new Pn(), n = !1, r = !1, a = {
    /**
     * Setups a initial state of anchors component.
     *
     * @returns {Void}
     */
    mount: function() {
      this._a = e.Html.wrapper.querySelectorAll("a"), this.bind();
    },
    /**
     * Binds events to anchors inside a track.
     *
     * @return {Void}
     */
    bind: function() {
      i.on("click", e.Html.wrapper, this.click);
    },
    /**
     * Unbinds events attached to anchors inside a track.
     *
     * @return {Void}
     */
    unbind: function() {
      i.off("click", e.Html.wrapper);
    },
    /**
     * Handler for click event. Prevents clicks when glide is in `prevent` status.
     *
     * @param  {Object} event
     * @return {Void}
     */
    click: function(l) {
      r && (l.stopPropagation(), l.preventDefault());
    },
    /**
     * Detaches anchors click event inside glide.
     *
     * @return {self}
     */
    detach: function() {
      if (r = !0, !n) {
        for (var l = 0; l < this.items.length; l++)
          this.items[l].draggable = !1;
        n = !0;
      }
      return this;
    },
    /**
     * Attaches anchors click events inside glide.
     *
     * @return {self}
     */
    attach: function() {
      if (r = !1, n) {
        for (var l = 0; l < this.items.length; l++)
          this.items[l].draggable = !0;
        n = !1;
      }
      return this;
    }
  };
  return xt(a, "items", {
    /**
     * Gets collection of the arrows HTML elements.
     *
     * @return {HTMLElement[]}
     */
    get: function() {
      return a._a;
    }
  }), t.on("swipe.move", function() {
    a.detach();
  }), t.on("swipe.end", function() {
    e.Transition.after(function() {
      a.attach();
    });
  }), t.on("destroy", function() {
    a.attach(), a.unbind(), i.destroy();
  }), a;
}
var Mm = '[data-glide-el="controls[nav]"]', Dc = '[data-glide-el^="controls"]', Tm = "".concat(Dc, ' [data-glide-dir*="<"]'), Em = "".concat(Dc, ' [data-glide-dir*=">"]');
function Am(s, e, t) {
  var i = new Pn(), n = ul ? {
    passive: !0
  } : !1, r = {
    /**
     * Inits arrows. Binds events listeners
     * to the arrows HTML elements.
     *
     * @return {Void}
     */
    mount: function() {
      this._n = e.Html.root.querySelectorAll(Mm), this._c = e.Html.root.querySelectorAll(Dc), this._arrowControls = {
        previous: e.Html.root.querySelectorAll(Tm),
        next: e.Html.root.querySelectorAll(Em)
      }, this.addBindings();
    },
    /**
     * Sets active class to current slide.
     *
     * @return {Void}
     */
    setActive: function() {
      for (var o = 0; o < this._n.length; o++)
        this.addClass(this._n[o].children);
    },
    /**
     * Removes active class to current slide.
     *
     * @return {Void}
     */
    removeActive: function() {
      for (var o = 0; o < this._n.length; o++)
        this.removeClass(this._n[o].children);
    },
    /**
     * Toggles active class on items inside navigation.
     *
     * @param  {HTMLElement} controls
     * @return {Void}
     */
    addClass: function(o) {
      var l = s.settings, c = o[s.index];
      c && (c.classList.add(l.classes.nav.active), Mu(c).forEach(function(h) {
        h.classList.remove(l.classes.nav.active);
      }));
    },
    /**
     * Removes active class from active control.
     *
     * @param  {HTMLElement} controls
     * @return {Void}
     */
    removeClass: function(o) {
      var l = o[s.index];
      l?.classList.remove(s.settings.classes.nav.active);
    },
    /**
     * Calculates, removes or adds `Glide.settings.classes.disabledArrow` class on the control arrows
     */
    setArrowState: function() {
      if (!s.settings.rewind) {
        var o = r._arrowControls.next, l = r._arrowControls.previous;
        this.resetArrowState(o, l), s.index === 0 && this.disableArrow(l), s.index === e.Run.length && this.disableArrow(o);
      }
    },
    /**
     * Removes `Glide.settings.classes.disabledArrow` from given NodeList elements
     *
     * @param {NodeList[]} lists
     */
    resetArrowState: function() {
      for (var o = s.settings, l = arguments.length, c = new Array(l), h = 0; h < l; h++)
        c[h] = arguments[h];
      c.forEach(function(d) {
        dl(d).forEach(function(u) {
          u.classList.remove(o.classes.arrow.disabled);
        });
      });
    },
    /**
     * Adds `Glide.settings.classes.disabledArrow` to given NodeList elements
     *
     * @param {NodeList[]} lists
     */
    disableArrow: function() {
      for (var o = s.settings, l = arguments.length, c = new Array(l), h = 0; h < l; h++)
        c[h] = arguments[h];
      c.forEach(function(d) {
        dl(d).forEach(function(u) {
          u.classList.add(o.classes.arrow.disabled);
        });
      });
    },
    /**
     * Adds handles to the each group of controls.
     *
     * @return {Void}
     */
    addBindings: function() {
      for (var o = 0; o < this._c.length; o++)
        this.bind(this._c[o].children);
    },
    /**
     * Removes handles from the each group of controls.
     *
     * @return {Void}
     */
    removeBindings: function() {
      for (var o = 0; o < this._c.length; o++)
        this.unbind(this._c[o].children);
    },
    /**
     * Binds events to arrows HTML elements.
     *
     * @param {HTMLCollection} elements
     * @return {Void}
     */
    bind: function(o) {
      for (var l = 0; l < o.length; l++)
        i.on("click", o[l], this.click), i.on("touchstart", o[l], this.click, n);
    },
    /**
     * Unbinds events binded to the arrows HTML elements.
     *
     * @param {HTMLCollection} elements
     * @return {Void}
     */
    unbind: function(o) {
      for (var l = 0; l < o.length; l++)
        i.off(["click", "touchstart"], o[l]);
    },
    /**
     * Handles `click` event on the arrows HTML elements.
     * Moves slider in direction given via the
     * `data-glide-dir` attribute.
     *
     * @param {Object} event
     * @return {void}
     */
    click: function(o) {
      !ul && o.type === "touchstart" && o.preventDefault();
      var l = o.currentTarget.getAttribute("data-glide-dir");
      e.Run.make(e.Direction.resolve(l));
    }
  };
  return xt(r, "items", {
    /**
     * Gets collection of the controls HTML elements.
     *
     * @return {HTMLElement[]}
     */
    get: function() {
      return r._c;
    }
  }), t.on(["mount.after", "move.after"], function() {
    r.setActive();
  }), t.on(["mount.after", "run"], function() {
    r.setArrowState();
  }), t.on("destroy", function() {
    r.removeBindings(), r.removeActive(), i.destroy();
  }), r;
}
function Rm(s, e, t) {
  var i = new Pn(), n = {
    /**
     * Binds keyboard events on component mount.
     *
     * @return {Void}
     */
    mount: function() {
      s.settings.keyboard && this.bind();
    },
    /**
     * Adds keyboard press events.
     *
     * @return {Void}
     */
    bind: function() {
      i.on("keyup", document, this.press);
    },
    /**
     * Removes keyboard press events.
     *
     * @return {Void}
     */
    unbind: function() {
      i.off("keyup", document);
    },
    /**
     * Handles keyboard's arrows press and moving glide foward and backward.
     *
     * @param  {Object} event
     * @return {Void}
     */
    press: function(a) {
      var o = s.settings.perSwipe, l = {
        ArrowRight: ">",
        ArrowLeft: "<"
      };
      ["ArrowRight", "ArrowLeft"].includes(a.code) && e.Run.make(e.Direction.resolve("".concat(o).concat(l[a.code])));
    }
  };
  return t.on(["destroy", "update"], function() {
    n.unbind();
  }), t.on("update", function() {
    n.mount();
  }), t.on("destroy", function() {
    i.destroy();
  }), n;
}
function Cm(s, e, t) {
  var i = new Pn(), n = {
    /**
     * Initializes autoplaying and events.
     *
     * @return {Void}
     */
    mount: function() {
      this.enable(), this.start(), s.settings.hoverpause && this.bind();
    },
    /**
     * Enables autoplaying
     *
     * @returns {Void}
     */
    enable: function() {
      this._e = !0;
    },
    /**
     * Disables autoplaying.
     *
     * @returns {Void}
     */
    disable: function() {
      this._e = !1;
    },
    /**
     * Starts autoplaying in configured interval.
     *
     * @param {Boolean|Number} force Run autoplaying with passed interval regardless of `autoplay` settings
     * @return {Void}
     */
    start: function() {
      var a = this;
      this._e && (this.enable(), s.settings.autoplay && Su(this._i) && (this._i = setInterval(function() {
        a.stop(), e.Run.make(">"), a.start(), t.emit("autoplay");
      }, this.time)));
    },
    /**
     * Stops autorunning of the glide.
     *
     * @return {Void}
     */
    stop: function() {
      this._i = clearInterval(this._i);
    },
    /**
     * Stops autoplaying while mouse is over glide's area.
     *
     * @return {Void}
     */
    bind: function() {
      var a = this;
      i.on("mouseover", e.Html.root, function() {
        a._e && a.stop();
      }), i.on("mouseout", e.Html.root, function() {
        a._e && a.start();
      });
    },
    /**
     * Unbind mouseover events.
     *
     * @returns {Void}
     */
    unbind: function() {
      i.off(["mouseover", "mouseout"], e.Html.root);
    }
  };
  return xt(n, "time", {
    /**
     * Gets time period value for the autoplay interval. Prioritizes
     * times in `data-glide-autoplay` attrubutes over options.
     *
     * @return {Number}
     */
    get: function() {
      var a = e.Html.slides[s.index].getAttribute("data-glide-autoplay");
      return Ut(a || s.settings.autoplay);
    }
  }), t.on(["destroy", "update"], function() {
    n.unbind();
  }), t.on(["run.before", "swipe.start", "update"], function() {
    n.stop();
  }), t.on(["pause", "destroy"], function() {
    n.disable(), n.stop();
  }), t.on(["run.after", "swipe.end"], function() {
    n.start();
  }), t.on(["play"], function() {
    n.enable(), n.start();
  }), t.on("update", function() {
    n.mount();
  }), t.on("destroy", function() {
    i.destroy();
  }), n;
}
function Hh(s) {
  return Is(s) ? Zp(s) : (an("Breakpoints option must be an object"), {});
}
function Im(s, e, t) {
  var i = new Pn(), n = s.settings, r = Hh(n.breakpoints), a = Object.assign({}, n), o = {
    /**
     * Matches settings for currectly matching media breakpoint.
     *
     * @param {Object} points
     * @returns {Object}
     */
    match: function(c) {
      if (typeof window.matchMedia < "u") {
        for (var h in c)
          if (c.hasOwnProperty(h) && window.matchMedia("(max-width: ".concat(h, "px)")).matches)
            return c[h];
      }
      return a;
    }
  };
  return Object.assign(n, o.match(r)), i.on("resize", window, ao(function() {
    s.settings = hl(n, o.match(r));
  }, s.settings.throttle)), t.on("update", function() {
    r = Hh(r), a = Object.assign({}, n);
  }), t.on("destroy", function() {
    i.off("resize", window);
  }), o;
}
var Pm = {
  // Required
  Html: nm,
  Translate: xm,
  Transition: ym,
  Direction: um,
  Peek: sm,
  Sizes: am,
  Gaps: tm,
  Move: rm,
  Clones: lm,
  Resize: cm,
  Build: om,
  Run: em,
  // Optional
  Swipe: bm,
  Images: wm,
  Anchors: Sm,
  Controls: Am,
  Keyboard: Rm,
  Autoplay: Cm,
  Breakpoints: Im
}, Lm = /* @__PURE__ */ (function(s) {
  Hp(t, s);
  var e = Wp(t);
  function t() {
    return so(this, t), e.apply(this, arguments);
  }
  return ro(t, [{
    key: "mount",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      return wa(Cs(t.prototype), "mount", this).call(this, Object.assign({}, Pm, n));
    }
  }]), t;
})(Qp);
const Dm = ".vh-microsite-gallery{padding:0 0 36px;width:100%;overflow:hidden;box-sizing:border-box}@media screen and (min-width:810px){.vh-microsite-gallery{padding:0 0 100px}}.vh-microsite-gallery__gallery{overflow:hidden}.vh-microsite-gallery__content{display:flex;margin:0;padding:0;list-style:none}.vh-microsite-gallery__item{aspect-ratio:13/11;overflow:hidden}.vh-microsite-gallery__item img{display:block;width:100%;height:100%;object-fit:cover;object-position:center center}.vh-microsite-gallery__bullets{display:flex;justify-content:center;gap:16px;margin-top:32px}.vh-microsite-gallery__bullet{background:var(--vh-color-gray);border:1px solid var(--vh-color-gray);outline:none;margin:0;padding:0;display:block;width:8px;height:8px;cursor:pointer;border-radius:50%}.glide__bullet--active{background:var(--vh-color-navy);border:1px solid var(--vh-color-navy)}";
var Nm = Object.defineProperty, Om = Object.getOwnPropertyDescriptor, Eu = (s, e, t, i) => {
  for (var n = i > 1 ? void 0 : i ? Om(e, t) : e, r = s.length - 1, a; r >= 0; r--)
    (a = s[r]) && (n = (i ? a(e, t, n) : a(n)) || n);
  return i && n && Nm(e, t, n), n;
};
let Fa = class extends Ie {
  firstUpdated() {
    const s = this.renderRoot.querySelector(".glide");
    if (s) {
      const e = new Lm(s, {
        type: "carousel",
        autoplay: 3e3,
        startAt: 0,
        perView: 3,
        breakpoints: {
          810: {
            perView: 1,
            peek: {
              before: 0,
              after: 0
            }
          }
        }
      });
      e.mount(), s.addEventListener("click", (t) => {
        if (t.target.closest(".glide__bullet")) return;
        const n = s.getBoundingClientRect();
        t.clientX - n.left < n.width / 2 ? e.go("<") : e.go(">");
      });
    }
  }
  render() {
    return $`
    <div class="vh-microsite-gallery">
      <div class="glide vh-microsite-gallery__gallery">
        <div class="glide__track" data-glide-el="track">
          <ul class="glide__slides vh-microsite-gallery__content">
            ${this.items?.map(
      (s) => $`<li class="glide__slide vh-microsite-gallery__item">
              <img src="${s}" alt="">
            </li>`
    )}
          </ul>
        </div>
        <div class="glide__bullets vh-microsite-gallery__bullets" data-glide-el="controls[nav]">
          ${this.items?.map(
      (s, e) => $`
            <button class="glide__bullet vh-microsite-gallery__bullet" data-glide-dir="=${e}" aria-label="Slide ${e + 1}"></button>
          `
    )}
        </div>
      </div>
    </div>
    `;
  }
};
Fa.styles = Je`
    ${We(Dm)}
  `;
Eu([
  D({ type: Array })
], Fa.prototype, "items", 2);
Fa = Eu([
  Oe("vh-microsite-gallery")
], Fa);
const Um = ".vh-microsite-feed__background{position:relative;background-size:cover;padding:85px 24px;background-image:var(--background-image-mobile)}@media screen and (min-width:810px){.vh-microsite-feed__background{background-image:var(--background-image);padding:100px}}.vh-microsite-feed__image{position:absolute;z-index:100}.vh-microsite-feed__image svg,.vh-microsite-feed__image img{width:100%;height:auto}.vh-microsite-feed__image-1{width:81px;left:12px;top:20%}@media screen and (min-width:810px){.vh-microsite-feed__image-1{width:auto;left:24px}}.vh-microsite-feed__image-2{width:81px;right:24px;top:40%}@media screen and (min-width:810px){.vh-microsite-feed__image-2{width:auto;inset:auto auto 24px 170px}}.vh-microsite-feed__image-3{width:85px;left:18px;top:60%}@media screen and (min-width:810px){.vh-microsite-feed__image-3{right:calc(50% - 42.5px);left:auto;top:75px}}.vh-microsite-feed__image-4{width:146px;bottom:50px;right:0}@media screen and (min-width:810px){.vh-microsite-feed__image-4{width:auto;bottom:0}}.vh-microsite-feed__iframe{width:100%;min-height:600px;background-color:var(--vh-color-white)}";
var Fm = Object.defineProperty, Bm = Object.getOwnPropertyDescriptor, qs = (s, e, t, i) => {
  for (var n = i > 1 ? void 0 : i ? Bm(e, t) : e, r = s.length - 1, a; r >= 0; r--)
    (a = s[r]) && (n = (i ? a(e, t, n) : a(n)) || n);
  return i && n && Fm(e, t, n), n;
};
let Rn = class extends Ie {
  render() {
    return $`
      <div class="vh-microsite-feed">
        <div class="vh-microsite-feed__background" style="--background-image: url(${this.background}); --background-image-mobile: url(${this.backgroundMobile})">
          <div class="vh-microsite-feed__iframe">
            <slot></slot>
          </div>
          <div class="vh-microsite-feed__image vh-microsite-feed__image-1">
            ${this.image1 ? $`<img src=${this.image1} alt="" />` : null}
          </div>
          <div class="vh-microsite-feed__image vh-microsite-feed__image-2">
            ${this.image2 ? $`<img src=${this.image2} alt="" />` : null}
          </div>
          <div class="vh-microsite-feed__image vh-microsite-feed__image-3">
            ${this.image3 ? $`<img src=${this.image3} alt="" />` : null}
          </div>
          <div class="vh-microsite-feed__image vh-microsite-feed__image-4">
            <svg xmlns="http://www.w3.org/2000/svg" width="329" height="256" fill="none" viewBox="0 0 329 256"><path fill="#fff" d="M19.628 113.212c10.13-10.2 29.89-15.45 44.917-.757l24.84 23.39a35 35 0 0 1-.079-4.211c.466-11.294 6.48-22.584 18.353-28.807 25.134-13.184 50.007 6.001 51.132 29.062l.473.265.657.369q.295-.151.617-.307l.081-.04c4.711-2.252 9.928-3.26 15.115-3.003l-8.459-9.558a18 18 0 0 1 6.137-28.364l10.131-4.526.343-.15a18 18 0 0 1 16.69 1.415 18 18 0 0 1 10.423-13.532l9.77-4.365c1.004-.449 2.039-.8 3.089-1.055a18 18 0 0 1 2.889-1.622l9.409-4.204a17.95 17.95 0 0 1 14.29-.17 17.95 17.95 0 0 1 9.66-10.53l9.409-4.204c9.076-4.055 19.722.016 23.777 9.092l23.732 53.118c4.055 9.076-.016 19.722-9.092 23.777l-9.409 4.203a17.95 17.95 0 0 1-14.293.168 17.95 17.95 0 0 1-9.659 10.527l-9.409 4.204a17.94 17.94 0 0 1-13.301.55 18 18 0 0 1-9.287 9.548l-14.065 6.284a18 18 0 0 1-20.822-4.505l-2.202-2.487c-1.426 17.695-18.247 32.655-38.583 27.999-11.505-2.613-20.16-11.847-22.892-22.293a8 8 0 0 0-.244-.469 10 10 0 0 0-.343-.558l-.093-.136-2.909-1.621-.004.44v.027c.001.06.007.477.039 1.451.033.997.084 2.292.148 3.821.129 3.062.303 6.865.478 10.784.324 7.235.721 16.154.627 19.295l-.003.099c-.029.824-.101 4.695-1.663 9.092h-.001c-4.914 13.872-19.961 22.913-34.738 20.551-11.215-1.791-18.697-9.864-20.684-11.714l-.073-.069-63.775-60.073-.158-.15C13.72 152.609 9.878 144.005 10.16 134.8c.268-8.792 4.237-16.32 9.469-21.588"/><path fill="#025f1d" d="m228.142 86.596 7.121 60.533-14.066 6.284-40.412-45.659 10.131-4.526 31.089 36.679 3.004-1.342-6.637-47.604zm48.748-21.78 23.73 53.113-9.409 4.203-10.12-22.653-23.951 10.701 10.119 22.647-9.409 4.204-23.73-53.113 9.409-4.203 9.602 21.491 23.95-10.7-9.602-21.492 9.409-4.203zm-95.498 84.423c-3.929-2.457-8.966-2.673-12.979-.754-.671.324-1.383.755-1.961 1.064-2.496 1.297-6.98 3.049-11.195 1.047 0 0-9.532-5.346-9.549-5.357-4.08-2.709-4.761-8.337-4.855-10.95.007-.449-.005-1.373-.005-1.373-.501-11.533-12.648-20.456-24.801-14.079-11.515 6.036-10.987 20.904-2.297 28.032 1.469 1.308 6.873 6.771 6.191 15.783l-.459 3.356c-.614 3.557-4.427 18.864-22.844 1.431l-44.525-41.926c-12.608-12.54-33.557 6.788-18.969 20.866l63.775 60.073c3.279 3.055 6.565 6.363 11.256 7.111 6.199.991 12.927-3.101 14.937-8.801.567-1.597.613-3.068.636-3.706.136-4.529-1.348-31.65-1.299-35.068.021-1.667.011-2.308.092-3.067 1.009-8.981 6.788-13.02 9.255-14.41 1.97-1.113 7.341-3.801 12.195-1.368l9.57 5.334c3.432 1.976 7.013 7.884 7.845 11.335 1.066 4.407 4.875 8.437 9.513 9.49 11.674 2.694 20.253-9.199 15.147-18.913-.893-1.704-2.549-3.808-4.69-5.143z"/></svg>
          </div>
        </div>
      </div>
    `;
  }
};
Rn.styles = Je`
    ${We(Um)}
  `;
qs([
  D()
], Rn.prototype, "background", 2);
qs([
  D()
], Rn.prototype, "backgroundMobile", 2);
qs([
  D()
], Rn.prototype, "image1", 2);
qs([
  D()
], Rn.prototype, "image2", 2);
qs([
  D()
], Rn.prototype, "image3", 2);
Rn = qs([
  Oe("vh-microsite-feed")
], Rn);
const km = ".vh-microsite-page{max-width:1440px;margin:0 auto}.vh-microsite-page__button{padding-bottom:100px;display:flex;justify-content:center}";
var zm = Object.defineProperty, Vm = Object.getOwnPropertyDescriptor, Gi = (s, e, t, i) => {
  for (var n = i > 1 ? void 0 : i ? Vm(e, t) : e, r = s.length - 1, a; r >= 0; r--)
    (a = s[r]) && (n = (i ? a(e, t, n) : a(n)) || n);
  return i && n && zm(e, t, n), n;
};
let _i = class extends Ie {
  render() {
    return $`
      <div class="vh-microsite-page">
        <vh-microsite-tout 
          heading=${this.toutOne?.heading || ""}
          headingLevel=${this.toutOne?.headingLevel || 2}
          body=${this.toutOne?.body || ""}
        ></vh-microsite-tout>
        <vh-microsite-countdown
          targetDate=${this.countdown?.targetDate || ""}
          heading=${this.countdown?.heading || ""}
          image=${this.countdown?.image || ""}
          imageMobile=${this.countdown?.imageMobile || ""}
          video=${this.countdown?.video || ""}
          .balloonsTotal=${this.countdown?.balloonsTotal || 0}
          .balloons=${this.countdown?.balloons || []}
        ></vh-microsite-countdown>
        <vh-microsite-tout 
          heading=${this.toutTwo?.heading || ""}
          headingLevel=${this.toutTwo?.headingLevel || 2}
          body=${this.toutTwo?.body || ""}
        ></vh-microsite-tout>
        <vh-microsite-gallery
          .items=${this.gallery?.items || []}
        ></vh-microsite-gallery>
        <vh-microsite-marquee
          .items=${this.marquee?.items || []}
        ></vh-microsite-marquee>
        <vh-microsite-tout 
          heading=${this.toutThree?.heading || ""}
          headingLevel=${this.toutThree?.headingLevel || 2}
          body=${this.toutThree?.body || ""}
        ></vh-microsite-tout>
        <vh-microsite-steps
          heading=${this.steps?.heading || ""}
          date=${this.steps?.date || ""}
          .steps=${this.steps?.steps || []}
        ></vh-microsite-steps>
        <div class="vh-microsite-page__button">
          <vh-microsite-button 
            href=${this.button?.href || ""}
            target=${this.button?.target || "_self"}
            label=${this.button?.label || ""}
          ></vh-microsite-button>
        </div>
        <vh-microsite-feed
          background=${this.feed?.background || ""}
          backgroundMobile=${this.feed?.backgroundMobile || ""}
          image1=${this.feed?.image1 || ""}
          image2=${this.feed?.image2 || ""}
          image3=${this.feed?.image3 || ""}
        ><slot></slot></vh-microsite-feed>
      </div>
    `;
  }
};
_i.styles = Je`
    ${We(km)}
  `;
Gi([
  D({ type: Object })
], _i.prototype, "toutOne", 2);
Gi([
  D({ type: Object })
], _i.prototype, "toutTwo", 2);
Gi([
  D({ type: Object })
], _i.prototype, "toutThree", 2);
Gi([
  D({ type: Object })
], _i.prototype, "countdown", 2);
Gi([
  D({ type: Object })
], _i.prototype, "gallery", 2);
Gi([
  D({ type: Object })
], _i.prototype, "marquee", 2);
Gi([
  D({ type: Object })
], _i.prototype, "button", 2);
Gi([
  D({ type: Object })
], _i.prototype, "steps", 2);
Gi([
  D({ type: Object })
], _i.prototype, "feed", 2);
_i = Gi([
  Oe("vh-microsite-page")
], _i);
const Hm = ".vh-microsite-callout{padding:40px 24px;overflow:hidden}@media screen and (min-width:810px){.vh-microsite-callout{overflow:visible;padding:100px 24px}}.vh-microsite-callout__content{display:flex;flex-direction:column;gap:24px}@media screen and (min-width:810px){.vh-microsite-callout__content{flex-direction:row;max-width:960px;margin:0 auto;gap:32px;align-items:center}}.vh-microsite-callout__left{display:flex;flex-direction:column;gap:32px;align-items:center}.vh-microsite-callout__icon{flex-shrink:0}.vh-microsite-callout__title{font-family:var(--vh-font-feature-display-condensed);font-size:48px;font-style:normal;font-weight:400;line-height:1}@media screen and (min-width:810px){.vh-microsite-callout__title{font-size:52px}}.vh-microsite-callout__title{color:var(--vh-color-navy);text-align:center;font-weight:700}.vh-microsite-callout__right{font-family:var(--vh-font-poppins);font-size:16px;font-style:normal;font-weight:400;line-height:1.5;flex:1;display:flex;flex-direction:column;gap:16px;color:var(--vh-color-navy);border-top:2px solid var(--vh-color-light-green);padding-top:24px}@media screen and (min-width:810px){.vh-microsite-callout__right{border-top:none;border-left:2px solid var(--vh-color-light-green);padding-left:32px}}.vh-microsite-callout__content--pre-animate .vh-microsite-callout__left,.vh-microsite-callout__content--pre-animate .vh-microsite-callout__right{opacity:0}.vh-microsite-callout__content--animate .vh-microsite-callout__left{opacity:0;animation:fadeIn .3s ease-out forwards,slideFromLeft .5s ease-out forwards}.vh-microsite-callout__content--animate .vh-microsite-callout__right{opacity:0;animation:fadeIn .3s ease-out forwards,slideFromRight .5s ease-out forwards}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}@keyframes slideFromLeft{0%{transform:translate(-50px)}to{transform:translate(0)}}@keyframes slideFromRight{0%{transform:translate(50px)}to{transform:translate(0)}}";
var $m = Object.defineProperty, Gm = Object.getOwnPropertyDescriptor, Au = (s, e, t, i) => {
  for (var n = i > 1 ? void 0 : i ? Gm(e, t) : e, r = s.length - 1, a; r >= 0; r--)
    (a = s[r]) && (n = (i ? a(e, t, n) : a(n)) || n);
  return i && n && $m(e, t, n), n;
};
let Ba = class extends Ie {
  constructor() {
    super(...arguments), this.isVisible = !1;
  }
  connectedCallback() {
    super.connectedCallback(), this.observer = new IntersectionObserver(
      (s) => {
        s.forEach((e) => {
          e.isIntersecting && !this.isVisible && (this.isVisible = !0);
        });
      },
      { threshold: 0.5 }
    );
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.observer?.disconnect();
  }
  firstUpdated() {
    const s = this.shadowRoot?.querySelector(".vh-microsite-callout__content");
    s && this.observer && this.observer.observe(s);
  }
  render() {
    return $`
      <div class="vh-microsite-callout">
        <div class=${Ze({
      "vh-microsite-callout__content": !0,
      "vh-microsite-callout__content--pre-animate": !0,
      "vh-microsite-callout__content--animate": this.isVisible
    })}>
          <div class="vh-microsite-callout__left">
            <vh-icon-spark size="24" fill="var(--vh-color-light-green)"></vh-icon-spark>
            <div class="vh-microsite-callout__title">
              <slot name="title"></slot>
            </div>
          </div>
          <div class="vh-microsite-callout__right">
            <slot name="description"></slot>
          </div>
        </div>
      </div>
    `;
  }
};
Ba.styles = Je`
    ${We(Hm)}
  `;
Au([
  D({ type: Boolean })
], Ba.prototype, "isVisible", 2);
Ba = Au([
  Oe("vh-microsite-callout")
], Ba);
const qm = String.raw, Wm = (() => {
  try {
    document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
  } catch {
    return !1;
  }
  return !0;
})(), Xm = typeof CSS < "u" && CSS.supports && CSS.supports("line-height", "mod(1,1)"), jm = typeof matchMedia < "u" ? matchMedia("(prefers-reduced-motion: reduce)") : null, ka = "--_number-flow-d-opacity", Nc = "--_number-flow-d-width", za = "--_number-flow-dx", Oc = "--_number-flow-d", Ym = (() => {
  try {
    return CSS.registerProperty({
      name: ka,
      syntax: "<number>",
      inherits: !1,
      initialValue: "0"
    }), CSS.registerProperty({
      name: za,
      syntax: "<length>",
      inherits: !0,
      initialValue: "0px"
    }), CSS.registerProperty({
      name: Nc,
      syntax: "<number>",
      inherits: !1,
      initialValue: "0"
    }), CSS.registerProperty({
      name: Oc,
      syntax: "<number>",
      inherits: !0,
      initialValue: "0"
    }), !0;
  } catch {
    return !1;
  }
})(), fl = "round(nearest, calc(var(--number-flow-mask-height, 0.25em) / 2), 1px)", Un = `calc(${fl} * 2)`, pl = "var(--number-flow-mask-width, 0.5em)", Fn = `calc(${pl} / var(--scale-x))`, qr = "#000 0, transparent 71%", Km = qm`:host{display:inline-block;direction:ltr;white-space:nowrap;isolation:isolate;line-height:1}.number,.number__inner{display:inline-block;transform-origin:left top}:host([data-will-change]) :is(.number,.number__inner,.section,.digit,.digit__num,.symbol){will-change:transform}.number{--scale-x:calc(1 + var(${Nc}) / var(--width));transform:translateX(var(${za})) scaleX(var(--scale-x));margin:0 calc(-1 * ${pl});position:relative;-webkit-mask-image:linear-gradient(to right,transparent 0,#000 ${Fn},#000 calc(100% - ${Fn}),transparent ),linear-gradient(to bottom,transparent 0,#000 ${Un},#000 calc(100% - ${Un}),transparent 100% ),radial-gradient(at bottom right,${qr}),radial-gradient(at bottom left,${qr}),radial-gradient(at top left,${qr}),radial-gradient(at top right,${qr});-webkit-mask-size:100% calc(100% - ${Un} * 2),calc(100% - ${Fn} * 2) 100%,${Fn} ${Un},${Fn} ${Un},${Fn} ${Un},${Fn} ${Un};-webkit-mask-position:center,center,top left,top right,bottom right,bottom left;-webkit-mask-repeat:no-repeat}.number__inner{padding:${fl} ${pl};transform:scaleX(calc(1 / var(--scale-x))) translateX(calc(-1 * var(${za})))}:host > :not(.number){z-index:5}.section,.symbol{display:inline-block;position:relative;isolation:isolate}.section::after{content:'\200b';display:inline-block}.section--justify-left{transform-origin:center left}.section--justify-right{transform-origin:center right}.section > [inert],.symbol > [inert]{margin:0 !important;position:absolute !important;z-index:-1}.digit{display:inline-block;position:relative;--c:var(--current) + var(${Oc})}.digit__num,.number .section::after{padding:${fl} 0}.digit__num{display:inline-block;--offset-raw:mod(var(--length) + var(--n) - mod(var(--c),var(--length)),var(--length));--offset:calc( var(--offset-raw) - var(--length) * round(down,var(--offset-raw) / (var(--length) / 2),1) );--y:clamp(-100%,var(--offset) * 100%,100%);transform:translateY(var(--y))}.digit__num[inert]{position:absolute;top:0;left:50%;transform:translateX(-50%) translateY(var(--y))}.digit:not(.is-spinning) .digit__num[inert]{display:none}.symbol__value{display:inline-block;mix-blend-mode:plus-lighter;white-space:pre}.section--justify-left .symbol > [inert]{left:0}.section--justify-right .symbol > [inert]{right:0}.animate-presence{opacity:calc(1 + var(${ka}))}`, Zm = HTMLElement, En = (s, e, t) => {
  const i = document.createElement(s), [n, r] = Array.isArray(e) ? [void 0, e] : [e, t];
  return n && Object.assign(i, n), r?.forEach((a) => i.appendChild(a)), i;
}, Jm = (s, e) => {
  var t;
  return e === "left" ? s.offsetLeft : (((t = s.offsetParent instanceof HTMLElement ? s.offsetParent : null) == null ? void 0 : t.offsetWidth) ?? 0) - s.offsetWidth - s.offsetLeft;
}, Qm = (s) => s.offsetWidth > 0 && s.offsetHeight > 0, eg = (s, e) => {
  !customElements.get(s) && customElements.define(s, e);
};
function tg(s, e, { reverse: t = !1 } = {}) {
  const i = s.length;
  for (let n = t ? i - 1 : 0; t ? n >= 0 : n < i; t ? n-- : n++)
    e(s[n], n);
}
function ig(s, e, t, i) {
  const n = e.formatToParts(s);
  t && n.unshift({ type: "prefix", value: t }), i && n.push({ type: "suffix", value: i });
  const r = [], a = [], o = [], l = [], c = {}, h = (v) => `${v}:${c[v] = (c[v] ?? -1) + 1}`;
  let d = "", u = !1, f = !1;
  for (const v of n) {
    d += v.value;
    const m = v.type === "minusSign" || v.type === "plusSign" ? "sign" : v.type;
    m === "integer" ? (u = !0, a.push(...v.value.split("").map((p) => ({ type: m, value: parseInt(p) })))) : m === "group" ? a.push({ type: m, value: v.value }) : m === "decimal" ? (f = !0, o.push({ type: m, value: v.value, key: h(m) })) : m === "fraction" ? o.push(...v.value.split("").map((p) => ({
      type: m,
      value: parseInt(p),
      key: h(m),
      pos: -1 - c[m]
    }))) : (u || f ? l : r).push({
      type: m,
      value: v.value,
      key: h(m)
    });
  }
  const g = [];
  for (let v = a.length - 1; v >= 0; v--) {
    const m = a[v];
    g.unshift(m.type === "integer" ? {
      ...m,
      key: h(m.type),
      pos: c[m.type]
    } : {
      ...m,
      key: h(m.type)
    });
  }
  return {
    pre: r,
    integer: g,
    fraction: o,
    post: l,
    valueAsString: d,
    value: typeof s == "string" ? parseFloat(s) : s
  };
}
const ng = Xm && Wm && Ym;
class Ru extends Zm {
  constructor() {
    super(), this.created = !1, this.batched = !1;
    const { animated: e, ...t } = this.constructor.defaultProps;
    this._animated = this.computedAnimated = e, Object.assign(this, t);
  }
  get animated() {
    return this._animated;
  }
  set animated(e) {
    var t;
    this.animated !== e && (this._animated = e, (t = this.shadowRoot) == null || t.getAnimations().forEach((i) => i.finish()));
  }
  /**
   * @internal
   */
  set data(e) {
    var t, i;
    if (e == null)
      return;
    const { pre: n, integer: r, fraction: a, post: o, value: l } = e;
    if (this.created) {
      const c = this._data;
      this._data = e, this.computedTrend = typeof this.trend == "function" ? this.trend(c.value, l) : this.trend, this.computedAnimated = ng && this._animated && (!this.respectMotionPreference || !((t = jm) != null && t.matches)) && // https://github.com/barvian/number-flow/issues/9
      Qm(this) && // https://github.com/barvian/number-flow/issues/165
      this.ownerDocument.visibilityState === "visible", (i = this.plugins) == null || i.forEach((h) => {
        var d;
        return (d = h.onUpdate) == null ? void 0 : d.call(h, e, c, this);
      }), this.batched || this.willUpdate(), this._pre.update(n), this._num.update({ integer: r, fraction: a }), this._post.update(o), this.batched || this.didUpdate();
    } else {
      this._data = e, this.attachShadow({ mode: "open" });
      try {
        this._internals ?? (this._internals = this.attachInternals()), this._internals.role = "img";
      } catch {
      }
      const c = document.createElement("style");
      this.nonce && (c.nonce = this.nonce), c.textContent = Km, this.shadowRoot.appendChild(c), this._pre = new Gh(this, n, {
        justify: "right",
        part: "left"
      }), this.shadowRoot.appendChild(this._pre.el), this._num = new sg(this, r, a), this.shadowRoot.appendChild(this._num.el), this._post = new Gh(this, o, {
        justify: "left",
        part: "right"
      }), this.shadowRoot.appendChild(this._post.el), this.created = !0;
    }
    try {
      this._internals.ariaLabel = e.valueAsString;
    } catch {
    }
  }
  /**
   * @internal
   */
  willUpdate() {
    this._pre.willUpdate(), this._num.willUpdate(), this._post.willUpdate();
  }
  /**
   * @internal
   */
  didUpdate() {
    if (!this.computedAnimated)
      return;
    this._abortAnimationsFinish ? this._abortAnimationsFinish.abort() : this.dispatchEvent(new Event("animationsstart")), this._pre.didUpdate(), this._num.didUpdate(), this._post.didUpdate();
    const e = new AbortController();
    Promise.all(this.shadowRoot.getAnimations().map((t) => t.finished)).then(() => {
      e.signal.aborted || (this.dispatchEvent(new Event("animationsfinish")), this._abortAnimationsFinish = void 0);
    }), this._abortAnimationsFinish = e;
  }
}
Ru.defaultProps = {
  transformTiming: {
    duration: 900,
    // Make sure to keep this minified:
    easing: "linear(0,.005,.019,.039,.066,.096,.129,.165,.202,.24,.278,.316,.354,.39,.426,.461,.494,.526,.557,.586,.614,.64,.665,.689,.711,.731,.751,.769,.786,.802,.817,.831,.844,.856,.867,.877,.887,.896,.904,.912,.919,.925,.931,.937,.942,.947,.951,.955,.959,.962,.965,.968,.971,.973,.976,.978,.98,.981,.983,.984,.986,.987,.988,.989,.99,.991,.992,.992,.993,.994,.994,.995,.995,.996,.996,.9963,.9967,.9969,.9972,.9975,.9977,.9979,.9981,.9982,.9984,.9985,.9987,.9988,.9989,1)"
  },
  spinTiming: void 0,
  opacityTiming: { duration: 450, easing: "ease-out" },
  animated: !0,
  trend: (s, e) => Math.sign(e - s),
  respectMotionPreference: !0,
  plugins: void 0,
  digits: void 0
};
class sg {
  constructor(e, t, i, { className: n, ...r } = {}) {
    this.flow = e, this._integer = new $h(e, t, {
      justify: "right",
      part: "integer"
    }), this._fraction = new $h(e, i, {
      justify: "left",
      part: "fraction"
    }), this._inner = En("span", {
      className: "number__inner"
    }, [this._integer.el, this._fraction.el]), this.el = En("span", {
      ...r,
      part: "number",
      className: `number ${n ?? ""}`
    }, [this._inner]);
  }
  willUpdate() {
    this._prevWidth = this.el.offsetWidth, this._prevLeft = this.el.getBoundingClientRect().left, this._integer.willUpdate(), this._fraction.willUpdate();
  }
  update({ integer: e, fraction: t }) {
    this._integer.update(e), this._fraction.update(t);
  }
  didUpdate() {
    const e = this.el.getBoundingClientRect();
    this._integer.didUpdate(), this._fraction.didUpdate();
    const t = this._prevLeft - e.left, i = this.el.offsetWidth, n = this._prevWidth - i;
    this.el.style.setProperty("--width", String(i)), this.el.animate({
      [za]: [`${t}px`, "0px"],
      [Nc]: [n, 0]
    }, {
      ...this.flow.transformTiming,
      composite: "accumulate"
    });
  }
}
class Cu {
  constructor(e, t, { justify: i, className: n, ...r }, a) {
    this.flow = e, this.children = /* @__PURE__ */ new Map(), this.onCharRemove = (l) => () => {
      this.children.delete(l);
    }, this.justify = i;
    const o = t.map((l) => this.addChar(l).el);
    this.el = En("span", {
      ...r,
      className: `section section--justify-${i} ${n ?? ""}`
    }, a ? a(o) : o);
  }
  addChar(e, { startDigitsAtZero: t = !1, ...i } = {}) {
    const n = e.type === "integer" || e.type === "fraction" ? new Pu(this, e.type, t ? 0 : e.value, e.pos, {
      ...i,
      onRemove: this.onCharRemove(e.key)
    }) : new rg(this, e.type, e.value, {
      ...i,
      onRemove: this.onCharRemove(e.key)
    });
    return this.children.set(e.key, n), n;
  }
  unpop(e) {
    e.el.removeAttribute("inert"), e.el.style.top = "", e.el.style[this.justify] = "";
  }
  pop(e) {
    e.forEach((t) => {
      t.el.style.top = `${t.el.offsetTop}px`, t.el.style[this.justify] = `${Jm(t.el, this.justify)}px`;
    }), e.forEach((t) => {
      t.el.setAttribute("inert", ""), t.present = !1;
    });
  }
  addNewAndUpdateExisting(e) {
    const t = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), n = this.justify === "left", r = n ? "prepend" : "append";
    if (tg(e, (a) => {
      let o;
      this.children.has(a.key) ? (o = this.children.get(a.key), i.set(a, o), this.unpop(o), o.present = !0) : (o = this.addChar(a, { startDigitsAtZero: !0, animateIn: !0 }), t.set(a, o)), this.el[r](o.el);
    }, { reverse: n }), this.flow.computedAnimated) {
      const a = this.el.getBoundingClientRect();
      t.forEach((o) => {
        o.willUpdate(a);
      });
    }
    t.forEach((a, o) => {
      a.update(o.value);
    }), i.forEach((a, o) => {
      a.update(o.value);
    });
  }
  willUpdate() {
    const e = this.el.getBoundingClientRect();
    this._prevOffset = e[this.justify], this.children.forEach((t) => t.willUpdate(e));
  }
  didUpdate() {
    const e = this.el.getBoundingClientRect();
    this.children.forEach((n) => n.didUpdate(e));
    const t = e[this.justify], i = this._prevOffset - t;
    i && this.children.size && this.el.animate({
      transform: [`translateX(${i}px)`, "none"]
    }, {
      ...this.flow.transformTiming,
      composite: "accumulate"
    });
  }
}
let $h = class extends Cu {
  update(e) {
    const t = /* @__PURE__ */ new Map();
    this.children.forEach((i, n) => {
      e.find((r) => r.key === n) || t.set(n, i), this.unpop(i);
    }), this.addNewAndUpdateExisting(e), t.forEach((i) => {
      i instanceof Pu && i.update(0);
    }), this.pop(t);
  }
};
class Gh extends Cu {
  update(e) {
    const t = /* @__PURE__ */ new Map();
    this.children.forEach((i, n) => {
      e.find((r) => r.key === n) || t.set(n, i);
    }), this.pop(t), this.addNewAndUpdateExisting(e);
  }
}
class ml {
  constructor(e, t, { onRemove: i, animateIn: n = !1 } = {}) {
    this.flow = e, this.el = t, this._present = !0, this._remove = () => {
      var r;
      this.el.remove(), (r = this._onRemove) == null || r.call(this);
    }, this.el.classList.add("animate-presence"), this.flow.computedAnimated && n && this.el.animate({
      [ka]: [-0.9999, 0]
    }, {
      ...this.flow.opacityTiming,
      composite: "accumulate"
    }), this._onRemove = i;
  }
  get present() {
    return this._present;
  }
  set present(e) {
    if (this._present !== e) {
      if (this._present = e, e ? this.el.removeAttribute("inert") : this.el.setAttribute("inert", ""), !this.flow.computedAnimated) {
        e || this._remove();
        return;
      }
      this.el.style.setProperty("--_number-flow-d-opacity", e ? "0" : "-.999"), this.el.animate({
        [ka]: e ? [-0.9999, 0] : [0.999, 0]
      }, {
        ...this.flow.opacityTiming,
        composite: "accumulate"
      }), e ? this.flow.removeEventListener("animationsfinish", this._remove) : this.flow.addEventListener("animationsfinish", this._remove, {
        once: !0
      });
    }
  }
}
class Iu extends ml {
  constructor(e, t, i, n) {
    super(e.flow, i, n), this.section = e, this.value = t, this.el = i;
  }
}
let Pu = class extends Iu {
  constructor(e, t, i, n, r) {
    var a, o;
    const l = (((o = (a = e.flow.digits) == null ? void 0 : a[n]) == null ? void 0 : o.max) ?? 9) + 1, c = Array.from({ length: l }).map((d, u) => {
      const f = En("span", { className: "digit__num" }, [
        document.createTextNode(String(u))
      ]);
      return u !== i && f.setAttribute("inert", ""), f.style.setProperty("--n", String(u)), f;
    }), h = En("span", {
      part: `digit ${t}-digit`,
      className: "digit"
    }, c);
    h.style.setProperty("--current", String(i)), h.style.setProperty("--length", String(l)), super(e, i, h, r), this.pos = n, this._onAnimationsFinish = () => {
      this.el.classList.remove("is-spinning");
    }, this._numbers = c, this.length = l;
  }
  willUpdate(e) {
    const t = this.el.getBoundingClientRect();
    this._prevValue = this.value;
    const i = t[this.section.justify] - e[this.section.justify], n = t.width / 2;
    this._prevCenter = this.section.justify === "left" ? i + n : i - n;
  }
  update(e) {
    this.el.style.setProperty("--current", String(e)), this._numbers.forEach((t, i) => i === e ? t.removeAttribute("inert") : t.setAttribute("inert", "")), this.value = e;
  }
  didUpdate(e) {
    const t = this.el.getBoundingClientRect(), i = t[this.section.justify] - e[this.section.justify], n = t.width / 2, r = this.section.justify === "left" ? i + n : i - n, a = this._prevCenter - r;
    a && this.el.animate({
      transform: [`translateX(${a}px)`, "none"]
    }, {
      ...this.flow.transformTiming,
      composite: "accumulate"
    });
    const o = this.getDelta();
    o && (this.el.classList.add("is-spinning"), this.el.animate({
      [Oc]: [-o, 0]
    }, {
      ...this.flow.spinTiming ?? this.flow.transformTiming,
      composite: "accumulate"
    }), this.flow.addEventListener("animationsfinish", this._onAnimationsFinish, { once: !0 }));
  }
  getDelta() {
    var e;
    if (this.flow.plugins)
      for (const n of this.flow.plugins) {
        const r = (e = n.getDelta) == null ? void 0 : e.call(n, this.value, this._prevValue, this);
        if (r != null)
          return r;
      }
    const t = this.value - this._prevValue, i = this.flow.computedTrend || Math.sign(t);
    return i < 0 && this.value > this._prevValue ? this.value - this.length - this._prevValue : i > 0 && this.value < this._prevValue ? this.length - this._prevValue + this.value : t;
  }
}, rg = class extends Iu {
  constructor(e, t, i, n) {
    const r = En("span", {
      className: "symbol__value",
      textContent: i
    });
    super(e, i, En("span", {
      part: `symbol ${t}`,
      className: "symbol"
    }, [r]), n), this.type = t, this._children = /* @__PURE__ */ new Map(), this._onChildRemove = (a) => () => {
      this._children.delete(a);
    }, this._children.set(i, new ml(this.flow, r, {
      onRemove: this._onChildRemove(i)
    }));
  }
  willUpdate(e) {
    if (this.type === "decimal")
      return;
    const t = this.el.getBoundingClientRect();
    this._prevOffset = t[this.section.justify] - e[this.section.justify];
  }
  update(e) {
    if (this.value !== e) {
      const t = this._children.get(this.value);
      t && (t.present = !1);
      const i = this._children.get(e);
      if (i)
        i.present = !0;
      else {
        const n = En("span", {
          className: "symbol__value",
          textContent: e
        });
        this.el.appendChild(n), this._children.set(e, new ml(this.flow, n, {
          animateIn: !0,
          onRemove: this._onChildRemove(e)
        }));
      }
    }
    this.value = e;
  }
  didUpdate(e) {
    if (this.type === "decimal")
      return;
    const t = this.el.getBoundingClientRect()[this.section.justify] - e[this.section.justify], i = this._prevOffset - t;
    i && this.el.animate({
      transform: [`translateX(${i}px)`, "none"]
    }, { ...this.flow.transformTiming, composite: "accumulate" });
  }
};
const ag = "number-flow-connect", og = "number-flow-update";
let lg = class extends Ru {
  constructor() {
    super(...arguments), this.connected = !1;
  }
  connectedCallback() {
    this.connected = !0, this.dispatchEvent(new Event(ag, { bubbles: !0 }));
  }
  disconnectedCallback() {
    this.connected = !1;
  }
  get value() {
    return this._value;
  }
  update(e) {
    (!this._formatter || this._prevFormat !== this.format || this._prevLocales !== this.locales) && (this._formatter = new Intl.NumberFormat(this.locales, this.format), this._prevFormat = this.format, this._prevLocales = this.locales), e != null && (this._value = e), this.dispatchEvent(new Event(og, { bubbles: !0 })), this.data = ig(this._value, this._formatter, this.numberPrefix, this.numberSuffix);
  }
};
eg("number-flow", lg);
const cg = ':host{display:inline-block}.number-flow-wrapper{font-variant-numeric:tabular-nums;color:var(--VH-Light-Green, #84c12f);font-family:var(--vh-font-feature-display-condensed, "Feature Display Condensed"),sans-serif;font-size:300px;font-style:italic;font-weight:800;line-height:100%;letter-spacing:-12.8px;opacity:0;animation:odometer-fade-in 1s ease-out forwards}@keyframes odometer-fade-in{0%{opacity:0}to{opacity:1}}number-flow{display:inline-block;--number-flow-mask-height: 10px}';
var hg = Object.defineProperty, dg = Object.getOwnPropertyDescriptor, Uc = (s, e, t, i) => {
  for (var n = i > 1 ? void 0 : i ? dg(e, t) : e, r = s.length - 1, a; r >= 0; r--)
    (a = s[r]) && (n = (i ? a(e, t, n) : a(n)) || n);
  return i && n && hg(e, t, n), n;
};
let wr = class extends Ie {
  constructor() {
    super(...arguments), this.value = 0;
  }
  updated(s) {
    if (!s.has("value")) return;
    const e = Math.max(0, Math.min(9999, Math.floor(this.value)));
    this._flowEl?.update(e);
  }
  firstUpdated() {
    if (this._flowEl) {
      this._flowEl.format = { useGrouping: !1 };
      const s = Math.max(0, Math.min(9999, Math.floor(this.value)));
      this._flowEl.update(s);
    }
  }
  render() {
    const s = Math.max(0, Math.min(9999, Math.floor(this.value)));
    return $`
			<div class="number-flow-wrapper" role="img" aria-label="${s}">
				<number-flow></number-flow>
			</div>
		`;
  }
};
wr.styles = Je`
		${We(cg)}
	`;
Uc([
  D({ type: Number })
], wr.prototype, "value", 2);
Uc([
  Gs("number-flow")
], wr.prototype, "_flowEl", 2);
wr = Uc([
  Oe("vh-microsite-odometer")
], wr);
const ug = ".vh-microsite-timeline-box{background-color:#ffffffb3;display:flex;flex-direction:column;width:100%}@media screen and (min-width:810px){.vh-microsite-timeline-box{max-width:695px;margin:0 auto}}.vh-microsite-timeline-box__year{text-align:center;margin:0;padding:0;width:100%}.vh-microsite-timeline-box__year vh-microsite-odometer{display:inline-block}.vh-microsite-timeline-box__description{box-sizing:border-box;background-color:#fff9;border-top:1px solid var(--vh-color-light-green);border-bottom:1px solid var(--vh-color-light-green);display:flex;align-items:center;justify-content:center;padding:24px;width:100%;animation:timeline-box-description-fade .4s ease-out}@media screen and (min-width:810px){.vh-microsite-timeline-box__description{padding:40px 32px}}@keyframes timeline-box-description-fade{0%{opacity:1}50%{opacity:0}to{opacity:1}}.vh-microsite-timeline-box__text{font-family:var(--vh-font-poppins);font-size:20px;font-style:normal;font-weight:400;line-height:1.2;color:var(--vh-color-navy);text-align:center;margin:0;min-height:182px}.vh-microsite-timeline-box__text strong{font-weight:600}.vh-microsite-timeline-box__text--pre-animate{opacity:0}.vh-microsite-timeline-box__text--animate{opacity:0;animation:fadeIn 1s ease-out forwards;animation-delay:.8s}@keyframes fadeInFromRight{0%{opacity:0;transform:translate(50px)}to{opacity:1;transform:translate(0)}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}";
var fg = Object.defineProperty, pg = Object.getOwnPropertyDescriptor, oo = (s, e, t, i) => {
  for (var n = i > 1 ? void 0 : i ? pg(e, t) : e, r = s.length - 1, a; r >= 0; r--)
    (a = s[r]) && (n = (i ? a(e, t, n) : a(n)) || n);
  return i && n && fg(e, t, n), n;
};
let Ps = class extends Ie {
  constructor() {
    super(...arguments), this.events = [], this.animateIn = !1, this.isVisible = !1;
  }
  connectedCallback() {
    super.connectedCallback(), this.animateIn && this.setupIntersectionObserver();
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.observer?.disconnect();
  }
  setupIntersectionObserver() {
    this.observer = new IntersectionObserver(
      (s) => {
        s.forEach((e) => {
          e.isIntersecting && !this.isVisible && (this.isVisible = !0);
        });
      },
      {
        threshold: 0.5
      }
    );
  }
  firstUpdated() {
    if (this.animateIn) {
      const s = this.shadowRoot?.querySelector(
        ".vh-microsite-timeline-box"
      );
      s && this.observer && this.observer.observe(s);
    }
  }
  renderYear(s) {
    const e = Number.parseInt(s, 10) || 0;
    return $`
      <div class="vh-microsite-timeline-box__year">
        <vh-microsite-odometer .value=${e}></vh-microsite-odometer>
      </div>
    `;
  }
  renderEvent(s) {
    const e = this.animateIn && this.isVisible;
    return $`
      ${this.renderYear(s.year)}
      <div class="vh-microsite-timeline-box__description">
        <p
          class=${Ze({
      "vh-microsite-timeline-box__text": !0,
      "vh-microsite-timeline-box__text--pre-animate": this.animateIn && !this.isVisible,
      "vh-microsite-timeline-box__text--animate": e
    })}
        >
          ${Qe(s.description)}
        </p>
      </div>
    `;
  }
  render() {
    return $`
      <div class="vh-microsite-timeline-box">
        ${this.events.map((s) => this.renderEvent(s))}
      </div>
    `;
  }
};
Ps.styles = Je`
    ${We(ug)}
  `;
oo([
  D({ type: Array })
], Ps.prototype, "events", 2);
oo([
  D({ type: Boolean })
], Ps.prototype, "animateIn", 2);
oo([
  D({ type: Boolean })
], Ps.prototype, "isVisible", 2);
Ps = oo([
  Oe("vh-microsite-timeline-box")
], Ps);
const mg = ".vh-microsite-subnav{display:flex;align-items:center;justify-content:center;width:100%;position:fixed;z-index:1001}@media screen and (max-width:600px){.vh-microsite-subnav{bottom:0!important}}.vh-microsite-subnav__links{display:flex;align-items:center;flex-direction:row;gap:8px;padding:12px 16px;background-color:#f2f9eae6;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch;scrollbar-width:none;justify-content:flex-start}.vh-microsite-subnav__links::-webkit-scrollbar{display:none}@media screen and (min-width:810px){.vh-microsite-subnav__links{gap:16px;overflow-x:visible;border-radius:40px;width:auto;justify-content:center}}.vh-microsite-subnav__link{display:flex;align-items:center;justify-content:center;gap:8px;padding:10px 24px;border-radius:40px;text-decoration:none;transition:all .2s ease-in-out;white-space:nowrap;background:transparent;color:var(--vh-color-navy);border:1px solid var(--vh-color-light-green);flex-shrink:0;box-sizing:border-box}.vh-microsite-subnav__link:hover,.vh-microsite-subnav__link--active{background:var(--vh-color-light-green);color:var(--vh-color-white)}.vh-microsite-subnav__link--active:hover{opacity:.8}@media screen and (min-width:810px){.vh-microsite-subnav__link{width:auto}}.vh-microsite-subnav__icon{width:16px;height:16px}.vh-microsite-subnav__label{font-family:var(--vh-font-poppins);font-size:16px;font-style:normal;font-weight:400;line-height:1.5;line-height:1}.vh-microsite-subnav__label--active{color:var(--vh-color-white);font-weight:500}";
var gg = Object.defineProperty, vg = Object.getOwnPropertyDescriptor, Fc = (s, e, t, i) => {
  for (var n = i > 1 ? void 0 : i ? vg(e, t) : e, r = s.length - 1, a; r >= 0; r--)
    (a = s[r]) && (n = (i ? a(e, t, n) : a(n)) || n);
  return i && n && gg(e, t, n), n;
};
let Va = class extends Ie {
  constructor() {
    super(...arguments), this.size = 16, this.color = "#84C12F";
  }
  render() {
    return $`
      <svg style="display: block; max-width: 100%; max-height: 100%;" xmlns="http://www.w3.org/2000/svg" width="${this.size}" height="${this.size}" fill="none" style="display:block" viewBox="0 0 16 16"><g stroke="${this.color}" stroke-linecap="round" stroke-linejoin="round" clip-path="url(#a)"><path d="M7.345 1.876a.667.667 0 0 1 1.31 0l.701 3.706a1.33 1.33 0 0 0 1.063 1.062l3.705.701a.667.667 0 0 1 0 1.31l-3.705.701a1.33 1.33 0 0 0-1.063 1.063l-.7 3.705a.667.667 0 0 1-1.311 0l-.7-3.705a1.33 1.33 0 0 0-1.063-1.063l-3.706-.7a.667.667 0 0 1 0-1.311l3.706-.7a1.33 1.33 0 0 0 1.062-1.063zm5.988-.543V4m1.334-1.333H12m-9.334 12a1.333 1.333 0 1 0 0-2.667 1.333 1.333 0 0 0 0 2.667"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h16v16H0z"/></clipPath></defs></svg>
    `;
  }
};
Fc([
  D({ type: Number })
], Va.prototype, "size", 2);
Fc([
  D({ type: String })
], Va.prototype, "color", 2);
Va = Fc([
  Oe("vh-icon-spark")
], Va);
var _g = Object.defineProperty, xg = Object.getOwnPropertyDescriptor, lo = (s, e, t, i) => {
  for (var n = i > 1 ? void 0 : i ? xg(e, t) : e, r = s.length - 1, a; r >= 0; r--)
    (a = s[r]) && (n = (i ? a(e, t, n) : a(n)) || n);
  return i && n && _g(e, t, n), n;
};
let Ls = class extends Ie {
  constructor() {
    super(...arguments), this.items = [], this.bottom = "0px";
  }
  connectedCallback() {
    super.connectedCallback();
    const s = window.location.pathname?.toLowerCase(), e = window.location.hash?.toLowerCase();
    this.items.forEach((t) => {
      if (!t.href || t.active !== void 0)
        return;
      const i = new URL(t.href, window.location.origin), n = i.pathname?.toLowerCase(), r = i.hash?.toLowerCase();
      t.active = n === s && r === e;
    });
  }
  render() {
    return $`
      <div class="vh-microsite-subnav"
        style="${this.top ? `top: ${this.top};` : ""}${this.bottom ? `bottom: ${this.bottom};` : ""} left: 0;"
      >
        <nav class="vh-microsite-subnav__links">
          ${this.items.map(
      (s) => $`
              <a
                class="vh-microsite-subnav__link ${s.active ? "vh-microsite-subnav__link--active" : ""}"
                href=${s.href || "#"}
              >
                <vh-icon-spark
                  class="vh-microsite-subnav__icon"
                  size="16"
                  color=${s.active ? "var(--vh-color-white)" : "var(--vh-color-navy)"}
                ></vh-icon-spark>
                <span class=${Ze({
        "vh-microsite-subnav__label": !0,
        "vh-microsite-subnav__label--active": s.active || !1
      })}>${s.label}</span>
              </a>
            `
    )}
        </nav>
      </div>
    `;
  }
};
Ls.styles = Je`
    ${We(mg)}
  `;
lo([
  D({ type: Array })
], Ls.prototype, "items", 2);
lo([
  D()
], Ls.prototype, "top", 2);
lo([
  D()
], Ls.prototype, "bottom", 2);
Ls = lo([
  Oe("vh-microsite-subnav")
], Ls);
const yg = ".vh-microsite-partners{padding:80px 24px 40px;display:flex;flex-direction:column;align-items:center;gap:40px;max-width:var(--vh-max-width-medium);margin:0 auto;box-sizing:border-box;overflow:hidden;background:var(--vh-color-white)}@media screen and (min-width:810px){.vh-microsite-partners{overflow:visible;gap:100px;padding:100px 24px}}.vh-microsite-partners__content{position:relative;width:100%}.vh-microsite-partners__text{display:flex;align-items:center;justify-content:center;letter-spacing:-26px;background:var(--vh-color-white);margin-right:16px}@media screen and (min-width:810px){.vh-microsite-partners__text{padding-right:300px;margin-right:0}}@media screen and (min-width:1280px){.vh-microsite-partners__text{letter-spacing:-50px}}.vh-microsite-partners__letter{font-family:var(--vh-font-feature-display-condensed);font-style:italic;font-weight:800;line-height:1;text-transform:uppercase;mix-blend-mode:multiply;font-size:180px;opacity:0}@media screen and (max-width:400px){.vh-microsite-partners__letter{font-size:160px}}@media screen and (min-width:810px){.vh-microsite-partners__letter{font-size:200px}}@media screen and (min-width:1280px){.vh-microsite-partners__letter{font-size:400px}}.vh-microsite-partners__letter--light-green{color:var(--vh-color-light-green)}.vh-microsite-partners__letter--green{color:var(--vh-color-green)}.vh-microsite-partners__letter--animate{opacity:0;animation:fadeInFromRight .7s ease-out forwards;animation-delay:calc(var(--animation-order) * .15s)}@keyframes fadeInFromRight{0%{opacity:0;transform:translate(50px)}to{opacity:1;transform:translate(0)}}.vh-microsite-partners__badge-position{position:relative;z-index:2;display:flex;justify-content:center;margin-top:-40px}@media screen and (min-width:810px){.vh-microsite-partners__badge-position{position:absolute;right:0;top:50%;transform:translateY(-50%);display:block;margin-top:0}}";
var bg = Object.defineProperty, wg = Object.getOwnPropertyDescriptor, Or = (s, e, t, i) => {
  for (var n = i > 1 ? void 0 : i ? wg(e, t) : e, r = s.length - 1, a; r >= 0; r--)
    (a = s[r]) && (n = (i ? a(e, t, n) : a(n)) || n);
  return i && n && bg(e, t, n), n;
};
let Qn = class extends Ie {
  constructor() {
    super(...arguments), this.heading = "", this.subheading = "", this.partners = [], this.isVisible = !1;
  }
  connectedCallback() {
    super.connectedCallback(), this.setupIntersectionObserver();
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.observer?.disconnect();
  }
  setupIntersectionObserver() {
    this.observer = new IntersectionObserver(
      (s) => {
        s.forEach((e) => {
          e.isIntersecting && !this.isVisible && (this.isVisible = !0);
        });
      },
      {
        threshold: 0.5
      }
    );
  }
  firstUpdated() {
    const s = this.shadowRoot?.querySelector(
      ".vh-microsite-partners__content"
    );
    s && this.observer && this.observer.observe(s);
  }
  renderHeadingLetters() {
    return this.heading.split("").map((e, t) => {
      const i = t % 2 === 0 ? "light-green" : "green", n = e === ".", r = Ze({
        "vh-microsite-partners__letter": !0,
        [`vh-microsite-partners__letter--${i}`]: !0,
        "vh-microsite-partners__letter--period": n,
        "vh-microsite-partners__letter--animate": this.isVisible
      });
      return $`
        <span class="${r}" style="--animation-order: ${t + 1}">
          ${e}
        </span>
      `;
    });
  }
  render() {
    return $`
      <div class="vh-microsite-partners">
        <div class="vh-microsite-partners__content">
          <div class="vh-microsite-partners__text">
            ${this.renderHeadingLetters()}
          </div>
          <vh-microsite-badge breakpoint="medium" class="vh-microsite-partners__badge-position" .text=${this.subheading}></vh-microsite-badge>
        </div>
        <vh-microsite-partner-cards .partners=${this.partners}></vh-microsite-partner-cards>
      </div>
    `;
  }
};
Qn.styles = Je`
    ${We(yg)}
  `;
Or([
  D({ type: String })
], Qn.prototype, "heading", 2);
Or([
  D({ type: String })
], Qn.prototype, "subheading", 2);
Or([
  D({ type: Array })
], Qn.prototype, "partners", 2);
Or([
  D({ type: Boolean })
], Qn.prototype, "isVisible", 2);
Qn = Or([
  Oe("vh-microsite-partners")
], Qn);
const Sg = ":host{display:block;width:100%}.vh-microsite-partner-cards{display:flex;flex-direction:column;gap:24px;width:100%}.partner-row{display:flex;flex-direction:column;gap:12px}@media screen and (min-width:810px){.partner-row{gap:24px;display:grid;grid-template-columns:1fr 2fr}.partner-row.reverse{grid-template-columns:2fr 1fr}.partner-row.reverse vh-microsite-partner-card-partner{order:2}.partner-row.reverse vh-microsite-partner-card-products{order:1}}.partner-row--pre-animate vh-microsite-partner-card-partner,.partner-row--pre-animate vh-microsite-partner-card-products{opacity:0}.partner-row--animate vh-microsite-partner-card-partner{opacity:0;animation:fadeIn .3s ease-out forwards,slideFromLeft .5s ease-out forwards}.partner-row--animate vh-microsite-partner-card-products{opacity:0;animation:fadeIn .3s ease-out forwards,slideFromRight .5s ease-out forwards}.partner-row--animate.reverse vh-microsite-partner-card-partner{animation:fadeIn .3s ease-out forwards,slideFromRight .5s ease-out forwards}.partner-row--animate.reverse vh-microsite-partner-card-products{animation:fadeIn .3s ease-out forwards,slideFromLeft .5s ease-out forwards}.partner-card__partner--mobile-animate{opacity:0;animation:fadeIn .3s ease-out forwards,slideFromRight .5s ease-out forwards}.partner-card__products--mobile-animate{opacity:0;animation:fadeIn .3s ease-out forwards,slideFromLeft .5s ease-out forwards}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}@keyframes slideFromLeft{0%{transform:translate(-50px)}to{transform:translate(0)}}@keyframes slideFromRight{0%{transform:translate(50px)}to{transform:translate(0)}}";
var Mg = Object.defineProperty, Tg = Object.getOwnPropertyDescriptor, Bc = (s, e, t, i) => {
  for (var n = i > 1 ? void 0 : i ? Tg(e, t) : e, r = s.length - 1, a; r >= 0; r--)
    (a = s[r]) && (n = (i ? a(e, t, n) : a(n)) || n);
  return i && n && Mg(e, t, n), n;
};
let Sr = class extends Ie {
  constructor() {
    super(...arguments), this.partners = [], this.cardObservers = [], this.visibleRows = /* @__PURE__ */ new Set(), this.visibleCards = /* @__PURE__ */ new Set(), this.isMobile = !1, this.mediaHandler = (s) => {
      this.isMobile = !s.matches;
    };
  }
  connectedCallback() {
    super.connectedCallback(), this.mediaQuery = window.matchMedia("(min-width: 810px)"), this.isMobile = !this.mediaQuery.matches, this.mediaQuery.addEventListener("change", this.mediaHandler), this.observer = new IntersectionObserver(
      (s) => {
        s.forEach((e) => {
          if (e.isIntersecting) {
            const t = Number(
              e.target.dataset.rowIndex
            );
            this.visibleRows.has(t) || (this.visibleRows.add(t), this.requestUpdate());
          }
        });
      },
      { threshold: 0.5 }
    );
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.observer?.disconnect(), this.cardObservers.forEach((s) => {
      s.disconnect();
    }), this.mediaQuery?.removeEventListener("change", this.mediaHandler);
  }
  setupCardObservers() {
    this.cardObservers.forEach((e) => {
      e.disconnect();
    }), this.cardObservers = [];
    const s = this.shadowRoot?.querySelectorAll(
      "vh-microsite-partner-card-partner, vh-microsite-partner-card-products"
    );
    s && s.forEach((e) => {
      const t = new IntersectionObserver(
        (i) => {
          i.forEach((n) => {
            if (n.isIntersecting) {
              const r = n.target.dataset.cardKey;
              r && !this.visibleCards.has(r) && (this.visibleCards.add(r), this.requestUpdate());
            }
          });
        },
        { threshold: 0.3 }
      );
      t.observe(e), this.cardObservers.push(t);
    });
  }
  firstUpdated() {
    this.shadowRoot?.querySelectorAll(".partner-row")?.forEach((e) => {
      this.observer?.observe(e);
    }), this.setupCardObservers();
  }
  updated() {
    this.shadowRoot?.querySelectorAll(".partner-row")?.forEach((e) => {
      e.getAttribute("data-observed") || (e.setAttribute("data-observed", "true"), this.observer?.observe(e));
    });
  }
  render() {
    return $`
      <div class="vh-microsite-partner-cards">
        ${this.partners.map((s, e) => {
      const t = e % 2 !== 0, i = this.visibleRows.has(e), n = `${e}-partner`, r = `${e}-products`, a = this.isMobile ? this.visibleCards.has(n) : i, o = this.isMobile ? this.visibleCards.has(r) : i;
      return $`
          <div class=${Ze({
        "partner-row": !0,
        "partner-row--pre-animate": !0,
        "partner-row--animate": !this.isMobile && i,
        reverse: t
      })} data-row-index="${e}">
            <vh-microsite-partner-card-partner
              class=${Ze({
        "partner-card__partner": !0,
        "partner-card__partner--mobile-animate": this.isMobile && a
      })}
              label="Partner"
              .name=${s.name}
              .reversed=${t}
              data-card-key="${n}"
            ></vh-microsite-partner-card-partner>
            <vh-microsite-partner-card-products
              class=${Ze({
        "partner-card__products": !0,
        "partner-card__products--mobile-animate": this.isMobile && o
      })}
              label="Products We Sourced:"
              .products=${s.products}
              .website=${s.website}
              .reversed=${t}
              data-card-key="${r}"
            ></vh-microsite-partner-card-products>
          </div>
          `;
    })}
      </div>
    `;
  }
};
Sr.styles = Je`
    ${We(Sg)}
  `;
Bc([
  D({ type: Array })
], Sr.prototype, "partners", 2);
Bc([
  D({ type: Boolean })
], Sr.prototype, "isMobile", 2);
Sr = Bc([
  Oe("vh-microsite-partner-cards")
], Sr);
const Eg = ".vh-microsite-partner-card-partner{display:flex;flex-direction:column;border-radius:16px;padding:40px 24px;background:linear-gradient(-40.87deg,#c5e86c 4.72%,#e9f9c1 104.65%);justify-content:space-between;align-items:flex-end;gap:16px}.vh-microsite-partner-card-partner--reversed{background:var(--vh-color-white);border:1px solid var(--vh-color-light-green)}.vh-microsite-partner-card-partner--reversed .vh-microsite-partner-card-partner__name{color:var(--vh-color-green)}@media screen and (min-width:810px){.vh-microsite-partner-card-partner{padding:40px;height:320px}}.vh-microsite-partner-card-partner__label-container{display:flex;align-items:center;justify-content:center;width:100%;padding:10px 0;border-top:1px solid var(--vh-color-light-green);border-bottom:1px solid var(--vh-color-light-green)}.vh-microsite-partner-card-partner__label{flex:1;color:var(--vh-color-navy);font-family:var(--vh-font-poppins);font-size:24px;font-style:normal;font-weight:400;line-height:1.2}.vh-microsite-partner-card-partner__name{width:100%;color:var(--vh-color-green);font-family:var(--vh-font-feature-display-condensed);font-size:54px;font-style:normal;font-weight:400;line-height:1}@media screen and (min-width:810px){.vh-microsite-partner-card-partner__name{font-size:62px}}";
var Ag = Object.defineProperty, Rg = Object.getOwnPropertyDescriptor, co = (s, e, t, i) => {
  for (var n = i > 1 ? void 0 : i ? Rg(e, t) : e, r = s.length - 1, a; r >= 0; r--)
    (a = s[r]) && (n = (i ? a(e, t, n) : a(n)) || n);
  return i && n && Ag(e, t, n), n;
};
let Ds = class extends Ie {
  constructor() {
    super(...arguments), this.label = "", this.name = "", this.reversed = !1;
  }
  render() {
    return $`
      <div class=${Ze({
      "vh-microsite-partner-card-partner": !0,
      "vh-microsite-partner-card-partner--reversed": this.reversed
    })}>
        <div class="vh-microsite-partner-card-partner__label-container">
          <div class="vh-microsite-partner-card-partner__label">${this.label}</div>
        </div>
        <div class="vh-microsite-partner-card-partner__name">${this.name}</div>
      </div>
    `;
  }
};
Ds.styles = Je`
    ${We(Eg)}
  `;
co([
  D({ type: String })
], Ds.prototype, "label", 2);
co([
  D({ type: String })
], Ds.prototype, "name", 2);
co([
  D({ type: Boolean })
], Ds.prototype, "reversed", 2);
Ds = co([
  Oe("vh-microsite-partner-card-partner")
], Ds);
const Cg = ".vh-microsite-partner-card-products{display:flex;flex-direction:column;border-radius:16px;padding:24px 24px 40px;background:linear-gradient(-29.54deg,#c5e86c 4.72%,#e9f9c1 104.65%);justify-content:space-between;align-items:flex-start;gap:40px}.vh-microsite-partner-card-products--reversed{background:var(--vh-color-white);border:1px solid var(--vh-color-light-green)}@media screen and (min-width:810px){.vh-microsite-partner-card-products{padding:40px;height:320px}}.vh-microsite-partner-card-products__products{display:flex;flex-direction:column;gap:16px;width:100%}.vh-microsite-partner-card-products__products-title{display:flex;align-items:center;gap:8px;color:var(--vh-color-navy);font-family:var(--vh-font-poppins);font-size:20px;font-style:normal;font-weight:400;line-height:1.2;font-weight:500}.vh-microsite-partner-card-products__products-list{color:var(--vh-color-navy);font-family:var(--vh-font-poppins);font-size:16px;font-style:normal;font-weight:400;line-height:1.5}.vh-microsite-partner-card-products__website{color:var(--vh-color-navy);font-family:var(--vh-font-poppins);font-size:20px;font-style:normal;font-weight:400;line-height:1.2;font-size:16px;font-weight:500;text-decoration:none;transition:text-decoration .2s ease;cursor:pointer}.vh-microsite-partner-card-products__website:hover{text-decoration:underline}@media screen and (min-width:810px){.vh-microsite-partner-card-products__website{font-size:20px}}";
var Ig = Object.defineProperty, Pg = Object.getOwnPropertyDescriptor, Ur = (s, e, t, i) => {
  for (var n = i > 1 ? void 0 : i ? Pg(e, t) : e, r = s.length - 1, a; r >= 0; r--)
    (a = s[r]) && (n = (i ? a(e, t, n) : a(n)) || n);
  return i && n && Ig(e, t, n), n;
};
let es = class extends Ie {
  constructor() {
    super(...arguments), this.label = "", this.products = [], this.website = "", this.reversed = !1;
  }
  render() {
    const s = this.website.startsWith("http") ? this.website : `https://${this.website}`;
    return $`
      <div class=${Ze({
      "vh-microsite-partner-card-products": !0,
      "vh-microsite-partner-card-products--reversed": this.reversed
    })}>
        <div class="vh-microsite-partner-card-products__products">
          <div class="vh-microsite-partner-card-products__products-title">
            <vh-icon-guarantee></vh-icon-guarantee>
            ${this.label}
          </div>
          <div class="vh-microsite-partner-card-products__products-list">
            ${this.products.join(", ")}
          </div>
        </div>
        <a 
          href="${s}" 
          target="_blank" 
          rel="noopener noreferrer"
          class="vh-microsite-partner-card-products__website"
        >
          ${this.website}
        </a>
      </div>
    `;
  }
};
es.styles = Je`
    ${We(Cg)}
  `;
Ur([
  D({ type: String })
], es.prototype, "label", 2);
Ur([
  D({ type: Array })
], es.prototype, "products", 2);
Ur([
  D({ type: String })
], es.prototype, "website", 2);
Ur([
  D({ type: Boolean })
], es.prototype, "reversed", 2);
es = Ur([
  Oe("vh-microsite-partner-card-products")
], es);
const Lg = ".vh-microsite-page-wrapper{margin:0 auto}";
var Dg = Object.getOwnPropertyDescriptor, Ng = (s, e, t, i) => {
  for (var n = i > 1 ? void 0 : i ? Dg(e, t) : e, r = s.length - 1, a; r >= 0; r--)
    (a = s[r]) && (n = a(n) || n);
  return n;
};
let gl = class extends Ie {
  render() {
    return $`
      <div class="vh-microsite-page-wrapper">
        <slot></slot>
      </div>
    `;
  }
};
gl.styles = Je`
    ${We(Lg)}
  `;
gl = Ng([
  Oe("vh-microsite-page-wrapper")
], gl);
const Og = ".vh-microsite-features{display:flex;overflow:hidden;flex-direction:column;gap:40px;align-items:center;padding:40px 24px}@media screen and (min-width:810px){.vh-microsite-features{overflow:visible;gap:100px;padding:100px 24px}}.vh-microsite-features__header{display:flex;flex-direction:column;gap:20px;align-items:center}.vh-microsite-features__title{font-family:var(--vh-font-feature-display-condensed);font-size:54px;font-style:normal;font-weight:400;line-height:1}@media screen and (min-width:810px){.vh-microsite-features__title{font-size:62px}}.vh-microsite-features__title{color:var(--vh-color-navy);text-align:center;margin:0}.vh-microsite-features__title strong{font-family:var(--vh-font-feature-display-condensed);font-style:italic;font-weight:700}.vh-microsite-features__description{font-family:var(--vh-font-poppins);font-size:16px;font-style:normal;font-weight:400;line-height:1.5;color:var(--vh-color-navy);max-width:960px;text-align:center}.vh-microsite-features__description strong{font-weight:600}.vh-microsite-features__grid{display:flex;flex-direction:column;gap:40px}@media screen and (min-width:1280px){.vh-microsite-features__grid{flex-direction:row;gap:40px}}.vh-microsite-features__card{display:flex;flex-direction:column;align-items:center;gap:20px;padding:32px 24px;border:2px solid var(--vh-color-light-green);border-radius:8px;background:var(--vh-color-white);text-align:center;max-width:320px}.vh-microsite-features__card-title{font-family:var(--vh-font-feature-display-condensed);font-size:44px;font-style:normal;font-weight:400;line-height:1.1}@media screen and (min-width:810px){.vh-microsite-features__card-title{font-size:48px}}.vh-microsite-features__card-title{margin:0;color:var(--vh-color-navy);border-top:2px solid var(--vh-color-light-green);border-bottom:2px solid var(--vh-color-light-green);padding:16px 0;width:100%;min-height:90px;display:flex;align-items:center;justify-content:center}.vh-microsite-features__card-description{font-family:var(--vh-font-poppins);font-size:16px;font-style:normal;font-weight:400;line-height:1.5;color:var(--vh-color-navy)}.vh-microsite-features--pre-animate .vh-microsite-features__title,.vh-microsite-features--pre-animate .vh-microsite-features__description,.vh-microsite-features--pre-animate .vh-microsite-features__card{opacity:0}.vh-microsite-features--animate .vh-microsite-features__title{opacity:0;animation:fadeInFromRight 1s ease-out forwards}.vh-microsite-features--animate .vh-microsite-features__description{opacity:0;animation:fadeInFromRight 1s ease-out forwards;animation-delay:.3s}.vh-microsite-features__card--animate{opacity:0;animation:fadeInFromRight .7s ease-out forwards;animation-delay:calc(.5s + var(--animation-order) * .4s)}@keyframes fadeInFromRight{0%{opacity:0;transform:translate(50px)}to{opacity:1;transform:translate(0)}}";
var Ug = Object.defineProperty, Fg = Object.getOwnPropertyDescriptor, Ln = (s, e, t, i) => {
  for (var n = i > 1 ? void 0 : i ? Fg(e, t) : e, r = s.length - 1, a; r >= 0; r--)
    (a = s[r]) && (n = (i ? a(e, t, n) : a(n)) || n);
  return i && n && Ug(e, t, n), n;
};
let Vi = class extends Ie {
  constructor() {
    super(...arguments), this.headline = "", this.description = "", this.features = [], this.isHeaderVisible = !1, this.isItemsVisible = !1, this.isMobile = !1, this.visibleCards = [], this.cardObservers = [], this.mediaHandler = (s) => {
      this.isMobile = !s.matches;
    };
  }
  connectedCallback() {
    super.connectedCallback(), this.mediaQuery = window.matchMedia("(min-width: 1280px)"), this.isMobile = !this.mediaQuery.matches, this.mediaQuery.addEventListener("change", this.mediaHandler), this.setupIntersectionObserver();
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.headerObserver?.disconnect(), this.itemsObserver?.disconnect(), this.cardObservers.forEach((s) => {
      s.disconnect();
    }), this.mediaQuery?.removeEventListener("change", this.mediaHandler);
  }
  setupIntersectionObserver() {
    this.headerObserver = new IntersectionObserver(
      (s) => {
        s.forEach((e) => {
          e.isIntersecting && !this.isHeaderVisible && (this.isHeaderVisible = !0);
        });
      },
      { threshold: 0.5 }
    ), this.itemsObserver = new IntersectionObserver(
      (s) => {
        s.forEach((e) => {
          e.isIntersecting && !this.isItemsVisible && (this.isItemsVisible = !0);
        });
      },
      { threshold: 0.2 }
    );
  }
  setupCardObservers() {
    this.cardObservers.forEach((e) => {
      e.disconnect();
    }), this.cardObservers = [];
    const s = this.shadowRoot?.querySelectorAll(
      ".vh-microsite-features__card"
    );
    s && (this.visibleCards = new Array(s.length).fill(!1), s.forEach((e, t) => {
      const i = new IntersectionObserver(
        (n) => {
          n.forEach((r) => {
            r.isIntersecting && !this.visibleCards[t] && (this.visibleCards = [
              ...this.visibleCards.slice(0, t),
              !0,
              ...this.visibleCards.slice(t + 1)
            ], this.requestUpdate());
          });
        },
        { threshold: 0.3 }
      );
      i.observe(e), this.cardObservers.push(i);
    }));
  }
  firstUpdated() {
    const s = this.shadowRoot?.querySelector(
      ".vh-microsite-features__header"
    );
    s && this.headerObserver && this.headerObserver.observe(s);
    const e = this.shadowRoot?.querySelector(".vh-microsite-features__grid");
    e && this.itemsObserver && this.itemsObserver.observe(e), this.setupCardObservers();
  }
  render() {
    return $`
      <div class=${Ze({
      "vh-microsite-features": !0,
      "vh-microsite-features--pre-animate": !0,
      "vh-microsite-features--animate": this.isHeaderVisible
    })}>
        <div class="vh-microsite-features__header">
          <h2 class="vh-microsite-features__title">${Qe(this.headline)}</h2>
          <div class="vh-microsite-features__description">${this.description}</div>
        </div>
        <div class="vh-microsite-features__grid">
          ${this.features?.map((s, e) => {
      const t = this.isMobile ? this.visibleCards[e] ?? !1 : this.isItemsVisible;
      return $`
              <div class=${Ze({
        "vh-microsite-features__card": !0,
        "vh-microsite-features__card--animate": t
      })} style="--animation-order: ${this.isMobile ? 1 : e + 1}">
                <vh-icon-spark class="vh-microsite-features__icon" color="var(--vh-color-navy)"></vh-icon-spark>
                <h3 class="vh-microsite-features__card-title">${s.headline}</h3>
                <div class="vh-microsite-features__card-description">${s.description}</div>
              </div>
            `;
    })}
        </div>
      </div>
    `;
  }
};
Vi.styles = Je`
    ${We(Og)}
  `;
Ln([
  D()
], Vi.prototype, "headline", 2);
Ln([
  D()
], Vi.prototype, "description", 2);
Ln([
  D({ type: Array })
], Vi.prototype, "features", 2);
Ln([
  D({ type: Boolean })
], Vi.prototype, "isHeaderVisible", 2);
Ln([
  D({ type: Boolean })
], Vi.prototype, "isItemsVisible", 2);
Ln([
  D({ type: Boolean })
], Vi.prototype, "isMobile", 2);
Ln([
  D({ type: Array })
], Vi.prototype, "visibleCards", 2);
Vi = Ln([
  Oe("vh-microsite-features")
], Vi);
const Bg = {}, kg = (s, e = Bg) => s._$AH = e;
const Lu = Ac(class extends Rc {
  constructor() {
    super(...arguments), this.key = Tt;
  }
  render(s, e) {
    return this.key = s, e;
  }
  update(s, [e, t]) {
    return e !== this.key && (kg(s), this.key = e), t;
  }
});
const kc = "182", zg = 0, qh = 1, Vg = 2, Sa = 1, Hg = 2, hr = 3, hn = 0, Kt = 1, fi = 2, ki = 0, Kn = 1, vl = 2, Wh = 3, Xh = 4, $g = 5, Wn = 100, Gg = 101, qg = 102, Wg = 103, Xg = 104, jg = 200, Yg = 201, Kg = 202, Zg = 203, _l = 204, xl = 205, Jg = 206, Qg = 207, ev = 208, tv = 209, iv = 210, nv = 211, sv = 212, rv = 213, av = 214, yl = 0, bl = 1, wl = 2, Ns = 3, Sl = 4, Ml = 5, Tl = 6, El = 7, Du = 0, ov = 1, lv = 2, zi = 0, Nu = 1, Ou = 2, Uu = 3, Fu = 4, Bu = 5, ku = 6, zu = 7, jh = "attached", cv = "detached", Vu = 300, ts = 301, Os = 302, Al = 303, Rl = 304, ho = 306, Us = 1e3, Fi = 1001, Ha = 1002, It = 1003, Hu = 1004, dr = 1005, bt = 1006, Ma = 1007, nn = 1008, ii = 1009, $u = 1010, Gu = 1011, Mr = 1012, zc = 1013, Hi = 1014, pi = 1015, Ai = 1016, Vc = 1017, Hc = 1018, Tr = 1020, qu = 35902, Wu = 35899, Xu = 1021, ju = 1022, mi = 1023, dn = 1026, Yn = 1027, $c = 1028, Gc = 1029, Fs = 1030, qc = 1031, Wc = 1033, Ta = 33776, Ea = 33777, Aa = 33778, Ra = 33779, Cl = 35840, Il = 35841, Pl = 35842, Ll = 35843, Dl = 36196, Nl = 37492, Ol = 37496, Ul = 37488, Fl = 37489, Bl = 37490, kl = 37491, zl = 37808, Vl = 37809, Hl = 37810, $l = 37811, Gl = 37812, ql = 37813, Wl = 37814, Xl = 37815, jl = 37816, Yl = 37817, Kl = 37818, Zl = 37819, Jl = 37820, Ql = 37821, ec = 36492, tc = 36494, ic = 36495, nc = 36283, sc = 36284, rc = 36285, ac = 36286, oc = 2200, hv = 2201, dv = 2202, Er = 2300, Ar = 2301, wo = 2302, Ms = 2400, Ts = 2401, $a = 2402, Xc = 2500, uv = 2501, fv = 0, Yu = 1, lc = 2, pv = 3200, Ku = 0, mv = 1, Sn = "", Ct = "srgb", Wt = "srgb-linear", Ga = "linear", lt = "srgb", os = 7680, Yh = 519, gv = 512, vv = 513, _v = 514, jc = 515, xv = 516, yv = 517, Yc = 518, bv = 519, cc = 35044, Kh = "300 es", Bi = 2e3, qa = 2001;
function Zu(s) {
  for (let e = s.length - 1; e >= 0; --e)
    if (s[e] >= 65535) return !0;
  return !1;
}
function wv(s) {
  return ArrayBuffer.isView(s) && !(s instanceof DataView);
}
function Rr(s) {
  return document.createElementNS("http://www.w3.org/1999/xhtml", s);
}
function Sv() {
  const s = Rr("canvas");
  return s.style.display = "block", s;
}
const Zh = {};
function Wa(...s) {
  const e = "THREE." + s.shift();
  console.log(e, ...s);
}
function Te(...s) {
  const e = "THREE." + s.shift();
  console.warn(e, ...s);
}
function Ce(...s) {
  const e = "THREE." + s.shift();
  console.error(e, ...s);
}
function Cr(...s) {
  const e = s.join(" ");
  e in Zh || (Zh[e] = !0, Te(...s));
}
function Mv(s, e, t) {
  return new Promise(function(i, n) {
    function r() {
      switch (s.clientWaitSync(e, s.SYNC_FLUSH_COMMANDS_BIT, 0)) {
        case s.WAIT_FAILED:
          n();
          break;
        case s.TIMEOUT_EXPIRED:
          setTimeout(r, t);
          break;
        default:
          i();
      }
    }
    setTimeout(r, t);
  });
}
class ss {
  /**
   * Adds the given event listener to the given event type.
   *
   * @param {string} type - The type of event to listen to.
   * @param {Function} listener - The function that gets called when the event is fired.
   */
  addEventListener(e, t) {
    this._listeners === void 0 && (this._listeners = {});
    const i = this._listeners;
    i[e] === void 0 && (i[e] = []), i[e].indexOf(t) === -1 && i[e].push(t);
  }
  /**
   * Returns `true` if the given event listener has been added to the given event type.
   *
   * @param {string} type - The type of event.
   * @param {Function} listener - The listener to check.
   * @return {boolean} Whether the given event listener has been added to the given event type.
   */
  hasEventListener(e, t) {
    const i = this._listeners;
    return i === void 0 ? !1 : i[e] !== void 0 && i[e].indexOf(t) !== -1;
  }
  /**
   * Removes the given event listener from the given event type.
   *
   * @param {string} type - The type of event.
   * @param {Function} listener - The listener to remove.
   */
  removeEventListener(e, t) {
    const i = this._listeners;
    if (i === void 0) return;
    const n = i[e];
    if (n !== void 0) {
      const r = n.indexOf(t);
      r !== -1 && n.splice(r, 1);
    }
  }
  /**
   * Dispatches an event object.
   *
   * @param {Object} event - The event that gets fired.
   */
  dispatchEvent(e) {
    const t = this._listeners;
    if (t === void 0) return;
    const i = t[e.type];
    if (i !== void 0) {
      e.target = this;
      const n = i.slice(0);
      for (let r = 0, a = n.length; r < a; r++)
        n[r].call(this, e);
      e.target = null;
    }
  }
}
const Ft = ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "0a", "0b", "0c", "0d", "0e", "0f", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "1a", "1b", "1c", "1d", "1e", "1f", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "2a", "2b", "2c", "2d", "2e", "2f", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "3a", "3b", "3c", "3d", "3e", "3f", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "4a", "4b", "4c", "4d", "4e", "4f", "50", "51", "52", "53", "54", "55", "56", "57", "58", "59", "5a", "5b", "5c", "5d", "5e", "5f", "60", "61", "62", "63", "64", "65", "66", "67", "68", "69", "6a", "6b", "6c", "6d", "6e", "6f", "70", "71", "72", "73", "74", "75", "76", "77", "78", "79", "7a", "7b", "7c", "7d", "7e", "7f", "80", "81", "82", "83", "84", "85", "86", "87", "88", "89", "8a", "8b", "8c", "8d", "8e", "8f", "90", "91", "92", "93", "94", "95", "96", "97", "98", "99", "9a", "9b", "9c", "9d", "9e", "9f", "a0", "a1", "a2", "a3", "a4", "a5", "a6", "a7", "a8", "a9", "aa", "ab", "ac", "ad", "ae", "af", "b0", "b1", "b2", "b3", "b4", "b5", "b6", "b7", "b8", "b9", "ba", "bb", "bc", "bd", "be", "bf", "c0", "c1", "c2", "c3", "c4", "c5", "c6", "c7", "c8", "c9", "ca", "cb", "cc", "cd", "ce", "cf", "d0", "d1", "d2", "d3", "d4", "d5", "d6", "d7", "d8", "d9", "da", "db", "dc", "dd", "de", "df", "e0", "e1", "e2", "e3", "e4", "e5", "e6", "e7", "e8", "e9", "ea", "eb", "ec", "ed", "ee", "ef", "f0", "f1", "f2", "f3", "f4", "f5", "f6", "f7", "f8", "f9", "fa", "fb", "fc", "fd", "fe", "ff"];
let Jh = 1234567;
const pr = Math.PI / 180, Bs = 180 / Math.PI;
function Ei() {
  const s = Math.random() * 4294967295 | 0, e = Math.random() * 4294967295 | 0, t = Math.random() * 4294967295 | 0, i = Math.random() * 4294967295 | 0;
  return (Ft[s & 255] + Ft[s >> 8 & 255] + Ft[s >> 16 & 255] + Ft[s >> 24 & 255] + "-" + Ft[e & 255] + Ft[e >> 8 & 255] + "-" + Ft[e >> 16 & 15 | 64] + Ft[e >> 24 & 255] + "-" + Ft[t & 63 | 128] + Ft[t >> 8 & 255] + "-" + Ft[t >> 16 & 255] + Ft[t >> 24 & 255] + Ft[i & 255] + Ft[i >> 8 & 255] + Ft[i >> 16 & 255] + Ft[i >> 24 & 255]).toLowerCase();
}
function Xe(s, e, t) {
  return Math.max(e, Math.min(t, s));
}
function Kc(s, e) {
  return (s % e + e) % e;
}
function Tv(s, e, t, i, n) {
  return i + (s - e) * (n - i) / (t - e);
}
function Ev(s, e, t) {
  return s !== e ? (t - s) / (e - s) : 0;
}
function mr(s, e, t) {
  return (1 - t) * s + t * e;
}
function Av(s, e, t, i) {
  return mr(s, e, 1 - Math.exp(-t * i));
}
function Rv(s, e = 1) {
  return e - Math.abs(Kc(s, e * 2) - e);
}
function Cv(s, e, t) {
  return s <= e ? 0 : s >= t ? 1 : (s = (s - e) / (t - e), s * s * (3 - 2 * s));
}
function Iv(s, e, t) {
  return s <= e ? 0 : s >= t ? 1 : (s = (s - e) / (t - e), s * s * s * (s * (s * 6 - 15) + 10));
}
function Pv(s, e) {
  return s + Math.floor(Math.random() * (e - s + 1));
}
function Lv(s, e) {
  return s + Math.random() * (e - s);
}
function Dv(s) {
  return s * (0.5 - Math.random());
}
function Nv(s) {
  s !== void 0 && (Jh = s);
  let e = Jh += 1831565813;
  return e = Math.imul(e ^ e >>> 15, e | 1), e ^= e + Math.imul(e ^ e >>> 7, e | 61), ((e ^ e >>> 14) >>> 0) / 4294967296;
}
function Ov(s) {
  return s * pr;
}
function Uv(s) {
  return s * Bs;
}
function Fv(s) {
  return (s & s - 1) === 0 && s !== 0;
}
function Bv(s) {
  return Math.pow(2, Math.ceil(Math.log(s) / Math.LN2));
}
function kv(s) {
  return Math.pow(2, Math.floor(Math.log(s) / Math.LN2));
}
function zv(s, e, t, i, n) {
  const r = Math.cos, a = Math.sin, o = r(t / 2), l = a(t / 2), c = r((e + i) / 2), h = a((e + i) / 2), d = r((e - i) / 2), u = a((e - i) / 2), f = r((i - e) / 2), g = a((i - e) / 2);
  switch (n) {
    case "XYX":
      s.set(o * h, l * d, l * u, o * c);
      break;
    case "YZY":
      s.set(l * u, o * h, l * d, o * c);
      break;
    case "ZXZ":
      s.set(l * d, l * u, o * h, o * c);
      break;
    case "XZX":
      s.set(o * h, l * g, l * f, o * c);
      break;
    case "YXY":
      s.set(l * f, o * h, l * g, o * c);
      break;
    case "ZYZ":
      s.set(l * g, l * f, o * h, o * c);
      break;
    default:
      Te("MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + n);
  }
}
function Mi(s, e) {
  switch (e.constructor) {
    case Float32Array:
      return s;
    case Uint32Array:
      return s / 4294967295;
    case Uint16Array:
      return s / 65535;
    case Uint8Array:
      return s / 255;
    case Int32Array:
      return Math.max(s / 2147483647, -1);
    case Int16Array:
      return Math.max(s / 32767, -1);
    case Int8Array:
      return Math.max(s / 127, -1);
    default:
      throw new Error("Invalid component type.");
  }
}
function ct(s, e) {
  switch (e.constructor) {
    case Float32Array:
      return s;
    case Uint32Array:
      return Math.round(s * 4294967295);
    case Uint16Array:
      return Math.round(s * 65535);
    case Uint8Array:
      return Math.round(s * 255);
    case Int32Array:
      return Math.round(s * 2147483647);
    case Int16Array:
      return Math.round(s * 32767);
    case Int8Array:
      return Math.round(s * 127);
    default:
      throw new Error("Invalid component type.");
  }
}
const hc = {
  DEG2RAD: pr,
  RAD2DEG: Bs,
  /**
   * Generate a [UUID](https://en.wikipedia.org/wiki/Universally_unique_identifier)
   * (universally unique identifier).
   *
   * @static
   * @method
   * @return {string} The UUID.
   */
  generateUUID: Ei,
  /**
   * Clamps the given value between min and max.
   *
   * @static
   * @method
   * @param {number} value - The value to clamp.
   * @param {number} min - The min value.
   * @param {number} max - The max value.
   * @return {number} The clamped value.
   */
  clamp: Xe,
  /**
   * Computes the Euclidean modulo of the given parameters that
   * is `( ( n % m ) + m ) % m`.
   *
   * @static
   * @method
   * @param {number} n - The first parameter.
   * @param {number} m - The second parameter.
   * @return {number} The Euclidean modulo.
   */
  euclideanModulo: Kc,
  /**
   * Performs a linear mapping from range `<a1, a2>` to range `<b1, b2>`
   * for the given value.
   *
   * @static
   * @method
   * @param {number} x - The value to be mapped.
   * @param {number} a1 - Minimum value for range A.
   * @param {number} a2 - Maximum value for range A.
   * @param {number} b1 - Minimum value for range B.
   * @param {number} b2 - Maximum value for range B.
   * @return {number} The mapped value.
   */
  mapLinear: Tv,
  /**
   * Returns the percentage in the closed interval `[0, 1]` of the given value
   * between the start and end point.
   *
   * @static
   * @method
   * @param {number} x - The start point
   * @param {number} y - The end point.
   * @param {number} value - A value between start and end.
   * @return {number} The interpolation factor.
   */
  inverseLerp: Ev,
  /**
   * Returns a value linearly interpolated from two known points based on the given interval -
   * `t = 0` will return `x` and `t = 1` will return `y`.
   *
   * @static
   * @method
   * @param {number} x - The start point
   * @param {number} y - The end point.
   * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
   * @return {number} The interpolated value.
   */
  lerp: mr,
  /**
   * Smoothly interpolate a number from `x` to `y` in  a spring-like manner using a delta
   * time to maintain frame rate independent movement. For details, see
   * [Frame rate independent damping using lerp](http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/).
   *
   * @static
   * @method
   * @param {number} x - The current point.
   * @param {number} y - The target point.
   * @param {number} lambda - A higher lambda value will make the movement more sudden,
   * and a lower value will make the movement more gradual.
   * @param {number} dt - Delta time in seconds.
   * @return {number} The interpolated value.
   */
  damp: Av,
  /**
   * Returns a value that alternates between `0` and the given `length` parameter.
   *
   * @static
   * @method
   * @param {number} x - The value to pingpong.
   * @param {number} [length=1] - The positive value the function will pingpong to.
   * @return {number} The alternated value.
   */
  pingpong: Rv,
  /**
   * Returns a value in the range `[0,1]` that represents the percentage that `x` has
   * moved between `min` and `max`, but smoothed or slowed down the closer `x` is to
   * the `min` and `max`.
   *
   * See [Smoothstep](http://en.wikipedia.org/wiki/Smoothstep) for more details.
   *
   * @static
   * @method
   * @param {number} x - The value to evaluate based on its position between min and max.
   * @param {number} min - The min value. Any x value below min will be `0`.
   * @param {number} max - The max value. Any x value above max will be `1`.
   * @return {number} The alternated value.
   */
  smoothstep: Cv,
  /**
   * A [variation on smoothstep](https://en.wikipedia.org/wiki/Smoothstep#Variations)
   * that has zero 1st and 2nd order derivatives at x=0 and x=1.
   *
   * @static
   * @method
   * @param {number} x - The value to evaluate based on its position between min and max.
   * @param {number} min - The min value. Any x value below min will be `0`.
   * @param {number} max - The max value. Any x value above max will be `1`.
   * @return {number} The alternated value.
   */
  smootherstep: Iv,
  /**
   * Returns a random integer from `<low, high>` interval.
   *
   * @static
   * @method
   * @param {number} low - The lower value boundary.
   * @param {number} high - The upper value boundary
   * @return {number} A random integer.
   */
  randInt: Pv,
  /**
   * Returns a random float from `<low, high>` interval.
   *
   * @static
   * @method
   * @param {number} low - The lower value boundary.
   * @param {number} high - The upper value boundary
   * @return {number} A random float.
   */
  randFloat: Lv,
  /**
   * Returns a random integer from `<-range/2, range/2>` interval.
   *
   * @static
   * @method
   * @param {number} range - Defines the value range.
   * @return {number} A random float.
   */
  randFloatSpread: Dv,
  /**
   * Returns a deterministic pseudo-random float in the interval `[0, 1]`.
   *
   * @static
   * @method
   * @param {number} [s] - The integer seed.
   * @return {number} A random float.
   */
  seededRandom: Nv,
  /**
   * Converts degrees to radians.
   *
   * @static
   * @method
   * @param {number} degrees - A value in degrees.
   * @return {number} The converted value in radians.
   */
  degToRad: Ov,
  /**
   * Converts radians to degrees.
   *
   * @static
   * @method
   * @param {number} radians - A value in radians.
   * @return {number} The converted value in degrees.
   */
  radToDeg: Uv,
  /**
   * Returns `true` if the given number is a power of two.
   *
   * @static
   * @method
   * @param {number} value - The value to check.
   * @return {boolean} Whether the given number is a power of two or not.
   */
  isPowerOfTwo: Fv,
  /**
   * Returns the smallest power of two that is greater than or equal to the given number.
   *
   * @static
   * @method
   * @param {number} value - The value to find a POT for.
   * @return {number} The smallest power of two that is greater than or equal to the given number.
   */
  ceilPowerOfTwo: Bv,
  /**
   * Returns the largest power of two that is less than or equal to the given number.
   *
   * @static
   * @method
   * @param {number} value - The value to find a POT for.
   * @return {number} The largest power of two that is less than or equal to the given number.
   */
  floorPowerOfTwo: kv,
  /**
   * Sets the given quaternion from the [Intrinsic Proper Euler Angles](https://en.wikipedia.org/wiki/Euler_angles)
   * defined by the given angles and order.
   *
   * Rotations are applied to the axes in the order specified by order:
   * rotation by angle `a` is applied first, then by angle `b`, then by angle `c`.
   *
   * @static
   * @method
   * @param {Quaternion} q - The quaternion to set.
   * @param {number} a - The rotation applied to the first axis, in radians.
   * @param {number} b - The rotation applied to the second axis, in radians.
   * @param {number} c - The rotation applied to the third axis, in radians.
   * @param {('XYX'|'XZX'|'YXY'|'YZY'|'ZXZ'|'ZYZ')} order - A string specifying the axes order.
   */
  setQuaternionFromProperEuler: zv,
  /**
   * Normalizes the given value according to the given typed array.
   *
   * @static
   * @method
   * @param {number} value - The float value in the range `[0,1]` to normalize.
   * @param {TypedArray} array - The typed array that defines the data type of the value.
   * @return {number} The normalize value.
   */
  normalize: ct,
  /**
   * Denormalizes the given value according to the given typed array.
   *
   * @static
   * @method
   * @param {number} value - The value to denormalize.
   * @param {TypedArray} array - The typed array that defines the data type of the value.
   * @return {number} The denormalize (float) value in the range `[0,1]`.
   */
  denormalize: Mi
};
class Ye {
  /**
   * Constructs a new 2D vector.
   *
   * @param {number} [x=0] - The x value of this vector.
   * @param {number} [y=0] - The y value of this vector.
   */
  constructor(e = 0, t = 0) {
    Ye.prototype.isVector2 = !0, this.x = e, this.y = t;
  }
  /**
   * Alias for {@link Vector2#x}.
   *
   * @type {number}
   */
  get width() {
    return this.x;
  }
  set width(e) {
    this.x = e;
  }
  /**
   * Alias for {@link Vector2#y}.
   *
   * @type {number}
   */
  get height() {
    return this.y;
  }
  set height(e) {
    this.y = e;
  }
  /**
   * Sets the vector components.
   *
   * @param {number} x - The value of the x component.
   * @param {number} y - The value of the y component.
   * @return {Vector2} A reference to this vector.
   */
  set(e, t) {
    return this.x = e, this.y = t, this;
  }
  /**
   * Sets the vector components to the same value.
   *
   * @param {number} scalar - The value to set for all vector components.
   * @return {Vector2} A reference to this vector.
   */
  setScalar(e) {
    return this.x = e, this.y = e, this;
  }
  /**
   * Sets the vector's x component to the given value
   *
   * @param {number} x - The value to set.
   * @return {Vector2} A reference to this vector.
   */
  setX(e) {
    return this.x = e, this;
  }
  /**
   * Sets the vector's y component to the given value
   *
   * @param {number} y - The value to set.
   * @return {Vector2} A reference to this vector.
   */
  setY(e) {
    return this.y = e, this;
  }
  /**
   * Allows to set a vector component with an index.
   *
   * @param {number} index - The component index. `0` equals to x, `1` equals to y.
   * @param {number} value - The value to set.
   * @return {Vector2} A reference to this vector.
   */
  setComponent(e, t) {
    switch (e) {
      case 0:
        this.x = t;
        break;
      case 1:
        this.y = t;
        break;
      default:
        throw new Error("index is out of range: " + e);
    }
    return this;
  }
  /**
   * Returns the value of the vector component which matches the given index.
   *
   * @param {number} index - The component index. `0` equals to x, `1` equals to y.
   * @return {number} A vector component value.
   */
  getComponent(e) {
    switch (e) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      default:
        throw new Error("index is out of range: " + e);
    }
  }
  /**
   * Returns a new vector with copied values from this instance.
   *
   * @return {Vector2} A clone of this instance.
   */
  clone() {
    return new this.constructor(this.x, this.y);
  }
  /**
   * Copies the values of the given vector to this instance.
   *
   * @param {Vector2} v - The vector to copy.
   * @return {Vector2} A reference to this vector.
   */
  copy(e) {
    return this.x = e.x, this.y = e.y, this;
  }
  /**
   * Adds the given vector to this instance.
   *
   * @param {Vector2} v - The vector to add.
   * @return {Vector2} A reference to this vector.
   */
  add(e) {
    return this.x += e.x, this.y += e.y, this;
  }
  /**
   * Adds the given scalar value to all components of this instance.
   *
   * @param {number} s - The scalar to add.
   * @return {Vector2} A reference to this vector.
   */
  addScalar(e) {
    return this.x += e, this.y += e, this;
  }
  /**
   * Adds the given vectors and stores the result in this instance.
   *
   * @param {Vector2} a - The first vector.
   * @param {Vector2} b - The second vector.
   * @return {Vector2} A reference to this vector.
   */
  addVectors(e, t) {
    return this.x = e.x + t.x, this.y = e.y + t.y, this;
  }
  /**
   * Adds the given vector scaled by the given factor to this instance.
   *
   * @param {Vector2} v - The vector.
   * @param {number} s - The factor that scales `v`.
   * @return {Vector2} A reference to this vector.
   */
  addScaledVector(e, t) {
    return this.x += e.x * t, this.y += e.y * t, this;
  }
  /**
   * Subtracts the given vector from this instance.
   *
   * @param {Vector2} v - The vector to subtract.
   * @return {Vector2} A reference to this vector.
   */
  sub(e) {
    return this.x -= e.x, this.y -= e.y, this;
  }
  /**
   * Subtracts the given scalar value from all components of this instance.
   *
   * @param {number} s - The scalar to subtract.
   * @return {Vector2} A reference to this vector.
   */
  subScalar(e) {
    return this.x -= e, this.y -= e, this;
  }
  /**
   * Subtracts the given vectors and stores the result in this instance.
   *
   * @param {Vector2} a - The first vector.
   * @param {Vector2} b - The second vector.
   * @return {Vector2} A reference to this vector.
   */
  subVectors(e, t) {
    return this.x = e.x - t.x, this.y = e.y - t.y, this;
  }
  /**
   * Multiplies the given vector with this instance.
   *
   * @param {Vector2} v - The vector to multiply.
   * @return {Vector2} A reference to this vector.
   */
  multiply(e) {
    return this.x *= e.x, this.y *= e.y, this;
  }
  /**
   * Multiplies the given scalar value with all components of this instance.
   *
   * @param {number} scalar - The scalar to multiply.
   * @return {Vector2} A reference to this vector.
   */
  multiplyScalar(e) {
    return this.x *= e, this.y *= e, this;
  }
  /**
   * Divides this instance by the given vector.
   *
   * @param {Vector2} v - The vector to divide.
   * @return {Vector2} A reference to this vector.
   */
  divide(e) {
    return this.x /= e.x, this.y /= e.y, this;
  }
  /**
   * Divides this vector by the given scalar.
   *
   * @param {number} scalar - The scalar to divide.
   * @return {Vector2} A reference to this vector.
   */
  divideScalar(e) {
    return this.multiplyScalar(1 / e);
  }
  /**
   * Multiplies this vector (with an implicit 1 as the 3rd component) by
   * the given 3x3 matrix.
   *
   * @param {Matrix3} m - The matrix to apply.
   * @return {Vector2} A reference to this vector.
   */
  applyMatrix3(e) {
    const t = this.x, i = this.y, n = e.elements;
    return this.x = n[0] * t + n[3] * i + n[6], this.y = n[1] * t + n[4] * i + n[7], this;
  }
  /**
   * If this vector's x or y value is greater than the given vector's x or y
   * value, replace that value with the corresponding min value.
   *
   * @param {Vector2} v - The vector.
   * @return {Vector2} A reference to this vector.
   */
  min(e) {
    return this.x = Math.min(this.x, e.x), this.y = Math.min(this.y, e.y), this;
  }
  /**
   * If this vector's x or y value is less than the given vector's x or y
   * value, replace that value with the corresponding max value.
   *
   * @param {Vector2} v - The vector.
   * @return {Vector2} A reference to this vector.
   */
  max(e) {
    return this.x = Math.max(this.x, e.x), this.y = Math.max(this.y, e.y), this;
  }
  /**
   * If this vector's x or y value is greater than the max vector's x or y
   * value, it is replaced by the corresponding value.
   * If this vector's x or y value is less than the min vector's x or y value,
   * it is replaced by the corresponding value.
   *
   * @param {Vector2} min - The minimum x and y values.
   * @param {Vector2} max - The maximum x and y values in the desired range.
   * @return {Vector2} A reference to this vector.
   */
  clamp(e, t) {
    return this.x = Xe(this.x, e.x, t.x), this.y = Xe(this.y, e.y, t.y), this;
  }
  /**
   * If this vector's x or y values are greater than the max value, they are
   * replaced by the max value.
   * If this vector's x or y values are less than the min value, they are
   * replaced by the min value.
   *
   * @param {number} minVal - The minimum value the components will be clamped to.
   * @param {number} maxVal - The maximum value the components will be clamped to.
   * @return {Vector2} A reference to this vector.
   */
  clampScalar(e, t) {
    return this.x = Xe(this.x, e, t), this.y = Xe(this.y, e, t), this;
  }
  /**
   * If this vector's length is greater than the max value, it is replaced by
   * the max value.
   * If this vector's length is less than the min value, it is replaced by the
   * min value.
   *
   * @param {number} min - The minimum value the vector length will be clamped to.
   * @param {number} max - The maximum value the vector length will be clamped to.
   * @return {Vector2} A reference to this vector.
   */
  clampLength(e, t) {
    const i = this.length();
    return this.divideScalar(i || 1).multiplyScalar(Xe(i, e, t));
  }
  /**
   * The components of this vector are rounded down to the nearest integer value.
   *
   * @return {Vector2} A reference to this vector.
   */
  floor() {
    return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
  }
  /**
   * The components of this vector are rounded up to the nearest integer value.
   *
   * @return {Vector2} A reference to this vector.
   */
  ceil() {
    return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
  }
  /**
   * The components of this vector are rounded to the nearest integer value
   *
   * @return {Vector2} A reference to this vector.
   */
  round() {
    return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
  }
  /**
   * The components of this vector are rounded towards zero (up if negative,
   * down if positive) to an integer value.
   *
   * @return {Vector2} A reference to this vector.
   */
  roundToZero() {
    return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this;
  }
  /**
   * Inverts this vector - i.e. sets x = -x and y = -y.
   *
   * @return {Vector2} A reference to this vector.
   */
  negate() {
    return this.x = -this.x, this.y = -this.y, this;
  }
  /**
   * Calculates the dot product of the given vector with this instance.
   *
   * @param {Vector2} v - The vector to compute the dot product with.
   * @return {number} The result of the dot product.
   */
  dot(e) {
    return this.x * e.x + this.y * e.y;
  }
  /**
   * Calculates the cross product of the given vector with this instance.
   *
   * @param {Vector2} v - The vector to compute the cross product with.
   * @return {number} The result of the cross product.
   */
  cross(e) {
    return this.x * e.y - this.y * e.x;
  }
  /**
   * Computes the square of the Euclidean length (straight-line length) from
   * (0, 0) to (x, y). If you are comparing the lengths of vectors, you should
   * compare the length squared instead as it is slightly more efficient to calculate.
   *
   * @return {number} The square length of this vector.
   */
  lengthSq() {
    return this.x * this.x + this.y * this.y;
  }
  /**
   * Computes the  Euclidean length (straight-line length) from (0, 0) to (x, y).
   *
   * @return {number} The length of this vector.
   */
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y);
  }
  /**
   * Computes the Manhattan length of this vector.
   *
   * @return {number} The length of this vector.
   */
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y);
  }
  /**
   * Converts this vector to a unit vector - that is, sets it equal to a vector
   * with the same direction as this one, but with a vector length of `1`.
   *
   * @return {Vector2} A reference to this vector.
   */
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  /**
   * Computes the angle in radians of this vector with respect to the positive x-axis.
   *
   * @return {number} The angle in radians.
   */
  angle() {
    return Math.atan2(-this.y, -this.x) + Math.PI;
  }
  /**
   * Returns the angle between the given vector and this instance in radians.
   *
   * @param {Vector2} v - The vector to compute the angle with.
   * @return {number} The angle in radians.
   */
  angleTo(e) {
    const t = Math.sqrt(this.lengthSq() * e.lengthSq());
    if (t === 0) return Math.PI / 2;
    const i = this.dot(e) / t;
    return Math.acos(Xe(i, -1, 1));
  }
  /**
   * Computes the distance from the given vector to this instance.
   *
   * @param {Vector2} v - The vector to compute the distance to.
   * @return {number} The distance.
   */
  distanceTo(e) {
    return Math.sqrt(this.distanceToSquared(e));
  }
  /**
   * Computes the squared distance from the given vector to this instance.
   * If you are just comparing the distance with another distance, you should compare
   * the distance squared instead as it is slightly more efficient to calculate.
   *
   * @param {Vector2} v - The vector to compute the squared distance to.
   * @return {number} The squared distance.
   */
  distanceToSquared(e) {
    const t = this.x - e.x, i = this.y - e.y;
    return t * t + i * i;
  }
  /**
   * Computes the Manhattan distance from the given vector to this instance.
   *
   * @param {Vector2} v - The vector to compute the Manhattan distance to.
   * @return {number} The Manhattan distance.
   */
  manhattanDistanceTo(e) {
    return Math.abs(this.x - e.x) + Math.abs(this.y - e.y);
  }
  /**
   * Sets this vector to a vector with the same direction as this one, but
   * with the specified length.
   *
   * @param {number} length - The new length of this vector.
   * @return {Vector2} A reference to this vector.
   */
  setLength(e) {
    return this.normalize().multiplyScalar(e);
  }
  /**
   * Linearly interpolates between the given vector and this instance, where
   * alpha is the percent distance along the line - alpha = 0 will be this
   * vector, and alpha = 1 will be the given one.
   *
   * @param {Vector2} v - The vector to interpolate towards.
   * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
   * @return {Vector2} A reference to this vector.
   */
  lerp(e, t) {
    return this.x += (e.x - this.x) * t, this.y += (e.y - this.y) * t, this;
  }
  /**
   * Linearly interpolates between the given vectors, where alpha is the percent
   * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
   * be the second one. The result is stored in this instance.
   *
   * @param {Vector2} v1 - The first vector.
   * @param {Vector2} v2 - The second vector.
   * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
   * @return {Vector2} A reference to this vector.
   */
  lerpVectors(e, t, i) {
    return this.x = e.x + (t.x - e.x) * i, this.y = e.y + (t.y - e.y) * i, this;
  }
  /**
   * Returns `true` if this vector is equal with the given one.
   *
   * @param {Vector2} v - The vector to test for equality.
   * @return {boolean} Whether this vector is equal with the given one.
   */
  equals(e) {
    return e.x === this.x && e.y === this.y;
  }
  /**
   * Sets this vector's x value to be `array[ offset ]` and y
   * value to be `array[ offset + 1 ]`.
   *
   * @param {Array<number>} array - An array holding the vector component values.
   * @param {number} [offset=0] - The offset into the array.
   * @return {Vector2} A reference to this vector.
   */
  fromArray(e, t = 0) {
    return this.x = e[t], this.y = e[t + 1], this;
  }
  /**
   * Writes the components of this vector to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the vector components.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The vector components.
   */
  toArray(e = [], t = 0) {
    return e[t] = this.x, e[t + 1] = this.y, e;
  }
  /**
   * Sets the components of this vector from the given buffer attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
   * @param {number} index - The index into the attribute.
   * @return {Vector2} A reference to this vector.
   */
  fromBufferAttribute(e, t) {
    return this.x = e.getX(t), this.y = e.getY(t), this;
  }
  /**
   * Rotates this vector around the given center by the given angle.
   *
   * @param {Vector2} center - The point around which to rotate.
   * @param {number} angle - The angle to rotate, in radians.
   * @return {Vector2} A reference to this vector.
   */
  rotateAround(e, t) {
    const i = Math.cos(t), n = Math.sin(t), r = this.x - e.x, a = this.y - e.y;
    return this.x = r * i - a * n + e.x, this.y = r * n + a * i + e.y, this;
  }
  /**
   * Sets each component of this vector to a pseudo-random value between `0` and
   * `1`, excluding `1`.
   *
   * @return {Vector2} A reference to this vector.
   */
  random() {
    return this.x = Math.random(), this.y = Math.random(), this;
  }
  *[Symbol.iterator]() {
    yield this.x, yield this.y;
  }
}
class si {
  /**
   * Constructs a new quaternion.
   *
   * @param {number} [x=0] - The x value of this quaternion.
   * @param {number} [y=0] - The y value of this quaternion.
   * @param {number} [z=0] - The z value of this quaternion.
   * @param {number} [w=1] - The w value of this quaternion.
   */
  constructor(e = 0, t = 0, i = 0, n = 1) {
    this.isQuaternion = !0, this._x = e, this._y = t, this._z = i, this._w = n;
  }
  /**
   * Interpolates between two quaternions via SLERP. This implementation assumes the
   * quaternion data are managed in flat arrays.
   *
   * @param {Array<number>} dst - The destination array.
   * @param {number} dstOffset - An offset into the destination array.
   * @param {Array<number>} src0 - The source array of the first quaternion.
   * @param {number} srcOffset0 - An offset into the first source array.
   * @param {Array<number>} src1 -  The source array of the second quaternion.
   * @param {number} srcOffset1 - An offset into the second source array.
   * @param {number} t - The interpolation factor in the range `[0,1]`.
   * @see {@link Quaternion#slerp}
   */
  static slerpFlat(e, t, i, n, r, a, o) {
    let l = i[n + 0], c = i[n + 1], h = i[n + 2], d = i[n + 3], u = r[a + 0], f = r[a + 1], g = r[a + 2], v = r[a + 3];
    if (o <= 0) {
      e[t + 0] = l, e[t + 1] = c, e[t + 2] = h, e[t + 3] = d;
      return;
    }
    if (o >= 1) {
      e[t + 0] = u, e[t + 1] = f, e[t + 2] = g, e[t + 3] = v;
      return;
    }
    if (d !== v || l !== u || c !== f || h !== g) {
      let m = l * u + c * f + h * g + d * v;
      m < 0 && (u = -u, f = -f, g = -g, v = -v, m = -m);
      let p = 1 - o;
      if (m < 0.9995) {
        const w = Math.acos(m), M = Math.sin(w);
        p = Math.sin(p * w) / M, o = Math.sin(o * w) / M, l = l * p + u * o, c = c * p + f * o, h = h * p + g * o, d = d * p + v * o;
      } else {
        l = l * p + u * o, c = c * p + f * o, h = h * p + g * o, d = d * p + v * o;
        const w = 1 / Math.sqrt(l * l + c * c + h * h + d * d);
        l *= w, c *= w, h *= w, d *= w;
      }
    }
    e[t] = l, e[t + 1] = c, e[t + 2] = h, e[t + 3] = d;
  }
  /**
   * Multiplies two quaternions. This implementation assumes the quaternion data are managed
   * in flat arrays.
   *
   * @param {Array<number>} dst - The destination array.
   * @param {number} dstOffset - An offset into the destination array.
   * @param {Array<number>} src0 - The source array of the first quaternion.
   * @param {number} srcOffset0 - An offset into the first source array.
   * @param {Array<number>} src1 -  The source array of the second quaternion.
   * @param {number} srcOffset1 - An offset into the second source array.
   * @return {Array<number>} The destination array.
   * @see {@link Quaternion#multiplyQuaternions}.
   */
  static multiplyQuaternionsFlat(e, t, i, n, r, a) {
    const o = i[n], l = i[n + 1], c = i[n + 2], h = i[n + 3], d = r[a], u = r[a + 1], f = r[a + 2], g = r[a + 3];
    return e[t] = o * g + h * d + l * f - c * u, e[t + 1] = l * g + h * u + c * d - o * f, e[t + 2] = c * g + h * f + o * u - l * d, e[t + 3] = h * g - o * d - l * u - c * f, e;
  }
  /**
   * The x value of this quaternion.
   *
   * @type {number}
   * @default 0
   */
  get x() {
    return this._x;
  }
  set x(e) {
    this._x = e, this._onChangeCallback();
  }
  /**
   * The y value of this quaternion.
   *
   * @type {number}
   * @default 0
   */
  get y() {
    return this._y;
  }
  set y(e) {
    this._y = e, this._onChangeCallback();
  }
  /**
   * The z value of this quaternion.
   *
   * @type {number}
   * @default 0
   */
  get z() {
    return this._z;
  }
  set z(e) {
    this._z = e, this._onChangeCallback();
  }
  /**
   * The w value of this quaternion.
   *
   * @type {number}
   * @default 1
   */
  get w() {
    return this._w;
  }
  set w(e) {
    this._w = e, this._onChangeCallback();
  }
  /**
   * Sets the quaternion components.
   *
   * @param {number} x - The x value of this quaternion.
   * @param {number} y - The y value of this quaternion.
   * @param {number} z - The z value of this quaternion.
   * @param {number} w - The w value of this quaternion.
   * @return {Quaternion} A reference to this quaternion.
   */
  set(e, t, i, n) {
    return this._x = e, this._y = t, this._z = i, this._w = n, this._onChangeCallback(), this;
  }
  /**
   * Returns a new quaternion with copied values from this instance.
   *
   * @return {Quaternion} A clone of this instance.
   */
  clone() {
    return new this.constructor(this._x, this._y, this._z, this._w);
  }
  /**
   * Copies the values of the given quaternion to this instance.
   *
   * @param {Quaternion} quaternion - The quaternion to copy.
   * @return {Quaternion} A reference to this quaternion.
   */
  copy(e) {
    return this._x = e.x, this._y = e.y, this._z = e.z, this._w = e.w, this._onChangeCallback(), this;
  }
  /**
   * Sets this quaternion from the rotation specified by the given
   * Euler angles.
   *
   * @param {Euler} euler - The Euler angles.
   * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
   * @return {Quaternion} A reference to this quaternion.
   */
  setFromEuler(e, t = !0) {
    const i = e._x, n = e._y, r = e._z, a = e._order, o = Math.cos, l = Math.sin, c = o(i / 2), h = o(n / 2), d = o(r / 2), u = l(i / 2), f = l(n / 2), g = l(r / 2);
    switch (a) {
      case "XYZ":
        this._x = u * h * d + c * f * g, this._y = c * f * d - u * h * g, this._z = c * h * g + u * f * d, this._w = c * h * d - u * f * g;
        break;
      case "YXZ":
        this._x = u * h * d + c * f * g, this._y = c * f * d - u * h * g, this._z = c * h * g - u * f * d, this._w = c * h * d + u * f * g;
        break;
      case "ZXY":
        this._x = u * h * d - c * f * g, this._y = c * f * d + u * h * g, this._z = c * h * g + u * f * d, this._w = c * h * d - u * f * g;
        break;
      case "ZYX":
        this._x = u * h * d - c * f * g, this._y = c * f * d + u * h * g, this._z = c * h * g - u * f * d, this._w = c * h * d + u * f * g;
        break;
      case "YZX":
        this._x = u * h * d + c * f * g, this._y = c * f * d + u * h * g, this._z = c * h * g - u * f * d, this._w = c * h * d - u * f * g;
        break;
      case "XZY":
        this._x = u * h * d - c * f * g, this._y = c * f * d - u * h * g, this._z = c * h * g + u * f * d, this._w = c * h * d + u * f * g;
        break;
      default:
        Te("Quaternion: .setFromEuler() encountered an unknown order: " + a);
    }
    return t === !0 && this._onChangeCallback(), this;
  }
  /**
   * Sets this quaternion from the given axis and angle.
   *
   * @param {Vector3} axis - The normalized axis.
   * @param {number} angle - The angle in radians.
   * @return {Quaternion} A reference to this quaternion.
   */
  setFromAxisAngle(e, t) {
    const i = t / 2, n = Math.sin(i);
    return this._x = e.x * n, this._y = e.y * n, this._z = e.z * n, this._w = Math.cos(i), this._onChangeCallback(), this;
  }
  /**
   * Sets this quaternion from the given rotation matrix.
   *
   * @param {Matrix4} m - A 4x4 matrix of which the upper 3x3 of matrix is a pure rotation matrix (i.e. unscaled).
   * @return {Quaternion} A reference to this quaternion.
   */
  setFromRotationMatrix(e) {
    const t = e.elements, i = t[0], n = t[4], r = t[8], a = t[1], o = t[5], l = t[9], c = t[2], h = t[6], d = t[10], u = i + o + d;
    if (u > 0) {
      const f = 0.5 / Math.sqrt(u + 1);
      this._w = 0.25 / f, this._x = (h - l) * f, this._y = (r - c) * f, this._z = (a - n) * f;
    } else if (i > o && i > d) {
      const f = 2 * Math.sqrt(1 + i - o - d);
      this._w = (h - l) / f, this._x = 0.25 * f, this._y = (n + a) / f, this._z = (r + c) / f;
    } else if (o > d) {
      const f = 2 * Math.sqrt(1 + o - i - d);
      this._w = (r - c) / f, this._x = (n + a) / f, this._y = 0.25 * f, this._z = (l + h) / f;
    } else {
      const f = 2 * Math.sqrt(1 + d - i - o);
      this._w = (a - n) / f, this._x = (r + c) / f, this._y = (l + h) / f, this._z = 0.25 * f;
    }
    return this._onChangeCallback(), this;
  }
  /**
   * Sets this quaternion to the rotation required to rotate the direction vector
   * `vFrom` to the direction vector `vTo`.
   *
   * @param {Vector3} vFrom - The first (normalized) direction vector.
   * @param {Vector3} vTo - The second (normalized) direction vector.
   * @return {Quaternion} A reference to this quaternion.
   */
  setFromUnitVectors(e, t) {
    let i = e.dot(t) + 1;
    return i < 1e-8 ? (i = 0, Math.abs(e.x) > Math.abs(e.z) ? (this._x = -e.y, this._y = e.x, this._z = 0, this._w = i) : (this._x = 0, this._y = -e.z, this._z = e.y, this._w = i)) : (this._x = e.y * t.z - e.z * t.y, this._y = e.z * t.x - e.x * t.z, this._z = e.x * t.y - e.y * t.x, this._w = i), this.normalize();
  }
  /**
   * Returns the angle between this quaternion and the given one in radians.
   *
   * @param {Quaternion} q - The quaternion to compute the angle with.
   * @return {number} The angle in radians.
   */
  angleTo(e) {
    return 2 * Math.acos(Math.abs(Xe(this.dot(e), -1, 1)));
  }
  /**
   * Rotates this quaternion by a given angular step to the given quaternion.
   * The method ensures that the final quaternion will not overshoot `q`.
   *
   * @param {Quaternion} q - The target quaternion.
   * @param {number} step - The angular step in radians.
   * @return {Quaternion} A reference to this quaternion.
   */
  rotateTowards(e, t) {
    const i = this.angleTo(e);
    if (i === 0) return this;
    const n = Math.min(1, t / i);
    return this.slerp(e, n), this;
  }
  /**
   * Sets this quaternion to the identity quaternion; that is, to the
   * quaternion that represents "no rotation".
   *
   * @return {Quaternion} A reference to this quaternion.
   */
  identity() {
    return this.set(0, 0, 0, 1);
  }
  /**
   * Inverts this quaternion via {@link Quaternion#conjugate}. The
   * quaternion is assumed to have unit length.
   *
   * @return {Quaternion} A reference to this quaternion.
   */
  invert() {
    return this.conjugate();
  }
  /**
   * Returns the rotational conjugate of this quaternion. The conjugate of a
   * quaternion represents the same rotation in the opposite direction about
   * the rotational axis.
   *
   * @return {Quaternion} A reference to this quaternion.
   */
  conjugate() {
    return this._x *= -1, this._y *= -1, this._z *= -1, this._onChangeCallback(), this;
  }
  /**
   * Calculates the dot product of this quaternion and the given one.
   *
   * @param {Quaternion} v - The quaternion to compute the dot product with.
   * @return {number} The result of the dot product.
   */
  dot(e) {
    return this._x * e._x + this._y * e._y + this._z * e._z + this._w * e._w;
  }
  /**
   * Computes the squared Euclidean length (straight-line length) of this quaternion,
   * considered as a 4 dimensional vector. This can be useful if you are comparing the
   * lengths of two quaternions, as this is a slightly more efficient calculation than
   * {@link Quaternion#length}.
   *
   * @return {number} The squared Euclidean length.
   */
  lengthSq() {
    return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
  }
  /**
   * Computes the Euclidean length (straight-line length) of this quaternion,
   * considered as a 4 dimensional vector.
   *
   * @return {number} The Euclidean length.
   */
  length() {
    return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
  }
  /**
   * Normalizes this quaternion - that is, calculated the quaternion that performs
   * the same rotation as this one, but has a length equal to `1`.
   *
   * @return {Quaternion} A reference to this quaternion.
   */
  normalize() {
    let e = this.length();
    return e === 0 ? (this._x = 0, this._y = 0, this._z = 0, this._w = 1) : (e = 1 / e, this._x = this._x * e, this._y = this._y * e, this._z = this._z * e, this._w = this._w * e), this._onChangeCallback(), this;
  }
  /**
   * Multiplies this quaternion by the given one.
   *
   * @param {Quaternion} q - The quaternion.
   * @return {Quaternion} A reference to this quaternion.
   */
  multiply(e) {
    return this.multiplyQuaternions(this, e);
  }
  /**
   * Pre-multiplies this quaternion by the given one.
   *
   * @param {Quaternion} q - The quaternion.
   * @return {Quaternion} A reference to this quaternion.
   */
  premultiply(e) {
    return this.multiplyQuaternions(e, this);
  }
  /**
   * Multiplies the given quaternions and stores the result in this instance.
   *
   * @param {Quaternion} a - The first quaternion.
   * @param {Quaternion} b - The second quaternion.
   * @return {Quaternion} A reference to this quaternion.
   */
  multiplyQuaternions(e, t) {
    const i = e._x, n = e._y, r = e._z, a = e._w, o = t._x, l = t._y, c = t._z, h = t._w;
    return this._x = i * h + a * o + n * c - r * l, this._y = n * h + a * l + r * o - i * c, this._z = r * h + a * c + i * l - n * o, this._w = a * h - i * o - n * l - r * c, this._onChangeCallback(), this;
  }
  /**
   * Performs a spherical linear interpolation between quaternions.
   *
   * @param {Quaternion} qb - The target quaternion.
   * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
   * @return {Quaternion} A reference to this quaternion.
   */
  slerp(e, t) {
    if (t <= 0) return this;
    if (t >= 1) return this.copy(e);
    let i = e._x, n = e._y, r = e._z, a = e._w, o = this.dot(e);
    o < 0 && (i = -i, n = -n, r = -r, a = -a, o = -o);
    let l = 1 - t;
    if (o < 0.9995) {
      const c = Math.acos(o), h = Math.sin(c);
      l = Math.sin(l * c) / h, t = Math.sin(t * c) / h, this._x = this._x * l + i * t, this._y = this._y * l + n * t, this._z = this._z * l + r * t, this._w = this._w * l + a * t, this._onChangeCallback();
    } else
      this._x = this._x * l + i * t, this._y = this._y * l + n * t, this._z = this._z * l + r * t, this._w = this._w * l + a * t, this.normalize();
    return this;
  }
  /**
   * Performs a spherical linear interpolation between the given quaternions
   * and stores the result in this quaternion.
   *
   * @param {Quaternion} qa - The source quaternion.
   * @param {Quaternion} qb - The target quaternion.
   * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
   * @return {Quaternion} A reference to this quaternion.
   */
  slerpQuaternions(e, t, i) {
    return this.copy(e).slerp(t, i);
  }
  /**
   * Sets this quaternion to a uniformly random, normalized quaternion.
   *
   * @return {Quaternion} A reference to this quaternion.
   */
  random() {
    const e = 2 * Math.PI * Math.random(), t = 2 * Math.PI * Math.random(), i = Math.random(), n = Math.sqrt(1 - i), r = Math.sqrt(i);
    return this.set(
      n * Math.sin(e),
      n * Math.cos(e),
      r * Math.sin(t),
      r * Math.cos(t)
    );
  }
  /**
   * Returns `true` if this quaternion is equal with the given one.
   *
   * @param {Quaternion} quaternion - The quaternion to test for equality.
   * @return {boolean} Whether this quaternion is equal with the given one.
   */
  equals(e) {
    return e._x === this._x && e._y === this._y && e._z === this._z && e._w === this._w;
  }
  /**
   * Sets this quaternion's components from the given array.
   *
   * @param {Array<number>} array - An array holding the quaternion component values.
   * @param {number} [offset=0] - The offset into the array.
   * @return {Quaternion} A reference to this quaternion.
   */
  fromArray(e, t = 0) {
    return this._x = e[t], this._y = e[t + 1], this._z = e[t + 2], this._w = e[t + 3], this._onChangeCallback(), this;
  }
  /**
   * Writes the components of this quaternion to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the quaternion components.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The quaternion components.
   */
  toArray(e = [], t = 0) {
    return e[t] = this._x, e[t + 1] = this._y, e[t + 2] = this._z, e[t + 3] = this._w, e;
  }
  /**
   * Sets the components of this quaternion from the given buffer attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute holding quaternion data.
   * @param {number} index - The index into the attribute.
   * @return {Quaternion} A reference to this quaternion.
   */
  fromBufferAttribute(e, t) {
    return this._x = e.getX(t), this._y = e.getY(t), this._z = e.getZ(t), this._w = e.getW(t), this._onChangeCallback(), this;
  }
  /**
   * This methods defines the serialization result of this class. Returns the
   * numerical elements of this quaternion in an array of format `[x, y, z, w]`.
   *
   * @return {Array<number>} The serialized quaternion.
   */
  toJSON() {
    return this.toArray();
  }
  _onChange(e) {
    return this._onChangeCallback = e, this;
  }
  _onChangeCallback() {
  }
  *[Symbol.iterator]() {
    yield this._x, yield this._y, yield this._z, yield this._w;
  }
}
class O {
  /**
   * Constructs a new 3D vector.
   *
   * @param {number} [x=0] - The x value of this vector.
   * @param {number} [y=0] - The y value of this vector.
   * @param {number} [z=0] - The z value of this vector.
   */
  constructor(e = 0, t = 0, i = 0) {
    O.prototype.isVector3 = !0, this.x = e, this.y = t, this.z = i;
  }
  /**
   * Sets the vector components.
   *
   * @param {number} x - The value of the x component.
   * @param {number} y - The value of the y component.
   * @param {number} z - The value of the z component.
   * @return {Vector3} A reference to this vector.
   */
  set(e, t, i) {
    return i === void 0 && (i = this.z), this.x = e, this.y = t, this.z = i, this;
  }
  /**
   * Sets the vector components to the same value.
   *
   * @param {number} scalar - The value to set for all vector components.
   * @return {Vector3} A reference to this vector.
   */
  setScalar(e) {
    return this.x = e, this.y = e, this.z = e, this;
  }
  /**
   * Sets the vector's x component to the given value
   *
   * @param {number} x - The value to set.
   * @return {Vector3} A reference to this vector.
   */
  setX(e) {
    return this.x = e, this;
  }
  /**
   * Sets the vector's y component to the given value
   *
   * @param {number} y - The value to set.
   * @return {Vector3} A reference to this vector.
   */
  setY(e) {
    return this.y = e, this;
  }
  /**
   * Sets the vector's z component to the given value
   *
   * @param {number} z - The value to set.
   * @return {Vector3} A reference to this vector.
   */
  setZ(e) {
    return this.z = e, this;
  }
  /**
   * Allows to set a vector component with an index.
   *
   * @param {number} index - The component index. `0` equals to x, `1` equals to y, `2` equals to z.
   * @param {number} value - The value to set.
   * @return {Vector3} A reference to this vector.
   */
  setComponent(e, t) {
    switch (e) {
      case 0:
        this.x = t;
        break;
      case 1:
        this.y = t;
        break;
      case 2:
        this.z = t;
        break;
      default:
        throw new Error("index is out of range: " + e);
    }
    return this;
  }
  /**
   * Returns the value of the vector component which matches the given index.
   *
   * @param {number} index - The component index. `0` equals to x, `1` equals to y, `2` equals to z.
   * @return {number} A vector component value.
   */
  getComponent(e) {
    switch (e) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      case 2:
        return this.z;
      default:
        throw new Error("index is out of range: " + e);
    }
  }
  /**
   * Returns a new vector with copied values from this instance.
   *
   * @return {Vector3} A clone of this instance.
   */
  clone() {
    return new this.constructor(this.x, this.y, this.z);
  }
  /**
   * Copies the values of the given vector to this instance.
   *
   * @param {Vector3} v - The vector to copy.
   * @return {Vector3} A reference to this vector.
   */
  copy(e) {
    return this.x = e.x, this.y = e.y, this.z = e.z, this;
  }
  /**
   * Adds the given vector to this instance.
   *
   * @param {Vector3} v - The vector to add.
   * @return {Vector3} A reference to this vector.
   */
  add(e) {
    return this.x += e.x, this.y += e.y, this.z += e.z, this;
  }
  /**
   * Adds the given scalar value to all components of this instance.
   *
   * @param {number} s - The scalar to add.
   * @return {Vector3} A reference to this vector.
   */
  addScalar(e) {
    return this.x += e, this.y += e, this.z += e, this;
  }
  /**
   * Adds the given vectors and stores the result in this instance.
   *
   * @param {Vector3} a - The first vector.
   * @param {Vector3} b - The second vector.
   * @return {Vector3} A reference to this vector.
   */
  addVectors(e, t) {
    return this.x = e.x + t.x, this.y = e.y + t.y, this.z = e.z + t.z, this;
  }
  /**
   * Adds the given vector scaled by the given factor to this instance.
   *
   * @param {Vector3|Vector4} v - The vector.
   * @param {number} s - The factor that scales `v`.
   * @return {Vector3} A reference to this vector.
   */
  addScaledVector(e, t) {
    return this.x += e.x * t, this.y += e.y * t, this.z += e.z * t, this;
  }
  /**
   * Subtracts the given vector from this instance.
   *
   * @param {Vector3} v - The vector to subtract.
   * @return {Vector3} A reference to this vector.
   */
  sub(e) {
    return this.x -= e.x, this.y -= e.y, this.z -= e.z, this;
  }
  /**
   * Subtracts the given scalar value from all components of this instance.
   *
   * @param {number} s - The scalar to subtract.
   * @return {Vector3} A reference to this vector.
   */
  subScalar(e) {
    return this.x -= e, this.y -= e, this.z -= e, this;
  }
  /**
   * Subtracts the given vectors and stores the result in this instance.
   *
   * @param {Vector3} a - The first vector.
   * @param {Vector3} b - The second vector.
   * @return {Vector3} A reference to this vector.
   */
  subVectors(e, t) {
    return this.x = e.x - t.x, this.y = e.y - t.y, this.z = e.z - t.z, this;
  }
  /**
   * Multiplies the given vector with this instance.
   *
   * @param {Vector3} v - The vector to multiply.
   * @return {Vector3} A reference to this vector.
   */
  multiply(e) {
    return this.x *= e.x, this.y *= e.y, this.z *= e.z, this;
  }
  /**
   * Multiplies the given scalar value with all components of this instance.
   *
   * @param {number} scalar - The scalar to multiply.
   * @return {Vector3} A reference to this vector.
   */
  multiplyScalar(e) {
    return this.x *= e, this.y *= e, this.z *= e, this;
  }
  /**
   * Multiplies the given vectors and stores the result in this instance.
   *
   * @param {Vector3} a - The first vector.
   * @param {Vector3} b - The second vector.
   * @return {Vector3} A reference to this vector.
   */
  multiplyVectors(e, t) {
    return this.x = e.x * t.x, this.y = e.y * t.y, this.z = e.z * t.z, this;
  }
  /**
   * Applies the given Euler rotation to this vector.
   *
   * @param {Euler} euler - The Euler angles.
   * @return {Vector3} A reference to this vector.
   */
  applyEuler(e) {
    return this.applyQuaternion(Qh.setFromEuler(e));
  }
  /**
   * Applies a rotation specified by an axis and an angle to this vector.
   *
   * @param {Vector3} axis - A normalized vector representing the rotation axis.
   * @param {number} angle - The angle in radians.
   * @return {Vector3} A reference to this vector.
   */
  applyAxisAngle(e, t) {
    return this.applyQuaternion(Qh.setFromAxisAngle(e, t));
  }
  /**
   * Multiplies this vector with the given 3x3 matrix.
   *
   * @param {Matrix3} m - The 3x3 matrix.
   * @return {Vector3} A reference to this vector.
   */
  applyMatrix3(e) {
    const t = this.x, i = this.y, n = this.z, r = e.elements;
    return this.x = r[0] * t + r[3] * i + r[6] * n, this.y = r[1] * t + r[4] * i + r[7] * n, this.z = r[2] * t + r[5] * i + r[8] * n, this;
  }
  /**
   * Multiplies this vector by the given normal matrix and normalizes
   * the result.
   *
   * @param {Matrix3} m - The normal matrix.
   * @return {Vector3} A reference to this vector.
   */
  applyNormalMatrix(e) {
    return this.applyMatrix3(e).normalize();
  }
  /**
   * Multiplies this vector (with an implicit 1 in the 4th dimension) by m, and
   * divides by perspective.
   *
   * @param {Matrix4} m - The matrix to apply.
   * @return {Vector3} A reference to this vector.
   */
  applyMatrix4(e) {
    const t = this.x, i = this.y, n = this.z, r = e.elements, a = 1 / (r[3] * t + r[7] * i + r[11] * n + r[15]);
    return this.x = (r[0] * t + r[4] * i + r[8] * n + r[12]) * a, this.y = (r[1] * t + r[5] * i + r[9] * n + r[13]) * a, this.z = (r[2] * t + r[6] * i + r[10] * n + r[14]) * a, this;
  }
  /**
   * Applies the given Quaternion to this vector.
   *
   * @param {Quaternion} q - The Quaternion.
   * @return {Vector3} A reference to this vector.
   */
  applyQuaternion(e) {
    const t = this.x, i = this.y, n = this.z, r = e.x, a = e.y, o = e.z, l = e.w, c = 2 * (a * n - o * i), h = 2 * (o * t - r * n), d = 2 * (r * i - a * t);
    return this.x = t + l * c + a * d - o * h, this.y = i + l * h + o * c - r * d, this.z = n + l * d + r * h - a * c, this;
  }
  /**
   * Projects this vector from world space into the camera's normalized
   * device coordinate (NDC) space.
   *
   * @param {Camera} camera - The camera.
   * @return {Vector3} A reference to this vector.
   */
  project(e) {
    return this.applyMatrix4(e.matrixWorldInverse).applyMatrix4(e.projectionMatrix);
  }
  /**
   * Unprojects this vector from the camera's normalized device coordinate (NDC)
   * space into world space.
   *
   * @param {Camera} camera - The camera.
   * @return {Vector3} A reference to this vector.
   */
  unproject(e) {
    return this.applyMatrix4(e.projectionMatrixInverse).applyMatrix4(e.matrixWorld);
  }
  /**
   * Transforms the direction of this vector by a matrix (the upper left 3 x 3
   * subset of the given 4x4 matrix and then normalizes the result.
   *
   * @param {Matrix4} m - The matrix.
   * @return {Vector3} A reference to this vector.
   */
  transformDirection(e) {
    const t = this.x, i = this.y, n = this.z, r = e.elements;
    return this.x = r[0] * t + r[4] * i + r[8] * n, this.y = r[1] * t + r[5] * i + r[9] * n, this.z = r[2] * t + r[6] * i + r[10] * n, this.normalize();
  }
  /**
   * Divides this instance by the given vector.
   *
   * @param {Vector3} v - The vector to divide.
   * @return {Vector3} A reference to this vector.
   */
  divide(e) {
    return this.x /= e.x, this.y /= e.y, this.z /= e.z, this;
  }
  /**
   * Divides this vector by the given scalar.
   *
   * @param {number} scalar - The scalar to divide.
   * @return {Vector3} A reference to this vector.
   */
  divideScalar(e) {
    return this.multiplyScalar(1 / e);
  }
  /**
   * If this vector's x, y or z value is greater than the given vector's x, y or z
   * value, replace that value with the corresponding min value.
   *
   * @param {Vector3} v - The vector.
   * @return {Vector3} A reference to this vector.
   */
  min(e) {
    return this.x = Math.min(this.x, e.x), this.y = Math.min(this.y, e.y), this.z = Math.min(this.z, e.z), this;
  }
  /**
   * If this vector's x, y or z value is less than the given vector's x, y or z
   * value, replace that value with the corresponding max value.
   *
   * @param {Vector3} v - The vector.
   * @return {Vector3} A reference to this vector.
   */
  max(e) {
    return this.x = Math.max(this.x, e.x), this.y = Math.max(this.y, e.y), this.z = Math.max(this.z, e.z), this;
  }
  /**
   * If this vector's x, y or z value is greater than the max vector's x, y or z
   * value, it is replaced by the corresponding value.
   * If this vector's x, y or z value is less than the min vector's x, y or z value,
   * it is replaced by the corresponding value.
   *
   * @param {Vector3} min - The minimum x, y and z values.
   * @param {Vector3} max - The maximum x, y and z values in the desired range.
   * @return {Vector3} A reference to this vector.
   */
  clamp(e, t) {
    return this.x = Xe(this.x, e.x, t.x), this.y = Xe(this.y, e.y, t.y), this.z = Xe(this.z, e.z, t.z), this;
  }
  /**
   * If this vector's x, y or z values are greater than the max value, they are
   * replaced by the max value.
   * If this vector's x, y or z values are less than the min value, they are
   * replaced by the min value.
   *
   * @param {number} minVal - The minimum value the components will be clamped to.
   * @param {number} maxVal - The maximum value the components will be clamped to.
   * @return {Vector3} A reference to this vector.
   */
  clampScalar(e, t) {
    return this.x = Xe(this.x, e, t), this.y = Xe(this.y, e, t), this.z = Xe(this.z, e, t), this;
  }
  /**
   * If this vector's length is greater than the max value, it is replaced by
   * the max value.
   * If this vector's length is less than the min value, it is replaced by the
   * min value.
   *
   * @param {number} min - The minimum value the vector length will be clamped to.
   * @param {number} max - The maximum value the vector length will be clamped to.
   * @return {Vector3} A reference to this vector.
   */
  clampLength(e, t) {
    const i = this.length();
    return this.divideScalar(i || 1).multiplyScalar(Xe(i, e, t));
  }
  /**
   * The components of this vector are rounded down to the nearest integer value.
   *
   * @return {Vector3} A reference to this vector.
   */
  floor() {
    return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this;
  }
  /**
   * The components of this vector are rounded up to the nearest integer value.
   *
   * @return {Vector3} A reference to this vector.
   */
  ceil() {
    return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this;
  }
  /**
   * The components of this vector are rounded to the nearest integer value
   *
   * @return {Vector3} A reference to this vector.
   */
  round() {
    return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this;
  }
  /**
   * The components of this vector are rounded towards zero (up if negative,
   * down if positive) to an integer value.
   *
   * @return {Vector3} A reference to this vector.
   */
  roundToZero() {
    return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this;
  }
  /**
   * Inverts this vector - i.e. sets x = -x, y = -y and z = -z.
   *
   * @return {Vector3} A reference to this vector.
   */
  negate() {
    return this.x = -this.x, this.y = -this.y, this.z = -this.z, this;
  }
  /**
   * Calculates the dot product of the given vector with this instance.
   *
   * @param {Vector3} v - The vector to compute the dot product with.
   * @return {number} The result of the dot product.
   */
  dot(e) {
    return this.x * e.x + this.y * e.y + this.z * e.z;
  }
  /**
   * Computes the square of the Euclidean length (straight-line length) from
   * (0, 0, 0) to (x, y, z). If you are comparing the lengths of vectors, you should
   * compare the length squared instead as it is slightly more efficient to calculate.
   *
   * @return {number} The square length of this vector.
   */
  lengthSq() {
    return this.x * this.x + this.y * this.y + this.z * this.z;
  }
  /**
   * Computes the  Euclidean length (straight-line length) from (0, 0, 0) to (x, y, z).
   *
   * @return {number} The length of this vector.
   */
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
  }
  /**
   * Computes the Manhattan length of this vector.
   *
   * @return {number} The length of this vector.
   */
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
  }
  /**
   * Converts this vector to a unit vector - that is, sets it equal to a vector
   * with the same direction as this one, but with a vector length of `1`.
   *
   * @return {Vector3} A reference to this vector.
   */
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  /**
   * Sets this vector to a vector with the same direction as this one, but
   * with the specified length.
   *
   * @param {number} length - The new length of this vector.
   * @return {Vector3} A reference to this vector.
   */
  setLength(e) {
    return this.normalize().multiplyScalar(e);
  }
  /**
   * Linearly interpolates between the given vector and this instance, where
   * alpha is the percent distance along the line - alpha = 0 will be this
   * vector, and alpha = 1 will be the given one.
   *
   * @param {Vector3} v - The vector to interpolate towards.
   * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
   * @return {Vector3} A reference to this vector.
   */
  lerp(e, t) {
    return this.x += (e.x - this.x) * t, this.y += (e.y - this.y) * t, this.z += (e.z - this.z) * t, this;
  }
  /**
   * Linearly interpolates between the given vectors, where alpha is the percent
   * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
   * be the second one. The result is stored in this instance.
   *
   * @param {Vector3} v1 - The first vector.
   * @param {Vector3} v2 - The second vector.
   * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
   * @return {Vector3} A reference to this vector.
   */
  lerpVectors(e, t, i) {
    return this.x = e.x + (t.x - e.x) * i, this.y = e.y + (t.y - e.y) * i, this.z = e.z + (t.z - e.z) * i, this;
  }
  /**
   * Calculates the cross product of the given vector with this instance.
   *
   * @param {Vector3} v - The vector to compute the cross product with.
   * @return {Vector3} The result of the cross product.
   */
  cross(e) {
    return this.crossVectors(this, e);
  }
  /**
   * Calculates the cross product of the given vectors and stores the result
   * in this instance.
   *
   * @param {Vector3} a - The first vector.
   * @param {Vector3} b - The second vector.
   * @return {Vector3} A reference to this vector.
   */
  crossVectors(e, t) {
    const i = e.x, n = e.y, r = e.z, a = t.x, o = t.y, l = t.z;
    return this.x = n * l - r * o, this.y = r * a - i * l, this.z = i * o - n * a, this;
  }
  /**
   * Projects this vector onto the given one.
   *
   * @param {Vector3} v - The vector to project to.
   * @return {Vector3} A reference to this vector.
   */
  projectOnVector(e) {
    const t = e.lengthSq();
    if (t === 0) return this.set(0, 0, 0);
    const i = e.dot(this) / t;
    return this.copy(e).multiplyScalar(i);
  }
  /**
   * Projects this vector onto a plane by subtracting this
   * vector projected onto the plane's normal from this vector.
   *
   * @param {Vector3} planeNormal - The plane normal.
   * @return {Vector3} A reference to this vector.
   */
  projectOnPlane(e) {
    return So.copy(this).projectOnVector(e), this.sub(So);
  }
  /**
   * Reflects this vector off a plane orthogonal to the given normal vector.
   *
   * @param {Vector3} normal - The (normalized) normal vector.
   * @return {Vector3} A reference to this vector.
   */
  reflect(e) {
    return this.sub(So.copy(e).multiplyScalar(2 * this.dot(e)));
  }
  /**
   * Returns the angle between the given vector and this instance in radians.
   *
   * @param {Vector3} v - The vector to compute the angle with.
   * @return {number} The angle in radians.
   */
  angleTo(e) {
    const t = Math.sqrt(this.lengthSq() * e.lengthSq());
    if (t === 0) return Math.PI / 2;
    const i = this.dot(e) / t;
    return Math.acos(Xe(i, -1, 1));
  }
  /**
   * Computes the distance from the given vector to this instance.
   *
   * @param {Vector3} v - The vector to compute the distance to.
   * @return {number} The distance.
   */
  distanceTo(e) {
    return Math.sqrt(this.distanceToSquared(e));
  }
  /**
   * Computes the squared distance from the given vector to this instance.
   * If you are just comparing the distance with another distance, you should compare
   * the distance squared instead as it is slightly more efficient to calculate.
   *
   * @param {Vector3} v - The vector to compute the squared distance to.
   * @return {number} The squared distance.
   */
  distanceToSquared(e) {
    const t = this.x - e.x, i = this.y - e.y, n = this.z - e.z;
    return t * t + i * i + n * n;
  }
  /**
   * Computes the Manhattan distance from the given vector to this instance.
   *
   * @param {Vector3} v - The vector to compute the Manhattan distance to.
   * @return {number} The Manhattan distance.
   */
  manhattanDistanceTo(e) {
    return Math.abs(this.x - e.x) + Math.abs(this.y - e.y) + Math.abs(this.z - e.z);
  }
  /**
   * Sets the vector components from the given spherical coordinates.
   *
   * @param {Spherical} s - The spherical coordinates.
   * @return {Vector3} A reference to this vector.
   */
  setFromSpherical(e) {
    return this.setFromSphericalCoords(e.radius, e.phi, e.theta);
  }
  /**
   * Sets the vector components from the given spherical coordinates.
   *
   * @param {number} radius - The radius.
   * @param {number} phi - The phi angle in radians.
   * @param {number} theta - The theta angle in radians.
   * @return {Vector3} A reference to this vector.
   */
  setFromSphericalCoords(e, t, i) {
    const n = Math.sin(t) * e;
    return this.x = n * Math.sin(i), this.y = Math.cos(t) * e, this.z = n * Math.cos(i), this;
  }
  /**
   * Sets the vector components from the given cylindrical coordinates.
   *
   * @param {Cylindrical} c - The cylindrical coordinates.
   * @return {Vector3} A reference to this vector.
   */
  setFromCylindrical(e) {
    return this.setFromCylindricalCoords(e.radius, e.theta, e.y);
  }
  /**
   * Sets the vector components from the given cylindrical coordinates.
   *
   * @param {number} radius - The radius.
   * @param {number} theta - The theta angle in radians.
   * @param {number} y - The y value.
   * @return {Vector3} A reference to this vector.
   */
  setFromCylindricalCoords(e, t, i) {
    return this.x = e * Math.sin(t), this.y = i, this.z = e * Math.cos(t), this;
  }
  /**
   * Sets the vector components to the position elements of the
   * given transformation matrix.
   *
   * @param {Matrix4} m - The 4x4 matrix.
   * @return {Vector3} A reference to this vector.
   */
  setFromMatrixPosition(e) {
    const t = e.elements;
    return this.x = t[12], this.y = t[13], this.z = t[14], this;
  }
  /**
   * Sets the vector components to the scale elements of the
   * given transformation matrix.
   *
   * @param {Matrix4} m - The 4x4 matrix.
   * @return {Vector3} A reference to this vector.
   */
  setFromMatrixScale(e) {
    const t = this.setFromMatrixColumn(e, 0).length(), i = this.setFromMatrixColumn(e, 1).length(), n = this.setFromMatrixColumn(e, 2).length();
    return this.x = t, this.y = i, this.z = n, this;
  }
  /**
   * Sets the vector components from the specified matrix column.
   *
   * @param {Matrix4} m - The 4x4 matrix.
   * @param {number} index - The column index.
   * @return {Vector3} A reference to this vector.
   */
  setFromMatrixColumn(e, t) {
    return this.fromArray(e.elements, t * 4);
  }
  /**
   * Sets the vector components from the specified matrix column.
   *
   * @param {Matrix3} m - The 3x3 matrix.
   * @param {number} index - The column index.
   * @return {Vector3} A reference to this vector.
   */
  setFromMatrix3Column(e, t) {
    return this.fromArray(e.elements, t * 3);
  }
  /**
   * Sets the vector components from the given Euler angles.
   *
   * @param {Euler} e - The Euler angles to set.
   * @return {Vector3} A reference to this vector.
   */
  setFromEuler(e) {
    return this.x = e._x, this.y = e._y, this.z = e._z, this;
  }
  /**
   * Sets the vector components from the RGB components of the
   * given color.
   *
   * @param {Color} c - The color to set.
   * @return {Vector3} A reference to this vector.
   */
  setFromColor(e) {
    return this.x = e.r, this.y = e.g, this.z = e.b, this;
  }
  /**
   * Returns `true` if this vector is equal with the given one.
   *
   * @param {Vector3} v - The vector to test for equality.
   * @return {boolean} Whether this vector is equal with the given one.
   */
  equals(e) {
    return e.x === this.x && e.y === this.y && e.z === this.z;
  }
  /**
   * Sets this vector's x value to be `array[ offset ]`, y value to be `array[ offset + 1 ]`
   * and z value to be `array[ offset + 2 ]`.
   *
   * @param {Array<number>} array - An array holding the vector component values.
   * @param {number} [offset=0] - The offset into the array.
   * @return {Vector3} A reference to this vector.
   */
  fromArray(e, t = 0) {
    return this.x = e[t], this.y = e[t + 1], this.z = e[t + 2], this;
  }
  /**
   * Writes the components of this vector to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the vector components.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The vector components.
   */
  toArray(e = [], t = 0) {
    return e[t] = this.x, e[t + 1] = this.y, e[t + 2] = this.z, e;
  }
  /**
   * Sets the components of this vector from the given buffer attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
   * @param {number} index - The index into the attribute.
   * @return {Vector3} A reference to this vector.
   */
  fromBufferAttribute(e, t) {
    return this.x = e.getX(t), this.y = e.getY(t), this.z = e.getZ(t), this;
  }
  /**
   * Sets each component of this vector to a pseudo-random value between `0` and
   * `1`, excluding `1`.
   *
   * @return {Vector3} A reference to this vector.
   */
  random() {
    return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this;
  }
  /**
   * Sets this vector to a uniformly random point on a unit sphere.
   *
   * @return {Vector3} A reference to this vector.
   */
  randomDirection() {
    const e = Math.random() * Math.PI * 2, t = Math.random() * 2 - 1, i = Math.sqrt(1 - t * t);
    return this.x = i * Math.cos(e), this.y = t, this.z = i * Math.sin(e), this;
  }
  *[Symbol.iterator]() {
    yield this.x, yield this.y, yield this.z;
  }
}
const So = /* @__PURE__ */ new O(), Qh = /* @__PURE__ */ new si();
class Be {
  /**
   * Constructs a new 3x3 matrix. The arguments are supposed to be
   * in row-major order. If no arguments are provided, the constructor
   * initializes the matrix as an identity matrix.
   *
   * @param {number} [n11] - 1-1 matrix element.
   * @param {number} [n12] - 1-2 matrix element.
   * @param {number} [n13] - 1-3 matrix element.
   * @param {number} [n21] - 2-1 matrix element.
   * @param {number} [n22] - 2-2 matrix element.
   * @param {number} [n23] - 2-3 matrix element.
   * @param {number} [n31] - 3-1 matrix element.
   * @param {number} [n32] - 3-2 matrix element.
   * @param {number} [n33] - 3-3 matrix element.
   */
  constructor(e, t, i, n, r, a, o, l, c) {
    Be.prototype.isMatrix3 = !0, this.elements = [
      1,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      1
    ], e !== void 0 && this.set(e, t, i, n, r, a, o, l, c);
  }
  /**
   * Sets the elements of the matrix.The arguments are supposed to be
   * in row-major order.
   *
   * @param {number} [n11] - 1-1 matrix element.
   * @param {number} [n12] - 1-2 matrix element.
   * @param {number} [n13] - 1-3 matrix element.
   * @param {number} [n21] - 2-1 matrix element.
   * @param {number} [n22] - 2-2 matrix element.
   * @param {number} [n23] - 2-3 matrix element.
   * @param {number} [n31] - 3-1 matrix element.
   * @param {number} [n32] - 3-2 matrix element.
   * @param {number} [n33] - 3-3 matrix element.
   * @return {Matrix3} A reference to this matrix.
   */
  set(e, t, i, n, r, a, o, l, c) {
    const h = this.elements;
    return h[0] = e, h[1] = n, h[2] = o, h[3] = t, h[4] = r, h[5] = l, h[6] = i, h[7] = a, h[8] = c, this;
  }
  /**
   * Sets this matrix to the 3x3 identity matrix.
   *
   * @return {Matrix3} A reference to this matrix.
   */
  identity() {
    return this.set(
      1,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Copies the values of the given matrix to this instance.
   *
   * @param {Matrix3} m - The matrix to copy.
   * @return {Matrix3} A reference to this matrix.
   */
  copy(e) {
    const t = this.elements, i = e.elements;
    return t[0] = i[0], t[1] = i[1], t[2] = i[2], t[3] = i[3], t[4] = i[4], t[5] = i[5], t[6] = i[6], t[7] = i[7], t[8] = i[8], this;
  }
  /**
   * Extracts the basis of this matrix into the three axis vectors provided.
   *
   * @param {Vector3} xAxis - The basis's x axis.
   * @param {Vector3} yAxis - The basis's y axis.
   * @param {Vector3} zAxis - The basis's z axis.
   * @return {Matrix3} A reference to this matrix.
   */
  extractBasis(e, t, i) {
    return e.setFromMatrix3Column(this, 0), t.setFromMatrix3Column(this, 1), i.setFromMatrix3Column(this, 2), this;
  }
  /**
   * Set this matrix to the upper 3x3 matrix of the given 4x4 matrix.
   *
   * @param {Matrix4} m - The 4x4 matrix.
   * @return {Matrix3} A reference to this matrix.
   */
  setFromMatrix4(e) {
    const t = e.elements;
    return this.set(
      t[0],
      t[4],
      t[8],
      t[1],
      t[5],
      t[9],
      t[2],
      t[6],
      t[10]
    ), this;
  }
  /**
   * Post-multiplies this matrix by the given 3x3 matrix.
   *
   * @param {Matrix3} m - The matrix to multiply with.
   * @return {Matrix3} A reference to this matrix.
   */
  multiply(e) {
    return this.multiplyMatrices(this, e);
  }
  /**
   * Pre-multiplies this matrix by the given 3x3 matrix.
   *
   * @param {Matrix3} m - The matrix to multiply with.
   * @return {Matrix3} A reference to this matrix.
   */
  premultiply(e) {
    return this.multiplyMatrices(e, this);
  }
  /**
   * Multiples the given 3x3 matrices and stores the result
   * in this matrix.
   *
   * @param {Matrix3} a - The first matrix.
   * @param {Matrix3} b - The second matrix.
   * @return {Matrix3} A reference to this matrix.
   */
  multiplyMatrices(e, t) {
    const i = e.elements, n = t.elements, r = this.elements, a = i[0], o = i[3], l = i[6], c = i[1], h = i[4], d = i[7], u = i[2], f = i[5], g = i[8], v = n[0], m = n[3], p = n[6], w = n[1], M = n[4], T = n[7], E = n[2], A = n[5], R = n[8];
    return r[0] = a * v + o * w + l * E, r[3] = a * m + o * M + l * A, r[6] = a * p + o * T + l * R, r[1] = c * v + h * w + d * E, r[4] = c * m + h * M + d * A, r[7] = c * p + h * T + d * R, r[2] = u * v + f * w + g * E, r[5] = u * m + f * M + g * A, r[8] = u * p + f * T + g * R, this;
  }
  /**
   * Multiplies every component of the matrix by the given scalar.
   *
   * @param {number} s - The scalar.
   * @return {Matrix3} A reference to this matrix.
   */
  multiplyScalar(e) {
    const t = this.elements;
    return t[0] *= e, t[3] *= e, t[6] *= e, t[1] *= e, t[4] *= e, t[7] *= e, t[2] *= e, t[5] *= e, t[8] *= e, this;
  }
  /**
   * Computes and returns the determinant of this matrix.
   *
   * @return {number} The determinant.
   */
  determinant() {
    const e = this.elements, t = e[0], i = e[1], n = e[2], r = e[3], a = e[4], o = e[5], l = e[6], c = e[7], h = e[8];
    return t * a * h - t * o * c - i * r * h + i * o * l + n * r * c - n * a * l;
  }
  /**
   * Inverts this matrix, using the [analytic method](https://en.wikipedia.org/wiki/Invertible_matrix#Analytic_solution).
   * You can not invert with a determinant of zero. If you attempt this, the method produces
   * a zero matrix instead.
   *
   * @return {Matrix3} A reference to this matrix.
   */
  invert() {
    const e = this.elements, t = e[0], i = e[1], n = e[2], r = e[3], a = e[4], o = e[5], l = e[6], c = e[7], h = e[8], d = h * a - o * c, u = o * l - h * r, f = c * r - a * l, g = t * d + i * u + n * f;
    if (g === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
    const v = 1 / g;
    return e[0] = d * v, e[1] = (n * c - h * i) * v, e[2] = (o * i - n * a) * v, e[3] = u * v, e[4] = (h * t - n * l) * v, e[5] = (n * r - o * t) * v, e[6] = f * v, e[7] = (i * l - c * t) * v, e[8] = (a * t - i * r) * v, this;
  }
  /**
   * Transposes this matrix in place.
   *
   * @return {Matrix3} A reference to this matrix.
   */
  transpose() {
    let e;
    const t = this.elements;
    return e = t[1], t[1] = t[3], t[3] = e, e = t[2], t[2] = t[6], t[6] = e, e = t[5], t[5] = t[7], t[7] = e, this;
  }
  /**
   * Computes the normal matrix which is the inverse transpose of the upper
   * left 3x3 portion of the given 4x4 matrix.
   *
   * @param {Matrix4} matrix4 - The 4x4 matrix.
   * @return {Matrix3} A reference to this matrix.
   */
  getNormalMatrix(e) {
    return this.setFromMatrix4(e).invert().transpose();
  }
  /**
   * Transposes this matrix into the supplied array, and returns itself unchanged.
   *
   * @param {Array<number>} r - An array to store the transposed matrix elements.
   * @return {Matrix3} A reference to this matrix.
   */
  transposeIntoArray(e) {
    const t = this.elements;
    return e[0] = t[0], e[1] = t[3], e[2] = t[6], e[3] = t[1], e[4] = t[4], e[5] = t[7], e[6] = t[2], e[7] = t[5], e[8] = t[8], this;
  }
  /**
   * Sets the UV transform matrix from offset, repeat, rotation, and center.
   *
   * @param {number} tx - Offset x.
   * @param {number} ty - Offset y.
   * @param {number} sx - Repeat x.
   * @param {number} sy - Repeat y.
   * @param {number} rotation - Rotation, in radians. Positive values rotate counterclockwise.
   * @param {number} cx - Center x of rotation.
   * @param {number} cy - Center y of rotation
   * @return {Matrix3} A reference to this matrix.
   */
  setUvTransform(e, t, i, n, r, a, o) {
    const l = Math.cos(r), c = Math.sin(r);
    return this.set(
      i * l,
      i * c,
      -i * (l * a + c * o) + a + e,
      -n * c,
      n * l,
      -n * (-c * a + l * o) + o + t,
      0,
      0,
      1
    ), this;
  }
  /**
   * Scales this matrix with the given scalar values.
   *
   * @param {number} sx - The amount to scale in the X axis.
   * @param {number} sy - The amount to scale in the Y axis.
   * @return {Matrix3} A reference to this matrix.
   */
  scale(e, t) {
    return this.premultiply(Mo.makeScale(e, t)), this;
  }
  /**
   * Rotates this matrix by the given angle.
   *
   * @param {number} theta - The rotation in radians.
   * @return {Matrix3} A reference to this matrix.
   */
  rotate(e) {
    return this.premultiply(Mo.makeRotation(-e)), this;
  }
  /**
   * Translates this matrix by the given scalar values.
   *
   * @param {number} tx - The amount to translate in the X axis.
   * @param {number} ty - The amount to translate in the Y axis.
   * @return {Matrix3} A reference to this matrix.
   */
  translate(e, t) {
    return this.premultiply(Mo.makeTranslation(e, t)), this;
  }
  // for 2D Transforms
  /**
   * Sets this matrix as a 2D translation transform.
   *
   * @param {number|Vector2} x - The amount to translate in the X axis or alternatively a translation vector.
   * @param {number} y - The amount to translate in the Y axis.
   * @return {Matrix3} A reference to this matrix.
   */
  makeTranslation(e, t) {
    return e.isVector2 ? this.set(
      1,
      0,
      e.x,
      0,
      1,
      e.y,
      0,
      0,
      1
    ) : this.set(
      1,
      0,
      e,
      0,
      1,
      t,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix as a 2D rotational transformation.
   *
   * @param {number} theta - The rotation in radians.
   * @return {Matrix3} A reference to this matrix.
   */
  makeRotation(e) {
    const t = Math.cos(e), i = Math.sin(e);
    return this.set(
      t,
      -i,
      0,
      i,
      t,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix as a 2D scale transform.
   *
   * @param {number} x - The amount to scale in the X axis.
   * @param {number} y - The amount to scale in the Y axis.
   * @return {Matrix3} A reference to this matrix.
   */
  makeScale(e, t) {
    return this.set(
      e,
      0,
      0,
      0,
      t,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Returns `true` if this matrix is equal with the given one.
   *
   * @param {Matrix3} matrix - The matrix to test for equality.
   * @return {boolean} Whether this matrix is equal with the given one.
   */
  equals(e) {
    const t = this.elements, i = e.elements;
    for (let n = 0; n < 9; n++)
      if (t[n] !== i[n]) return !1;
    return !0;
  }
  /**
   * Sets the elements of the matrix from the given array.
   *
   * @param {Array<number>} array - The matrix elements in column-major order.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Matrix3} A reference to this matrix.
   */
  fromArray(e, t = 0) {
    for (let i = 0; i < 9; i++)
      this.elements[i] = e[i + t];
    return this;
  }
  /**
   * Writes the elements of this matrix to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the matrix elements in column-major order.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The matrix elements in column-major order.
   */
  toArray(e = [], t = 0) {
    const i = this.elements;
    return e[t] = i[0], e[t + 1] = i[1], e[t + 2] = i[2], e[t + 3] = i[3], e[t + 4] = i[4], e[t + 5] = i[5], e[t + 6] = i[6], e[t + 7] = i[7], e[t + 8] = i[8], e;
  }
  /**
   * Returns a matrix with copied values from this instance.
   *
   * @return {Matrix3} A clone of this instance.
   */
  clone() {
    return new this.constructor().fromArray(this.elements);
  }
}
const Mo = /* @__PURE__ */ new Be(), ed = /* @__PURE__ */ new Be().set(
  0.4123908,
  0.3575843,
  0.1804808,
  0.212639,
  0.7151687,
  0.0721923,
  0.0193308,
  0.1191948,
  0.9505322
), td = /* @__PURE__ */ new Be().set(
  3.2409699,
  -1.5373832,
  -0.4986108,
  -0.9692436,
  1.8759675,
  0.0415551,
  0.0556301,
  -0.203977,
  1.0569715
);
function Vv() {
  const s = {
    enabled: !0,
    workingColorSpace: Wt,
    /**
     * Implementations of supported color spaces.
     *
     * Required:
     *	- primaries: chromaticity coordinates [ rx ry gx gy bx by ]
     *	- whitePoint: reference white [ x y ]
     *	- transfer: transfer function (pre-defined)
     *	- toXYZ: Matrix3 RGB to XYZ transform
     *	- fromXYZ: Matrix3 XYZ to RGB transform
     *	- luminanceCoefficients: RGB luminance coefficients
     *
     * Optional:
     *  - outputColorSpaceConfig: { drawingBufferColorSpace: ColorSpace, toneMappingMode: 'extended' | 'standard' }
     *  - workingColorSpaceConfig: { unpackColorSpace: ColorSpace }
     *
     * Reference:
     * - https://www.russellcottrell.com/photo/matrixCalculator.htm
     */
    spaces: {},
    convert: function(n, r, a) {
      return this.enabled === !1 || r === a || !r || !a || (this.spaces[r].transfer === lt && (n.r = on(n.r), n.g = on(n.g), n.b = on(n.b)), this.spaces[r].primaries !== this.spaces[a].primaries && (n.applyMatrix3(this.spaces[r].toXYZ), n.applyMatrix3(this.spaces[a].fromXYZ)), this.spaces[a].transfer === lt && (n.r = Es(n.r), n.g = Es(n.g), n.b = Es(n.b))), n;
    },
    workingToColorSpace: function(n, r) {
      return this.convert(n, this.workingColorSpace, r);
    },
    colorSpaceToWorking: function(n, r) {
      return this.convert(n, r, this.workingColorSpace);
    },
    getPrimaries: function(n) {
      return this.spaces[n].primaries;
    },
    getTransfer: function(n) {
      return n === Sn ? Ga : this.spaces[n].transfer;
    },
    getToneMappingMode: function(n) {
      return this.spaces[n].outputColorSpaceConfig.toneMappingMode || "standard";
    },
    getLuminanceCoefficients: function(n, r = this.workingColorSpace) {
      return n.fromArray(this.spaces[r].luminanceCoefficients);
    },
    define: function(n) {
      Object.assign(this.spaces, n);
    },
    // Internal APIs
    _getMatrix: function(n, r, a) {
      return n.copy(this.spaces[r].toXYZ).multiply(this.spaces[a].fromXYZ);
    },
    _getDrawingBufferColorSpace: function(n) {
      return this.spaces[n].outputColorSpaceConfig.drawingBufferColorSpace;
    },
    _getUnpackColorSpace: function(n = this.workingColorSpace) {
      return this.spaces[n].workingColorSpaceConfig.unpackColorSpace;
    },
    // Deprecated
    fromWorkingColorSpace: function(n, r) {
      return Cr("ColorManagement: .fromWorkingColorSpace() has been renamed to .workingToColorSpace()."), s.workingToColorSpace(n, r);
    },
    toWorkingColorSpace: function(n, r) {
      return Cr("ColorManagement: .toWorkingColorSpace() has been renamed to .colorSpaceToWorking()."), s.colorSpaceToWorking(n, r);
    }
  }, e = [0.64, 0.33, 0.3, 0.6, 0.15, 0.06], t = [0.2126, 0.7152, 0.0722], i = [0.3127, 0.329];
  return s.define({
    [Wt]: {
      primaries: e,
      whitePoint: i,
      transfer: Ga,
      toXYZ: ed,
      fromXYZ: td,
      luminanceCoefficients: t,
      workingColorSpaceConfig: { unpackColorSpace: Ct },
      outputColorSpaceConfig: { drawingBufferColorSpace: Ct }
    },
    [Ct]: {
      primaries: e,
      whitePoint: i,
      transfer: lt,
      toXYZ: ed,
      fromXYZ: td,
      luminanceCoefficients: t,
      outputColorSpaceConfig: { drawingBufferColorSpace: Ct }
    }
  }), s;
}
const Ke = /* @__PURE__ */ Vv();
function on(s) {
  return s < 0.04045 ? s * 0.0773993808 : Math.pow(s * 0.9478672986 + 0.0521327014, 2.4);
}
function Es(s) {
  return s < 31308e-7 ? s * 12.92 : 1.055 * Math.pow(s, 0.41666) - 0.055;
}
let ls;
class Hv {
  /**
   * Returns a data URI containing a representation of the given image.
   *
   * @param {(HTMLImageElement|HTMLCanvasElement)} image - The image object.
   * @param {string} [type='image/png'] - Indicates the image format.
   * @return {string} The data URI.
   */
  static getDataURL(e, t = "image/png") {
    if (/^data:/i.test(e.src) || typeof HTMLCanvasElement > "u")
      return e.src;
    let i;
    if (e instanceof HTMLCanvasElement)
      i = e;
    else {
      ls === void 0 && (ls = Rr("canvas")), ls.width = e.width, ls.height = e.height;
      const n = ls.getContext("2d");
      e instanceof ImageData ? n.putImageData(e, 0, 0) : n.drawImage(e, 0, 0, e.width, e.height), i = ls;
    }
    return i.toDataURL(t);
  }
  /**
   * Converts the given sRGB image data to linear color space.
   *
   * @param {(HTMLImageElement|HTMLCanvasElement|ImageBitmap|Object)} image - The image object.
   * @return {HTMLCanvasElement|Object} The converted image.
   */
  static sRGBToLinear(e) {
    if (typeof HTMLImageElement < "u" && e instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && e instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && e instanceof ImageBitmap) {
      const t = Rr("canvas");
      t.width = e.width, t.height = e.height;
      const i = t.getContext("2d");
      i.drawImage(e, 0, 0, e.width, e.height);
      const n = i.getImageData(0, 0, e.width, e.height), r = n.data;
      for (let a = 0; a < r.length; a++)
        r[a] = on(r[a] / 255) * 255;
      return i.putImageData(n, 0, 0), t;
    } else if (e.data) {
      const t = e.data.slice(0);
      for (let i = 0; i < t.length; i++)
        t instanceof Uint8Array || t instanceof Uint8ClampedArray ? t[i] = Math.floor(on(t[i] / 255) * 255) : t[i] = on(t[i]);
      return {
        data: t,
        width: e.width,
        height: e.height
      };
    } else
      return Te("ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied."), e;
  }
}
let $v = 0;
class Zc {
  /**
   * Constructs a new video texture.
   *
   * @param {any} [data=null] - The data definition of a texture.
   */
  constructor(e = null) {
    this.isSource = !0, Object.defineProperty(this, "id", { value: $v++ }), this.uuid = Ei(), this.data = e, this.dataReady = !0, this.version = 0;
  }
  /**
   * Returns the dimensions of the source into the given target vector.
   *
   * @param {(Vector2|Vector3)} target - The target object the result is written into.
   * @return {(Vector2|Vector3)} The dimensions of the source.
   */
  getSize(e) {
    const t = this.data;
    return typeof HTMLVideoElement < "u" && t instanceof HTMLVideoElement ? e.set(t.videoWidth, t.videoHeight, 0) : typeof VideoFrame < "u" && t instanceof VideoFrame ? e.set(t.displayHeight, t.displayWidth, 0) : t !== null ? e.set(t.width, t.height, t.depth || 0) : e.set(0, 0, 0), e;
  }
  /**
   * When the property is set to `true`, the engine allocates the memory
   * for the texture (if necessary) and triggers the actual texture upload
   * to the GPU next time the source is used.
   *
   * @type {boolean}
   * @default false
   * @param {boolean} value
   */
  set needsUpdate(e) {
    e === !0 && this.version++;
  }
  /**
   * Serializes the source into JSON.
   *
   * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
   * @return {Object} A JSON object representing the serialized source.
   * @see {@link ObjectLoader#parse}
   */
  toJSON(e) {
    const t = e === void 0 || typeof e == "string";
    if (!t && e.images[this.uuid] !== void 0)
      return e.images[this.uuid];
    const i = {
      uuid: this.uuid,
      url: ""
    }, n = this.data;
    if (n !== null) {
      let r;
      if (Array.isArray(n)) {
        r = [];
        for (let a = 0, o = n.length; a < o; a++)
          n[a].isDataTexture ? r.push(To(n[a].image)) : r.push(To(n[a]));
      } else
        r = To(n);
      i.url = r;
    }
    return t || (e.images[this.uuid] = i), i;
  }
}
function To(s) {
  return typeof HTMLImageElement < "u" && s instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && s instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && s instanceof ImageBitmap ? Hv.getDataURL(s) : s.data ? {
    data: Array.from(s.data),
    width: s.width,
    height: s.height,
    type: s.data.constructor.name
  } : (Te("Texture: Unable to serialize Texture."), {});
}
let Gv = 0;
const Eo = /* @__PURE__ */ new O();
class Ot extends ss {
  /**
   * Constructs a new texture.
   *
   * @param {?Object} [image=Texture.DEFAULT_IMAGE] - The image holding the texture data.
   * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
   * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
   * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
   * @param {number} [magFilter=LinearFilter] - The mag filter value.
   * @param {number} [minFilter=LinearMipmapLinearFilter] - The min filter value.
   * @param {number} [format=RGBAFormat] - The texture format.
   * @param {number} [type=UnsignedByteType] - The texture type.
   * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
   * @param {string} [colorSpace=NoColorSpace] - The color space.
   */
  constructor(e = Ot.DEFAULT_IMAGE, t = Ot.DEFAULT_MAPPING, i = Fi, n = Fi, r = bt, a = nn, o = mi, l = ii, c = Ot.DEFAULT_ANISOTROPY, h = Sn) {
    super(), this.isTexture = !0, Object.defineProperty(this, "id", { value: Gv++ }), this.uuid = Ei(), this.name = "", this.source = new Zc(e), this.mipmaps = [], this.mapping = t, this.channel = 0, this.wrapS = i, this.wrapT = n, this.magFilter = r, this.minFilter = a, this.anisotropy = c, this.format = o, this.internalFormat = null, this.type = l, this.offset = new Ye(0, 0), this.repeat = new Ye(1, 1), this.center = new Ye(0, 0), this.rotation = 0, this.matrixAutoUpdate = !0, this.matrix = new Be(), this.generateMipmaps = !0, this.premultiplyAlpha = !1, this.flipY = !0, this.unpackAlignment = 4, this.colorSpace = h, this.userData = {}, this.updateRanges = [], this.version = 0, this.onUpdate = null, this.renderTarget = null, this.isRenderTargetTexture = !1, this.isArrayTexture = !!(e && e.depth && e.depth > 1), this.pmremVersion = 0;
  }
  /**
   * The width of the texture in pixels.
   */
  get width() {
    return this.source.getSize(Eo).x;
  }
  /**
   * The height of the texture in pixels.
   */
  get height() {
    return this.source.getSize(Eo).y;
  }
  /**
   * The depth of the texture in pixels.
   */
  get depth() {
    return this.source.getSize(Eo).z;
  }
  /**
   * The image object holding the texture data.
   *
   * @type {?Object}
   */
  get image() {
    return this.source.data;
  }
  set image(e = null) {
    this.source.data = e;
  }
  /**
   * Updates the texture transformation matrix from the from the properties {@link Texture#offset},
   * {@link Texture#repeat}, {@link Texture#rotation}, and {@link Texture#center}.
   */
  updateMatrix() {
    this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
  }
  /**
   * Adds a range of data in the data texture to be updated on the GPU.
   *
   * @param {number} start - Position at which to start update.
   * @param {number} count - The number of components to update.
   */
  addUpdateRange(e, t) {
    this.updateRanges.push({ start: e, count: t });
  }
  /**
   * Clears the update ranges.
   */
  clearUpdateRanges() {
    this.updateRanges.length = 0;
  }
  /**
   * Returns a new texture with copied values from this instance.
   *
   * @return {Texture} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
  /**
   * Copies the values of the given texture to this instance.
   *
   * @param {Texture} source - The texture to copy.
   * @return {Texture} A reference to this instance.
   */
  copy(e) {
    return this.name = e.name, this.source = e.source, this.mipmaps = e.mipmaps.slice(0), this.mapping = e.mapping, this.channel = e.channel, this.wrapS = e.wrapS, this.wrapT = e.wrapT, this.magFilter = e.magFilter, this.minFilter = e.minFilter, this.anisotropy = e.anisotropy, this.format = e.format, this.internalFormat = e.internalFormat, this.type = e.type, this.offset.copy(e.offset), this.repeat.copy(e.repeat), this.center.copy(e.center), this.rotation = e.rotation, this.matrixAutoUpdate = e.matrixAutoUpdate, this.matrix.copy(e.matrix), this.generateMipmaps = e.generateMipmaps, this.premultiplyAlpha = e.premultiplyAlpha, this.flipY = e.flipY, this.unpackAlignment = e.unpackAlignment, this.colorSpace = e.colorSpace, this.renderTarget = e.renderTarget, this.isRenderTargetTexture = e.isRenderTargetTexture, this.isArrayTexture = e.isArrayTexture, this.userData = JSON.parse(JSON.stringify(e.userData)), this.needsUpdate = !0, this;
  }
  /**
   * Sets this texture's properties based on `values`.
   * @param {Object} values - A container with texture parameters.
   */
  setValues(e) {
    for (const t in e) {
      const i = e[t];
      if (i === void 0) {
        Te(`Texture.setValues(): parameter '${t}' has value of undefined.`);
        continue;
      }
      const n = this[t];
      if (n === void 0) {
        Te(`Texture.setValues(): property '${t}' does not exist.`);
        continue;
      }
      n && i && n.isVector2 && i.isVector2 || n && i && n.isVector3 && i.isVector3 || n && i && n.isMatrix3 && i.isMatrix3 ? n.copy(i) : this[t] = i;
    }
  }
  /**
   * Serializes the texture into JSON.
   *
   * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
   * @return {Object} A JSON object representing the serialized texture.
   * @see {@link ObjectLoader#parse}
   */
  toJSON(e) {
    const t = e === void 0 || typeof e == "string";
    if (!t && e.textures[this.uuid] !== void 0)
      return e.textures[this.uuid];
    const i = {
      metadata: {
        version: 4.7,
        type: "Texture",
        generator: "Texture.toJSON"
      },
      uuid: this.uuid,
      name: this.name,
      image: this.source.toJSON(e).uuid,
      mapping: this.mapping,
      channel: this.channel,
      repeat: [this.repeat.x, this.repeat.y],
      offset: [this.offset.x, this.offset.y],
      center: [this.center.x, this.center.y],
      rotation: this.rotation,
      wrap: [this.wrapS, this.wrapT],
      format: this.format,
      internalFormat: this.internalFormat,
      type: this.type,
      colorSpace: this.colorSpace,
      minFilter: this.minFilter,
      magFilter: this.magFilter,
      anisotropy: this.anisotropy,
      flipY: this.flipY,
      generateMipmaps: this.generateMipmaps,
      premultiplyAlpha: this.premultiplyAlpha,
      unpackAlignment: this.unpackAlignment
    };
    return Object.keys(this.userData).length > 0 && (i.userData = this.userData), t || (e.textures[this.uuid] = i), i;
  }
  /**
   * Frees the GPU-related resources allocated by this instance. Call this
   * method whenever this instance is no longer used in your app.
   *
   * @fires Texture#dispose
   */
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
  /**
   * Transforms the given uv vector with the textures uv transformation matrix.
   *
   * @param {Vector2} uv - The uv vector.
   * @return {Vector2} The transformed uv vector.
   */
  transformUv(e) {
    if (this.mapping !== Vu) return e;
    if (e.applyMatrix3(this.matrix), e.x < 0 || e.x > 1)
      switch (this.wrapS) {
        case Us:
          e.x = e.x - Math.floor(e.x);
          break;
        case Fi:
          e.x = e.x < 0 ? 0 : 1;
          break;
        case Ha:
          Math.abs(Math.floor(e.x) % 2) === 1 ? e.x = Math.ceil(e.x) - e.x : e.x = e.x - Math.floor(e.x);
          break;
      }
    if (e.y < 0 || e.y > 1)
      switch (this.wrapT) {
        case Us:
          e.y = e.y - Math.floor(e.y);
          break;
        case Fi:
          e.y = e.y < 0 ? 0 : 1;
          break;
        case Ha:
          Math.abs(Math.floor(e.y) % 2) === 1 ? e.y = Math.ceil(e.y) - e.y : e.y = e.y - Math.floor(e.y);
          break;
      }
    return this.flipY && (e.y = 1 - e.y), e;
  }
  /**
   * Setting this property to `true` indicates the engine the texture
   * must be updated in the next render. This triggers a texture upload
   * to the GPU and ensures correct texture parameter configuration.
   *
   * @type {boolean}
   * @default false
   * @param {boolean} value
   */
  set needsUpdate(e) {
    e === !0 && (this.version++, this.source.needsUpdate = !0);
  }
  /**
   * Setting this property to `true` indicates the engine the PMREM
   * must be regenerated.
   *
   * @type {boolean}
   * @default false
   * @param {boolean} value
   */
  set needsPMREMUpdate(e) {
    e === !0 && this.pmremVersion++;
  }
}
Ot.DEFAULT_IMAGE = null;
Ot.DEFAULT_MAPPING = Vu;
Ot.DEFAULT_ANISOTROPY = 1;
class _t {
  /**
   * Constructs a new 4D vector.
   *
   * @param {number} [x=0] - The x value of this vector.
   * @param {number} [y=0] - The y value of this vector.
   * @param {number} [z=0] - The z value of this vector.
   * @param {number} [w=1] - The w value of this vector.
   */
  constructor(e = 0, t = 0, i = 0, n = 1) {
    _t.prototype.isVector4 = !0, this.x = e, this.y = t, this.z = i, this.w = n;
  }
  /**
   * Alias for {@link Vector4#z}.
   *
   * @type {number}
   */
  get width() {
    return this.z;
  }
  set width(e) {
    this.z = e;
  }
  /**
   * Alias for {@link Vector4#w}.
   *
   * @type {number}
   */
  get height() {
    return this.w;
  }
  set height(e) {
    this.w = e;
  }
  /**
   * Sets the vector components.
   *
   * @param {number} x - The value of the x component.
   * @param {number} y - The value of the y component.
   * @param {number} z - The value of the z component.
   * @param {number} w - The value of the w component.
   * @return {Vector4} A reference to this vector.
   */
  set(e, t, i, n) {
    return this.x = e, this.y = t, this.z = i, this.w = n, this;
  }
  /**
   * Sets the vector components to the same value.
   *
   * @param {number} scalar - The value to set for all vector components.
   * @return {Vector4} A reference to this vector.
   */
  setScalar(e) {
    return this.x = e, this.y = e, this.z = e, this.w = e, this;
  }
  /**
   * Sets the vector's x component to the given value
   *
   * @param {number} x - The value to set.
   * @return {Vector4} A reference to this vector.
   */
  setX(e) {
    return this.x = e, this;
  }
  /**
   * Sets the vector's y component to the given value
   *
   * @param {number} y - The value to set.
   * @return {Vector4} A reference to this vector.
   */
  setY(e) {
    return this.y = e, this;
  }
  /**
   * Sets the vector's z component to the given value
   *
   * @param {number} z - The value to set.
   * @return {Vector4} A reference to this vector.
   */
  setZ(e) {
    return this.z = e, this;
  }
  /**
   * Sets the vector's w component to the given value
   *
   * @param {number} w - The value to set.
   * @return {Vector4} A reference to this vector.
   */
  setW(e) {
    return this.w = e, this;
  }
  /**
   * Allows to set a vector component with an index.
   *
   * @param {number} index - The component index. `0` equals to x, `1` equals to y,
   * `2` equals to z, `3` equals to w.
   * @param {number} value - The value to set.
   * @return {Vector4} A reference to this vector.
   */
  setComponent(e, t) {
    switch (e) {
      case 0:
        this.x = t;
        break;
      case 1:
        this.y = t;
        break;
      case 2:
        this.z = t;
        break;
      case 3:
        this.w = t;
        break;
      default:
        throw new Error("index is out of range: " + e);
    }
    return this;
  }
  /**
   * Returns the value of the vector component which matches the given index.
   *
   * @param {number} index - The component index. `0` equals to x, `1` equals to y,
   * `2` equals to z, `3` equals to w.
   * @return {number} A vector component value.
   */
  getComponent(e) {
    switch (e) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      case 2:
        return this.z;
      case 3:
        return this.w;
      default:
        throw new Error("index is out of range: " + e);
    }
  }
  /**
   * Returns a new vector with copied values from this instance.
   *
   * @return {Vector4} A clone of this instance.
   */
  clone() {
    return new this.constructor(this.x, this.y, this.z, this.w);
  }
  /**
   * Copies the values of the given vector to this instance.
   *
   * @param {Vector3|Vector4} v - The vector to copy.
   * @return {Vector4} A reference to this vector.
   */
  copy(e) {
    return this.x = e.x, this.y = e.y, this.z = e.z, this.w = e.w !== void 0 ? e.w : 1, this;
  }
  /**
   * Adds the given vector to this instance.
   *
   * @param {Vector4} v - The vector to add.
   * @return {Vector4} A reference to this vector.
   */
  add(e) {
    return this.x += e.x, this.y += e.y, this.z += e.z, this.w += e.w, this;
  }
  /**
   * Adds the given scalar value to all components of this instance.
   *
   * @param {number} s - The scalar to add.
   * @return {Vector4} A reference to this vector.
   */
  addScalar(e) {
    return this.x += e, this.y += e, this.z += e, this.w += e, this;
  }
  /**
   * Adds the given vectors and stores the result in this instance.
   *
   * @param {Vector4} a - The first vector.
   * @param {Vector4} b - The second vector.
   * @return {Vector4} A reference to this vector.
   */
  addVectors(e, t) {
    return this.x = e.x + t.x, this.y = e.y + t.y, this.z = e.z + t.z, this.w = e.w + t.w, this;
  }
  /**
   * Adds the given vector scaled by the given factor to this instance.
   *
   * @param {Vector4} v - The vector.
   * @param {number} s - The factor that scales `v`.
   * @return {Vector4} A reference to this vector.
   */
  addScaledVector(e, t) {
    return this.x += e.x * t, this.y += e.y * t, this.z += e.z * t, this.w += e.w * t, this;
  }
  /**
   * Subtracts the given vector from this instance.
   *
   * @param {Vector4} v - The vector to subtract.
   * @return {Vector4} A reference to this vector.
   */
  sub(e) {
    return this.x -= e.x, this.y -= e.y, this.z -= e.z, this.w -= e.w, this;
  }
  /**
   * Subtracts the given scalar value from all components of this instance.
   *
   * @param {number} s - The scalar to subtract.
   * @return {Vector4} A reference to this vector.
   */
  subScalar(e) {
    return this.x -= e, this.y -= e, this.z -= e, this.w -= e, this;
  }
  /**
   * Subtracts the given vectors and stores the result in this instance.
   *
   * @param {Vector4} a - The first vector.
   * @param {Vector4} b - The second vector.
   * @return {Vector4} A reference to this vector.
   */
  subVectors(e, t) {
    return this.x = e.x - t.x, this.y = e.y - t.y, this.z = e.z - t.z, this.w = e.w - t.w, this;
  }
  /**
   * Multiplies the given vector with this instance.
   *
   * @param {Vector4} v - The vector to multiply.
   * @return {Vector4} A reference to this vector.
   */
  multiply(e) {
    return this.x *= e.x, this.y *= e.y, this.z *= e.z, this.w *= e.w, this;
  }
  /**
   * Multiplies the given scalar value with all components of this instance.
   *
   * @param {number} scalar - The scalar to multiply.
   * @return {Vector4} A reference to this vector.
   */
  multiplyScalar(e) {
    return this.x *= e, this.y *= e, this.z *= e, this.w *= e, this;
  }
  /**
   * Multiplies this vector with the given 4x4 matrix.
   *
   * @param {Matrix4} m - The 4x4 matrix.
   * @return {Vector4} A reference to this vector.
   */
  applyMatrix4(e) {
    const t = this.x, i = this.y, n = this.z, r = this.w, a = e.elements;
    return this.x = a[0] * t + a[4] * i + a[8] * n + a[12] * r, this.y = a[1] * t + a[5] * i + a[9] * n + a[13] * r, this.z = a[2] * t + a[6] * i + a[10] * n + a[14] * r, this.w = a[3] * t + a[7] * i + a[11] * n + a[15] * r, this;
  }
  /**
   * Divides this instance by the given vector.
   *
   * @param {Vector4} v - The vector to divide.
   * @return {Vector4} A reference to this vector.
   */
  divide(e) {
    return this.x /= e.x, this.y /= e.y, this.z /= e.z, this.w /= e.w, this;
  }
  /**
   * Divides this vector by the given scalar.
   *
   * @param {number} scalar - The scalar to divide.
   * @return {Vector4} A reference to this vector.
   */
  divideScalar(e) {
    return this.multiplyScalar(1 / e);
  }
  /**
   * Sets the x, y and z components of this
   * vector to the quaternion's axis and w to the angle.
   *
   * @param {Quaternion} q - The Quaternion to set.
   * @return {Vector4} A reference to this vector.
   */
  setAxisAngleFromQuaternion(e) {
    this.w = 2 * Math.acos(e.w);
    const t = Math.sqrt(1 - e.w * e.w);
    return t < 1e-4 ? (this.x = 1, this.y = 0, this.z = 0) : (this.x = e.x / t, this.y = e.y / t, this.z = e.z / t), this;
  }
  /**
   * Sets the x, y and z components of this
   * vector to the axis of rotation and w to the angle.
   *
   * @param {Matrix4} m - A 4x4 matrix of which the upper left 3x3 matrix is a pure rotation matrix.
   * @return {Vector4} A reference to this vector.
   */
  setAxisAngleFromRotationMatrix(e) {
    let t, i, n, r;
    const l = e.elements, c = l[0], h = l[4], d = l[8], u = l[1], f = l[5], g = l[9], v = l[2], m = l[6], p = l[10];
    if (Math.abs(h - u) < 0.01 && Math.abs(d - v) < 0.01 && Math.abs(g - m) < 0.01) {
      if (Math.abs(h + u) < 0.1 && Math.abs(d + v) < 0.1 && Math.abs(g + m) < 0.1 && Math.abs(c + f + p - 3) < 0.1)
        return this.set(1, 0, 0, 0), this;
      t = Math.PI;
      const M = (c + 1) / 2, T = (f + 1) / 2, E = (p + 1) / 2, A = (h + u) / 4, R = (d + v) / 4, F = (g + m) / 4;
      return M > T && M > E ? M < 0.01 ? (i = 0, n = 0.707106781, r = 0.707106781) : (i = Math.sqrt(M), n = A / i, r = R / i) : T > E ? T < 0.01 ? (i = 0.707106781, n = 0, r = 0.707106781) : (n = Math.sqrt(T), i = A / n, r = F / n) : E < 0.01 ? (i = 0.707106781, n = 0.707106781, r = 0) : (r = Math.sqrt(E), i = R / r, n = F / r), this.set(i, n, r, t), this;
    }
    let w = Math.sqrt((m - g) * (m - g) + (d - v) * (d - v) + (u - h) * (u - h));
    return Math.abs(w) < 1e-3 && (w = 1), this.x = (m - g) / w, this.y = (d - v) / w, this.z = (u - h) / w, this.w = Math.acos((c + f + p - 1) / 2), this;
  }
  /**
   * Sets the vector components to the position elements of the
   * given transformation matrix.
   *
   * @param {Matrix4} m - The 4x4 matrix.
   * @return {Vector4} A reference to this vector.
   */
  setFromMatrixPosition(e) {
    const t = e.elements;
    return this.x = t[12], this.y = t[13], this.z = t[14], this.w = t[15], this;
  }
  /**
   * If this vector's x, y, z or w value is greater than the given vector's x, y, z or w
   * value, replace that value with the corresponding min value.
   *
   * @param {Vector4} v - The vector.
   * @return {Vector4} A reference to this vector.
   */
  min(e) {
    return this.x = Math.min(this.x, e.x), this.y = Math.min(this.y, e.y), this.z = Math.min(this.z, e.z), this.w = Math.min(this.w, e.w), this;
  }
  /**
   * If this vector's x, y, z or w value is less than the given vector's x, y, z or w
   * value, replace that value with the corresponding max value.
   *
   * @param {Vector4} v - The vector.
   * @return {Vector4} A reference to this vector.
   */
  max(e) {
    return this.x = Math.max(this.x, e.x), this.y = Math.max(this.y, e.y), this.z = Math.max(this.z, e.z), this.w = Math.max(this.w, e.w), this;
  }
  /**
   * If this vector's x, y, z or w value is greater than the max vector's x, y, z or w
   * value, it is replaced by the corresponding value.
   * If this vector's x, y, z or w value is less than the min vector's x, y, z or w value,
   * it is replaced by the corresponding value.
   *
   * @param {Vector4} min - The minimum x, y and z values.
   * @param {Vector4} max - The maximum x, y and z values in the desired range.
   * @return {Vector4} A reference to this vector.
   */
  clamp(e, t) {
    return this.x = Xe(this.x, e.x, t.x), this.y = Xe(this.y, e.y, t.y), this.z = Xe(this.z, e.z, t.z), this.w = Xe(this.w, e.w, t.w), this;
  }
  /**
   * If this vector's x, y, z or w values are greater than the max value, they are
   * replaced by the max value.
   * If this vector's x, y, z or w values are less than the min value, they are
   * replaced by the min value.
   *
   * @param {number} minVal - The minimum value the components will be clamped to.
   * @param {number} maxVal - The maximum value the components will be clamped to.
   * @return {Vector4} A reference to this vector.
   */
  clampScalar(e, t) {
    return this.x = Xe(this.x, e, t), this.y = Xe(this.y, e, t), this.z = Xe(this.z, e, t), this.w = Xe(this.w, e, t), this;
  }
  /**
   * If this vector's length is greater than the max value, it is replaced by
   * the max value.
   * If this vector's length is less than the min value, it is replaced by the
   * min value.
   *
   * @param {number} min - The minimum value the vector length will be clamped to.
   * @param {number} max - The maximum value the vector length will be clamped to.
   * @return {Vector4} A reference to this vector.
   */
  clampLength(e, t) {
    const i = this.length();
    return this.divideScalar(i || 1).multiplyScalar(Xe(i, e, t));
  }
  /**
   * The components of this vector are rounded down to the nearest integer value.
   *
   * @return {Vector4} A reference to this vector.
   */
  floor() {
    return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this.w = Math.floor(this.w), this;
  }
  /**
   * The components of this vector are rounded up to the nearest integer value.
   *
   * @return {Vector4} A reference to this vector.
   */
  ceil() {
    return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this.w = Math.ceil(this.w), this;
  }
  /**
   * The components of this vector are rounded to the nearest integer value
   *
   * @return {Vector4} A reference to this vector.
   */
  round() {
    return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this.w = Math.round(this.w), this;
  }
  /**
   * The components of this vector are rounded towards zero (up if negative,
   * down if positive) to an integer value.
   *
   * @return {Vector4} A reference to this vector.
   */
  roundToZero() {
    return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this.w = Math.trunc(this.w), this;
  }
  /**
   * Inverts this vector - i.e. sets x = -x, y = -y, z = -z, w = -w.
   *
   * @return {Vector4} A reference to this vector.
   */
  negate() {
    return this.x = -this.x, this.y = -this.y, this.z = -this.z, this.w = -this.w, this;
  }
  /**
   * Calculates the dot product of the given vector with this instance.
   *
   * @param {Vector4} v - The vector to compute the dot product with.
   * @return {number} The result of the dot product.
   */
  dot(e) {
    return this.x * e.x + this.y * e.y + this.z * e.z + this.w * e.w;
  }
  /**
   * Computes the square of the Euclidean length (straight-line length) from
   * (0, 0, 0, 0) to (x, y, z, w). If you are comparing the lengths of vectors, you should
   * compare the length squared instead as it is slightly more efficient to calculate.
   *
   * @return {number} The square length of this vector.
   */
  lengthSq() {
    return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
  }
  /**
   * Computes the  Euclidean length (straight-line length) from (0, 0, 0, 0) to (x, y, z, w).
   *
   * @return {number} The length of this vector.
   */
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
  }
  /**
   * Computes the Manhattan length of this vector.
   *
   * @return {number} The length of this vector.
   */
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
  }
  /**
   * Converts this vector to a unit vector - that is, sets it equal to a vector
   * with the same direction as this one, but with a vector length of `1`.
   *
   * @return {Vector4} A reference to this vector.
   */
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  /**
   * Sets this vector to a vector with the same direction as this one, but
   * with the specified length.
   *
   * @param {number} length - The new length of this vector.
   * @return {Vector4} A reference to this vector.
   */
  setLength(e) {
    return this.normalize().multiplyScalar(e);
  }
  /**
   * Linearly interpolates between the given vector and this instance, where
   * alpha is the percent distance along the line - alpha = 0 will be this
   * vector, and alpha = 1 will be the given one.
   *
   * @param {Vector4} v - The vector to interpolate towards.
   * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
   * @return {Vector4} A reference to this vector.
   */
  lerp(e, t) {
    return this.x += (e.x - this.x) * t, this.y += (e.y - this.y) * t, this.z += (e.z - this.z) * t, this.w += (e.w - this.w) * t, this;
  }
  /**
   * Linearly interpolates between the given vectors, where alpha is the percent
   * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
   * be the second one. The result is stored in this instance.
   *
   * @param {Vector4} v1 - The first vector.
   * @param {Vector4} v2 - The second vector.
   * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
   * @return {Vector4} A reference to this vector.
   */
  lerpVectors(e, t, i) {
    return this.x = e.x + (t.x - e.x) * i, this.y = e.y + (t.y - e.y) * i, this.z = e.z + (t.z - e.z) * i, this.w = e.w + (t.w - e.w) * i, this;
  }
  /**
   * Returns `true` if this vector is equal with the given one.
   *
   * @param {Vector4} v - The vector to test for equality.
   * @return {boolean} Whether this vector is equal with the given one.
   */
  equals(e) {
    return e.x === this.x && e.y === this.y && e.z === this.z && e.w === this.w;
  }
  /**
   * Sets this vector's x value to be `array[ offset ]`, y value to be `array[ offset + 1 ]`,
   * z value to be `array[ offset + 2 ]`, w value to be `array[ offset + 3 ]`.
   *
   * @param {Array<number>} array - An array holding the vector component values.
   * @param {number} [offset=0] - The offset into the array.
   * @return {Vector4} A reference to this vector.
   */
  fromArray(e, t = 0) {
    return this.x = e[t], this.y = e[t + 1], this.z = e[t + 2], this.w = e[t + 3], this;
  }
  /**
   * Writes the components of this vector to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the vector components.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The vector components.
   */
  toArray(e = [], t = 0) {
    return e[t] = this.x, e[t + 1] = this.y, e[t + 2] = this.z, e[t + 3] = this.w, e;
  }
  /**
   * Sets the components of this vector from the given buffer attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
   * @param {number} index - The index into the attribute.
   * @return {Vector4} A reference to this vector.
   */
  fromBufferAttribute(e, t) {
    return this.x = e.getX(t), this.y = e.getY(t), this.z = e.getZ(t), this.w = e.getW(t), this;
  }
  /**
   * Sets each component of this vector to a pseudo-random value between `0` and
   * `1`, excluding `1`.
   *
   * @return {Vector4} A reference to this vector.
   */
  random() {
    return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this.w = Math.random(), this;
  }
  *[Symbol.iterator]() {
    yield this.x, yield this.y, yield this.z, yield this.w;
  }
}
class qv extends ss {
  /**
   * Render target options.
   *
   * @typedef {Object} RenderTarget~Options
   * @property {boolean} [generateMipmaps=false] - Whether to generate mipmaps or not.
   * @property {number} [magFilter=LinearFilter] - The mag filter.
   * @property {number} [minFilter=LinearFilter] - The min filter.
   * @property {number} [format=RGBAFormat] - The texture format.
   * @property {number} [type=UnsignedByteType] - The texture type.
   * @property {?string} [internalFormat=null] - The texture's internal format.
   * @property {number} [wrapS=ClampToEdgeWrapping] - The texture's uv wrapping mode.
   * @property {number} [wrapT=ClampToEdgeWrapping] - The texture's uv wrapping mode.
   * @property {number} [anisotropy=1] - The texture's anisotropy value.
   * @property {string} [colorSpace=NoColorSpace] - The texture's color space.
   * @property {boolean} [depthBuffer=true] - Whether to allocate a depth buffer or not.
   * @property {boolean} [stencilBuffer=false] - Whether to allocate a stencil buffer or not.
   * @property {boolean} [resolveDepthBuffer=true] - Whether to resolve the depth buffer or not.
   * @property {boolean} [resolveStencilBuffer=true] - Whether  to resolve the stencil buffer or not.
   * @property {?Texture} [depthTexture=null] - Reference to a depth texture.
   * @property {number} [samples=0] - The MSAA samples count.
   * @property {number} [count=1] - Defines the number of color attachments . Must be at least `1`.
   * @property {number} [depth=1] - The texture depth.
   * @property {boolean} [multiview=false] - Whether this target is used for multiview rendering.
   */
  /**
   * Constructs a new render target.
   *
   * @param {number} [width=1] - The width of the render target.
   * @param {number} [height=1] - The height of the render target.
   * @param {RenderTarget~Options} [options] - The configuration object.
   */
  constructor(e = 1, t = 1, i = {}) {
    super(), i = Object.assign({
      generateMipmaps: !1,
      internalFormat: null,
      minFilter: bt,
      depthBuffer: !0,
      stencilBuffer: !1,
      resolveDepthBuffer: !0,
      resolveStencilBuffer: !0,
      depthTexture: null,
      samples: 0,
      count: 1,
      depth: 1,
      multiview: !1
    }, i), this.isRenderTarget = !0, this.width = e, this.height = t, this.depth = i.depth, this.scissor = new _t(0, 0, e, t), this.scissorTest = !1, this.viewport = new _t(0, 0, e, t);
    const n = { width: e, height: t, depth: i.depth }, r = new Ot(n);
    this.textures = [];
    const a = i.count;
    for (let o = 0; o < a; o++)
      this.textures[o] = r.clone(), this.textures[o].isRenderTargetTexture = !0, this.textures[o].renderTarget = this;
    this._setTextureOptions(i), this.depthBuffer = i.depthBuffer, this.stencilBuffer = i.stencilBuffer, this.resolveDepthBuffer = i.resolveDepthBuffer, this.resolveStencilBuffer = i.resolveStencilBuffer, this._depthTexture = null, this.depthTexture = i.depthTexture, this.samples = i.samples, this.multiview = i.multiview;
  }
  _setTextureOptions(e = {}) {
    const t = {
      minFilter: bt,
      generateMipmaps: !1,
      flipY: !1,
      internalFormat: null
    };
    e.mapping !== void 0 && (t.mapping = e.mapping), e.wrapS !== void 0 && (t.wrapS = e.wrapS), e.wrapT !== void 0 && (t.wrapT = e.wrapT), e.wrapR !== void 0 && (t.wrapR = e.wrapR), e.magFilter !== void 0 && (t.magFilter = e.magFilter), e.minFilter !== void 0 && (t.minFilter = e.minFilter), e.format !== void 0 && (t.format = e.format), e.type !== void 0 && (t.type = e.type), e.anisotropy !== void 0 && (t.anisotropy = e.anisotropy), e.colorSpace !== void 0 && (t.colorSpace = e.colorSpace), e.flipY !== void 0 && (t.flipY = e.flipY), e.generateMipmaps !== void 0 && (t.generateMipmaps = e.generateMipmaps), e.internalFormat !== void 0 && (t.internalFormat = e.internalFormat);
    for (let i = 0; i < this.textures.length; i++)
      this.textures[i].setValues(t);
  }
  /**
   * The texture representing the default color attachment.
   *
   * @type {Texture}
   */
  get texture() {
    return this.textures[0];
  }
  set texture(e) {
    this.textures[0] = e;
  }
  set depthTexture(e) {
    this._depthTexture !== null && (this._depthTexture.renderTarget = null), e !== null && (e.renderTarget = this), this._depthTexture = e;
  }
  /**
   * Instead of saving the depth in a renderbuffer, a texture
   * can be used instead which is useful for further processing
   * e.g. in context of post-processing.
   *
   * @type {?DepthTexture}
   * @default null
   */
  get depthTexture() {
    return this._depthTexture;
  }
  /**
   * Sets the size of this render target.
   *
   * @param {number} width - The width.
   * @param {number} height - The height.
   * @param {number} [depth=1] - The depth.
   */
  setSize(e, t, i = 1) {
    if (this.width !== e || this.height !== t || this.depth !== i) {
      this.width = e, this.height = t, this.depth = i;
      for (let n = 0, r = this.textures.length; n < r; n++)
        this.textures[n].image.width = e, this.textures[n].image.height = t, this.textures[n].image.depth = i, this.textures[n].isData3DTexture !== !0 && (this.textures[n].isArrayTexture = this.textures[n].image.depth > 1);
      this.dispose();
    }
    this.viewport.set(0, 0, e, t), this.scissor.set(0, 0, e, t);
  }
  /**
   * Returns a new render target with copied values from this instance.
   *
   * @return {RenderTarget} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
  /**
   * Copies the settings of the given render target. This is a structural copy so
   * no resources are shared between render targets after the copy. That includes
   * all MRT textures and the depth texture.
   *
   * @param {RenderTarget} source - The render target to copy.
   * @return {RenderTarget} A reference to this instance.
   */
  copy(e) {
    this.width = e.width, this.height = e.height, this.depth = e.depth, this.scissor.copy(e.scissor), this.scissorTest = e.scissorTest, this.viewport.copy(e.viewport), this.textures.length = 0;
    for (let t = 0, i = e.textures.length; t < i; t++) {
      this.textures[t] = e.textures[t].clone(), this.textures[t].isRenderTargetTexture = !0, this.textures[t].renderTarget = this;
      const n = Object.assign({}, e.textures[t].image);
      this.textures[t].source = new Zc(n);
    }
    return this.depthBuffer = e.depthBuffer, this.stencilBuffer = e.stencilBuffer, this.resolveDepthBuffer = e.resolveDepthBuffer, this.resolveStencilBuffer = e.resolveStencilBuffer, e.depthTexture !== null && (this.depthTexture = e.depthTexture.clone()), this.samples = e.samples, this;
  }
  /**
   * Frees the GPU-related resources allocated by this instance. Call this
   * method whenever this instance is no longer used in your app.
   *
   * @fires RenderTarget#dispose
   */
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
}
class gi extends qv {
  /**
   * Constructs a new 3D render target.
   *
   * @param {number} [width=1] - The width of the render target.
   * @param {number} [height=1] - The height of the render target.
   * @param {RenderTarget~Options} [options] - The configuration object.
   */
  constructor(e = 1, t = 1, i = {}) {
    super(e, t, i), this.isWebGLRenderTarget = !0;
  }
}
class Ju extends Ot {
  /**
   * Constructs a new data array texture.
   *
   * @param {?TypedArray} [data=null] - The buffer data.
   * @param {number} [width=1] - The width of the texture.
   * @param {number} [height=1] - The height of the texture.
   * @param {number} [depth=1] - The depth of the texture.
   */
  constructor(e = null, t = 1, i = 1, n = 1) {
    super(null), this.isDataArrayTexture = !0, this.image = { data: e, width: t, height: i, depth: n }, this.magFilter = It, this.minFilter = It, this.wrapR = Fi, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1, this.layerUpdates = /* @__PURE__ */ new Set();
  }
  /**
   * Describes that a specific layer of the texture needs to be updated.
   * Normally when {@link Texture#needsUpdate} is set to `true`, the
   * entire data texture array is sent to the GPU. Marking specific
   * layers will only transmit subsets of all mipmaps associated with a
   * specific depth in the array which is often much more performant.
   *
   * @param {number} layerIndex - The layer index that should be updated.
   */
  addLayerUpdate(e) {
    this.layerUpdates.add(e);
  }
  /**
   * Resets the layer updates registry.
   */
  clearLayerUpdates() {
    this.layerUpdates.clear();
  }
}
class Wv extends Ot {
  /**
   * Constructs a new data array texture.
   *
   * @param {?TypedArray} [data=null] - The buffer data.
   * @param {number} [width=1] - The width of the texture.
   * @param {number} [height=1] - The height of the texture.
   * @param {number} [depth=1] - The depth of the texture.
   */
  constructor(e = null, t = 1, i = 1, n = 1) {
    super(null), this.isData3DTexture = !0, this.image = { data: e, width: t, height: i, depth: n }, this.magFilter = It, this.minFilter = It, this.wrapR = Fi, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
  }
}
class qi {
  /**
   * Constructs a new bounding box.
   *
   * @param {Vector3} [min=(Infinity,Infinity,Infinity)] - A vector representing the lower boundary of the box.
   * @param {Vector3} [max=(-Infinity,-Infinity,-Infinity)] - A vector representing the upper boundary of the box.
   */
  constructor(e = new O(1 / 0, 1 / 0, 1 / 0), t = new O(-1 / 0, -1 / 0, -1 / 0)) {
    this.isBox3 = !0, this.min = e, this.max = t;
  }
  /**
   * Sets the lower and upper boundaries of this box.
   * Please note that this method only copies the values from the given objects.
   *
   * @param {Vector3} min - The lower boundary of the box.
   * @param {Vector3} max - The upper boundary of the box.
   * @return {Box3} A reference to this bounding box.
   */
  set(e, t) {
    return this.min.copy(e), this.max.copy(t), this;
  }
  /**
   * Sets the upper and lower bounds of this box so it encloses the position data
   * in the given array.
   *
   * @param {Array<number>} array - An array holding 3D position data.
   * @return {Box3} A reference to this bounding box.
   */
  setFromArray(e) {
    this.makeEmpty();
    for (let t = 0, i = e.length; t < i; t += 3)
      this.expandByPoint(bi.fromArray(e, t));
    return this;
  }
  /**
   * Sets the upper and lower bounds of this box so it encloses the position data
   * in the given buffer attribute.
   *
   * @param {BufferAttribute} attribute - A buffer attribute holding 3D position data.
   * @return {Box3} A reference to this bounding box.
   */
  setFromBufferAttribute(e) {
    this.makeEmpty();
    for (let t = 0, i = e.count; t < i; t++)
      this.expandByPoint(bi.fromBufferAttribute(e, t));
    return this;
  }
  /**
   * Sets the upper and lower bounds of this box so it encloses the position data
   * in the given array.
   *
   * @param {Array<Vector3>} points - An array holding 3D position data as instances of {@link Vector3}.
   * @return {Box3} A reference to this bounding box.
   */
  setFromPoints(e) {
    this.makeEmpty();
    for (let t = 0, i = e.length; t < i; t++)
      this.expandByPoint(e[t]);
    return this;
  }
  /**
   * Centers this box on the given center vector and sets this box's width, height and
   * depth to the given size values.
   *
   * @param {Vector3} center - The center of the box.
   * @param {Vector3} size - The x, y and z dimensions of the box.
   * @return {Box3} A reference to this bounding box.
   */
  setFromCenterAndSize(e, t) {
    const i = bi.copy(t).multiplyScalar(0.5);
    return this.min.copy(e).sub(i), this.max.copy(e).add(i), this;
  }
  /**
   * Computes the world-axis-aligned bounding box for the given 3D object
   * (including its children), accounting for the object's, and children's,
   * world transforms. The function may result in a larger box than strictly necessary.
   *
   * @param {Object3D} object - The 3D object to compute the bounding box for.
   * @param {boolean} [precise=false] - If set to `true`, the method computes the smallest
   * world-axis-aligned bounding box at the expense of more computation.
   * @return {Box3} A reference to this bounding box.
   */
  setFromObject(e, t = !1) {
    return this.makeEmpty(), this.expandByObject(e, t);
  }
  /**
   * Returns a new box with copied values from this instance.
   *
   * @return {Box3} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
  /**
   * Copies the values of the given box to this instance.
   *
   * @param {Box3} box - The box to copy.
   * @return {Box3} A reference to this bounding box.
   */
  copy(e) {
    return this.min.copy(e.min), this.max.copy(e.max), this;
  }
  /**
   * Makes this box empty which means in encloses a zero space in 3D.
   *
   * @return {Box3} A reference to this bounding box.
   */
  makeEmpty() {
    return this.min.x = this.min.y = this.min.z = 1 / 0, this.max.x = this.max.y = this.max.z = -1 / 0, this;
  }
  /**
   * Returns true if this box includes zero points within its bounds.
   * Note that a box with equal lower and upper bounds still includes one
   * point, the one both bounds share.
   *
   * @return {boolean} Whether this box is empty or not.
   */
  isEmpty() {
    return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
  }
  /**
   * Returns the center point of this box.
   *
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The center point.
   */
  getCenter(e) {
    return this.isEmpty() ? e.set(0, 0, 0) : e.addVectors(this.min, this.max).multiplyScalar(0.5);
  }
  /**
   * Returns the dimensions of this box.
   *
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The size.
   */
  getSize(e) {
    return this.isEmpty() ? e.set(0, 0, 0) : e.subVectors(this.max, this.min);
  }
  /**
   * Expands the boundaries of this box to include the given point.
   *
   * @param {Vector3} point - The point that should be included by the bounding box.
   * @return {Box3} A reference to this bounding box.
   */
  expandByPoint(e) {
    return this.min.min(e), this.max.max(e), this;
  }
  /**
   * Expands this box equilaterally by the given vector. The width of this
   * box will be expanded by the x component of the vector in both
   * directions. The height of this box will be expanded by the y component of
   * the vector in both directions. The depth of this box will be
   * expanded by the z component of the vector in both directions.
   *
   * @param {Vector3} vector - The vector that should expand the bounding box.
   * @return {Box3} A reference to this bounding box.
   */
  expandByVector(e) {
    return this.min.sub(e), this.max.add(e), this;
  }
  /**
   * Expands each dimension of the box by the given scalar. If negative, the
   * dimensions of the box will be contracted.
   *
   * @param {number} scalar - The scalar value that should expand the bounding box.
   * @return {Box3} A reference to this bounding box.
   */
  expandByScalar(e) {
    return this.min.addScalar(-e), this.max.addScalar(e), this;
  }
  /**
   * Expands the boundaries of this box to include the given 3D object and
   * its children, accounting for the object's, and children's, world
   * transforms. The function may result in a larger box than strictly
   * necessary (unless the precise parameter is set to true).
   *
   * @param {Object3D} object - The 3D object that should expand the bounding box.
   * @param {boolean} precise - If set to `true`, the method expands the bounding box
   * as little as necessary at the expense of more computation.
   * @return {Box3} A reference to this bounding box.
   */
  expandByObject(e, t = !1) {
    e.updateWorldMatrix(!1, !1);
    const i = e.geometry;
    if (i !== void 0) {
      const r = i.getAttribute("position");
      if (t === !0 && r !== void 0 && e.isInstancedMesh !== !0)
        for (let a = 0, o = r.count; a < o; a++)
          e.isMesh === !0 ? e.getVertexPosition(a, bi) : bi.fromBufferAttribute(r, a), bi.applyMatrix4(e.matrixWorld), this.expandByPoint(bi);
      else
        e.boundingBox !== void 0 ? (e.boundingBox === null && e.computeBoundingBox(), Wr.copy(e.boundingBox)) : (i.boundingBox === null && i.computeBoundingBox(), Wr.copy(i.boundingBox)), Wr.applyMatrix4(e.matrixWorld), this.union(Wr);
    }
    const n = e.children;
    for (let r = 0, a = n.length; r < a; r++)
      this.expandByObject(n[r], t);
    return this;
  }
  /**
   * Returns `true` if the given point lies within or on the boundaries of this box.
   *
   * @param {Vector3} point - The point to test.
   * @return {boolean} Whether the bounding box contains the given point or not.
   */
  containsPoint(e) {
    return e.x >= this.min.x && e.x <= this.max.x && e.y >= this.min.y && e.y <= this.max.y && e.z >= this.min.z && e.z <= this.max.z;
  }
  /**
   * Returns `true` if this bounding box includes the entirety of the given bounding box.
   * If this box and the given one are identical, this function also returns `true`.
   *
   * @param {Box3} box - The bounding box to test.
   * @return {boolean} Whether the bounding box contains the given bounding box or not.
   */
  containsBox(e) {
    return this.min.x <= e.min.x && e.max.x <= this.max.x && this.min.y <= e.min.y && e.max.y <= this.max.y && this.min.z <= e.min.z && e.max.z <= this.max.z;
  }
  /**
   * Returns a point as a proportion of this box's width, height and depth.
   *
   * @param {Vector3} point - A point in 3D space.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} A point as a proportion of this box's width, height and depth.
   */
  getParameter(e, t) {
    return t.set(
      (e.x - this.min.x) / (this.max.x - this.min.x),
      (e.y - this.min.y) / (this.max.y - this.min.y),
      (e.z - this.min.z) / (this.max.z - this.min.z)
    );
  }
  /**
   * Returns `true` if the given bounding box intersects with this bounding box.
   *
   * @param {Box3} box - The bounding box to test.
   * @return {boolean} Whether the given bounding box intersects with this bounding box.
   */
  intersectsBox(e) {
    return e.max.x >= this.min.x && e.min.x <= this.max.x && e.max.y >= this.min.y && e.min.y <= this.max.y && e.max.z >= this.min.z && e.min.z <= this.max.z;
  }
  /**
   * Returns `true` if the given bounding sphere intersects with this bounding box.
   *
   * @param {Sphere} sphere - The bounding sphere to test.
   * @return {boolean} Whether the given bounding sphere intersects with this bounding box.
   */
  intersectsSphere(e) {
    return this.clampPoint(e.center, bi), bi.distanceToSquared(e.center) <= e.radius * e.radius;
  }
  /**
   * Returns `true` if the given plane intersects with this bounding box.
   *
   * @param {Plane} plane - The plane to test.
   * @return {boolean} Whether the given plane intersects with this bounding box.
   */
  intersectsPlane(e) {
    let t, i;
    return e.normal.x > 0 ? (t = e.normal.x * this.min.x, i = e.normal.x * this.max.x) : (t = e.normal.x * this.max.x, i = e.normal.x * this.min.x), e.normal.y > 0 ? (t += e.normal.y * this.min.y, i += e.normal.y * this.max.y) : (t += e.normal.y * this.max.y, i += e.normal.y * this.min.y), e.normal.z > 0 ? (t += e.normal.z * this.min.z, i += e.normal.z * this.max.z) : (t += e.normal.z * this.max.z, i += e.normal.z * this.min.z), t <= -e.constant && i >= -e.constant;
  }
  /**
   * Returns `true` if the given triangle intersects with this bounding box.
   *
   * @param {Triangle} triangle - The triangle to test.
   * @return {boolean} Whether the given triangle intersects with this bounding box.
   */
  intersectsTriangle(e) {
    if (this.isEmpty())
      return !1;
    this.getCenter(er), Xr.subVectors(this.max, er), cs.subVectors(e.a, er), hs.subVectors(e.b, er), ds.subVectors(e.c, er), mn.subVectors(hs, cs), gn.subVectors(ds, hs), Bn.subVectors(cs, ds);
    let t = [
      0,
      -mn.z,
      mn.y,
      0,
      -gn.z,
      gn.y,
      0,
      -Bn.z,
      Bn.y,
      mn.z,
      0,
      -mn.x,
      gn.z,
      0,
      -gn.x,
      Bn.z,
      0,
      -Bn.x,
      -mn.y,
      mn.x,
      0,
      -gn.y,
      gn.x,
      0,
      -Bn.y,
      Bn.x,
      0
    ];
    return !Ao(t, cs, hs, ds, Xr) || (t = [1, 0, 0, 0, 1, 0, 0, 0, 1], !Ao(t, cs, hs, ds, Xr)) ? !1 : (jr.crossVectors(mn, gn), t = [jr.x, jr.y, jr.z], Ao(t, cs, hs, ds, Xr));
  }
  /**
   * Clamps the given point within the bounds of this box.
   *
   * @param {Vector3} point - The point to clamp.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The clamped point.
   */
  clampPoint(e, t) {
    return t.copy(e).clamp(this.min, this.max);
  }
  /**
   * Returns the euclidean distance from any edge of this box to the specified point. If
   * the given point lies inside of this box, the distance will be `0`.
   *
   * @param {Vector3} point - The point to compute the distance to.
   * @return {number} The euclidean distance.
   */
  distanceToPoint(e) {
    return this.clampPoint(e, bi).distanceTo(e);
  }
  /**
   * Returns a bounding sphere that encloses this bounding box.
   *
   * @param {Sphere} target - The target sphere that is used to store the method's result.
   * @return {Sphere} The bounding sphere that encloses this bounding box.
   */
  getBoundingSphere(e) {
    return this.isEmpty() ? e.makeEmpty() : (this.getCenter(e.center), e.radius = this.getSize(bi).length() * 0.5), e;
  }
  /**
   * Computes the intersection of this bounding box and the given one, setting the upper
   * bound of this box to the lesser of the two boxes' upper bounds and the
   * lower bound of this box to the greater of the two boxes' lower bounds. If
   * there's no overlap, makes this box empty.
   *
   * @param {Box3} box - The bounding box to intersect with.
   * @return {Box3} A reference to this bounding box.
   */
  intersect(e) {
    return this.min.max(e.min), this.max.min(e.max), this.isEmpty() && this.makeEmpty(), this;
  }
  /**
   * Computes the union of this box and another and the given one, setting the upper
   * bound of this box to the greater of the two boxes' upper bounds and the
   * lower bound of this box to the lesser of the two boxes' lower bounds.
   *
   * @param {Box3} box - The bounding box that will be unioned with this instance.
   * @return {Box3} A reference to this bounding box.
   */
  union(e) {
    return this.min.min(e.min), this.max.max(e.max), this;
  }
  /**
   * Transforms this bounding box by the given 4x4 transformation matrix.
   *
   * @param {Matrix4} matrix - The transformation matrix.
   * @return {Box3} A reference to this bounding box.
   */
  applyMatrix4(e) {
    return this.isEmpty() ? this : (Ki[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(e), Ki[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(e), Ki[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(e), Ki[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(e), Ki[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(e), Ki[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(e), Ki[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(e), Ki[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(e), this.setFromPoints(Ki), this);
  }
  /**
   * Adds the given offset to both the upper and lower bounds of this bounding box,
   * effectively moving it in 3D space.
   *
   * @param {Vector3} offset - The offset that should be used to translate the bounding box.
   * @return {Box3} A reference to this bounding box.
   */
  translate(e) {
    return this.min.add(e), this.max.add(e), this;
  }
  /**
   * Returns `true` if this bounding box is equal with the given one.
   *
   * @param {Box3} box - The box to test for equality.
   * @return {boolean} Whether this bounding box is equal with the given one.
   */
  equals(e) {
    return e.min.equals(this.min) && e.max.equals(this.max);
  }
  /**
   * Returns a serialized structure of the bounding box.
   *
   * @return {Object} Serialized structure with fields representing the object state.
   */
  toJSON() {
    return {
      min: this.min.toArray(),
      max: this.max.toArray()
    };
  }
  /**
   * Returns a serialized structure of the bounding box.
   *
   * @param {Object} json - The serialized json to set the box from.
   * @return {Box3} A reference to this bounding box.
   */
  fromJSON(e) {
    return this.min.fromArray(e.min), this.max.fromArray(e.max), this;
  }
}
const Ki = [
  /* @__PURE__ */ new O(),
  /* @__PURE__ */ new O(),
  /* @__PURE__ */ new O(),
  /* @__PURE__ */ new O(),
  /* @__PURE__ */ new O(),
  /* @__PURE__ */ new O(),
  /* @__PURE__ */ new O(),
  /* @__PURE__ */ new O()
], bi = /* @__PURE__ */ new O(), Wr = /* @__PURE__ */ new qi(), cs = /* @__PURE__ */ new O(), hs = /* @__PURE__ */ new O(), ds = /* @__PURE__ */ new O(), mn = /* @__PURE__ */ new O(), gn = /* @__PURE__ */ new O(), Bn = /* @__PURE__ */ new O(), er = /* @__PURE__ */ new O(), Xr = /* @__PURE__ */ new O(), jr = /* @__PURE__ */ new O(), kn = /* @__PURE__ */ new O();
function Ao(s, e, t, i, n) {
  for (let r = 0, a = s.length - 3; r <= a; r += 3) {
    kn.fromArray(s, r);
    const o = n.x * Math.abs(kn.x) + n.y * Math.abs(kn.y) + n.z * Math.abs(kn.z), l = e.dot(kn), c = t.dot(kn), h = i.dot(kn);
    if (Math.max(-Math.max(l, c, h), Math.min(l, c, h)) > o)
      return !1;
  }
  return !0;
}
const Xv = /* @__PURE__ */ new qi(), tr = /* @__PURE__ */ new O(), Ro = /* @__PURE__ */ new O();
class Wi {
  /**
   * Constructs a new sphere.
   *
   * @param {Vector3} [center=(0,0,0)] - The center of the sphere
   * @param {number} [radius=-1] - The radius of the sphere.
   */
  constructor(e = new O(), t = -1) {
    this.isSphere = !0, this.center = e, this.radius = t;
  }
  /**
   * Sets the sphere's components by copying the given values.
   *
   * @param {Vector3} center - The center.
   * @param {number} radius - The radius.
   * @return {Sphere} A reference to this sphere.
   */
  set(e, t) {
    return this.center.copy(e), this.radius = t, this;
  }
  /**
   * Computes the minimum bounding sphere for list of points.
   * If the optional center point is given, it is used as the sphere's
   * center. Otherwise, the center of the axis-aligned bounding box
   * encompassing the points is calculated.
   *
   * @param {Array<Vector3>} points - A list of points in 3D space.
   * @param {Vector3} [optionalCenter] - The center of the sphere.
   * @return {Sphere} A reference to this sphere.
   */
  setFromPoints(e, t) {
    const i = this.center;
    t !== void 0 ? i.copy(t) : Xv.setFromPoints(e).getCenter(i);
    let n = 0;
    for (let r = 0, a = e.length; r < a; r++)
      n = Math.max(n, i.distanceToSquared(e[r]));
    return this.radius = Math.sqrt(n), this;
  }
  /**
   * Copies the values of the given sphere to this instance.
   *
   * @param {Sphere} sphere - The sphere to copy.
   * @return {Sphere} A reference to this sphere.
   */
  copy(e) {
    return this.center.copy(e.center), this.radius = e.radius, this;
  }
  /**
   * Returns `true` if the sphere is empty (the radius set to a negative number).
   *
   * Spheres with a radius of `0` contain only their center point and are not
   * considered to be empty.
   *
   * @return {boolean} Whether this sphere is empty or not.
   */
  isEmpty() {
    return this.radius < 0;
  }
  /**
   * Makes this sphere empty which means in encloses a zero space in 3D.
   *
   * @return {Sphere} A reference to this sphere.
   */
  makeEmpty() {
    return this.center.set(0, 0, 0), this.radius = -1, this;
  }
  /**
   * Returns `true` if this sphere contains the given point inclusive of
   * the surface of the sphere.
   *
   * @param {Vector3} point - The point to check.
   * @return {boolean} Whether this sphere contains the given point or not.
   */
  containsPoint(e) {
    return e.distanceToSquared(this.center) <= this.radius * this.radius;
  }
  /**
   * Returns the closest distance from the boundary of the sphere to the
   * given point. If the sphere contains the point, the distance will
   * be negative.
   *
   * @param {Vector3} point - The point to compute the distance to.
   * @return {number} The distance to the point.
   */
  distanceToPoint(e) {
    return e.distanceTo(this.center) - this.radius;
  }
  /**
   * Returns `true` if this sphere intersects with the given one.
   *
   * @param {Sphere} sphere - The sphere to test.
   * @return {boolean} Whether this sphere intersects with the given one or not.
   */
  intersectsSphere(e) {
    const t = this.radius + e.radius;
    return e.center.distanceToSquared(this.center) <= t * t;
  }
  /**
   * Returns `true` if this sphere intersects with the given box.
   *
   * @param {Box3} box - The box to test.
   * @return {boolean} Whether this sphere intersects with the given box or not.
   */
  intersectsBox(e) {
    return e.intersectsSphere(this);
  }
  /**
   * Returns `true` if this sphere intersects with the given plane.
   *
   * @param {Plane} plane - The plane to test.
   * @return {boolean} Whether this sphere intersects with the given plane or not.
   */
  intersectsPlane(e) {
    return Math.abs(e.distanceToPoint(this.center)) <= this.radius;
  }
  /**
   * Clamps a point within the sphere. If the point is outside the sphere, it
   * will clamp it to the closest point on the edge of the sphere. Points
   * already inside the sphere will not be affected.
   *
   * @param {Vector3} point - The plane to clamp.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The clamped point.
   */
  clampPoint(e, t) {
    const i = this.center.distanceToSquared(e);
    return t.copy(e), i > this.radius * this.radius && (t.sub(this.center).normalize(), t.multiplyScalar(this.radius).add(this.center)), t;
  }
  /**
   * Returns a bounding box that encloses this sphere.
   *
   * @param {Box3} target - The target box that is used to store the method's result.
   * @return {Box3} The bounding box that encloses this sphere.
   */
  getBoundingBox(e) {
    return this.isEmpty() ? (e.makeEmpty(), e) : (e.set(this.center, this.center), e.expandByScalar(this.radius), e);
  }
  /**
   * Transforms this sphere with the given 4x4 transformation matrix.
   *
   * @param {Matrix4} matrix - The transformation matrix.
   * @return {Sphere} A reference to this sphere.
   */
  applyMatrix4(e) {
    return this.center.applyMatrix4(e), this.radius = this.radius * e.getMaxScaleOnAxis(), this;
  }
  /**
   * Translates the sphere's center by the given offset.
   *
   * @param {Vector3} offset - The offset.
   * @return {Sphere} A reference to this sphere.
   */
  translate(e) {
    return this.center.add(e), this;
  }
  /**
   * Expands the boundaries of this sphere to include the given point.
   *
   * @param {Vector3} point - The point to include.
   * @return {Sphere} A reference to this sphere.
   */
  expandByPoint(e) {
    if (this.isEmpty())
      return this.center.copy(e), this.radius = 0, this;
    tr.subVectors(e, this.center);
    const t = tr.lengthSq();
    if (t > this.radius * this.radius) {
      const i = Math.sqrt(t), n = (i - this.radius) * 0.5;
      this.center.addScaledVector(tr, n / i), this.radius += n;
    }
    return this;
  }
  /**
   * Expands this sphere to enclose both the original sphere and the given sphere.
   *
   * @param {Sphere} sphere - The sphere to include.
   * @return {Sphere} A reference to this sphere.
   */
  union(e) {
    return e.isEmpty() ? this : this.isEmpty() ? (this.copy(e), this) : (this.center.equals(e.center) === !0 ? this.radius = Math.max(this.radius, e.radius) : (Ro.subVectors(e.center, this.center).setLength(e.radius), this.expandByPoint(tr.copy(e.center).add(Ro)), this.expandByPoint(tr.copy(e.center).sub(Ro))), this);
  }
  /**
   * Returns `true` if this sphere is equal with the given one.
   *
   * @param {Sphere} sphere - The sphere to test for equality.
   * @return {boolean} Whether this bounding sphere is equal with the given one.
   */
  equals(e) {
    return e.center.equals(this.center) && e.radius === this.radius;
  }
  /**
   * Returns a new sphere with copied values from this instance.
   *
   * @return {Sphere} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
  /**
   * Returns a serialized structure of the bounding sphere.
   *
   * @return {Object} Serialized structure with fields representing the object state.
   */
  toJSON() {
    return {
      radius: this.radius,
      center: this.center.toArray()
    };
  }
  /**
   * Returns a serialized structure of the bounding sphere.
   *
   * @param {Object} json - The serialized json to set the sphere from.
   * @return {Sphere} A reference to this bounding sphere.
   */
  fromJSON(e) {
    return this.radius = e.radius, this.center.fromArray(e.center), this;
  }
}
const Zi = /* @__PURE__ */ new O(), Co = /* @__PURE__ */ new O(), Yr = /* @__PURE__ */ new O(), vn = /* @__PURE__ */ new O(), Io = /* @__PURE__ */ new O(), Kr = /* @__PURE__ */ new O(), Po = /* @__PURE__ */ new O();
class uo {
  /**
   * Constructs a new ray.
   *
   * @param {Vector3} [origin=(0,0,0)] - The origin of the ray.
   * @param {Vector3} [direction=(0,0,-1)] - The (normalized) direction of the ray.
   */
  constructor(e = new O(), t = new O(0, 0, -1)) {
    this.origin = e, this.direction = t;
  }
  /**
   * Sets the ray's components by copying the given values.
   *
   * @param {Vector3} origin - The origin.
   * @param {Vector3} direction - The direction.
   * @return {Ray} A reference to this ray.
   */
  set(e, t) {
    return this.origin.copy(e), this.direction.copy(t), this;
  }
  /**
   * Copies the values of the given ray to this instance.
   *
   * @param {Ray} ray - The ray to copy.
   * @return {Ray} A reference to this ray.
   */
  copy(e) {
    return this.origin.copy(e.origin), this.direction.copy(e.direction), this;
  }
  /**
   * Returns a vector that is located at a given distance along this ray.
   *
   * @param {number} t - The distance along the ray to retrieve a position for.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} A position on the ray.
   */
  at(e, t) {
    return t.copy(this.origin).addScaledVector(this.direction, e);
  }
  /**
   * Adjusts the direction of the ray to point at the given vector in world space.
   *
   * @param {Vector3} v - The target position.
   * @return {Ray} A reference to this ray.
   */
  lookAt(e) {
    return this.direction.copy(e).sub(this.origin).normalize(), this;
  }
  /**
   * Shift the origin of this ray along its direction by the given distance.
   *
   * @param {number} t - The distance along the ray to interpolate.
   * @return {Ray} A reference to this ray.
   */
  recast(e) {
    return this.origin.copy(this.at(e, Zi)), this;
  }
  /**
   * Returns the point along this ray that is closest to the given point.
   *
   * @param {Vector3} point - A point in 3D space to get the closet location on the ray for.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The closest point on this ray.
   */
  closestPointToPoint(e, t) {
    t.subVectors(e, this.origin);
    const i = t.dot(this.direction);
    return i < 0 ? t.copy(this.origin) : t.copy(this.origin).addScaledVector(this.direction, i);
  }
  /**
   * Returns the distance of the closest approach between this ray and the given point.
   *
   * @param {Vector3} point - A point in 3D space to compute the distance to.
   * @return {number} The distance.
   */
  distanceToPoint(e) {
    return Math.sqrt(this.distanceSqToPoint(e));
  }
  /**
   * Returns the squared distance of the closest approach between this ray and the given point.
   *
   * @param {Vector3} point - A point in 3D space to compute the distance to.
   * @return {number} The squared distance.
   */
  distanceSqToPoint(e) {
    const t = Zi.subVectors(e, this.origin).dot(this.direction);
    return t < 0 ? this.origin.distanceToSquared(e) : (Zi.copy(this.origin).addScaledVector(this.direction, t), Zi.distanceToSquared(e));
  }
  /**
   * Returns the squared distance between this ray and the given line segment.
   *
   * @param {Vector3} v0 - The start point of the line segment.
   * @param {Vector3} v1 - The end point of the line segment.
   * @param {Vector3} [optionalPointOnRay] - When provided, it receives the point on this ray that is closest to the segment.
   * @param {Vector3} [optionalPointOnSegment] - When provided, it receives the point on the line segment that is closest to this ray.
   * @return {number} The squared distance.
   */
  distanceSqToSegment(e, t, i, n) {
    Co.copy(e).add(t).multiplyScalar(0.5), Yr.copy(t).sub(e).normalize(), vn.copy(this.origin).sub(Co);
    const r = e.distanceTo(t) * 0.5, a = -this.direction.dot(Yr), o = vn.dot(this.direction), l = -vn.dot(Yr), c = vn.lengthSq(), h = Math.abs(1 - a * a);
    let d, u, f, g;
    if (h > 0)
      if (d = a * l - o, u = a * o - l, g = r * h, d >= 0)
        if (u >= -g)
          if (u <= g) {
            const v = 1 / h;
            d *= v, u *= v, f = d * (d + a * u + 2 * o) + u * (a * d + u + 2 * l) + c;
          } else
            u = r, d = Math.max(0, -(a * u + o)), f = -d * d + u * (u + 2 * l) + c;
        else
          u = -r, d = Math.max(0, -(a * u + o)), f = -d * d + u * (u + 2 * l) + c;
      else
        u <= -g ? (d = Math.max(0, -(-a * r + o)), u = d > 0 ? -r : Math.min(Math.max(-r, -l), r), f = -d * d + u * (u + 2 * l) + c) : u <= g ? (d = 0, u = Math.min(Math.max(-r, -l), r), f = u * (u + 2 * l) + c) : (d = Math.max(0, -(a * r + o)), u = d > 0 ? r : Math.min(Math.max(-r, -l), r), f = -d * d + u * (u + 2 * l) + c);
    else
      u = a > 0 ? -r : r, d = Math.max(0, -(a * u + o)), f = -d * d + u * (u + 2 * l) + c;
    return i && i.copy(this.origin).addScaledVector(this.direction, d), n && n.copy(Co).addScaledVector(Yr, u), f;
  }
  /**
   * Intersects this ray with the given sphere, returning the intersection
   * point or `null` if there is no intersection.
   *
   * @param {Sphere} sphere - The sphere to intersect.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The intersection point.
   */
  intersectSphere(e, t) {
    Zi.subVectors(e.center, this.origin);
    const i = Zi.dot(this.direction), n = Zi.dot(Zi) - i * i, r = e.radius * e.radius;
    if (n > r) return null;
    const a = Math.sqrt(r - n), o = i - a, l = i + a;
    return l < 0 ? null : o < 0 ? this.at(l, t) : this.at(o, t);
  }
  /**
   * Returns `true` if this ray intersects with the given sphere.
   *
   * @param {Sphere} sphere - The sphere to intersect.
   * @return {boolean} Whether this ray intersects with the given sphere or not.
   */
  intersectsSphere(e) {
    return e.radius < 0 ? !1 : this.distanceSqToPoint(e.center) <= e.radius * e.radius;
  }
  /**
   * Computes the distance from the ray's origin to the given plane. Returns `null` if the ray
   * does not intersect with the plane.
   *
   * @param {Plane} plane - The plane to compute the distance to.
   * @return {?number} Whether this ray intersects with the given sphere or not.
   */
  distanceToPlane(e) {
    const t = e.normal.dot(this.direction);
    if (t === 0)
      return e.distanceToPoint(this.origin) === 0 ? 0 : null;
    const i = -(this.origin.dot(e.normal) + e.constant) / t;
    return i >= 0 ? i : null;
  }
  /**
   * Intersects this ray with the given plane, returning the intersection
   * point or `null` if there is no intersection.
   *
   * @param {Plane} plane - The plane to intersect.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The intersection point.
   */
  intersectPlane(e, t) {
    const i = this.distanceToPlane(e);
    return i === null ? null : this.at(i, t);
  }
  /**
   * Returns `true` if this ray intersects with the given plane.
   *
   * @param {Plane} plane - The plane to intersect.
   * @return {boolean} Whether this ray intersects with the given plane or not.
   */
  intersectsPlane(e) {
    const t = e.distanceToPoint(this.origin);
    return t === 0 || e.normal.dot(this.direction) * t < 0;
  }
  /**
   * Intersects this ray with the given bounding box, returning the intersection
   * point or `null` if there is no intersection.
   *
   * @param {Box3} box - The box to intersect.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The intersection point.
   */
  intersectBox(e, t) {
    let i, n, r, a, o, l;
    const c = 1 / this.direction.x, h = 1 / this.direction.y, d = 1 / this.direction.z, u = this.origin;
    return c >= 0 ? (i = (e.min.x - u.x) * c, n = (e.max.x - u.x) * c) : (i = (e.max.x - u.x) * c, n = (e.min.x - u.x) * c), h >= 0 ? (r = (e.min.y - u.y) * h, a = (e.max.y - u.y) * h) : (r = (e.max.y - u.y) * h, a = (e.min.y - u.y) * h), i > a || r > n || ((r > i || isNaN(i)) && (i = r), (a < n || isNaN(n)) && (n = a), d >= 0 ? (o = (e.min.z - u.z) * d, l = (e.max.z - u.z) * d) : (o = (e.max.z - u.z) * d, l = (e.min.z - u.z) * d), i > l || o > n) || ((o > i || i !== i) && (i = o), (l < n || n !== n) && (n = l), n < 0) ? null : this.at(i >= 0 ? i : n, t);
  }
  /**
   * Returns `true` if this ray intersects with the given box.
   *
   * @param {Box3} box - The box to intersect.
   * @return {boolean} Whether this ray intersects with the given box or not.
   */
  intersectsBox(e) {
    return this.intersectBox(e, Zi) !== null;
  }
  /**
   * Intersects this ray with the given triangle, returning the intersection
   * point or `null` if there is no intersection.
   *
   * @param {Vector3} a - The first vertex of the triangle.
   * @param {Vector3} b - The second vertex of the triangle.
   * @param {Vector3} c - The third vertex of the triangle.
   * @param {boolean} backfaceCulling - Whether to use backface culling or not.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The intersection point.
   */
  intersectTriangle(e, t, i, n, r) {
    Io.subVectors(t, e), Kr.subVectors(i, e), Po.crossVectors(Io, Kr);
    let a = this.direction.dot(Po), o;
    if (a > 0) {
      if (n) return null;
      o = 1;
    } else if (a < 0)
      o = -1, a = -a;
    else
      return null;
    vn.subVectors(this.origin, e);
    const l = o * this.direction.dot(Kr.crossVectors(vn, Kr));
    if (l < 0)
      return null;
    const c = o * this.direction.dot(Io.cross(vn));
    if (c < 0 || l + c > a)
      return null;
    const h = -o * vn.dot(Po);
    return h < 0 ? null : this.at(h / a, r);
  }
  /**
   * Transforms this ray with the given 4x4 transformation matrix.
   *
   * @param {Matrix4} matrix4 - The transformation matrix.
   * @return {Ray} A reference to this ray.
   */
  applyMatrix4(e) {
    return this.origin.applyMatrix4(e), this.direction.transformDirection(e), this;
  }
  /**
   * Returns `true` if this ray is equal with the given one.
   *
   * @param {Ray} ray - The ray to test for equality.
   * @return {boolean} Whether this ray is equal with the given one.
   */
  equals(e) {
    return e.origin.equals(this.origin) && e.direction.equals(this.direction);
  }
  /**
   * Returns a new ray with copied values from this instance.
   *
   * @return {Ray} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
}
class ze {
  /**
   * Constructs a new 4x4 matrix. The arguments are supposed to be
   * in row-major order. If no arguments are provided, the constructor
   * initializes the matrix as an identity matrix.
   *
   * @param {number} [n11] - 1-1 matrix element.
   * @param {number} [n12] - 1-2 matrix element.
   * @param {number} [n13] - 1-3 matrix element.
   * @param {number} [n14] - 1-4 matrix element.
   * @param {number} [n21] - 2-1 matrix element.
   * @param {number} [n22] - 2-2 matrix element.
   * @param {number} [n23] - 2-3 matrix element.
   * @param {number} [n24] - 2-4 matrix element.
   * @param {number} [n31] - 3-1 matrix element.
   * @param {number} [n32] - 3-2 matrix element.
   * @param {number} [n33] - 3-3 matrix element.
   * @param {number} [n34] - 3-4 matrix element.
   * @param {number} [n41] - 4-1 matrix element.
   * @param {number} [n42] - 4-2 matrix element.
   * @param {number} [n43] - 4-3 matrix element.
   * @param {number} [n44] - 4-4 matrix element.
   */
  constructor(e, t, i, n, r, a, o, l, c, h, d, u, f, g, v, m) {
    ze.prototype.isMatrix4 = !0, this.elements = [
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    ], e !== void 0 && this.set(e, t, i, n, r, a, o, l, c, h, d, u, f, g, v, m);
  }
  /**
   * Sets the elements of the matrix.The arguments are supposed to be
   * in row-major order.
   *
   * @param {number} [n11] - 1-1 matrix element.
   * @param {number} [n12] - 1-2 matrix element.
   * @param {number} [n13] - 1-3 matrix element.
   * @param {number} [n14] - 1-4 matrix element.
   * @param {number} [n21] - 2-1 matrix element.
   * @param {number} [n22] - 2-2 matrix element.
   * @param {number} [n23] - 2-3 matrix element.
   * @param {number} [n24] - 2-4 matrix element.
   * @param {number} [n31] - 3-1 matrix element.
   * @param {number} [n32] - 3-2 matrix element.
   * @param {number} [n33] - 3-3 matrix element.
   * @param {number} [n34] - 3-4 matrix element.
   * @param {number} [n41] - 4-1 matrix element.
   * @param {number} [n42] - 4-2 matrix element.
   * @param {number} [n43] - 4-3 matrix element.
   * @param {number} [n44] - 4-4 matrix element.
   * @return {Matrix4} A reference to this matrix.
   */
  set(e, t, i, n, r, a, o, l, c, h, d, u, f, g, v, m) {
    const p = this.elements;
    return p[0] = e, p[4] = t, p[8] = i, p[12] = n, p[1] = r, p[5] = a, p[9] = o, p[13] = l, p[2] = c, p[6] = h, p[10] = d, p[14] = u, p[3] = f, p[7] = g, p[11] = v, p[15] = m, this;
  }
  /**
   * Sets this matrix to the 4x4 identity matrix.
   *
   * @return {Matrix4} A reference to this matrix.
   */
  identity() {
    return this.set(
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Returns a matrix with copied values from this instance.
   *
   * @return {Matrix4} A clone of this instance.
   */
  clone() {
    return new ze().fromArray(this.elements);
  }
  /**
   * Copies the values of the given matrix to this instance.
   *
   * @param {Matrix4} m - The matrix to copy.
   * @return {Matrix4} A reference to this matrix.
   */
  copy(e) {
    const t = this.elements, i = e.elements;
    return t[0] = i[0], t[1] = i[1], t[2] = i[2], t[3] = i[3], t[4] = i[4], t[5] = i[5], t[6] = i[6], t[7] = i[7], t[8] = i[8], t[9] = i[9], t[10] = i[10], t[11] = i[11], t[12] = i[12], t[13] = i[13], t[14] = i[14], t[15] = i[15], this;
  }
  /**
   * Copies the translation component of the given matrix
   * into this matrix's translation component.
   *
   * @param {Matrix4} m - The matrix to copy the translation component.
   * @return {Matrix4} A reference to this matrix.
   */
  copyPosition(e) {
    const t = this.elements, i = e.elements;
    return t[12] = i[12], t[13] = i[13], t[14] = i[14], this;
  }
  /**
   * Set the upper 3x3 elements of this matrix to the values of given 3x3 matrix.
   *
   * @param {Matrix3} m - The 3x3 matrix.
   * @return {Matrix4} A reference to this matrix.
   */
  setFromMatrix3(e) {
    const t = e.elements;
    return this.set(
      t[0],
      t[3],
      t[6],
      0,
      t[1],
      t[4],
      t[7],
      0,
      t[2],
      t[5],
      t[8],
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Extracts the basis of this matrix into the three axis vectors provided.
   *
   * @param {Vector3} xAxis - The basis's x axis.
   * @param {Vector3} yAxis - The basis's y axis.
   * @param {Vector3} zAxis - The basis's z axis.
   * @return {Matrix4} A reference to this matrix.
   */
  extractBasis(e, t, i) {
    return this.determinant() === 0 ? (e.set(1, 0, 0), t.set(0, 1, 0), i.set(0, 0, 1), this) : (e.setFromMatrixColumn(this, 0), t.setFromMatrixColumn(this, 1), i.setFromMatrixColumn(this, 2), this);
  }
  /**
   * Sets the given basis vectors to this matrix.
   *
   * @param {Vector3} xAxis - The basis's x axis.
   * @param {Vector3} yAxis - The basis's y axis.
   * @param {Vector3} zAxis - The basis's z axis.
   * @return {Matrix4} A reference to this matrix.
   */
  makeBasis(e, t, i) {
    return this.set(
      e.x,
      t.x,
      i.x,
      0,
      e.y,
      t.y,
      i.y,
      0,
      e.z,
      t.z,
      i.z,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Extracts the rotation component of the given matrix
   * into this matrix's rotation component.
   *
   * Note: This method does not support reflection matrices.
   *
   * @param {Matrix4} m - The matrix.
   * @return {Matrix4} A reference to this matrix.
   */
  extractRotation(e) {
    if (e.determinant() === 0)
      return this.identity();
    const t = this.elements, i = e.elements, n = 1 / us.setFromMatrixColumn(e, 0).length(), r = 1 / us.setFromMatrixColumn(e, 1).length(), a = 1 / us.setFromMatrixColumn(e, 2).length();
    return t[0] = i[0] * n, t[1] = i[1] * n, t[2] = i[2] * n, t[3] = 0, t[4] = i[4] * r, t[5] = i[5] * r, t[6] = i[6] * r, t[7] = 0, t[8] = i[8] * a, t[9] = i[9] * a, t[10] = i[10] * a, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, this;
  }
  /**
   * Sets the rotation component (the upper left 3x3 matrix) of this matrix to
   * the rotation specified by the given Euler angles. The rest of
   * the matrix is set to the identity. Depending on the {@link Euler#order},
   * there are six possible outcomes. See [this page](https://en.wikipedia.org/wiki/Euler_angles#Rotation_matrix)
   * for a complete list.
   *
   * @param {Euler} euler - The Euler angles.
   * @return {Matrix4} A reference to this matrix.
   */
  makeRotationFromEuler(e) {
    const t = this.elements, i = e.x, n = e.y, r = e.z, a = Math.cos(i), o = Math.sin(i), l = Math.cos(n), c = Math.sin(n), h = Math.cos(r), d = Math.sin(r);
    if (e.order === "XYZ") {
      const u = a * h, f = a * d, g = o * h, v = o * d;
      t[0] = l * h, t[4] = -l * d, t[8] = c, t[1] = f + g * c, t[5] = u - v * c, t[9] = -o * l, t[2] = v - u * c, t[6] = g + f * c, t[10] = a * l;
    } else if (e.order === "YXZ") {
      const u = l * h, f = l * d, g = c * h, v = c * d;
      t[0] = u + v * o, t[4] = g * o - f, t[8] = a * c, t[1] = a * d, t[5] = a * h, t[9] = -o, t[2] = f * o - g, t[6] = v + u * o, t[10] = a * l;
    } else if (e.order === "ZXY") {
      const u = l * h, f = l * d, g = c * h, v = c * d;
      t[0] = u - v * o, t[4] = -a * d, t[8] = g + f * o, t[1] = f + g * o, t[5] = a * h, t[9] = v - u * o, t[2] = -a * c, t[6] = o, t[10] = a * l;
    } else if (e.order === "ZYX") {
      const u = a * h, f = a * d, g = o * h, v = o * d;
      t[0] = l * h, t[4] = g * c - f, t[8] = u * c + v, t[1] = l * d, t[5] = v * c + u, t[9] = f * c - g, t[2] = -c, t[6] = o * l, t[10] = a * l;
    } else if (e.order === "YZX") {
      const u = a * l, f = a * c, g = o * l, v = o * c;
      t[0] = l * h, t[4] = v - u * d, t[8] = g * d + f, t[1] = d, t[5] = a * h, t[9] = -o * h, t[2] = -c * h, t[6] = f * d + g, t[10] = u - v * d;
    } else if (e.order === "XZY") {
      const u = a * l, f = a * c, g = o * l, v = o * c;
      t[0] = l * h, t[4] = -d, t[8] = c * h, t[1] = u * d + v, t[5] = a * h, t[9] = f * d - g, t[2] = g * d - f, t[6] = o * h, t[10] = v * d + u;
    }
    return t[3] = 0, t[7] = 0, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, this;
  }
  /**
   * Sets the rotation component of this matrix to the rotation specified by
   * the given Quaternion as outlined [here](https://en.wikipedia.org/wiki/Rotation_matrix#Quaternion)
   * The rest of the matrix is set to the identity.
   *
   * @param {Quaternion} q - The Quaternion.
   * @return {Matrix4} A reference to this matrix.
   */
  makeRotationFromQuaternion(e) {
    return this.compose(jv, e, Yv);
  }
  /**
   * Sets the rotation component of the transformation matrix, looking from `eye` towards
   * `target`, and oriented by the up-direction.
   *
   * @param {Vector3} eye - The eye vector.
   * @param {Vector3} target - The target vector.
   * @param {Vector3} up - The up vector.
   * @return {Matrix4} A reference to this matrix.
   */
  lookAt(e, t, i) {
    const n = this.elements;
    return ei.subVectors(e, t), ei.lengthSq() === 0 && (ei.z = 1), ei.normalize(), _n.crossVectors(i, ei), _n.lengthSq() === 0 && (Math.abs(i.z) === 1 ? ei.x += 1e-4 : ei.z += 1e-4, ei.normalize(), _n.crossVectors(i, ei)), _n.normalize(), Zr.crossVectors(ei, _n), n[0] = _n.x, n[4] = Zr.x, n[8] = ei.x, n[1] = _n.y, n[5] = Zr.y, n[9] = ei.y, n[2] = _n.z, n[6] = Zr.z, n[10] = ei.z, this;
  }
  /**
   * Post-multiplies this matrix by the given 4x4 matrix.
   *
   * @param {Matrix4} m - The matrix to multiply with.
   * @return {Matrix4} A reference to this matrix.
   */
  multiply(e) {
    return this.multiplyMatrices(this, e);
  }
  /**
   * Pre-multiplies this matrix by the given 4x4 matrix.
   *
   * @param {Matrix4} m - The matrix to multiply with.
   * @return {Matrix4} A reference to this matrix.
   */
  premultiply(e) {
    return this.multiplyMatrices(e, this);
  }
  /**
   * Multiples the given 4x4 matrices and stores the result
   * in this matrix.
   *
   * @param {Matrix4} a - The first matrix.
   * @param {Matrix4} b - The second matrix.
   * @return {Matrix4} A reference to this matrix.
   */
  multiplyMatrices(e, t) {
    const i = e.elements, n = t.elements, r = this.elements, a = i[0], o = i[4], l = i[8], c = i[12], h = i[1], d = i[5], u = i[9], f = i[13], g = i[2], v = i[6], m = i[10], p = i[14], w = i[3], M = i[7], T = i[11], E = i[15], A = n[0], R = n[4], F = n[8], y = n[12], b = n[1], P = n[5], H = n[9], V = n[13], Y = n[2], X = n[6], q = n[10], z = n[14], J = n[3], ue = n[7], le = n[11], fe = n[15];
    return r[0] = a * A + o * b + l * Y + c * J, r[4] = a * R + o * P + l * X + c * ue, r[8] = a * F + o * H + l * q + c * le, r[12] = a * y + o * V + l * z + c * fe, r[1] = h * A + d * b + u * Y + f * J, r[5] = h * R + d * P + u * X + f * ue, r[9] = h * F + d * H + u * q + f * le, r[13] = h * y + d * V + u * z + f * fe, r[2] = g * A + v * b + m * Y + p * J, r[6] = g * R + v * P + m * X + p * ue, r[10] = g * F + v * H + m * q + p * le, r[14] = g * y + v * V + m * z + p * fe, r[3] = w * A + M * b + T * Y + E * J, r[7] = w * R + M * P + T * X + E * ue, r[11] = w * F + M * H + T * q + E * le, r[15] = w * y + M * V + T * z + E * fe, this;
  }
  /**
   * Multiplies every component of the matrix by the given scalar.
   *
   * @param {number} s - The scalar.
   * @return {Matrix4} A reference to this matrix.
   */
  multiplyScalar(e) {
    const t = this.elements;
    return t[0] *= e, t[4] *= e, t[8] *= e, t[12] *= e, t[1] *= e, t[5] *= e, t[9] *= e, t[13] *= e, t[2] *= e, t[6] *= e, t[10] *= e, t[14] *= e, t[3] *= e, t[7] *= e, t[11] *= e, t[15] *= e, this;
  }
  /**
   * Computes and returns the determinant of this matrix.
   *
   * Based on the method outlined [here](http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.html).
   *
   * @return {number} The determinant.
   */
  determinant() {
    const e = this.elements, t = e[0], i = e[4], n = e[8], r = e[12], a = e[1], o = e[5], l = e[9], c = e[13], h = e[2], d = e[6], u = e[10], f = e[14], g = e[3], v = e[7], m = e[11], p = e[15], w = l * f - c * u, M = o * f - c * d, T = o * u - l * d, E = a * f - c * h, A = a * u - l * h, R = a * d - o * h;
    return t * (v * w - m * M + p * T) - i * (g * w - m * E + p * A) + n * (g * M - v * E + p * R) - r * (g * T - v * A + m * R);
  }
  /**
   * Transposes this matrix in place.
   *
   * @return {Matrix4} A reference to this matrix.
   */
  transpose() {
    const e = this.elements;
    let t;
    return t = e[1], e[1] = e[4], e[4] = t, t = e[2], e[2] = e[8], e[8] = t, t = e[6], e[6] = e[9], e[9] = t, t = e[3], e[3] = e[12], e[12] = t, t = e[7], e[7] = e[13], e[13] = t, t = e[11], e[11] = e[14], e[14] = t, this;
  }
  /**
   * Sets the position component for this matrix from the given vector,
   * without affecting the rest of the matrix.
   *
   * @param {number|Vector3} x - The x component of the vector or alternatively the vector object.
   * @param {number} y - The y component of the vector.
   * @param {number} z - The z component of the vector.
   * @return {Matrix4} A reference to this matrix.
   */
  setPosition(e, t, i) {
    const n = this.elements;
    return e.isVector3 ? (n[12] = e.x, n[13] = e.y, n[14] = e.z) : (n[12] = e, n[13] = t, n[14] = i), this;
  }
  /**
   * Inverts this matrix, using the [analytic method](https://en.wikipedia.org/wiki/Invertible_matrix#Analytic_solution).
   * You can not invert with a determinant of zero. If you attempt this, the method produces
   * a zero matrix instead.
   *
   * @return {Matrix4} A reference to this matrix.
   */
  invert() {
    const e = this.elements, t = e[0], i = e[1], n = e[2], r = e[3], a = e[4], o = e[5], l = e[6], c = e[7], h = e[8], d = e[9], u = e[10], f = e[11], g = e[12], v = e[13], m = e[14], p = e[15], w = d * m * c - v * u * c + v * l * f - o * m * f - d * l * p + o * u * p, M = g * u * c - h * m * c - g * l * f + a * m * f + h * l * p - a * u * p, T = h * v * c - g * d * c + g * o * f - a * v * f - h * o * p + a * d * p, E = g * d * l - h * v * l - g * o * u + a * v * u + h * o * m - a * d * m, A = t * w + i * M + n * T + r * E;
    if (A === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    const R = 1 / A;
    return e[0] = w * R, e[1] = (v * u * r - d * m * r - v * n * f + i * m * f + d * n * p - i * u * p) * R, e[2] = (o * m * r - v * l * r + v * n * c - i * m * c - o * n * p + i * l * p) * R, e[3] = (d * l * r - o * u * r - d * n * c + i * u * c + o * n * f - i * l * f) * R, e[4] = M * R, e[5] = (h * m * r - g * u * r + g * n * f - t * m * f - h * n * p + t * u * p) * R, e[6] = (g * l * r - a * m * r - g * n * c + t * m * c + a * n * p - t * l * p) * R, e[7] = (a * u * r - h * l * r + h * n * c - t * u * c - a * n * f + t * l * f) * R, e[8] = T * R, e[9] = (g * d * r - h * v * r - g * i * f + t * v * f + h * i * p - t * d * p) * R, e[10] = (a * v * r - g * o * r + g * i * c - t * v * c - a * i * p + t * o * p) * R, e[11] = (h * o * r - a * d * r - h * i * c + t * d * c + a * i * f - t * o * f) * R, e[12] = E * R, e[13] = (h * v * n - g * d * n + g * i * u - t * v * u - h * i * m + t * d * m) * R, e[14] = (g * o * n - a * v * n - g * i * l + t * v * l + a * i * m - t * o * m) * R, e[15] = (a * d * n - h * o * n + h * i * l - t * d * l - a * i * u + t * o * u) * R, this;
  }
  /**
   * Multiplies the columns of this matrix by the given vector.
   *
   * @param {Vector3} v - The scale vector.
   * @return {Matrix4} A reference to this matrix.
   */
  scale(e) {
    const t = this.elements, i = e.x, n = e.y, r = e.z;
    return t[0] *= i, t[4] *= n, t[8] *= r, t[1] *= i, t[5] *= n, t[9] *= r, t[2] *= i, t[6] *= n, t[10] *= r, t[3] *= i, t[7] *= n, t[11] *= r, this;
  }
  /**
   * Gets the maximum scale value of the three axes.
   *
   * @return {number} The maximum scale.
   */
  getMaxScaleOnAxis() {
    const e = this.elements, t = e[0] * e[0] + e[1] * e[1] + e[2] * e[2], i = e[4] * e[4] + e[5] * e[5] + e[6] * e[6], n = e[8] * e[8] + e[9] * e[9] + e[10] * e[10];
    return Math.sqrt(Math.max(t, i, n));
  }
  /**
   * Sets this matrix as a translation transform from the given vector.
   *
   * @param {number|Vector3} x - The amount to translate in the X axis or alternatively a translation vector.
   * @param {number} y - The amount to translate in the Y axis.
   * @param {number} z - The amount to translate in the z axis.
   * @return {Matrix4} A reference to this matrix.
   */
  makeTranslation(e, t, i) {
    return e.isVector3 ? this.set(
      1,
      0,
      0,
      e.x,
      0,
      1,
      0,
      e.y,
      0,
      0,
      1,
      e.z,
      0,
      0,
      0,
      1
    ) : this.set(
      1,
      0,
      0,
      e,
      0,
      1,
      0,
      t,
      0,
      0,
      1,
      i,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix as a rotational transformation around the X axis by
   * the given angle.
   *
   * @param {number} theta - The rotation in radians.
   * @return {Matrix4} A reference to this matrix.
   */
  makeRotationX(e) {
    const t = Math.cos(e), i = Math.sin(e);
    return this.set(
      1,
      0,
      0,
      0,
      0,
      t,
      -i,
      0,
      0,
      i,
      t,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix as a rotational transformation around the Y axis by
   * the given angle.
   *
   * @param {number} theta - The rotation in radians.
   * @return {Matrix4} A reference to this matrix.
   */
  makeRotationY(e) {
    const t = Math.cos(e), i = Math.sin(e);
    return this.set(
      t,
      0,
      i,
      0,
      0,
      1,
      0,
      0,
      -i,
      0,
      t,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix as a rotational transformation around the Z axis by
   * the given angle.
   *
   * @param {number} theta - The rotation in radians.
   * @return {Matrix4} A reference to this matrix.
   */
  makeRotationZ(e) {
    const t = Math.cos(e), i = Math.sin(e);
    return this.set(
      t,
      -i,
      0,
      0,
      i,
      t,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix as a rotational transformation around the given axis by
   * the given angle.
   *
   * This is a somewhat controversial but mathematically sound alternative to
   * rotating via Quaternions. See the discussion [here](https://www.gamedev.net/articles/programming/math-and-physics/do-we-really-need-quaternions-r1199).
   *
   * @param {Vector3} axis - The normalized rotation axis.
   * @param {number} angle - The rotation in radians.
   * @return {Matrix4} A reference to this matrix.
   */
  makeRotationAxis(e, t) {
    const i = Math.cos(t), n = Math.sin(t), r = 1 - i, a = e.x, o = e.y, l = e.z, c = r * a, h = r * o;
    return this.set(
      c * a + i,
      c * o - n * l,
      c * l + n * o,
      0,
      c * o + n * l,
      h * o + i,
      h * l - n * a,
      0,
      c * l - n * o,
      h * l + n * a,
      r * l * l + i,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix as a scale transformation.
   *
   * @param {number} x - The amount to scale in the X axis.
   * @param {number} y - The amount to scale in the Y axis.
   * @param {number} z - The amount to scale in the Z axis.
   * @return {Matrix4} A reference to this matrix.
   */
  makeScale(e, t, i) {
    return this.set(
      e,
      0,
      0,
      0,
      0,
      t,
      0,
      0,
      0,
      0,
      i,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix as a shear transformation.
   *
   * @param {number} xy - The amount to shear X by Y.
   * @param {number} xz - The amount to shear X by Z.
   * @param {number} yx - The amount to shear Y by X.
   * @param {number} yz - The amount to shear Y by Z.
   * @param {number} zx - The amount to shear Z by X.
   * @param {number} zy - The amount to shear Z by Y.
   * @return {Matrix4} A reference to this matrix.
   */
  makeShear(e, t, i, n, r, a) {
    return this.set(
      1,
      i,
      r,
      0,
      e,
      1,
      a,
      0,
      t,
      n,
      1,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix to the transformation composed of the given position,
   * rotation (Quaternion) and scale.
   *
   * @param {Vector3} position - The position vector.
   * @param {Quaternion} quaternion - The rotation as a Quaternion.
   * @param {Vector3} scale - The scale vector.
   * @return {Matrix4} A reference to this matrix.
   */
  compose(e, t, i) {
    const n = this.elements, r = t._x, a = t._y, o = t._z, l = t._w, c = r + r, h = a + a, d = o + o, u = r * c, f = r * h, g = r * d, v = a * h, m = a * d, p = o * d, w = l * c, M = l * h, T = l * d, E = i.x, A = i.y, R = i.z;
    return n[0] = (1 - (v + p)) * E, n[1] = (f + T) * E, n[2] = (g - M) * E, n[3] = 0, n[4] = (f - T) * A, n[5] = (1 - (u + p)) * A, n[6] = (m + w) * A, n[7] = 0, n[8] = (g + M) * R, n[9] = (m - w) * R, n[10] = (1 - (u + v)) * R, n[11] = 0, n[12] = e.x, n[13] = e.y, n[14] = e.z, n[15] = 1, this;
  }
  /**
   * Decomposes this matrix into its position, rotation and scale components
   * and provides the result in the given objects.
   *
   * Note: Not all matrices are decomposable in this way. For example, if an
   * object has a non-uniformly scaled parent, then the object's world matrix
   * may not be decomposable, and this method may not be appropriate.
   *
   * @param {Vector3} position - The position vector.
   * @param {Quaternion} quaternion - The rotation as a Quaternion.
   * @param {Vector3} scale - The scale vector.
   * @return {Matrix4} A reference to this matrix.
   */
  decompose(e, t, i) {
    const n = this.elements;
    if (e.x = n[12], e.y = n[13], e.z = n[14], this.determinant() === 0)
      return i.set(1, 1, 1), t.identity(), this;
    let r = us.set(n[0], n[1], n[2]).length();
    const a = us.set(n[4], n[5], n[6]).length(), o = us.set(n[8], n[9], n[10]).length();
    this.determinant() < 0 && (r = -r), wi.copy(this);
    const c = 1 / r, h = 1 / a, d = 1 / o;
    return wi.elements[0] *= c, wi.elements[1] *= c, wi.elements[2] *= c, wi.elements[4] *= h, wi.elements[5] *= h, wi.elements[6] *= h, wi.elements[8] *= d, wi.elements[9] *= d, wi.elements[10] *= d, t.setFromRotationMatrix(wi), i.x = r, i.y = a, i.z = o, this;
  }
  /**
  	 * Creates a perspective projection matrix. This is used internally by
  	 * {@link PerspectiveCamera#updateProjectionMatrix}.
  
  	 * @param {number} left - Left boundary of the viewing frustum at the near plane.
  	 * @param {number} right - Right boundary of the viewing frustum at the near plane.
  	 * @param {number} top - Top boundary of the viewing frustum at the near plane.
  	 * @param {number} bottom - Bottom boundary of the viewing frustum at the near plane.
  	 * @param {number} near - The distance from the camera to the near plane.
  	 * @param {number} far - The distance from the camera to the far plane.
  	 * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} [coordinateSystem=WebGLCoordinateSystem] - The coordinate system.
  	 * @param {boolean} [reversedDepth=false] - Whether to use a reversed depth.
  	 * @return {Matrix4} A reference to this matrix.
  	 */
  makePerspective(e, t, i, n, r, a, o = Bi, l = !1) {
    const c = this.elements, h = 2 * r / (t - e), d = 2 * r / (i - n), u = (t + e) / (t - e), f = (i + n) / (i - n);
    let g, v;
    if (l)
      g = r / (a - r), v = a * r / (a - r);
    else if (o === Bi)
      g = -(a + r) / (a - r), v = -2 * a * r / (a - r);
    else if (o === qa)
      g = -a / (a - r), v = -a * r / (a - r);
    else
      throw new Error("THREE.Matrix4.makePerspective(): Invalid coordinate system: " + o);
    return c[0] = h, c[4] = 0, c[8] = u, c[12] = 0, c[1] = 0, c[5] = d, c[9] = f, c[13] = 0, c[2] = 0, c[6] = 0, c[10] = g, c[14] = v, c[3] = 0, c[7] = 0, c[11] = -1, c[15] = 0, this;
  }
  /**
  	 * Creates a orthographic projection matrix. This is used internally by
  	 * {@link OrthographicCamera#updateProjectionMatrix}.
  
  	 * @param {number} left - Left boundary of the viewing frustum at the near plane.
  	 * @param {number} right - Right boundary of the viewing frustum at the near plane.
  	 * @param {number} top - Top boundary of the viewing frustum at the near plane.
  	 * @param {number} bottom - Bottom boundary of the viewing frustum at the near plane.
  	 * @param {number} near - The distance from the camera to the near plane.
  	 * @param {number} far - The distance from the camera to the far plane.
  	 * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} [coordinateSystem=WebGLCoordinateSystem] - The coordinate system.
  	 * @param {boolean} [reversedDepth=false] - Whether to use a reversed depth.
  	 * @return {Matrix4} A reference to this matrix.
  	 */
  makeOrthographic(e, t, i, n, r, a, o = Bi, l = !1) {
    const c = this.elements, h = 2 / (t - e), d = 2 / (i - n), u = -(t + e) / (t - e), f = -(i + n) / (i - n);
    let g, v;
    if (l)
      g = 1 / (a - r), v = a / (a - r);
    else if (o === Bi)
      g = -2 / (a - r), v = -(a + r) / (a - r);
    else if (o === qa)
      g = -1 / (a - r), v = -r / (a - r);
    else
      throw new Error("THREE.Matrix4.makeOrthographic(): Invalid coordinate system: " + o);
    return c[0] = h, c[4] = 0, c[8] = 0, c[12] = u, c[1] = 0, c[5] = d, c[9] = 0, c[13] = f, c[2] = 0, c[6] = 0, c[10] = g, c[14] = v, c[3] = 0, c[7] = 0, c[11] = 0, c[15] = 1, this;
  }
  /**
   * Returns `true` if this matrix is equal with the given one.
   *
   * @param {Matrix4} matrix - The matrix to test for equality.
   * @return {boolean} Whether this matrix is equal with the given one.
   */
  equals(e) {
    const t = this.elements, i = e.elements;
    for (let n = 0; n < 16; n++)
      if (t[n] !== i[n]) return !1;
    return !0;
  }
  /**
   * Sets the elements of the matrix from the given array.
   *
   * @param {Array<number>} array - The matrix elements in column-major order.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Matrix4} A reference to this matrix.
   */
  fromArray(e, t = 0) {
    for (let i = 0; i < 16; i++)
      this.elements[i] = e[i + t];
    return this;
  }
  /**
   * Writes the elements of this matrix to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the matrix elements in column-major order.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The matrix elements in column-major order.
   */
  toArray(e = [], t = 0) {
    const i = this.elements;
    return e[t] = i[0], e[t + 1] = i[1], e[t + 2] = i[2], e[t + 3] = i[3], e[t + 4] = i[4], e[t + 5] = i[5], e[t + 6] = i[6], e[t + 7] = i[7], e[t + 8] = i[8], e[t + 9] = i[9], e[t + 10] = i[10], e[t + 11] = i[11], e[t + 12] = i[12], e[t + 13] = i[13], e[t + 14] = i[14], e[t + 15] = i[15], e;
  }
}
const us = /* @__PURE__ */ new O(), wi = /* @__PURE__ */ new ze(), jv = /* @__PURE__ */ new O(0, 0, 0), Yv = /* @__PURE__ */ new O(1, 1, 1), _n = /* @__PURE__ */ new O(), Zr = /* @__PURE__ */ new O(), ei = /* @__PURE__ */ new O(), id = /* @__PURE__ */ new ze(), nd = /* @__PURE__ */ new si();
class kt {
  /**
   * Constructs a new euler instance.
   *
   * @param {number} [x=0] - The angle of the x axis in radians.
   * @param {number} [y=0] - The angle of the y axis in radians.
   * @param {number} [z=0] - The angle of the z axis in radians.
   * @param {string} [order=Euler.DEFAULT_ORDER] - A string representing the order that the rotations are applied.
   */
  constructor(e = 0, t = 0, i = 0, n = kt.DEFAULT_ORDER) {
    this.isEuler = !0, this._x = e, this._y = t, this._z = i, this._order = n;
  }
  /**
   * The angle of the x axis in radians.
   *
   * @type {number}
   * @default 0
   */
  get x() {
    return this._x;
  }
  set x(e) {
    this._x = e, this._onChangeCallback();
  }
  /**
   * The angle of the y axis in radians.
   *
   * @type {number}
   * @default 0
   */
  get y() {
    return this._y;
  }
  set y(e) {
    this._y = e, this._onChangeCallback();
  }
  /**
   * The angle of the z axis in radians.
   *
   * @type {number}
   * @default 0
   */
  get z() {
    return this._z;
  }
  set z(e) {
    this._z = e, this._onChangeCallback();
  }
  /**
   * A string representing the order that the rotations are applied.
   *
   * @type {string}
   * @default 'XYZ'
   */
  get order() {
    return this._order;
  }
  set order(e) {
    this._order = e, this._onChangeCallback();
  }
  /**
   * Sets the Euler components.
   *
   * @param {number} x - The angle of the x axis in radians.
   * @param {number} y - The angle of the y axis in radians.
   * @param {number} z - The angle of the z axis in radians.
   * @param {string} [order] - A string representing the order that the rotations are applied.
   * @return {Euler} A reference to this Euler instance.
   */
  set(e, t, i, n = this._order) {
    return this._x = e, this._y = t, this._z = i, this._order = n, this._onChangeCallback(), this;
  }
  /**
   * Returns a new Euler instance with copied values from this instance.
   *
   * @return {Euler} A clone of this instance.
   */
  clone() {
    return new this.constructor(this._x, this._y, this._z, this._order);
  }
  /**
   * Copies the values of the given Euler instance to this instance.
   *
   * @param {Euler} euler - The Euler instance to copy.
   * @return {Euler} A reference to this Euler instance.
   */
  copy(e) {
    return this._x = e._x, this._y = e._y, this._z = e._z, this._order = e._order, this._onChangeCallback(), this;
  }
  /**
   * Sets the angles of this Euler instance from a pure rotation matrix.
   *
   * @param {Matrix4} m - A 4x4 matrix of which the upper 3x3 of matrix is a pure rotation matrix (i.e. unscaled).
   * @param {string} [order] - A string representing the order that the rotations are applied.
   * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
   * @return {Euler} A reference to this Euler instance.
   */
  setFromRotationMatrix(e, t = this._order, i = !0) {
    const n = e.elements, r = n[0], a = n[4], o = n[8], l = n[1], c = n[5], h = n[9], d = n[2], u = n[6], f = n[10];
    switch (t) {
      case "XYZ":
        this._y = Math.asin(Xe(o, -1, 1)), Math.abs(o) < 0.9999999 ? (this._x = Math.atan2(-h, f), this._z = Math.atan2(-a, r)) : (this._x = Math.atan2(u, c), this._z = 0);
        break;
      case "YXZ":
        this._x = Math.asin(-Xe(h, -1, 1)), Math.abs(h) < 0.9999999 ? (this._y = Math.atan2(o, f), this._z = Math.atan2(l, c)) : (this._y = Math.atan2(-d, r), this._z = 0);
        break;
      case "ZXY":
        this._x = Math.asin(Xe(u, -1, 1)), Math.abs(u) < 0.9999999 ? (this._y = Math.atan2(-d, f), this._z = Math.atan2(-a, c)) : (this._y = 0, this._z = Math.atan2(l, r));
        break;
      case "ZYX":
        this._y = Math.asin(-Xe(d, -1, 1)), Math.abs(d) < 0.9999999 ? (this._x = Math.atan2(u, f), this._z = Math.atan2(l, r)) : (this._x = 0, this._z = Math.atan2(-a, c));
        break;
      case "YZX":
        this._z = Math.asin(Xe(l, -1, 1)), Math.abs(l) < 0.9999999 ? (this._x = Math.atan2(-h, c), this._y = Math.atan2(-d, r)) : (this._x = 0, this._y = Math.atan2(o, f));
        break;
      case "XZY":
        this._z = Math.asin(-Xe(a, -1, 1)), Math.abs(a) < 0.9999999 ? (this._x = Math.atan2(u, c), this._y = Math.atan2(o, r)) : (this._x = Math.atan2(-h, f), this._y = 0);
        break;
      default:
        Te("Euler: .setFromRotationMatrix() encountered an unknown order: " + t);
    }
    return this._order = t, i === !0 && this._onChangeCallback(), this;
  }
  /**
   * Sets the angles of this Euler instance from a normalized quaternion.
   *
   * @param {Quaternion} q - A normalized Quaternion.
   * @param {string} [order] - A string representing the order that the rotations are applied.
   * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
   * @return {Euler} A reference to this Euler instance.
   */
  setFromQuaternion(e, t, i) {
    return id.makeRotationFromQuaternion(e), this.setFromRotationMatrix(id, t, i);
  }
  /**
   * Sets the angles of this Euler instance from the given vector.
   *
   * @param {Vector3} v - The vector.
   * @param {string} [order] - A string representing the order that the rotations are applied.
   * @return {Euler} A reference to this Euler instance.
   */
  setFromVector3(e, t = this._order) {
    return this.set(e.x, e.y, e.z, t);
  }
  /**
   * Resets the euler angle with a new order by creating a quaternion from this
   * euler angle and then setting this euler angle with the quaternion and the
   * new order.
   *
   * Warning: This discards revolution information.
   *
   * @param {string} [newOrder] - A string representing the new order that the rotations are applied.
   * @return {Euler} A reference to this Euler instance.
   */
  reorder(e) {
    return nd.setFromEuler(this), this.setFromQuaternion(nd, e);
  }
  /**
   * Returns `true` if this Euler instance is equal with the given one.
   *
   * @param {Euler} euler - The Euler instance to test for equality.
   * @return {boolean} Whether this Euler instance is equal with the given one.
   */
  equals(e) {
    return e._x === this._x && e._y === this._y && e._z === this._z && e._order === this._order;
  }
  /**
   * Sets this Euler instance's components to values from the given array. The first three
   * entries of the array are assign to the x,y and z components. An optional fourth entry
   * defines the Euler order.
   *
   * @param {Array<number,number,number,?string>} array - An array holding the Euler component values.
   * @return {Euler} A reference to this Euler instance.
   */
  fromArray(e) {
    return this._x = e[0], this._y = e[1], this._z = e[2], e[3] !== void 0 && (this._order = e[3]), this._onChangeCallback(), this;
  }
  /**
   * Writes the components of this Euler instance to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number,number,number,string>} [array=[]] - The target array holding the Euler components.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number,number,number,string>} The Euler components.
   */
  toArray(e = [], t = 0) {
    return e[t] = this._x, e[t + 1] = this._y, e[t + 2] = this._z, e[t + 3] = this._order, e;
  }
  _onChange(e) {
    return this._onChangeCallback = e, this;
  }
  _onChangeCallback() {
  }
  *[Symbol.iterator]() {
    yield this._x, yield this._y, yield this._z, yield this._order;
  }
}
kt.DEFAULT_ORDER = "XYZ";
class Qu {
  /**
   * Constructs a new layers instance, with membership
   * initially set to layer `0`.
   */
  constructor() {
    this.mask = 1;
  }
  /**
   * Sets membership to the given layer, and remove membership all other layers.
   *
   * @param {number} layer - The layer to set.
   */
  set(e) {
    this.mask = (1 << e | 0) >>> 0;
  }
  /**
   * Adds membership of the given layer.
   *
   * @param {number} layer - The layer to enable.
   */
  enable(e) {
    this.mask |= 1 << e | 0;
  }
  /**
   * Adds membership to all layers.
   */
  enableAll() {
    this.mask = -1;
  }
  /**
   * Toggles the membership of the given layer.
   *
   * @param {number} layer - The layer to toggle.
   */
  toggle(e) {
    this.mask ^= 1 << e | 0;
  }
  /**
   * Removes membership of the given layer.
   *
   * @param {number} layer - The layer to enable.
   */
  disable(e) {
    this.mask &= ~(1 << e | 0);
  }
  /**
   * Removes the membership from all layers.
   */
  disableAll() {
    this.mask = 0;
  }
  /**
   * Returns `true` if this and the given layers object have at least one
   * layer in common.
   *
   * @param {Layers} layers - The layers to test.
   * @return {boolean } Whether this and the given layers object have at least one layer in common or not.
   */
  test(e) {
    return (this.mask & e.mask) !== 0;
  }
  /**
   * Returns `true` if the given layer is enabled.
   *
   * @param {number} layer - The layer to test.
   * @return {boolean } Whether the given layer is enabled or not.
   */
  isEnabled(e) {
    return (this.mask & (1 << e | 0)) !== 0;
  }
}
let Kv = 0;
const sd = /* @__PURE__ */ new O(), fs = /* @__PURE__ */ new si(), Ji = /* @__PURE__ */ new ze(), Jr = /* @__PURE__ */ new O(), ir = /* @__PURE__ */ new O(), Zv = /* @__PURE__ */ new O(), Jv = /* @__PURE__ */ new si(), rd = /* @__PURE__ */ new O(1, 0, 0), ad = /* @__PURE__ */ new O(0, 1, 0), od = /* @__PURE__ */ new O(0, 0, 1), ld = { type: "added" }, Qv = { type: "removed" }, ps = { type: "childadded", child: null }, Lo = { type: "childremoved", child: null };
class wt extends ss {
  /**
   * Constructs a new 3D object.
   */
  constructor() {
    super(), this.isObject3D = !0, Object.defineProperty(this, "id", { value: Kv++ }), this.uuid = Ei(), this.name = "", this.type = "Object3D", this.parent = null, this.children = [], this.up = wt.DEFAULT_UP.clone();
    const e = new O(), t = new kt(), i = new si(), n = new O(1, 1, 1);
    function r() {
      i.setFromEuler(t, !1);
    }
    function a() {
      t.setFromQuaternion(i, void 0, !1);
    }
    t._onChange(r), i._onChange(a), Object.defineProperties(this, {
      /**
       * Represents the object's local position.
       *
       * @name Object3D#position
       * @type {Vector3}
       * @default (0,0,0)
       */
      position: {
        configurable: !0,
        enumerable: !0,
        value: e
      },
      /**
       * Represents the object's local rotation as Euler angles, in radians.
       *
       * @name Object3D#rotation
       * @type {Euler}
       * @default (0,0,0)
       */
      rotation: {
        configurable: !0,
        enumerable: !0,
        value: t
      },
      /**
       * Represents the object's local rotation as Quaternions.
       *
       * @name Object3D#quaternion
       * @type {Quaternion}
       */
      quaternion: {
        configurable: !0,
        enumerable: !0,
        value: i
      },
      /**
       * Represents the object's local scale.
       *
       * @name Object3D#scale
       * @type {Vector3}
       * @default (1,1,1)
       */
      scale: {
        configurable: !0,
        enumerable: !0,
        value: n
      },
      /**
       * Represents the object's model-view matrix.
       *
       * @name Object3D#modelViewMatrix
       * @type {Matrix4}
       */
      modelViewMatrix: {
        value: new ze()
      },
      /**
       * Represents the object's normal matrix.
       *
       * @name Object3D#normalMatrix
       * @type {Matrix3}
       */
      normalMatrix: {
        value: new Be()
      }
    }), this.matrix = new ze(), this.matrixWorld = new ze(), this.matrixAutoUpdate = wt.DEFAULT_MATRIX_AUTO_UPDATE, this.matrixWorldAutoUpdate = wt.DEFAULT_MATRIX_WORLD_AUTO_UPDATE, this.matrixWorldNeedsUpdate = !1, this.layers = new Qu(), this.visible = !0, this.castShadow = !1, this.receiveShadow = !1, this.frustumCulled = !0, this.renderOrder = 0, this.animations = [], this.customDepthMaterial = void 0, this.customDistanceMaterial = void 0, this.userData = {};
  }
  /**
   * A callback that is executed immediately before a 3D object is rendered to a shadow map.
   *
   * @param {Renderer|WebGLRenderer} renderer - The renderer.
   * @param {Object3D} object - The 3D object.
   * @param {Camera} camera - The camera that is used to render the scene.
   * @param {Camera} shadowCamera - The shadow camera.
   * @param {BufferGeometry} geometry - The 3D object's geometry.
   * @param {Material} depthMaterial - The depth material.
   * @param {Object} group - The geometry group data.
   */
  onBeforeShadow() {
  }
  /**
   * A callback that is executed immediately after a 3D object is rendered to a shadow map.
   *
   * @param {Renderer|WebGLRenderer} renderer - The renderer.
   * @param {Object3D} object - The 3D object.
   * @param {Camera} camera - The camera that is used to render the scene.
   * @param {Camera} shadowCamera - The shadow camera.
   * @param {BufferGeometry} geometry - The 3D object's geometry.
   * @param {Material} depthMaterial - The depth material.
   * @param {Object} group - The geometry group data.
   */
  onAfterShadow() {
  }
  /**
   * A callback that is executed immediately before a 3D object is rendered.
   *
   * @param {Renderer|WebGLRenderer} renderer - The renderer.
   * @param {Object3D} object - The 3D object.
   * @param {Camera} camera - The camera that is used to render the scene.
   * @param {BufferGeometry} geometry - The 3D object's geometry.
   * @param {Material} material - The 3D object's material.
   * @param {Object} group - The geometry group data.
   */
  onBeforeRender() {
  }
  /**
   * A callback that is executed immediately after a 3D object is rendered.
   *
   * @param {Renderer|WebGLRenderer} renderer - The renderer.
   * @param {Object3D} object - The 3D object.
   * @param {Camera} camera - The camera that is used to render the scene.
   * @param {BufferGeometry} geometry - The 3D object's geometry.
   * @param {Material} material - The 3D object's material.
   * @param {Object} group - The geometry group data.
   */
  onAfterRender() {
  }
  /**
   * Applies the given transformation matrix to the object and updates the object's position,
   * rotation and scale.
   *
   * @param {Matrix4} matrix - The transformation matrix.
   */
  applyMatrix4(e) {
    this.matrixAutoUpdate && this.updateMatrix(), this.matrix.premultiply(e), this.matrix.decompose(this.position, this.quaternion, this.scale);
  }
  /**
   * Applies a rotation represented by given the quaternion to the 3D object.
   *
   * @param {Quaternion} q - The quaternion.
   * @return {Object3D} A reference to this instance.
   */
  applyQuaternion(e) {
    return this.quaternion.premultiply(e), this;
  }
  /**
   * Sets the given rotation represented as an axis/angle couple to the 3D object.
   *
   * @param {Vector3} axis - The (normalized) axis vector.
   * @param {number} angle - The angle in radians.
   */
  setRotationFromAxisAngle(e, t) {
    this.quaternion.setFromAxisAngle(e, t);
  }
  /**
   * Sets the given rotation represented as Euler angles to the 3D object.
   *
   * @param {Euler} euler - The Euler angles.
   */
  setRotationFromEuler(e) {
    this.quaternion.setFromEuler(e, !0);
  }
  /**
   * Sets the given rotation represented as rotation matrix to the 3D object.
   *
   * @param {Matrix4} m - Although a 4x4 matrix is expected, the upper 3x3 portion must be
   * a pure rotation matrix (i.e, unscaled).
   */
  setRotationFromMatrix(e) {
    this.quaternion.setFromRotationMatrix(e);
  }
  /**
   * Sets the given rotation represented as a Quaternion to the 3D object.
   *
   * @param {Quaternion} q - The Quaternion
   */
  setRotationFromQuaternion(e) {
    this.quaternion.copy(e);
  }
  /**
   * Rotates the 3D object along an axis in local space.
   *
   * @param {Vector3} axis - The (normalized) axis vector.
   * @param {number} angle - The angle in radians.
   * @return {Object3D} A reference to this instance.
   */
  rotateOnAxis(e, t) {
    return fs.setFromAxisAngle(e, t), this.quaternion.multiply(fs), this;
  }
  /**
   * Rotates the 3D object along an axis in world space.
   *
   * @param {Vector3} axis - The (normalized) axis vector.
   * @param {number} angle - The angle in radians.
   * @return {Object3D} A reference to this instance.
   */
  rotateOnWorldAxis(e, t) {
    return fs.setFromAxisAngle(e, t), this.quaternion.premultiply(fs), this;
  }
  /**
   * Rotates the 3D object around its X axis in local space.
   *
   * @param {number} angle - The angle in radians.
   * @return {Object3D} A reference to this instance.
   */
  rotateX(e) {
    return this.rotateOnAxis(rd, e);
  }
  /**
   * Rotates the 3D object around its Y axis in local space.
   *
   * @param {number} angle - The angle in radians.
   * @return {Object3D} A reference to this instance.
   */
  rotateY(e) {
    return this.rotateOnAxis(ad, e);
  }
  /**
   * Rotates the 3D object around its Z axis in local space.
   *
   * @param {number} angle - The angle in radians.
   * @return {Object3D} A reference to this instance.
   */
  rotateZ(e) {
    return this.rotateOnAxis(od, e);
  }
  /**
   * Translate the 3D object by a distance along the given axis in local space.
   *
   * @param {Vector3} axis - The (normalized) axis vector.
   * @param {number} distance - The distance in world units.
   * @return {Object3D} A reference to this instance.
   */
  translateOnAxis(e, t) {
    return sd.copy(e).applyQuaternion(this.quaternion), this.position.add(sd.multiplyScalar(t)), this;
  }
  /**
   * Translate the 3D object by a distance along its X-axis in local space.
   *
   * @param {number} distance - The distance in world units.
   * @return {Object3D} A reference to this instance.
   */
  translateX(e) {
    return this.translateOnAxis(rd, e);
  }
  /**
   * Translate the 3D object by a distance along its Y-axis in local space.
   *
   * @param {number} distance - The distance in world units.
   * @return {Object3D} A reference to this instance.
   */
  translateY(e) {
    return this.translateOnAxis(ad, e);
  }
  /**
   * Translate the 3D object by a distance along its Z-axis in local space.
   *
   * @param {number} distance - The distance in world units.
   * @return {Object3D} A reference to this instance.
   */
  translateZ(e) {
    return this.translateOnAxis(od, e);
  }
  /**
   * Converts the given vector from this 3D object's local space to world space.
   *
   * @param {Vector3} vector - The vector to convert.
   * @return {Vector3} The converted vector.
   */
  localToWorld(e) {
    return this.updateWorldMatrix(!0, !1), e.applyMatrix4(this.matrixWorld);
  }
  /**
   * Converts the given vector from this 3D object's word space to local space.
   *
   * @param {Vector3} vector - The vector to convert.
   * @return {Vector3} The converted vector.
   */
  worldToLocal(e) {
    return this.updateWorldMatrix(!0, !1), e.applyMatrix4(Ji.copy(this.matrixWorld).invert());
  }
  /**
   * Rotates the object to face a point in world space.
   *
   * This method does not support objects having non-uniformly-scaled parent(s).
   *
   * @param {number|Vector3} x - The x coordinate in world space. Alternatively, a vector representing a position in world space
   * @param {number} [y] - The y coordinate in world space.
   * @param {number} [z] - The z coordinate in world space.
   */
  lookAt(e, t, i) {
    e.isVector3 ? Jr.copy(e) : Jr.set(e, t, i);
    const n = this.parent;
    this.updateWorldMatrix(!0, !1), ir.setFromMatrixPosition(this.matrixWorld), this.isCamera || this.isLight ? Ji.lookAt(ir, Jr, this.up) : Ji.lookAt(Jr, ir, this.up), this.quaternion.setFromRotationMatrix(Ji), n && (Ji.extractRotation(n.matrixWorld), fs.setFromRotationMatrix(Ji), this.quaternion.premultiply(fs.invert()));
  }
  /**
   * Adds the given 3D object as a child to this 3D object. An arbitrary number of
   * objects may be added. Any current parent on an object passed in here will be
   * removed, since an object can have at most one parent.
   *
   * @fires Object3D#added
   * @fires Object3D#childadded
   * @param {Object3D} object - The 3D object to add.
   * @return {Object3D} A reference to this instance.
   */
  add(e) {
    if (arguments.length > 1) {
      for (let t = 0; t < arguments.length; t++)
        this.add(arguments[t]);
      return this;
    }
    return e === this ? (Ce("Object3D.add: object can't be added as a child of itself.", e), this) : (e && e.isObject3D ? (e.removeFromParent(), e.parent = this, this.children.push(e), e.dispatchEvent(ld), ps.child = e, this.dispatchEvent(ps), ps.child = null) : Ce("Object3D.add: object not an instance of THREE.Object3D.", e), this);
  }
  /**
   * Removes the given 3D object as child from this 3D object.
   * An arbitrary number of objects may be removed.
   *
   * @fires Object3D#removed
   * @fires Object3D#childremoved
   * @param {Object3D} object - The 3D object to remove.
   * @return {Object3D} A reference to this instance.
   */
  remove(e) {
    if (arguments.length > 1) {
      for (let i = 0; i < arguments.length; i++)
        this.remove(arguments[i]);
      return this;
    }
    const t = this.children.indexOf(e);
    return t !== -1 && (e.parent = null, this.children.splice(t, 1), e.dispatchEvent(Qv), Lo.child = e, this.dispatchEvent(Lo), Lo.child = null), this;
  }
  /**
   * Removes this 3D object from its current parent.
   *
   * @fires Object3D#removed
   * @fires Object3D#childremoved
   * @return {Object3D} A reference to this instance.
   */
  removeFromParent() {
    const e = this.parent;
    return e !== null && e.remove(this), this;
  }
  /**
   * Removes all child objects.
   *
   * @fires Object3D#removed
   * @fires Object3D#childremoved
   * @return {Object3D} A reference to this instance.
   */
  clear() {
    return this.remove(...this.children);
  }
  /**
   * Adds the given 3D object as a child of this 3D object, while maintaining the object's world
   * transform. This method does not support scene graphs having non-uniformly-scaled nodes(s).
   *
   * @fires Object3D#added
   * @fires Object3D#childadded
   * @param {Object3D} object - The 3D object to attach.
   * @return {Object3D} A reference to this instance.
   */
  attach(e) {
    return this.updateWorldMatrix(!0, !1), Ji.copy(this.matrixWorld).invert(), e.parent !== null && (e.parent.updateWorldMatrix(!0, !1), Ji.multiply(e.parent.matrixWorld)), e.applyMatrix4(Ji), e.removeFromParent(), e.parent = this, this.children.push(e), e.updateWorldMatrix(!1, !0), e.dispatchEvent(ld), ps.child = e, this.dispatchEvent(ps), ps.child = null, this;
  }
  /**
   * Searches through the 3D object and its children, starting with the 3D object
   * itself, and returns the first with a matching ID.
   *
   * @param {number} id - The id.
   * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
   */
  getObjectById(e) {
    return this.getObjectByProperty("id", e);
  }
  /**
   * Searches through the 3D object and its children, starting with the 3D object
   * itself, and returns the first with a matching name.
   *
   * @param {string} name - The name.
   * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
   */
  getObjectByName(e) {
    return this.getObjectByProperty("name", e);
  }
  /**
   * Searches through the 3D object and its children, starting with the 3D object
   * itself, and returns the first with a matching property value.
   *
   * @param {string} name - The name of the property.
   * @param {any} value - The value.
   * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
   */
  getObjectByProperty(e, t) {
    if (this[e] === t) return this;
    for (let i = 0, n = this.children.length; i < n; i++) {
      const a = this.children[i].getObjectByProperty(e, t);
      if (a !== void 0)
        return a;
    }
  }
  /**
   * Searches through the 3D object and its children, starting with the 3D object
   * itself, and returns all 3D objects with a matching property value.
   *
   * @param {string} name - The name of the property.
   * @param {any} value - The value.
   * @param {Array<Object3D>} result - The method stores the result in this array.
   * @return {Array<Object3D>} The found 3D objects.
   */
  getObjectsByProperty(e, t, i = []) {
    this[e] === t && i.push(this);
    const n = this.children;
    for (let r = 0, a = n.length; r < a; r++)
      n[r].getObjectsByProperty(e, t, i);
    return i;
  }
  /**
   * Returns a vector representing the position of the 3D object in world space.
   *
   * @param {Vector3} target - The target vector the result is stored to.
   * @return {Vector3} The 3D object's position in world space.
   */
  getWorldPosition(e) {
    return this.updateWorldMatrix(!0, !1), e.setFromMatrixPosition(this.matrixWorld);
  }
  /**
   * Returns a Quaternion representing the position of the 3D object in world space.
   *
   * @param {Quaternion} target - The target Quaternion the result is stored to.
   * @return {Quaternion} The 3D object's rotation in world space.
   */
  getWorldQuaternion(e) {
    return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(ir, e, Zv), e;
  }
  /**
   * Returns a vector representing the scale of the 3D object in world space.
   *
   * @param {Vector3} target - The target vector the result is stored to.
   * @return {Vector3} The 3D object's scale in world space.
   */
  getWorldScale(e) {
    return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(ir, Jv, e), e;
  }
  /**
   * Returns a vector representing the ("look") direction of the 3D object in world space.
   *
   * @param {Vector3} target - The target vector the result is stored to.
   * @return {Vector3} The 3D object's direction in world space.
   */
  getWorldDirection(e) {
    this.updateWorldMatrix(!0, !1);
    const t = this.matrixWorld.elements;
    return e.set(t[8], t[9], t[10]).normalize();
  }
  /**
   * Abstract method to get intersections between a casted ray and this
   * 3D object. Renderable 3D objects such as {@link Mesh}, {@link Line} or {@link Points}
   * implement this method in order to use raycasting.
   *
   * @abstract
   * @param {Raycaster} raycaster - The raycaster.
   * @param {Array<Object>} intersects - An array holding the result of the method.
   */
  raycast() {
  }
  /**
   * Executes the callback on this 3D object and all descendants.
   *
   * Note: Modifying the scene graph inside the callback is discouraged.
   *
   * @param {Function} callback - A callback function that allows to process the current 3D object.
   */
  traverse(e) {
    e(this);
    const t = this.children;
    for (let i = 0, n = t.length; i < n; i++)
      t[i].traverse(e);
  }
  /**
   * Like {@link Object3D#traverse}, but the callback will only be executed for visible 3D objects.
   * Descendants of invisible 3D objects are not traversed.
   *
   * Note: Modifying the scene graph inside the callback is discouraged.
   *
   * @param {Function} callback - A callback function that allows to process the current 3D object.
   */
  traverseVisible(e) {
    if (this.visible === !1) return;
    e(this);
    const t = this.children;
    for (let i = 0, n = t.length; i < n; i++)
      t[i].traverseVisible(e);
  }
  /**
   * Like {@link Object3D#traverse}, but the callback will only be executed for all ancestors.
   *
   * Note: Modifying the scene graph inside the callback is discouraged.
   *
   * @param {Function} callback - A callback function that allows to process the current 3D object.
   */
  traverseAncestors(e) {
    const t = this.parent;
    t !== null && (e(t), t.traverseAncestors(e));
  }
  /**
   * Updates the transformation matrix in local space by computing it from the current
   * position, rotation and scale values.
   */
  updateMatrix() {
    this.matrix.compose(this.position, this.quaternion, this.scale), this.matrixWorldNeedsUpdate = !0;
  }
  /**
   * Updates the transformation matrix in world space of this 3D objects and its descendants.
   *
   * To ensure correct results, this method also recomputes the 3D object's transformation matrix in
   * local space. The computation of the local and world matrix can be controlled with the
   * {@link Object3D#matrixAutoUpdate} and {@link Object3D#matrixWorldAutoUpdate} flags which are both
   * `true` by default.  Set these flags to `false` if you need more control over the update matrix process.
   *
   * @param {boolean} [force=false] - When set to `true`, a recomputation of world matrices is forced even
   * when {@link Object3D#matrixWorldAutoUpdate} is set to `false`.
   */
  updateMatrixWorld(e) {
    this.matrixAutoUpdate && this.updateMatrix(), (this.matrixWorldNeedsUpdate || e) && (this.matrixWorldAutoUpdate === !0 && (this.parent === null ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix)), this.matrixWorldNeedsUpdate = !1, e = !0);
    const t = this.children;
    for (let i = 0, n = t.length; i < n; i++)
      t[i].updateMatrixWorld(e);
  }
  /**
   * An alternative version of {@link Object3D#updateMatrixWorld} with more control over the
   * update of ancestor and descendant nodes.
   *
   * @param {boolean} [updateParents=false] Whether ancestor nodes should be updated or not.
   * @param {boolean} [updateChildren=false] Whether descendant nodes should be updated or not.
   */
  updateWorldMatrix(e, t) {
    const i = this.parent;
    if (e === !0 && i !== null && i.updateWorldMatrix(!0, !1), this.matrixAutoUpdate && this.updateMatrix(), this.matrixWorldAutoUpdate === !0 && (this.parent === null ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix)), t === !0) {
      const n = this.children;
      for (let r = 0, a = n.length; r < a; r++)
        n[r].updateWorldMatrix(!1, !0);
    }
  }
  /**
   * Serializes the 3D object into JSON.
   *
   * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
   * @return {Object} A JSON object representing the serialized 3D object.
   * @see {@link ObjectLoader#parse}
   */
  toJSON(e) {
    const t = e === void 0 || typeof e == "string", i = {};
    t && (e = {
      geometries: {},
      materials: {},
      textures: {},
      images: {},
      shapes: {},
      skeletons: {},
      animations: {},
      nodes: {}
    }, i.metadata = {
      version: 4.7,
      type: "Object",
      generator: "Object3D.toJSON"
    });
    const n = {};
    n.uuid = this.uuid, n.type = this.type, this.name !== "" && (n.name = this.name), this.castShadow === !0 && (n.castShadow = !0), this.receiveShadow === !0 && (n.receiveShadow = !0), this.visible === !1 && (n.visible = !1), this.frustumCulled === !1 && (n.frustumCulled = !1), this.renderOrder !== 0 && (n.renderOrder = this.renderOrder), Object.keys(this.userData).length > 0 && (n.userData = this.userData), n.layers = this.layers.mask, n.matrix = this.matrix.toArray(), n.up = this.up.toArray(), this.matrixAutoUpdate === !1 && (n.matrixAutoUpdate = !1), this.isInstancedMesh && (n.type = "InstancedMesh", n.count = this.count, n.instanceMatrix = this.instanceMatrix.toJSON(), this.instanceColor !== null && (n.instanceColor = this.instanceColor.toJSON())), this.isBatchedMesh && (n.type = "BatchedMesh", n.perObjectFrustumCulled = this.perObjectFrustumCulled, n.sortObjects = this.sortObjects, n.drawRanges = this._drawRanges, n.reservedRanges = this._reservedRanges, n.geometryInfo = this._geometryInfo.map((o) => ({
      ...o,
      boundingBox: o.boundingBox ? o.boundingBox.toJSON() : void 0,
      boundingSphere: o.boundingSphere ? o.boundingSphere.toJSON() : void 0
    })), n.instanceInfo = this._instanceInfo.map((o) => ({ ...o })), n.availableInstanceIds = this._availableInstanceIds.slice(), n.availableGeometryIds = this._availableGeometryIds.slice(), n.nextIndexStart = this._nextIndexStart, n.nextVertexStart = this._nextVertexStart, n.geometryCount = this._geometryCount, n.maxInstanceCount = this._maxInstanceCount, n.maxVertexCount = this._maxVertexCount, n.maxIndexCount = this._maxIndexCount, n.geometryInitialized = this._geometryInitialized, n.matricesTexture = this._matricesTexture.toJSON(e), n.indirectTexture = this._indirectTexture.toJSON(e), this._colorsTexture !== null && (n.colorsTexture = this._colorsTexture.toJSON(e)), this.boundingSphere !== null && (n.boundingSphere = this.boundingSphere.toJSON()), this.boundingBox !== null && (n.boundingBox = this.boundingBox.toJSON()));
    function r(o, l) {
      return o[l.uuid] === void 0 && (o[l.uuid] = l.toJSON(e)), l.uuid;
    }
    if (this.isScene)
      this.background && (this.background.isColor ? n.background = this.background.toJSON() : this.background.isTexture && (n.background = this.background.toJSON(e).uuid)), this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== !0 && (n.environment = this.environment.toJSON(e).uuid);
    else if (this.isMesh || this.isLine || this.isPoints) {
      n.geometry = r(e.geometries, this.geometry);
      const o = this.geometry.parameters;
      if (o !== void 0 && o.shapes !== void 0) {
        const l = o.shapes;
        if (Array.isArray(l))
          for (let c = 0, h = l.length; c < h; c++) {
            const d = l[c];
            r(e.shapes, d);
          }
        else
          r(e.shapes, l);
      }
    }
    if (this.isSkinnedMesh && (n.bindMode = this.bindMode, n.bindMatrix = this.bindMatrix.toArray(), this.skeleton !== void 0 && (r(e.skeletons, this.skeleton), n.skeleton = this.skeleton.uuid)), this.material !== void 0)
      if (Array.isArray(this.material)) {
        const o = [];
        for (let l = 0, c = this.material.length; l < c; l++)
          o.push(r(e.materials, this.material[l]));
        n.material = o;
      } else
        n.material = r(e.materials, this.material);
    if (this.children.length > 0) {
      n.children = [];
      for (let o = 0; o < this.children.length; o++)
        n.children.push(this.children[o].toJSON(e).object);
    }
    if (this.animations.length > 0) {
      n.animations = [];
      for (let o = 0; o < this.animations.length; o++) {
        const l = this.animations[o];
        n.animations.push(r(e.animations, l));
      }
    }
    if (t) {
      const o = a(e.geometries), l = a(e.materials), c = a(e.textures), h = a(e.images), d = a(e.shapes), u = a(e.skeletons), f = a(e.animations), g = a(e.nodes);
      o.length > 0 && (i.geometries = o), l.length > 0 && (i.materials = l), c.length > 0 && (i.textures = c), h.length > 0 && (i.images = h), d.length > 0 && (i.shapes = d), u.length > 0 && (i.skeletons = u), f.length > 0 && (i.animations = f), g.length > 0 && (i.nodes = g);
    }
    return i.object = n, i;
    function a(o) {
      const l = [];
      for (const c in o) {
        const h = o[c];
        delete h.metadata, l.push(h);
      }
      return l;
    }
  }
  /**
   * Returns a new 3D object with copied values from this instance.
   *
   * @param {boolean} [recursive=true] - When set to `true`, descendants of the 3D object are also cloned.
   * @return {Object3D} A clone of this instance.
   */
  clone(e) {
    return new this.constructor().copy(this, e);
  }
  /**
   * Copies the values of the given 3D object to this instance.
   *
   * @param {Object3D} source - The 3D object to copy.
   * @param {boolean} [recursive=true] - When set to `true`, descendants of the 3D object are cloned.
   * @return {Object3D} A reference to this instance.
   */
  copy(e, t = !0) {
    if (this.name = e.name, this.up.copy(e.up), this.position.copy(e.position), this.rotation.order = e.rotation.order, this.quaternion.copy(e.quaternion), this.scale.copy(e.scale), this.matrix.copy(e.matrix), this.matrixWorld.copy(e.matrixWorld), this.matrixAutoUpdate = e.matrixAutoUpdate, this.matrixWorldAutoUpdate = e.matrixWorldAutoUpdate, this.matrixWorldNeedsUpdate = e.matrixWorldNeedsUpdate, this.layers.mask = e.layers.mask, this.visible = e.visible, this.castShadow = e.castShadow, this.receiveShadow = e.receiveShadow, this.frustumCulled = e.frustumCulled, this.renderOrder = e.renderOrder, this.animations = e.animations.slice(), this.userData = JSON.parse(JSON.stringify(e.userData)), t === !0)
      for (let i = 0; i < e.children.length; i++) {
        const n = e.children[i];
        this.add(n.clone());
      }
    return this;
  }
}
wt.DEFAULT_UP = /* @__PURE__ */ new O(0, 1, 0);
wt.DEFAULT_MATRIX_AUTO_UPDATE = !0;
wt.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = !0;
const Si = /* @__PURE__ */ new O(), Qi = /* @__PURE__ */ new O(), Do = /* @__PURE__ */ new O(), en = /* @__PURE__ */ new O(), ms = /* @__PURE__ */ new O(), gs = /* @__PURE__ */ new O(), cd = /* @__PURE__ */ new O(), No = /* @__PURE__ */ new O(), Oo = /* @__PURE__ */ new O(), Uo = /* @__PURE__ */ new O(), Fo = /* @__PURE__ */ new _t(), Bo = /* @__PURE__ */ new _t(), ko = /* @__PURE__ */ new _t();
class Ti {
  /**
   * Constructs a new triangle.
   *
   * @param {Vector3} [a=(0,0,0)] - The first corner of the triangle.
   * @param {Vector3} [b=(0,0,0)] - The second corner of the triangle.
   * @param {Vector3} [c=(0,0,0)] - The third corner of the triangle.
   */
  constructor(e = new O(), t = new O(), i = new O()) {
    this.a = e, this.b = t, this.c = i;
  }
  /**
   * Computes the normal vector of a triangle.
   *
   * @param {Vector3} a - The first corner of the triangle.
   * @param {Vector3} b - The second corner of the triangle.
   * @param {Vector3} c - The third corner of the triangle.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The triangle's normal.
   */
  static getNormal(e, t, i, n) {
    n.subVectors(i, t), Si.subVectors(e, t), n.cross(Si);
    const r = n.lengthSq();
    return r > 0 ? n.multiplyScalar(1 / Math.sqrt(r)) : n.set(0, 0, 0);
  }
  /**
   * Computes a barycentric coordinates from the given vector.
   * Returns `null` if the triangle is degenerate.
   *
   * @param {Vector3} point - A point in 3D space.
   * @param {Vector3} a - The first corner of the triangle.
   * @param {Vector3} b - The second corner of the triangle.
   * @param {Vector3} c - The third corner of the triangle.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The barycentric coordinates for the given point
   */
  static getBarycoord(e, t, i, n, r) {
    Si.subVectors(n, t), Qi.subVectors(i, t), Do.subVectors(e, t);
    const a = Si.dot(Si), o = Si.dot(Qi), l = Si.dot(Do), c = Qi.dot(Qi), h = Qi.dot(Do), d = a * c - o * o;
    if (d === 0)
      return r.set(0, 0, 0), null;
    const u = 1 / d, f = (c * l - o * h) * u, g = (a * h - o * l) * u;
    return r.set(1 - f - g, g, f);
  }
  /**
   * Returns `true` if the given point, when projected onto the plane of the
   * triangle, lies within the triangle.
   *
   * @param {Vector3} point - The point in 3D space to test.
   * @param {Vector3} a - The first corner of the triangle.
   * @param {Vector3} b - The second corner of the triangle.
   * @param {Vector3} c - The third corner of the triangle.
   * @return {boolean} Whether the given point, when projected onto the plane of the
   * triangle, lies within the triangle or not.
   */
  static containsPoint(e, t, i, n) {
    return this.getBarycoord(e, t, i, n, en) === null ? !1 : en.x >= 0 && en.y >= 0 && en.x + en.y <= 1;
  }
  /**
   * Computes the value barycentrically interpolated for the given point on the
   * triangle. Returns `null` if the triangle is degenerate.
   *
   * @param {Vector3} point - Position of interpolated point.
   * @param {Vector3} p1 - The first corner of the triangle.
   * @param {Vector3} p2 - The second corner of the triangle.
   * @param {Vector3} p3 - The third corner of the triangle.
   * @param {Vector3} v1 - Value to interpolate of first vertex.
   * @param {Vector3} v2 - Value to interpolate of second vertex.
   * @param {Vector3} v3 - Value to interpolate of third vertex.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The interpolated value.
   */
  static getInterpolation(e, t, i, n, r, a, o, l) {
    return this.getBarycoord(e, t, i, n, en) === null ? (l.x = 0, l.y = 0, "z" in l && (l.z = 0), "w" in l && (l.w = 0), null) : (l.setScalar(0), l.addScaledVector(r, en.x), l.addScaledVector(a, en.y), l.addScaledVector(o, en.z), l);
  }
  /**
   * Computes the value barycentrically interpolated for the given attribute and indices.
   *
   * @param {BufferAttribute} attr - The attribute to interpolate.
   * @param {number} i1 - Index of first vertex.
   * @param {number} i2 - Index of second vertex.
   * @param {number} i3 - Index of third vertex.
   * @param {Vector3} barycoord - The barycoordinate value to use to interpolate.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The interpolated attribute value.
   */
  static getInterpolatedAttribute(e, t, i, n, r, a) {
    return Fo.setScalar(0), Bo.setScalar(0), ko.setScalar(0), Fo.fromBufferAttribute(e, t), Bo.fromBufferAttribute(e, i), ko.fromBufferAttribute(e, n), a.setScalar(0), a.addScaledVector(Fo, r.x), a.addScaledVector(Bo, r.y), a.addScaledVector(ko, r.z), a;
  }
  /**
   * Returns `true` if the triangle is oriented towards the given direction.
   *
   * @param {Vector3} a - The first corner of the triangle.
   * @param {Vector3} b - The second corner of the triangle.
   * @param {Vector3} c - The third corner of the triangle.
   * @param {Vector3} direction - The (normalized) direction vector.
   * @return {boolean} Whether the triangle is oriented towards the given direction or not.
   */
  static isFrontFacing(e, t, i, n) {
    return Si.subVectors(i, t), Qi.subVectors(e, t), Si.cross(Qi).dot(n) < 0;
  }
  /**
   * Sets the triangle's vertices by copying the given values.
   *
   * @param {Vector3} a - The first corner of the triangle.
   * @param {Vector3} b - The second corner of the triangle.
   * @param {Vector3} c - The third corner of the triangle.
   * @return {Triangle} A reference to this triangle.
   */
  set(e, t, i) {
    return this.a.copy(e), this.b.copy(t), this.c.copy(i), this;
  }
  /**
   * Sets the triangle's vertices by copying the given array values.
   *
   * @param {Array<Vector3>} points - An array with 3D points.
   * @param {number} i0 - The array index representing the first corner of the triangle.
   * @param {number} i1 - The array index representing the second corner of the triangle.
   * @param {number} i2 - The array index representing the third corner of the triangle.
   * @return {Triangle} A reference to this triangle.
   */
  setFromPointsAndIndices(e, t, i, n) {
    return this.a.copy(e[t]), this.b.copy(e[i]), this.c.copy(e[n]), this;
  }
  /**
   * Sets the triangle's vertices by copying the given attribute values.
   *
   * @param {BufferAttribute} attribute - A buffer attribute with 3D points data.
   * @param {number} i0 - The attribute index representing the first corner of the triangle.
   * @param {number} i1 - The attribute index representing the second corner of the triangle.
   * @param {number} i2 - The attribute index representing the third corner of the triangle.
   * @return {Triangle} A reference to this triangle.
   */
  setFromAttributeAndIndices(e, t, i, n) {
    return this.a.fromBufferAttribute(e, t), this.b.fromBufferAttribute(e, i), this.c.fromBufferAttribute(e, n), this;
  }
  /**
   * Returns a new triangle with copied values from this instance.
   *
   * @return {Triangle} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
  /**
   * Copies the values of the given triangle to this instance.
   *
   * @param {Triangle} triangle - The triangle to copy.
   * @return {Triangle} A reference to this triangle.
   */
  copy(e) {
    return this.a.copy(e.a), this.b.copy(e.b), this.c.copy(e.c), this;
  }
  /**
   * Computes the area of the triangle.
   *
   * @return {number} The triangle's area.
   */
  getArea() {
    return Si.subVectors(this.c, this.b), Qi.subVectors(this.a, this.b), Si.cross(Qi).length() * 0.5;
  }
  /**
   * Computes the midpoint of the triangle.
   *
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The triangle's midpoint.
   */
  getMidpoint(e) {
    return e.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
  }
  /**
   * Computes the normal of the triangle.
   *
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The triangle's normal.
   */
  getNormal(e) {
    return Ti.getNormal(this.a, this.b, this.c, e);
  }
  /**
   * Computes a plane the triangle lies within.
   *
   * @param {Plane} target - The target vector that is used to store the method's result.
   * @return {Plane} The plane the triangle lies within.
   */
  getPlane(e) {
    return e.setFromCoplanarPoints(this.a, this.b, this.c);
  }
  /**
   * Computes a barycentric coordinates from the given vector.
   * Returns `null` if the triangle is degenerate.
   *
   * @param {Vector3} point - A point in 3D space.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The barycentric coordinates for the given point
   */
  getBarycoord(e, t) {
    return Ti.getBarycoord(e, this.a, this.b, this.c, t);
  }
  /**
   * Computes the value barycentrically interpolated for the given point on the
   * triangle. Returns `null` if the triangle is degenerate.
   *
   * @param {Vector3} point - Position of interpolated point.
   * @param {Vector3} v1 - Value to interpolate of first vertex.
   * @param {Vector3} v2 - Value to interpolate of second vertex.
   * @param {Vector3} v3 - Value to interpolate of third vertex.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The interpolated value.
   */
  getInterpolation(e, t, i, n, r) {
    return Ti.getInterpolation(e, this.a, this.b, this.c, t, i, n, r);
  }
  /**
   * Returns `true` if the given point, when projected onto the plane of the
   * triangle, lies within the triangle.
   *
   * @param {Vector3} point - The point in 3D space to test.
   * @return {boolean} Whether the given point, when projected onto the plane of the
   * triangle, lies within the triangle or not.
   */
  containsPoint(e) {
    return Ti.containsPoint(e, this.a, this.b, this.c);
  }
  /**
   * Returns `true` if the triangle is oriented towards the given direction.
   *
   * @param {Vector3} direction - The (normalized) direction vector.
   * @return {boolean} Whether the triangle is oriented towards the given direction or not.
   */
  isFrontFacing(e) {
    return Ti.isFrontFacing(this.a, this.b, this.c, e);
  }
  /**
   * Returns `true` if this triangle intersects with the given box.
   *
   * @param {Box3} box - The box to intersect.
   * @return {boolean} Whether this triangle intersects with the given box or not.
   */
  intersectsBox(e) {
    return e.intersectsTriangle(this);
  }
  /**
   * Returns the closest point on the triangle to the given point.
   *
   * @param {Vector3} p - The point to compute the closest point for.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The closest point on the triangle.
   */
  closestPointToPoint(e, t) {
    const i = this.a, n = this.b, r = this.c;
    let a, o;
    ms.subVectors(n, i), gs.subVectors(r, i), No.subVectors(e, i);
    const l = ms.dot(No), c = gs.dot(No);
    if (l <= 0 && c <= 0)
      return t.copy(i);
    Oo.subVectors(e, n);
    const h = ms.dot(Oo), d = gs.dot(Oo);
    if (h >= 0 && d <= h)
      return t.copy(n);
    const u = l * d - h * c;
    if (u <= 0 && l >= 0 && h <= 0)
      return a = l / (l - h), t.copy(i).addScaledVector(ms, a);
    Uo.subVectors(e, r);
    const f = ms.dot(Uo), g = gs.dot(Uo);
    if (g >= 0 && f <= g)
      return t.copy(r);
    const v = f * c - l * g;
    if (v <= 0 && c >= 0 && g <= 0)
      return o = c / (c - g), t.copy(i).addScaledVector(gs, o);
    const m = h * g - f * d;
    if (m <= 0 && d - h >= 0 && f - g >= 0)
      return cd.subVectors(r, n), o = (d - h) / (d - h + (f - g)), t.copy(n).addScaledVector(cd, o);
    const p = 1 / (m + v + u);
    return a = v * p, o = u * p, t.copy(i).addScaledVector(ms, a).addScaledVector(gs, o);
  }
  /**
   * Returns `true` if this triangle is equal with the given one.
   *
   * @param {Triangle} triangle - The triangle to test for equality.
   * @return {boolean} Whether this triangle is equal with the given one.
   */
  equals(e) {
    return e.a.equals(this.a) && e.b.equals(this.b) && e.c.equals(this.c);
  }
}
const ef = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
}, xn = { h: 0, s: 0, l: 0 }, Qr = { h: 0, s: 0, l: 0 };
function zo(s, e, t) {
  return t < 0 && (t += 1), t > 1 && (t -= 1), t < 1 / 6 ? s + (e - s) * 6 * t : t < 1 / 2 ? e : t < 2 / 3 ? s + (e - s) * 6 * (2 / 3 - t) : s;
}
class Ne {
  /**
   * Constructs a new color.
   *
   * Note that standard method of specifying color in three.js is with a hexadecimal triplet,
   * and that method is used throughout the rest of the documentation.
   *
   * @param {(number|string|Color)} [r] - The red component of the color. If `g` and `b` are
   * not provided, it can be hexadecimal triplet, a CSS-style string or another `Color` instance.
   * @param {number} [g] - The green component.
   * @param {number} [b] - The blue component.
   */
  constructor(e, t, i) {
    return this.isColor = !0, this.r = 1, this.g = 1, this.b = 1, this.set(e, t, i);
  }
  /**
   * Sets the colors's components from the given values.
   *
   * @param {(number|string|Color)} [r] - The red component of the color. If `g` and `b` are
   * not provided, it can be hexadecimal triplet, a CSS-style string or another `Color` instance.
   * @param {number} [g] - The green component.
   * @param {number} [b] - The blue component.
   * @return {Color} A reference to this color.
   */
  set(e, t, i) {
    if (t === void 0 && i === void 0) {
      const n = e;
      n && n.isColor ? this.copy(n) : typeof n == "number" ? this.setHex(n) : typeof n == "string" && this.setStyle(n);
    } else
      this.setRGB(e, t, i);
    return this;
  }
  /**
   * Sets the colors's components to the given scalar value.
   *
   * @param {number} scalar - The scalar value.
   * @return {Color} A reference to this color.
   */
  setScalar(e) {
    return this.r = e, this.g = e, this.b = e, this;
  }
  /**
   * Sets this color from a hexadecimal value.
   *
   * @param {number} hex - The hexadecimal value.
   * @param {string} [colorSpace=SRGBColorSpace] - The color space.
   * @return {Color} A reference to this color.
   */
  setHex(e, t = Ct) {
    return e = Math.floor(e), this.r = (e >> 16 & 255) / 255, this.g = (e >> 8 & 255) / 255, this.b = (e & 255) / 255, Ke.colorSpaceToWorking(this, t), this;
  }
  /**
   * Sets this color from RGB values.
   *
   * @param {number} r - Red channel value between `0.0` and `1.0`.
   * @param {number} g - Green channel value between `0.0` and `1.0`.
   * @param {number} b - Blue channel value between `0.0` and `1.0`.
   * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
   * @return {Color} A reference to this color.
   */
  setRGB(e, t, i, n = Ke.workingColorSpace) {
    return this.r = e, this.g = t, this.b = i, Ke.colorSpaceToWorking(this, n), this;
  }
  /**
   * Sets this color from RGB values.
   *
   * @param {number} h - Hue value between `0.0` and `1.0`.
   * @param {number} s - Saturation value between `0.0` and `1.0`.
   * @param {number} l - Lightness value between `0.0` and `1.0`.
   * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
   * @return {Color} A reference to this color.
   */
  setHSL(e, t, i, n = Ke.workingColorSpace) {
    if (e = Kc(e, 1), t = Xe(t, 0, 1), i = Xe(i, 0, 1), t === 0)
      this.r = this.g = this.b = i;
    else {
      const r = i <= 0.5 ? i * (1 + t) : i + t - i * t, a = 2 * i - r;
      this.r = zo(a, r, e + 1 / 3), this.g = zo(a, r, e), this.b = zo(a, r, e - 1 / 3);
    }
    return Ke.colorSpaceToWorking(this, n), this;
  }
  /**
   * Sets this color from a CSS-style string. For example, `rgb(250, 0,0)`,
   * `rgb(100%, 0%, 0%)`, `hsl(0, 100%, 50%)`, `#ff0000`, `#f00`, or `red` ( or
   * any [X11 color name](https://en.wikipedia.org/wiki/X11_color_names#Color_name_chart) -
   * all 140 color names are supported).
   *
   * @param {string} style - Color as a CSS-style string.
   * @param {string} [colorSpace=SRGBColorSpace] - The color space.
   * @return {Color} A reference to this color.
   */
  setStyle(e, t = Ct) {
    function i(r) {
      r !== void 0 && parseFloat(r) < 1 && Te("Color: Alpha component of " + e + " will be ignored.");
    }
    let n;
    if (n = /^(\w+)\(([^\)]*)\)/.exec(e)) {
      let r;
      const a = n[1], o = n[2];
      switch (a) {
        case "rgb":
        case "rgba":
          if (r = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(o))
            return i(r[4]), this.setRGB(
              Math.min(255, parseInt(r[1], 10)) / 255,
              Math.min(255, parseInt(r[2], 10)) / 255,
              Math.min(255, parseInt(r[3], 10)) / 255,
              t
            );
          if (r = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(o))
            return i(r[4]), this.setRGB(
              Math.min(100, parseInt(r[1], 10)) / 100,
              Math.min(100, parseInt(r[2], 10)) / 100,
              Math.min(100, parseInt(r[3], 10)) / 100,
              t
            );
          break;
        case "hsl":
        case "hsla":
          if (r = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(o))
            return i(r[4]), this.setHSL(
              parseFloat(r[1]) / 360,
              parseFloat(r[2]) / 100,
              parseFloat(r[3]) / 100,
              t
            );
          break;
        default:
          Te("Color: Unknown color model " + e);
      }
    } else if (n = /^\#([A-Fa-f\d]+)$/.exec(e)) {
      const r = n[1], a = r.length;
      if (a === 3)
        return this.setRGB(
          parseInt(r.charAt(0), 16) / 15,
          parseInt(r.charAt(1), 16) / 15,
          parseInt(r.charAt(2), 16) / 15,
          t
        );
      if (a === 6)
        return this.setHex(parseInt(r, 16), t);
      Te("Color: Invalid hex color " + e);
    } else if (e && e.length > 0)
      return this.setColorName(e, t);
    return this;
  }
  /**
   * Sets this color from a color name. Faster than {@link Color#setStyle} if
   * you don't need the other CSS-style formats.
   *
   * For convenience, the list of names is exposed in `Color.NAMES` as a hash.
   * ```js
   * Color.NAMES.aliceblue // returns 0xF0F8FF
   * ```
   *
   * @param {string} style - The color name.
   * @param {string} [colorSpace=SRGBColorSpace] - The color space.
   * @return {Color} A reference to this color.
   */
  setColorName(e, t = Ct) {
    const i = ef[e.toLowerCase()];
    return i !== void 0 ? this.setHex(i, t) : Te("Color: Unknown color " + e), this;
  }
  /**
   * Returns a new color with copied values from this instance.
   *
   * @return {Color} A clone of this instance.
   */
  clone() {
    return new this.constructor(this.r, this.g, this.b);
  }
  /**
   * Copies the values of the given color to this instance.
   *
   * @param {Color} color - The color to copy.
   * @return {Color} A reference to this color.
   */
  copy(e) {
    return this.r = e.r, this.g = e.g, this.b = e.b, this;
  }
  /**
   * Copies the given color into this color, and then converts this color from
   * `SRGBColorSpace` to `LinearSRGBColorSpace`.
   *
   * @param {Color} color - The color to copy/convert.
   * @return {Color} A reference to this color.
   */
  copySRGBToLinear(e) {
    return this.r = on(e.r), this.g = on(e.g), this.b = on(e.b), this;
  }
  /**
   * Copies the given color into this color, and then converts this color from
   * `LinearSRGBColorSpace` to `SRGBColorSpace`.
   *
   * @param {Color} color - The color to copy/convert.
   * @return {Color} A reference to this color.
   */
  copyLinearToSRGB(e) {
    return this.r = Es(e.r), this.g = Es(e.g), this.b = Es(e.b), this;
  }
  /**
   * Converts this color from `SRGBColorSpace` to `LinearSRGBColorSpace`.
   *
   * @return {Color} A reference to this color.
   */
  convertSRGBToLinear() {
    return this.copySRGBToLinear(this), this;
  }
  /**
   * Converts this color from `LinearSRGBColorSpace` to `SRGBColorSpace`.
   *
   * @return {Color} A reference to this color.
   */
  convertLinearToSRGB() {
    return this.copyLinearToSRGB(this), this;
  }
  /**
   * Returns the hexadecimal value of this color.
   *
   * @param {string} [colorSpace=SRGBColorSpace] - The color space.
   * @return {number} The hexadecimal value.
   */
  getHex(e = Ct) {
    return Ke.workingToColorSpace(Bt.copy(this), e), Math.round(Xe(Bt.r * 255, 0, 255)) * 65536 + Math.round(Xe(Bt.g * 255, 0, 255)) * 256 + Math.round(Xe(Bt.b * 255, 0, 255));
  }
  /**
   * Returns the hexadecimal value of this color as a string (for example, 'FFFFFF').
   *
   * @param {string} [colorSpace=SRGBColorSpace] - The color space.
   * @return {string} The hexadecimal value as a string.
   */
  getHexString(e = Ct) {
    return ("000000" + this.getHex(e).toString(16)).slice(-6);
  }
  /**
   * Converts the colors RGB values into the HSL format and stores them into the
   * given target object.
   *
   * @param {{h:number,s:number,l:number}} target - The target object that is used to store the method's result.
   * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
   * @return {{h:number,s:number,l:number}} The HSL representation of this color.
   */
  getHSL(e, t = Ke.workingColorSpace) {
    Ke.workingToColorSpace(Bt.copy(this), t);
    const i = Bt.r, n = Bt.g, r = Bt.b, a = Math.max(i, n, r), o = Math.min(i, n, r);
    let l, c;
    const h = (o + a) / 2;
    if (o === a)
      l = 0, c = 0;
    else {
      const d = a - o;
      switch (c = h <= 0.5 ? d / (a + o) : d / (2 - a - o), a) {
        case i:
          l = (n - r) / d + (n < r ? 6 : 0);
          break;
        case n:
          l = (r - i) / d + 2;
          break;
        case r:
          l = (i - n) / d + 4;
          break;
      }
      l /= 6;
    }
    return e.h = l, e.s = c, e.l = h, e;
  }
  /**
   * Returns the RGB values of this color and stores them into the given target object.
   *
   * @param {Color} target - The target color that is used to store the method's result.
   * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
   * @return {Color} The RGB representation of this color.
   */
  getRGB(e, t = Ke.workingColorSpace) {
    return Ke.workingToColorSpace(Bt.copy(this), t), e.r = Bt.r, e.g = Bt.g, e.b = Bt.b, e;
  }
  /**
   * Returns the value of this color as a CSS style string. Example: `rgb(255,0,0)`.
   *
   * @param {string} [colorSpace=SRGBColorSpace] - The color space.
   * @return {string} The CSS representation of this color.
   */
  getStyle(e = Ct) {
    Ke.workingToColorSpace(Bt.copy(this), e);
    const t = Bt.r, i = Bt.g, n = Bt.b;
    return e !== Ct ? `color(${e} ${t.toFixed(3)} ${i.toFixed(3)} ${n.toFixed(3)})` : `rgb(${Math.round(t * 255)},${Math.round(i * 255)},${Math.round(n * 255)})`;
  }
  /**
   * Adds the given HSL values to this color's values.
   * Internally, this converts the color's RGB values to HSL, adds HSL
   * and then converts the color back to RGB.
   *
   * @param {number} h - Hue value between `0.0` and `1.0`.
   * @param {number} s - Saturation value between `0.0` and `1.0`.
   * @param {number} l - Lightness value between `0.0` and `1.0`.
   * @return {Color} A reference to this color.
   */
  offsetHSL(e, t, i) {
    return this.getHSL(xn), this.setHSL(xn.h + e, xn.s + t, xn.l + i);
  }
  /**
   * Adds the RGB values of the given color to the RGB values of this color.
   *
   * @param {Color} color - The color to add.
   * @return {Color} A reference to this color.
   */
  add(e) {
    return this.r += e.r, this.g += e.g, this.b += e.b, this;
  }
  /**
   * Adds the RGB values of the given colors and stores the result in this instance.
   *
   * @param {Color} color1 - The first color.
   * @param {Color} color2 - The second color.
   * @return {Color} A reference to this color.
   */
  addColors(e, t) {
    return this.r = e.r + t.r, this.g = e.g + t.g, this.b = e.b + t.b, this;
  }
  /**
   * Adds the given scalar value to the RGB values of this color.
   *
   * @param {number} s - The scalar to add.
   * @return {Color} A reference to this color.
   */
  addScalar(e) {
    return this.r += e, this.g += e, this.b += e, this;
  }
  /**
   * Subtracts the RGB values of the given color from the RGB values of this color.
   *
   * @param {Color} color - The color to subtract.
   * @return {Color} A reference to this color.
   */
  sub(e) {
    return this.r = Math.max(0, this.r - e.r), this.g = Math.max(0, this.g - e.g), this.b = Math.max(0, this.b - e.b), this;
  }
  /**
   * Multiplies the RGB values of the given color with the RGB values of this color.
   *
   * @param {Color} color - The color to multiply.
   * @return {Color} A reference to this color.
   */
  multiply(e) {
    return this.r *= e.r, this.g *= e.g, this.b *= e.b, this;
  }
  /**
   * Multiplies the given scalar value with the RGB values of this color.
   *
   * @param {number} s - The scalar to multiply.
   * @return {Color} A reference to this color.
   */
  multiplyScalar(e) {
    return this.r *= e, this.g *= e, this.b *= e, this;
  }
  /**
   * Linearly interpolates this color's RGB values toward the RGB values of the
   * given color. The alpha argument can be thought of as the ratio between
   * the two colors, where `0.0` is this color and `1.0` is the first argument.
   *
   * @param {Color} color - The color to converge on.
   * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
   * @return {Color} A reference to this color.
   */
  lerp(e, t) {
    return this.r += (e.r - this.r) * t, this.g += (e.g - this.g) * t, this.b += (e.b - this.b) * t, this;
  }
  /**
   * Linearly interpolates between the given colors and stores the result in this instance.
   * The alpha argument can be thought of as the ratio between the two colors, where `0.0`
   * is the first and `1.0` is the second color.
   *
   * @param {Color} color1 - The first color.
   * @param {Color} color2 - The second color.
   * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
   * @return {Color} A reference to this color.
   */
  lerpColors(e, t, i) {
    return this.r = e.r + (t.r - e.r) * i, this.g = e.g + (t.g - e.g) * i, this.b = e.b + (t.b - e.b) * i, this;
  }
  /**
   * Linearly interpolates this color's HSL values toward the HSL values of the
   * given color. It differs from {@link Color#lerp} by not interpolating straight
   * from one color to the other, but instead going through all the hues in between
   * those two colors. The alpha argument can be thought of as the ratio between
   * the two colors, where 0.0 is this color and 1.0 is the first argument.
   *
   * @param {Color} color - The color to converge on.
   * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
   * @return {Color} A reference to this color.
   */
  lerpHSL(e, t) {
    this.getHSL(xn), e.getHSL(Qr);
    const i = mr(xn.h, Qr.h, t), n = mr(xn.s, Qr.s, t), r = mr(xn.l, Qr.l, t);
    return this.setHSL(i, n, r), this;
  }
  /**
   * Sets the color's RGB components from the given 3D vector.
   *
   * @param {Vector3} v - The vector to set.
   * @return {Color} A reference to this color.
   */
  setFromVector3(e) {
    return this.r = e.x, this.g = e.y, this.b = e.z, this;
  }
  /**
   * Transforms this color with the given 3x3 matrix.
   *
   * @param {Matrix3} m - The matrix.
   * @return {Color} A reference to this color.
   */
  applyMatrix3(e) {
    const t = this.r, i = this.g, n = this.b, r = e.elements;
    return this.r = r[0] * t + r[3] * i + r[6] * n, this.g = r[1] * t + r[4] * i + r[7] * n, this.b = r[2] * t + r[5] * i + r[8] * n, this;
  }
  /**
   * Returns `true` if this color is equal with the given one.
   *
   * @param {Color} c - The color to test for equality.
   * @return {boolean} Whether this bounding color is equal with the given one.
   */
  equals(e) {
    return e.r === this.r && e.g === this.g && e.b === this.b;
  }
  /**
   * Sets this color's RGB components from the given array.
   *
   * @param {Array<number>} array - An array holding the RGB values.
   * @param {number} [offset=0] - The offset into the array.
   * @return {Color} A reference to this color.
   */
  fromArray(e, t = 0) {
    return this.r = e[t], this.g = e[t + 1], this.b = e[t + 2], this;
  }
  /**
   * Writes the RGB components of this color to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the color components.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The color components.
   */
  toArray(e = [], t = 0) {
    return e[t] = this.r, e[t + 1] = this.g, e[t + 2] = this.b, e;
  }
  /**
   * Sets the components of this color from the given buffer attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute holding color data.
   * @param {number} index - The index into the attribute.
   * @return {Color} A reference to this color.
   */
  fromBufferAttribute(e, t) {
    return this.r = e.getX(t), this.g = e.getY(t), this.b = e.getZ(t), this;
  }
  /**
   * This methods defines the serialization result of this class. Returns the color
   * as a hexadecimal value.
   *
   * @return {number} The hexadecimal value.
   */
  toJSON() {
    return this.getHex();
  }
  *[Symbol.iterator]() {
    yield this.r, yield this.g, yield this.b;
  }
}
const Bt = /* @__PURE__ */ new Ne();
Ne.NAMES = ef;
let e_ = 0;
class Yt extends ss {
  /**
   * Constructs a new material.
   */
  constructor() {
    super(), this.isMaterial = !0, Object.defineProperty(this, "id", { value: e_++ }), this.uuid = Ei(), this.name = "", this.type = "Material", this.blending = Kn, this.side = hn, this.vertexColors = !1, this.opacity = 1, this.transparent = !1, this.alphaHash = !1, this.blendSrc = _l, this.blendDst = xl, this.blendEquation = Wn, this.blendSrcAlpha = null, this.blendDstAlpha = null, this.blendEquationAlpha = null, this.blendColor = new Ne(0, 0, 0), this.blendAlpha = 0, this.depthFunc = Ns, this.depthTest = !0, this.depthWrite = !0, this.stencilWriteMask = 255, this.stencilFunc = Yh, this.stencilRef = 0, this.stencilFuncMask = 255, this.stencilFail = os, this.stencilZFail = os, this.stencilZPass = os, this.stencilWrite = !1, this.clippingPlanes = null, this.clipIntersection = !1, this.clipShadows = !1, this.shadowSide = null, this.colorWrite = !0, this.precision = null, this.polygonOffset = !1, this.polygonOffsetFactor = 0, this.polygonOffsetUnits = 0, this.dithering = !1, this.alphaToCoverage = !1, this.premultipliedAlpha = !1, this.forceSinglePass = !1, this.allowOverride = !0, this.visible = !0, this.toneMapped = !0, this.userData = {}, this.version = 0, this._alphaTest = 0;
  }
  /**
   * Sets the alpha value to be used when running an alpha test. The material
   * will not be rendered if the opacity is lower than this value.
   *
   * @type {number}
   * @readonly
   * @default 0
   */
  get alphaTest() {
    return this._alphaTest;
  }
  set alphaTest(e) {
    this._alphaTest > 0 != e > 0 && this.version++, this._alphaTest = e;
  }
  /**
   * An optional callback that is executed immediately before the material is used to render a 3D object.
   *
   * This method can only be used when rendering with {@link WebGLRenderer}.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {Scene} scene - The scene.
   * @param {Camera} camera - The camera that is used to render the scene.
   * @param {BufferGeometry} geometry - The 3D object's geometry.
   * @param {Object3D} object - The 3D object.
   * @param {Object} group - The geometry group data.
   */
  onBeforeRender() {
  }
  /**
   * An optional callback that is executed immediately before the shader
   * program is compiled. This function is called with the shader source code
   * as a parameter. Useful for the modification of built-in materials.
   *
   * This method can only be used when rendering with {@link WebGLRenderer}. The
   * recommended approach when customizing materials is to use `WebGPURenderer` with the new
   * Node Material system and [TSL](https://github.com/mrdoob/three.js/wiki/Three.js-Shading-Language).
   *
   * @param {{vertexShader:string,fragmentShader:string,uniforms:Object}} shaderobject - The object holds the uniforms and the vertex and fragment shader source.
   * @param {WebGLRenderer} renderer - A reference to the renderer.
   */
  onBeforeCompile() {
  }
  /**
   * In case {@link Material#onBeforeCompile} is used, this callback can be used to identify
   * values of settings used in `onBeforeCompile()`, so three.js can reuse a cached
   * shader or recompile the shader for this material as needed.
   *
   * This method can only be used when rendering with {@link WebGLRenderer}.
   *
   * @return {string} The custom program cache key.
   */
  customProgramCacheKey() {
    return this.onBeforeCompile.toString();
  }
  /**
   * This method can be used to set default values from parameter objects.
   * It is a generic implementation so it can be used with different types
   * of materials.
   *
   * @param {Object} [values] - The material values to set.
   */
  setValues(e) {
    if (e !== void 0)
      for (const t in e) {
        const i = e[t];
        if (i === void 0) {
          Te(`Material: parameter '${t}' has value of undefined.`);
          continue;
        }
        const n = this[t];
        if (n === void 0) {
          Te(`Material: '${t}' is not a property of THREE.${this.type}.`);
          continue;
        }
        n && n.isColor ? n.set(i) : n && n.isVector3 && i && i.isVector3 ? n.copy(i) : this[t] = i;
      }
  }
  /**
   * Serializes the material into JSON.
   *
   * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
   * @return {Object} A JSON object representing the serialized material.
   * @see {@link ObjectLoader#parse}
   */
  toJSON(e) {
    const t = e === void 0 || typeof e == "string";
    t && (e = {
      textures: {},
      images: {}
    });
    const i = {
      metadata: {
        version: 4.7,
        type: "Material",
        generator: "Material.toJSON"
      }
    };
    i.uuid = this.uuid, i.type = this.type, this.name !== "" && (i.name = this.name), this.color && this.color.isColor && (i.color = this.color.getHex()), this.roughness !== void 0 && (i.roughness = this.roughness), this.metalness !== void 0 && (i.metalness = this.metalness), this.sheen !== void 0 && (i.sheen = this.sheen), this.sheenColor && this.sheenColor.isColor && (i.sheenColor = this.sheenColor.getHex()), this.sheenRoughness !== void 0 && (i.sheenRoughness = this.sheenRoughness), this.emissive && this.emissive.isColor && (i.emissive = this.emissive.getHex()), this.emissiveIntensity !== void 0 && this.emissiveIntensity !== 1 && (i.emissiveIntensity = this.emissiveIntensity), this.specular && this.specular.isColor && (i.specular = this.specular.getHex()), this.specularIntensity !== void 0 && (i.specularIntensity = this.specularIntensity), this.specularColor && this.specularColor.isColor && (i.specularColor = this.specularColor.getHex()), this.shininess !== void 0 && (i.shininess = this.shininess), this.clearcoat !== void 0 && (i.clearcoat = this.clearcoat), this.clearcoatRoughness !== void 0 && (i.clearcoatRoughness = this.clearcoatRoughness), this.clearcoatMap && this.clearcoatMap.isTexture && (i.clearcoatMap = this.clearcoatMap.toJSON(e).uuid), this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture && (i.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(e).uuid), this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture && (i.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(e).uuid, i.clearcoatNormalScale = this.clearcoatNormalScale.toArray()), this.sheenColorMap && this.sheenColorMap.isTexture && (i.sheenColorMap = this.sheenColorMap.toJSON(e).uuid), this.sheenRoughnessMap && this.sheenRoughnessMap.isTexture && (i.sheenRoughnessMap = this.sheenRoughnessMap.toJSON(e).uuid), this.dispersion !== void 0 && (i.dispersion = this.dispersion), this.iridescence !== void 0 && (i.iridescence = this.iridescence), this.iridescenceIOR !== void 0 && (i.iridescenceIOR = this.iridescenceIOR), this.iridescenceThicknessRange !== void 0 && (i.iridescenceThicknessRange = this.iridescenceThicknessRange), this.iridescenceMap && this.iridescenceMap.isTexture && (i.iridescenceMap = this.iridescenceMap.toJSON(e).uuid), this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture && (i.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(e).uuid), this.anisotropy !== void 0 && (i.anisotropy = this.anisotropy), this.anisotropyRotation !== void 0 && (i.anisotropyRotation = this.anisotropyRotation), this.anisotropyMap && this.anisotropyMap.isTexture && (i.anisotropyMap = this.anisotropyMap.toJSON(e).uuid), this.map && this.map.isTexture && (i.map = this.map.toJSON(e).uuid), this.matcap && this.matcap.isTexture && (i.matcap = this.matcap.toJSON(e).uuid), this.alphaMap && this.alphaMap.isTexture && (i.alphaMap = this.alphaMap.toJSON(e).uuid), this.lightMap && this.lightMap.isTexture && (i.lightMap = this.lightMap.toJSON(e).uuid, i.lightMapIntensity = this.lightMapIntensity), this.aoMap && this.aoMap.isTexture && (i.aoMap = this.aoMap.toJSON(e).uuid, i.aoMapIntensity = this.aoMapIntensity), this.bumpMap && this.bumpMap.isTexture && (i.bumpMap = this.bumpMap.toJSON(e).uuid, i.bumpScale = this.bumpScale), this.normalMap && this.normalMap.isTexture && (i.normalMap = this.normalMap.toJSON(e).uuid, i.normalMapType = this.normalMapType, i.normalScale = this.normalScale.toArray()), this.displacementMap && this.displacementMap.isTexture && (i.displacementMap = this.displacementMap.toJSON(e).uuid, i.displacementScale = this.displacementScale, i.displacementBias = this.displacementBias), this.roughnessMap && this.roughnessMap.isTexture && (i.roughnessMap = this.roughnessMap.toJSON(e).uuid), this.metalnessMap && this.metalnessMap.isTexture && (i.metalnessMap = this.metalnessMap.toJSON(e).uuid), this.emissiveMap && this.emissiveMap.isTexture && (i.emissiveMap = this.emissiveMap.toJSON(e).uuid), this.specularMap && this.specularMap.isTexture && (i.specularMap = this.specularMap.toJSON(e).uuid), this.specularIntensityMap && this.specularIntensityMap.isTexture && (i.specularIntensityMap = this.specularIntensityMap.toJSON(e).uuid), this.specularColorMap && this.specularColorMap.isTexture && (i.specularColorMap = this.specularColorMap.toJSON(e).uuid), this.envMap && this.envMap.isTexture && (i.envMap = this.envMap.toJSON(e).uuid, this.combine !== void 0 && (i.combine = this.combine)), this.envMapRotation !== void 0 && (i.envMapRotation = this.envMapRotation.toArray()), this.envMapIntensity !== void 0 && (i.envMapIntensity = this.envMapIntensity), this.reflectivity !== void 0 && (i.reflectivity = this.reflectivity), this.refractionRatio !== void 0 && (i.refractionRatio = this.refractionRatio), this.gradientMap && this.gradientMap.isTexture && (i.gradientMap = this.gradientMap.toJSON(e).uuid), this.transmission !== void 0 && (i.transmission = this.transmission), this.transmissionMap && this.transmissionMap.isTexture && (i.transmissionMap = this.transmissionMap.toJSON(e).uuid), this.thickness !== void 0 && (i.thickness = this.thickness), this.thicknessMap && this.thicknessMap.isTexture && (i.thicknessMap = this.thicknessMap.toJSON(e).uuid), this.attenuationDistance !== void 0 && this.attenuationDistance !== 1 / 0 && (i.attenuationDistance = this.attenuationDistance), this.attenuationColor !== void 0 && (i.attenuationColor = this.attenuationColor.getHex()), this.size !== void 0 && (i.size = this.size), this.shadowSide !== null && (i.shadowSide = this.shadowSide), this.sizeAttenuation !== void 0 && (i.sizeAttenuation = this.sizeAttenuation), this.blending !== Kn && (i.blending = this.blending), this.side !== hn && (i.side = this.side), this.vertexColors === !0 && (i.vertexColors = !0), this.opacity < 1 && (i.opacity = this.opacity), this.transparent === !0 && (i.transparent = !0), this.blendSrc !== _l && (i.blendSrc = this.blendSrc), this.blendDst !== xl && (i.blendDst = this.blendDst), this.blendEquation !== Wn && (i.blendEquation = this.blendEquation), this.blendSrcAlpha !== null && (i.blendSrcAlpha = this.blendSrcAlpha), this.blendDstAlpha !== null && (i.blendDstAlpha = this.blendDstAlpha), this.blendEquationAlpha !== null && (i.blendEquationAlpha = this.blendEquationAlpha), this.blendColor && this.blendColor.isColor && (i.blendColor = this.blendColor.getHex()), this.blendAlpha !== 0 && (i.blendAlpha = this.blendAlpha), this.depthFunc !== Ns && (i.depthFunc = this.depthFunc), this.depthTest === !1 && (i.depthTest = this.depthTest), this.depthWrite === !1 && (i.depthWrite = this.depthWrite), this.colorWrite === !1 && (i.colorWrite = this.colorWrite), this.stencilWriteMask !== 255 && (i.stencilWriteMask = this.stencilWriteMask), this.stencilFunc !== Yh && (i.stencilFunc = this.stencilFunc), this.stencilRef !== 0 && (i.stencilRef = this.stencilRef), this.stencilFuncMask !== 255 && (i.stencilFuncMask = this.stencilFuncMask), this.stencilFail !== os && (i.stencilFail = this.stencilFail), this.stencilZFail !== os && (i.stencilZFail = this.stencilZFail), this.stencilZPass !== os && (i.stencilZPass = this.stencilZPass), this.stencilWrite === !0 && (i.stencilWrite = this.stencilWrite), this.rotation !== void 0 && this.rotation !== 0 && (i.rotation = this.rotation), this.polygonOffset === !0 && (i.polygonOffset = !0), this.polygonOffsetFactor !== 0 && (i.polygonOffsetFactor = this.polygonOffsetFactor), this.polygonOffsetUnits !== 0 && (i.polygonOffsetUnits = this.polygonOffsetUnits), this.linewidth !== void 0 && this.linewidth !== 1 && (i.linewidth = this.linewidth), this.dashSize !== void 0 && (i.dashSize = this.dashSize), this.gapSize !== void 0 && (i.gapSize = this.gapSize), this.scale !== void 0 && (i.scale = this.scale), this.dithering === !0 && (i.dithering = !0), this.alphaTest > 0 && (i.alphaTest = this.alphaTest), this.alphaHash === !0 && (i.alphaHash = !0), this.alphaToCoverage === !0 && (i.alphaToCoverage = !0), this.premultipliedAlpha === !0 && (i.premultipliedAlpha = !0), this.forceSinglePass === !0 && (i.forceSinglePass = !0), this.allowOverride === !1 && (i.allowOverride = !1), this.wireframe === !0 && (i.wireframe = !0), this.wireframeLinewidth > 1 && (i.wireframeLinewidth = this.wireframeLinewidth), this.wireframeLinecap !== "round" && (i.wireframeLinecap = this.wireframeLinecap), this.wireframeLinejoin !== "round" && (i.wireframeLinejoin = this.wireframeLinejoin), this.flatShading === !0 && (i.flatShading = !0), this.visible === !1 && (i.visible = !1), this.toneMapped === !1 && (i.toneMapped = !1), this.fog === !1 && (i.fog = !1), Object.keys(this.userData).length > 0 && (i.userData = this.userData);
    function n(r) {
      const a = [];
      for (const o in r) {
        const l = r[o];
        delete l.metadata, a.push(l);
      }
      return a;
    }
    if (t) {
      const r = n(e.textures), a = n(e.images);
      r.length > 0 && (i.textures = r), a.length > 0 && (i.images = a);
    }
    return i;
  }
  /**
   * Returns a new material with copied values from this instance.
   *
   * @return {Material} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
  /**
   * Copies the values of the given material to this instance.
   *
   * @param {Material} source - The material to copy.
   * @return {Material} A reference to this instance.
   */
  copy(e) {
    this.name = e.name, this.blending = e.blending, this.side = e.side, this.vertexColors = e.vertexColors, this.opacity = e.opacity, this.transparent = e.transparent, this.blendSrc = e.blendSrc, this.blendDst = e.blendDst, this.blendEquation = e.blendEquation, this.blendSrcAlpha = e.blendSrcAlpha, this.blendDstAlpha = e.blendDstAlpha, this.blendEquationAlpha = e.blendEquationAlpha, this.blendColor.copy(e.blendColor), this.blendAlpha = e.blendAlpha, this.depthFunc = e.depthFunc, this.depthTest = e.depthTest, this.depthWrite = e.depthWrite, this.stencilWriteMask = e.stencilWriteMask, this.stencilFunc = e.stencilFunc, this.stencilRef = e.stencilRef, this.stencilFuncMask = e.stencilFuncMask, this.stencilFail = e.stencilFail, this.stencilZFail = e.stencilZFail, this.stencilZPass = e.stencilZPass, this.stencilWrite = e.stencilWrite;
    const t = e.clippingPlanes;
    let i = null;
    if (t !== null) {
      const n = t.length;
      i = new Array(n);
      for (let r = 0; r !== n; ++r)
        i[r] = t[r].clone();
    }
    return this.clippingPlanes = i, this.clipIntersection = e.clipIntersection, this.clipShadows = e.clipShadows, this.shadowSide = e.shadowSide, this.colorWrite = e.colorWrite, this.precision = e.precision, this.polygonOffset = e.polygonOffset, this.polygonOffsetFactor = e.polygonOffsetFactor, this.polygonOffsetUnits = e.polygonOffsetUnits, this.dithering = e.dithering, this.alphaTest = e.alphaTest, this.alphaHash = e.alphaHash, this.alphaToCoverage = e.alphaToCoverage, this.premultipliedAlpha = e.premultipliedAlpha, this.forceSinglePass = e.forceSinglePass, this.allowOverride = e.allowOverride, this.visible = e.visible, this.toneMapped = e.toneMapped, this.userData = JSON.parse(JSON.stringify(e.userData)), this;
  }
  /**
   * Frees the GPU-related resources allocated by this instance. Call this
   * method whenever this instance is no longer used in your app.
   *
   * @fires Material#dispose
   */
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
  /**
   * Setting this property to `true` indicates the engine the material
   * needs to be recompiled.
   *
   * @type {boolean}
   * @default false
   * @param {boolean} value
   */
  set needsUpdate(e) {
    e === !0 && this.version++;
  }
}
class sn extends Yt {
  /**
   * Constructs a new mesh basic material.
   *
   * @param {Object} [parameters] - An object with one or more properties
   * defining the material's appearance. Any property of the material
   * (including any property from inherited materials) can be passed
   * in here. Color values can be passed any type of value accepted
   * by {@link Color#set}.
   */
  constructor(e) {
    super(), this.isMeshBasicMaterial = !0, this.type = "MeshBasicMaterial", this.color = new Ne(16777215), this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.envMapRotation = new kt(), this.combine = Du, this.reflectivity = 1, this.refractionRatio = 0.98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.fog = !0, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.color.copy(e.color), this.map = e.map, this.lightMap = e.lightMap, this.lightMapIntensity = e.lightMapIntensity, this.aoMap = e.aoMap, this.aoMapIntensity = e.aoMapIntensity, this.specularMap = e.specularMap, this.alphaMap = e.alphaMap, this.envMap = e.envMap, this.envMapRotation.copy(e.envMapRotation), this.combine = e.combine, this.reflectivity = e.reflectivity, this.refractionRatio = e.refractionRatio, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.wireframeLinecap = e.wireframeLinecap, this.wireframeLinejoin = e.wireframeLinejoin, this.fog = e.fog, this;
  }
}
const Rt = /* @__PURE__ */ new O(), ea = /* @__PURE__ */ new Ye();
let t_ = 0;
class qt {
  /**
   * Constructs a new buffer attribute.
   *
   * @param {TypedArray} array - The array holding the attribute data.
   * @param {number} itemSize - The item size.
   * @param {boolean} [normalized=false] - Whether the data are normalized or not.
   */
  constructor(e, t, i = !1) {
    if (Array.isArray(e))
      throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
    this.isBufferAttribute = !0, Object.defineProperty(this, "id", { value: t_++ }), this.name = "", this.array = e, this.itemSize = t, this.count = e !== void 0 ? e.length / t : 0, this.normalized = i, this.usage = cc, this.updateRanges = [], this.gpuType = pi, this.version = 0;
  }
  /**
   * A callback function that is executed after the renderer has transferred the attribute
   * array data to the GPU.
   */
  onUploadCallback() {
  }
  /**
   * Flag to indicate that this attribute has changed and should be re-sent to
   * the GPU. Set this to `true` when you modify the value of the array.
   *
   * @type {number}
   * @default false
   * @param {boolean} value
   */
  set needsUpdate(e) {
    e === !0 && this.version++;
  }
  /**
   * Sets the usage of this buffer attribute.
   *
   * @param {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)} value - The usage to set.
   * @return {BufferAttribute} A reference to this buffer attribute.
   */
  setUsage(e) {
    return this.usage = e, this;
  }
  /**
   * Adds a range of data in the data array to be updated on the GPU.
   *
   * @param {number} start - Position at which to start update.
   * @param {number} count - The number of components to update.
   */
  addUpdateRange(e, t) {
    this.updateRanges.push({ start: e, count: t });
  }
  /**
   * Clears the update ranges.
   */
  clearUpdateRanges() {
    this.updateRanges.length = 0;
  }
  /**
   * Copies the values of the given buffer attribute to this instance.
   *
   * @param {BufferAttribute} source - The buffer attribute to copy.
   * @return {BufferAttribute} A reference to this instance.
   */
  copy(e) {
    return this.name = e.name, this.array = new e.array.constructor(e.array), this.itemSize = e.itemSize, this.count = e.count, this.normalized = e.normalized, this.usage = e.usage, this.gpuType = e.gpuType, this;
  }
  /**
   * Copies a vector from the given buffer attribute to this one. The start
   * and destination position in the attribute buffers are represented by the
   * given indices.
   *
   * @param {number} index1 - The destination index into this buffer attribute.
   * @param {BufferAttribute} attribute - The buffer attribute to copy from.
   * @param {number} index2 - The source index into the given buffer attribute.
   * @return {BufferAttribute} A reference to this instance.
   */
  copyAt(e, t, i) {
    e *= this.itemSize, i *= t.itemSize;
    for (let n = 0, r = this.itemSize; n < r; n++)
      this.array[e + n] = t.array[i + n];
    return this;
  }
  /**
   * Copies the given array data into this buffer attribute.
   *
   * @param {(TypedArray|Array)} array - The array to copy.
   * @return {BufferAttribute} A reference to this instance.
   */
  copyArray(e) {
    return this.array.set(e), this;
  }
  /**
   * Applies the given 3x3 matrix to the given attribute. Works with
   * item size `2` and `3`.
   *
   * @param {Matrix3} m - The matrix to apply.
   * @return {BufferAttribute} A reference to this instance.
   */
  applyMatrix3(e) {
    if (this.itemSize === 2)
      for (let t = 0, i = this.count; t < i; t++)
        ea.fromBufferAttribute(this, t), ea.applyMatrix3(e), this.setXY(t, ea.x, ea.y);
    else if (this.itemSize === 3)
      for (let t = 0, i = this.count; t < i; t++)
        Rt.fromBufferAttribute(this, t), Rt.applyMatrix3(e), this.setXYZ(t, Rt.x, Rt.y, Rt.z);
    return this;
  }
  /**
   * Applies the given 4x4 matrix to the given attribute. Only works with
   * item size `3`.
   *
   * @param {Matrix4} m - The matrix to apply.
   * @return {BufferAttribute} A reference to this instance.
   */
  applyMatrix4(e) {
    for (let t = 0, i = this.count; t < i; t++)
      Rt.fromBufferAttribute(this, t), Rt.applyMatrix4(e), this.setXYZ(t, Rt.x, Rt.y, Rt.z);
    return this;
  }
  /**
   * Applies the given 3x3 normal matrix to the given attribute. Only works with
   * item size `3`.
   *
   * @param {Matrix3} m - The normal matrix to apply.
   * @return {BufferAttribute} A reference to this instance.
   */
  applyNormalMatrix(e) {
    for (let t = 0, i = this.count; t < i; t++)
      Rt.fromBufferAttribute(this, t), Rt.applyNormalMatrix(e), this.setXYZ(t, Rt.x, Rt.y, Rt.z);
    return this;
  }
  /**
   * Applies the given 4x4 matrix to the given attribute. Only works with
   * item size `3` and with direction vectors.
   *
   * @param {Matrix4} m - The matrix to apply.
   * @return {BufferAttribute} A reference to this instance.
   */
  transformDirection(e) {
    for (let t = 0, i = this.count; t < i; t++)
      Rt.fromBufferAttribute(this, t), Rt.transformDirection(e), this.setXYZ(t, Rt.x, Rt.y, Rt.z);
    return this;
  }
  /**
   * Sets the given array data in the buffer attribute.
   *
   * @param {(TypedArray|Array)} value - The array data to set.
   * @param {number} [offset=0] - The offset in this buffer attribute's array.
   * @return {BufferAttribute} A reference to this instance.
   */
  set(e, t = 0) {
    return this.array.set(e, t), this;
  }
  /**
   * Returns the given component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} component - The component index.
   * @return {number} The returned value.
   */
  getComponent(e, t) {
    let i = this.array[e * this.itemSize + t];
    return this.normalized && (i = Mi(i, this.array)), i;
  }
  /**
   * Sets the given value to the given component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} component - The component index.
   * @param {number} value - The value to set.
   * @return {BufferAttribute} A reference to this instance.
   */
  setComponent(e, t, i) {
    return this.normalized && (i = ct(i, this.array)), this.array[e * this.itemSize + t] = i, this;
  }
  /**
   * Returns the x component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @return {number} The x component.
   */
  getX(e) {
    let t = this.array[e * this.itemSize];
    return this.normalized && (t = Mi(t, this.array)), t;
  }
  /**
   * Sets the x component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} x - The value to set.
   * @return {BufferAttribute} A reference to this instance.
   */
  setX(e, t) {
    return this.normalized && (t = ct(t, this.array)), this.array[e * this.itemSize] = t, this;
  }
  /**
   * Returns the y component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @return {number} The y component.
   */
  getY(e) {
    let t = this.array[e * this.itemSize + 1];
    return this.normalized && (t = Mi(t, this.array)), t;
  }
  /**
   * Sets the y component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} y - The value to set.
   * @return {BufferAttribute} A reference to this instance.
   */
  setY(e, t) {
    return this.normalized && (t = ct(t, this.array)), this.array[e * this.itemSize + 1] = t, this;
  }
  /**
   * Returns the z component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @return {number} The z component.
   */
  getZ(e) {
    let t = this.array[e * this.itemSize + 2];
    return this.normalized && (t = Mi(t, this.array)), t;
  }
  /**
   * Sets the z component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} z - The value to set.
   * @return {BufferAttribute} A reference to this instance.
   */
  setZ(e, t) {
    return this.normalized && (t = ct(t, this.array)), this.array[e * this.itemSize + 2] = t, this;
  }
  /**
   * Returns the w component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @return {number} The w component.
   */
  getW(e) {
    let t = this.array[e * this.itemSize + 3];
    return this.normalized && (t = Mi(t, this.array)), t;
  }
  /**
   * Sets the w component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} w - The value to set.
   * @return {BufferAttribute} A reference to this instance.
   */
  setW(e, t) {
    return this.normalized && (t = ct(t, this.array)), this.array[e * this.itemSize + 3] = t, this;
  }
  /**
   * Sets the x and y component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} x - The value for the x component to set.
   * @param {number} y - The value for the y component to set.
   * @return {BufferAttribute} A reference to this instance.
   */
  setXY(e, t, i) {
    return e *= this.itemSize, this.normalized && (t = ct(t, this.array), i = ct(i, this.array)), this.array[e + 0] = t, this.array[e + 1] = i, this;
  }
  /**
   * Sets the x, y and z component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} x - The value for the x component to set.
   * @param {number} y - The value for the y component to set.
   * @param {number} z - The value for the z component to set.
   * @return {BufferAttribute} A reference to this instance.
   */
  setXYZ(e, t, i, n) {
    return e *= this.itemSize, this.normalized && (t = ct(t, this.array), i = ct(i, this.array), n = ct(n, this.array)), this.array[e + 0] = t, this.array[e + 1] = i, this.array[e + 2] = n, this;
  }
  /**
   * Sets the x, y, z and w component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} x - The value for the x component to set.
   * @param {number} y - The value for the y component to set.
   * @param {number} z - The value for the z component to set.
   * @param {number} w - The value for the w component to set.
   * @return {BufferAttribute} A reference to this instance.
   */
  setXYZW(e, t, i, n, r) {
    return e *= this.itemSize, this.normalized && (t = ct(t, this.array), i = ct(i, this.array), n = ct(n, this.array), r = ct(r, this.array)), this.array[e + 0] = t, this.array[e + 1] = i, this.array[e + 2] = n, this.array[e + 3] = r, this;
  }
  /**
   * Sets the given callback function that is executed after the Renderer has transferred
   * the attribute array data to the GPU. Can be used to perform clean-up operations after
   * the upload when attribute data are not needed anymore on the CPU side.
   *
   * @param {Function} callback - The `onUpload()` callback.
   * @return {BufferAttribute} A reference to this instance.
   */
  onUpload(e) {
    return this.onUploadCallback = e, this;
  }
  /**
   * Returns a new buffer attribute with copied values from this instance.
   *
   * @return {BufferAttribute} A clone of this instance.
   */
  clone() {
    return new this.constructor(this.array, this.itemSize).copy(this);
  }
  /**
   * Serializes the buffer attribute into JSON.
   *
   * @return {Object} A JSON object representing the serialized buffer attribute.
   */
  toJSON() {
    const e = {
      itemSize: this.itemSize,
      type: this.array.constructor.name,
      array: Array.from(this.array),
      normalized: this.normalized
    };
    return this.name !== "" && (e.name = this.name), this.usage !== cc && (e.usage = this.usage), e;
  }
}
class tf extends qt {
  /**
   * Constructs a new buffer attribute.
   *
   * @param {(Array<number>|Uint16Array)} array - The array holding the attribute data.
   * @param {number} itemSize - The item size.
   * @param {boolean} [normalized=false] - Whether the data are normalized or not.
   */
  constructor(e, t, i) {
    super(new Uint16Array(e), t, i);
  }
}
class nf extends qt {
  /**
   * Constructs a new buffer attribute.
   *
   * @param {(Array<number>|Uint32Array)} array - The array holding the attribute data.
   * @param {number} itemSize - The item size.
   * @param {boolean} [normalized=false] - Whether the data are normalized or not.
   */
  constructor(e, t, i) {
    super(new Uint32Array(e), t, i);
  }
}
class ri extends qt {
  /**
   * Constructs a new buffer attribute.
   *
   * @param {(Array<number>|Float32Array)} array - The array holding the attribute data.
   * @param {number} itemSize - The item size.
   * @param {boolean} [normalized=false] - Whether the data are normalized or not.
   */
  constructor(e, t, i) {
    super(new Float32Array(e), t, i);
  }
}
let i_ = 0;
const di = /* @__PURE__ */ new ze(), Vo = /* @__PURE__ */ new wt(), vs = /* @__PURE__ */ new O(), ti = /* @__PURE__ */ new qi(), nr = /* @__PURE__ */ new qi(), Nt = /* @__PURE__ */ new O();
class ci extends ss {
  /**
   * Constructs a new geometry.
   */
  constructor() {
    super(), this.isBufferGeometry = !0, Object.defineProperty(this, "id", { value: i_++ }), this.uuid = Ei(), this.name = "", this.type = "BufferGeometry", this.index = null, this.indirect = null, this.indirectOffset = 0, this.attributes = {}, this.morphAttributes = {}, this.morphTargetsRelative = !1, this.groups = [], this.boundingBox = null, this.boundingSphere = null, this.drawRange = { start: 0, count: 1 / 0 }, this.userData = {};
  }
  /**
   * Returns the index of this geometry.
   *
   * @return {?BufferAttribute} The index. Returns `null` if no index is defined.
   */
  getIndex() {
    return this.index;
  }
  /**
   * Sets the given index to this geometry.
   *
   * @param {Array<number>|BufferAttribute} index - The index to set.
   * @return {BufferGeometry} A reference to this instance.
   */
  setIndex(e) {
    return Array.isArray(e) ? this.index = new (Zu(e) ? nf : tf)(e, 1) : this.index = e, this;
  }
  /**
   * Sets the given indirect attribute to this geometry.
   *
   * @param {BufferAttribute} indirect - The attribute holding indirect draw calls.
   * @param {number|Array<number>} [indirectOffset=0] - The offset, in bytes, into the indirect drawing buffer where the value data begins. If an array is provided, multiple indirect draw calls will be made for each offset.
   * @return {BufferGeometry} A reference to this instance.
   */
  setIndirect(e, t = 0) {
    return this.indirect = e, this.indirectOffset = t, this;
  }
  /**
   * Returns the indirect attribute of this geometry.
   *
   * @return {?BufferAttribute} The indirect attribute. Returns `null` if no indirect attribute is defined.
   */
  getIndirect() {
    return this.indirect;
  }
  /**
   * Returns the buffer attribute for the given name.
   *
   * @param {string} name - The attribute name.
   * @return {BufferAttribute|InterleavedBufferAttribute|undefined} The buffer attribute.
   * Returns `undefined` if not attribute has been found.
   */
  getAttribute(e) {
    return this.attributes[e];
  }
  /**
   * Sets the given attribute for the given name.
   *
   * @param {string} name - The attribute name.
   * @param {BufferAttribute|InterleavedBufferAttribute} attribute - The attribute to set.
   * @return {BufferGeometry} A reference to this instance.
   */
  setAttribute(e, t) {
    return this.attributes[e] = t, this;
  }
  /**
   * Deletes the attribute for the given name.
   *
   * @param {string} name - The attribute name to delete.
   * @return {BufferGeometry} A reference to this instance.
   */
  deleteAttribute(e) {
    return delete this.attributes[e], this;
  }
  /**
   * Returns `true` if this geometry has an attribute for the given name.
   *
   * @param {string} name - The attribute name.
   * @return {boolean} Whether this geometry has an attribute for the given name or not.
   */
  hasAttribute(e) {
    return this.attributes[e] !== void 0;
  }
  /**
   * Adds a group to this geometry.
   *
   * @param {number} start - The first element in this draw call. That is the first
   * vertex for non-indexed geometry, otherwise the first triangle index.
   * @param {number} count - Specifies how many vertices (or indices) are part of this group.
   * @param {number} [materialIndex=0] - The material array index to use.
   */
  addGroup(e, t, i = 0) {
    this.groups.push({
      start: e,
      count: t,
      materialIndex: i
    });
  }
  /**
   * Clears all groups.
   */
  clearGroups() {
    this.groups = [];
  }
  /**
   * Sets the draw range for this geometry.
   *
   * @param {number} start - The first vertex for non-indexed geometry, otherwise the first triangle index.
   * @param {number} count - For non-indexed BufferGeometry, `count` is the number of vertices to render.
   * For indexed BufferGeometry, `count` is the number of indices to render.
   */
  setDrawRange(e, t) {
    this.drawRange.start = e, this.drawRange.count = t;
  }
  /**
   * Applies the given 4x4 transformation matrix to the geometry.
   *
   * @param {Matrix4} matrix - The matrix to apply.
   * @return {BufferGeometry} A reference to this instance.
   */
  applyMatrix4(e) {
    const t = this.attributes.position;
    t !== void 0 && (t.applyMatrix4(e), t.needsUpdate = !0);
    const i = this.attributes.normal;
    if (i !== void 0) {
      const r = new Be().getNormalMatrix(e);
      i.applyNormalMatrix(r), i.needsUpdate = !0;
    }
    const n = this.attributes.tangent;
    return n !== void 0 && (n.transformDirection(e), n.needsUpdate = !0), this.boundingBox !== null && this.computeBoundingBox(), this.boundingSphere !== null && this.computeBoundingSphere(), this;
  }
  /**
   * Applies the rotation represented by the Quaternion to the geometry.
   *
   * @param {Quaternion} q - The Quaternion to apply.
   * @return {BufferGeometry} A reference to this instance.
   */
  applyQuaternion(e) {
    return di.makeRotationFromQuaternion(e), this.applyMatrix4(di), this;
  }
  /**
   * Rotates the geometry about the X axis. This is typically done as a one time
   * operation, and not during a loop. Use {@link Object3D#rotation} for typical
   * real-time mesh rotation.
   *
   * @param {number} angle - The angle in radians.
   * @return {BufferGeometry} A reference to this instance.
   */
  rotateX(e) {
    return di.makeRotationX(e), this.applyMatrix4(di), this;
  }
  /**
   * Rotates the geometry about the Y axis. This is typically done as a one time
   * operation, and not during a loop. Use {@link Object3D#rotation} for typical
   * real-time mesh rotation.
   *
   * @param {number} angle - The angle in radians.
   * @return {BufferGeometry} A reference to this instance.
   */
  rotateY(e) {
    return di.makeRotationY(e), this.applyMatrix4(di), this;
  }
  /**
   * Rotates the geometry about the Z axis. This is typically done as a one time
   * operation, and not during a loop. Use {@link Object3D#rotation} for typical
   * real-time mesh rotation.
   *
   * @param {number} angle - The angle in radians.
   * @return {BufferGeometry} A reference to this instance.
   */
  rotateZ(e) {
    return di.makeRotationZ(e), this.applyMatrix4(di), this;
  }
  /**
   * Translates the geometry. This is typically done as a one time
   * operation, and not during a loop. Use {@link Object3D#position} for typical
   * real-time mesh rotation.
   *
   * @param {number} x - The x offset.
   * @param {number} y - The y offset.
   * @param {number} z - The z offset.
   * @return {BufferGeometry} A reference to this instance.
   */
  translate(e, t, i) {
    return di.makeTranslation(e, t, i), this.applyMatrix4(di), this;
  }
  /**
   * Scales the geometry. This is typically done as a one time
   * operation, and not during a loop. Use {@link Object3D#scale} for typical
   * real-time mesh rotation.
   *
   * @param {number} x - The x scale.
   * @param {number} y - The y scale.
   * @param {number} z - The z scale.
   * @return {BufferGeometry} A reference to this instance.
   */
  scale(e, t, i) {
    return di.makeScale(e, t, i), this.applyMatrix4(di), this;
  }
  /**
   * Rotates the geometry to face a point in 3D space. This is typically done as a one time
   * operation, and not during a loop. Use {@link Object3D#lookAt} for typical
   * real-time mesh rotation.
   *
   * @param {Vector3} vector - The target point.
   * @return {BufferGeometry} A reference to this instance.
   */
  lookAt(e) {
    return Vo.lookAt(e), Vo.updateMatrix(), this.applyMatrix4(Vo.matrix), this;
  }
  /**
   * Center the geometry based on its bounding box.
   *
   * @return {BufferGeometry} A reference to this instance.
   */
  center() {
    return this.computeBoundingBox(), this.boundingBox.getCenter(vs).negate(), this.translate(vs.x, vs.y, vs.z), this;
  }
  /**
   * Defines a geometry by creating a `position` attribute based on the given array of points. The array
   * can hold 2D or 3D vectors. When using two-dimensional data, the `z` coordinate for all vertices is
   * set to `0`.
   *
   * If the method is used with an existing `position` attribute, the vertex data are overwritten with the
   * data from the array. The length of the array must match the vertex count.
   *
   * @param {Array<Vector2>|Array<Vector3>} points - The points.
   * @return {BufferGeometry} A reference to this instance.
   */
  setFromPoints(e) {
    const t = this.getAttribute("position");
    if (t === void 0) {
      const i = [];
      for (let n = 0, r = e.length; n < r; n++) {
        const a = e[n];
        i.push(a.x, a.y, a.z || 0);
      }
      this.setAttribute("position", new ri(i, 3));
    } else {
      const i = Math.min(e.length, t.count);
      for (let n = 0; n < i; n++) {
        const r = e[n];
        t.setXYZ(n, r.x, r.y, r.z || 0);
      }
      e.length > t.count && Te("BufferGeometry: Buffer size too small for points data. Use .dispose() and create a new geometry."), t.needsUpdate = !0;
    }
    return this;
  }
  /**
   * Computes the bounding box of the geometry, and updates the `boundingBox` member.
   * The bounding box is not computed by the engine; it must be computed by your app.
   * You may need to recompute the bounding box if the geometry vertices are modified.
   */
  computeBoundingBox() {
    this.boundingBox === null && (this.boundingBox = new qi());
    const e = this.attributes.position, t = this.morphAttributes.position;
    if (e && e.isGLBufferAttribute) {
      Ce("BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box.", this), this.boundingBox.set(
        new O(-1 / 0, -1 / 0, -1 / 0),
        new O(1 / 0, 1 / 0, 1 / 0)
      );
      return;
    }
    if (e !== void 0) {
      if (this.boundingBox.setFromBufferAttribute(e), t)
        for (let i = 0, n = t.length; i < n; i++) {
          const r = t[i];
          ti.setFromBufferAttribute(r), this.morphTargetsRelative ? (Nt.addVectors(this.boundingBox.min, ti.min), this.boundingBox.expandByPoint(Nt), Nt.addVectors(this.boundingBox.max, ti.max), this.boundingBox.expandByPoint(Nt)) : (this.boundingBox.expandByPoint(ti.min), this.boundingBox.expandByPoint(ti.max));
        }
    } else
      this.boundingBox.makeEmpty();
    (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) && Ce('BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
  }
  /**
   * Computes the bounding sphere of the geometry, and updates the `boundingSphere` member.
   * The engine automatically computes the bounding sphere when it is needed, e.g., for ray casting or view frustum culling.
   * You may need to recompute the bounding sphere if the geometry vertices are modified.
   */
  computeBoundingSphere() {
    this.boundingSphere === null && (this.boundingSphere = new Wi());
    const e = this.attributes.position, t = this.morphAttributes.position;
    if (e && e.isGLBufferAttribute) {
      Ce("BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere.", this), this.boundingSphere.set(new O(), 1 / 0);
      return;
    }
    if (e) {
      const i = this.boundingSphere.center;
      if (ti.setFromBufferAttribute(e), t)
        for (let r = 0, a = t.length; r < a; r++) {
          const o = t[r];
          nr.setFromBufferAttribute(o), this.morphTargetsRelative ? (Nt.addVectors(ti.min, nr.min), ti.expandByPoint(Nt), Nt.addVectors(ti.max, nr.max), ti.expandByPoint(Nt)) : (ti.expandByPoint(nr.min), ti.expandByPoint(nr.max));
        }
      ti.getCenter(i);
      let n = 0;
      for (let r = 0, a = e.count; r < a; r++)
        Nt.fromBufferAttribute(e, r), n = Math.max(n, i.distanceToSquared(Nt));
      if (t)
        for (let r = 0, a = t.length; r < a; r++) {
          const o = t[r], l = this.morphTargetsRelative;
          for (let c = 0, h = o.count; c < h; c++)
            Nt.fromBufferAttribute(o, c), l && (vs.fromBufferAttribute(e, c), Nt.add(vs)), n = Math.max(n, i.distanceToSquared(Nt));
        }
      this.boundingSphere.radius = Math.sqrt(n), isNaN(this.boundingSphere.radius) && Ce('BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
    }
  }
  /**
   * Calculates and adds a tangent attribute to this geometry.
   *
   * The computation is only supported for indexed geometries and if position, normal, and uv attributes
   * are defined. When using a tangent space normal map, prefer the MikkTSpace algorithm provided by
   * {@link BufferGeometryUtils#computeMikkTSpaceTangents} instead.
   */
  computeTangents() {
    const e = this.index, t = this.attributes;
    if (e === null || t.position === void 0 || t.normal === void 0 || t.uv === void 0) {
      Ce("BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
      return;
    }
    const i = t.position, n = t.normal, r = t.uv;
    this.hasAttribute("tangent") === !1 && this.setAttribute("tangent", new qt(new Float32Array(4 * i.count), 4));
    const a = this.getAttribute("tangent"), o = [], l = [];
    for (let F = 0; F < i.count; F++)
      o[F] = new O(), l[F] = new O();
    const c = new O(), h = new O(), d = new O(), u = new Ye(), f = new Ye(), g = new Ye(), v = new O(), m = new O();
    function p(F, y, b) {
      c.fromBufferAttribute(i, F), h.fromBufferAttribute(i, y), d.fromBufferAttribute(i, b), u.fromBufferAttribute(r, F), f.fromBufferAttribute(r, y), g.fromBufferAttribute(r, b), h.sub(c), d.sub(c), f.sub(u), g.sub(u);
      const P = 1 / (f.x * g.y - g.x * f.y);
      isFinite(P) && (v.copy(h).multiplyScalar(g.y).addScaledVector(d, -f.y).multiplyScalar(P), m.copy(d).multiplyScalar(f.x).addScaledVector(h, -g.x).multiplyScalar(P), o[F].add(v), o[y].add(v), o[b].add(v), l[F].add(m), l[y].add(m), l[b].add(m));
    }
    let w = this.groups;
    w.length === 0 && (w = [{
      start: 0,
      count: e.count
    }]);
    for (let F = 0, y = w.length; F < y; ++F) {
      const b = w[F], P = b.start, H = b.count;
      for (let V = P, Y = P + H; V < Y; V += 3)
        p(
          e.getX(V + 0),
          e.getX(V + 1),
          e.getX(V + 2)
        );
    }
    const M = new O(), T = new O(), E = new O(), A = new O();
    function R(F) {
      E.fromBufferAttribute(n, F), A.copy(E);
      const y = o[F];
      M.copy(y), M.sub(E.multiplyScalar(E.dot(y))).normalize(), T.crossVectors(A, y);
      const P = T.dot(l[F]) < 0 ? -1 : 1;
      a.setXYZW(F, M.x, M.y, M.z, P);
    }
    for (let F = 0, y = w.length; F < y; ++F) {
      const b = w[F], P = b.start, H = b.count;
      for (let V = P, Y = P + H; V < Y; V += 3)
        R(e.getX(V + 0)), R(e.getX(V + 1)), R(e.getX(V + 2));
    }
  }
  /**
   * Computes vertex normals for the given vertex data. For indexed geometries, the method sets
   * each vertex normal to be the average of the face normals of the faces that share that vertex.
   * For non-indexed geometries, vertices are not shared, and the method sets each vertex normal
   * to be the same as the face normal.
   */
  computeVertexNormals() {
    const e = this.index, t = this.getAttribute("position");
    if (t !== void 0) {
      let i = this.getAttribute("normal");
      if (i === void 0)
        i = new qt(new Float32Array(t.count * 3), 3), this.setAttribute("normal", i);
      else
        for (let u = 0, f = i.count; u < f; u++)
          i.setXYZ(u, 0, 0, 0);
      const n = new O(), r = new O(), a = new O(), o = new O(), l = new O(), c = new O(), h = new O(), d = new O();
      if (e)
        for (let u = 0, f = e.count; u < f; u += 3) {
          const g = e.getX(u + 0), v = e.getX(u + 1), m = e.getX(u + 2);
          n.fromBufferAttribute(t, g), r.fromBufferAttribute(t, v), a.fromBufferAttribute(t, m), h.subVectors(a, r), d.subVectors(n, r), h.cross(d), o.fromBufferAttribute(i, g), l.fromBufferAttribute(i, v), c.fromBufferAttribute(i, m), o.add(h), l.add(h), c.add(h), i.setXYZ(g, o.x, o.y, o.z), i.setXYZ(v, l.x, l.y, l.z), i.setXYZ(m, c.x, c.y, c.z);
        }
      else
        for (let u = 0, f = t.count; u < f; u += 3)
          n.fromBufferAttribute(t, u + 0), r.fromBufferAttribute(t, u + 1), a.fromBufferAttribute(t, u + 2), h.subVectors(a, r), d.subVectors(n, r), h.cross(d), i.setXYZ(u + 0, h.x, h.y, h.z), i.setXYZ(u + 1, h.x, h.y, h.z), i.setXYZ(u + 2, h.x, h.y, h.z);
      this.normalizeNormals(), i.needsUpdate = !0;
    }
  }
  /**
   * Ensures every normal vector in a geometry will have a magnitude of `1`. This will
   * correct lighting on the geometry surfaces.
   */
  normalizeNormals() {
    const e = this.attributes.normal;
    for (let t = 0, i = e.count; t < i; t++)
      Nt.fromBufferAttribute(e, t), Nt.normalize(), e.setXYZ(t, Nt.x, Nt.y, Nt.z);
  }
  /**
   * Return a new non-index version of this indexed geometry. If the geometry
   * is already non-indexed, the method is a NOOP.
   *
   * @return {BufferGeometry} The non-indexed version of this indexed geometry.
   */
  toNonIndexed() {
    function e(o, l) {
      const c = o.array, h = o.itemSize, d = o.normalized, u = new c.constructor(l.length * h);
      let f = 0, g = 0;
      for (let v = 0, m = l.length; v < m; v++) {
        o.isInterleavedBufferAttribute ? f = l[v] * o.data.stride + o.offset : f = l[v] * h;
        for (let p = 0; p < h; p++)
          u[g++] = c[f++];
      }
      return new qt(u, h, d);
    }
    if (this.index === null)
      return Te("BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed."), this;
    const t = new ci(), i = this.index.array, n = this.attributes;
    for (const o in n) {
      const l = n[o], c = e(l, i);
      t.setAttribute(o, c);
    }
    const r = this.morphAttributes;
    for (const o in r) {
      const l = [], c = r[o];
      for (let h = 0, d = c.length; h < d; h++) {
        const u = c[h], f = e(u, i);
        l.push(f);
      }
      t.morphAttributes[o] = l;
    }
    t.morphTargetsRelative = this.morphTargetsRelative;
    const a = this.groups;
    for (let o = 0, l = a.length; o < l; o++) {
      const c = a[o];
      t.addGroup(c.start, c.count, c.materialIndex);
    }
    return t;
  }
  /**
   * Serializes the geometry into JSON.
   *
   * @return {Object} A JSON object representing the serialized geometry.
   */
  toJSON() {
    const e = {
      metadata: {
        version: 4.7,
        type: "BufferGeometry",
        generator: "BufferGeometry.toJSON"
      }
    };
    if (e.uuid = this.uuid, e.type = this.type, this.name !== "" && (e.name = this.name), Object.keys(this.userData).length > 0 && (e.userData = this.userData), this.parameters !== void 0) {
      const l = this.parameters;
      for (const c in l)
        l[c] !== void 0 && (e[c] = l[c]);
      return e;
    }
    e.data = { attributes: {} };
    const t = this.index;
    t !== null && (e.data.index = {
      type: t.array.constructor.name,
      array: Array.prototype.slice.call(t.array)
    });
    const i = this.attributes;
    for (const l in i) {
      const c = i[l];
      e.data.attributes[l] = c.toJSON(e.data);
    }
    const n = {};
    let r = !1;
    for (const l in this.morphAttributes) {
      const c = this.morphAttributes[l], h = [];
      for (let d = 0, u = c.length; d < u; d++) {
        const f = c[d];
        h.push(f.toJSON(e.data));
      }
      h.length > 0 && (n[l] = h, r = !0);
    }
    r && (e.data.morphAttributes = n, e.data.morphTargetsRelative = this.morphTargetsRelative);
    const a = this.groups;
    a.length > 0 && (e.data.groups = JSON.parse(JSON.stringify(a)));
    const o = this.boundingSphere;
    return o !== null && (e.data.boundingSphere = o.toJSON()), e;
  }
  /**
   * Returns a new geometry with copied values from this instance.
   *
   * @return {BufferGeometry} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
  /**
   * Copies the values of the given geometry to this instance.
   *
   * @param {BufferGeometry} source - The geometry to copy.
   * @return {BufferGeometry} A reference to this instance.
   */
  copy(e) {
    this.index = null, this.attributes = {}, this.morphAttributes = {}, this.groups = [], this.boundingBox = null, this.boundingSphere = null;
    const t = {};
    this.name = e.name;
    const i = e.index;
    i !== null && this.setIndex(i.clone());
    const n = e.attributes;
    for (const c in n) {
      const h = n[c];
      this.setAttribute(c, h.clone(t));
    }
    const r = e.morphAttributes;
    for (const c in r) {
      const h = [], d = r[c];
      for (let u = 0, f = d.length; u < f; u++)
        h.push(d[u].clone(t));
      this.morphAttributes[c] = h;
    }
    this.morphTargetsRelative = e.morphTargetsRelative;
    const a = e.groups;
    for (let c = 0, h = a.length; c < h; c++) {
      const d = a[c];
      this.addGroup(d.start, d.count, d.materialIndex);
    }
    const o = e.boundingBox;
    o !== null && (this.boundingBox = o.clone());
    const l = e.boundingSphere;
    return l !== null && (this.boundingSphere = l.clone()), this.drawRange.start = e.drawRange.start, this.drawRange.count = e.drawRange.count, this.userData = e.userData, this;
  }
  /**
   * Frees the GPU-related resources allocated by this instance. Call this
   * method whenever this instance is no longer used in your app.
   *
   * @fires BufferGeometry#dispose
   */
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
}
const hd = /* @__PURE__ */ new ze(), zn = /* @__PURE__ */ new uo(), ta = /* @__PURE__ */ new Wi(), dd = /* @__PURE__ */ new O(), ia = /* @__PURE__ */ new O(), na = /* @__PURE__ */ new O(), sa = /* @__PURE__ */ new O(), Ho = /* @__PURE__ */ new O(), ra = /* @__PURE__ */ new O(), ud = /* @__PURE__ */ new O(), aa = /* @__PURE__ */ new O();
class zt extends wt {
  /**
   * Constructs a new mesh.
   *
   * @param {BufferGeometry} [geometry] - The mesh geometry.
   * @param {Material|Array<Material>} [material] - The mesh material.
   */
  constructor(e = new ci(), t = new sn()) {
    super(), this.isMesh = !0, this.type = "Mesh", this.geometry = e, this.material = t, this.morphTargetDictionary = void 0, this.morphTargetInfluences = void 0, this.count = 1, this.updateMorphTargets();
  }
  copy(e, t) {
    return super.copy(e, t), e.morphTargetInfluences !== void 0 && (this.morphTargetInfluences = e.morphTargetInfluences.slice()), e.morphTargetDictionary !== void 0 && (this.morphTargetDictionary = Object.assign({}, e.morphTargetDictionary)), this.material = Array.isArray(e.material) ? e.material.slice() : e.material, this.geometry = e.geometry, this;
  }
  /**
   * Sets the values of {@link Mesh#morphTargetDictionary} and {@link Mesh#morphTargetInfluences}
   * to make sure existing morph targets can influence this 3D object.
   */
  updateMorphTargets() {
    const t = this.geometry.morphAttributes, i = Object.keys(t);
    if (i.length > 0) {
      const n = t[i[0]];
      if (n !== void 0) {
        this.morphTargetInfluences = [], this.morphTargetDictionary = {};
        for (let r = 0, a = n.length; r < a; r++) {
          const o = n[r].name || String(r);
          this.morphTargetInfluences.push(0), this.morphTargetDictionary[o] = r;
        }
      }
    }
  }
  /**
   * Returns the local-space position of the vertex at the given index, taking into
   * account the current animation state of both morph targets and skinning.
   *
   * @param {number} index - The vertex index.
   * @param {Vector3} target - The target object that is used to store the method's result.
   * @return {Vector3} The vertex position in local space.
   */
  getVertexPosition(e, t) {
    const i = this.geometry, n = i.attributes.position, r = i.morphAttributes.position, a = i.morphTargetsRelative;
    t.fromBufferAttribute(n, e);
    const o = this.morphTargetInfluences;
    if (r && o) {
      ra.set(0, 0, 0);
      for (let l = 0, c = r.length; l < c; l++) {
        const h = o[l], d = r[l];
        h !== 0 && (Ho.fromBufferAttribute(d, e), a ? ra.addScaledVector(Ho, h) : ra.addScaledVector(Ho.sub(t), h));
      }
      t.add(ra);
    }
    return t;
  }
  /**
   * Computes intersection points between a casted ray and this line.
   *
   * @param {Raycaster} raycaster - The raycaster.
   * @param {Array<Object>} intersects - The target array that holds the intersection points.
   */
  raycast(e, t) {
    const i = this.geometry, n = this.material, r = this.matrixWorld;
    n !== void 0 && (i.boundingSphere === null && i.computeBoundingSphere(), ta.copy(i.boundingSphere), ta.applyMatrix4(r), zn.copy(e.ray).recast(e.near), !(ta.containsPoint(zn.origin) === !1 && (zn.intersectSphere(ta, dd) === null || zn.origin.distanceToSquared(dd) > (e.far - e.near) ** 2)) && (hd.copy(r).invert(), zn.copy(e.ray).applyMatrix4(hd), !(i.boundingBox !== null && zn.intersectsBox(i.boundingBox) === !1) && this._computeIntersections(e, t, zn)));
  }
  _computeIntersections(e, t, i) {
    let n;
    const r = this.geometry, a = this.material, o = r.index, l = r.attributes.position, c = r.attributes.uv, h = r.attributes.uv1, d = r.attributes.normal, u = r.groups, f = r.drawRange;
    if (o !== null)
      if (Array.isArray(a))
        for (let g = 0, v = u.length; g < v; g++) {
          const m = u[g], p = a[m.materialIndex], w = Math.max(m.start, f.start), M = Math.min(o.count, Math.min(m.start + m.count, f.start + f.count));
          for (let T = w, E = M; T < E; T += 3) {
            const A = o.getX(T), R = o.getX(T + 1), F = o.getX(T + 2);
            n = oa(this, p, e, i, c, h, d, A, R, F), n && (n.faceIndex = Math.floor(T / 3), n.face.materialIndex = m.materialIndex, t.push(n));
          }
        }
      else {
        const g = Math.max(0, f.start), v = Math.min(o.count, f.start + f.count);
        for (let m = g, p = v; m < p; m += 3) {
          const w = o.getX(m), M = o.getX(m + 1), T = o.getX(m + 2);
          n = oa(this, a, e, i, c, h, d, w, M, T), n && (n.faceIndex = Math.floor(m / 3), t.push(n));
        }
      }
    else if (l !== void 0)
      if (Array.isArray(a))
        for (let g = 0, v = u.length; g < v; g++) {
          const m = u[g], p = a[m.materialIndex], w = Math.max(m.start, f.start), M = Math.min(l.count, Math.min(m.start + m.count, f.start + f.count));
          for (let T = w, E = M; T < E; T += 3) {
            const A = T, R = T + 1, F = T + 2;
            n = oa(this, p, e, i, c, h, d, A, R, F), n && (n.faceIndex = Math.floor(T / 3), n.face.materialIndex = m.materialIndex, t.push(n));
          }
        }
      else {
        const g = Math.max(0, f.start), v = Math.min(l.count, f.start + f.count);
        for (let m = g, p = v; m < p; m += 3) {
          const w = m, M = m + 1, T = m + 2;
          n = oa(this, a, e, i, c, h, d, w, M, T), n && (n.faceIndex = Math.floor(m / 3), t.push(n));
        }
      }
  }
}
function n_(s, e, t, i, n, r, a, o) {
  let l;
  if (e.side === Kt ? l = i.intersectTriangle(a, r, n, !0, o) : l = i.intersectTriangle(n, r, a, e.side === hn, o), l === null) return null;
  aa.copy(o), aa.applyMatrix4(s.matrixWorld);
  const c = t.ray.origin.distanceTo(aa);
  return c < t.near || c > t.far ? null : {
    distance: c,
    point: aa.clone(),
    object: s
  };
}
function oa(s, e, t, i, n, r, a, o, l, c) {
  s.getVertexPosition(o, ia), s.getVertexPosition(l, na), s.getVertexPosition(c, sa);
  const h = n_(s, e, t, i, ia, na, sa, ud);
  if (h) {
    const d = new O();
    Ti.getBarycoord(ud, ia, na, sa, d), n && (h.uv = Ti.getInterpolatedAttribute(n, o, l, c, d, new Ye())), r && (h.uv1 = Ti.getInterpolatedAttribute(r, o, l, c, d, new Ye())), a && (h.normal = Ti.getInterpolatedAttribute(a, o, l, c, d, new O()), h.normal.dot(i.direction) > 0 && h.normal.multiplyScalar(-1));
    const u = {
      a: o,
      b: l,
      c,
      normal: new O(),
      materialIndex: 0
    };
    Ti.getNormal(ia, na, sa, u.normal), h.face = u, h.barycoord = d;
  }
  return h;
}
class Fr extends ci {
  /**
   * Constructs a new box geometry.
   *
   * @param {number} [width=1] - The width. That is, the length of the edges parallel to the X axis.
   * @param {number} [height=1] - The height. That is, the length of the edges parallel to the Y axis.
   * @param {number} [depth=1] - The depth. That is, the length of the edges parallel to the Z axis.
   * @param {number} [widthSegments=1] - Number of segmented rectangular faces along the width of the sides.
   * @param {number} [heightSegments=1] - Number of segmented rectangular faces along the height of the sides.
   * @param {number} [depthSegments=1] - Number of segmented rectangular faces along the depth of the sides.
   */
  constructor(e = 1, t = 1, i = 1, n = 1, r = 1, a = 1) {
    super(), this.type = "BoxGeometry", this.parameters = {
      width: e,
      height: t,
      depth: i,
      widthSegments: n,
      heightSegments: r,
      depthSegments: a
    };
    const o = this;
    n = Math.floor(n), r = Math.floor(r), a = Math.floor(a);
    const l = [], c = [], h = [], d = [];
    let u = 0, f = 0;
    g("z", "y", "x", -1, -1, i, t, e, a, r, 0), g("z", "y", "x", 1, -1, i, t, -e, a, r, 1), g("x", "z", "y", 1, 1, e, i, t, n, a, 2), g("x", "z", "y", 1, -1, e, i, -t, n, a, 3), g("x", "y", "z", 1, -1, e, t, i, n, r, 4), g("x", "y", "z", -1, -1, e, t, -i, n, r, 5), this.setIndex(l), this.setAttribute("position", new ri(c, 3)), this.setAttribute("normal", new ri(h, 3)), this.setAttribute("uv", new ri(d, 2));
    function g(v, m, p, w, M, T, E, A, R, F, y) {
      const b = T / R, P = E / F, H = T / 2, V = E / 2, Y = A / 2, X = R + 1, q = F + 1;
      let z = 0, J = 0;
      const ue = new O();
      for (let le = 0; le < q; le++) {
        const fe = le * P - V;
        for (let Ge = 0; Ge < X; Ge++) {
          const Ve = Ge * b - H;
          ue[v] = Ve * w, ue[m] = fe * M, ue[p] = Y, c.push(ue.x, ue.y, ue.z), ue[v] = 0, ue[m] = 0, ue[p] = A > 0 ? 1 : -1, h.push(ue.x, ue.y, ue.z), d.push(Ge / R), d.push(1 - le / F), z += 1;
        }
      }
      for (let le = 0; le < F; le++)
        for (let fe = 0; fe < R; fe++) {
          const Ge = u + fe + X * le, Ve = u + fe + X * (le + 1), yt = u + (fe + 1) + X * (le + 1), vt = u + (fe + 1) + X * le;
          l.push(Ge, Ve, vt), l.push(Ve, yt, vt), J += 6;
        }
      o.addGroup(f, J, y), f += J, u += z;
    }
  }
  copy(e) {
    return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
  }
  /**
   * Factory method for creating an instance of this class from the given
   * JSON object.
   *
   * @param {Object} data - A JSON object representing the serialized geometry.
   * @return {BoxGeometry} A new instance.
   */
  static fromJSON(e) {
    return new Fr(e.width, e.height, e.depth, e.widthSegments, e.heightSegments, e.depthSegments);
  }
}
function ks(s) {
  const e = {};
  for (const t in s) {
    e[t] = {};
    for (const i in s[t]) {
      const n = s[t][i];
      n && (n.isColor || n.isMatrix3 || n.isMatrix4 || n.isVector2 || n.isVector3 || n.isVector4 || n.isTexture || n.isQuaternion) ? n.isRenderTargetTexture ? (Te("UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms()."), e[t][i] = null) : e[t][i] = n.clone() : Array.isArray(n) ? e[t][i] = n.slice() : e[t][i] = n;
    }
  }
  return e;
}
function $t(s) {
  const e = {};
  for (let t = 0; t < s.length; t++) {
    const i = ks(s[t]);
    for (const n in i)
      e[n] = i[n];
  }
  return e;
}
function s_(s) {
  const e = [];
  for (let t = 0; t < s.length; t++)
    e.push(s[t].clone());
  return e;
}
function sf(s) {
  const e = s.getRenderTarget();
  return e === null ? s.outputColorSpace : e.isXRRenderTarget === !0 ? e.texture.colorSpace : Ke.workingColorSpace;
}
const Jc = { clone: ks, merge: $t };
var r_ = `void main() {
	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
}`, a_ = `void main() {
	gl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );
}`;
class oi extends Yt {
  /**
   * Constructs a new shader material.
   *
   * @param {Object} [parameters] - An object with one or more properties
   * defining the material's appearance. Any property of the material
   * (including any property from inherited materials) can be passed
   * in here. Color values can be passed any type of value accepted
   * by {@link Color#set}.
   */
  constructor(e) {
    super(), this.isShaderMaterial = !0, this.type = "ShaderMaterial", this.defines = {}, this.uniforms = {}, this.uniformsGroups = [], this.vertexShader = r_, this.fragmentShader = a_, this.linewidth = 1, this.wireframe = !1, this.wireframeLinewidth = 1, this.fog = !1, this.lights = !1, this.clipping = !1, this.forceSinglePass = !0, this.extensions = {
      clipCullDistance: !1,
      // set to use vertex shader clipping
      multiDraw: !1
      // set to use vertex shader multi_draw / enable gl_DrawID
    }, this.defaultAttributeValues = {
      color: [1, 1, 1],
      uv: [0, 0],
      uv1: [0, 0]
    }, this.index0AttributeName = void 0, this.uniformsNeedUpdate = !1, this.glslVersion = null, e !== void 0 && this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.fragmentShader = e.fragmentShader, this.vertexShader = e.vertexShader, this.uniforms = ks(e.uniforms), this.uniformsGroups = s_(e.uniformsGroups), this.defines = Object.assign({}, e.defines), this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.fog = e.fog, this.lights = e.lights, this.clipping = e.clipping, this.extensions = Object.assign({}, e.extensions), this.glslVersion = e.glslVersion, this.defaultAttributeValues = Object.assign({}, e.defaultAttributeValues), this.index0AttributeName = e.index0AttributeName, this.uniformsNeedUpdate = e.uniformsNeedUpdate, this;
  }
  toJSON(e) {
    const t = super.toJSON(e);
    t.glslVersion = this.glslVersion, t.uniforms = {};
    for (const n in this.uniforms) {
      const a = this.uniforms[n].value;
      a && a.isTexture ? t.uniforms[n] = {
        type: "t",
        value: a.toJSON(e).uuid
      } : a && a.isColor ? t.uniforms[n] = {
        type: "c",
        value: a.getHex()
      } : a && a.isVector2 ? t.uniforms[n] = {
        type: "v2",
        value: a.toArray()
      } : a && a.isVector3 ? t.uniforms[n] = {
        type: "v3",
        value: a.toArray()
      } : a && a.isVector4 ? t.uniforms[n] = {
        type: "v4",
        value: a.toArray()
      } : a && a.isMatrix3 ? t.uniforms[n] = {
        type: "m3",
        value: a.toArray()
      } : a && a.isMatrix4 ? t.uniforms[n] = {
        type: "m4",
        value: a.toArray()
      } : t.uniforms[n] = {
        value: a
      };
    }
    Object.keys(this.defines).length > 0 && (t.defines = this.defines), t.vertexShader = this.vertexShader, t.fragmentShader = this.fragmentShader, t.lights = this.lights, t.clipping = this.clipping;
    const i = {};
    for (const n in this.extensions)
      this.extensions[n] === !0 && (i[n] = !0);
    return Object.keys(i).length > 0 && (t.extensions = i), t;
  }
}
class rf extends wt {
  /**
   * Constructs a new camera.
   */
  constructor() {
    super(), this.isCamera = !0, this.type = "Camera", this.matrixWorldInverse = new ze(), this.projectionMatrix = new ze(), this.projectionMatrixInverse = new ze(), this.coordinateSystem = Bi, this._reversedDepth = !1;
  }
  /**
   * The flag that indicates whether the camera uses a reversed depth buffer.
   *
   * @type {boolean}
   * @default false
   */
  get reversedDepth() {
    return this._reversedDepth;
  }
  copy(e, t) {
    return super.copy(e, t), this.matrixWorldInverse.copy(e.matrixWorldInverse), this.projectionMatrix.copy(e.projectionMatrix), this.projectionMatrixInverse.copy(e.projectionMatrixInverse), this.coordinateSystem = e.coordinateSystem, this;
  }
  /**
   * Returns a vector representing the ("look") direction of the 3D object in world space.
   *
   * This method is overwritten since cameras have a different forward vector compared to other
   * 3D objects. A camera looks down its local, negative z-axis by default.
   *
   * @param {Vector3} target - The target vector the result is stored to.
   * @return {Vector3} The 3D object's direction in world space.
   */
  getWorldDirection(e) {
    return super.getWorldDirection(e).negate();
  }
  updateMatrixWorld(e) {
    super.updateMatrixWorld(e), this.matrixWorldInverse.copy(this.matrixWorld).invert();
  }
  updateWorldMatrix(e, t) {
    super.updateWorldMatrix(e, t), this.matrixWorldInverse.copy(this.matrixWorld).invert();
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
const yn = /* @__PURE__ */ new O(), fd = /* @__PURE__ */ new Ye(), pd = /* @__PURE__ */ new Ye();
class Gt extends rf {
  /**
   * Constructs a new perspective camera.
   *
   * @param {number} [fov=50] - The vertical field of view.
   * @param {number} [aspect=1] - The aspect ratio.
   * @param {number} [near=0.1] - The camera's near plane.
   * @param {number} [far=2000] - The camera's far plane.
   */
  constructor(e = 50, t = 1, i = 0.1, n = 2e3) {
    super(), this.isPerspectiveCamera = !0, this.type = "PerspectiveCamera", this.fov = e, this.zoom = 1, this.near = i, this.far = n, this.focus = 10, this.aspect = t, this.view = null, this.filmGauge = 35, this.filmOffset = 0, this.updateProjectionMatrix();
  }
  copy(e, t) {
    return super.copy(e, t), this.fov = e.fov, this.zoom = e.zoom, this.near = e.near, this.far = e.far, this.focus = e.focus, this.aspect = e.aspect, this.view = e.view === null ? null : Object.assign({}, e.view), this.filmGauge = e.filmGauge, this.filmOffset = e.filmOffset, this;
  }
  /**
   * Sets the FOV by focal length in respect to the current {@link PerspectiveCamera#filmGauge}.
   *
   * The default film gauge is 35, so that the focal length can be specified for
   * a 35mm (full frame) camera.
   *
   * @param {number} focalLength - Values for focal length and film gauge must have the same unit.
   */
  setFocalLength(e) {
    const t = 0.5 * this.getFilmHeight() / e;
    this.fov = Bs * 2 * Math.atan(t), this.updateProjectionMatrix();
  }
  /**
   * Returns the focal length from the current {@link PerspectiveCamera#fov} and
   * {@link PerspectiveCamera#filmGauge}.
   *
   * @return {number} The computed focal length.
   */
  getFocalLength() {
    const e = Math.tan(pr * 0.5 * this.fov);
    return 0.5 * this.getFilmHeight() / e;
  }
  /**
   * Returns the current vertical field of view angle in degrees considering {@link PerspectiveCamera#zoom}.
   *
   * @return {number} The effective FOV.
   */
  getEffectiveFOV() {
    return Bs * 2 * Math.atan(
      Math.tan(pr * 0.5 * this.fov) / this.zoom
    );
  }
  /**
   * Returns the width of the image on the film. If {@link PerspectiveCamera#aspect} is greater than or
   * equal to one (landscape format), the result equals {@link PerspectiveCamera#filmGauge}.
   *
   * @return {number} The film width.
   */
  getFilmWidth() {
    return this.filmGauge * Math.min(this.aspect, 1);
  }
  /**
   * Returns the height of the image on the film. If {@link PerspectiveCamera#aspect} is greater than or
   * equal to one (landscape format), the result equals {@link PerspectiveCamera#filmGauge}.
   *
   * @return {number} The film width.
   */
  getFilmHeight() {
    return this.filmGauge / Math.max(this.aspect, 1);
  }
  /**
   * Computes the 2D bounds of the camera's viewable rectangle at a given distance along the viewing direction.
   * Sets `minTarget` and `maxTarget` to the coordinates of the lower-left and upper-right corners of the view rectangle.
   *
   * @param {number} distance - The viewing distance.
   * @param {Vector2} minTarget - The lower-left corner of the view rectangle is written into this vector.
   * @param {Vector2} maxTarget - The upper-right corner of the view rectangle is written into this vector.
   */
  getViewBounds(e, t, i) {
    yn.set(-1, -1, 0.5).applyMatrix4(this.projectionMatrixInverse), t.set(yn.x, yn.y).multiplyScalar(-e / yn.z), yn.set(1, 1, 0.5).applyMatrix4(this.projectionMatrixInverse), i.set(yn.x, yn.y).multiplyScalar(-e / yn.z);
  }
  /**
   * Computes the width and height of the camera's viewable rectangle at a given distance along the viewing direction.
   *
   * @param {number} distance - The viewing distance.
   * @param {Vector2} target - The target vector that is used to store result where x is width and y is height.
   * @returns {Vector2} The view size.
   */
  getViewSize(e, t) {
    return this.getViewBounds(e, fd, pd), t.subVectors(pd, fd);
  }
  /**
   * Sets an offset in a larger frustum. This is useful for multi-window or
   * multi-monitor/multi-machine setups.
   *
   * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
   * the monitors are in grid like this
   *```
   *   +---+---+---+
   *   | A | B | C |
   *   +---+---+---+
   *   | D | E | F |
   *   +---+---+---+
   *```
   * then for each monitor you would call it like this:
   *```js
   * const w = 1920;
   * const h = 1080;
   * const fullWidth = w * 3;
   * const fullHeight = h * 2;
   *
   * // --A--
   * camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
   * // --B--
   * camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
   * // --C--
   * camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
   * // --D--
   * camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
   * // --E--
   * camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
   * // --F--
   * camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
   * ```
   *
   * Note there is no reason monitors have to be the same size or in a grid.
   *
   * @param {number} fullWidth - The full width of multiview setup.
   * @param {number} fullHeight - The full height of multiview setup.
   * @param {number} x - The horizontal offset of the subcamera.
   * @param {number} y - The vertical offset of the subcamera.
   * @param {number} width - The width of subcamera.
   * @param {number} height - The height of subcamera.
   */
  setViewOffset(e, t, i, n, r, a) {
    this.aspect = e / t, this.view === null && (this.view = {
      enabled: !0,
      fullWidth: 1,
      fullHeight: 1,
      offsetX: 0,
      offsetY: 0,
      width: 1,
      height: 1
    }), this.view.enabled = !0, this.view.fullWidth = e, this.view.fullHeight = t, this.view.offsetX = i, this.view.offsetY = n, this.view.width = r, this.view.height = a, this.updateProjectionMatrix();
  }
  /**
   * Removes the view offset from the projection matrix.
   */
  clearViewOffset() {
    this.view !== null && (this.view.enabled = !1), this.updateProjectionMatrix();
  }
  /**
   * Updates the camera's projection matrix. Must be called after any change of
   * camera properties.
   */
  updateProjectionMatrix() {
    const e = this.near;
    let t = e * Math.tan(pr * 0.5 * this.fov) / this.zoom, i = 2 * t, n = this.aspect * i, r = -0.5 * n;
    const a = this.view;
    if (this.view !== null && this.view.enabled) {
      const l = a.fullWidth, c = a.fullHeight;
      r += a.offsetX * n / l, t -= a.offsetY * i / c, n *= a.width / l, i *= a.height / c;
    }
    const o = this.filmOffset;
    o !== 0 && (r += e * o / this.getFilmWidth()), this.projectionMatrix.makePerspective(r, r + n, t, t - i, e, this.far, this.coordinateSystem, this.reversedDepth), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
  }
  toJSON(e) {
    const t = super.toJSON(e);
    return t.object.fov = this.fov, t.object.zoom = this.zoom, t.object.near = this.near, t.object.far = this.far, t.object.focus = this.focus, t.object.aspect = this.aspect, this.view !== null && (t.object.view = Object.assign({}, this.view)), t.object.filmGauge = this.filmGauge, t.object.filmOffset = this.filmOffset, t;
  }
}
const _s = -90, xs = 1;
class o_ extends wt {
  /**
   * Constructs a new cube camera.
   *
   * @param {number} near - The camera's near plane.
   * @param {number} far - The camera's far plane.
   * @param {WebGLCubeRenderTarget} renderTarget - The cube render target.
   */
  constructor(e, t, i) {
    super(), this.type = "CubeCamera", this.renderTarget = i, this.coordinateSystem = null, this.activeMipmapLevel = 0;
    const n = new Gt(_s, xs, e, t);
    n.layers = this.layers, this.add(n);
    const r = new Gt(_s, xs, e, t);
    r.layers = this.layers, this.add(r);
    const a = new Gt(_s, xs, e, t);
    a.layers = this.layers, this.add(a);
    const o = new Gt(_s, xs, e, t);
    o.layers = this.layers, this.add(o);
    const l = new Gt(_s, xs, e, t);
    l.layers = this.layers, this.add(l);
    const c = new Gt(_s, xs, e, t);
    c.layers = this.layers, this.add(c);
  }
  /**
   * Must be called when the coordinate system of the cube camera is changed.
   */
  updateCoordinateSystem() {
    const e = this.coordinateSystem, t = this.children.concat(), [i, n, r, a, o, l] = t;
    for (const c of t) this.remove(c);
    if (e === Bi)
      i.up.set(0, 1, 0), i.lookAt(1, 0, 0), n.up.set(0, 1, 0), n.lookAt(-1, 0, 0), r.up.set(0, 0, -1), r.lookAt(0, 1, 0), a.up.set(0, 0, 1), a.lookAt(0, -1, 0), o.up.set(0, 1, 0), o.lookAt(0, 0, 1), l.up.set(0, 1, 0), l.lookAt(0, 0, -1);
    else if (e === qa)
      i.up.set(0, -1, 0), i.lookAt(-1, 0, 0), n.up.set(0, -1, 0), n.lookAt(1, 0, 0), r.up.set(0, 0, 1), r.lookAt(0, 1, 0), a.up.set(0, 0, -1), a.lookAt(0, -1, 0), o.up.set(0, -1, 0), o.lookAt(0, 0, 1), l.up.set(0, -1, 0), l.lookAt(0, 0, -1);
    else
      throw new Error("THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: " + e);
    for (const c of t)
      this.add(c), c.updateMatrixWorld();
  }
  /**
   * Calling this method will render the given scene with the given renderer
   * into the cube render target of the camera.
   *
   * @param {(Renderer|WebGLRenderer)} renderer - The renderer.
   * @param {Scene} scene - The scene to render.
   */
  update(e, t) {
    this.parent === null && this.updateMatrixWorld();
    const { renderTarget: i, activeMipmapLevel: n } = this;
    this.coordinateSystem !== e.coordinateSystem && (this.coordinateSystem = e.coordinateSystem, this.updateCoordinateSystem());
    const [r, a, o, l, c, h] = this.children, d = e.getRenderTarget(), u = e.getActiveCubeFace(), f = e.getActiveMipmapLevel(), g = e.xr.enabled;
    e.xr.enabled = !1;
    const v = i.texture.generateMipmaps;
    i.texture.generateMipmaps = !1, e.setRenderTarget(i, 0, n), e.render(t, r), e.setRenderTarget(i, 1, n), e.render(t, a), e.setRenderTarget(i, 2, n), e.render(t, o), e.setRenderTarget(i, 3, n), e.render(t, l), e.setRenderTarget(i, 4, n), e.render(t, c), i.texture.generateMipmaps = v, e.setRenderTarget(i, 5, n), e.render(t, h), e.setRenderTarget(d, u, f), e.xr.enabled = g, i.texture.needsPMREMUpdate = !0;
  }
}
class af extends Ot {
  /**
   * Constructs a new cube texture.
   *
   * @param {Array<Image>} [images=[]] - An array holding a image for each side of a cube.
   * @param {number} [mapping=CubeReflectionMapping] - The texture mapping.
   * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
   * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
   * @param {number} [magFilter=LinearFilter] - The mag filter value.
   * @param {number} [minFilter=LinearMipmapLinearFilter] - The min filter value.
   * @param {number} [format=RGBAFormat] - The texture format.
   * @param {number} [type=UnsignedByteType] - The texture type.
   * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
   * @param {string} [colorSpace=NoColorSpace] - The color space value.
   */
  constructor(e = [], t = ts, i, n, r, a, o, l, c, h) {
    super(e, t, i, n, r, a, o, l, c, h), this.isCubeTexture = !0, this.flipY = !1;
  }
  /**
   * Alias for {@link CubeTexture#image}.
   *
   * @type {Array<Image>}
   */
  get images() {
    return this.image;
  }
  set images(e) {
    this.image = e;
  }
}
class of extends gi {
  /**
   * Constructs a new cube render target.
   *
   * @param {number} [size=1] - The size of the render target.
   * @param {RenderTarget~Options} [options] - The configuration object.
   */
  constructor(e = 1, t = {}) {
    super(e, e, t), this.isWebGLCubeRenderTarget = !0;
    const i = { width: e, height: e, depth: 1 }, n = [i, i, i, i, i, i];
    this.texture = new af(n), this._setTextureOptions(t), this.texture.isRenderTargetTexture = !0;
  }
  /**
   * Converts the given equirectangular texture to a cube map.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {Texture} texture - The equirectangular texture.
   * @return {WebGLCubeRenderTarget} A reference to this cube render target.
   */
  fromEquirectangularTexture(e, t) {
    this.texture.type = t.type, this.texture.colorSpace = t.colorSpace, this.texture.generateMipmaps = t.generateMipmaps, this.texture.minFilter = t.minFilter, this.texture.magFilter = t.magFilter;
    const i = {
      uniforms: {
        tEquirect: { value: null }
      },
      vertexShader: (
        /* glsl */
        `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`
      ),
      fragmentShader: (
        /* glsl */
        `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
      )
    }, n = new Fr(5, 5, 5), r = new oi({
      name: "CubemapFromEquirect",
      uniforms: ks(i.uniforms),
      vertexShader: i.vertexShader,
      fragmentShader: i.fragmentShader,
      side: Kt,
      blending: ki
    });
    r.uniforms.tEquirect.value = t;
    const a = new zt(n, r), o = t.minFilter;
    return t.minFilter === nn && (t.minFilter = bt), new o_(1, 10, this).update(e, a), t.minFilter = o, a.geometry.dispose(), a.material.dispose(), this;
  }
  /**
   * Clears this cube render target.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {boolean} [color=true] - Whether the color buffer should be cleared or not.
   * @param {boolean} [depth=true] - Whether the depth buffer should be cleared or not.
   * @param {boolean} [stencil=true] - Whether the stencil buffer should be cleared or not.
   */
  clear(e, t = !0, i = !0, n = !0) {
    const r = e.getRenderTarget();
    for (let a = 0; a < 6; a++)
      e.setRenderTarget(this, a), e.clear(t, i, n);
    e.setRenderTarget(r);
  }
}
class Mn extends wt {
  constructor() {
    super(), this.isGroup = !0, this.type = "Group";
  }
}
const l_ = { type: "move" };
class $o {
  /**
   * Constructs a new XR controller.
   */
  constructor() {
    this._targetRay = null, this._grip = null, this._hand = null;
  }
  /**
   * Returns a group representing the hand space of the XR controller.
   *
   * @return {Group} A group representing the hand space of the XR controller.
   */
  getHandSpace() {
    return this._hand === null && (this._hand = new Mn(), this._hand.matrixAutoUpdate = !1, this._hand.visible = !1, this._hand.joints = {}, this._hand.inputState = { pinching: !1 }), this._hand;
  }
  /**
   * Returns a group representing the target ray space of the XR controller.
   *
   * @return {Group} A group representing the target ray space of the XR controller.
   */
  getTargetRaySpace() {
    return this._targetRay === null && (this._targetRay = new Mn(), this._targetRay.matrixAutoUpdate = !1, this._targetRay.visible = !1, this._targetRay.hasLinearVelocity = !1, this._targetRay.linearVelocity = new O(), this._targetRay.hasAngularVelocity = !1, this._targetRay.angularVelocity = new O()), this._targetRay;
  }
  /**
   * Returns a group representing the grip space of the XR controller.
   *
   * @return {Group} A group representing the grip space of the XR controller.
   */
  getGripSpace() {
    return this._grip === null && (this._grip = new Mn(), this._grip.matrixAutoUpdate = !1, this._grip.visible = !1, this._grip.hasLinearVelocity = !1, this._grip.linearVelocity = new O(), this._grip.hasAngularVelocity = !1, this._grip.angularVelocity = new O()), this._grip;
  }
  /**
   * Dispatches the given event to the groups representing
   * the different coordinate spaces of the XR controller.
   *
   * @param {Object} event - The event to dispatch.
   * @return {WebXRController} A reference to this instance.
   */
  dispatchEvent(e) {
    return this._targetRay !== null && this._targetRay.dispatchEvent(e), this._grip !== null && this._grip.dispatchEvent(e), this._hand !== null && this._hand.dispatchEvent(e), this;
  }
  /**
   * Connects the controller with the given XR input source.
   *
   * @param {XRInputSource} inputSource - The input source.
   * @return {WebXRController} A reference to this instance.
   */
  connect(e) {
    if (e && e.hand) {
      const t = this._hand;
      if (t)
        for (const i of e.hand.values())
          this._getHandJoint(t, i);
    }
    return this.dispatchEvent({ type: "connected", data: e }), this;
  }
  /**
   * Disconnects the controller from the given XR input source.
   *
   * @param {XRInputSource} inputSource - The input source.
   * @return {WebXRController} A reference to this instance.
   */
  disconnect(e) {
    return this.dispatchEvent({ type: "disconnected", data: e }), this._targetRay !== null && (this._targetRay.visible = !1), this._grip !== null && (this._grip.visible = !1), this._hand !== null && (this._hand.visible = !1), this;
  }
  /**
   * Updates the controller with the given input source, XR frame and reference space.
   * This updates the transformations of the groups that represent the different
   * coordinate systems of the controller.
   *
   * @param {XRInputSource} inputSource - The input source.
   * @param {XRFrame} frame - The XR frame.
   * @param {XRReferenceSpace} referenceSpace - The reference space.
   * @return {WebXRController} A reference to this instance.
   */
  update(e, t, i) {
    let n = null, r = null, a = null;
    const o = this._targetRay, l = this._grip, c = this._hand;
    if (e && t.session.visibilityState !== "visible-blurred") {
      if (c && e.hand) {
        a = !0;
        for (const v of e.hand.values()) {
          const m = t.getJointPose(v, i), p = this._getHandJoint(c, v);
          m !== null && (p.matrix.fromArray(m.transform.matrix), p.matrix.decompose(p.position, p.rotation, p.scale), p.matrixWorldNeedsUpdate = !0, p.jointRadius = m.radius), p.visible = m !== null;
        }
        const h = c.joints["index-finger-tip"], d = c.joints["thumb-tip"], u = h.position.distanceTo(d.position), f = 0.02, g = 5e-3;
        c.inputState.pinching && u > f + g ? (c.inputState.pinching = !1, this.dispatchEvent({
          type: "pinchend",
          handedness: e.handedness,
          target: this
        })) : !c.inputState.pinching && u <= f - g && (c.inputState.pinching = !0, this.dispatchEvent({
          type: "pinchstart",
          handedness: e.handedness,
          target: this
        }));
      } else
        l !== null && e.gripSpace && (r = t.getPose(e.gripSpace, i), r !== null && (l.matrix.fromArray(r.transform.matrix), l.matrix.decompose(l.position, l.rotation, l.scale), l.matrixWorldNeedsUpdate = !0, r.linearVelocity ? (l.hasLinearVelocity = !0, l.linearVelocity.copy(r.linearVelocity)) : l.hasLinearVelocity = !1, r.angularVelocity ? (l.hasAngularVelocity = !0, l.angularVelocity.copy(r.angularVelocity)) : l.hasAngularVelocity = !1));
      o !== null && (n = t.getPose(e.targetRaySpace, i), n === null && r !== null && (n = r), n !== null && (o.matrix.fromArray(n.transform.matrix), o.matrix.decompose(o.position, o.rotation, o.scale), o.matrixWorldNeedsUpdate = !0, n.linearVelocity ? (o.hasLinearVelocity = !0, o.linearVelocity.copy(n.linearVelocity)) : o.hasLinearVelocity = !1, n.angularVelocity ? (o.hasAngularVelocity = !0, o.angularVelocity.copy(n.angularVelocity)) : o.hasAngularVelocity = !1, this.dispatchEvent(l_)));
    }
    return o !== null && (o.visible = n !== null), l !== null && (l.visible = r !== null), c !== null && (c.visible = a !== null), this;
  }
  /**
   * Returns a group representing the hand joint for the given input joint.
   *
   * @private
   * @param {Group} hand - The group representing the hand space.
   * @param {XRJointSpace} inputjoint - The hand joint data.
   * @return {Group} A group representing the hand joint for the given input joint.
   */
  _getHandJoint(e, t) {
    if (e.joints[t.jointName] === void 0) {
      const i = new Mn();
      i.matrixAutoUpdate = !1, i.visible = !1, e.joints[t.jointName] = i, e.add(i);
    }
    return e.joints[t.jointName];
  }
}
class c_ extends wt {
  /**
   * Constructs a new scene.
   */
  constructor() {
    super(), this.isScene = !0, this.type = "Scene", this.background = null, this.environment = null, this.fog = null, this.backgroundBlurriness = 0, this.backgroundIntensity = 1, this.backgroundRotation = new kt(), this.environmentIntensity = 1, this.environmentRotation = new kt(), this.overrideMaterial = null, typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", { detail: this }));
  }
  copy(e, t) {
    return super.copy(e, t), e.background !== null && (this.background = e.background.clone()), e.environment !== null && (this.environment = e.environment.clone()), e.fog !== null && (this.fog = e.fog.clone()), this.backgroundBlurriness = e.backgroundBlurriness, this.backgroundIntensity = e.backgroundIntensity, this.backgroundRotation.copy(e.backgroundRotation), this.environmentIntensity = e.environmentIntensity, this.environmentRotation.copy(e.environmentRotation), e.overrideMaterial !== null && (this.overrideMaterial = e.overrideMaterial.clone()), this.matrixAutoUpdate = e.matrixAutoUpdate, this;
  }
  toJSON(e) {
    const t = super.toJSON(e);
    return this.fog !== null && (t.object.fog = this.fog.toJSON()), this.backgroundBlurriness > 0 && (t.object.backgroundBlurriness = this.backgroundBlurriness), this.backgroundIntensity !== 1 && (t.object.backgroundIntensity = this.backgroundIntensity), t.object.backgroundRotation = this.backgroundRotation.toArray(), this.environmentIntensity !== 1 && (t.object.environmentIntensity = this.environmentIntensity), t.object.environmentRotation = this.environmentRotation.toArray(), t;
  }
}
class h_ {
  /**
   * Constructs a new interleaved buffer.
   *
   * @param {TypedArray} array - A typed array with a shared buffer storing attribute data.
   * @param {number} stride - The number of typed-array elements per vertex.
   */
  constructor(e, t) {
    this.isInterleavedBuffer = !0, this.array = e, this.stride = t, this.count = e !== void 0 ? e.length / t : 0, this.usage = cc, this.updateRanges = [], this.version = 0, this.uuid = Ei();
  }
  /**
   * A callback function that is executed after the renderer has transferred the attribute array
   * data to the GPU.
   */
  onUploadCallback() {
  }
  /**
   * Flag to indicate that this attribute has changed and should be re-sent to
   * the GPU. Set this to `true` when you modify the value of the array.
   *
   * @type {number}
   * @default false
   * @param {boolean} value
   */
  set needsUpdate(e) {
    e === !0 && this.version++;
  }
  /**
   * Sets the usage of this interleaved buffer.
   *
   * @param {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)} value - The usage to set.
   * @return {InterleavedBuffer} A reference to this interleaved buffer.
   */
  setUsage(e) {
    return this.usage = e, this;
  }
  /**
   * Adds a range of data in the data array to be updated on the GPU.
   *
   * @param {number} start - Position at which to start update.
   * @param {number} count - The number of components to update.
   */
  addUpdateRange(e, t) {
    this.updateRanges.push({ start: e, count: t });
  }
  /**
   * Clears the update ranges.
   */
  clearUpdateRanges() {
    this.updateRanges.length = 0;
  }
  /**
   * Copies the values of the given interleaved buffer to this instance.
   *
   * @param {InterleavedBuffer} source - The interleaved buffer to copy.
   * @return {InterleavedBuffer} A reference to this instance.
   */
  copy(e) {
    return this.array = new e.array.constructor(e.array), this.count = e.count, this.stride = e.stride, this.usage = e.usage, this;
  }
  /**
   * Copies a vector from the given interleaved buffer to this one. The start
   * and destination position in the attribute buffers are represented by the
   * given indices.
   *
   * @param {number} index1 - The destination index into this interleaved buffer.
   * @param {InterleavedBuffer} interleavedBuffer - The interleaved buffer to copy from.
   * @param {number} index2 - The source index into the given interleaved buffer.
   * @return {InterleavedBuffer} A reference to this instance.
   */
  copyAt(e, t, i) {
    e *= this.stride, i *= t.stride;
    for (let n = 0, r = this.stride; n < r; n++)
      this.array[e + n] = t.array[i + n];
    return this;
  }
  /**
   * Sets the given array data in the interleaved buffer.
   *
   * @param {(TypedArray|Array)} value - The array data to set.
   * @param {number} [offset=0] - The offset in this interleaved buffer's array.
   * @return {InterleavedBuffer} A reference to this instance.
   */
  set(e, t = 0) {
    return this.array.set(e, t), this;
  }
  /**
   * Returns a new interleaved buffer with copied values from this instance.
   *
   * @param {Object} [data] - An object with shared array buffers that allows to retain shared structures.
   * @return {InterleavedBuffer} A clone of this instance.
   */
  clone(e) {
    e.arrayBuffers === void 0 && (e.arrayBuffers = {}), this.array.buffer._uuid === void 0 && (this.array.buffer._uuid = Ei()), e.arrayBuffers[this.array.buffer._uuid] === void 0 && (e.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer);
    const t = new this.array.constructor(e.arrayBuffers[this.array.buffer._uuid]), i = new this.constructor(t, this.stride);
    return i.setUsage(this.usage), i;
  }
  /**
   * Sets the given callback function that is executed after the Renderer has transferred
   * the array data to the GPU. Can be used to perform clean-up operations after
   * the upload when data are not needed anymore on the CPU side.
   *
   * @param {Function} callback - The `onUpload()` callback.
   * @return {InterleavedBuffer} A reference to this instance.
   */
  onUpload(e) {
    return this.onUploadCallback = e, this;
  }
  /**
   * Serializes the interleaved buffer into JSON.
   *
   * @param {Object} [data] - An optional value holding meta information about the serialization.
   * @return {Object} A JSON object representing the serialized interleaved buffer.
   */
  toJSON(e) {
    return e.arrayBuffers === void 0 && (e.arrayBuffers = {}), this.array.buffer._uuid === void 0 && (this.array.buffer._uuid = Ei()), e.arrayBuffers[this.array.buffer._uuid] === void 0 && (e.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer))), {
      uuid: this.uuid,
      buffer: this.array.buffer._uuid,
      type: this.array.constructor.name,
      stride: this.stride
    };
  }
}
const Ht = /* @__PURE__ */ new O();
class Qc {
  /**
   * Constructs a new interleaved buffer attribute.
   *
   * @param {InterleavedBuffer} interleavedBuffer - The buffer holding the interleaved data.
   * @param {number} itemSize - The item size.
   * @param {number} offset - The attribute offset into the buffer.
   * @param {boolean} [normalized=false] - Whether the data are normalized or not.
   */
  constructor(e, t, i, n = !1) {
    this.isInterleavedBufferAttribute = !0, this.name = "", this.data = e, this.itemSize = t, this.offset = i, this.normalized = n;
  }
  /**
   * The item count of this buffer attribute.
   *
   * @type {number}
   * @readonly
   */
  get count() {
    return this.data.count;
  }
  /**
   * The array holding the interleaved buffer attribute data.
   *
   * @type {TypedArray}
   */
  get array() {
    return this.data.array;
  }
  /**
   * Flag to indicate that this attribute has changed and should be re-sent to
   * the GPU. Set this to `true` when you modify the value of the array.
   *
   * @type {number}
   * @default false
   * @param {boolean} value
   */
  set needsUpdate(e) {
    this.data.needsUpdate = e;
  }
  /**
   * Applies the given 4x4 matrix to the given attribute. Only works with
   * item size `3`.
   *
   * @param {Matrix4} m - The matrix to apply.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  applyMatrix4(e) {
    for (let t = 0, i = this.data.count; t < i; t++)
      Ht.fromBufferAttribute(this, t), Ht.applyMatrix4(e), this.setXYZ(t, Ht.x, Ht.y, Ht.z);
    return this;
  }
  /**
   * Applies the given 3x3 normal matrix to the given attribute. Only works with
   * item size `3`.
   *
   * @param {Matrix3} m - The normal matrix to apply.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  applyNormalMatrix(e) {
    for (let t = 0, i = this.count; t < i; t++)
      Ht.fromBufferAttribute(this, t), Ht.applyNormalMatrix(e), this.setXYZ(t, Ht.x, Ht.y, Ht.z);
    return this;
  }
  /**
   * Applies the given 4x4 matrix to the given attribute. Only works with
   * item size `3` and with direction vectors.
   *
   * @param {Matrix4} m - The matrix to apply.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  transformDirection(e) {
    for (let t = 0, i = this.count; t < i; t++)
      Ht.fromBufferAttribute(this, t), Ht.transformDirection(e), this.setXYZ(t, Ht.x, Ht.y, Ht.z);
    return this;
  }
  /**
   * Returns the given component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} component - The component index.
   * @return {number} The returned value.
   */
  getComponent(e, t) {
    let i = this.array[e * this.data.stride + this.offset + t];
    return this.normalized && (i = Mi(i, this.array)), i;
  }
  /**
   * Sets the given value to the given component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} component - The component index.
   * @param {number} value - The value to set.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  setComponent(e, t, i) {
    return this.normalized && (i = ct(i, this.array)), this.data.array[e * this.data.stride + this.offset + t] = i, this;
  }
  /**
   * Sets the x component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} x - The value to set.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  setX(e, t) {
    return this.normalized && (t = ct(t, this.array)), this.data.array[e * this.data.stride + this.offset] = t, this;
  }
  /**
   * Sets the y component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} y - The value to set.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  setY(e, t) {
    return this.normalized && (t = ct(t, this.array)), this.data.array[e * this.data.stride + this.offset + 1] = t, this;
  }
  /**
   * Sets the z component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} z - The value to set.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  setZ(e, t) {
    return this.normalized && (t = ct(t, this.array)), this.data.array[e * this.data.stride + this.offset + 2] = t, this;
  }
  /**
   * Sets the w component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} w - The value to set.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  setW(e, t) {
    return this.normalized && (t = ct(t, this.array)), this.data.array[e * this.data.stride + this.offset + 3] = t, this;
  }
  /**
   * Returns the x component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @return {number} The x component.
   */
  getX(e) {
    let t = this.data.array[e * this.data.stride + this.offset];
    return this.normalized && (t = Mi(t, this.array)), t;
  }
  /**
   * Returns the y component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @return {number} The y component.
   */
  getY(e) {
    let t = this.data.array[e * this.data.stride + this.offset + 1];
    return this.normalized && (t = Mi(t, this.array)), t;
  }
  /**
   * Returns the z component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @return {number} The z component.
   */
  getZ(e) {
    let t = this.data.array[e * this.data.stride + this.offset + 2];
    return this.normalized && (t = Mi(t, this.array)), t;
  }
  /**
   * Returns the w component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @return {number} The w component.
   */
  getW(e) {
    let t = this.data.array[e * this.data.stride + this.offset + 3];
    return this.normalized && (t = Mi(t, this.array)), t;
  }
  /**
   * Sets the x and y component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} x - The value for the x component to set.
   * @param {number} y - The value for the y component to set.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  setXY(e, t, i) {
    return e = e * this.data.stride + this.offset, this.normalized && (t = ct(t, this.array), i = ct(i, this.array)), this.data.array[e + 0] = t, this.data.array[e + 1] = i, this;
  }
  /**
   * Sets the x, y and z component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} x - The value for the x component to set.
   * @param {number} y - The value for the y component to set.
   * @param {number} z - The value for the z component to set.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  setXYZ(e, t, i, n) {
    return e = e * this.data.stride + this.offset, this.normalized && (t = ct(t, this.array), i = ct(i, this.array), n = ct(n, this.array)), this.data.array[e + 0] = t, this.data.array[e + 1] = i, this.data.array[e + 2] = n, this;
  }
  /**
   * Sets the x, y, z and w component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} x - The value for the x component to set.
   * @param {number} y - The value for the y component to set.
   * @param {number} z - The value for the z component to set.
   * @param {number} w - The value for the w component to set.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  setXYZW(e, t, i, n, r) {
    return e = e * this.data.stride + this.offset, this.normalized && (t = ct(t, this.array), i = ct(i, this.array), n = ct(n, this.array), r = ct(r, this.array)), this.data.array[e + 0] = t, this.data.array[e + 1] = i, this.data.array[e + 2] = n, this.data.array[e + 3] = r, this;
  }
  /**
   * Returns a new buffer attribute with copied values from this instance.
   *
   * If no parameter is provided, cloning an interleaved buffer attribute will de-interleave buffer data.
   *
   * @param {Object} [data] - An object with interleaved buffers that allows to retain the interleaved property.
   * @return {BufferAttribute|InterleavedBufferAttribute} A clone of this instance.
   */
  clone(e) {
    if (e === void 0) {
      Wa("InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.");
      const t = [];
      for (let i = 0; i < this.count; i++) {
        const n = i * this.data.stride + this.offset;
        for (let r = 0; r < this.itemSize; r++)
          t.push(this.data.array[n + r]);
      }
      return new qt(new this.array.constructor(t), this.itemSize, this.normalized);
    } else
      return e.interleavedBuffers === void 0 && (e.interleavedBuffers = {}), e.interleavedBuffers[this.data.uuid] === void 0 && (e.interleavedBuffers[this.data.uuid] = this.data.clone(e)), new Qc(e.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
  }
  /**
   * Serializes the buffer attribute into JSON.
   *
   * If no parameter is provided, cloning an interleaved buffer attribute will de-interleave buffer data.
   *
   * @param {Object} [data] - An optional value holding meta information about the serialization.
   * @return {Object} A JSON object representing the serialized buffer attribute.
   */
  toJSON(e) {
    if (e === void 0) {
      Wa("InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.");
      const t = [];
      for (let i = 0; i < this.count; i++) {
        const n = i * this.data.stride + this.offset;
        for (let r = 0; r < this.itemSize; r++)
          t.push(this.data.array[n + r]);
      }
      return {
        itemSize: this.itemSize,
        type: this.array.constructor.name,
        array: t,
        normalized: this.normalized
      };
    } else
      return e.interleavedBuffers === void 0 && (e.interleavedBuffers = {}), e.interleavedBuffers[this.data.uuid] === void 0 && (e.interleavedBuffers[this.data.uuid] = this.data.toJSON(e)), {
        isInterleavedBufferAttribute: !0,
        itemSize: this.itemSize,
        data: this.data.uuid,
        offset: this.offset,
        normalized: this.normalized
      };
  }
}
const md = /* @__PURE__ */ new O(), gd = /* @__PURE__ */ new _t(), vd = /* @__PURE__ */ new _t(), d_ = /* @__PURE__ */ new O(), _d = /* @__PURE__ */ new ze(), la = /* @__PURE__ */ new O(), Go = /* @__PURE__ */ new Wi(), xd = /* @__PURE__ */ new ze(), qo = /* @__PURE__ */ new uo();
class u_ extends zt {
  /**
   * Constructs a new skinned mesh.
   *
   * @param {BufferGeometry} [geometry] - The mesh geometry.
   * @param {Material|Array<Material>} [material] - The mesh material.
   */
  constructor(e, t) {
    super(e, t), this.isSkinnedMesh = !0, this.type = "SkinnedMesh", this.bindMode = jh, this.bindMatrix = new ze(), this.bindMatrixInverse = new ze(), this.boundingBox = null, this.boundingSphere = null;
  }
  /**
   * Computes the bounding box of the skinned mesh, and updates {@link SkinnedMesh#boundingBox}.
   * The bounding box is not automatically computed by the engine; this method must be called by your app.
   * If the skinned mesh is animated, the bounding box should be recomputed per frame in order to reflect
   * the current animation state.
   */
  computeBoundingBox() {
    const e = this.geometry;
    this.boundingBox === null && (this.boundingBox = new qi()), this.boundingBox.makeEmpty();
    const t = e.getAttribute("position");
    for (let i = 0; i < t.count; i++)
      this.getVertexPosition(i, la), this.boundingBox.expandByPoint(la);
  }
  /**
   * Computes the bounding sphere of the skinned mesh, and updates {@link SkinnedMesh#boundingSphere}.
   * The bounding sphere is automatically computed by the engine once when it is needed, e.g., for ray casting
   * and view frustum culling. If the skinned mesh is animated, the bounding sphere should be recomputed
   * per frame in order to reflect the current animation state.
   */
  computeBoundingSphere() {
    const e = this.geometry;
    this.boundingSphere === null && (this.boundingSphere = new Wi()), this.boundingSphere.makeEmpty();
    const t = e.getAttribute("position");
    for (let i = 0; i < t.count; i++)
      this.getVertexPosition(i, la), this.boundingSphere.expandByPoint(la);
  }
  copy(e, t) {
    return super.copy(e, t), this.bindMode = e.bindMode, this.bindMatrix.copy(e.bindMatrix), this.bindMatrixInverse.copy(e.bindMatrixInverse), this.skeleton = e.skeleton, e.boundingBox !== null && (this.boundingBox = e.boundingBox.clone()), e.boundingSphere !== null && (this.boundingSphere = e.boundingSphere.clone()), this;
  }
  raycast(e, t) {
    const i = this.material, n = this.matrixWorld;
    i !== void 0 && (this.boundingSphere === null && this.computeBoundingSphere(), Go.copy(this.boundingSphere), Go.applyMatrix4(n), e.ray.intersectsSphere(Go) !== !1 && (xd.copy(n).invert(), qo.copy(e.ray).applyMatrix4(xd), !(this.boundingBox !== null && qo.intersectsBox(this.boundingBox) === !1) && this._computeIntersections(e, t, qo)));
  }
  getVertexPosition(e, t) {
    return super.getVertexPosition(e, t), this.applyBoneTransform(e, t), t;
  }
  /**
   * Binds the given skeleton to the skinned mesh.
   *
   * @param {Skeleton} skeleton - The skeleton to bind.
   * @param {Matrix4} [bindMatrix] - The bind matrix. If no bind matrix is provided,
   * the skinned mesh's world matrix will be used instead.
   */
  bind(e, t) {
    this.skeleton = e, t === void 0 && (this.updateMatrixWorld(!0), this.skeleton.calculateInverses(), t = this.matrixWorld), this.bindMatrix.copy(t), this.bindMatrixInverse.copy(t).invert();
  }
  /**
   * This method sets the skinned mesh in the rest pose).
   */
  pose() {
    this.skeleton.pose();
  }
  /**
   * Normalizes the skin weights which are defined as a buffer attribute
   * in the skinned mesh's geometry.
   */
  normalizeSkinWeights() {
    const e = new _t(), t = this.geometry.attributes.skinWeight;
    for (let i = 0, n = t.count; i < n; i++) {
      e.fromBufferAttribute(t, i);
      const r = 1 / e.manhattanLength();
      r !== 1 / 0 ? e.multiplyScalar(r) : e.set(1, 0, 0, 0), t.setXYZW(i, e.x, e.y, e.z, e.w);
    }
  }
  updateMatrixWorld(e) {
    super.updateMatrixWorld(e), this.bindMode === jh ? this.bindMatrixInverse.copy(this.matrixWorld).invert() : this.bindMode === cv ? this.bindMatrixInverse.copy(this.bindMatrix).invert() : Te("SkinnedMesh: Unrecognized bindMode: " + this.bindMode);
  }
  /**
   * Applies the bone transform associated with the given index to the given
   * vertex position. Returns the updated vector.
   *
   * @param {number} index - The vertex index.
   * @param {Vector3} target - The target object that is used to store the method's result.
   * the skinned mesh's world matrix will be used instead.
   * @return {Vector3} The updated vertex position.
   */
  applyBoneTransform(e, t) {
    const i = this.skeleton, n = this.geometry;
    gd.fromBufferAttribute(n.attributes.skinIndex, e), vd.fromBufferAttribute(n.attributes.skinWeight, e), md.copy(t).applyMatrix4(this.bindMatrix), t.set(0, 0, 0);
    for (let r = 0; r < 4; r++) {
      const a = vd.getComponent(r);
      if (a !== 0) {
        const o = gd.getComponent(r);
        _d.multiplyMatrices(i.bones[o].matrixWorld, i.boneInverses[o]), t.addScaledVector(d_.copy(md).applyMatrix4(_d), a);
      }
    }
    return t.applyMatrix4(this.bindMatrixInverse);
  }
}
class lf extends wt {
  /**
   * Constructs a new bone.
   */
  constructor() {
    super(), this.isBone = !0, this.type = "Bone";
  }
}
class eh extends Ot {
  /**
   * Constructs a new data texture.
   *
   * @param {?TypedArray} [data=null] - The buffer data.
   * @param {number} [width=1] - The width of the texture.
   * @param {number} [height=1] - The height of the texture.
   * @param {number} [format=RGBAFormat] - The texture format.
   * @param {number} [type=UnsignedByteType] - The texture type.
   * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
   * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
   * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
   * @param {number} [magFilter=NearestFilter] - The mag filter value.
   * @param {number} [minFilter=NearestFilter] - The min filter value.
   * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
   * @param {string} [colorSpace=NoColorSpace] - The color space.
   */
  constructor(e = null, t = 1, i = 1, n, r, a, o, l, c = It, h = It, d, u) {
    super(null, a, o, l, c, h, n, r, d, u), this.isDataTexture = !0, this.image = { data: e, width: t, height: i }, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
  }
}
const yd = /* @__PURE__ */ new ze(), f_ = /* @__PURE__ */ new ze();
class th {
  /**
   * Constructs a new skeleton.
   *
   * @param {Array<Bone>} [bones] - An array of bones.
   * @param {Array<Matrix4>} [boneInverses] - An array of bone inverse matrices.
   * If not provided, these matrices will be computed automatically via {@link Skeleton#calculateInverses}.
   */
  constructor(e = [], t = []) {
    this.uuid = Ei(), this.bones = e.slice(0), this.boneInverses = t, this.boneMatrices = null, this.previousBoneMatrices = null, this.boneTexture = null, this.init();
  }
  /**
   * Initializes the skeleton. This method gets automatically called by the constructor
   * but depending on how the skeleton is created it might be necessary to call this method
   * manually.
   */
  init() {
    const e = this.bones, t = this.boneInverses;
    if (this.boneMatrices = new Float32Array(e.length * 16), t.length === 0)
      this.calculateInverses();
    else if (e.length !== t.length) {
      Te("Skeleton: Number of inverse bone matrices does not match amount of bones."), this.boneInverses = [];
      for (let i = 0, n = this.bones.length; i < n; i++)
        this.boneInverses.push(new ze());
    }
  }
  /**
   * Computes the bone inverse matrices. This method resets {@link Skeleton#boneInverses}
   * and fills it with new matrices.
   */
  calculateInverses() {
    this.boneInverses.length = 0;
    for (let e = 0, t = this.bones.length; e < t; e++) {
      const i = new ze();
      this.bones[e] && i.copy(this.bones[e].matrixWorld).invert(), this.boneInverses.push(i);
    }
  }
  /**
   * Resets the skeleton to the base pose.
   */
  pose() {
    for (let e = 0, t = this.bones.length; e < t; e++) {
      const i = this.bones[e];
      i && i.matrixWorld.copy(this.boneInverses[e]).invert();
    }
    for (let e = 0, t = this.bones.length; e < t; e++) {
      const i = this.bones[e];
      i && (i.parent && i.parent.isBone ? (i.matrix.copy(i.parent.matrixWorld).invert(), i.matrix.multiply(i.matrixWorld)) : i.matrix.copy(i.matrixWorld), i.matrix.decompose(i.position, i.quaternion, i.scale));
    }
  }
  /**
   * Resets the skeleton to the base pose.
   */
  update() {
    const e = this.bones, t = this.boneInverses, i = this.boneMatrices, n = this.boneTexture;
    for (let r = 0, a = e.length; r < a; r++) {
      const o = e[r] ? e[r].matrixWorld : f_;
      yd.multiplyMatrices(o, t[r]), yd.toArray(i, r * 16);
    }
    n !== null && (n.needsUpdate = !0);
  }
  /**
   * Returns a new skeleton with copied values from this instance.
   *
   * @return {Skeleton} A clone of this instance.
   */
  clone() {
    return new th(this.bones, this.boneInverses);
  }
  /**
   * Computes a data texture for passing bone data to the vertex shader.
   *
   * @return {Skeleton} A reference of this instance.
   */
  computeBoneTexture() {
    let e = Math.sqrt(this.bones.length * 4);
    e = Math.ceil(e / 4) * 4, e = Math.max(e, 4);
    const t = new Float32Array(e * e * 4);
    t.set(this.boneMatrices);
    const i = new eh(t, e, e, mi, pi);
    return i.needsUpdate = !0, this.boneMatrices = t, this.boneTexture = i, this;
  }
  /**
   * Searches through the skeleton's bone array and returns the first with a
   * matching name.
   *
   * @param {string} name - The name of the bone.
   * @return {Bone|undefined} The found bone. `undefined` if no bone has been found.
   */
  getBoneByName(e) {
    for (let t = 0, i = this.bones.length; t < i; t++) {
      const n = this.bones[t];
      if (n.name === e)
        return n;
    }
  }
  /**
   * Frees the GPU-related resources allocated by this instance. Call this
   * method whenever this instance is no longer used in your app.
   */
  dispose() {
    this.boneTexture !== null && (this.boneTexture.dispose(), this.boneTexture = null);
  }
  /**
   * Setups the skeleton by the given JSON and bones.
   *
   * @param {Object} json - The skeleton as serialized JSON.
   * @param {Object<string, Bone>} bones - An array of bones.
   * @return {Skeleton} A reference of this instance.
   */
  fromJSON(e, t) {
    this.uuid = e.uuid;
    for (let i = 0, n = e.bones.length; i < n; i++) {
      const r = e.bones[i];
      let a = t[r];
      a === void 0 && (Te("Skeleton: No bone found with UUID:", r), a = new lf()), this.bones.push(a), this.boneInverses.push(new ze().fromArray(e.boneInverses[i]));
    }
    return this.init(), this;
  }
  /**
   * Serializes the skeleton into JSON.
   *
   * @return {Object} A JSON object representing the serialized skeleton.
   * @see {@link ObjectLoader#parse}
   */
  toJSON() {
    const e = {
      metadata: {
        version: 4.7,
        type: "Skeleton",
        generator: "Skeleton.toJSON"
      },
      bones: [],
      boneInverses: []
    };
    e.uuid = this.uuid;
    const t = this.bones, i = this.boneInverses;
    for (let n = 0, r = t.length; n < r; n++) {
      const a = t[n];
      e.bones.push(a.uuid);
      const o = i[n];
      e.boneInverses.push(o.toArray());
    }
    return e;
  }
}
class dc extends qt {
  /**
   * Constructs a new instanced buffer attribute.
   *
   * @param {TypedArray} array - The array holding the attribute data.
   * @param {number} itemSize - The item size.
   * @param {boolean} [normalized=false] - Whether the data are normalized or not.
   * @param {number} [meshPerAttribute=1] - How often a value of this buffer attribute should be repeated.
   */
  constructor(e, t, i, n = 1) {
    super(e, t, i), this.isInstancedBufferAttribute = !0, this.meshPerAttribute = n;
  }
  copy(e) {
    return super.copy(e), this.meshPerAttribute = e.meshPerAttribute, this;
  }
  toJSON() {
    const e = super.toJSON();
    return e.meshPerAttribute = this.meshPerAttribute, e.isInstancedBufferAttribute = !0, e;
  }
}
const ys = /* @__PURE__ */ new ze(), bd = /* @__PURE__ */ new ze(), ca = [], wd = /* @__PURE__ */ new qi(), p_ = /* @__PURE__ */ new ze(), sr = /* @__PURE__ */ new zt(), rr = /* @__PURE__ */ new Wi();
class m_ extends zt {
  /**
   * Constructs a new instanced mesh.
   *
   * @param {BufferGeometry} [geometry] - The mesh geometry.
   * @param {Material|Array<Material>} [material] - The mesh material.
   * @param {number} count - The number of instances.
   */
  constructor(e, t, i) {
    super(e, t), this.isInstancedMesh = !0, this.instanceMatrix = new dc(new Float32Array(i * 16), 16), this.instanceColor = null, this.morphTexture = null, this.count = i, this.boundingBox = null, this.boundingSphere = null;
    for (let n = 0; n < i; n++)
      this.setMatrixAt(n, p_);
  }
  /**
   * Computes the bounding box of the instanced mesh, and updates {@link InstancedMesh#boundingBox}.
   * The bounding box is not automatically computed by the engine; this method must be called by your app.
   * You may need to recompute the bounding box if an instance is transformed via {@link InstancedMesh#setMatrixAt}.
   */
  computeBoundingBox() {
    const e = this.geometry, t = this.count;
    this.boundingBox === null && (this.boundingBox = new qi()), e.boundingBox === null && e.computeBoundingBox(), this.boundingBox.makeEmpty();
    for (let i = 0; i < t; i++)
      this.getMatrixAt(i, ys), wd.copy(e.boundingBox).applyMatrix4(ys), this.boundingBox.union(wd);
  }
  /**
   * Computes the bounding sphere of the instanced mesh, and updates {@link InstancedMesh#boundingSphere}
   * The engine automatically computes the bounding sphere when it is needed, e.g., for ray casting or view frustum culling.
   * You may need to recompute the bounding sphere if an instance is transformed via {@link InstancedMesh#setMatrixAt}.
   */
  computeBoundingSphere() {
    const e = this.geometry, t = this.count;
    this.boundingSphere === null && (this.boundingSphere = new Wi()), e.boundingSphere === null && e.computeBoundingSphere(), this.boundingSphere.makeEmpty();
    for (let i = 0; i < t; i++)
      this.getMatrixAt(i, ys), rr.copy(e.boundingSphere).applyMatrix4(ys), this.boundingSphere.union(rr);
  }
  copy(e, t) {
    return super.copy(e, t), this.instanceMatrix.copy(e.instanceMatrix), e.morphTexture !== null && (this.morphTexture = e.morphTexture.clone()), e.instanceColor !== null && (this.instanceColor = e.instanceColor.clone()), this.count = e.count, e.boundingBox !== null && (this.boundingBox = e.boundingBox.clone()), e.boundingSphere !== null && (this.boundingSphere = e.boundingSphere.clone()), this;
  }
  /**
   * Gets the color of the defined instance.
   *
   * @param {number} index - The instance index.
   * @param {Color} color - The target object that is used to store the method's result.
   */
  getColorAt(e, t) {
    t.fromArray(this.instanceColor.array, e * 3);
  }
  /**
   * Gets the local transformation matrix of the defined instance.
   *
   * @param {number} index - The instance index.
   * @param {Matrix4} matrix - The target object that is used to store the method's result.
   */
  getMatrixAt(e, t) {
    t.fromArray(this.instanceMatrix.array, e * 16);
  }
  /**
   * Gets the morph target weights of the defined instance.
   *
   * @param {number} index - The instance index.
   * @param {Mesh} object - The target object that is used to store the method's result.
   */
  getMorphAt(e, t) {
    const i = t.morphTargetInfluences, n = this.morphTexture.source.data.data, r = i.length + 1, a = e * r + 1;
    for (let o = 0; o < i.length; o++)
      i[o] = n[a + o];
  }
  raycast(e, t) {
    const i = this.matrixWorld, n = this.count;
    if (sr.geometry = this.geometry, sr.material = this.material, sr.material !== void 0 && (this.boundingSphere === null && this.computeBoundingSphere(), rr.copy(this.boundingSphere), rr.applyMatrix4(i), e.ray.intersectsSphere(rr) !== !1))
      for (let r = 0; r < n; r++) {
        this.getMatrixAt(r, ys), bd.multiplyMatrices(i, ys), sr.matrixWorld = bd, sr.raycast(e, ca);
        for (let a = 0, o = ca.length; a < o; a++) {
          const l = ca[a];
          l.instanceId = r, l.object = this, t.push(l);
        }
        ca.length = 0;
      }
  }
  /**
   * Sets the given color to the defined instance. Make sure you set the `needsUpdate` flag of
   * {@link InstancedMesh#instanceColor} to `true` after updating all the colors.
   *
   * @param {number} index - The instance index.
   * @param {Color} color - The instance color.
   */
  setColorAt(e, t) {
    this.instanceColor === null && (this.instanceColor = new dc(new Float32Array(this.instanceMatrix.count * 3).fill(1), 3)), t.toArray(this.instanceColor.array, e * 3);
  }
  /**
   * Sets the given local transformation matrix to the defined instance. Make sure you set the `needsUpdate` flag of
   * {@link InstancedMesh#instanceMatrix} to `true` after updating all the colors.
   *
   * @param {number} index - The instance index.
   * @param {Matrix4} matrix - The local transformation.
   */
  setMatrixAt(e, t) {
    t.toArray(this.instanceMatrix.array, e * 16);
  }
  /**
   * Sets the morph target weights to the defined instance. Make sure you set the `needsUpdate` flag of
   * {@link InstancedMesh#morphTexture} to `true` after updating all the influences.
   *
   * @param {number} index - The instance index.
   * @param {Mesh} object -  A mesh which `morphTargetInfluences` property containing the morph target weights
   * of a single instance.
   */
  setMorphAt(e, t) {
    const i = t.morphTargetInfluences, n = i.length + 1;
    this.morphTexture === null && (this.morphTexture = new eh(new Float32Array(n * this.count), n, this.count, $c, pi));
    const r = this.morphTexture.source.data.data;
    let a = 0;
    for (let c = 0; c < i.length; c++)
      a += i[c];
    const o = this.geometry.morphTargetsRelative ? 1 : 1 - a, l = n * e;
    r[l] = o, r.set(i, l + 1);
  }
  updateMorphTargets() {
  }
  /**
   * Frees the GPU-related resources allocated by this instance. Call this
   * method whenever this instance is no longer used in your app.
   */
  dispose() {
    this.dispatchEvent({ type: "dispose" }), this.morphTexture !== null && (this.morphTexture.dispose(), this.morphTexture = null);
  }
}
const Wo = /* @__PURE__ */ new O(), g_ = /* @__PURE__ */ new O(), v_ = /* @__PURE__ */ new Be();
class qn {
  /**
   * Constructs a new plane.
   *
   * @param {Vector3} [normal=(1,0,0)] - A unit length vector defining the normal of the plane.
   * @param {number} [constant=0] - The signed distance from the origin to the plane.
   */
  constructor(e = new O(1, 0, 0), t = 0) {
    this.isPlane = !0, this.normal = e, this.constant = t;
  }
  /**
   * Sets the plane components by copying the given values.
   *
   * @param {Vector3} normal - The normal.
   * @param {number} constant - The constant.
   * @return {Plane} A reference to this plane.
   */
  set(e, t) {
    return this.normal.copy(e), this.constant = t, this;
  }
  /**
   * Sets the plane components by defining `x`, `y`, `z` as the
   * plane normal and `w` as the constant.
   *
   * @param {number} x - The value for the normal's x component.
   * @param {number} y - The value for the normal's y component.
   * @param {number} z - The value for the normal's z component.
   * @param {number} w - The constant value.
   * @return {Plane} A reference to this plane.
   */
  setComponents(e, t, i, n) {
    return this.normal.set(e, t, i), this.constant = n, this;
  }
  /**
   * Sets the plane from the given normal and coplanar point (that is a point
   * that lies onto the plane).
   *
   * @param {Vector3} normal - The normal.
   * @param {Vector3} point - A coplanar point.
   * @return {Plane} A reference to this plane.
   */
  setFromNormalAndCoplanarPoint(e, t) {
    return this.normal.copy(e), this.constant = -t.dot(this.normal), this;
  }
  /**
   * Sets the plane from three coplanar points. The winding order is
   * assumed to be counter-clockwise, and determines the direction of
   * the plane normal.
   *
   * @param {Vector3} a - The first coplanar point.
   * @param {Vector3} b - The second coplanar point.
   * @param {Vector3} c - The third coplanar point.
   * @return {Plane} A reference to this plane.
   */
  setFromCoplanarPoints(e, t, i) {
    const n = Wo.subVectors(i, t).cross(g_.subVectors(e, t)).normalize();
    return this.setFromNormalAndCoplanarPoint(n, e), this;
  }
  /**
   * Copies the values of the given plane to this instance.
   *
   * @param {Plane} plane - The plane to copy.
   * @return {Plane} A reference to this plane.
   */
  copy(e) {
    return this.normal.copy(e.normal), this.constant = e.constant, this;
  }
  /**
   * Normalizes the plane normal and adjusts the constant accordingly.
   *
   * @return {Plane} A reference to this plane.
   */
  normalize() {
    const e = 1 / this.normal.length();
    return this.normal.multiplyScalar(e), this.constant *= e, this;
  }
  /**
   * Negates both the plane normal and the constant.
   *
   * @return {Plane} A reference to this plane.
   */
  negate() {
    return this.constant *= -1, this.normal.negate(), this;
  }
  /**
   * Returns the signed distance from the given point to this plane.
   *
   * @param {Vector3} point - The point to compute the distance for.
   * @return {number} The signed distance.
   */
  distanceToPoint(e) {
    return this.normal.dot(e) + this.constant;
  }
  /**
   * Returns the signed distance from the given sphere to this plane.
   *
   * @param {Sphere} sphere - The sphere to compute the distance for.
   * @return {number} The signed distance.
   */
  distanceToSphere(e) {
    return this.distanceToPoint(e.center) - e.radius;
  }
  /**
   * Projects a the given point onto the plane.
   *
   * @param {Vector3} point - The point to project.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The projected point on the plane.
   */
  projectPoint(e, t) {
    return t.copy(e).addScaledVector(this.normal, -this.distanceToPoint(e));
  }
  /**
   * Returns the intersection point of the passed line and the plane. Returns
   * `null` if the line does not intersect. Returns the line's starting point if
   * the line is coplanar with the plane.
   *
   * @param {Line3} line - The line to compute the intersection for.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The intersection point.
   */
  intersectLine(e, t) {
    const i = e.delta(Wo), n = this.normal.dot(i);
    if (n === 0)
      return this.distanceToPoint(e.start) === 0 ? t.copy(e.start) : null;
    const r = -(e.start.dot(this.normal) + this.constant) / n;
    return r < 0 || r > 1 ? null : t.copy(e.start).addScaledVector(i, r);
  }
  /**
   * Returns `true` if the given line segment intersects with (passes through) the plane.
   *
   * @param {Line3} line - The line to test.
   * @return {boolean} Whether the given line segment intersects with the plane or not.
   */
  intersectsLine(e) {
    const t = this.distanceToPoint(e.start), i = this.distanceToPoint(e.end);
    return t < 0 && i > 0 || i < 0 && t > 0;
  }
  /**
   * Returns `true` if the given bounding box intersects with the plane.
   *
   * @param {Box3} box - The bounding box to test.
   * @return {boolean} Whether the given bounding box intersects with the plane or not.
   */
  intersectsBox(e) {
    return e.intersectsPlane(this);
  }
  /**
   * Returns `true` if the given bounding sphere intersects with the plane.
   *
   * @param {Sphere} sphere - The bounding sphere to test.
   * @return {boolean} Whether the given bounding sphere intersects with the plane or not.
   */
  intersectsSphere(e) {
    return e.intersectsPlane(this);
  }
  /**
   * Returns a coplanar vector to the plane, by calculating the
   * projection of the normal at the origin onto the plane.
   *
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The coplanar point.
   */
  coplanarPoint(e) {
    return e.copy(this.normal).multiplyScalar(-this.constant);
  }
  /**
   * Apply a 4x4 matrix to the plane. The matrix must be an affine, homogeneous transform.
   *
   * The optional normal matrix can be pre-computed like so:
   * ```js
   * const optionalNormalMatrix = new THREE.Matrix3().getNormalMatrix( matrix );
   * ```
   *
   * @param {Matrix4} matrix - The transformation matrix.
   * @param {Matrix4} [optionalNormalMatrix] - A pre-computed normal matrix.
   * @return {Plane} A reference to this plane.
   */
  applyMatrix4(e, t) {
    const i = t || v_.getNormalMatrix(e), n = this.coplanarPoint(Wo).applyMatrix4(e), r = this.normal.applyMatrix3(i).normalize();
    return this.constant = -n.dot(r), this;
  }
  /**
   * Translates the plane by the distance defined by the given offset vector.
   * Note that this only affects the plane constant and will not affect the normal vector.
   *
   * @param {Vector3} offset - The offset vector.
   * @return {Plane} A reference to this plane.
   */
  translate(e) {
    return this.constant -= e.dot(this.normal), this;
  }
  /**
   * Returns `true` if this plane is equal with the given one.
   *
   * @param {Plane} plane - The plane to test for equality.
   * @return {boolean} Whether this plane is equal with the given one.
   */
  equals(e) {
    return e.normal.equals(this.normal) && e.constant === this.constant;
  }
  /**
   * Returns a new plane with copied values from this instance.
   *
   * @return {Plane} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
}
const Vn = /* @__PURE__ */ new Wi(), __ = /* @__PURE__ */ new Ye(0.5, 0.5), ha = /* @__PURE__ */ new O();
class ih {
  /**
   * Constructs a new frustum.
   *
   * @param {Plane} [p0] - The first plane that encloses the frustum.
   * @param {Plane} [p1] - The second plane that encloses the frustum.
   * @param {Plane} [p2] - The third plane that encloses the frustum.
   * @param {Plane} [p3] - The fourth plane that encloses the frustum.
   * @param {Plane} [p4] - The fifth plane that encloses the frustum.
   * @param {Plane} [p5] - The sixth plane that encloses the frustum.
   */
  constructor(e = new qn(), t = new qn(), i = new qn(), n = new qn(), r = new qn(), a = new qn()) {
    this.planes = [e, t, i, n, r, a];
  }
  /**
   * Sets the frustum planes by copying the given planes.
   *
   * @param {Plane} [p0] - The first plane that encloses the frustum.
   * @param {Plane} [p1] - The second plane that encloses the frustum.
   * @param {Plane} [p2] - The third plane that encloses the frustum.
   * @param {Plane} [p3] - The fourth plane that encloses the frustum.
   * @param {Plane} [p4] - The fifth plane that encloses the frustum.
   * @param {Plane} [p5] - The sixth plane that encloses the frustum.
   * @return {Frustum} A reference to this frustum.
   */
  set(e, t, i, n, r, a) {
    const o = this.planes;
    return o[0].copy(e), o[1].copy(t), o[2].copy(i), o[3].copy(n), o[4].copy(r), o[5].copy(a), this;
  }
  /**
   * Copies the values of the given frustum to this instance.
   *
   * @param {Frustum} frustum - The frustum to copy.
   * @return {Frustum} A reference to this frustum.
   */
  copy(e) {
    const t = this.planes;
    for (let i = 0; i < 6; i++)
      t[i].copy(e.planes[i]);
    return this;
  }
  /**
   * Sets the frustum planes from the given projection matrix.
   *
   * @param {Matrix4} m - The projection matrix.
   * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} coordinateSystem - The coordinate system.
   * @param {boolean} [reversedDepth=false] - Whether to use a reversed depth.
   * @return {Frustum} A reference to this frustum.
   */
  setFromProjectionMatrix(e, t = Bi, i = !1) {
    const n = this.planes, r = e.elements, a = r[0], o = r[1], l = r[2], c = r[3], h = r[4], d = r[5], u = r[6], f = r[7], g = r[8], v = r[9], m = r[10], p = r[11], w = r[12], M = r[13], T = r[14], E = r[15];
    if (n[0].setComponents(c - a, f - h, p - g, E - w).normalize(), n[1].setComponents(c + a, f + h, p + g, E + w).normalize(), n[2].setComponents(c + o, f + d, p + v, E + M).normalize(), n[3].setComponents(c - o, f - d, p - v, E - M).normalize(), i)
      n[4].setComponents(l, u, m, T).normalize(), n[5].setComponents(c - l, f - u, p - m, E - T).normalize();
    else if (n[4].setComponents(c - l, f - u, p - m, E - T).normalize(), t === Bi)
      n[5].setComponents(c + l, f + u, p + m, E + T).normalize();
    else if (t === qa)
      n[5].setComponents(l, u, m, T).normalize();
    else
      throw new Error("THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: " + t);
    return this;
  }
  /**
   * Returns `true` if the 3D object's bounding sphere is intersecting this frustum.
   *
   * Note that the 3D object must have a geometry so that the bounding sphere can be calculated.
   *
   * @param {Object3D} object - The 3D object to test.
   * @return {boolean} Whether the 3D object's bounding sphere is intersecting this frustum or not.
   */
  intersectsObject(e) {
    if (e.boundingSphere !== void 0)
      e.boundingSphere === null && e.computeBoundingSphere(), Vn.copy(e.boundingSphere).applyMatrix4(e.matrixWorld);
    else {
      const t = e.geometry;
      t.boundingSphere === null && t.computeBoundingSphere(), Vn.copy(t.boundingSphere).applyMatrix4(e.matrixWorld);
    }
    return this.intersectsSphere(Vn);
  }
  /**
   * Returns `true` if the given sprite is intersecting this frustum.
   *
   * @param {Sprite} sprite - The sprite to test.
   * @return {boolean} Whether the sprite is intersecting this frustum or not.
   */
  intersectsSprite(e) {
    Vn.center.set(0, 0, 0);
    const t = __.distanceTo(e.center);
    return Vn.radius = 0.7071067811865476 + t, Vn.applyMatrix4(e.matrixWorld), this.intersectsSphere(Vn);
  }
  /**
   * Returns `true` if the given bounding sphere is intersecting this frustum.
   *
   * @param {Sphere} sphere - The bounding sphere to test.
   * @return {boolean} Whether the bounding sphere is intersecting this frustum or not.
   */
  intersectsSphere(e) {
    const t = this.planes, i = e.center, n = -e.radius;
    for (let r = 0; r < 6; r++)
      if (t[r].distanceToPoint(i) < n)
        return !1;
    return !0;
  }
  /**
   * Returns `true` if the given bounding box is intersecting this frustum.
   *
   * @param {Box3} box - The bounding box to test.
   * @return {boolean} Whether the bounding box is intersecting this frustum or not.
   */
  intersectsBox(e) {
    const t = this.planes;
    for (let i = 0; i < 6; i++) {
      const n = t[i];
      if (ha.x = n.normal.x > 0 ? e.max.x : e.min.x, ha.y = n.normal.y > 0 ? e.max.y : e.min.y, ha.z = n.normal.z > 0 ? e.max.z : e.min.z, n.distanceToPoint(ha) < 0)
        return !1;
    }
    return !0;
  }
  /**
   * Returns `true` if the given point lies within the frustum.
   *
   * @param {Vector3} point - The point to test.
   * @return {boolean} Whether the point lies within this frustum or not.
   */
  containsPoint(e) {
    const t = this.planes;
    for (let i = 0; i < 6; i++)
      if (t[i].distanceToPoint(e) < 0)
        return !1;
    return !0;
  }
  /**
   * Returns a new frustum with copied values from this instance.
   *
   * @return {Frustum} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
}
class cf extends Yt {
  /**
   * Constructs a new line basic material.
   *
   * @param {Object} [parameters] - An object with one or more properties
   * defining the material's appearance. Any property of the material
   * (including any property from inherited materials) can be passed
   * in here. Color values can be passed any type of value accepted
   * by {@link Color#set}.
   */
  constructor(e) {
    super(), this.isLineBasicMaterial = !0, this.type = "LineBasicMaterial", this.color = new Ne(16777215), this.map = null, this.linewidth = 1, this.linecap = "round", this.linejoin = "round", this.fog = !0, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.color.copy(e.color), this.map = e.map, this.linewidth = e.linewidth, this.linecap = e.linecap, this.linejoin = e.linejoin, this.fog = e.fog, this;
  }
}
const Xa = /* @__PURE__ */ new O(), ja = /* @__PURE__ */ new O(), Sd = /* @__PURE__ */ new ze(), ar = /* @__PURE__ */ new uo(), da = /* @__PURE__ */ new Wi(), Xo = /* @__PURE__ */ new O(), Md = /* @__PURE__ */ new O();
class nh extends wt {
  /**
   * Constructs a new line.
   *
   * @param {BufferGeometry} [geometry] - The line geometry.
   * @param {Material|Array<Material>} [material] - The line material.
   */
  constructor(e = new ci(), t = new cf()) {
    super(), this.isLine = !0, this.type = "Line", this.geometry = e, this.material = t, this.morphTargetDictionary = void 0, this.morphTargetInfluences = void 0, this.updateMorphTargets();
  }
  copy(e, t) {
    return super.copy(e, t), this.material = Array.isArray(e.material) ? e.material.slice() : e.material, this.geometry = e.geometry, this;
  }
  /**
   * Computes an array of distance values which are necessary for rendering dashed lines.
   * For each vertex in the geometry, the method calculates the cumulative length from the
   * current point to the very beginning of the line.
   *
   * @return {Line} A reference to this line.
   */
  computeLineDistances() {
    const e = this.geometry;
    if (e.index === null) {
      const t = e.attributes.position, i = [0];
      for (let n = 1, r = t.count; n < r; n++)
        Xa.fromBufferAttribute(t, n - 1), ja.fromBufferAttribute(t, n), i[n] = i[n - 1], i[n] += Xa.distanceTo(ja);
      e.setAttribute("lineDistance", new ri(i, 1));
    } else
      Te("Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
    return this;
  }
  /**
   * Computes intersection points between a casted ray and this line.
   *
   * @param {Raycaster} raycaster - The raycaster.
   * @param {Array<Object>} intersects - The target array that holds the intersection points.
   */
  raycast(e, t) {
    const i = this.geometry, n = this.matrixWorld, r = e.params.Line.threshold, a = i.drawRange;
    if (i.boundingSphere === null && i.computeBoundingSphere(), da.copy(i.boundingSphere), da.applyMatrix4(n), da.radius += r, e.ray.intersectsSphere(da) === !1) return;
    Sd.copy(n).invert(), ar.copy(e.ray).applyMatrix4(Sd);
    const o = r / ((this.scale.x + this.scale.y + this.scale.z) / 3), l = o * o, c = this.isLineSegments ? 2 : 1, h = i.index, u = i.attributes.position;
    if (h !== null) {
      const f = Math.max(0, a.start), g = Math.min(h.count, a.start + a.count);
      for (let v = f, m = g - 1; v < m; v += c) {
        const p = h.getX(v), w = h.getX(v + 1), M = ua(this, e, ar, l, p, w, v);
        M && t.push(M);
      }
      if (this.isLineLoop) {
        const v = h.getX(g - 1), m = h.getX(f), p = ua(this, e, ar, l, v, m, g - 1);
        p && t.push(p);
      }
    } else {
      const f = Math.max(0, a.start), g = Math.min(u.count, a.start + a.count);
      for (let v = f, m = g - 1; v < m; v += c) {
        const p = ua(this, e, ar, l, v, v + 1, v);
        p && t.push(p);
      }
      if (this.isLineLoop) {
        const v = ua(this, e, ar, l, g - 1, f, g - 1);
        v && t.push(v);
      }
    }
  }
  /**
   * Sets the values of {@link Line#morphTargetDictionary} and {@link Line#morphTargetInfluences}
   * to make sure existing morph targets can influence this 3D object.
   */
  updateMorphTargets() {
    const t = this.geometry.morphAttributes, i = Object.keys(t);
    if (i.length > 0) {
      const n = t[i[0]];
      if (n !== void 0) {
        this.morphTargetInfluences = [], this.morphTargetDictionary = {};
        for (let r = 0, a = n.length; r < a; r++) {
          const o = n[r].name || String(r);
          this.morphTargetInfluences.push(0), this.morphTargetDictionary[o] = r;
        }
      }
    }
  }
}
function ua(s, e, t, i, n, r, a) {
  const o = s.geometry.attributes.position;
  if (Xa.fromBufferAttribute(o, n), ja.fromBufferAttribute(o, r), t.distanceSqToSegment(Xa, ja, Xo, Md) > i) return;
  Xo.applyMatrix4(s.matrixWorld);
  const c = e.ray.origin.distanceTo(Xo);
  if (!(c < e.near || c > e.far))
    return {
      distance: c,
      // What do we want? intersection point on the ray or on the segment??
      // point: raycaster.ray.at( distance ),
      point: Md.clone().applyMatrix4(s.matrixWorld),
      index: a,
      face: null,
      faceIndex: null,
      barycoord: null,
      object: s
    };
}
const Td = /* @__PURE__ */ new O(), Ed = /* @__PURE__ */ new O();
class x_ extends nh {
  /**
   * Constructs a new line segments.
   *
   * @param {BufferGeometry} [geometry] - The line geometry.
   * @param {Material|Array<Material>} [material] - The line material.
   */
  constructor(e, t) {
    super(e, t), this.isLineSegments = !0, this.type = "LineSegments";
  }
  computeLineDistances() {
    const e = this.geometry;
    if (e.index === null) {
      const t = e.attributes.position, i = [];
      for (let n = 0, r = t.count; n < r; n += 2)
        Td.fromBufferAttribute(t, n), Ed.fromBufferAttribute(t, n + 1), i[n] = n === 0 ? 0 : i[n - 1], i[n + 1] = i[n] + Td.distanceTo(Ed);
      e.setAttribute("lineDistance", new ri(i, 1));
    } else
      Te("LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
    return this;
  }
}
class y_ extends nh {
  /**
   * Constructs a new line loop.
   *
   * @param {BufferGeometry} [geometry] - The line geometry.
   * @param {Material|Array<Material>} [material] - The line material.
   */
  constructor(e, t) {
    super(e, t), this.isLineLoop = !0, this.type = "LineLoop";
  }
}
class hf extends Yt {
  /**
   * Constructs a new points material.
   *
   * @param {Object} [parameters] - An object with one or more properties
   * defining the material's appearance. Any property of the material
   * (including any property from inherited materials) can be passed
   * in here. Color values can be passed any type of value accepted
   * by {@link Color#set}.
   */
  constructor(e) {
    super(), this.isPointsMaterial = !0, this.type = "PointsMaterial", this.color = new Ne(16777215), this.map = null, this.alphaMap = null, this.size = 1, this.sizeAttenuation = !0, this.fog = !0, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.color.copy(e.color), this.map = e.map, this.alphaMap = e.alphaMap, this.size = e.size, this.sizeAttenuation = e.sizeAttenuation, this.fog = e.fog, this;
  }
}
const Ad = /* @__PURE__ */ new ze(), uc = /* @__PURE__ */ new uo(), fa = /* @__PURE__ */ new Wi(), pa = /* @__PURE__ */ new O();
class b_ extends wt {
  /**
   * Constructs a new point cloud.
   *
   * @param {BufferGeometry} [geometry] - The points geometry.
   * @param {Material|Array<Material>} [material] - The points material.
   */
  constructor(e = new ci(), t = new hf()) {
    super(), this.isPoints = !0, this.type = "Points", this.geometry = e, this.material = t, this.morphTargetDictionary = void 0, this.morphTargetInfluences = void 0, this.updateMorphTargets();
  }
  copy(e, t) {
    return super.copy(e, t), this.material = Array.isArray(e.material) ? e.material.slice() : e.material, this.geometry = e.geometry, this;
  }
  /**
   * Computes intersection points between a casted ray and this point cloud.
   *
   * @param {Raycaster} raycaster - The raycaster.
   * @param {Array<Object>} intersects - The target array that holds the intersection points.
   */
  raycast(e, t) {
    const i = this.geometry, n = this.matrixWorld, r = e.params.Points.threshold, a = i.drawRange;
    if (i.boundingSphere === null && i.computeBoundingSphere(), fa.copy(i.boundingSphere), fa.applyMatrix4(n), fa.radius += r, e.ray.intersectsSphere(fa) === !1) return;
    Ad.copy(n).invert(), uc.copy(e.ray).applyMatrix4(Ad);
    const o = r / ((this.scale.x + this.scale.y + this.scale.z) / 3), l = o * o, c = i.index, d = i.attributes.position;
    if (c !== null) {
      const u = Math.max(0, a.start), f = Math.min(c.count, a.start + a.count);
      for (let g = u, v = f; g < v; g++) {
        const m = c.getX(g);
        pa.fromBufferAttribute(d, m), Rd(pa, m, l, n, e, t, this);
      }
    } else {
      const u = Math.max(0, a.start), f = Math.min(d.count, a.start + a.count);
      for (let g = u, v = f; g < v; g++)
        pa.fromBufferAttribute(d, g), Rd(pa, g, l, n, e, t, this);
    }
  }
  /**
   * Sets the values of {@link Points#morphTargetDictionary} and {@link Points#morphTargetInfluences}
   * to make sure existing morph targets can influence this 3D object.
   */
  updateMorphTargets() {
    const t = this.geometry.morphAttributes, i = Object.keys(t);
    if (i.length > 0) {
      const n = t[i[0]];
      if (n !== void 0) {
        this.morphTargetInfluences = [], this.morphTargetDictionary = {};
        for (let r = 0, a = n.length; r < a; r++) {
          const o = n[r].name || String(r);
          this.morphTargetInfluences.push(0), this.morphTargetDictionary[o] = r;
        }
      }
    }
  }
}
function Rd(s, e, t, i, n, r, a) {
  const o = uc.distanceSqToPoint(s);
  if (o < t) {
    const l = new O();
    uc.closestPointToPoint(s, l), l.applyMatrix4(i);
    const c = n.ray.origin.distanceTo(l);
    if (c < n.near || c > n.far) return;
    r.push({
      distance: c,
      distanceToRay: Math.sqrt(o),
      point: l,
      index: e,
      face: null,
      faceIndex: null,
      barycoord: null,
      object: a
    });
  }
}
class Ir extends Ot {
  /**
   * Constructs a new depth texture.
   *
   * @param {number} width - The width of the texture.
   * @param {number} height - The height of the texture.
   * @param {number} [type=UnsignedIntType] - The texture type.
   * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
   * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
   * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
   * @param {number} [magFilter=LinearFilter] - The mag filter value.
   * @param {number} [minFilter=LinearFilter] - The min filter value.
   * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
   * @param {number} [format=DepthFormat] - The texture format.
   * @param {number} [depth=1] - The depth of the texture.
   */
  constructor(e, t, i = Hi, n, r, a, o = It, l = It, c, h = dn, d = 1) {
    if (h !== dn && h !== Yn)
      throw new Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
    const u = { width: e, height: t, depth: d };
    super(u, n, r, a, o, l, h, i, c), this.isDepthTexture = !0, this.flipY = !1, this.generateMipmaps = !1, this.compareFunction = null;
  }
  copy(e) {
    return super.copy(e), this.source = new Zc(Object.assign({}, e.image)), this.compareFunction = e.compareFunction, this;
  }
  toJSON(e) {
    const t = super.toJSON(e);
    return this.compareFunction !== null && (t.compareFunction = this.compareFunction), t;
  }
}
class w_ extends Ir {
  /**
   * Constructs a new cube depth texture.
   *
   * @param {number} size - The size (width and height) of each cube face.
   * @param {number} [type=UnsignedIntType] - The texture type.
   * @param {number} [mapping=CubeReflectionMapping] - The texture mapping.
   * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
   * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
   * @param {number} [magFilter=NearestFilter] - The mag filter value.
   * @param {number} [minFilter=NearestFilter] - The min filter value.
   * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
   * @param {number} [format=DepthFormat] - The texture format.
   */
  constructor(e, t = Hi, i = ts, n, r, a = It, o = It, l, c = dn) {
    const h = { width: e, height: e, depth: 1 }, d = [h, h, h, h, h, h];
    super(e, e, t, i, n, r, a, o, l, c), this.image = d, this.isCubeDepthTexture = !0, this.isCubeTexture = !0;
  }
  /**
   * Alias for {@link CubeDepthTexture#image}.
   *
   * @type {Array<Image>}
   */
  get images() {
    return this.image;
  }
  set images(e) {
    this.image = e;
  }
}
class df extends Ot {
  /**
   * Creates a new raw texture.
   *
   * @param {?(WebGLTexture|GPUTexture)} [sourceTexture=null] - The external texture.
   */
  constructor(e = null) {
    super(), this.sourceTexture = e, this.isExternalTexture = !0;
  }
  copy(e) {
    return super.copy(e), this.sourceTexture = e.sourceTexture, this;
  }
}
class Br extends ci {
  /**
   * Constructs a new plane geometry.
   *
   * @param {number} [width=1] - The width along the X axis.
   * @param {number} [height=1] - The height along the Y axis
   * @param {number} [widthSegments=1] - The number of segments along the X axis.
   * @param {number} [heightSegments=1] - The number of segments along the Y axis.
   */
  constructor(e = 1, t = 1, i = 1, n = 1) {
    super(), this.type = "PlaneGeometry", this.parameters = {
      width: e,
      height: t,
      widthSegments: i,
      heightSegments: n
    };
    const r = e / 2, a = t / 2, o = Math.floor(i), l = Math.floor(n), c = o + 1, h = l + 1, d = e / o, u = t / l, f = [], g = [], v = [], m = [];
    for (let p = 0; p < h; p++) {
      const w = p * u - a;
      for (let M = 0; M < c; M++) {
        const T = M * d - r;
        g.push(T, -w, 0), v.push(0, 0, 1), m.push(M / o), m.push(1 - p / l);
      }
    }
    for (let p = 0; p < l; p++)
      for (let w = 0; w < o; w++) {
        const M = w + c * p, T = w + c * (p + 1), E = w + 1 + c * (p + 1), A = w + 1 + c * p;
        f.push(M, T, A), f.push(T, E, A);
      }
    this.setIndex(f), this.setAttribute("position", new ri(g, 3)), this.setAttribute("normal", new ri(v, 3)), this.setAttribute("uv", new ri(m, 2));
  }
  copy(e) {
    return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
  }
  /**
   * Factory method for creating an instance of this class from the given
   * JSON object.
   *
   * @param {Object} data - A JSON object representing the serialized geometry.
   * @return {PlaneGeometry} A new instance.
   */
  static fromJSON(e) {
    return new Br(e.width, e.height, e.widthSegments, e.heightSegments);
  }
}
class S_ extends oi {
  /**
   * Constructs a new raw shader material.
   *
   * @param {Object} [parameters] - An object with one or more properties
   * defining the material's appearance. Any property of the material
   * (including any property from inherited materials) can be passed
   * in here. Color values can be passed any type of value accepted
   * by {@link Color#set}.
   */
  constructor(e) {
    super(e), this.isRawShaderMaterial = !0, this.type = "RawShaderMaterial";
  }
}
class Pr extends Yt {
  /**
   * Constructs a new mesh standard material.
   *
   * @param {Object} [parameters] - An object with one or more properties
   * defining the material's appearance. Any property of the material
   * (including any property from inherited materials) can be passed
   * in here. Color values can be passed any type of value accepted
   * by {@link Color#set}.
   */
  constructor(e) {
    super(), this.isMeshStandardMaterial = !0, this.type = "MeshStandardMaterial", this.defines = { STANDARD: "" }, this.color = new Ne(16777215), this.roughness = 1, this.metalness = 0, this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new Ne(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = Ku, this.normalScale = new Ye(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.roughnessMap = null, this.metalnessMap = null, this.alphaMap = null, this.envMap = null, this.envMapRotation = new kt(), this.envMapIntensity = 1, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.flatShading = !1, this.fog = !0, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.defines = { STANDARD: "" }, this.color.copy(e.color), this.roughness = e.roughness, this.metalness = e.metalness, this.map = e.map, this.lightMap = e.lightMap, this.lightMapIntensity = e.lightMapIntensity, this.aoMap = e.aoMap, this.aoMapIntensity = e.aoMapIntensity, this.emissive.copy(e.emissive), this.emissiveMap = e.emissiveMap, this.emissiveIntensity = e.emissiveIntensity, this.bumpMap = e.bumpMap, this.bumpScale = e.bumpScale, this.normalMap = e.normalMap, this.normalMapType = e.normalMapType, this.normalScale.copy(e.normalScale), this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this.roughnessMap = e.roughnessMap, this.metalnessMap = e.metalnessMap, this.alphaMap = e.alphaMap, this.envMap = e.envMap, this.envMapRotation.copy(e.envMapRotation), this.envMapIntensity = e.envMapIntensity, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.wireframeLinecap = e.wireframeLinecap, this.wireframeLinejoin = e.wireframeLinejoin, this.flatShading = e.flatShading, this.fog = e.fog, this;
  }
}
class Xi extends Pr {
  /**
   * Constructs a new mesh physical material.
   *
   * @param {Object} [parameters] - An object with one or more properties
   * defining the material's appearance. Any property of the material
   * (including any property from inherited materials) can be passed
   * in here. Color values can be passed any type of value accepted
   * by {@link Color#set}.
   */
  constructor(e) {
    super(), this.isMeshPhysicalMaterial = !0, this.defines = {
      STANDARD: "",
      PHYSICAL: ""
    }, this.type = "MeshPhysicalMaterial", this.anisotropyRotation = 0, this.anisotropyMap = null, this.clearcoatMap = null, this.clearcoatRoughness = 0, this.clearcoatRoughnessMap = null, this.clearcoatNormalScale = new Ye(1, 1), this.clearcoatNormalMap = null, this.ior = 1.5, Object.defineProperty(this, "reflectivity", {
      get: function() {
        return Xe(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
      },
      set: function(t) {
        this.ior = (1 + 0.4 * t) / (1 - 0.4 * t);
      }
    }), this.iridescenceMap = null, this.iridescenceIOR = 1.3, this.iridescenceThicknessRange = [100, 400], this.iridescenceThicknessMap = null, this.sheenColor = new Ne(0), this.sheenColorMap = null, this.sheenRoughness = 1, this.sheenRoughnessMap = null, this.transmissionMap = null, this.thickness = 0, this.thicknessMap = null, this.attenuationDistance = 1 / 0, this.attenuationColor = new Ne(1, 1, 1), this.specularIntensity = 1, this.specularIntensityMap = null, this.specularColor = new Ne(1, 1, 1), this.specularColorMap = null, this._anisotropy = 0, this._clearcoat = 0, this._dispersion = 0, this._iridescence = 0, this._sheen = 0, this._transmission = 0, this.setValues(e);
  }
  /**
   * The anisotropy strength, from `0.0` to `1.0`.
   *
   * @type {number}
   * @default 0
   */
  get anisotropy() {
    return this._anisotropy;
  }
  set anisotropy(e) {
    this._anisotropy > 0 != e > 0 && this.version++, this._anisotropy = e;
  }
  /**
   * Represents the intensity of the clear coat layer, from `0.0` to `1.0`. Use
   * clear coat related properties to enable multilayer materials that have a
   * thin translucent layer over the base layer.
   *
   * @type {number}
   * @default 0
   */
  get clearcoat() {
    return this._clearcoat;
  }
  set clearcoat(e) {
    this._clearcoat > 0 != e > 0 && this.version++, this._clearcoat = e;
  }
  /**
   * The intensity of the iridescence layer, simulating RGB color shift based on the angle between
   * the surface and the viewer, from `0.0` to `1.0`.
   *
   * @type {number}
   * @default 0
   */
  get iridescence() {
    return this._iridescence;
  }
  set iridescence(e) {
    this._iridescence > 0 != e > 0 && this.version++, this._iridescence = e;
  }
  /**
   * Defines the strength of the angular separation of colors (chromatic aberration) transmitting
   * through a relatively clear volume. Any value zero or larger is valid, the typical range of
   * realistic values is `[0, 1]`. This property can be only be used with transmissive objects.
   *
   * @type {number}
   * @default 0
   */
  get dispersion() {
    return this._dispersion;
  }
  set dispersion(e) {
    this._dispersion > 0 != e > 0 && this.version++, this._dispersion = e;
  }
  /**
   * The intensity of the sheen layer, from `0.0` to `1.0`.
   *
   * @type {number}
   * @default 0
   */
  get sheen() {
    return this._sheen;
  }
  set sheen(e) {
    this._sheen > 0 != e > 0 && this.version++, this._sheen = e;
  }
  /**
   * Degree of transmission (or optical transparency), from `0.0` to `1.0`.
   *
   * Thin, transparent or semitransparent, plastic or glass materials remain
   * largely reflective even if they are fully transmissive. The transmission
   * property can be used to model these materials.
   *
   * When transmission is non-zero, `opacity` should be  set to `1`.
   *
   * @type {number}
   * @default 0
   */
  get transmission() {
    return this._transmission;
  }
  set transmission(e) {
    this._transmission > 0 != e > 0 && this.version++, this._transmission = e;
  }
  copy(e) {
    return super.copy(e), this.defines = {
      STANDARD: "",
      PHYSICAL: ""
    }, this.anisotropy = e.anisotropy, this.anisotropyRotation = e.anisotropyRotation, this.anisotropyMap = e.anisotropyMap, this.clearcoat = e.clearcoat, this.clearcoatMap = e.clearcoatMap, this.clearcoatRoughness = e.clearcoatRoughness, this.clearcoatRoughnessMap = e.clearcoatRoughnessMap, this.clearcoatNormalMap = e.clearcoatNormalMap, this.clearcoatNormalScale.copy(e.clearcoatNormalScale), this.dispersion = e.dispersion, this.ior = e.ior, this.iridescence = e.iridescence, this.iridescenceMap = e.iridescenceMap, this.iridescenceIOR = e.iridescenceIOR, this.iridescenceThicknessRange = [...e.iridescenceThicknessRange], this.iridescenceThicknessMap = e.iridescenceThicknessMap, this.sheen = e.sheen, this.sheenColor.copy(e.sheenColor), this.sheenColorMap = e.sheenColorMap, this.sheenRoughness = e.sheenRoughness, this.sheenRoughnessMap = e.sheenRoughnessMap, this.transmission = e.transmission, this.transmissionMap = e.transmissionMap, this.thickness = e.thickness, this.thicknessMap = e.thicknessMap, this.attenuationDistance = e.attenuationDistance, this.attenuationColor.copy(e.attenuationColor), this.specularIntensity = e.specularIntensity, this.specularIntensityMap = e.specularIntensityMap, this.specularColor.copy(e.specularColor), this.specularColorMap = e.specularColorMap, this;
  }
}
class M_ extends Yt {
  /**
   * Constructs a new mesh depth material.
   *
   * @param {Object} [parameters] - An object with one or more properties
   * defining the material's appearance. Any property of the material
   * (including any property from inherited materials) can be passed
   * in here. Color values can be passed any type of value accepted
   * by {@link Color#set}.
   */
  constructor(e) {
    super(), this.isMeshDepthMaterial = !0, this.type = "MeshDepthMaterial", this.depthPacking = pv, this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.wireframe = !1, this.wireframeLinewidth = 1, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.depthPacking = e.depthPacking, this.map = e.map, this.alphaMap = e.alphaMap, this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this;
  }
}
class T_ extends Yt {
  /**
   * Constructs a new mesh distance material.
   *
   * @param {Object} [parameters] - An object with one or more properties
   * defining the material's appearance. Any property of the material
   * (including any property from inherited materials) can be passed
   * in here. Color values can be passed any type of value accepted
   * by {@link Color#set}.
   */
  constructor(e) {
    super(), this.isMeshDistanceMaterial = !0, this.type = "MeshDistanceMaterial", this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.map = e.map, this.alphaMap = e.alphaMap, this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this;
  }
}
function ma(s, e) {
  return !s || s.constructor === e ? s : typeof e.BYTES_PER_ELEMENT == "number" ? new e(s) : Array.prototype.slice.call(s);
}
function E_(s) {
  function e(n, r) {
    return s[n] - s[r];
  }
  const t = s.length, i = new Array(t);
  for (let n = 0; n !== t; ++n) i[n] = n;
  return i.sort(e), i;
}
function Cd(s, e, t) {
  const i = s.length, n = new s.constructor(i);
  for (let r = 0, a = 0; a !== i; ++r) {
    const o = t[r] * e;
    for (let l = 0; l !== e; ++l)
      n[a++] = s[o + l];
  }
  return n;
}
function uf(s, e, t, i) {
  let n = 1, r = s[0];
  for (; r !== void 0 && r[i] === void 0; )
    r = s[n++];
  if (r === void 0) return;
  let a = r[i];
  if (a !== void 0)
    if (Array.isArray(a))
      do
        a = r[i], a !== void 0 && (e.push(r.time), t.push(...a)), r = s[n++];
      while (r !== void 0);
    else if (a.toArray !== void 0)
      do
        a = r[i], a !== void 0 && (e.push(r.time), a.toArray(t, t.length)), r = s[n++];
      while (r !== void 0);
    else
      do
        a = r[i], a !== void 0 && (e.push(r.time), t.push(a)), r = s[n++];
      while (r !== void 0);
}
class kr {
  /**
   * Constructs a new interpolant.
   *
   * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
   * @param {TypedArray} sampleValues - The sample values.
   * @param {number} sampleSize - The sample size
   * @param {TypedArray} [resultBuffer] - The result buffer.
   */
  constructor(e, t, i, n) {
    this.parameterPositions = e, this._cachedIndex = 0, this.resultBuffer = n !== void 0 ? n : new t.constructor(i), this.sampleValues = t, this.valueSize = i, this.settings = null, this.DefaultSettings_ = {};
  }
  /**
   * Evaluate the interpolant at position `t`.
   *
   * @param {number} t - The interpolation factor.
   * @return {TypedArray} The result buffer.
   */
  evaluate(e) {
    const t = this.parameterPositions;
    let i = this._cachedIndex, n = t[i], r = t[i - 1];
    e: {
      t: {
        let a;
        i: {
          n: if (!(e < n)) {
            for (let o = i + 2; ; ) {
              if (n === void 0) {
                if (e < r) break n;
                return i = t.length, this._cachedIndex = i, this.copySampleValue_(i - 1);
              }
              if (i === o) break;
              if (r = n, n = t[++i], e < n)
                break t;
            }
            a = t.length;
            break i;
          }
          if (!(e >= r)) {
            const o = t[1];
            e < o && (i = 2, r = o);
            for (let l = i - 2; ; ) {
              if (r === void 0)
                return this._cachedIndex = 0, this.copySampleValue_(0);
              if (i === l) break;
              if (n = r, r = t[--i - 1], e >= r)
                break t;
            }
            a = i, i = 0;
            break i;
          }
          break e;
        }
        for (; i < a; ) {
          const o = i + a >>> 1;
          e < t[o] ? a = o : i = o + 1;
        }
        if (n = t[i], r = t[i - 1], r === void 0)
          return this._cachedIndex = 0, this.copySampleValue_(0);
        if (n === void 0)
          return i = t.length, this._cachedIndex = i, this.copySampleValue_(i - 1);
      }
      this._cachedIndex = i, this.intervalChanged_(i, r, n);
    }
    return this.interpolate_(i, r, e, n);
  }
  /**
   * Returns the interpolation settings.
   *
   * @return {Object} The interpolation settings.
   */
  getSettings_() {
    return this.settings || this.DefaultSettings_;
  }
  /**
   * Copies a sample value to the result buffer.
   *
   * @param {number} index - An index into the sample value buffer.
   * @return {TypedArray} The result buffer.
   */
  copySampleValue_(e) {
    const t = this.resultBuffer, i = this.sampleValues, n = this.valueSize, r = e * n;
    for (let a = 0; a !== n; ++a)
      t[a] = i[r + a];
    return t;
  }
  /**
   * Copies a sample value to the result buffer.
   *
   * @abstract
   * @param {number} i1 - An index into the sample value buffer.
   * @param {number} t0 - The previous interpolation factor.
   * @param {number} t - The current interpolation factor.
   * @param {number} t1 - The next interpolation factor.
   * @return {TypedArray} The result buffer.
   */
  interpolate_() {
    throw new Error("call to abstract method");
  }
  /**
   * Optional method that is executed when the interval has changed.
   *
   * @param {number} i1 - An index into the sample value buffer.
   * @param {number} t0 - The previous interpolation factor.
   * @param {number} t - The current interpolation factor.
   */
  intervalChanged_() {
  }
}
class A_ extends kr {
  /**
   * Constructs a new cubic interpolant.
   *
   * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
   * @param {TypedArray} sampleValues - The sample values.
   * @param {number} sampleSize - The sample size
   * @param {TypedArray} [resultBuffer] - The result buffer.
   */
  constructor(e, t, i, n) {
    super(e, t, i, n), this._weightPrev = -0, this._offsetPrev = -0, this._weightNext = -0, this._offsetNext = -0, this.DefaultSettings_ = {
      endingStart: Ms,
      endingEnd: Ms
    };
  }
  intervalChanged_(e, t, i) {
    const n = this.parameterPositions;
    let r = e - 2, a = e + 1, o = n[r], l = n[a];
    if (o === void 0)
      switch (this.getSettings_().endingStart) {
        case Ts:
          r = e, o = 2 * t - i;
          break;
        case $a:
          r = n.length - 2, o = t + n[r] - n[r + 1];
          break;
        default:
          r = e, o = i;
      }
    if (l === void 0)
      switch (this.getSettings_().endingEnd) {
        case Ts:
          a = e, l = 2 * i - t;
          break;
        case $a:
          a = 1, l = i + n[1] - n[0];
          break;
        default:
          a = e - 1, l = t;
      }
    const c = (i - t) * 0.5, h = this.valueSize;
    this._weightPrev = c / (t - o), this._weightNext = c / (l - i), this._offsetPrev = r * h, this._offsetNext = a * h;
  }
  interpolate_(e, t, i, n) {
    const r = this.resultBuffer, a = this.sampleValues, o = this.valueSize, l = e * o, c = l - o, h = this._offsetPrev, d = this._offsetNext, u = this._weightPrev, f = this._weightNext, g = (i - t) / (n - t), v = g * g, m = v * g, p = -u * m + 2 * u * v - u * g, w = (1 + u) * m + (-1.5 - 2 * u) * v + (-0.5 + u) * g + 1, M = (-1 - f) * m + (1.5 + f) * v + 0.5 * g, T = f * m - f * v;
    for (let E = 0; E !== o; ++E)
      r[E] = p * a[h + E] + w * a[c + E] + M * a[l + E] + T * a[d + E];
    return r;
  }
}
class ff extends kr {
  /**
   * Constructs a new linear interpolant.
   *
   * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
   * @param {TypedArray} sampleValues - The sample values.
   * @param {number} sampleSize - The sample size
   * @param {TypedArray} [resultBuffer] - The result buffer.
   */
  constructor(e, t, i, n) {
    super(e, t, i, n);
  }
  interpolate_(e, t, i, n) {
    const r = this.resultBuffer, a = this.sampleValues, o = this.valueSize, l = e * o, c = l - o, h = (i - t) / (n - t), d = 1 - h;
    for (let u = 0; u !== o; ++u)
      r[u] = a[c + u] * d + a[l + u] * h;
    return r;
  }
}
class R_ extends kr {
  /**
   * Constructs a new discrete interpolant.
   *
   * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
   * @param {TypedArray} sampleValues - The sample values.
   * @param {number} sampleSize - The sample size
   * @param {TypedArray} [resultBuffer] - The result buffer.
   */
  constructor(e, t, i, n) {
    super(e, t, i, n);
  }
  interpolate_(e) {
    return this.copySampleValue_(e - 1);
  }
}
class Pi {
  /**
   * Constructs a new keyframe track.
   *
   * @param {string} name - The keyframe track's name.
   * @param {Array<number>} times - A list of keyframe times.
   * @param {Array<number|string|boolean>} values - A list of keyframe values.
   * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
   */
  constructor(e, t, i, n) {
    if (e === void 0) throw new Error("THREE.KeyframeTrack: track name is undefined");
    if (t === void 0 || t.length === 0) throw new Error("THREE.KeyframeTrack: no keyframes in track named " + e);
    this.name = e, this.times = ma(t, this.TimeBufferType), this.values = ma(i, this.ValueBufferType), this.setInterpolation(n || this.DefaultInterpolation);
  }
  /**
   * Converts the keyframe track to JSON.
   *
   * @static
   * @param {KeyframeTrack} track - The keyframe track to serialize.
   * @return {Object} The serialized keyframe track as JSON.
   */
  static toJSON(e) {
    const t = e.constructor;
    let i;
    if (t.toJSON !== this.toJSON)
      i = t.toJSON(e);
    else {
      i = {
        name: e.name,
        times: ma(e.times, Array),
        values: ma(e.values, Array)
      };
      const n = e.getInterpolation();
      n !== e.DefaultInterpolation && (i.interpolation = n);
    }
    return i.type = e.ValueTypeName, i;
  }
  /**
   * Factory method for creating a new discrete interpolant.
   *
   * @static
   * @param {TypedArray} [result] - The result buffer.
   * @return {DiscreteInterpolant} The new interpolant.
   */
  InterpolantFactoryMethodDiscrete(e) {
    return new R_(this.times, this.values, this.getValueSize(), e);
  }
  /**
   * Factory method for creating a new linear interpolant.
   *
   * @static
   * @param {TypedArray} [result] - The result buffer.
   * @return {LinearInterpolant} The new interpolant.
   */
  InterpolantFactoryMethodLinear(e) {
    return new ff(this.times, this.values, this.getValueSize(), e);
  }
  /**
   * Factory method for creating a new smooth interpolant.
   *
   * @static
   * @param {TypedArray} [result] - The result buffer.
   * @return {CubicInterpolant} The new interpolant.
   */
  InterpolantFactoryMethodSmooth(e) {
    return new A_(this.times, this.values, this.getValueSize(), e);
  }
  /**
   * Defines the interpolation factor method for this keyframe track.
   *
   * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} interpolation - The interpolation type.
   * @return {KeyframeTrack} A reference to this keyframe track.
   */
  setInterpolation(e) {
    let t;
    switch (e) {
      case Er:
        t = this.InterpolantFactoryMethodDiscrete;
        break;
      case Ar:
        t = this.InterpolantFactoryMethodLinear;
        break;
      case wo:
        t = this.InterpolantFactoryMethodSmooth;
        break;
    }
    if (t === void 0) {
      const i = "unsupported interpolation for " + this.ValueTypeName + " keyframe track named " + this.name;
      if (this.createInterpolant === void 0)
        if (e !== this.DefaultInterpolation)
          this.setInterpolation(this.DefaultInterpolation);
        else
          throw new Error(i);
      return Te("KeyframeTrack:", i), this;
    }
    return this.createInterpolant = t, this;
  }
  /**
   * Returns the current interpolation type.
   *
   * @return {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} The interpolation type.
   */
  getInterpolation() {
    switch (this.createInterpolant) {
      case this.InterpolantFactoryMethodDiscrete:
        return Er;
      case this.InterpolantFactoryMethodLinear:
        return Ar;
      case this.InterpolantFactoryMethodSmooth:
        return wo;
    }
  }
  /**
   * Returns the value size.
   *
   * @return {number} The value size.
   */
  getValueSize() {
    return this.values.length / this.times.length;
  }
  /**
   * Moves all keyframes either forward or backward in time.
   *
   * @param {number} timeOffset - The offset to move the time values.
   * @return {KeyframeTrack} A reference to this keyframe track.
   */
  shift(e) {
    if (e !== 0) {
      const t = this.times;
      for (let i = 0, n = t.length; i !== n; ++i)
        t[i] += e;
    }
    return this;
  }
  /**
   * Scale all keyframe times by a factor (useful for frame - seconds conversions).
   *
   * @param {number} timeScale - The time scale.
   * @return {KeyframeTrack} A reference to this keyframe track.
   */
  scale(e) {
    if (e !== 1) {
      const t = this.times;
      for (let i = 0, n = t.length; i !== n; ++i)
        t[i] *= e;
    }
    return this;
  }
  /**
   * Removes keyframes before and after animation without changing any values within the defined time range.
   *
   * Note: The method does not shift around keys to the start of the track time, because for interpolated
   * keys this will change their values
   *
   * @param {number} startTime - The start time.
   * @param {number} endTime - The end time.
   * @return {KeyframeTrack} A reference to this keyframe track.
   */
  trim(e, t) {
    const i = this.times, n = i.length;
    let r = 0, a = n - 1;
    for (; r !== n && i[r] < e; )
      ++r;
    for (; a !== -1 && i[a] > t; )
      --a;
    if (++a, r !== 0 || a !== n) {
      r >= a && (a = Math.max(a, 1), r = a - 1);
      const o = this.getValueSize();
      this.times = i.slice(r, a), this.values = this.values.slice(r * o, a * o);
    }
    return this;
  }
  /**
   * Performs minimal validation on the keyframe track. Returns `true` if the values
   * are valid.
   *
   * @return {boolean} Whether the keyframes are valid or not.
   */
  validate() {
    let e = !0;
    const t = this.getValueSize();
    t - Math.floor(t) !== 0 && (Ce("KeyframeTrack: Invalid value size in track.", this), e = !1);
    const i = this.times, n = this.values, r = i.length;
    r === 0 && (Ce("KeyframeTrack: Track is empty.", this), e = !1);
    let a = null;
    for (let o = 0; o !== r; o++) {
      const l = i[o];
      if (typeof l == "number" && isNaN(l)) {
        Ce("KeyframeTrack: Time is not a valid number.", this, o, l), e = !1;
        break;
      }
      if (a !== null && a > l) {
        Ce("KeyframeTrack: Out of order keys.", this, o, l, a), e = !1;
        break;
      }
      a = l;
    }
    if (n !== void 0 && wv(n))
      for (let o = 0, l = n.length; o !== l; ++o) {
        const c = n[o];
        if (isNaN(c)) {
          Ce("KeyframeTrack: Value is not a valid number.", this, o, c), e = !1;
          break;
        }
      }
    return e;
  }
  /**
   * Optimizes this keyframe track by removing equivalent sequential keys (which are
   * common in morph target sequences).
   *
   * @return {AnimationClip} A reference to this animation clip.
   */
  optimize() {
    const e = this.times.slice(), t = this.values.slice(), i = this.getValueSize(), n = this.getInterpolation() === wo, r = e.length - 1;
    let a = 1;
    for (let o = 1; o < r; ++o) {
      let l = !1;
      const c = e[o], h = e[o + 1];
      if (c !== h && (o !== 1 || c !== e[0]))
        if (n)
          l = !0;
        else {
          const d = o * i, u = d - i, f = d + i;
          for (let g = 0; g !== i; ++g) {
            const v = t[d + g];
            if (v !== t[u + g] || v !== t[f + g]) {
              l = !0;
              break;
            }
          }
        }
      if (l) {
        if (o !== a) {
          e[a] = e[o];
          const d = o * i, u = a * i;
          for (let f = 0; f !== i; ++f)
            t[u + f] = t[d + f];
        }
        ++a;
      }
    }
    if (r > 0) {
      e[a] = e[r];
      for (let o = r * i, l = a * i, c = 0; c !== i; ++c)
        t[l + c] = t[o + c];
      ++a;
    }
    return a !== e.length ? (this.times = e.slice(0, a), this.values = t.slice(0, a * i)) : (this.times = e, this.values = t), this;
  }
  /**
   * Returns a new keyframe track with copied values from this instance.
   *
   * @return {KeyframeTrack} A clone of this instance.
   */
  clone() {
    const e = this.times.slice(), t = this.values.slice(), i = this.constructor, n = new i(this.name, e, t);
    return n.createInterpolant = this.createInterpolant, n;
  }
}
Pi.prototype.ValueTypeName = "";
Pi.prototype.TimeBufferType = Float32Array;
Pi.prototype.ValueBufferType = Float32Array;
Pi.prototype.DefaultInterpolation = Ar;
class Ws extends Pi {
  /**
   * Constructs a new boolean keyframe track.
   *
   * This keyframe track type has no `interpolation` parameter because the
   * interpolation is always discrete.
   *
   * @param {string} name - The keyframe track's name.
   * @param {Array<number>} times - A list of keyframe times.
   * @param {Array<boolean>} values - A list of keyframe values.
   */
  constructor(e, t, i) {
    super(e, t, i);
  }
}
Ws.prototype.ValueTypeName = "bool";
Ws.prototype.ValueBufferType = Array;
Ws.prototype.DefaultInterpolation = Er;
Ws.prototype.InterpolantFactoryMethodLinear = void 0;
Ws.prototype.InterpolantFactoryMethodSmooth = void 0;
class pf extends Pi {
  /**
   * Constructs a new color keyframe track.
   *
   * @param {string} name - The keyframe track's name.
   * @param {Array<number>} times - A list of keyframe times.
   * @param {Array<number>} values - A list of keyframe values.
   * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
   */
  constructor(e, t, i, n) {
    super(e, t, i, n);
  }
}
pf.prototype.ValueTypeName = "color";
class zs extends Pi {
  /**
   * Constructs a new number keyframe track.
   *
   * @param {string} name - The keyframe track's name.
   * @param {Array<number>} times - A list of keyframe times.
   * @param {Array<number>} values - A list of keyframe values.
   * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
   */
  constructor(e, t, i, n) {
    super(e, t, i, n);
  }
}
zs.prototype.ValueTypeName = "number";
class C_ extends kr {
  /**
   * Constructs a new SLERP interpolant.
   *
   * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
   * @param {TypedArray} sampleValues - The sample values.
   * @param {number} sampleSize - The sample size
   * @param {TypedArray} [resultBuffer] - The result buffer.
   */
  constructor(e, t, i, n) {
    super(e, t, i, n);
  }
  interpolate_(e, t, i, n) {
    const r = this.resultBuffer, a = this.sampleValues, o = this.valueSize, l = (i - t) / (n - t);
    let c = e * o;
    for (let h = c + o; c !== h; c += 4)
      si.slerpFlat(r, 0, a, c - o, a, c, l);
    return r;
  }
}
class Vs extends Pi {
  /**
   * Constructs a new Quaternion keyframe track.
   *
   * @param {string} name - The keyframe track's name.
   * @param {Array<number>} times - A list of keyframe times.
   * @param {Array<number>} values - A list of keyframe values.
   * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
   */
  constructor(e, t, i, n) {
    super(e, t, i, n);
  }
  /**
   * Overwritten so the method returns Quaternion based interpolant.
   *
   * @static
   * @param {TypedArray} [result] - The result buffer.
   * @return {QuaternionLinearInterpolant} The new interpolant.
   */
  InterpolantFactoryMethodLinear(e) {
    return new C_(this.times, this.values, this.getValueSize(), e);
  }
}
Vs.prototype.ValueTypeName = "quaternion";
Vs.prototype.InterpolantFactoryMethodSmooth = void 0;
class Xs extends Pi {
  /**
   * Constructs a new string keyframe track.
   *
   * This keyframe track type has no `interpolation` parameter because the
   * interpolation is always discrete.
   *
   * @param {string} name - The keyframe track's name.
   * @param {Array<number>} times - A list of keyframe times.
   * @param {Array<string>} values - A list of keyframe values.
   */
  constructor(e, t, i) {
    super(e, t, i);
  }
}
Xs.prototype.ValueTypeName = "string";
Xs.prototype.ValueBufferType = Array;
Xs.prototype.DefaultInterpolation = Er;
Xs.prototype.InterpolantFactoryMethodLinear = void 0;
Xs.prototype.InterpolantFactoryMethodSmooth = void 0;
class Hs extends Pi {
  /**
   * Constructs a new vector keyframe track.
   *
   * @param {string} name - The keyframe track's name.
   * @param {Array<number>} times - A list of keyframe times.
   * @param {Array<number>} values - A list of keyframe values.
   * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
   */
  constructor(e, t, i, n) {
    super(e, t, i, n);
  }
}
Hs.prototype.ValueTypeName = "vector";
class fc {
  /**
   * Constructs a new animation clip.
   *
   * Note: Instead of instantiating an AnimationClip directly with the constructor, you can
   * use the static interface of this class for creating clips. In most cases though, animation clips
   * will automatically be created by loaders when importing animated 3D assets.
   *
   * @param {string} [name=''] - The clip's name.
   * @param {number} [duration=-1] - The clip's duration in seconds. If a negative value is passed,
   * the duration will be calculated from the passed keyframes.
   * @param {Array<KeyframeTrack>} tracks - An array of keyframe tracks.
   * @param {(NormalAnimationBlendMode|AdditiveAnimationBlendMode)} [blendMode=NormalAnimationBlendMode] - Defines how the animation
   * is blended/combined when two or more animations are simultaneously played.
   */
  constructor(e = "", t = -1, i = [], n = Xc) {
    this.name = e, this.tracks = i, this.duration = t, this.blendMode = n, this.uuid = Ei(), this.userData = {}, this.duration < 0 && this.resetDuration();
  }
  /**
   * Factory method for creating an animation clip from the given JSON.
   *
   * @static
   * @param {Object} json - The serialized animation clip.
   * @return {AnimationClip} The new animation clip.
   */
  static parse(e) {
    const t = [], i = e.tracks, n = 1 / (e.fps || 1);
    for (let a = 0, o = i.length; a !== o; ++a)
      t.push(P_(i[a]).scale(n));
    const r = new this(e.name, e.duration, t, e.blendMode);
    return r.uuid = e.uuid, r.userData = JSON.parse(e.userData || "{}"), r;
  }
  /**
   * Serializes the given animation clip into JSON.
   *
   * @static
   * @param {AnimationClip} clip - The animation clip to serialize.
   * @return {Object} The JSON object.
   */
  static toJSON(e) {
    const t = [], i = e.tracks, n = {
      name: e.name,
      duration: e.duration,
      tracks: t,
      uuid: e.uuid,
      blendMode: e.blendMode,
      userData: JSON.stringify(e.userData)
    };
    for (let r = 0, a = i.length; r !== a; ++r)
      t.push(Pi.toJSON(i[r]));
    return n;
  }
  /**
   * Returns a new animation clip from the passed morph targets array of a
   * geometry, taking a name and the number of frames per second.
   *
   * Note: The fps parameter is required, but the animation speed can be
   * overridden via {@link AnimationAction#setDuration}.
   *
   * @static
   * @param {string} name - The name of the animation clip.
   * @param {Array<Object>} morphTargetSequence - A sequence of morph targets.
   * @param {number} fps - The Frames-Per-Second value.
   * @param {boolean} noLoop - Whether the clip should be no loop or not.
   * @return {AnimationClip} The new animation clip.
   */
  static CreateFromMorphTargetSequence(e, t, i, n) {
    const r = t.length, a = [];
    for (let o = 0; o < r; o++) {
      let l = [], c = [];
      l.push(
        (o + r - 1) % r,
        o,
        (o + 1) % r
      ), c.push(0, 1, 0);
      const h = E_(l);
      l = Cd(l, 1, h), c = Cd(c, 1, h), !n && l[0] === 0 && (l.push(r), c.push(c[0])), a.push(
        new zs(
          ".morphTargetInfluences[" + t[o].name + "]",
          l,
          c
        ).scale(1 / i)
      );
    }
    return new this(e, -1, a);
  }
  /**
   * Searches for an animation clip by name, taking as its first parameter
   * either an array of clips, or a mesh or geometry that contains an
   * array named "animations" property.
   *
   * @static
   * @param {(Array<AnimationClip>|Object3D)} objectOrClipArray - The array or object to search through.
   * @param {string} name - The name to search for.
   * @return {?AnimationClip} The found animation clip. Returns `null` if no clip has been found.
   */
  static findByName(e, t) {
    let i = e;
    if (!Array.isArray(e)) {
      const n = e;
      i = n.geometry && n.geometry.animations || n.animations;
    }
    for (let n = 0; n < i.length; n++)
      if (i[n].name === t)
        return i[n];
    return null;
  }
  /**
   * Returns an array of new AnimationClips created from the morph target
   * sequences of a geometry, trying to sort morph target names into
   * animation-group-based patterns like "Walk_001, Walk_002, Run_001, Run_002...".
   *
   * See {@link MD2Loader#parse} as an example for how the method should be used.
   *
   * @static
   * @param {Array<Object>} morphTargets - A sequence of morph targets.
   * @param {number} fps - The Frames-Per-Second value.
   * @param {boolean} noLoop - Whether the clip should be no loop or not.
   * @return {Array<AnimationClip>} An array of new animation clips.
   */
  static CreateClipsFromMorphTargetSequences(e, t, i) {
    const n = {}, r = /^([\w-]*?)([\d]+)$/;
    for (let o = 0, l = e.length; o < l; o++) {
      const c = e[o], h = c.name.match(r);
      if (h && h.length > 1) {
        const d = h[1];
        let u = n[d];
        u || (n[d] = u = []), u.push(c);
      }
    }
    const a = [];
    for (const o in n)
      a.push(this.CreateFromMorphTargetSequence(o, n[o], t, i));
    return a;
  }
  /**
   * Parses the `animation.hierarchy` format and returns a new animation clip.
   *
   * @static
   * @deprecated since r175.
   * @param {Object} animation - A serialized animation clip as JSON.
   * @param {Array<Bones>} bones - An array of bones.
   * @return {?AnimationClip} The new animation clip.
   */
  static parseAnimation(e, t) {
    if (Te("AnimationClip: parseAnimation() is deprecated and will be removed with r185"), !e)
      return Ce("AnimationClip: No animation in JSONLoader data."), null;
    const i = function(d, u, f, g, v) {
      if (f.length !== 0) {
        const m = [], p = [];
        uf(f, m, p, g), m.length !== 0 && v.push(new d(u, m, p));
      }
    }, n = [], r = e.name || "default", a = e.fps || 30, o = e.blendMode;
    let l = e.length || -1;
    const c = e.hierarchy || [];
    for (let d = 0; d < c.length; d++) {
      const u = c[d].keys;
      if (!(!u || u.length === 0))
        if (u[0].morphTargets) {
          const f = {};
          let g;
          for (g = 0; g < u.length; g++)
            if (u[g].morphTargets)
              for (let v = 0; v < u[g].morphTargets.length; v++)
                f[u[g].morphTargets[v]] = -1;
          for (const v in f) {
            const m = [], p = [];
            for (let w = 0; w !== u[g].morphTargets.length; ++w) {
              const M = u[g];
              m.push(M.time), p.push(M.morphTarget === v ? 1 : 0);
            }
            n.push(new zs(".morphTargetInfluence[" + v + "]", m, p));
          }
          l = f.length * a;
        } else {
          const f = ".bones[" + t[d].name + "]";
          i(
            Hs,
            f + ".position",
            u,
            "pos",
            n
          ), i(
            Vs,
            f + ".quaternion",
            u,
            "rot",
            n
          ), i(
            Hs,
            f + ".scale",
            u,
            "scl",
            n
          );
        }
    }
    return n.length === 0 ? null : new this(r, l, n, o);
  }
  /**
   * Sets the duration of this clip to the duration of its longest keyframe track.
   *
   * @return {AnimationClip} A reference to this animation clip.
   */
  resetDuration() {
    const e = this.tracks;
    let t = 0;
    for (let i = 0, n = e.length; i !== n; ++i) {
      const r = this.tracks[i];
      t = Math.max(t, r.times[r.times.length - 1]);
    }
    return this.duration = t, this;
  }
  /**
   * Trims all tracks to the clip's duration.
   *
   * @return {AnimationClip} A reference to this animation clip.
   */
  trim() {
    for (let e = 0; e < this.tracks.length; e++)
      this.tracks[e].trim(0, this.duration);
    return this;
  }
  /**
   * Performs minimal validation on each track in the clip. Returns `true` if all
   * tracks are valid.
   *
   * @return {boolean} Whether the clip's keyframes are valid or not.
   */
  validate() {
    let e = !0;
    for (let t = 0; t < this.tracks.length; t++)
      e = e && this.tracks[t].validate();
    return e;
  }
  /**
   * Optimizes each track by removing equivalent sequential keys (which are
   * common in morph target sequences).
   *
   * @return {AnimationClip} A reference to this animation clip.
   */
  optimize() {
    for (let e = 0; e < this.tracks.length; e++)
      this.tracks[e].optimize();
    return this;
  }
  /**
   * Returns a new animation clip with copied values from this instance.
   *
   * @return {AnimationClip} A clone of this instance.
   */
  clone() {
    const e = [];
    for (let i = 0; i < this.tracks.length; i++)
      e.push(this.tracks[i].clone());
    const t = new this.constructor(this.name, this.duration, e, this.blendMode);
    return t.userData = JSON.parse(JSON.stringify(this.userData)), t;
  }
  /**
   * Serializes this animation clip into JSON.
   *
   * @return {Object} The JSON object.
   */
  toJSON() {
    return this.constructor.toJSON(this);
  }
}
function I_(s) {
  switch (s.toLowerCase()) {
    case "scalar":
    case "double":
    case "float":
    case "number":
    case "integer":
      return zs;
    case "vector":
    case "vector2":
    case "vector3":
    case "vector4":
      return Hs;
    case "color":
      return pf;
    case "quaternion":
      return Vs;
    case "bool":
    case "boolean":
      return Ws;
    case "string":
      return Xs;
  }
  throw new Error("THREE.KeyframeTrack: Unsupported typeName: " + s);
}
function P_(s) {
  if (s.type === void 0)
    throw new Error("THREE.KeyframeTrack: track type undefined, can not parse");
  const e = I_(s.type);
  if (s.times === void 0) {
    const t = [], i = [];
    uf(s.keys, t, i, "value"), s.times = t, s.values = i;
  }
  return e.parse !== void 0 ? e.parse(s) : new e(s.name, s.times, s.values, s.interpolation);
}
const rn = {
  /**
   * Whether caching is enabled or not.
   *
   * @static
   * @type {boolean}
   * @default false
   */
  enabled: !1,
  /**
   * A dictionary that holds cached files.
   *
   * @static
   * @type {Object<string,Object>}
   */
  files: {},
  /**
   * Adds a cache entry with a key to reference the file. If this key already
   * holds a file, it is overwritten.
   *
   * @static
   * @param {string} key - The key to reference the cached file.
   * @param {Object} file -  The file to be cached.
   */
  add: function(s, e) {
    this.enabled !== !1 && (this.files[s] = e);
  },
  /**
   * Gets the cached value for the given key.
   *
   * @static
   * @param {string} key - The key to reference the cached file.
   * @return {Object|undefined} The cached file. If the key does not exist `undefined` is returned.
   */
  get: function(s) {
    if (this.enabled !== !1)
      return this.files[s];
  },
  /**
   * Removes the cached file associated with the given key.
   *
   * @static
   * @param {string} key - The key to reference the cached file.
   */
  remove: function(s) {
    delete this.files[s];
  },
  /**
   * Remove all values from the cache.
   *
   * @static
   */
  clear: function() {
    this.files = {};
  }
};
class L_ {
  /**
   * Constructs a new loading manager.
   *
   * @param {Function} [onLoad] - Executes when all items have been loaded.
   * @param {Function} [onProgress] - Executes when single items have been loaded.
   * @param {Function} [onError] - Executes when an error occurs.
   */
  constructor(e, t, i) {
    const n = this;
    let r = !1, a = 0, o = 0, l;
    const c = [];
    this.onStart = void 0, this.onLoad = e, this.onProgress = t, this.onError = i, this._abortController = null, this.itemStart = function(h) {
      o++, r === !1 && n.onStart !== void 0 && n.onStart(h, a, o), r = !0;
    }, this.itemEnd = function(h) {
      a++, n.onProgress !== void 0 && n.onProgress(h, a, o), a === o && (r = !1, n.onLoad !== void 0 && n.onLoad());
    }, this.itemError = function(h) {
      n.onError !== void 0 && n.onError(h);
    }, this.resolveURL = function(h) {
      return l ? l(h) : h;
    }, this.setURLModifier = function(h) {
      return l = h, this;
    }, this.addHandler = function(h, d) {
      return c.push(h, d), this;
    }, this.removeHandler = function(h) {
      const d = c.indexOf(h);
      return d !== -1 && c.splice(d, 2), this;
    }, this.getHandler = function(h) {
      for (let d = 0, u = c.length; d < u; d += 2) {
        const f = c[d], g = c[d + 1];
        if (f.global && (f.lastIndex = 0), f.test(h))
          return g;
      }
      return null;
    }, this.abort = function() {
      return this.abortController.abort(), this._abortController = null, this;
    };
  }
  // TODO: Revert this back to a single member variable once this issue has been fixed
  // https://github.com/cloudflare/workerd/issues/3657
  /**
   * Used for aborting ongoing requests in loaders using this manager.
   *
   * @type {AbortController}
   */
  get abortController() {
    return this._abortController || (this._abortController = new AbortController()), this._abortController;
  }
}
const D_ = /* @__PURE__ */ new L_();
class js {
  /**
   * Constructs a new loader.
   *
   * @param {LoadingManager} [manager] - The loading manager.
   */
  constructor(e) {
    this.manager = e !== void 0 ? e : D_, this.crossOrigin = "anonymous", this.withCredentials = !1, this.path = "", this.resourcePath = "", this.requestHeader = {};
  }
  /**
   * This method needs to be implemented by all concrete loaders. It holds the
   * logic for loading assets from the backend.
   *
   * @abstract
   * @param {string} url - The path/URL of the file to be loaded.
   * @param {Function} onLoad - Executed when the loading process has been finished.
   * @param {onProgressCallback} [onProgress] - Executed while the loading is in progress.
   * @param {onErrorCallback} [onError] - Executed when errors occur.
   */
  load() {
  }
  /**
   * A async version of {@link Loader#load}.
   *
   * @param {string} url - The path/URL of the file to be loaded.
   * @param {onProgressCallback} [onProgress] - Executed while the loading is in progress.
   * @return {Promise} A Promise that resolves when the asset has been loaded.
   */
  loadAsync(e, t) {
    const i = this;
    return new Promise(function(n, r) {
      i.load(e, n, t, r);
    });
  }
  /**
   * This method needs to be implemented by all concrete loaders. It holds the
   * logic for parsing the asset into three.js entities.
   *
   * @abstract
   * @param {any} data - The data to parse.
   */
  parse() {
  }
  /**
   * Sets the `crossOrigin` String to implement CORS for loading the URL
   * from a different domain that allows CORS.
   *
   * @param {string} crossOrigin - The `crossOrigin` value.
   * @return {Loader} A reference to this instance.
   */
  setCrossOrigin(e) {
    return this.crossOrigin = e, this;
  }
  /**
   * Whether the XMLHttpRequest uses credentials such as cookies, authorization
   * headers or TLS client certificates, see [XMLHttpRequest.withCredentials](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/withCredentials).
   *
   * Note: This setting has no effect if you are loading files locally or from the same domain.
   *
   * @param {boolean} value - The `withCredentials` value.
   * @return {Loader} A reference to this instance.
   */
  setWithCredentials(e) {
    return this.withCredentials = e, this;
  }
  /**
   * Sets the base path for the asset.
   *
   * @param {string} path - The base path.
   * @return {Loader} A reference to this instance.
   */
  setPath(e) {
    return this.path = e, this;
  }
  /**
   * Sets the base path for dependent resources like textures.
   *
   * @param {string} resourcePath - The resource path.
   * @return {Loader} A reference to this instance.
   */
  setResourcePath(e) {
    return this.resourcePath = e, this;
  }
  /**
   * Sets the given request header.
   *
   * @param {Object} requestHeader - A [request header](https://developer.mozilla.org/en-US/docs/Glossary/Request_header)
   * for configuring the HTTP request.
   * @return {Loader} A reference to this instance.
   */
  setRequestHeader(e) {
    return this.requestHeader = e, this;
  }
  /**
   * This method can be implemented in loaders for aborting ongoing requests.
   *
   * @abstract
   * @return {Loader} A reference to this instance.
   */
  abort() {
    return this;
  }
}
js.DEFAULT_MATERIAL_NAME = "__DEFAULT";
const tn = {};
class N_ extends Error {
  constructor(e, t) {
    super(e), this.response = t;
  }
}
class mf extends js {
  /**
   * Constructs a new file loader.
   *
   * @param {LoadingManager} [manager] - The loading manager.
   */
  constructor(e) {
    super(e), this.mimeType = "", this.responseType = "", this._abortController = new AbortController();
  }
  /**
   * Starts loading from the given URL and pass the loaded response to the `onLoad()` callback.
   *
   * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
   * @param {function(any)} onLoad - Executed when the loading process has been finished.
   * @param {onProgressCallback} [onProgress] - Executed while the loading is in progress.
   * @param {onErrorCallback} [onError] - Executed when errors occur.
   * @return {any|undefined} The cached resource if available.
   */
  load(e, t, i, n) {
    e === void 0 && (e = ""), this.path !== void 0 && (e = this.path + e), e = this.manager.resolveURL(e);
    const r = rn.get(`file:${e}`);
    if (r !== void 0)
      return this.manager.itemStart(e), setTimeout(() => {
        t && t(r), this.manager.itemEnd(e);
      }, 0), r;
    if (tn[e] !== void 0) {
      tn[e].push({
        onLoad: t,
        onProgress: i,
        onError: n
      });
      return;
    }
    tn[e] = [], tn[e].push({
      onLoad: t,
      onProgress: i,
      onError: n
    });
    const a = new Request(e, {
      headers: new Headers(this.requestHeader),
      credentials: this.withCredentials ? "include" : "same-origin",
      signal: typeof AbortSignal.any == "function" ? AbortSignal.any([this._abortController.signal, this.manager.abortController.signal]) : this._abortController.signal
    }), o = this.mimeType, l = this.responseType;
    fetch(a).then((c) => {
      if (c.status === 200 || c.status === 0) {
        if (c.status === 0 && Te("FileLoader: HTTP Status 0 received."), typeof ReadableStream > "u" || c.body === void 0 || c.body.getReader === void 0)
          return c;
        const h = tn[e], d = c.body.getReader(), u = c.headers.get("X-File-Size") || c.headers.get("Content-Length"), f = u ? parseInt(u) : 0, g = f !== 0;
        let v = 0;
        const m = new ReadableStream({
          start(p) {
            w();
            function w() {
              d.read().then(({ done: M, value: T }) => {
                if (M)
                  p.close();
                else {
                  v += T.byteLength;
                  const E = new ProgressEvent("progress", { lengthComputable: g, loaded: v, total: f });
                  for (let A = 0, R = h.length; A < R; A++) {
                    const F = h[A];
                    F.onProgress && F.onProgress(E);
                  }
                  p.enqueue(T), w();
                }
              }, (M) => {
                p.error(M);
              });
            }
          }
        });
        return new Response(m);
      } else
        throw new N_(`fetch for "${c.url}" responded with ${c.status}: ${c.statusText}`, c);
    }).then((c) => {
      switch (l) {
        case "arraybuffer":
          return c.arrayBuffer();
        case "blob":
          return c.blob();
        case "document":
          return c.text().then((h) => new DOMParser().parseFromString(h, o));
        case "json":
          return c.json();
        default:
          if (o === "")
            return c.text();
          {
            const d = /charset="?([^;"\s]*)"?/i.exec(o), u = d && d[1] ? d[1].toLowerCase() : void 0, f = new TextDecoder(u);
            return c.arrayBuffer().then((g) => f.decode(g));
          }
      }
    }).then((c) => {
      rn.add(`file:${e}`, c);
      const h = tn[e];
      delete tn[e];
      for (let d = 0, u = h.length; d < u; d++) {
        const f = h[d];
        f.onLoad && f.onLoad(c);
      }
    }).catch((c) => {
      const h = tn[e];
      if (h === void 0)
        throw this.manager.itemError(e), c;
      delete tn[e];
      for (let d = 0, u = h.length; d < u; d++) {
        const f = h[d];
        f.onError && f.onError(c);
      }
      this.manager.itemError(e);
    }).finally(() => {
      this.manager.itemEnd(e);
    }), this.manager.itemStart(e);
  }
  /**
   * Sets the expected response type.
   *
   * @param {('arraybuffer'|'blob'|'document'|'json'|'')} value - The response type.
   * @return {FileLoader} A reference to this file loader.
   */
  setResponseType(e) {
    return this.responseType = e, this;
  }
  /**
   * Sets the expected mime type of the loaded file.
   *
   * @param {string} value - The mime type.
   * @return {FileLoader} A reference to this file loader.
   */
  setMimeType(e) {
    return this.mimeType = e, this;
  }
  /**
   * Aborts ongoing fetch requests.
   *
   * @return {FileLoader} A reference to this instance.
   */
  abort() {
    return this._abortController.abort(), this._abortController = new AbortController(), this;
  }
}
const bs = /* @__PURE__ */ new WeakMap();
class O_ extends js {
  /**
   * Constructs a new image loader.
   *
   * @param {LoadingManager} [manager] - The loading manager.
   */
  constructor(e) {
    super(e);
  }
  /**
   * Starts loading from the given URL and passes the loaded image
   * to the `onLoad()` callback. The method also returns a new `Image` object which can
   * directly be used for texture creation. If you do it this way, the texture
   * may pop up in your scene once the respective loading process is finished.
   *
   * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
   * @param {function(Image)} onLoad - Executed when the loading process has been finished.
   * @param {onProgressCallback} onProgress - Unsupported in this loader.
   * @param {onErrorCallback} onError - Executed when errors occur.
   * @return {Image} The image.
   */
  load(e, t, i, n) {
    this.path !== void 0 && (e = this.path + e), e = this.manager.resolveURL(e);
    const r = this, a = rn.get(`image:${e}`);
    if (a !== void 0) {
      if (a.complete === !0)
        r.manager.itemStart(e), setTimeout(function() {
          t && t(a), r.manager.itemEnd(e);
        }, 0);
      else {
        let d = bs.get(a);
        d === void 0 && (d = [], bs.set(a, d)), d.push({ onLoad: t, onError: n });
      }
      return a;
    }
    const o = Rr("img");
    function l() {
      h(), t && t(this);
      const d = bs.get(this) || [];
      for (let u = 0; u < d.length; u++) {
        const f = d[u];
        f.onLoad && f.onLoad(this);
      }
      bs.delete(this), r.manager.itemEnd(e);
    }
    function c(d) {
      h(), n && n(d), rn.remove(`image:${e}`);
      const u = bs.get(this) || [];
      for (let f = 0; f < u.length; f++) {
        const g = u[f];
        g.onError && g.onError(d);
      }
      bs.delete(this), r.manager.itemError(e), r.manager.itemEnd(e);
    }
    function h() {
      o.removeEventListener("load", l, !1), o.removeEventListener("error", c, !1);
    }
    return o.addEventListener("load", l, !1), o.addEventListener("error", c, !1), e.slice(0, 5) !== "data:" && this.crossOrigin !== void 0 && (o.crossOrigin = this.crossOrigin), rn.add(`image:${e}`, o), r.manager.itemStart(e), o.src = e, o;
  }
}
class gf extends js {
  /**
   * Constructs a new texture loader.
   *
   * @param {LoadingManager} [manager] - The loading manager.
   */
  constructor(e) {
    super(e);
  }
  /**
   * Starts loading from the given URL and pass the fully loaded texture
   * to the `onLoad()` callback. The method also returns a new texture object which can
   * directly be used for material creation. If you do it this way, the texture
   * may pop up in your scene once the respective loading process is finished.
   *
   * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
   * @param {function(Texture)} onLoad - Executed when the loading process has been finished.
   * @param {onProgressCallback} onProgress - Unsupported in this loader.
   * @param {onErrorCallback} onError - Executed when errors occur.
   * @return {Texture} The texture.
   */
  load(e, t, i, n) {
    const r = new Ot(), a = new O_(this.manager);
    return a.setCrossOrigin(this.crossOrigin), a.setPath(this.path), a.load(e, function(o) {
      r.image = o, r.needsUpdate = !0, t !== void 0 && t(r);
    }, i, n), r;
  }
}
class fo extends wt {
  /**
   * Constructs a new light.
   *
   * @param {(number|Color|string)} [color=0xffffff] - The light's color.
   * @param {number} [intensity=1] - The light's strength/intensity.
   */
  constructor(e, t = 1) {
    super(), this.isLight = !0, this.type = "Light", this.color = new Ne(e), this.intensity = t;
  }
  /**
   * Frees the GPU-related resources allocated by this instance. Call this
   * method whenever this instance is no longer used in your app.
   */
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
  copy(e, t) {
    return super.copy(e, t), this.color.copy(e.color), this.intensity = e.intensity, this;
  }
  toJSON(e) {
    const t = super.toJSON(e);
    return t.object.color = this.color.getHex(), t.object.intensity = this.intensity, t;
  }
}
const jo = /* @__PURE__ */ new ze(), Id = /* @__PURE__ */ new O(), Pd = /* @__PURE__ */ new O();
class sh {
  /**
   * Constructs a new light shadow.
   *
   * @param {Camera} camera - The light's view of the world.
   */
  constructor(e) {
    this.camera = e, this.intensity = 1, this.bias = 0, this.normalBias = 0, this.radius = 1, this.blurSamples = 8, this.mapSize = new Ye(512, 512), this.mapType = ii, this.map = null, this.mapPass = null, this.matrix = new ze(), this.autoUpdate = !0, this.needsUpdate = !1, this._frustum = new ih(), this._frameExtents = new Ye(1, 1), this._viewportCount = 1, this._viewports = [
      new _t(0, 0, 1, 1)
    ];
  }
  /**
   * Used internally by the renderer to get the number of viewports that need
   * to be rendered for this shadow.
   *
   * @return {number} The viewport count.
   */
  getViewportCount() {
    return this._viewportCount;
  }
  /**
   * Gets the shadow cameras frustum. Used internally by the renderer to cull objects.
   *
   * @return {Frustum} The shadow camera frustum.
   */
  getFrustum() {
    return this._frustum;
  }
  /**
   * Update the matrices for the camera and shadow, used internally by the renderer.
   *
   * @param {Light} light - The light for which the shadow is being rendered.
   */
  updateMatrices(e) {
    const t = this.camera, i = this.matrix;
    Id.setFromMatrixPosition(e.matrixWorld), t.position.copy(Id), Pd.setFromMatrixPosition(e.target.matrixWorld), t.lookAt(Pd), t.updateMatrixWorld(), jo.multiplyMatrices(t.projectionMatrix, t.matrixWorldInverse), this._frustum.setFromProjectionMatrix(jo, t.coordinateSystem, t.reversedDepth), t.reversedDepth ? i.set(
      0.5,
      0,
      0,
      0.5,
      0,
      0.5,
      0,
      0.5,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    ) : i.set(
      0.5,
      0,
      0,
      0.5,
      0,
      0.5,
      0,
      0.5,
      0,
      0,
      0.5,
      0.5,
      0,
      0,
      0,
      1
    ), i.multiply(jo);
  }
  /**
   * Returns a viewport definition for the given viewport index.
   *
   * @param {number} viewportIndex - The viewport index.
   * @return {Vector4} The viewport.
   */
  getViewport(e) {
    return this._viewports[e];
  }
  /**
   * Returns the frame extends.
   *
   * @return {Vector2} The frame extends.
   */
  getFrameExtents() {
    return this._frameExtents;
  }
  /**
   * Frees the GPU-related resources allocated by this instance. Call this
   * method whenever this instance is no longer used in your app.
   */
  dispose() {
    this.map && this.map.dispose(), this.mapPass && this.mapPass.dispose();
  }
  /**
   * Copies the values of the given light shadow instance to this instance.
   *
   * @param {LightShadow} source - The light shadow to copy.
   * @return {LightShadow} A reference to this light shadow instance.
   */
  copy(e) {
    return this.camera = e.camera.clone(), this.intensity = e.intensity, this.bias = e.bias, this.radius = e.radius, this.autoUpdate = e.autoUpdate, this.needsUpdate = e.needsUpdate, this.normalBias = e.normalBias, this.blurSamples = e.blurSamples, this.mapSize.copy(e.mapSize), this;
  }
  /**
   * Returns a new light shadow instance with copied values from this instance.
   *
   * @return {LightShadow} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
  /**
   * Serializes the light shadow into JSON.
   *
   * @return {Object} A JSON object representing the serialized light shadow.
   * @see {@link ObjectLoader#parse}
   */
  toJSON() {
    const e = {};
    return this.intensity !== 1 && (e.intensity = this.intensity), this.bias !== 0 && (e.bias = this.bias), this.normalBias !== 0 && (e.normalBias = this.normalBias), this.radius !== 1 && (e.radius = this.radius), (this.mapSize.x !== 512 || this.mapSize.y !== 512) && (e.mapSize = this.mapSize.toArray()), e.camera = this.camera.toJSON(!1).object, delete e.camera.matrix, e;
  }
}
class U_ extends sh {
  /**
   * Constructs a new spot light shadow.
   */
  constructor() {
    super(new Gt(50, 1, 0.5, 500)), this.isSpotLightShadow = !0, this.focus = 1, this.aspect = 1;
  }
  updateMatrices(e) {
    const t = this.camera, i = Bs * 2 * e.angle * this.focus, n = this.mapSize.width / this.mapSize.height * this.aspect, r = e.distance || t.far;
    (i !== t.fov || n !== t.aspect || r !== t.far) && (t.fov = i, t.aspect = n, t.far = r, t.updateProjectionMatrix()), super.updateMatrices(e);
  }
  copy(e) {
    return super.copy(e), this.focus = e.focus, this;
  }
}
class F_ extends fo {
  /**
   * Constructs a new spot light.
   *
   * @param {(number|Color|string)} [color=0xffffff] - The light's color.
   * @param {number} [intensity=1] - The light's strength/intensity measured in candela (cd).
   * @param {number} [distance=0] - Maximum range of the light. `0` means no limit.
   * @param {number} [angle=Math.PI/3] - Maximum angle of light dispersion from its direction whose upper bound is `Math.PI/2`.
   * @param {number} [penumbra=0] - Percent of the spotlight cone that is attenuated due to penumbra. Value range is `[0,1]`.
   * @param {number} [decay=2] - The amount the light dims along the distance of the light.
   */
  constructor(e, t, i = 0, n = Math.PI / 3, r = 0, a = 2) {
    super(e, t), this.isSpotLight = !0, this.type = "SpotLight", this.position.copy(wt.DEFAULT_UP), this.updateMatrix(), this.target = new wt(), this.distance = i, this.angle = n, this.penumbra = r, this.decay = a, this.map = null, this.shadow = new U_();
  }
  /**
   * The light's power. Power is the luminous power of the light measured in lumens (lm).
   *  Changing the power will also change the light's intensity.
   *
   * @type {number}
   */
  get power() {
    return this.intensity * Math.PI;
  }
  set power(e) {
    this.intensity = e / Math.PI;
  }
  dispose() {
    super.dispose(), this.shadow.dispose();
  }
  copy(e, t) {
    return super.copy(e, t), this.distance = e.distance, this.angle = e.angle, this.penumbra = e.penumbra, this.decay = e.decay, this.target = e.target.clone(), this.map = e.map, this.shadow = e.shadow.clone(), this;
  }
  toJSON(e) {
    const t = super.toJSON(e);
    return t.object.distance = this.distance, t.object.angle = this.angle, t.object.decay = this.decay, t.object.penumbra = this.penumbra, t.object.target = this.target.uuid, this.map && this.map.isTexture && (t.object.map = this.map.toJSON(e).uuid), t.object.shadow = this.shadow.toJSON(), t;
  }
}
class B_ extends sh {
  /**
   * Constructs a new point light shadow.
   */
  constructor() {
    super(new Gt(90, 1, 0.5, 500)), this.isPointLightShadow = !0;
  }
}
class k_ extends fo {
  /**
   * Constructs a new point light.
   *
   * @param {(number|Color|string)} [color=0xffffff] - The light's color.
   * @param {number} [intensity=1] - The light's strength/intensity measured in candela (cd).
   * @param {number} [distance=0] - Maximum range of the light. `0` means no limit.
   * @param {number} [decay=2] - The amount the light dims along the distance of the light.
   */
  constructor(e, t, i = 0, n = 2) {
    super(e, t), this.isPointLight = !0, this.type = "PointLight", this.distance = i, this.decay = n, this.shadow = new B_();
  }
  /**
   * The light's power. Power is the luminous power of the light measured in lumens (lm).
   * Changing the power will also change the light's intensity.
   *
   * @type {number}
   */
  get power() {
    return this.intensity * 4 * Math.PI;
  }
  set power(e) {
    this.intensity = e / (4 * Math.PI);
  }
  dispose() {
    super.dispose(), this.shadow.dispose();
  }
  copy(e, t) {
    return super.copy(e, t), this.distance = e.distance, this.decay = e.decay, this.shadow = e.shadow.clone(), this;
  }
  toJSON(e) {
    const t = super.toJSON(e);
    return t.object.distance = this.distance, t.object.decay = this.decay, t.object.shadow = this.shadow.toJSON(), t;
  }
}
class zr extends rf {
  /**
   * Constructs a new orthographic camera.
   *
   * @param {number} [left=-1] - The left plane of the camera's frustum.
   * @param {number} [right=1] - The right plane of the camera's frustum.
   * @param {number} [top=1] - The top plane of the camera's frustum.
   * @param {number} [bottom=-1] - The bottom plane of the camera's frustum.
   * @param {number} [near=0.1] - The camera's near plane.
   * @param {number} [far=2000] - The camera's far plane.
   */
  constructor(e = -1, t = 1, i = 1, n = -1, r = 0.1, a = 2e3) {
    super(), this.isOrthographicCamera = !0, this.type = "OrthographicCamera", this.zoom = 1, this.view = null, this.left = e, this.right = t, this.top = i, this.bottom = n, this.near = r, this.far = a, this.updateProjectionMatrix();
  }
  copy(e, t) {
    return super.copy(e, t), this.left = e.left, this.right = e.right, this.top = e.top, this.bottom = e.bottom, this.near = e.near, this.far = e.far, this.zoom = e.zoom, this.view = e.view === null ? null : Object.assign({}, e.view), this;
  }
  /**
   * Sets an offset in a larger frustum. This is useful for multi-window or
   * multi-monitor/multi-machine setups.
   *
   * @param {number} fullWidth - The full width of multiview setup.
   * @param {number} fullHeight - The full height of multiview setup.
   * @param {number} x - The horizontal offset of the subcamera.
   * @param {number} y - The vertical offset of the subcamera.
   * @param {number} width - The width of subcamera.
   * @param {number} height - The height of subcamera.
   * @see {@link PerspectiveCamera#setViewOffset}
   */
  setViewOffset(e, t, i, n, r, a) {
    this.view === null && (this.view = {
      enabled: !0,
      fullWidth: 1,
      fullHeight: 1,
      offsetX: 0,
      offsetY: 0,
      width: 1,
      height: 1
    }), this.view.enabled = !0, this.view.fullWidth = e, this.view.fullHeight = t, this.view.offsetX = i, this.view.offsetY = n, this.view.width = r, this.view.height = a, this.updateProjectionMatrix();
  }
  /**
   * Removes the view offset from the projection matrix.
   */
  clearViewOffset() {
    this.view !== null && (this.view.enabled = !1), this.updateProjectionMatrix();
  }
  /**
   * Updates the camera's projection matrix. Must be called after any change of
   * camera properties.
   */
  updateProjectionMatrix() {
    const e = (this.right - this.left) / (2 * this.zoom), t = (this.top - this.bottom) / (2 * this.zoom), i = (this.right + this.left) / 2, n = (this.top + this.bottom) / 2;
    let r = i - e, a = i + e, o = n + t, l = n - t;
    if (this.view !== null && this.view.enabled) {
      const c = (this.right - this.left) / this.view.fullWidth / this.zoom, h = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
      r += c * this.view.offsetX, a = r + c * this.view.width, o -= h * this.view.offsetY, l = o - h * this.view.height;
    }
    this.projectionMatrix.makeOrthographic(r, a, o, l, this.near, this.far, this.coordinateSystem, this.reversedDepth), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
  }
  toJSON(e) {
    const t = super.toJSON(e);
    return t.object.zoom = this.zoom, t.object.left = this.left, t.object.right = this.right, t.object.top = this.top, t.object.bottom = this.bottom, t.object.near = this.near, t.object.far = this.far, this.view !== null && (t.object.view = Object.assign({}, this.view)), t;
  }
}
class z_ extends sh {
  /**
   * Constructs a new directional light shadow.
   */
  constructor() {
    super(new zr(-5, 5, 5, -5, 0.5, 500)), this.isDirectionalLightShadow = !0;
  }
}
class Ca extends fo {
  /**
   * Constructs a new directional light.
   *
   * @param {(number|Color|string)} [color=0xffffff] - The light's color.
   * @param {number} [intensity=1] - The light's strength/intensity.
   */
  constructor(e, t) {
    super(e, t), this.isDirectionalLight = !0, this.type = "DirectionalLight", this.position.copy(wt.DEFAULT_UP), this.updateMatrix(), this.target = new wt(), this.shadow = new z_();
  }
  dispose() {
    super.dispose(), this.shadow.dispose();
  }
  copy(e) {
    return super.copy(e), this.target = e.target.clone(), this.shadow = e.shadow.clone(), this;
  }
  toJSON(e) {
    const t = super.toJSON(e);
    return t.object.shadow = this.shadow.toJSON(), t.object.target = this.target.uuid, t;
  }
}
class V_ extends fo {
  /**
   * Constructs a new ambient light.
   *
   * @param {(number|Color|string)} [color=0xffffff] - The light's color.
   * @param {number} [intensity=1] - The light's strength/intensity.
   */
  constructor(e, t) {
    super(e, t), this.isAmbientLight = !0, this.type = "AmbientLight";
  }
}
class gr {
  /**
   * Extracts the base URL from the given URL.
   *
   * @param {string} url -The URL to extract the base URL from.
   * @return {string} The extracted base URL.
   */
  static extractUrlBase(e) {
    const t = e.lastIndexOf("/");
    return t === -1 ? "./" : e.slice(0, t + 1);
  }
  /**
   * Resolves relative URLs against the given path. Absolute paths, data urls,
   * and blob URLs will be returned as is. Invalid URLs will return an empty
   * string.
   *
   * @param {string} url -The URL to resolve.
   * @param {string} path - The base path for relative URLs to be resolved against.
   * @return {string} The resolved URL.
   */
  static resolveURL(e, t) {
    return typeof e != "string" || e === "" ? "" : (/^https?:\/\//i.test(t) && /^\//.test(e) && (t = t.replace(/(^https?:\/\/[^\/]+).*/i, "$1")), /^(https?:)?\/\//i.test(e) || /^data:.*,.*$/i.test(e) || /^blob:.*$/i.test(e) ? e : t + e);
  }
}
const Yo = /* @__PURE__ */ new WeakMap();
class H_ extends js {
  /**
   * Constructs a new image bitmap loader.
   *
   * @param {LoadingManager} [manager] - The loading manager.
   */
  constructor(e) {
    super(e), this.isImageBitmapLoader = !0, typeof createImageBitmap > "u" && Te("ImageBitmapLoader: createImageBitmap() not supported."), typeof fetch > "u" && Te("ImageBitmapLoader: fetch() not supported."), this.options = { premultiplyAlpha: "none" }, this._abortController = new AbortController();
  }
  /**
   * Sets the given loader options. The structure of the object must match the `options` parameter of
   * [createImageBitmap](https://developer.mozilla.org/en-US/docs/Web/API/Window/createImageBitmap).
   *
   * @param {Object} options - The loader options to set.
   * @return {ImageBitmapLoader} A reference to this image bitmap loader.
   */
  setOptions(e) {
    return this.options = e, this;
  }
  /**
   * Starts loading from the given URL and pass the loaded image bitmap to the `onLoad()` callback.
   *
   * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
   * @param {function(ImageBitmap)} onLoad - Executed when the loading process has been finished.
   * @param {onProgressCallback} onProgress - Unsupported in this loader.
   * @param {onErrorCallback} onError - Executed when errors occur.
   * @return {ImageBitmap|undefined} The image bitmap.
   */
  load(e, t, i, n) {
    e === void 0 && (e = ""), this.path !== void 0 && (e = this.path + e), e = this.manager.resolveURL(e);
    const r = this, a = rn.get(`image-bitmap:${e}`);
    if (a !== void 0) {
      if (r.manager.itemStart(e), a.then) {
        a.then((c) => {
          if (Yo.has(a) === !0)
            n && n(Yo.get(a)), r.manager.itemError(e), r.manager.itemEnd(e);
          else
            return t && t(c), r.manager.itemEnd(e), c;
        });
        return;
      }
      return setTimeout(function() {
        t && t(a), r.manager.itemEnd(e);
      }, 0), a;
    }
    const o = {};
    o.credentials = this.crossOrigin === "anonymous" ? "same-origin" : "include", o.headers = this.requestHeader, o.signal = typeof AbortSignal.any == "function" ? AbortSignal.any([this._abortController.signal, this.manager.abortController.signal]) : this._abortController.signal;
    const l = fetch(e, o).then(function(c) {
      return c.blob();
    }).then(function(c) {
      return createImageBitmap(c, Object.assign(r.options, { colorSpaceConversion: "none" }));
    }).then(function(c) {
      return rn.add(`image-bitmap:${e}`, c), t && t(c), r.manager.itemEnd(e), c;
    }).catch(function(c) {
      n && n(c), Yo.set(l, c), rn.remove(`image-bitmap:${e}`), r.manager.itemError(e), r.manager.itemEnd(e);
    });
    rn.add(`image-bitmap:${e}`, l), r.manager.itemStart(e);
  }
  /**
   * Aborts ongoing fetch requests.
   *
   * @return {ImageBitmapLoader} A reference to this instance.
   */
  abort() {
    return this._abortController.abort(), this._abortController = new AbortController(), this;
  }
}
class $_ extends Gt {
  /**
   * Constructs a new array camera.
   *
   * @param {Array<PerspectiveCamera>} [array=[]] - An array of perspective sub cameras.
   */
  constructor(e = []) {
    super(), this.isArrayCamera = !0, this.isMultiViewCamera = !1, this.cameras = e;
  }
}
class vf {
  /**
   * Constructs a new clock.
   *
   * @param {boolean} [autoStart=true] - Whether to automatically start the clock when
   * `getDelta()` is called for the first time.
   */
  constructor(e = !0) {
    this.autoStart = e, this.startTime = 0, this.oldTime = 0, this.elapsedTime = 0, this.running = !1;
  }
  /**
   * Starts the clock. When `autoStart` is set to `true`, the method is automatically
   * called by the class.
   */
  start() {
    this.startTime = performance.now(), this.oldTime = this.startTime, this.elapsedTime = 0, this.running = !0;
  }
  /**
   * Stops the clock.
   */
  stop() {
    this.getElapsedTime(), this.running = !1, this.autoStart = !1;
  }
  /**
   * Returns the elapsed time in seconds.
   *
   * @return {number} The elapsed time.
   */
  getElapsedTime() {
    return this.getDelta(), this.elapsedTime;
  }
  /**
   * Returns the delta time in seconds.
   *
   * @return {number} The delta time.
   */
  getDelta() {
    let e = 0;
    if (this.autoStart && !this.running)
      return this.start(), 0;
    if (this.running) {
      const t = performance.now();
      e = (t - this.oldTime) / 1e3, this.oldTime = t, this.elapsedTime += e;
    }
    return e;
  }
}
class G_ {
  /**
   * Constructs a new property mixer.
   *
   * @param {PropertyBinding} binding - The property binding.
   * @param {string} typeName - The keyframe track type name.
   * @param {number} valueSize - The keyframe track value size.
   */
  constructor(e, t, i) {
    this.binding = e, this.valueSize = i;
    let n, r, a;
    switch (t) {
      case "quaternion":
        n = this._slerp, r = this._slerpAdditive, a = this._setAdditiveIdentityQuaternion, this.buffer = new Float64Array(i * 6), this._workIndex = 5;
        break;
      case "string":
      case "bool":
        n = this._select, r = this._select, a = this._setAdditiveIdentityOther, this.buffer = new Array(i * 5);
        break;
      default:
        n = this._lerp, r = this._lerpAdditive, a = this._setAdditiveIdentityNumeric, this.buffer = new Float64Array(i * 5);
    }
    this._mixBufferRegion = n, this._mixBufferRegionAdditive = r, this._setIdentity = a, this._origIndex = 3, this._addIndex = 4, this.cumulativeWeight = 0, this.cumulativeWeightAdditive = 0, this.useCount = 0, this.referenceCount = 0;
  }
  /**
   * Accumulates data in the `incoming` region into `accu<i>`.
   *
   * @param {number} accuIndex - The accumulation index.
   * @param {number} weight - The weight.
   */
  accumulate(e, t) {
    const i = this.buffer, n = this.valueSize, r = e * n + n;
    let a = this.cumulativeWeight;
    if (a === 0) {
      for (let o = 0; o !== n; ++o)
        i[r + o] = i[o];
      a = t;
    } else {
      a += t;
      const o = t / a;
      this._mixBufferRegion(i, r, 0, o, n);
    }
    this.cumulativeWeight = a;
  }
  /**
   * Accumulates data in the `incoming` region into `add`.
   *
   * @param {number} weight - The weight.
   */
  accumulateAdditive(e) {
    const t = this.buffer, i = this.valueSize, n = i * this._addIndex;
    this.cumulativeWeightAdditive === 0 && this._setIdentity(), this._mixBufferRegionAdditive(t, n, 0, e, i), this.cumulativeWeightAdditive += e;
  }
  /**
   * Applies the state of `accu<i>` to the binding when accus differ.
   *
   * @param {number} accuIndex - The accumulation index.
   */
  apply(e) {
    const t = this.valueSize, i = this.buffer, n = e * t + t, r = this.cumulativeWeight, a = this.cumulativeWeightAdditive, o = this.binding;
    if (this.cumulativeWeight = 0, this.cumulativeWeightAdditive = 0, r < 1) {
      const l = t * this._origIndex;
      this._mixBufferRegion(
        i,
        n,
        l,
        1 - r,
        t
      );
    }
    a > 0 && this._mixBufferRegionAdditive(i, n, this._addIndex * t, 1, t);
    for (let l = t, c = t + t; l !== c; ++l)
      if (i[l] !== i[l + t]) {
        o.setValue(i, n);
        break;
      }
  }
  /**
   * Remembers the state of the bound property and copy it to both accus.
   */
  saveOriginalState() {
    const e = this.binding, t = this.buffer, i = this.valueSize, n = i * this._origIndex;
    e.getValue(t, n);
    for (let r = i, a = n; r !== a; ++r)
      t[r] = t[n + r % i];
    this._setIdentity(), this.cumulativeWeight = 0, this.cumulativeWeightAdditive = 0;
  }
  /**
   * Applies the state previously taken via {@link PropertyMixer#saveOriginalState} to the binding.
   */
  restoreOriginalState() {
    const e = this.valueSize * 3;
    this.binding.setValue(this.buffer, e);
  }
  // internals
  _setAdditiveIdentityNumeric() {
    const e = this._addIndex * this.valueSize, t = e + this.valueSize;
    for (let i = e; i < t; i++)
      this.buffer[i] = 0;
  }
  _setAdditiveIdentityQuaternion() {
    this._setAdditiveIdentityNumeric(), this.buffer[this._addIndex * this.valueSize + 3] = 1;
  }
  _setAdditiveIdentityOther() {
    const e = this._origIndex * this.valueSize, t = this._addIndex * this.valueSize;
    for (let i = 0; i < this.valueSize; i++)
      this.buffer[t + i] = this.buffer[e + i];
  }
  // mix functions
  _select(e, t, i, n, r) {
    if (n >= 0.5)
      for (let a = 0; a !== r; ++a)
        e[t + a] = e[i + a];
  }
  _slerp(e, t, i, n) {
    si.slerpFlat(e, t, e, t, e, i, n);
  }
  _slerpAdditive(e, t, i, n, r) {
    const a = this._workIndex * r;
    si.multiplyQuaternionsFlat(e, a, e, t, e, i), si.slerpFlat(e, t, e, t, e, a, n);
  }
  _lerp(e, t, i, n, r) {
    const a = 1 - n;
    for (let o = 0; o !== r; ++o) {
      const l = t + o;
      e[l] = e[l] * a + e[i + o] * n;
    }
  }
  _lerpAdditive(e, t, i, n, r) {
    for (let a = 0; a !== r; ++a) {
      const o = t + a;
      e[o] = e[o] + e[i + a] * n;
    }
  }
}
const rh = "\\[\\]\\.:\\/", q_ = new RegExp("[" + rh + "]", "g"), ah = "[^" + rh + "]", W_ = "[^" + rh.replace("\\.", "") + "]", X_ = /* @__PURE__ */ /((?:WC+[\/:])*)/.source.replace("WC", ah), j_ = /* @__PURE__ */ /(WCOD+)?/.source.replace("WCOD", W_), Y_ = /* @__PURE__ */ /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace("WC", ah), K_ = /* @__PURE__ */ /\.(WC+)(?:\[(.+)\])?/.source.replace("WC", ah), Z_ = new RegExp(
  "^" + X_ + j_ + Y_ + K_ + "$"
), J_ = ["material", "materials", "bones", "map"];
class Q_ {
  constructor(e, t, i) {
    const n = i || st.parseTrackName(t);
    this._targetGroup = e, this._bindings = e.subscribe_(t, n);
  }
  getValue(e, t) {
    this.bind();
    const i = this._targetGroup.nCachedObjects_, n = this._bindings[i];
    n !== void 0 && n.getValue(e, t);
  }
  setValue(e, t) {
    const i = this._bindings;
    for (let n = this._targetGroup.nCachedObjects_, r = i.length; n !== r; ++n)
      i[n].setValue(e, t);
  }
  bind() {
    const e = this._bindings;
    for (let t = this._targetGroup.nCachedObjects_, i = e.length; t !== i; ++t)
      e[t].bind();
  }
  unbind() {
    const e = this._bindings;
    for (let t = this._targetGroup.nCachedObjects_, i = e.length; t !== i; ++t)
      e[t].unbind();
  }
}
class st {
  /**
   * Constructs a new property binding.
   *
   * @param {Object} rootNode - The root node.
   * @param {string} path - The path.
   * @param {?Object} [parsedPath] - The parsed path.
   */
  constructor(e, t, i) {
    this.path = t, this.parsedPath = i || st.parseTrackName(t), this.node = st.findNode(e, this.parsedPath.nodeName), this.rootNode = e, this.getValue = this._getValue_unbound, this.setValue = this._setValue_unbound;
  }
  /**
   * Factory method for creating a property binding from the given parameters.
   *
   * @static
   * @param {Object} root - The root node.
   * @param {string} path - The path.
   * @param {?Object} [parsedPath] - The parsed path.
   * @return {PropertyBinding|Composite} The created property binding or composite.
   */
  static create(e, t, i) {
    return e && e.isAnimationObjectGroup ? new st.Composite(e, t, i) : new st(e, t, i);
  }
  /**
   * Replaces spaces with underscores and removes unsupported characters from
   * node names, to ensure compatibility with parseTrackName().
   *
   * @param {string} name - Node name to be sanitized.
   * @return {string} The sanitized node name.
   */
  static sanitizeNodeName(e) {
    return e.replace(/\s/g, "_").replace(q_, "");
  }
  /**
   * Parses the given track name (an object path to an animated property) and
   * returns an object with information about the path. Matches strings in the following forms:
   *
   * - nodeName.property
   * - nodeName.property[accessor]
   * - nodeName.material.property[accessor]
   * - uuid.property[accessor]
   * - uuid.objectName[objectIndex].propertyName[propertyIndex]
   * - parentName/nodeName.property
   * - parentName/parentName/nodeName.property[index]
   * - .bone[Armature.DEF_cog].position
   * - scene:helium_balloon_model:helium_balloon_model.position
   *
   * @static
   * @param {string} trackName - The track name to parse.
   * @return {Object} The parsed track name as an object.
   */
  static parseTrackName(e) {
    const t = Z_.exec(e);
    if (t === null)
      throw new Error("PropertyBinding: Cannot parse trackName: " + e);
    const i = {
      // directoryName: matches[ 1 ], // (tschw) currently unused
      nodeName: t[2],
      objectName: t[3],
      objectIndex: t[4],
      propertyName: t[5],
      // required
      propertyIndex: t[6]
    }, n = i.nodeName && i.nodeName.lastIndexOf(".");
    if (n !== void 0 && n !== -1) {
      const r = i.nodeName.substring(n + 1);
      J_.indexOf(r) !== -1 && (i.nodeName = i.nodeName.substring(0, n), i.objectName = r);
    }
    if (i.propertyName === null || i.propertyName.length === 0)
      throw new Error("PropertyBinding: can not parse propertyName from trackName: " + e);
    return i;
  }
  /**
   * Searches for a node in the hierarchy of the given root object by the given
   * node name.
   *
   * @static
   * @param {Object} root - The root object.
   * @param {string|number} nodeName - The name of the node.
   * @return {?Object} The found node. Returns `null` if no object was found.
   */
  static findNode(e, t) {
    if (t === void 0 || t === "" || t === "." || t === -1 || t === e.name || t === e.uuid)
      return e;
    if (e.skeleton) {
      const i = e.skeleton.getBoneByName(t);
      if (i !== void 0)
        return i;
    }
    if (e.children) {
      const i = function(r) {
        for (let a = 0; a < r.length; a++) {
          const o = r[a];
          if (o.name === t || o.uuid === t)
            return o;
          const l = i(o.children);
          if (l) return l;
        }
        return null;
      }, n = i(e.children);
      if (n)
        return n;
    }
    return null;
  }
  // these are used to "bind" a nonexistent property
  _getValue_unavailable() {
  }
  _setValue_unavailable() {
  }
  // Getters
  _getValue_direct(e, t) {
    e[t] = this.targetObject[this.propertyName];
  }
  _getValue_array(e, t) {
    const i = this.resolvedProperty;
    for (let n = 0, r = i.length; n !== r; ++n)
      e[t++] = i[n];
  }
  _getValue_arrayElement(e, t) {
    e[t] = this.resolvedProperty[this.propertyIndex];
  }
  _getValue_toArray(e, t) {
    this.resolvedProperty.toArray(e, t);
  }
  // Direct
  _setValue_direct(e, t) {
    this.targetObject[this.propertyName] = e[t];
  }
  _setValue_direct_setNeedsUpdate(e, t) {
    this.targetObject[this.propertyName] = e[t], this.targetObject.needsUpdate = !0;
  }
  _setValue_direct_setMatrixWorldNeedsUpdate(e, t) {
    this.targetObject[this.propertyName] = e[t], this.targetObject.matrixWorldNeedsUpdate = !0;
  }
  // EntireArray
  _setValue_array(e, t) {
    const i = this.resolvedProperty;
    for (let n = 0, r = i.length; n !== r; ++n)
      i[n] = e[t++];
  }
  _setValue_array_setNeedsUpdate(e, t) {
    const i = this.resolvedProperty;
    for (let n = 0, r = i.length; n !== r; ++n)
      i[n] = e[t++];
    this.targetObject.needsUpdate = !0;
  }
  _setValue_array_setMatrixWorldNeedsUpdate(e, t) {
    const i = this.resolvedProperty;
    for (let n = 0, r = i.length; n !== r; ++n)
      i[n] = e[t++];
    this.targetObject.matrixWorldNeedsUpdate = !0;
  }
  // ArrayElement
  _setValue_arrayElement(e, t) {
    this.resolvedProperty[this.propertyIndex] = e[t];
  }
  _setValue_arrayElement_setNeedsUpdate(e, t) {
    this.resolvedProperty[this.propertyIndex] = e[t], this.targetObject.needsUpdate = !0;
  }
  _setValue_arrayElement_setMatrixWorldNeedsUpdate(e, t) {
    this.resolvedProperty[this.propertyIndex] = e[t], this.targetObject.matrixWorldNeedsUpdate = !0;
  }
  // HasToFromArray
  _setValue_fromArray(e, t) {
    this.resolvedProperty.fromArray(e, t);
  }
  _setValue_fromArray_setNeedsUpdate(e, t) {
    this.resolvedProperty.fromArray(e, t), this.targetObject.needsUpdate = !0;
  }
  _setValue_fromArray_setMatrixWorldNeedsUpdate(e, t) {
    this.resolvedProperty.fromArray(e, t), this.targetObject.matrixWorldNeedsUpdate = !0;
  }
  _getValue_unbound(e, t) {
    this.bind(), this.getValue(e, t);
  }
  _setValue_unbound(e, t) {
    this.bind(), this.setValue(e, t);
  }
  /**
   * Creates a getter / setter pair for the property tracked by this binding.
   */
  bind() {
    let e = this.node;
    const t = this.parsedPath, i = t.objectName, n = t.propertyName;
    let r = t.propertyIndex;
    if (e || (e = st.findNode(this.rootNode, t.nodeName), this.node = e), this.getValue = this._getValue_unavailable, this.setValue = this._setValue_unavailable, !e) {
      Te("PropertyBinding: No target node found for track: " + this.path + ".");
      return;
    }
    if (i) {
      let c = t.objectIndex;
      switch (i) {
        case "materials":
          if (!e.material) {
            Ce("PropertyBinding: Can not bind to material as node does not have a material.", this);
            return;
          }
          if (!e.material.materials) {
            Ce("PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.", this);
            return;
          }
          e = e.material.materials;
          break;
        case "bones":
          if (!e.skeleton) {
            Ce("PropertyBinding: Can not bind to bones as node does not have a skeleton.", this);
            return;
          }
          e = e.skeleton.bones;
          for (let h = 0; h < e.length; h++)
            if (e[h].name === c) {
              c = h;
              break;
            }
          break;
        case "map":
          if ("map" in e) {
            e = e.map;
            break;
          }
          if (!e.material) {
            Ce("PropertyBinding: Can not bind to material as node does not have a material.", this);
            return;
          }
          if (!e.material.map) {
            Ce("PropertyBinding: Can not bind to material.map as node.material does not have a map.", this);
            return;
          }
          e = e.material.map;
          break;
        default:
          if (e[i] === void 0) {
            Ce("PropertyBinding: Can not bind to objectName of node undefined.", this);
            return;
          }
          e = e[i];
      }
      if (c !== void 0) {
        if (e[c] === void 0) {
          Ce("PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.", this, e);
          return;
        }
        e = e[c];
      }
    }
    const a = e[n];
    if (a === void 0) {
      const c = t.nodeName;
      Ce("PropertyBinding: Trying to update property for track: " + c + "." + n + " but it wasn't found.", e);
      return;
    }
    let o = this.Versioning.None;
    this.targetObject = e, e.isMaterial === !0 ? o = this.Versioning.NeedsUpdate : e.isObject3D === !0 && (o = this.Versioning.MatrixWorldNeedsUpdate);
    let l = this.BindingType.Direct;
    if (r !== void 0) {
      if (n === "morphTargetInfluences") {
        if (!e.geometry) {
          Ce("PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.", this);
          return;
        }
        if (!e.geometry.morphAttributes) {
          Ce("PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.", this);
          return;
        }
        e.morphTargetDictionary[r] !== void 0 && (r = e.morphTargetDictionary[r]);
      }
      l = this.BindingType.ArrayElement, this.resolvedProperty = a, this.propertyIndex = r;
    } else a.fromArray !== void 0 && a.toArray !== void 0 ? (l = this.BindingType.HasFromToArray, this.resolvedProperty = a) : Array.isArray(a) ? (l = this.BindingType.EntireArray, this.resolvedProperty = a) : this.propertyName = n;
    this.getValue = this.GetterByBindingType[l], this.setValue = this.SetterByBindingTypeAndVersioning[l][o];
  }
  /**
   * Unbinds the property.
   */
  unbind() {
    this.node = null, this.getValue = this._getValue_unbound, this.setValue = this._setValue_unbound;
  }
}
st.Composite = Q_;
st.prototype.BindingType = {
  Direct: 0,
  EntireArray: 1,
  ArrayElement: 2,
  HasFromToArray: 3
};
st.prototype.Versioning = {
  None: 0,
  NeedsUpdate: 1,
  MatrixWorldNeedsUpdate: 2
};
st.prototype.GetterByBindingType = [
  st.prototype._getValue_direct,
  st.prototype._getValue_array,
  st.prototype._getValue_arrayElement,
  st.prototype._getValue_toArray
];
st.prototype.SetterByBindingTypeAndVersioning = [
  [
    // Direct
    st.prototype._setValue_direct,
    st.prototype._setValue_direct_setNeedsUpdate,
    st.prototype._setValue_direct_setMatrixWorldNeedsUpdate
  ],
  [
    // EntireArray
    st.prototype._setValue_array,
    st.prototype._setValue_array_setNeedsUpdate,
    st.prototype._setValue_array_setMatrixWorldNeedsUpdate
  ],
  [
    // ArrayElement
    st.prototype._setValue_arrayElement,
    st.prototype._setValue_arrayElement_setNeedsUpdate,
    st.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
  ],
  [
    // HasToFromArray
    st.prototype._setValue_fromArray,
    st.prototype._setValue_fromArray_setNeedsUpdate,
    st.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
  ]
];
class e0 {
  /**
   * Constructs a new animation action.
   *
   * @param {AnimationMixer} mixer - The mixer that is controlled by this action.
   * @param {AnimationClip} clip - The animation clip that holds the actual keyframes.
   * @param {?Object3D} [localRoot=null] - The root object on which this action is performed.
   * @param {(NormalAnimationBlendMode|AdditiveAnimationBlendMode)} [blendMode] - The blend mode.
   */
  constructor(e, t, i = null, n = t.blendMode) {
    this._mixer = e, this._clip = t, this._localRoot = i, this.blendMode = n;
    const r = t.tracks, a = r.length, o = new Array(a), l = {
      endingStart: Ms,
      endingEnd: Ms
    };
    for (let c = 0; c !== a; ++c) {
      const h = r[c].createInterpolant(null);
      o[c] = h, h.settings = l;
    }
    this._interpolantSettings = l, this._interpolants = o, this._propertyBindings = new Array(a), this._cacheIndex = null, this._byClipCacheIndex = null, this._timeScaleInterpolant = null, this._weightInterpolant = null, this.loop = hv, this._loopCount = -1, this._startTime = null, this.time = 0, this.timeScale = 1, this._effectiveTimeScale = 1, this.weight = 1, this._effectiveWeight = 1, this.repetitions = 1 / 0, this.paused = !1, this.enabled = !0, this.clampWhenFinished = !1, this.zeroSlopeAtStart = !0, this.zeroSlopeAtEnd = !0;
  }
  /**
   * Starts the playback of the animation.
   *
   * @return {AnimationAction} A reference to this animation action.
   */
  play() {
    return this._mixer._activateAction(this), this;
  }
  /**
   * Stops the playback of the animation.
   *
   * @return {AnimationAction} A reference to this animation action.
   */
  stop() {
    return this._mixer._deactivateAction(this), this.reset();
  }
  /**
   * Resets the playback of the animation.
   *
   * @return {AnimationAction} A reference to this animation action.
   */
  reset() {
    return this.paused = !1, this.enabled = !0, this.time = 0, this._loopCount = -1, this._startTime = null, this.stopFading().stopWarping();
  }
  /**
   * Returns `true` if the animation is running.
   *
   * @return {boolean} Whether the animation is running or not.
   */
  isRunning() {
    return this.enabled && !this.paused && this.timeScale !== 0 && this._startTime === null && this._mixer._isActiveAction(this);
  }
  /**
   * Returns `true` when {@link AnimationAction#play} has been called.
   *
   * @return {boolean} Whether the animation is scheduled or not.
   */
  isScheduled() {
    return this._mixer._isActiveAction(this);
  }
  /**
   * Defines the time when the animation should start.
   *
   * @param {number} time - The start time in seconds.
   * @return {AnimationAction} A reference to this animation action.
   */
  startAt(e) {
    return this._startTime = e, this;
  }
  /**
   * Configures the loop settings for this action.
   *
   * @param {(LoopRepeat|LoopOnce|LoopPingPong)} mode - The loop mode.
   * @param {number} repetitions - The number of repetitions.
   * @return {AnimationAction} A reference to this animation action.
   */
  setLoop(e, t) {
    return this.loop = e, this.repetitions = t, this;
  }
  /**
   * Sets the effective weight of this action.
   *
   * An action has no effect and thus an effective weight of zero when the
   * action is disabled.
   *
   * @param {number} weight - The weight to set.
   * @return {AnimationAction} A reference to this animation action.
   */
  setEffectiveWeight(e) {
    return this.weight = e, this._effectiveWeight = this.enabled ? e : 0, this.stopFading();
  }
  /**
   * Returns the effective weight of this action.
   *
   * @return {number} The effective weight.
   */
  getEffectiveWeight() {
    return this._effectiveWeight;
  }
  /**
   * Fades the animation in by increasing its weight gradually from `0` to `1`,
   * within the passed time interval.
   *
   * @param {number} duration - The duration of the fade.
   * @return {AnimationAction} A reference to this animation action.
   */
  fadeIn(e) {
    return this._scheduleFading(e, 0, 1);
  }
  /**
   * Fades the animation out by decreasing its weight gradually from `1` to `0`,
   * within the passed time interval.
   *
   * @param {number} duration - The duration of the fade.
   * @return {AnimationAction} A reference to this animation action.
   */
  fadeOut(e) {
    return this._scheduleFading(e, 1, 0);
  }
  /**
   * Causes this action to fade in and the given action to fade out,
   * within the passed time interval.
   *
   * @param {AnimationAction} fadeOutAction - The animation action to fade out.
   * @param {number} duration - The duration of the fade.
   * @param {boolean} [warp=false] - Whether warping should be used or not.
   * @return {AnimationAction} A reference to this animation action.
   */
  crossFadeFrom(e, t, i = !1) {
    if (e.fadeOut(t), this.fadeIn(t), i === !0) {
      const n = this._clip.duration, r = e._clip.duration, a = r / n, o = n / r;
      e.warp(1, a, t), this.warp(o, 1, t);
    }
    return this;
  }
  /**
   * Causes this action to fade out and the given action to fade in,
   * within the passed time interval.
   *
   * @param {AnimationAction} fadeInAction - The animation action to fade in.
   * @param {number} duration - The duration of the fade.
   * @param {boolean} [warp=false] - Whether warping should be used or not.
   * @return {AnimationAction} A reference to this animation action.
   */
  crossFadeTo(e, t, i = !1) {
    return e.crossFadeFrom(this, t, i);
  }
  /**
   * Stops any fading which is applied to this action.
   *
   * @return {AnimationAction} A reference to this animation action.
   */
  stopFading() {
    const e = this._weightInterpolant;
    return e !== null && (this._weightInterpolant = null, this._mixer._takeBackControlInterpolant(e)), this;
  }
  /**
   * Sets the effective time scale of this action.
   *
   * An action has no effect and thus an effective time scale of zero when the
   * action is paused.
   *
   * @param {number} timeScale - The time scale to set.
   * @return {AnimationAction} A reference to this animation action.
   */
  setEffectiveTimeScale(e) {
    return this.timeScale = e, this._effectiveTimeScale = this.paused ? 0 : e, this.stopWarping();
  }
  /**
   * Returns the effective time scale of this action.
   *
   * @return {number} The effective time scale.
   */
  getEffectiveTimeScale() {
    return this._effectiveTimeScale;
  }
  /**
   * Sets the duration for a single loop of this action.
   *
   * @param {number} duration - The duration to set.
   * @return {AnimationAction} A reference to this animation action.
   */
  setDuration(e) {
    return this.timeScale = this._clip.duration / e, this.stopWarping();
  }
  /**
   * Synchronizes this action with the passed other action.
   *
   * @param {AnimationAction} action - The action to sync with.
   * @return {AnimationAction} A reference to this animation action.
   */
  syncWith(e) {
    return this.time = e.time, this.timeScale = e.timeScale, this.stopWarping();
  }
  /**
   * Decelerates this animation's speed to `0` within the passed time interval.
   *
   * @param {number} duration - The duration.
   * @return {AnimationAction} A reference to this animation action.
   */
  halt(e) {
    return this.warp(this._effectiveTimeScale, 0, e);
  }
  /**
   * Changes the playback speed, within the passed time interval, by modifying
   * {@link AnimationAction#timeScale} gradually from `startTimeScale` to
   * `endTimeScale`.
   *
   * @param {number} startTimeScale - The start time scale.
   * @param {number} endTimeScale - The end time scale.
   * @param {number} duration - The duration.
   * @return {AnimationAction} A reference to this animation action.
   */
  warp(e, t, i) {
    const n = this._mixer, r = n.time, a = this.timeScale;
    let o = this._timeScaleInterpolant;
    o === null && (o = n._lendControlInterpolant(), this._timeScaleInterpolant = o);
    const l = o.parameterPositions, c = o.sampleValues;
    return l[0] = r, l[1] = r + i, c[0] = e / a, c[1] = t / a, this;
  }
  /**
   * Stops any scheduled warping which is applied to this action.
   *
   * @return {AnimationAction} A reference to this animation action.
   */
  stopWarping() {
    const e = this._timeScaleInterpolant;
    return e !== null && (this._timeScaleInterpolant = null, this._mixer._takeBackControlInterpolant(e)), this;
  }
  /**
   * Returns the animation mixer of this animation action.
   *
   * @return {AnimationMixer} The animation mixer.
   */
  getMixer() {
    return this._mixer;
  }
  /**
   * Returns the animation clip of this animation action.
   *
   * @return {AnimationClip} The animation clip.
   */
  getClip() {
    return this._clip;
  }
  /**
   * Returns the root object of this animation action.
   *
   * @return {Object3D} The root object.
   */
  getRoot() {
    return this._localRoot || this._mixer._root;
  }
  // Interna
  _update(e, t, i, n) {
    if (!this.enabled) {
      this._updateWeight(e);
      return;
    }
    const r = this._startTime;
    if (r !== null) {
      const l = (e - r) * i;
      l < 0 || i === 0 ? t = 0 : (this._startTime = null, t = i * l);
    }
    t *= this._updateTimeScale(e);
    const a = this._updateTime(t), o = this._updateWeight(e);
    if (o > 0) {
      const l = this._interpolants, c = this._propertyBindings;
      switch (this.blendMode) {
        case uv:
          for (let h = 0, d = l.length; h !== d; ++h)
            l[h].evaluate(a), c[h].accumulateAdditive(o);
          break;
        case Xc:
        default:
          for (let h = 0, d = l.length; h !== d; ++h)
            l[h].evaluate(a), c[h].accumulate(n, o);
      }
    }
  }
  _updateWeight(e) {
    let t = 0;
    if (this.enabled) {
      t = this.weight;
      const i = this._weightInterpolant;
      if (i !== null) {
        const n = i.evaluate(e)[0];
        t *= n, e > i.parameterPositions[1] && (this.stopFading(), n === 0 && (this.enabled = !1));
      }
    }
    return this._effectiveWeight = t, t;
  }
  _updateTimeScale(e) {
    let t = 0;
    if (!this.paused) {
      t = this.timeScale;
      const i = this._timeScaleInterpolant;
      if (i !== null) {
        const n = i.evaluate(e)[0];
        t *= n, e > i.parameterPositions[1] && (this.stopWarping(), t === 0 ? this.paused = !0 : this.timeScale = t);
      }
    }
    return this._effectiveTimeScale = t, t;
  }
  _updateTime(e) {
    const t = this._clip.duration, i = this.loop;
    let n = this.time + e, r = this._loopCount;
    const a = i === dv;
    if (e === 0)
      return r === -1 ? n : a && (r & 1) === 1 ? t - n : n;
    if (i === oc) {
      r === -1 && (this._loopCount = 0, this._setEndings(!0, !0, !1));
      e: {
        if (n >= t)
          n = t;
        else if (n < 0)
          n = 0;
        else {
          this.time = n;
          break e;
        }
        this.clampWhenFinished ? this.paused = !0 : this.enabled = !1, this.time = n, this._mixer.dispatchEvent({
          type: "finished",
          action: this,
          direction: e < 0 ? -1 : 1
        });
      }
    } else {
      if (r === -1 && (e >= 0 ? (r = 0, this._setEndings(!0, this.repetitions === 0, a)) : this._setEndings(this.repetitions === 0, !0, a)), n >= t || n < 0) {
        const o = Math.floor(n / t);
        n -= t * o, r += Math.abs(o);
        const l = this.repetitions - r;
        if (l <= 0)
          this.clampWhenFinished ? this.paused = !0 : this.enabled = !1, n = e > 0 ? t : 0, this.time = n, this._mixer.dispatchEvent({
            type: "finished",
            action: this,
            direction: e > 0 ? 1 : -1
          });
        else {
          if (l === 1) {
            const c = e < 0;
            this._setEndings(c, !c, a);
          } else
            this._setEndings(!1, !1, a);
          this._loopCount = r, this.time = n, this._mixer.dispatchEvent({
            type: "loop",
            action: this,
            loopDelta: o
          });
        }
      } else
        this.time = n;
      if (a && (r & 1) === 1)
        return t - n;
    }
    return n;
  }
  _setEndings(e, t, i) {
    const n = this._interpolantSettings;
    i ? (n.endingStart = Ts, n.endingEnd = Ts) : (e ? n.endingStart = this.zeroSlopeAtStart ? Ts : Ms : n.endingStart = $a, t ? n.endingEnd = this.zeroSlopeAtEnd ? Ts : Ms : n.endingEnd = $a);
  }
  _scheduleFading(e, t, i) {
    const n = this._mixer, r = n.time;
    let a = this._weightInterpolant;
    a === null && (a = n._lendControlInterpolant(), this._weightInterpolant = a);
    const o = a.parameterPositions, l = a.sampleValues;
    return o[0] = r, l[0] = t, o[1] = r + e, l[1] = i, this;
  }
}
const t0 = new Float32Array(1);
class i0 extends ss {
  /**
   * Constructs a new animation mixer.
   *
   * @param {Object3D} root - The object whose animations shall be played by this mixer.
   */
  constructor(e) {
    super(), this._root = e, this._initMemoryManager(), this._accuIndex = 0, this.time = 0, this.timeScale = 1;
  }
  _bindAction(e, t) {
    const i = e._localRoot || this._root, n = e._clip.tracks, r = n.length, a = e._propertyBindings, o = e._interpolants, l = i.uuid, c = this._bindingsByRootAndName;
    let h = c[l];
    h === void 0 && (h = {}, c[l] = h);
    for (let d = 0; d !== r; ++d) {
      const u = n[d], f = u.name;
      let g = h[f];
      if (g !== void 0)
        ++g.referenceCount, a[d] = g;
      else {
        if (g = a[d], g !== void 0) {
          g._cacheIndex === null && (++g.referenceCount, this._addInactiveBinding(g, l, f));
          continue;
        }
        const v = t && t._propertyBindings[d].binding.parsedPath;
        g = new G_(
          st.create(i, f, v),
          u.ValueTypeName,
          u.getValueSize()
        ), ++g.referenceCount, this._addInactiveBinding(g, l, f), a[d] = g;
      }
      o[d].resultBuffer = g.buffer;
    }
  }
  _activateAction(e) {
    if (!this._isActiveAction(e)) {
      if (e._cacheIndex === null) {
        const i = (e._localRoot || this._root).uuid, n = e._clip.uuid, r = this._actionsByClip[n];
        this._bindAction(
          e,
          r && r.knownActions[0]
        ), this._addInactiveAction(e, n, i);
      }
      const t = e._propertyBindings;
      for (let i = 0, n = t.length; i !== n; ++i) {
        const r = t[i];
        r.useCount++ === 0 && (this._lendBinding(r), r.saveOriginalState());
      }
      this._lendAction(e);
    }
  }
  _deactivateAction(e) {
    if (this._isActiveAction(e)) {
      const t = e._propertyBindings;
      for (let i = 0, n = t.length; i !== n; ++i) {
        const r = t[i];
        --r.useCount === 0 && (r.restoreOriginalState(), this._takeBackBinding(r));
      }
      this._takeBackAction(e);
    }
  }
  // Memory manager
  _initMemoryManager() {
    this._actions = [], this._nActiveActions = 0, this._actionsByClip = {}, this._bindings = [], this._nActiveBindings = 0, this._bindingsByRootAndName = {}, this._controlInterpolants = [], this._nActiveControlInterpolants = 0;
    const e = this;
    this.stats = {
      actions: {
        get total() {
          return e._actions.length;
        },
        get inUse() {
          return e._nActiveActions;
        }
      },
      bindings: {
        get total() {
          return e._bindings.length;
        },
        get inUse() {
          return e._nActiveBindings;
        }
      },
      controlInterpolants: {
        get total() {
          return e._controlInterpolants.length;
        },
        get inUse() {
          return e._nActiveControlInterpolants;
        }
      }
    };
  }
  // Memory management for AnimationAction objects
  _isActiveAction(e) {
    const t = e._cacheIndex;
    return t !== null && t < this._nActiveActions;
  }
  _addInactiveAction(e, t, i) {
    const n = this._actions, r = this._actionsByClip;
    let a = r[t];
    if (a === void 0)
      a = {
        knownActions: [e],
        actionByRoot: {}
      }, e._byClipCacheIndex = 0, r[t] = a;
    else {
      const o = a.knownActions;
      e._byClipCacheIndex = o.length, o.push(e);
    }
    e._cacheIndex = n.length, n.push(e), a.actionByRoot[i] = e;
  }
  _removeInactiveAction(e) {
    const t = this._actions, i = t[t.length - 1], n = e._cacheIndex;
    i._cacheIndex = n, t[n] = i, t.pop(), e._cacheIndex = null;
    const r = e._clip.uuid, a = this._actionsByClip, o = a[r], l = o.knownActions, c = l[l.length - 1], h = e._byClipCacheIndex;
    c._byClipCacheIndex = h, l[h] = c, l.pop(), e._byClipCacheIndex = null;
    const d = o.actionByRoot, u = (e._localRoot || this._root).uuid;
    delete d[u], l.length === 0 && delete a[r], this._removeInactiveBindingsForAction(e);
  }
  _removeInactiveBindingsForAction(e) {
    const t = e._propertyBindings;
    for (let i = 0, n = t.length; i !== n; ++i) {
      const r = t[i];
      --r.referenceCount === 0 && this._removeInactiveBinding(r);
    }
  }
  _lendAction(e) {
    const t = this._actions, i = e._cacheIndex, n = this._nActiveActions++, r = t[n];
    e._cacheIndex = n, t[n] = e, r._cacheIndex = i, t[i] = r;
  }
  _takeBackAction(e) {
    const t = this._actions, i = e._cacheIndex, n = --this._nActiveActions, r = t[n];
    e._cacheIndex = n, t[n] = e, r._cacheIndex = i, t[i] = r;
  }
  // Memory management for PropertyMixer objects
  _addInactiveBinding(e, t, i) {
    const n = this._bindingsByRootAndName, r = this._bindings;
    let a = n[t];
    a === void 0 && (a = {}, n[t] = a), a[i] = e, e._cacheIndex = r.length, r.push(e);
  }
  _removeInactiveBinding(e) {
    const t = this._bindings, i = e.binding, n = i.rootNode.uuid, r = i.path, a = this._bindingsByRootAndName, o = a[n], l = t[t.length - 1], c = e._cacheIndex;
    l._cacheIndex = c, t[c] = l, t.pop(), delete o[r], Object.keys(o).length === 0 && delete a[n];
  }
  _lendBinding(e) {
    const t = this._bindings, i = e._cacheIndex, n = this._nActiveBindings++, r = t[n];
    e._cacheIndex = n, t[n] = e, r._cacheIndex = i, t[i] = r;
  }
  _takeBackBinding(e) {
    const t = this._bindings, i = e._cacheIndex, n = --this._nActiveBindings, r = t[n];
    e._cacheIndex = n, t[n] = e, r._cacheIndex = i, t[i] = r;
  }
  // Memory management of Interpolants for weight and time scale
  _lendControlInterpolant() {
    const e = this._controlInterpolants, t = this._nActiveControlInterpolants++;
    let i = e[t];
    return i === void 0 && (i = new ff(
      new Float32Array(2),
      new Float32Array(2),
      1,
      t0
    ), i.__cacheIndex = t, e[t] = i), i;
  }
  _takeBackControlInterpolant(e) {
    const t = this._controlInterpolants, i = e.__cacheIndex, n = --this._nActiveControlInterpolants, r = t[n];
    e.__cacheIndex = n, t[n] = e, r.__cacheIndex = i, t[i] = r;
  }
  /**
   * Returns an instance of {@link AnimationAction} for the passed clip.
   *
   * If an action fitting the clip and root parameters doesn't yet exist, it
   * will be created by this method. Calling this method several times with the
   * same clip and root parameters always returns the same action.
   *
   * @param {AnimationClip|string} clip - An animation clip or alternatively the name of the animation clip.
   * @param {Object3D} [optionalRoot] - An alternative root object.
   * @param {(NormalAnimationBlendMode|AdditiveAnimationBlendMode)} [blendMode] - The blend mode.
   * @return {?AnimationAction} The animation action.
   */
  clipAction(e, t, i) {
    const n = t || this._root, r = n.uuid;
    let a = typeof e == "string" ? fc.findByName(n, e) : e;
    const o = a !== null ? a.uuid : e, l = this._actionsByClip[o];
    let c = null;
    if (i === void 0 && (a !== null ? i = a.blendMode : i = Xc), l !== void 0) {
      const d = l.actionByRoot[r];
      if (d !== void 0 && d.blendMode === i)
        return d;
      c = l.knownActions[0], a === null && (a = c._clip);
    }
    if (a === null) return null;
    const h = new e0(this, a, t, i);
    return this._bindAction(h, c), this._addInactiveAction(h, o, r), h;
  }
  /**
   * Returns an existing animation action for the passed clip.
   *
   * @param {AnimationClip|string} clip - An animation clip or alternatively the name of the animation clip.
   * @param {Object3D} [optionalRoot] - An alternative root object.
   * @return {?AnimationAction} The animation action. Returns `null` if no action was found.
   */
  existingAction(e, t) {
    const i = t || this._root, n = i.uuid, r = typeof e == "string" ? fc.findByName(i, e) : e, a = r ? r.uuid : e, o = this._actionsByClip[a];
    return o !== void 0 && o.actionByRoot[n] || null;
  }
  /**
   * Deactivates all previously scheduled actions on this mixer.
   *
   * @return {AnimationMixer} A reference to this animation mixer.
   */
  stopAllAction() {
    const e = this._actions, t = this._nActiveActions;
    for (let i = t - 1; i >= 0; --i)
      e[i].stop();
    return this;
  }
  /**
   * Advances the global mixer time and updates the animation.
   *
   * This is usually done in the render loop by passing the delta
   * time from {@link Clock} or {@link Timer}.
   *
   * @param {number} deltaTime - The delta time in seconds.
   * @return {AnimationMixer} A reference to this animation mixer.
   */
  update(e) {
    e *= this.timeScale;
    const t = this._actions, i = this._nActiveActions, n = this.time += e, r = Math.sign(e), a = this._accuIndex ^= 1;
    for (let c = 0; c !== i; ++c)
      t[c]._update(n, e, r, a);
    const o = this._bindings, l = this._nActiveBindings;
    for (let c = 0; c !== l; ++c)
      o[c].apply(a);
    return this;
  }
  /**
   * Sets the global mixer to a specific time and updates the animation accordingly.
   *
   * This is useful when you need to jump to an exact time in an animation. The
   * input parameter will be scaled by {@link AnimationMixer#timeScale}
   *
   * @param {number} time - The time to set in seconds.
   * @return {AnimationMixer} A reference to this animation mixer.
   */
  setTime(e) {
    this.time = 0;
    for (let t = 0; t < this._actions.length; t++)
      this._actions[t].time = 0;
    return this.update(e);
  }
  /**
   * Returns this mixer's root object.
   *
   * @return {Object3D} The mixer's root object.
   */
  getRoot() {
    return this._root;
  }
  /**
   * Deallocates all memory resources for a clip. Before using this method make
   * sure to call {@link AnimationAction#stop} for all related actions.
   *
   * @param {AnimationClip} clip - The clip to uncache.
   */
  uncacheClip(e) {
    const t = this._actions, i = e.uuid, n = this._actionsByClip, r = n[i];
    if (r !== void 0) {
      const a = r.knownActions;
      for (let o = 0, l = a.length; o !== l; ++o) {
        const c = a[o];
        this._deactivateAction(c);
        const h = c._cacheIndex, d = t[t.length - 1];
        c._cacheIndex = null, c._byClipCacheIndex = null, d._cacheIndex = h, t[h] = d, t.pop(), this._removeInactiveBindingsForAction(c);
      }
      delete n[i];
    }
  }
  /**
   * Deallocates all memory resources for a root object. Before using this
   * method make sure to call {@link AnimationAction#stop} for all related
   * actions or alternatively {@link AnimationMixer#stopAllAction} when the
   * mixer operates on a single root.
   *
   * @param {Object3D} root - The root object to uncache.
   */
  uncacheRoot(e) {
    const t = e.uuid, i = this._actionsByClip;
    for (const a in i) {
      const o = i[a].actionByRoot, l = o[t];
      l !== void 0 && (this._deactivateAction(l), this._removeInactiveAction(l));
    }
    const n = this._bindingsByRootAndName, r = n[t];
    if (r !== void 0)
      for (const a in r) {
        const o = r[a];
        o.restoreOriginalState(), this._removeInactiveBinding(o);
      }
  }
  /**
   * Deallocates all memory resources for an action. The action is identified by the
   * given clip and an optional root object. Before using this method make
   * sure to call {@link AnimationAction#stop} to deactivate the action.
   *
   * @param {AnimationClip|string} clip - An animation clip or alternatively the name of the animation clip.
   * @param {Object3D} [optionalRoot] - An alternative root object.
   */
  uncacheAction(e, t) {
    const i = this.existingAction(e, t);
    i !== null && (this._deactivateAction(i), this._removeInactiveAction(i));
  }
}
function Ld(s, e, t, i) {
  const n = n0(i);
  switch (t) {
    // https://registry.khronos.org/OpenGL-Refpages/es3.0/html/glTexImage2D.xhtml
    case Xu:
      return s * e;
    case $c:
      return s * e / n.components * n.byteLength;
    case Gc:
      return s * e / n.components * n.byteLength;
    case Fs:
      return s * e * 2 / n.components * n.byteLength;
    case qc:
      return s * e * 2 / n.components * n.byteLength;
    case ju:
      return s * e * 3 / n.components * n.byteLength;
    case mi:
      return s * e * 4 / n.components * n.byteLength;
    case Wc:
      return s * e * 4 / n.components * n.byteLength;
    // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_s3tc_srgb/
    case Ta:
    case Ea:
      return Math.floor((s + 3) / 4) * Math.floor((e + 3) / 4) * 8;
    case Aa:
    case Ra:
      return Math.floor((s + 3) / 4) * Math.floor((e + 3) / 4) * 16;
    // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_pvrtc/
    case Il:
    case Ll:
      return Math.max(s, 16) * Math.max(e, 8) / 4;
    case Cl:
    case Pl:
      return Math.max(s, 8) * Math.max(e, 8) / 2;
    // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_etc/
    case Dl:
    case Nl:
    case Ul:
    case Fl:
      return Math.floor((s + 3) / 4) * Math.floor((e + 3) / 4) * 8;
    case Ol:
    case Bl:
    case kl:
      return Math.floor((s + 3) / 4) * Math.floor((e + 3) / 4) * 16;
    // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_astc/
    case zl:
      return Math.floor((s + 3) / 4) * Math.floor((e + 3) / 4) * 16;
    case Vl:
      return Math.floor((s + 4) / 5) * Math.floor((e + 3) / 4) * 16;
    case Hl:
      return Math.floor((s + 4) / 5) * Math.floor((e + 4) / 5) * 16;
    case $l:
      return Math.floor((s + 5) / 6) * Math.floor((e + 4) / 5) * 16;
    case Gl:
      return Math.floor((s + 5) / 6) * Math.floor((e + 5) / 6) * 16;
    case ql:
      return Math.floor((s + 7) / 8) * Math.floor((e + 4) / 5) * 16;
    case Wl:
      return Math.floor((s + 7) / 8) * Math.floor((e + 5) / 6) * 16;
    case Xl:
      return Math.floor((s + 7) / 8) * Math.floor((e + 7) / 8) * 16;
    case jl:
      return Math.floor((s + 9) / 10) * Math.floor((e + 4) / 5) * 16;
    case Yl:
      return Math.floor((s + 9) / 10) * Math.floor((e + 5) / 6) * 16;
    case Kl:
      return Math.floor((s + 9) / 10) * Math.floor((e + 7) / 8) * 16;
    case Zl:
      return Math.floor((s + 9) / 10) * Math.floor((e + 9) / 10) * 16;
    case Jl:
      return Math.floor((s + 11) / 12) * Math.floor((e + 9) / 10) * 16;
    case Ql:
      return Math.floor((s + 11) / 12) * Math.floor((e + 11) / 12) * 16;
    // https://registry.khronos.org/webgl/extensions/EXT_texture_compression_bptc/
    case ec:
    case tc:
    case ic:
      return Math.ceil(s / 4) * Math.ceil(e / 4) * 16;
    // https://registry.khronos.org/webgl/extensions/EXT_texture_compression_rgtc/
    case nc:
    case sc:
      return Math.ceil(s / 4) * Math.ceil(e / 4) * 8;
    case rc:
    case ac:
      return Math.ceil(s / 4) * Math.ceil(e / 4) * 16;
  }
  throw new Error(
    `Unable to determine texture byte length for ${t} format.`
  );
}
function n0(s) {
  switch (s) {
    case ii:
    case $u:
      return { byteLength: 1, components: 1 };
    case Mr:
    case Gu:
    case Ai:
      return { byteLength: 2, components: 1 };
    case Vc:
    case Hc:
      return { byteLength: 2, components: 4 };
    case Hi:
    case zc:
    case pi:
      return { byteLength: 4, components: 1 };
    case qu:
    case Wu:
      return { byteLength: 4, components: 3 };
  }
  throw new Error(`Unknown texture type ${s}.`);
}
typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", { detail: {
  revision: kc
} }));
typeof window < "u" && (window.__THREE__ ? Te("WARNING: Multiple instances of Three.js being imported.") : window.__THREE__ = kc);
function _f() {
  let s = null, e = !1, t = null, i = null;
  function n(r, a) {
    t(r, a), i = s.requestAnimationFrame(n);
  }
  return {
    start: function() {
      e !== !0 && t !== null && (i = s.requestAnimationFrame(n), e = !0);
    },
    stop: function() {
      s.cancelAnimationFrame(i), e = !1;
    },
    setAnimationLoop: function(r) {
      t = r;
    },
    setContext: function(r) {
      s = r;
    }
  };
}
function s0(s) {
  const e = /* @__PURE__ */ new WeakMap();
  function t(o, l) {
    const c = o.array, h = o.usage, d = c.byteLength, u = s.createBuffer();
    s.bindBuffer(l, u), s.bufferData(l, c, h), o.onUploadCallback();
    let f;
    if (c instanceof Float32Array)
      f = s.FLOAT;
    else if (typeof Float16Array < "u" && c instanceof Float16Array)
      f = s.HALF_FLOAT;
    else if (c instanceof Uint16Array)
      o.isFloat16BufferAttribute ? f = s.HALF_FLOAT : f = s.UNSIGNED_SHORT;
    else if (c instanceof Int16Array)
      f = s.SHORT;
    else if (c instanceof Uint32Array)
      f = s.UNSIGNED_INT;
    else if (c instanceof Int32Array)
      f = s.INT;
    else if (c instanceof Int8Array)
      f = s.BYTE;
    else if (c instanceof Uint8Array)
      f = s.UNSIGNED_BYTE;
    else if (c instanceof Uint8ClampedArray)
      f = s.UNSIGNED_BYTE;
    else
      throw new Error("THREE.WebGLAttributes: Unsupported buffer data format: " + c);
    return {
      buffer: u,
      type: f,
      bytesPerElement: c.BYTES_PER_ELEMENT,
      version: o.version,
      size: d
    };
  }
  function i(o, l, c) {
    const h = l.array, d = l.updateRanges;
    if (s.bindBuffer(c, o), d.length === 0)
      s.bufferSubData(c, 0, h);
    else {
      d.sort((f, g) => f.start - g.start);
      let u = 0;
      for (let f = 1; f < d.length; f++) {
        const g = d[u], v = d[f];
        v.start <= g.start + g.count + 1 ? g.count = Math.max(
          g.count,
          v.start + v.count - g.start
        ) : (++u, d[u] = v);
      }
      d.length = u + 1;
      for (let f = 0, g = d.length; f < g; f++) {
        const v = d[f];
        s.bufferSubData(
          c,
          v.start * h.BYTES_PER_ELEMENT,
          h,
          v.start,
          v.count
        );
      }
      l.clearUpdateRanges();
    }
    l.onUploadCallback();
  }
  function n(o) {
    return o.isInterleavedBufferAttribute && (o = o.data), e.get(o);
  }
  function r(o) {
    o.isInterleavedBufferAttribute && (o = o.data);
    const l = e.get(o);
    l && (s.deleteBuffer(l.buffer), e.delete(o));
  }
  function a(o, l) {
    if (o.isInterleavedBufferAttribute && (o = o.data), o.isGLBufferAttribute) {
      const h = e.get(o);
      (!h || h.version < o.version) && e.set(o, {
        buffer: o.buffer,
        type: o.type,
        bytesPerElement: o.elementSize,
        version: o.version
      });
      return;
    }
    const c = e.get(o);
    if (c === void 0)
      e.set(o, t(o, l));
    else if (c.version < o.version) {
      if (c.size !== o.array.byteLength)
        throw new Error("THREE.WebGLAttributes: The size of the buffer attribute's array buffer does not match the original size. Resizing buffer attributes is not supported.");
      i(c.buffer, o, l), c.version = o.version;
    }
  }
  return {
    get: n,
    remove: r,
    update: a
  };
}
var r0 = `#ifdef USE_ALPHAHASH
	if ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;
#endif`, a0 = `#ifdef USE_ALPHAHASH
	const float ALPHA_HASH_SCALE = 0.05;
	float hash2D( vec2 value ) {
		return fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );
	}
	float hash3D( vec3 value ) {
		return hash2D( vec2( hash2D( value.xy ), value.z ) );
	}
	float getAlphaHashThreshold( vec3 position ) {
		float maxDeriv = max(
			length( dFdx( position.xyz ) ),
			length( dFdy( position.xyz ) )
		);
		float pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );
		vec2 pixScales = vec2(
			exp2( floor( log2( pixScale ) ) ),
			exp2( ceil( log2( pixScale ) ) )
		);
		vec2 alpha = vec2(
			hash3D( floor( pixScales.x * position.xyz ) ),
			hash3D( floor( pixScales.y * position.xyz ) )
		);
		float lerpFactor = fract( log2( pixScale ) );
		float x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;
		float a = min( lerpFactor, 1.0 - lerpFactor );
		vec3 cases = vec3(
			x * x / ( 2.0 * a * ( 1.0 - a ) ),
			( x - 0.5 * a ) / ( 1.0 - a ),
			1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )
		);
		float threshold = ( x < ( 1.0 - a ) )
			? ( ( x < a ) ? cases.x : cases.y )
			: cases.z;
		return clamp( threshold , 1.0e-6, 1.0 );
	}
#endif`, o0 = `#ifdef USE_ALPHAMAP
	diffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;
#endif`, l0 = `#ifdef USE_ALPHAMAP
	uniform sampler2D alphaMap;
#endif`, c0 = `#ifdef USE_ALPHATEST
	#ifdef ALPHA_TO_COVERAGE
	diffuseColor.a = smoothstep( alphaTest, alphaTest + fwidth( diffuseColor.a ), diffuseColor.a );
	if ( diffuseColor.a == 0.0 ) discard;
	#else
	if ( diffuseColor.a < alphaTest ) discard;
	#endif
#endif`, h0 = `#ifdef USE_ALPHATEST
	uniform float alphaTest;
#endif`, d0 = `#ifdef USE_AOMAP
	float ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;
	reflectedLight.indirectDiffuse *= ambientOcclusion;
	#if defined( USE_CLEARCOAT ) 
		clearcoatSpecularIndirect *= ambientOcclusion;
	#endif
	#if defined( USE_SHEEN ) 
		sheenSpecularIndirect *= ambientOcclusion;
	#endif
	#if defined( USE_ENVMAP ) && defined( STANDARD )
		float dotNV = saturate( dot( geometryNormal, geometryViewDir ) );
		reflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );
	#endif
#endif`, u0 = `#ifdef USE_AOMAP
	uniform sampler2D aoMap;
	uniform float aoMapIntensity;
#endif`, f0 = `#ifdef USE_BATCHING
	#if ! defined( GL_ANGLE_multi_draw )
	#define gl_DrawID _gl_DrawID
	uniform int _gl_DrawID;
	#endif
	uniform highp sampler2D batchingTexture;
	uniform highp usampler2D batchingIdTexture;
	mat4 getBatchingMatrix( const in float i ) {
		int size = textureSize( batchingTexture, 0 ).x;
		int j = int( i ) * 4;
		int x = j % size;
		int y = j / size;
		vec4 v1 = texelFetch( batchingTexture, ivec2( x, y ), 0 );
		vec4 v2 = texelFetch( batchingTexture, ivec2( x + 1, y ), 0 );
		vec4 v3 = texelFetch( batchingTexture, ivec2( x + 2, y ), 0 );
		vec4 v4 = texelFetch( batchingTexture, ivec2( x + 3, y ), 0 );
		return mat4( v1, v2, v3, v4 );
	}
	float getIndirectIndex( const in int i ) {
		int size = textureSize( batchingIdTexture, 0 ).x;
		int x = i % size;
		int y = i / size;
		return float( texelFetch( batchingIdTexture, ivec2( x, y ), 0 ).r );
	}
#endif
#ifdef USE_BATCHING_COLOR
	uniform sampler2D batchingColorTexture;
	vec3 getBatchingColor( const in float i ) {
		int size = textureSize( batchingColorTexture, 0 ).x;
		int j = int( i );
		int x = j % size;
		int y = j / size;
		return texelFetch( batchingColorTexture, ivec2( x, y ), 0 ).rgb;
	}
#endif`, p0 = `#ifdef USE_BATCHING
	mat4 batchingMatrix = getBatchingMatrix( getIndirectIndex( gl_DrawID ) );
#endif`, m0 = `vec3 transformed = vec3( position );
#ifdef USE_ALPHAHASH
	vPosition = vec3( position );
#endif`, g0 = `vec3 objectNormal = vec3( normal );
#ifdef USE_TANGENT
	vec3 objectTangent = vec3( tangent.xyz );
#endif`, v0 = `float G_BlinnPhong_Implicit( ) {
	return 0.25;
}
float D_BlinnPhong( const in float shininess, const in float dotNH ) {
	return RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );
}
vec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNH = saturate( dot( normal, halfDir ) );
	float dotVH = saturate( dot( viewDir, halfDir ) );
	vec3 F = F_Schlick( specularColor, 1.0, dotVH );
	float G = G_BlinnPhong_Implicit( );
	float D = D_BlinnPhong( shininess, dotNH );
	return F * ( G * D );
} // validated`, _0 = `#ifdef USE_IRIDESCENCE
	const mat3 XYZ_TO_REC709 = mat3(
		 3.2404542, -0.9692660,  0.0556434,
		-1.5371385,  1.8760108, -0.2040259,
		-0.4985314,  0.0415560,  1.0572252
	);
	vec3 Fresnel0ToIor( vec3 fresnel0 ) {
		vec3 sqrtF0 = sqrt( fresnel0 );
		return ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );
	}
	vec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {
		return pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );
	}
	float IorToFresnel0( float transmittedIor, float incidentIor ) {
		return pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));
	}
	vec3 evalSensitivity( float OPD, vec3 shift ) {
		float phase = 2.0 * PI * OPD * 1.0e-9;
		vec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );
		vec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );
		vec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );
		vec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );
		xyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );
		xyz /= 1.0685e-7;
		vec3 rgb = XYZ_TO_REC709 * xyz;
		return rgb;
	}
	vec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {
		vec3 I;
		float iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );
		float sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );
		float cosTheta2Sq = 1.0 - sinTheta2Sq;
		if ( cosTheta2Sq < 0.0 ) {
			return vec3( 1.0 );
		}
		float cosTheta2 = sqrt( cosTheta2Sq );
		float R0 = IorToFresnel0( iridescenceIOR, outsideIOR );
		float R12 = F_Schlick( R0, 1.0, cosTheta1 );
		float T121 = 1.0 - R12;
		float phi12 = 0.0;
		if ( iridescenceIOR < outsideIOR ) phi12 = PI;
		float phi21 = PI - phi12;
		vec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );		vec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );
		vec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );
		vec3 phi23 = vec3( 0.0 );
		if ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;
		if ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;
		if ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;
		float OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;
		vec3 phi = vec3( phi21 ) + phi23;
		vec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );
		vec3 r123 = sqrt( R123 );
		vec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );
		vec3 C0 = R12 + Rs;
		I = C0;
		vec3 Cm = Rs - T121;
		for ( int m = 1; m <= 2; ++ m ) {
			Cm *= r123;
			vec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );
			I += Cm * Sm;
		}
		return max( I, vec3( 0.0 ) );
	}
#endif`, x0 = `#ifdef USE_BUMPMAP
	uniform sampler2D bumpMap;
	uniform float bumpScale;
	vec2 dHdxy_fwd() {
		vec2 dSTdx = dFdx( vBumpMapUv );
		vec2 dSTdy = dFdy( vBumpMapUv );
		float Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;
		float dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;
		float dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;
		return vec2( dBx, dBy );
	}
	vec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {
		vec3 vSigmaX = normalize( dFdx( surf_pos.xyz ) );
		vec3 vSigmaY = normalize( dFdy( surf_pos.xyz ) );
		vec3 vN = surf_norm;
		vec3 R1 = cross( vSigmaY, vN );
		vec3 R2 = cross( vN, vSigmaX );
		float fDet = dot( vSigmaX, R1 ) * faceDirection;
		vec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );
		return normalize( abs( fDet ) * surf_norm - vGrad );
	}
#endif`, y0 = `#if NUM_CLIPPING_PLANES > 0
	vec4 plane;
	#ifdef ALPHA_TO_COVERAGE
		float distanceToPlane, distanceGradient;
		float clipOpacity = 1.0;
		#pragma unroll_loop_start
		for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {
			plane = clippingPlanes[ i ];
			distanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;
			distanceGradient = fwidth( distanceToPlane ) / 2.0;
			clipOpacity *= smoothstep( - distanceGradient, distanceGradient, distanceToPlane );
			if ( clipOpacity == 0.0 ) discard;
		}
		#pragma unroll_loop_end
		#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES
			float unionClipOpacity = 1.0;
			#pragma unroll_loop_start
			for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {
				plane = clippingPlanes[ i ];
				distanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;
				distanceGradient = fwidth( distanceToPlane ) / 2.0;
				unionClipOpacity *= 1.0 - smoothstep( - distanceGradient, distanceGradient, distanceToPlane );
			}
			#pragma unroll_loop_end
			clipOpacity *= 1.0 - unionClipOpacity;
		#endif
		diffuseColor.a *= clipOpacity;
		if ( diffuseColor.a == 0.0 ) discard;
	#else
		#pragma unroll_loop_start
		for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {
			plane = clippingPlanes[ i ];
			if ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;
		}
		#pragma unroll_loop_end
		#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES
			bool clipped = true;
			#pragma unroll_loop_start
			for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {
				plane = clippingPlanes[ i ];
				clipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;
			}
			#pragma unroll_loop_end
			if ( clipped ) discard;
		#endif
	#endif
#endif`, b0 = `#if NUM_CLIPPING_PLANES > 0
	varying vec3 vClipPosition;
	uniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];
#endif`, w0 = `#if NUM_CLIPPING_PLANES > 0
	varying vec3 vClipPosition;
#endif`, S0 = `#if NUM_CLIPPING_PLANES > 0
	vClipPosition = - mvPosition.xyz;
#endif`, M0 = `#if defined( USE_COLOR_ALPHA )
	diffuseColor *= vColor;
#elif defined( USE_COLOR )
	diffuseColor.rgb *= vColor;
#endif`, T0 = `#if defined( USE_COLOR_ALPHA )
	varying vec4 vColor;
#elif defined( USE_COLOR )
	varying vec3 vColor;
#endif`, E0 = `#if defined( USE_COLOR_ALPHA )
	varying vec4 vColor;
#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )
	varying vec3 vColor;
#endif`, A0 = `#if defined( USE_COLOR_ALPHA )
	vColor = vec4( 1.0 );
#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )
	vColor = vec3( 1.0 );
#endif
#ifdef USE_COLOR
	vColor *= color;
#endif
#ifdef USE_INSTANCING_COLOR
	vColor.xyz *= instanceColor.xyz;
#endif
#ifdef USE_BATCHING_COLOR
	vec3 batchingColor = getBatchingColor( getIndirectIndex( gl_DrawID ) );
	vColor.xyz *= batchingColor.xyz;
#endif`, R0 = `#define PI 3.141592653589793
#define PI2 6.283185307179586
#define PI_HALF 1.5707963267948966
#define RECIPROCAL_PI 0.3183098861837907
#define RECIPROCAL_PI2 0.15915494309189535
#define EPSILON 1e-6
#ifndef saturate
#define saturate( a ) clamp( a, 0.0, 1.0 )
#endif
#define whiteComplement( a ) ( 1.0 - saturate( a ) )
float pow2( const in float x ) { return x*x; }
vec3 pow2( const in vec3 x ) { return x*x; }
float pow3( const in float x ) { return x*x*x; }
float pow4( const in float x ) { float x2 = x*x; return x2*x2; }
float max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }
float average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }
highp float rand( const in vec2 uv ) {
	const highp float a = 12.9898, b = 78.233, c = 43758.5453;
	highp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );
	return fract( sin( sn ) * c );
}
#ifdef HIGH_PRECISION
	float precisionSafeLength( vec3 v ) { return length( v ); }
#else
	float precisionSafeLength( vec3 v ) {
		float maxComponent = max3( abs( v ) );
		return length( v / maxComponent ) * maxComponent;
	}
#endif
struct IncidentLight {
	vec3 color;
	vec3 direction;
	bool visible;
};
struct ReflectedLight {
	vec3 directDiffuse;
	vec3 directSpecular;
	vec3 indirectDiffuse;
	vec3 indirectSpecular;
};
#ifdef USE_ALPHAHASH
	varying vec3 vPosition;
#endif
vec3 transformDirection( in vec3 dir, in mat4 matrix ) {
	return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );
}
vec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {
	return normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );
}
bool isPerspectiveMatrix( mat4 m ) {
	return m[ 2 ][ 3 ] == - 1.0;
}
vec2 equirectUv( in vec3 dir ) {
	float u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;
	float v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;
	return vec2( u, v );
}
vec3 BRDF_Lambert( const in vec3 diffuseColor ) {
	return RECIPROCAL_PI * diffuseColor;
}
vec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {
	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );
	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );
}
float F_Schlick( const in float f0, const in float f90, const in float dotVH ) {
	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );
	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );
} // validated`, C0 = `#ifdef ENVMAP_TYPE_CUBE_UV
	#define cubeUV_minMipLevel 4.0
	#define cubeUV_minTileSize 16.0
	float getFace( vec3 direction ) {
		vec3 absDirection = abs( direction );
		float face = - 1.0;
		if ( absDirection.x > absDirection.z ) {
			if ( absDirection.x > absDirection.y )
				face = direction.x > 0.0 ? 0.0 : 3.0;
			else
				face = direction.y > 0.0 ? 1.0 : 4.0;
		} else {
			if ( absDirection.z > absDirection.y )
				face = direction.z > 0.0 ? 2.0 : 5.0;
			else
				face = direction.y > 0.0 ? 1.0 : 4.0;
		}
		return face;
	}
	vec2 getUV( vec3 direction, float face ) {
		vec2 uv;
		if ( face == 0.0 ) {
			uv = vec2( direction.z, direction.y ) / abs( direction.x );
		} else if ( face == 1.0 ) {
			uv = vec2( - direction.x, - direction.z ) / abs( direction.y );
		} else if ( face == 2.0 ) {
			uv = vec2( - direction.x, direction.y ) / abs( direction.z );
		} else if ( face == 3.0 ) {
			uv = vec2( - direction.z, direction.y ) / abs( direction.x );
		} else if ( face == 4.0 ) {
			uv = vec2( - direction.x, direction.z ) / abs( direction.y );
		} else {
			uv = vec2( direction.x, direction.y ) / abs( direction.z );
		}
		return 0.5 * ( uv + 1.0 );
	}
	vec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {
		float face = getFace( direction );
		float filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );
		mipInt = max( mipInt, cubeUV_minMipLevel );
		float faceSize = exp2( mipInt );
		highp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;
		if ( face > 2.0 ) {
			uv.y += faceSize;
			face -= 3.0;
		}
		uv.x += face * faceSize;
		uv.x += filterInt * 3.0 * cubeUV_minTileSize;
		uv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );
		uv.x *= CUBEUV_TEXEL_WIDTH;
		uv.y *= CUBEUV_TEXEL_HEIGHT;
		#ifdef texture2DGradEXT
			return texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;
		#else
			return texture2D( envMap, uv ).rgb;
		#endif
	}
	#define cubeUV_r0 1.0
	#define cubeUV_m0 - 2.0
	#define cubeUV_r1 0.8
	#define cubeUV_m1 - 1.0
	#define cubeUV_r4 0.4
	#define cubeUV_m4 2.0
	#define cubeUV_r5 0.305
	#define cubeUV_m5 3.0
	#define cubeUV_r6 0.21
	#define cubeUV_m6 4.0
	float roughnessToMip( float roughness ) {
		float mip = 0.0;
		if ( roughness >= cubeUV_r1 ) {
			mip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;
		} else if ( roughness >= cubeUV_r4 ) {
			mip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;
		} else if ( roughness >= cubeUV_r5 ) {
			mip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;
		} else if ( roughness >= cubeUV_r6 ) {
			mip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;
		} else {
			mip = - 2.0 * log2( 1.16 * roughness );		}
		return mip;
	}
	vec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {
		float mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );
		float mipF = fract( mip );
		float mipInt = floor( mip );
		vec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );
		if ( mipF == 0.0 ) {
			return vec4( color0, 1.0 );
		} else {
			vec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );
			return vec4( mix( color0, color1, mipF ), 1.0 );
		}
	}
#endif`, I0 = `vec3 transformedNormal = objectNormal;
#ifdef USE_TANGENT
	vec3 transformedTangent = objectTangent;
#endif
#ifdef USE_BATCHING
	mat3 bm = mat3( batchingMatrix );
	transformedNormal /= vec3( dot( bm[ 0 ], bm[ 0 ] ), dot( bm[ 1 ], bm[ 1 ] ), dot( bm[ 2 ], bm[ 2 ] ) );
	transformedNormal = bm * transformedNormal;
	#ifdef USE_TANGENT
		transformedTangent = bm * transformedTangent;
	#endif
#endif
#ifdef USE_INSTANCING
	mat3 im = mat3( instanceMatrix );
	transformedNormal /= vec3( dot( im[ 0 ], im[ 0 ] ), dot( im[ 1 ], im[ 1 ] ), dot( im[ 2 ], im[ 2 ] ) );
	transformedNormal = im * transformedNormal;
	#ifdef USE_TANGENT
		transformedTangent = im * transformedTangent;
	#endif
#endif
transformedNormal = normalMatrix * transformedNormal;
#ifdef FLIP_SIDED
	transformedNormal = - transformedNormal;
#endif
#ifdef USE_TANGENT
	transformedTangent = ( modelViewMatrix * vec4( transformedTangent, 0.0 ) ).xyz;
	#ifdef FLIP_SIDED
		transformedTangent = - transformedTangent;
	#endif
#endif`, P0 = `#ifdef USE_DISPLACEMENTMAP
	uniform sampler2D displacementMap;
	uniform float displacementScale;
	uniform float displacementBias;
#endif`, L0 = `#ifdef USE_DISPLACEMENTMAP
	transformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );
#endif`, D0 = `#ifdef USE_EMISSIVEMAP
	vec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );
	#ifdef DECODE_VIDEO_TEXTURE_EMISSIVE
		emissiveColor = sRGBTransferEOTF( emissiveColor );
	#endif
	totalEmissiveRadiance *= emissiveColor.rgb;
#endif`, N0 = `#ifdef USE_EMISSIVEMAP
	uniform sampler2D emissiveMap;
#endif`, O0 = "gl_FragColor = linearToOutputTexel( gl_FragColor );", U0 = `vec4 LinearTransferOETF( in vec4 value ) {
	return value;
}
vec4 sRGBTransferEOTF( in vec4 value ) {
	return vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.a );
}
vec4 sRGBTransferOETF( in vec4 value ) {
	return vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );
}`, F0 = `#ifdef USE_ENVMAP
	#ifdef ENV_WORLDPOS
		vec3 cameraToFrag;
		if ( isOrthographic ) {
			cameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );
		} else {
			cameraToFrag = normalize( vWorldPosition - cameraPosition );
		}
		vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
		#ifdef ENVMAP_MODE_REFLECTION
			vec3 reflectVec = reflect( cameraToFrag, worldNormal );
		#else
			vec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );
		#endif
	#else
		vec3 reflectVec = vReflect;
	#endif
	#ifdef ENVMAP_TYPE_CUBE
		vec4 envColor = textureCube( envMap, envMapRotation * vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );
	#else
		vec4 envColor = vec4( 0.0 );
	#endif
	#ifdef ENVMAP_BLENDING_MULTIPLY
		outgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );
	#elif defined( ENVMAP_BLENDING_MIX )
		outgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );
	#elif defined( ENVMAP_BLENDING_ADD )
		outgoingLight += envColor.xyz * specularStrength * reflectivity;
	#endif
#endif`, B0 = `#ifdef USE_ENVMAP
	uniform float envMapIntensity;
	uniform float flipEnvMap;
	uniform mat3 envMapRotation;
	#ifdef ENVMAP_TYPE_CUBE
		uniform samplerCube envMap;
	#else
		uniform sampler2D envMap;
	#endif
#endif`, k0 = `#ifdef USE_ENVMAP
	uniform float reflectivity;
	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )
		#define ENV_WORLDPOS
	#endif
	#ifdef ENV_WORLDPOS
		varying vec3 vWorldPosition;
		uniform float refractionRatio;
	#else
		varying vec3 vReflect;
	#endif
#endif`, z0 = `#ifdef USE_ENVMAP
	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )
		#define ENV_WORLDPOS
	#endif
	#ifdef ENV_WORLDPOS
		
		varying vec3 vWorldPosition;
	#else
		varying vec3 vReflect;
		uniform float refractionRatio;
	#endif
#endif`, V0 = `#ifdef USE_ENVMAP
	#ifdef ENV_WORLDPOS
		vWorldPosition = worldPosition.xyz;
	#else
		vec3 cameraToVertex;
		if ( isOrthographic ) {
			cameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );
		} else {
			cameraToVertex = normalize( worldPosition.xyz - cameraPosition );
		}
		vec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );
		#ifdef ENVMAP_MODE_REFLECTION
			vReflect = reflect( cameraToVertex, worldNormal );
		#else
			vReflect = refract( cameraToVertex, worldNormal, refractionRatio );
		#endif
	#endif
#endif`, H0 = `#ifdef USE_FOG
	vFogDepth = - mvPosition.z;
#endif`, $0 = `#ifdef USE_FOG
	varying float vFogDepth;
#endif`, G0 = `#ifdef USE_FOG
	#ifdef FOG_EXP2
		float fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );
	#else
		float fogFactor = smoothstep( fogNear, fogFar, vFogDepth );
	#endif
	gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );
#endif`, q0 = `#ifdef USE_FOG
	uniform vec3 fogColor;
	varying float vFogDepth;
	#ifdef FOG_EXP2
		uniform float fogDensity;
	#else
		uniform float fogNear;
		uniform float fogFar;
	#endif
#endif`, W0 = `#ifdef USE_GRADIENTMAP
	uniform sampler2D gradientMap;
#endif
vec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {
	float dotNL = dot( normal, lightDirection );
	vec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );
	#ifdef USE_GRADIENTMAP
		return vec3( texture2D( gradientMap, coord ).r );
	#else
		vec2 fw = fwidth( coord ) * 0.5;
		return mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );
	#endif
}`, X0 = `#ifdef USE_LIGHTMAP
	uniform sampler2D lightMap;
	uniform float lightMapIntensity;
#endif`, j0 = `LambertMaterial material;
material.diffuseColor = diffuseColor.rgb;
material.specularStrength = specularStrength;`, Y0 = `varying vec3 vViewPosition;
struct LambertMaterial {
	vec3 diffuseColor;
	float specularStrength;
};
void RE_Direct_Lambert( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_Lambert
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Lambert`, K0 = `uniform bool receiveShadow;
uniform vec3 ambientLightColor;
#if defined( USE_LIGHT_PROBES )
	uniform vec3 lightProbe[ 9 ];
#endif
vec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {
	float x = normal.x, y = normal.y, z = normal.z;
	vec3 result = shCoefficients[ 0 ] * 0.886227;
	result += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;
	result += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;
	result += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;
	result += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;
	result += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;
	result += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );
	result += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;
	result += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );
	return result;
}
vec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {
	vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
	vec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );
	return irradiance;
}
vec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {
	vec3 irradiance = ambientLightColor;
	return irradiance;
}
float getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {
	float distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );
	if ( cutoffDistance > 0.0 ) {
		distanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );
	}
	return distanceFalloff;
}
float getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {
	return smoothstep( coneCosine, penumbraCosine, angleCosine );
}
#if NUM_DIR_LIGHTS > 0
	struct DirectionalLight {
		vec3 direction;
		vec3 color;
	};
	uniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];
	void getDirectionalLightInfo( const in DirectionalLight directionalLight, out IncidentLight light ) {
		light.color = directionalLight.color;
		light.direction = directionalLight.direction;
		light.visible = true;
	}
#endif
#if NUM_POINT_LIGHTS > 0
	struct PointLight {
		vec3 position;
		vec3 color;
		float distance;
		float decay;
	};
	uniform PointLight pointLights[ NUM_POINT_LIGHTS ];
	void getPointLightInfo( const in PointLight pointLight, const in vec3 geometryPosition, out IncidentLight light ) {
		vec3 lVector = pointLight.position - geometryPosition;
		light.direction = normalize( lVector );
		float lightDistance = length( lVector );
		light.color = pointLight.color;
		light.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );
		light.visible = ( light.color != vec3( 0.0 ) );
	}
#endif
#if NUM_SPOT_LIGHTS > 0
	struct SpotLight {
		vec3 position;
		vec3 direction;
		vec3 color;
		float distance;
		float decay;
		float coneCos;
		float penumbraCos;
	};
	uniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];
	void getSpotLightInfo( const in SpotLight spotLight, const in vec3 geometryPosition, out IncidentLight light ) {
		vec3 lVector = spotLight.position - geometryPosition;
		light.direction = normalize( lVector );
		float angleCos = dot( light.direction, spotLight.direction );
		float spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );
		if ( spotAttenuation > 0.0 ) {
			float lightDistance = length( lVector );
			light.color = spotLight.color * spotAttenuation;
			light.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );
			light.visible = ( light.color != vec3( 0.0 ) );
		} else {
			light.color = vec3( 0.0 );
			light.visible = false;
		}
	}
#endif
#if NUM_RECT_AREA_LIGHTS > 0
	struct RectAreaLight {
		vec3 color;
		vec3 position;
		vec3 halfWidth;
		vec3 halfHeight;
	};
	uniform sampler2D ltc_1;	uniform sampler2D ltc_2;
	uniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];
#endif
#if NUM_HEMI_LIGHTS > 0
	struct HemisphereLight {
		vec3 direction;
		vec3 skyColor;
		vec3 groundColor;
	};
	uniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];
	vec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {
		float dotNL = dot( normal, hemiLight.direction );
		float hemiDiffuseWeight = 0.5 * dotNL + 0.5;
		vec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );
		return irradiance;
	}
#endif`, Z0 = `#ifdef USE_ENVMAP
	vec3 getIBLIrradiance( const in vec3 normal ) {
		#ifdef ENVMAP_TYPE_CUBE_UV
			vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
			vec4 envMapColor = textureCubeUV( envMap, envMapRotation * worldNormal, 1.0 );
			return PI * envMapColor.rgb * envMapIntensity;
		#else
			return vec3( 0.0 );
		#endif
	}
	vec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {
		#ifdef ENVMAP_TYPE_CUBE_UV
			vec3 reflectVec = reflect( - viewDir, normal );
			reflectVec = normalize( mix( reflectVec, normal, pow4( roughness ) ) );
			reflectVec = inverseTransformDirection( reflectVec, viewMatrix );
			vec4 envMapColor = textureCubeUV( envMap, envMapRotation * reflectVec, roughness );
			return envMapColor.rgb * envMapIntensity;
		#else
			return vec3( 0.0 );
		#endif
	}
	#ifdef USE_ANISOTROPY
		vec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {
			#ifdef ENVMAP_TYPE_CUBE_UV
				vec3 bentNormal = cross( bitangent, viewDir );
				bentNormal = normalize( cross( bentNormal, bitangent ) );
				bentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );
				return getIBLRadiance( viewDir, bentNormal, roughness );
			#else
				return vec3( 0.0 );
			#endif
		}
	#endif
#endif`, J0 = `ToonMaterial material;
material.diffuseColor = diffuseColor.rgb;`, Q0 = `varying vec3 vViewPosition;
struct ToonMaterial {
	vec3 diffuseColor;
};
void RE_Direct_Toon( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {
	vec3 irradiance = getGradientIrradiance( geometryNormal, directLight.direction ) * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_Toon
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Toon`, ex = `BlinnPhongMaterial material;
material.diffuseColor = diffuseColor.rgb;
material.specularColor = specular;
material.specularShininess = shininess;
material.specularStrength = specularStrength;`, tx = `varying vec3 vViewPosition;
struct BlinnPhongMaterial {
	vec3 diffuseColor;
	vec3 specularColor;
	float specularShininess;
	float specularStrength;
};
void RE_Direct_BlinnPhong( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
	reflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometryViewDir, geometryNormal, material.specularColor, material.specularShininess ) * material.specularStrength;
}
void RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_BlinnPhong
#define RE_IndirectDiffuse		RE_IndirectDiffuse_BlinnPhong`, ix = `PhysicalMaterial material;
material.diffuseColor = diffuseColor.rgb;
material.diffuseContribution = diffuseColor.rgb * ( 1.0 - metalnessFactor );
material.metalness = metalnessFactor;
vec3 dxy = max( abs( dFdx( nonPerturbedNormal ) ), abs( dFdy( nonPerturbedNormal ) ) );
float geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );
material.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;
material.roughness = min( material.roughness, 1.0 );
#ifdef IOR
	material.ior = ior;
	#ifdef USE_SPECULAR
		float specularIntensityFactor = specularIntensity;
		vec3 specularColorFactor = specularColor;
		#ifdef USE_SPECULAR_COLORMAP
			specularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;
		#endif
		#ifdef USE_SPECULAR_INTENSITYMAP
			specularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;
		#endif
		material.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );
	#else
		float specularIntensityFactor = 1.0;
		vec3 specularColorFactor = vec3( 1.0 );
		material.specularF90 = 1.0;
	#endif
	material.specularColor = min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor;
	material.specularColorBlended = mix( material.specularColor, diffuseColor.rgb, metalnessFactor );
#else
	material.specularColor = vec3( 0.04 );
	material.specularColorBlended = mix( material.specularColor, diffuseColor.rgb, metalnessFactor );
	material.specularF90 = 1.0;
#endif
#ifdef USE_CLEARCOAT
	material.clearcoat = clearcoat;
	material.clearcoatRoughness = clearcoatRoughness;
	material.clearcoatF0 = vec3( 0.04 );
	material.clearcoatF90 = 1.0;
	#ifdef USE_CLEARCOATMAP
		material.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;
	#endif
	#ifdef USE_CLEARCOAT_ROUGHNESSMAP
		material.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;
	#endif
	material.clearcoat = saturate( material.clearcoat );	material.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );
	material.clearcoatRoughness += geometryRoughness;
	material.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );
#endif
#ifdef USE_DISPERSION
	material.dispersion = dispersion;
#endif
#ifdef USE_IRIDESCENCE
	material.iridescence = iridescence;
	material.iridescenceIOR = iridescenceIOR;
	#ifdef USE_IRIDESCENCEMAP
		material.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;
	#endif
	#ifdef USE_IRIDESCENCE_THICKNESSMAP
		material.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;
	#else
		material.iridescenceThickness = iridescenceThicknessMaximum;
	#endif
#endif
#ifdef USE_SHEEN
	material.sheenColor = sheenColor;
	#ifdef USE_SHEEN_COLORMAP
		material.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;
	#endif
	material.sheenRoughness = clamp( sheenRoughness, 0.0001, 1.0 );
	#ifdef USE_SHEEN_ROUGHNESSMAP
		material.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;
	#endif
#endif
#ifdef USE_ANISOTROPY
	#ifdef USE_ANISOTROPYMAP
		mat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );
		vec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;
		vec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;
	#else
		vec2 anisotropyV = anisotropyVector;
	#endif
	material.anisotropy = length( anisotropyV );
	if( material.anisotropy == 0.0 ) {
		anisotropyV = vec2( 1.0, 0.0 );
	} else {
		anisotropyV /= material.anisotropy;
		material.anisotropy = saturate( material.anisotropy );
	}
	material.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );
	material.anisotropyT = tbn[ 0 ] * anisotropyV.x + tbn[ 1 ] * anisotropyV.y;
	material.anisotropyB = tbn[ 1 ] * anisotropyV.x - tbn[ 0 ] * anisotropyV.y;
#endif`, nx = `uniform sampler2D dfgLUT;
struct PhysicalMaterial {
	vec3 diffuseColor;
	vec3 diffuseContribution;
	vec3 specularColor;
	vec3 specularColorBlended;
	float roughness;
	float metalness;
	float specularF90;
	float dispersion;
	#ifdef USE_CLEARCOAT
		float clearcoat;
		float clearcoatRoughness;
		vec3 clearcoatF0;
		float clearcoatF90;
	#endif
	#ifdef USE_IRIDESCENCE
		float iridescence;
		float iridescenceIOR;
		float iridescenceThickness;
		vec3 iridescenceFresnel;
		vec3 iridescenceF0;
		vec3 iridescenceFresnelDielectric;
		vec3 iridescenceFresnelMetallic;
	#endif
	#ifdef USE_SHEEN
		vec3 sheenColor;
		float sheenRoughness;
	#endif
	#ifdef IOR
		float ior;
	#endif
	#ifdef USE_TRANSMISSION
		float transmission;
		float transmissionAlpha;
		float thickness;
		float attenuationDistance;
		vec3 attenuationColor;
	#endif
	#ifdef USE_ANISOTROPY
		float anisotropy;
		float alphaT;
		vec3 anisotropyT;
		vec3 anisotropyB;
	#endif
};
vec3 clearcoatSpecularDirect = vec3( 0.0 );
vec3 clearcoatSpecularIndirect = vec3( 0.0 );
vec3 sheenSpecularDirect = vec3( 0.0 );
vec3 sheenSpecularIndirect = vec3(0.0 );
vec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {
    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );
    float x2 = x * x;
    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );
    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );
}
float V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {
	float a2 = pow2( alpha );
	float gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );
	float gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );
	return 0.5 / max( gv + gl, EPSILON );
}
float D_GGX( const in float alpha, const in float dotNH ) {
	float a2 = pow2( alpha );
	float denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;
	return RECIPROCAL_PI * a2 / pow2( denom );
}
#ifdef USE_ANISOTROPY
	float V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {
		float gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );
		float gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );
		float v = 0.5 / ( gv + gl );
		return v;
	}
	float D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {
		float a2 = alphaT * alphaB;
		highp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );
		highp float v2 = dot( v, v );
		float w2 = a2 / v2;
		return RECIPROCAL_PI * a2 * pow2 ( w2 );
	}
#endif
#ifdef USE_CLEARCOAT
	vec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {
		vec3 f0 = material.clearcoatF0;
		float f90 = material.clearcoatF90;
		float roughness = material.clearcoatRoughness;
		float alpha = pow2( roughness );
		vec3 halfDir = normalize( lightDir + viewDir );
		float dotNL = saturate( dot( normal, lightDir ) );
		float dotNV = saturate( dot( normal, viewDir ) );
		float dotNH = saturate( dot( normal, halfDir ) );
		float dotVH = saturate( dot( viewDir, halfDir ) );
		vec3 F = F_Schlick( f0, f90, dotVH );
		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );
		float D = D_GGX( alpha, dotNH );
		return F * ( V * D );
	}
#endif
vec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {
	vec3 f0 = material.specularColorBlended;
	float f90 = material.specularF90;
	float roughness = material.roughness;
	float alpha = pow2( roughness );
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNL = saturate( dot( normal, lightDir ) );
	float dotNV = saturate( dot( normal, viewDir ) );
	float dotNH = saturate( dot( normal, halfDir ) );
	float dotVH = saturate( dot( viewDir, halfDir ) );
	vec3 F = F_Schlick( f0, f90, dotVH );
	#ifdef USE_IRIDESCENCE
		F = mix( F, material.iridescenceFresnel, material.iridescence );
	#endif
	#ifdef USE_ANISOTROPY
		float dotTL = dot( material.anisotropyT, lightDir );
		float dotTV = dot( material.anisotropyT, viewDir );
		float dotTH = dot( material.anisotropyT, halfDir );
		float dotBL = dot( material.anisotropyB, lightDir );
		float dotBV = dot( material.anisotropyB, viewDir );
		float dotBH = dot( material.anisotropyB, halfDir );
		float V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );
		float D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );
	#else
		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );
		float D = D_GGX( alpha, dotNH );
	#endif
	return F * ( V * D );
}
vec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {
	const float LUT_SIZE = 64.0;
	const float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;
	const float LUT_BIAS = 0.5 / LUT_SIZE;
	float dotNV = saturate( dot( N, V ) );
	vec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );
	uv = uv * LUT_SCALE + LUT_BIAS;
	return uv;
}
float LTC_ClippedSphereFormFactor( const in vec3 f ) {
	float l = length( f );
	return max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );
}
vec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {
	float x = dot( v1, v2 );
	float y = abs( x );
	float a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;
	float b = 3.4175940 + ( 4.1616724 + y ) * y;
	float v = a / b;
	float theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;
	return cross( v1, v2 ) * theta_sintheta;
}
vec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {
	vec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];
	vec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];
	vec3 lightNormal = cross( v1, v2 );
	if( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );
	vec3 T1, T2;
	T1 = normalize( V - N * dot( V, N ) );
	T2 = - cross( N, T1 );
	mat3 mat = mInv * transpose( mat3( T1, T2, N ) );
	vec3 coords[ 4 ];
	coords[ 0 ] = mat * ( rectCoords[ 0 ] - P );
	coords[ 1 ] = mat * ( rectCoords[ 1 ] - P );
	coords[ 2 ] = mat * ( rectCoords[ 2 ] - P );
	coords[ 3 ] = mat * ( rectCoords[ 3 ] - P );
	coords[ 0 ] = normalize( coords[ 0 ] );
	coords[ 1 ] = normalize( coords[ 1 ] );
	coords[ 2 ] = normalize( coords[ 2 ] );
	coords[ 3 ] = normalize( coords[ 3 ] );
	vec3 vectorFormFactor = vec3( 0.0 );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );
	float result = LTC_ClippedSphereFormFactor( vectorFormFactor );
	return vec3( result );
}
#if defined( USE_SHEEN )
float D_Charlie( float roughness, float dotNH ) {
	float alpha = pow2( roughness );
	float invAlpha = 1.0 / alpha;
	float cos2h = dotNH * dotNH;
	float sin2h = max( 1.0 - cos2h, 0.0078125 );
	return ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );
}
float V_Neubelt( float dotNV, float dotNL ) {
	return saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );
}
vec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNL = saturate( dot( normal, lightDir ) );
	float dotNV = saturate( dot( normal, viewDir ) );
	float dotNH = saturate( dot( normal, halfDir ) );
	float D = D_Charlie( sheenRoughness, dotNH );
	float V = V_Neubelt( dotNV, dotNL );
	return sheenColor * ( D * V );
}
#endif
float IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {
	float dotNV = saturate( dot( normal, viewDir ) );
	float r2 = roughness * roughness;
	float rInv = 1.0 / ( roughness + 0.1 );
	float a = -1.9362 + 1.0678 * roughness + 0.4573 * r2 - 0.8469 * rInv;
	float b = -0.6014 + 0.5538 * roughness - 0.4670 * r2 - 0.1255 * rInv;
	float DG = exp( a * dotNV + b );
	return saturate( DG );
}
vec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {
	float dotNV = saturate( dot( normal, viewDir ) );
	vec2 fab = texture2D( dfgLUT, vec2( roughness, dotNV ) ).rg;
	return specularColor * fab.x + specularF90 * fab.y;
}
#ifdef USE_IRIDESCENCE
void computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {
#else
void computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {
#endif
	float dotNV = saturate( dot( normal, viewDir ) );
	vec2 fab = texture2D( dfgLUT, vec2( roughness, dotNV ) ).rg;
	#ifdef USE_IRIDESCENCE
		vec3 Fr = mix( specularColor, iridescenceF0, iridescence );
	#else
		vec3 Fr = specularColor;
	#endif
	vec3 FssEss = Fr * fab.x + specularF90 * fab.y;
	float Ess = fab.x + fab.y;
	float Ems = 1.0 - Ess;
	vec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;	vec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );
	singleScatter += FssEss;
	multiScatter += Fms * Ems;
}
vec3 BRDF_GGX_Multiscatter( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {
	vec3 singleScatter = BRDF_GGX( lightDir, viewDir, normal, material );
	float dotNL = saturate( dot( normal, lightDir ) );
	float dotNV = saturate( dot( normal, viewDir ) );
	vec2 dfgV = texture2D( dfgLUT, vec2( material.roughness, dotNV ) ).rg;
	vec2 dfgL = texture2D( dfgLUT, vec2( material.roughness, dotNL ) ).rg;
	vec3 FssEss_V = material.specularColorBlended * dfgV.x + material.specularF90 * dfgV.y;
	vec3 FssEss_L = material.specularColorBlended * dfgL.x + material.specularF90 * dfgL.y;
	float Ess_V = dfgV.x + dfgV.y;
	float Ess_L = dfgL.x + dfgL.y;
	float Ems_V = 1.0 - Ess_V;
	float Ems_L = 1.0 - Ess_L;
	vec3 Favg = material.specularColorBlended + ( 1.0 - material.specularColorBlended ) * 0.047619;
	vec3 Fms = FssEss_V * FssEss_L * Favg / ( 1.0 - Ems_V * Ems_L * Favg + EPSILON );
	float compensationFactor = Ems_V * Ems_L;
	vec3 multiScatter = Fms * compensationFactor;
	return singleScatter + multiScatter;
}
#if NUM_RECT_AREA_LIGHTS > 0
	void RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
		vec3 normal = geometryNormal;
		vec3 viewDir = geometryViewDir;
		vec3 position = geometryPosition;
		vec3 lightPos = rectAreaLight.position;
		vec3 halfWidth = rectAreaLight.halfWidth;
		vec3 halfHeight = rectAreaLight.halfHeight;
		vec3 lightColor = rectAreaLight.color;
		float roughness = material.roughness;
		vec3 rectCoords[ 4 ];
		rectCoords[ 0 ] = lightPos + halfWidth - halfHeight;		rectCoords[ 1 ] = lightPos - halfWidth - halfHeight;
		rectCoords[ 2 ] = lightPos - halfWidth + halfHeight;
		rectCoords[ 3 ] = lightPos + halfWidth + halfHeight;
		vec2 uv = LTC_Uv( normal, viewDir, roughness );
		vec4 t1 = texture2D( ltc_1, uv );
		vec4 t2 = texture2D( ltc_2, uv );
		mat3 mInv = mat3(
			vec3( t1.x, 0, t1.y ),
			vec3(    0, 1,    0 ),
			vec3( t1.z, 0, t1.w )
		);
		vec3 fresnel = ( material.specularColorBlended * t2.x + ( vec3( 1.0 ) - material.specularColorBlended ) * t2.y );
		reflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );
		reflectedLight.directDiffuse += lightColor * material.diffuseContribution * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );
	}
#endif
void RE_Direct_Physical( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	#ifdef USE_CLEARCOAT
		float dotNLcc = saturate( dot( geometryClearcoatNormal, directLight.direction ) );
		vec3 ccIrradiance = dotNLcc * directLight.color;
		clearcoatSpecularDirect += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometryViewDir, geometryClearcoatNormal, material );
	#endif
	#ifdef USE_SHEEN
 
 		sheenSpecularDirect += irradiance * BRDF_Sheen( directLight.direction, geometryViewDir, geometryNormal, material.sheenColor, material.sheenRoughness );
 
 		float sheenAlbedoV = IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );
 		float sheenAlbedoL = IBLSheenBRDF( geometryNormal, directLight.direction, material.sheenRoughness );
 
 		float sheenEnergyComp = 1.0 - max3( material.sheenColor ) * max( sheenAlbedoV, sheenAlbedoL );
 
 		irradiance *= sheenEnergyComp;
 
 	#endif
	reflectedLight.directSpecular += irradiance * BRDF_GGX_Multiscatter( directLight.direction, geometryViewDir, geometryNormal, material );
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseContribution );
}
void RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
	vec3 diffuse = irradiance * BRDF_Lambert( material.diffuseContribution );
	#ifdef USE_SHEEN
		float sheenAlbedo = IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );
		float sheenEnergyComp = 1.0 - max3( material.sheenColor ) * sheenAlbedo;
		diffuse *= sheenEnergyComp;
	#endif
	reflectedLight.indirectDiffuse += diffuse;
}
void RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {
	#ifdef USE_CLEARCOAT
		clearcoatSpecularIndirect += clearcoatRadiance * EnvironmentBRDF( geometryClearcoatNormal, geometryViewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );
	#endif
	#ifdef USE_SHEEN
		sheenSpecularIndirect += irradiance * material.sheenColor * IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness ) * RECIPROCAL_PI;
 	#endif
	vec3 singleScatteringDielectric = vec3( 0.0 );
	vec3 multiScatteringDielectric = vec3( 0.0 );
	vec3 singleScatteringMetallic = vec3( 0.0 );
	vec3 multiScatteringMetallic = vec3( 0.0 );
	#ifdef USE_IRIDESCENCE
		computeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnelDielectric, material.roughness, singleScatteringDielectric, multiScatteringDielectric );
		computeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.diffuseColor, material.specularF90, material.iridescence, material.iridescenceFresnelMetallic, material.roughness, singleScatteringMetallic, multiScatteringMetallic );
	#else
		computeMultiscattering( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.roughness, singleScatteringDielectric, multiScatteringDielectric );
		computeMultiscattering( geometryNormal, geometryViewDir, material.diffuseColor, material.specularF90, material.roughness, singleScatteringMetallic, multiScatteringMetallic );
	#endif
	vec3 singleScattering = mix( singleScatteringDielectric, singleScatteringMetallic, material.metalness );
	vec3 multiScattering = mix( multiScatteringDielectric, multiScatteringMetallic, material.metalness );
	vec3 totalScatteringDielectric = singleScatteringDielectric + multiScatteringDielectric;
	vec3 diffuse = material.diffuseContribution * ( 1.0 - totalScatteringDielectric );
	vec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;
	vec3 indirectSpecular = radiance * singleScattering;
	indirectSpecular += multiScattering * cosineWeightedIrradiance;
	vec3 indirectDiffuse = diffuse * cosineWeightedIrradiance;
	#ifdef USE_SHEEN
		float sheenAlbedo = IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );
		float sheenEnergyComp = 1.0 - max3( material.sheenColor ) * sheenAlbedo;
		indirectSpecular *= sheenEnergyComp;
		indirectDiffuse *= sheenEnergyComp;
	#endif
	reflectedLight.indirectSpecular += indirectSpecular;
	reflectedLight.indirectDiffuse += indirectDiffuse;
}
#define RE_Direct				RE_Direct_Physical
#define RE_Direct_RectArea		RE_Direct_RectArea_Physical
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Physical
#define RE_IndirectSpecular		RE_IndirectSpecular_Physical
float computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {
	return saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );
}`, sx = `
vec3 geometryPosition = - vViewPosition;
vec3 geometryNormal = normal;
vec3 geometryViewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );
vec3 geometryClearcoatNormal = vec3( 0.0 );
#ifdef USE_CLEARCOAT
	geometryClearcoatNormal = clearcoatNormal;
#endif
#ifdef USE_IRIDESCENCE
	float dotNVi = saturate( dot( normal, geometryViewDir ) );
	if ( material.iridescenceThickness == 0.0 ) {
		material.iridescence = 0.0;
	} else {
		material.iridescence = saturate( material.iridescence );
	}
	if ( material.iridescence > 0.0 ) {
		material.iridescenceFresnelDielectric = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );
		material.iridescenceFresnelMetallic = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.diffuseColor );
		material.iridescenceFresnel = mix( material.iridescenceFresnelDielectric, material.iridescenceFresnelMetallic, material.metalness );
		material.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );
	}
#endif
IncidentLight directLight;
#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )
	PointLight pointLight;
	#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0
	PointLightShadow pointLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {
		pointLight = pointLights[ i ];
		getPointLightInfo( pointLight, geometryPosition, directLight );
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS ) && ( defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_BASIC ) )
		pointLightShadow = pointLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowIntensity, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;
		#endif
		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )
	SpotLight spotLight;
	vec4 spotColor;
	vec3 spotLightCoord;
	bool inSpotLightMap;
	#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0
	SpotLightShadow spotLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {
		spotLight = spotLights[ i ];
		getSpotLightInfo( spotLight, geometryPosition, directLight );
		#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )
		#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX
		#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
		#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS
		#else
		#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )
		#endif
		#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )
			spotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;
			inSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );
			spotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );
			directLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;
		#endif
		#undef SPOT_LIGHT_MAP_INDEX
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
		spotLightShadow = spotLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowIntensity, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;
		#endif
		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )
	DirectionalLight directionalLight;
	#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0
	DirectionalLightShadow directionalLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {
		directionalLight = directionalLights[ i ];
		getDirectionalLightInfo( directionalLight, directLight );
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )
		directionalLightShadow = directionalLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowIntensity, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;
		#endif
		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )
	RectAreaLight rectAreaLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {
		rectAreaLight = rectAreaLights[ i ];
		RE_Direct_RectArea( rectAreaLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if defined( RE_IndirectDiffuse )
	vec3 iblIrradiance = vec3( 0.0 );
	vec3 irradiance = getAmbientLightIrradiance( ambientLightColor );
	#if defined( USE_LIGHT_PROBES )
		irradiance += getLightProbeIrradiance( lightProbe, geometryNormal );
	#endif
	#if ( NUM_HEMI_LIGHTS > 0 )
		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {
			irradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometryNormal );
		}
		#pragma unroll_loop_end
	#endif
#endif
#if defined( RE_IndirectSpecular )
	vec3 radiance = vec3( 0.0 );
	vec3 clearcoatRadiance = vec3( 0.0 );
#endif`, rx = `#if defined( RE_IndirectDiffuse )
	#ifdef USE_LIGHTMAP
		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );
		vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;
		irradiance += lightMapIrradiance;
	#endif
	#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )
		iblIrradiance += getIBLIrradiance( geometryNormal );
	#endif
#endif
#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )
	#ifdef USE_ANISOTROPY
		radiance += getIBLAnisotropyRadiance( geometryViewDir, geometryNormal, material.roughness, material.anisotropyB, material.anisotropy );
	#else
		radiance += getIBLRadiance( geometryViewDir, geometryNormal, material.roughness );
	#endif
	#ifdef USE_CLEARCOAT
		clearcoatRadiance += getIBLRadiance( geometryViewDir, geometryClearcoatNormal, material.clearcoatRoughness );
	#endif
#endif`, ax = `#if defined( RE_IndirectDiffuse )
	RE_IndirectDiffuse( irradiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
#endif
#if defined( RE_IndirectSpecular )
	RE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
#endif`, ox = `#if defined( USE_LOGARITHMIC_DEPTH_BUFFER )
	gl_FragDepth = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;
#endif`, lx = `#if defined( USE_LOGARITHMIC_DEPTH_BUFFER )
	uniform float logDepthBufFC;
	varying float vFragDepth;
	varying float vIsPerspective;
#endif`, cx = `#ifdef USE_LOGARITHMIC_DEPTH_BUFFER
	varying float vFragDepth;
	varying float vIsPerspective;
#endif`, hx = `#ifdef USE_LOGARITHMIC_DEPTH_BUFFER
	vFragDepth = 1.0 + gl_Position.w;
	vIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );
#endif`, dx = `#ifdef USE_MAP
	vec4 sampledDiffuseColor = texture2D( map, vMapUv );
	#ifdef DECODE_VIDEO_TEXTURE
		sampledDiffuseColor = sRGBTransferEOTF( sampledDiffuseColor );
	#endif
	diffuseColor *= sampledDiffuseColor;
#endif`, ux = `#ifdef USE_MAP
	uniform sampler2D map;
#endif`, fx = `#if defined( USE_MAP ) || defined( USE_ALPHAMAP )
	#if defined( USE_POINTS_UV )
		vec2 uv = vUv;
	#else
		vec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;
	#endif
#endif
#ifdef USE_MAP
	diffuseColor *= texture2D( map, uv );
#endif
#ifdef USE_ALPHAMAP
	diffuseColor.a *= texture2D( alphaMap, uv ).g;
#endif`, px = `#if defined( USE_POINTS_UV )
	varying vec2 vUv;
#else
	#if defined( USE_MAP ) || defined( USE_ALPHAMAP )
		uniform mat3 uvTransform;
	#endif
#endif
#ifdef USE_MAP
	uniform sampler2D map;
#endif
#ifdef USE_ALPHAMAP
	uniform sampler2D alphaMap;
#endif`, mx = `float metalnessFactor = metalness;
#ifdef USE_METALNESSMAP
	vec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );
	metalnessFactor *= texelMetalness.b;
#endif`, gx = `#ifdef USE_METALNESSMAP
	uniform sampler2D metalnessMap;
#endif`, vx = `#ifdef USE_INSTANCING_MORPH
	float morphTargetInfluences[ MORPHTARGETS_COUNT ];
	float morphTargetBaseInfluence = texelFetch( morphTexture, ivec2( 0, gl_InstanceID ), 0 ).r;
	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
		morphTargetInfluences[i] =  texelFetch( morphTexture, ivec2( i + 1, gl_InstanceID ), 0 ).r;
	}
#endif`, _x = `#if defined( USE_MORPHCOLORS )
	vColor *= morphTargetBaseInfluence;
	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
		#if defined( USE_COLOR_ALPHA )
			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];
		#elif defined( USE_COLOR )
			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];
		#endif
	}
#endif`, xx = `#ifdef USE_MORPHNORMALS
	objectNormal *= morphTargetBaseInfluence;
	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
		if ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];
	}
#endif`, yx = `#ifdef USE_MORPHTARGETS
	#ifndef USE_INSTANCING_MORPH
		uniform float morphTargetBaseInfluence;
		uniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];
	#endif
	uniform sampler2DArray morphTargetsTexture;
	uniform ivec2 morphTargetsTextureSize;
	vec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {
		int texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;
		int y = texelIndex / morphTargetsTextureSize.x;
		int x = texelIndex - y * morphTargetsTextureSize.x;
		ivec3 morphUV = ivec3( x, y, morphTargetIndex );
		return texelFetch( morphTargetsTexture, morphUV, 0 );
	}
#endif`, bx = `#ifdef USE_MORPHTARGETS
	transformed *= morphTargetBaseInfluence;
	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
		if ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];
	}
#endif`, wx = `float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;
#ifdef FLAT_SHADED
	vec3 fdx = dFdx( vViewPosition );
	vec3 fdy = dFdy( vViewPosition );
	vec3 normal = normalize( cross( fdx, fdy ) );
#else
	vec3 normal = normalize( vNormal );
	#ifdef DOUBLE_SIDED
		normal *= faceDirection;
	#endif
#endif
#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )
	#ifdef USE_TANGENT
		mat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );
	#else
		mat3 tbn = getTangentFrame( - vViewPosition, normal,
		#if defined( USE_NORMALMAP )
			vNormalMapUv
		#elif defined( USE_CLEARCOAT_NORMALMAP )
			vClearcoatNormalMapUv
		#else
			vUv
		#endif
		);
	#endif
	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )
		tbn[0] *= faceDirection;
		tbn[1] *= faceDirection;
	#endif
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	#ifdef USE_TANGENT
		mat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );
	#else
		mat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );
	#endif
	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )
		tbn2[0] *= faceDirection;
		tbn2[1] *= faceDirection;
	#endif
#endif
vec3 nonPerturbedNormal = normal;`, Sx = `#ifdef USE_NORMALMAP_OBJECTSPACE
	normal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;
	#ifdef FLIP_SIDED
		normal = - normal;
	#endif
	#ifdef DOUBLE_SIDED
		normal = normal * faceDirection;
	#endif
	normal = normalize( normalMatrix * normal );
#elif defined( USE_NORMALMAP_TANGENTSPACE )
	vec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;
	mapN.xy *= normalScale;
	normal = normalize( tbn * mapN );
#elif defined( USE_BUMPMAP )
	normal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );
#endif`, Mx = `#ifndef FLAT_SHADED
	varying vec3 vNormal;
	#ifdef USE_TANGENT
		varying vec3 vTangent;
		varying vec3 vBitangent;
	#endif
#endif`, Tx = `#ifndef FLAT_SHADED
	varying vec3 vNormal;
	#ifdef USE_TANGENT
		varying vec3 vTangent;
		varying vec3 vBitangent;
	#endif
#endif`, Ex = `#ifndef FLAT_SHADED
	vNormal = normalize( transformedNormal );
	#ifdef USE_TANGENT
		vTangent = normalize( transformedTangent );
		vBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );
	#endif
#endif`, Ax = `#ifdef USE_NORMALMAP
	uniform sampler2D normalMap;
	uniform vec2 normalScale;
#endif
#ifdef USE_NORMALMAP_OBJECTSPACE
	uniform mat3 normalMatrix;
#endif
#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )
	mat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {
		vec3 q0 = dFdx( eye_pos.xyz );
		vec3 q1 = dFdy( eye_pos.xyz );
		vec2 st0 = dFdx( uv.st );
		vec2 st1 = dFdy( uv.st );
		vec3 N = surf_norm;
		vec3 q1perp = cross( q1, N );
		vec3 q0perp = cross( N, q0 );
		vec3 T = q1perp * st0.x + q0perp * st1.x;
		vec3 B = q1perp * st0.y + q0perp * st1.y;
		float det = max( dot( T, T ), dot( B, B ) );
		float scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );
		return mat3( T * scale, B * scale, N );
	}
#endif`, Rx = `#ifdef USE_CLEARCOAT
	vec3 clearcoatNormal = nonPerturbedNormal;
#endif`, Cx = `#ifdef USE_CLEARCOAT_NORMALMAP
	vec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;
	clearcoatMapN.xy *= clearcoatNormalScale;
	clearcoatNormal = normalize( tbn2 * clearcoatMapN );
#endif`, Ix = `#ifdef USE_CLEARCOATMAP
	uniform sampler2D clearcoatMap;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	uniform sampler2D clearcoatNormalMap;
	uniform vec2 clearcoatNormalScale;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	uniform sampler2D clearcoatRoughnessMap;
#endif`, Px = `#ifdef USE_IRIDESCENCEMAP
	uniform sampler2D iridescenceMap;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	uniform sampler2D iridescenceThicknessMap;
#endif`, Lx = `#ifdef OPAQUE
diffuseColor.a = 1.0;
#endif
#ifdef USE_TRANSMISSION
diffuseColor.a *= material.transmissionAlpha;
#endif
gl_FragColor = vec4( outgoingLight, diffuseColor.a );`, Dx = `vec3 packNormalToRGB( const in vec3 normal ) {
	return normalize( normal ) * 0.5 + 0.5;
}
vec3 unpackRGBToNormal( const in vec3 rgb ) {
	return 2.0 * rgb.xyz - 1.0;
}
const float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;const float ShiftRight8 = 1. / 256.;
const float Inv255 = 1. / 255.;
const vec4 PackFactors = vec4( 1.0, 256.0, 256.0 * 256.0, 256.0 * 256.0 * 256.0 );
const vec2 UnpackFactors2 = vec2( UnpackDownscale, 1.0 / PackFactors.g );
const vec3 UnpackFactors3 = vec3( UnpackDownscale / PackFactors.rg, 1.0 / PackFactors.b );
const vec4 UnpackFactors4 = vec4( UnpackDownscale / PackFactors.rgb, 1.0 / PackFactors.a );
vec4 packDepthToRGBA( const in float v ) {
	if( v <= 0.0 )
		return vec4( 0., 0., 0., 0. );
	if( v >= 1.0 )
		return vec4( 1., 1., 1., 1. );
	float vuf;
	float af = modf( v * PackFactors.a, vuf );
	float bf = modf( vuf * ShiftRight8, vuf );
	float gf = modf( vuf * ShiftRight8, vuf );
	return vec4( vuf * Inv255, gf * PackUpscale, bf * PackUpscale, af );
}
vec3 packDepthToRGB( const in float v ) {
	if( v <= 0.0 )
		return vec3( 0., 0., 0. );
	if( v >= 1.0 )
		return vec3( 1., 1., 1. );
	float vuf;
	float bf = modf( v * PackFactors.b, vuf );
	float gf = modf( vuf * ShiftRight8, vuf );
	return vec3( vuf * Inv255, gf * PackUpscale, bf );
}
vec2 packDepthToRG( const in float v ) {
	if( v <= 0.0 )
		return vec2( 0., 0. );
	if( v >= 1.0 )
		return vec2( 1., 1. );
	float vuf;
	float gf = modf( v * 256., vuf );
	return vec2( vuf * Inv255, gf );
}
float unpackRGBAToDepth( const in vec4 v ) {
	return dot( v, UnpackFactors4 );
}
float unpackRGBToDepth( const in vec3 v ) {
	return dot( v, UnpackFactors3 );
}
float unpackRGToDepth( const in vec2 v ) {
	return v.r * UnpackFactors2.r + v.g * UnpackFactors2.g;
}
vec4 pack2HalfToRGBA( const in vec2 v ) {
	vec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );
	return vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );
}
vec2 unpackRGBATo2Half( const in vec4 v ) {
	return vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );
}
float viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {
	return ( viewZ + near ) / ( near - far );
}
float orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {
	return depth * ( near - far ) - near;
}
float viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {
	return ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );
}
float perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {
	return ( near * far ) / ( ( far - near ) * depth - far );
}`, Nx = `#ifdef PREMULTIPLIED_ALPHA
	gl_FragColor.rgb *= gl_FragColor.a;
#endif`, Ox = `vec4 mvPosition = vec4( transformed, 1.0 );
#ifdef USE_BATCHING
	mvPosition = batchingMatrix * mvPosition;
#endif
#ifdef USE_INSTANCING
	mvPosition = instanceMatrix * mvPosition;
#endif
mvPosition = modelViewMatrix * mvPosition;
gl_Position = projectionMatrix * mvPosition;`, Ux = `#ifdef DITHERING
	gl_FragColor.rgb = dithering( gl_FragColor.rgb );
#endif`, Fx = `#ifdef DITHERING
	vec3 dithering( vec3 color ) {
		float grid_position = rand( gl_FragCoord.xy );
		vec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );
		dither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );
		return color + dither_shift_RGB;
	}
#endif`, Bx = `float roughnessFactor = roughness;
#ifdef USE_ROUGHNESSMAP
	vec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );
	roughnessFactor *= texelRoughness.g;
#endif`, kx = `#ifdef USE_ROUGHNESSMAP
	uniform sampler2D roughnessMap;
#endif`, zx = `#if NUM_SPOT_LIGHT_COORDS > 0
	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];
#endif
#if NUM_SPOT_LIGHT_MAPS > 0
	uniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];
#endif
#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
		#if defined( SHADOWMAP_TYPE_PCF )
			uniform sampler2DShadow directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];
		#else
			uniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];
		#endif
		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];
		struct DirectionalLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
		#if defined( SHADOWMAP_TYPE_PCF )
			uniform sampler2DShadow spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];
		#else
			uniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];
		#endif
		struct SpotLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		#if defined( SHADOWMAP_TYPE_PCF )
			uniform samplerCubeShadow pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];
		#elif defined( SHADOWMAP_TYPE_BASIC )
			uniform samplerCube pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];
		#endif
		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];
		struct PointLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
			float shadowCameraNear;
			float shadowCameraFar;
		};
		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];
	#endif
	#if defined( SHADOWMAP_TYPE_PCF )
		float interleavedGradientNoise( vec2 position ) {
			return fract( 52.9829189 * fract( dot( position, vec2( 0.06711056, 0.00583715 ) ) ) );
		}
		vec2 vogelDiskSample( int sampleIndex, int samplesCount, float phi ) {
			const float goldenAngle = 2.399963229728653;
			float r = sqrt( ( float( sampleIndex ) + 0.5 ) / float( samplesCount ) );
			float theta = float( sampleIndex ) * goldenAngle + phi;
			return vec2( cos( theta ), sin( theta ) ) * r;
		}
	#endif
	#if defined( SHADOWMAP_TYPE_PCF )
		float getShadow( sampler2DShadow shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {
			float shadow = 1.0;
			shadowCoord.xyz /= shadowCoord.w;
			shadowCoord.z += shadowBias;
			bool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;
			bool frustumTest = inFrustum && shadowCoord.z <= 1.0;
			if ( frustumTest ) {
				vec2 texelSize = vec2( 1.0 ) / shadowMapSize;
				float radius = shadowRadius * texelSize.x;
				float phi = interleavedGradientNoise( gl_FragCoord.xy ) * 6.28318530718;
				shadow = (
					texture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 0, 5, phi ) * radius, shadowCoord.z ) ) +
					texture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 1, 5, phi ) * radius, shadowCoord.z ) ) +
					texture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 2, 5, phi ) * radius, shadowCoord.z ) ) +
					texture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 3, 5, phi ) * radius, shadowCoord.z ) ) +
					texture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 4, 5, phi ) * radius, shadowCoord.z ) )
				) * 0.2;
			}
			return mix( 1.0, shadow, shadowIntensity );
		}
	#elif defined( SHADOWMAP_TYPE_VSM )
		float getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {
			float shadow = 1.0;
			shadowCoord.xyz /= shadowCoord.w;
			shadowCoord.z += shadowBias;
			bool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;
			bool frustumTest = inFrustum && shadowCoord.z <= 1.0;
			if ( frustumTest ) {
				vec2 distribution = texture2D( shadowMap, shadowCoord.xy ).rg;
				float mean = distribution.x;
				float variance = distribution.y * distribution.y;
				#ifdef USE_REVERSED_DEPTH_BUFFER
					float hard_shadow = step( mean, shadowCoord.z );
				#else
					float hard_shadow = step( shadowCoord.z, mean );
				#endif
				if ( hard_shadow == 1.0 ) {
					shadow = 1.0;
				} else {
					variance = max( variance, 0.0000001 );
					float d = shadowCoord.z - mean;
					float p_max = variance / ( variance + d * d );
					p_max = clamp( ( p_max - 0.3 ) / 0.65, 0.0, 1.0 );
					shadow = max( hard_shadow, p_max );
				}
			}
			return mix( 1.0, shadow, shadowIntensity );
		}
	#else
		float getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {
			float shadow = 1.0;
			shadowCoord.xyz /= shadowCoord.w;
			shadowCoord.z += shadowBias;
			bool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;
			bool frustumTest = inFrustum && shadowCoord.z <= 1.0;
			if ( frustumTest ) {
				float depth = texture2D( shadowMap, shadowCoord.xy ).r;
				#ifdef USE_REVERSED_DEPTH_BUFFER
					shadow = step( depth, shadowCoord.z );
				#else
					shadow = step( shadowCoord.z, depth );
				#endif
			}
			return mix( 1.0, shadow, shadowIntensity );
		}
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
	#if defined( SHADOWMAP_TYPE_PCF )
	float getPointShadow( samplerCubeShadow shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {
		float shadow = 1.0;
		vec3 lightToPosition = shadowCoord.xyz;
		vec3 bd3D = normalize( lightToPosition );
		vec3 absVec = abs( lightToPosition );
		float viewSpaceZ = max( max( absVec.x, absVec.y ), absVec.z );
		if ( viewSpaceZ - shadowCameraFar <= 0.0 && viewSpaceZ - shadowCameraNear >= 0.0 ) {
			float dp = ( shadowCameraFar * ( viewSpaceZ - shadowCameraNear ) ) / ( viewSpaceZ * ( shadowCameraFar - shadowCameraNear ) );
			dp += shadowBias;
			float texelSize = shadowRadius / shadowMapSize.x;
			vec3 absDir = abs( bd3D );
			vec3 tangent = absDir.x > absDir.z ? vec3( 0.0, 1.0, 0.0 ) : vec3( 1.0, 0.0, 0.0 );
			tangent = normalize( cross( bd3D, tangent ) );
			vec3 bitangent = cross( bd3D, tangent );
			float phi = interleavedGradientNoise( gl_FragCoord.xy ) * 6.28318530718;
			shadow = (
				texture( shadowMap, vec4( bd3D + ( tangent * vogelDiskSample( 0, 5, phi ).x + bitangent * vogelDiskSample( 0, 5, phi ).y ) * texelSize, dp ) ) +
				texture( shadowMap, vec4( bd3D + ( tangent * vogelDiskSample( 1, 5, phi ).x + bitangent * vogelDiskSample( 1, 5, phi ).y ) * texelSize, dp ) ) +
				texture( shadowMap, vec4( bd3D + ( tangent * vogelDiskSample( 2, 5, phi ).x + bitangent * vogelDiskSample( 2, 5, phi ).y ) * texelSize, dp ) ) +
				texture( shadowMap, vec4( bd3D + ( tangent * vogelDiskSample( 3, 5, phi ).x + bitangent * vogelDiskSample( 3, 5, phi ).y ) * texelSize, dp ) ) +
				texture( shadowMap, vec4( bd3D + ( tangent * vogelDiskSample( 4, 5, phi ).x + bitangent * vogelDiskSample( 4, 5, phi ).y ) * texelSize, dp ) )
			) * 0.2;
		}
		return mix( 1.0, shadow, shadowIntensity );
	}
	#elif defined( SHADOWMAP_TYPE_BASIC )
	float getPointShadow( samplerCube shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {
		float shadow = 1.0;
		vec3 lightToPosition = shadowCoord.xyz;
		vec3 bd3D = normalize( lightToPosition );
		vec3 absVec = abs( lightToPosition );
		float viewSpaceZ = max( max( absVec.x, absVec.y ), absVec.z );
		if ( viewSpaceZ - shadowCameraFar <= 0.0 && viewSpaceZ - shadowCameraNear >= 0.0 ) {
			float dp = ( shadowCameraFar * ( viewSpaceZ - shadowCameraNear ) ) / ( viewSpaceZ * ( shadowCameraFar - shadowCameraNear ) );
			dp += shadowBias;
			float depth = textureCube( shadowMap, bd3D ).r;
			#ifdef USE_REVERSED_DEPTH_BUFFER
				shadow = step( depth, dp );
			#else
				shadow = step( dp, depth );
			#endif
		}
		return mix( 1.0, shadow, shadowIntensity );
	}
	#endif
	#endif
#endif`, Vx = `#if NUM_SPOT_LIGHT_COORDS > 0
	uniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];
	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];
#endif
#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
		uniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];
		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];
		struct DirectionalLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
		struct SpotLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		uniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];
		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];
		struct PointLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
			float shadowCameraNear;
			float shadowCameraFar;
		};
		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];
	#endif
#endif`, Hx = `#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )
	vec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );
	vec4 shadowWorldPosition;
#endif
#if defined( USE_SHADOWMAP )
	#if NUM_DIR_LIGHT_SHADOWS > 0
		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {
			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );
			vDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;
		}
		#pragma unroll_loop_end
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {
			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );
			vPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;
		}
		#pragma unroll_loop_end
	#endif
#endif
#if NUM_SPOT_LIGHT_COORDS > 0
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {
		shadowWorldPosition = worldPosition;
		#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
			shadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;
		#endif
		vSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;
	}
	#pragma unroll_loop_end
#endif`, $x = `float getShadowMask() {
	float shadow = 1.0;
	#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
	DirectionalLightShadow directionalLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {
		directionalLight = directionalLightShadows[ i ];
		shadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowIntensity, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
	SpotLightShadow spotLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {
		spotLight = spotLightShadows[ i ];
		shadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowIntensity, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0 && ( defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_BASIC ) )
	PointLightShadow pointLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {
		pointLight = pointLightShadows[ i ];
		shadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowIntensity, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#endif
	return shadow;
}`, Gx = `#ifdef USE_SKINNING
	mat4 boneMatX = getBoneMatrix( skinIndex.x );
	mat4 boneMatY = getBoneMatrix( skinIndex.y );
	mat4 boneMatZ = getBoneMatrix( skinIndex.z );
	mat4 boneMatW = getBoneMatrix( skinIndex.w );
#endif`, qx = `#ifdef USE_SKINNING
	uniform mat4 bindMatrix;
	uniform mat4 bindMatrixInverse;
	uniform highp sampler2D boneTexture;
	mat4 getBoneMatrix( const in float i ) {
		int size = textureSize( boneTexture, 0 ).x;
		int j = int( i ) * 4;
		int x = j % size;
		int y = j / size;
		vec4 v1 = texelFetch( boneTexture, ivec2( x, y ), 0 );
		vec4 v2 = texelFetch( boneTexture, ivec2( x + 1, y ), 0 );
		vec4 v3 = texelFetch( boneTexture, ivec2( x + 2, y ), 0 );
		vec4 v4 = texelFetch( boneTexture, ivec2( x + 3, y ), 0 );
		return mat4( v1, v2, v3, v4 );
	}
#endif`, Wx = `#ifdef USE_SKINNING
	vec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );
	vec4 skinned = vec4( 0.0 );
	skinned += boneMatX * skinVertex * skinWeight.x;
	skinned += boneMatY * skinVertex * skinWeight.y;
	skinned += boneMatZ * skinVertex * skinWeight.z;
	skinned += boneMatW * skinVertex * skinWeight.w;
	transformed = ( bindMatrixInverse * skinned ).xyz;
#endif`, Xx = `#ifdef USE_SKINNING
	mat4 skinMatrix = mat4( 0.0 );
	skinMatrix += skinWeight.x * boneMatX;
	skinMatrix += skinWeight.y * boneMatY;
	skinMatrix += skinWeight.z * boneMatZ;
	skinMatrix += skinWeight.w * boneMatW;
	skinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;
	objectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;
	#ifdef USE_TANGENT
		objectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;
	#endif
#endif`, jx = `float specularStrength;
#ifdef USE_SPECULARMAP
	vec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );
	specularStrength = texelSpecular.r;
#else
	specularStrength = 1.0;
#endif`, Yx = `#ifdef USE_SPECULARMAP
	uniform sampler2D specularMap;
#endif`, Kx = `#if defined( TONE_MAPPING )
	gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );
#endif`, Zx = `#ifndef saturate
#define saturate( a ) clamp( a, 0.0, 1.0 )
#endif
uniform float toneMappingExposure;
vec3 LinearToneMapping( vec3 color ) {
	return saturate( toneMappingExposure * color );
}
vec3 ReinhardToneMapping( vec3 color ) {
	color *= toneMappingExposure;
	return saturate( color / ( vec3( 1.0 ) + color ) );
}
vec3 CineonToneMapping( vec3 color ) {
	color *= toneMappingExposure;
	color = max( vec3( 0.0 ), color - 0.004 );
	return pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );
}
vec3 RRTAndODTFit( vec3 v ) {
	vec3 a = v * ( v + 0.0245786 ) - 0.000090537;
	vec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;
	return a / b;
}
vec3 ACESFilmicToneMapping( vec3 color ) {
	const mat3 ACESInputMat = mat3(
		vec3( 0.59719, 0.07600, 0.02840 ),		vec3( 0.35458, 0.90834, 0.13383 ),
		vec3( 0.04823, 0.01566, 0.83777 )
	);
	const mat3 ACESOutputMat = mat3(
		vec3(  1.60475, -0.10208, -0.00327 ),		vec3( -0.53108,  1.10813, -0.07276 ),
		vec3( -0.07367, -0.00605,  1.07602 )
	);
	color *= toneMappingExposure / 0.6;
	color = ACESInputMat * color;
	color = RRTAndODTFit( color );
	color = ACESOutputMat * color;
	return saturate( color );
}
const mat3 LINEAR_REC2020_TO_LINEAR_SRGB = mat3(
	vec3( 1.6605, - 0.1246, - 0.0182 ),
	vec3( - 0.5876, 1.1329, - 0.1006 ),
	vec3( - 0.0728, - 0.0083, 1.1187 )
);
const mat3 LINEAR_SRGB_TO_LINEAR_REC2020 = mat3(
	vec3( 0.6274, 0.0691, 0.0164 ),
	vec3( 0.3293, 0.9195, 0.0880 ),
	vec3( 0.0433, 0.0113, 0.8956 )
);
vec3 agxDefaultContrastApprox( vec3 x ) {
	vec3 x2 = x * x;
	vec3 x4 = x2 * x2;
	return + 15.5 * x4 * x2
		- 40.14 * x4 * x
		+ 31.96 * x4
		- 6.868 * x2 * x
		+ 0.4298 * x2
		+ 0.1191 * x
		- 0.00232;
}
vec3 AgXToneMapping( vec3 color ) {
	const mat3 AgXInsetMatrix = mat3(
		vec3( 0.856627153315983, 0.137318972929847, 0.11189821299995 ),
		vec3( 0.0951212405381588, 0.761241990602591, 0.0767994186031903 ),
		vec3( 0.0482516061458583, 0.101439036467562, 0.811302368396859 )
	);
	const mat3 AgXOutsetMatrix = mat3(
		vec3( 1.1271005818144368, - 0.1413297634984383, - 0.14132976349843826 ),
		vec3( - 0.11060664309660323, 1.157823702216272, - 0.11060664309660294 ),
		vec3( - 0.016493938717834573, - 0.016493938717834257, 1.2519364065950405 )
	);
	const float AgxMinEv = - 12.47393;	const float AgxMaxEv = 4.026069;
	color *= toneMappingExposure;
	color = LINEAR_SRGB_TO_LINEAR_REC2020 * color;
	color = AgXInsetMatrix * color;
	color = max( color, 1e-10 );	color = log2( color );
	color = ( color - AgxMinEv ) / ( AgxMaxEv - AgxMinEv );
	color = clamp( color, 0.0, 1.0 );
	color = agxDefaultContrastApprox( color );
	color = AgXOutsetMatrix * color;
	color = pow( max( vec3( 0.0 ), color ), vec3( 2.2 ) );
	color = LINEAR_REC2020_TO_LINEAR_SRGB * color;
	color = clamp( color, 0.0, 1.0 );
	return color;
}
vec3 NeutralToneMapping( vec3 color ) {
	const float StartCompression = 0.8 - 0.04;
	const float Desaturation = 0.15;
	color *= toneMappingExposure;
	float x = min( color.r, min( color.g, color.b ) );
	float offset = x < 0.08 ? x - 6.25 * x * x : 0.04;
	color -= offset;
	float peak = max( color.r, max( color.g, color.b ) );
	if ( peak < StartCompression ) return color;
	float d = 1. - StartCompression;
	float newPeak = 1. - d * d / ( peak + d - StartCompression );
	color *= newPeak / peak;
	float g = 1. - 1. / ( Desaturation * ( peak - newPeak ) + 1. );
	return mix( color, vec3( newPeak ), g );
}
vec3 CustomToneMapping( vec3 color ) { return color; }`, Jx = `#ifdef USE_TRANSMISSION
	material.transmission = transmission;
	material.transmissionAlpha = 1.0;
	material.thickness = thickness;
	material.attenuationDistance = attenuationDistance;
	material.attenuationColor = attenuationColor;
	#ifdef USE_TRANSMISSIONMAP
		material.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;
	#endif
	#ifdef USE_THICKNESSMAP
		material.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;
	#endif
	vec3 pos = vWorldPosition;
	vec3 v = normalize( cameraPosition - pos );
	vec3 n = inverseTransformDirection( normal, viewMatrix );
	vec4 transmitted = getIBLVolumeRefraction(
		n, v, material.roughness, material.diffuseContribution, material.specularColorBlended, material.specularF90,
		pos, modelMatrix, viewMatrix, projectionMatrix, material.dispersion, material.ior, material.thickness,
		material.attenuationColor, material.attenuationDistance );
	material.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );
	totalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );
#endif`, Qx = `#ifdef USE_TRANSMISSION
	uniform float transmission;
	uniform float thickness;
	uniform float attenuationDistance;
	uniform vec3 attenuationColor;
	#ifdef USE_TRANSMISSIONMAP
		uniform sampler2D transmissionMap;
	#endif
	#ifdef USE_THICKNESSMAP
		uniform sampler2D thicknessMap;
	#endif
	uniform vec2 transmissionSamplerSize;
	uniform sampler2D transmissionSamplerMap;
	uniform mat4 modelMatrix;
	uniform mat4 projectionMatrix;
	varying vec3 vWorldPosition;
	float w0( float a ) {
		return ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );
	}
	float w1( float a ) {
		return ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );
	}
	float w2( float a ){
		return ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );
	}
	float w3( float a ) {
		return ( 1.0 / 6.0 ) * ( a * a * a );
	}
	float g0( float a ) {
		return w0( a ) + w1( a );
	}
	float g1( float a ) {
		return w2( a ) + w3( a );
	}
	float h0( float a ) {
		return - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );
	}
	float h1( float a ) {
		return 1.0 + w3( a ) / ( w2( a ) + w3( a ) );
	}
	vec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {
		uv = uv * texelSize.zw + 0.5;
		vec2 iuv = floor( uv );
		vec2 fuv = fract( uv );
		float g0x = g0( fuv.x );
		float g1x = g1( fuv.x );
		float h0x = h0( fuv.x );
		float h1x = h1( fuv.x );
		float h0y = h0( fuv.y );
		float h1y = h1( fuv.y );
		vec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;
		vec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;
		vec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;
		vec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;
		return g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +
			g1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );
	}
	vec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {
		vec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );
		vec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );
		vec2 fLodSizeInv = 1.0 / fLodSize;
		vec2 cLodSizeInv = 1.0 / cLodSize;
		vec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );
		vec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );
		return mix( fSample, cSample, fract( lod ) );
	}
	vec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {
		vec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );
		vec3 modelScale;
		modelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );
		modelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );
		modelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );
		return normalize( refractionVector ) * thickness * modelScale;
	}
	float applyIorToRoughness( const in float roughness, const in float ior ) {
		return roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );
	}
	vec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {
		float lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );
		return textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );
	}
	vec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {
		if ( isinf( attenuationDistance ) ) {
			return vec3( 1.0 );
		} else {
			vec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;
			vec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );			return transmittance;
		}
	}
	vec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,
		const in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,
		const in mat4 viewMatrix, const in mat4 projMatrix, const in float dispersion, const in float ior, const in float thickness,
		const in vec3 attenuationColor, const in float attenuationDistance ) {
		vec4 transmittedLight;
		vec3 transmittance;
		#ifdef USE_DISPERSION
			float halfSpread = ( ior - 1.0 ) * 0.025 * dispersion;
			vec3 iors = vec3( ior - halfSpread, ior, ior + halfSpread );
			for ( int i = 0; i < 3; i ++ ) {
				vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, iors[ i ], modelMatrix );
				vec3 refractedRayExit = position + transmissionRay;
				vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );
				vec2 refractionCoords = ndcPos.xy / ndcPos.w;
				refractionCoords += 1.0;
				refractionCoords /= 2.0;
				vec4 transmissionSample = getTransmissionSample( refractionCoords, roughness, iors[ i ] );
				transmittedLight[ i ] = transmissionSample[ i ];
				transmittedLight.a += transmissionSample.a;
				transmittance[ i ] = diffuseColor[ i ] * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance )[ i ];
			}
			transmittedLight.a /= 3.0;
		#else
			vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );
			vec3 refractedRayExit = position + transmissionRay;
			vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );
			vec2 refractionCoords = ndcPos.xy / ndcPos.w;
			refractionCoords += 1.0;
			refractionCoords /= 2.0;
			transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );
			transmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );
		#endif
		vec3 attenuatedColor = transmittance * transmittedLight.rgb;
		vec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );
		float transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;
		return vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );
	}
#endif`, ey = `#if defined( USE_UV ) || defined( USE_ANISOTROPY )
	varying vec2 vUv;
#endif
#ifdef USE_MAP
	varying vec2 vMapUv;
#endif
#ifdef USE_ALPHAMAP
	varying vec2 vAlphaMapUv;
#endif
#ifdef USE_LIGHTMAP
	varying vec2 vLightMapUv;
#endif
#ifdef USE_AOMAP
	varying vec2 vAoMapUv;
#endif
#ifdef USE_BUMPMAP
	varying vec2 vBumpMapUv;
#endif
#ifdef USE_NORMALMAP
	varying vec2 vNormalMapUv;
#endif
#ifdef USE_EMISSIVEMAP
	varying vec2 vEmissiveMapUv;
#endif
#ifdef USE_METALNESSMAP
	varying vec2 vMetalnessMapUv;
#endif
#ifdef USE_ROUGHNESSMAP
	varying vec2 vRoughnessMapUv;
#endif
#ifdef USE_ANISOTROPYMAP
	varying vec2 vAnisotropyMapUv;
#endif
#ifdef USE_CLEARCOATMAP
	varying vec2 vClearcoatMapUv;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	varying vec2 vClearcoatNormalMapUv;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	varying vec2 vClearcoatRoughnessMapUv;
#endif
#ifdef USE_IRIDESCENCEMAP
	varying vec2 vIridescenceMapUv;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	varying vec2 vIridescenceThicknessMapUv;
#endif
#ifdef USE_SHEEN_COLORMAP
	varying vec2 vSheenColorMapUv;
#endif
#ifdef USE_SHEEN_ROUGHNESSMAP
	varying vec2 vSheenRoughnessMapUv;
#endif
#ifdef USE_SPECULARMAP
	varying vec2 vSpecularMapUv;
#endif
#ifdef USE_SPECULAR_COLORMAP
	varying vec2 vSpecularColorMapUv;
#endif
#ifdef USE_SPECULAR_INTENSITYMAP
	varying vec2 vSpecularIntensityMapUv;
#endif
#ifdef USE_TRANSMISSIONMAP
	uniform mat3 transmissionMapTransform;
	varying vec2 vTransmissionMapUv;
#endif
#ifdef USE_THICKNESSMAP
	uniform mat3 thicknessMapTransform;
	varying vec2 vThicknessMapUv;
#endif`, ty = `#if defined( USE_UV ) || defined( USE_ANISOTROPY )
	varying vec2 vUv;
#endif
#ifdef USE_MAP
	uniform mat3 mapTransform;
	varying vec2 vMapUv;
#endif
#ifdef USE_ALPHAMAP
	uniform mat3 alphaMapTransform;
	varying vec2 vAlphaMapUv;
#endif
#ifdef USE_LIGHTMAP
	uniform mat3 lightMapTransform;
	varying vec2 vLightMapUv;
#endif
#ifdef USE_AOMAP
	uniform mat3 aoMapTransform;
	varying vec2 vAoMapUv;
#endif
#ifdef USE_BUMPMAP
	uniform mat3 bumpMapTransform;
	varying vec2 vBumpMapUv;
#endif
#ifdef USE_NORMALMAP
	uniform mat3 normalMapTransform;
	varying vec2 vNormalMapUv;
#endif
#ifdef USE_DISPLACEMENTMAP
	uniform mat3 displacementMapTransform;
	varying vec2 vDisplacementMapUv;
#endif
#ifdef USE_EMISSIVEMAP
	uniform mat3 emissiveMapTransform;
	varying vec2 vEmissiveMapUv;
#endif
#ifdef USE_METALNESSMAP
	uniform mat3 metalnessMapTransform;
	varying vec2 vMetalnessMapUv;
#endif
#ifdef USE_ROUGHNESSMAP
	uniform mat3 roughnessMapTransform;
	varying vec2 vRoughnessMapUv;
#endif
#ifdef USE_ANISOTROPYMAP
	uniform mat3 anisotropyMapTransform;
	varying vec2 vAnisotropyMapUv;
#endif
#ifdef USE_CLEARCOATMAP
	uniform mat3 clearcoatMapTransform;
	varying vec2 vClearcoatMapUv;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	uniform mat3 clearcoatNormalMapTransform;
	varying vec2 vClearcoatNormalMapUv;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	uniform mat3 clearcoatRoughnessMapTransform;
	varying vec2 vClearcoatRoughnessMapUv;
#endif
#ifdef USE_SHEEN_COLORMAP
	uniform mat3 sheenColorMapTransform;
	varying vec2 vSheenColorMapUv;
#endif
#ifdef USE_SHEEN_ROUGHNESSMAP
	uniform mat3 sheenRoughnessMapTransform;
	varying vec2 vSheenRoughnessMapUv;
#endif
#ifdef USE_IRIDESCENCEMAP
	uniform mat3 iridescenceMapTransform;
	varying vec2 vIridescenceMapUv;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	uniform mat3 iridescenceThicknessMapTransform;
	varying vec2 vIridescenceThicknessMapUv;
#endif
#ifdef USE_SPECULARMAP
	uniform mat3 specularMapTransform;
	varying vec2 vSpecularMapUv;
#endif
#ifdef USE_SPECULAR_COLORMAP
	uniform mat3 specularColorMapTransform;
	varying vec2 vSpecularColorMapUv;
#endif
#ifdef USE_SPECULAR_INTENSITYMAP
	uniform mat3 specularIntensityMapTransform;
	varying vec2 vSpecularIntensityMapUv;
#endif
#ifdef USE_TRANSMISSIONMAP
	uniform mat3 transmissionMapTransform;
	varying vec2 vTransmissionMapUv;
#endif
#ifdef USE_THICKNESSMAP
	uniform mat3 thicknessMapTransform;
	varying vec2 vThicknessMapUv;
#endif`, iy = `#if defined( USE_UV ) || defined( USE_ANISOTROPY )
	vUv = vec3( uv, 1 ).xy;
#endif
#ifdef USE_MAP
	vMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;
#endif
#ifdef USE_ALPHAMAP
	vAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_LIGHTMAP
	vLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_AOMAP
	vAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_BUMPMAP
	vBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_NORMALMAP
	vNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_DISPLACEMENTMAP
	vDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_EMISSIVEMAP
	vEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_METALNESSMAP
	vMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_ROUGHNESSMAP
	vRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_ANISOTROPYMAP
	vAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_CLEARCOATMAP
	vClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	vClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	vClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_IRIDESCENCEMAP
	vIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	vIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SHEEN_COLORMAP
	vSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SHEEN_ROUGHNESSMAP
	vSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SPECULARMAP
	vSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SPECULAR_COLORMAP
	vSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SPECULAR_INTENSITYMAP
	vSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_TRANSMISSIONMAP
	vTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_THICKNESSMAP
	vThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;
#endif`, ny = `#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0
	vec4 worldPosition = vec4( transformed, 1.0 );
	#ifdef USE_BATCHING
		worldPosition = batchingMatrix * worldPosition;
	#endif
	#ifdef USE_INSTANCING
		worldPosition = instanceMatrix * worldPosition;
	#endif
	worldPosition = modelMatrix * worldPosition;
#endif`;
const sy = `varying vec2 vUv;
uniform mat3 uvTransform;
void main() {
	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;
	gl_Position = vec4( position.xy, 1.0, 1.0 );
}`, ry = `uniform sampler2D t2D;
uniform float backgroundIntensity;
varying vec2 vUv;
void main() {
	vec4 texColor = texture2D( t2D, vUv );
	#ifdef DECODE_VIDEO_TEXTURE
		texColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );
	#endif
	texColor.rgb *= backgroundIntensity;
	gl_FragColor = texColor;
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
}`, ay = `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
	gl_Position.z = gl_Position.w;
}`, oy = `#ifdef ENVMAP_TYPE_CUBE
	uniform samplerCube envMap;
#elif defined( ENVMAP_TYPE_CUBE_UV )
	uniform sampler2D envMap;
#endif
uniform float flipEnvMap;
uniform float backgroundBlurriness;
uniform float backgroundIntensity;
uniform mat3 backgroundRotation;
varying vec3 vWorldDirection;
#include <cube_uv_reflection_fragment>
void main() {
	#ifdef ENVMAP_TYPE_CUBE
		vec4 texColor = textureCube( envMap, backgroundRotation * vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );
	#elif defined( ENVMAP_TYPE_CUBE_UV )
		vec4 texColor = textureCubeUV( envMap, backgroundRotation * vWorldDirection, backgroundBlurriness );
	#else
		vec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );
	#endif
	texColor.rgb *= backgroundIntensity;
	gl_FragColor = texColor;
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
}`, ly = `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
	gl_Position.z = gl_Position.w;
}`, cy = `uniform samplerCube tCube;
uniform float tFlip;
uniform float opacity;
varying vec3 vWorldDirection;
void main() {
	vec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );
	gl_FragColor = texColor;
	gl_FragColor.a *= opacity;
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
}`, hy = `#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
varying vec2 vHighPrecisionZW;
void main() {
	#include <uv_vertex>
	#include <batching_vertex>
	#include <skinbase_vertex>
	#include <morphinstance_vertex>
	#ifdef USE_DISPLACEMENTMAP
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vHighPrecisionZW = gl_Position.zw;
}`, dy = `#if DEPTH_PACKING == 3200
	uniform float opacity;
#endif
#include <common>
#include <packing>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
varying vec2 vHighPrecisionZW;
void main() {
	vec4 diffuseColor = vec4( 1.0 );
	#include <clipping_planes_fragment>
	#if DEPTH_PACKING == 3200
		diffuseColor.a = opacity;
	#endif
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <logdepthbuf_fragment>
	#ifdef USE_REVERSED_DEPTH_BUFFER
		float fragCoordZ = vHighPrecisionZW[ 0 ] / vHighPrecisionZW[ 1 ];
	#else
		float fragCoordZ = 0.5 * vHighPrecisionZW[ 0 ] / vHighPrecisionZW[ 1 ] + 0.5;
	#endif
	#if DEPTH_PACKING == 3200
		gl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );
	#elif DEPTH_PACKING == 3201
		gl_FragColor = packDepthToRGBA( fragCoordZ );
	#elif DEPTH_PACKING == 3202
		gl_FragColor = vec4( packDepthToRGB( fragCoordZ ), 1.0 );
	#elif DEPTH_PACKING == 3203
		gl_FragColor = vec4( packDepthToRG( fragCoordZ ), 0.0, 1.0 );
	#endif
}`, uy = `#define DISTANCE
varying vec3 vWorldPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <batching_vertex>
	#include <skinbase_vertex>
	#include <morphinstance_vertex>
	#ifdef USE_DISPLACEMENTMAP
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <worldpos_vertex>
	#include <clipping_planes_vertex>
	vWorldPosition = worldPosition.xyz;
}`, fy = `#define DISTANCE
uniform vec3 referencePosition;
uniform float nearDistance;
uniform float farDistance;
varying vec3 vWorldPosition;
#include <common>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <clipping_planes_pars_fragment>
void main () {
	vec4 diffuseColor = vec4( 1.0 );
	#include <clipping_planes_fragment>
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	float dist = length( vWorldPosition - referencePosition );
	dist = ( dist - nearDistance ) / ( farDistance - nearDistance );
	dist = saturate( dist );
	gl_FragColor = vec4( dist, 0.0, 0.0, 1.0 );
}`, py = `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
}`, my = `uniform sampler2D tEquirect;
varying vec3 vWorldDirection;
#include <common>
void main() {
	vec3 direction = normalize( vWorldDirection );
	vec2 sampleUV = equirectUv( direction );
	gl_FragColor = texture2D( tEquirect, sampleUV );
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
}`, gy = `uniform float scale;
attribute float lineDistance;
varying float vLineDistance;
#include <common>
#include <uv_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	vLineDistance = scale * lineDistance;
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
}`, vy = `uniform vec3 diffuse;
uniform float opacity;
uniform float dashSize;
uniform float totalSize;
varying float vLineDistance;
#include <common>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	if ( mod( vLineDistance, totalSize ) > dashSize ) {
		discard;
	}
	vec3 outgoingLight = vec3( 0.0 );
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
}`, _y = `#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinbase_vertex>
		#include <skinnormal_vertex>
		#include <defaultnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <fog_vertex>
}`, xy = `uniform vec3 diffuse;
uniform float opacity;
#ifndef FLAT_SHADED
	varying vec3 vNormal;
#endif
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <specularmap_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	#ifdef USE_LIGHTMAP
		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );
		reflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;
	#else
		reflectedLight.indirectDiffuse += vec3( 1.0 );
	#endif
	#include <aomap_fragment>
	reflectedLight.indirectDiffuse *= diffuseColor.rgb;
	vec3 outgoingLight = reflectedLight.indirectDiffuse;
	#include <envmap_fragment>
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, yy = `#define LAMBERT
varying vec3 vViewPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, by = `#define LAMBERT
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float opacity;
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_lambert_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <specularmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_lambert_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;
	#include <envmap_fragment>
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, wy = `#define MATCAP
varying vec3 vViewPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <color_pars_vertex>
#include <displacementmap_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
	vViewPosition = - mvPosition.xyz;
}`, Sy = `#define MATCAP
uniform vec3 diffuse;
uniform float opacity;
uniform sampler2D matcap;
varying vec3 vViewPosition;
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <fog_pars_fragment>
#include <normal_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	vec3 viewDir = normalize( vViewPosition );
	vec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );
	vec3 y = cross( viewDir, x );
	vec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;
	#ifdef USE_MATCAP
		vec4 matcapColor = texture2D( matcap, uv );
	#else
		vec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );
	#endif
	vec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, My = `#define NORMAL
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )
	varying vec3 vViewPosition;
#endif
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphinstance_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )
	vViewPosition = - mvPosition.xyz;
#endif
}`, Ty = `#define NORMAL
uniform float opacity;
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )
	varying vec3 vViewPosition;
#endif
#include <uv_pars_fragment>
#include <normal_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( 0.0, 0.0, 0.0, opacity );
	#include <clipping_planes_fragment>
	#include <logdepthbuf_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	gl_FragColor = vec4( normalize( normal ) * 0.5 + 0.5, diffuseColor.a );
	#ifdef OPAQUE
		gl_FragColor.a = 1.0;
	#endif
}`, Ey = `#define PHONG
varying vec3 vViewPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphinstance_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, Ay = `#define PHONG
uniform vec3 diffuse;
uniform vec3 emissive;
uniform vec3 specular;
uniform float shininess;
uniform float opacity;
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_phong_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <specularmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_phong_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;
	#include <envmap_fragment>
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, Ry = `#define STANDARD
varying vec3 vViewPosition;
#ifdef USE_TRANSMISSION
	varying vec3 vWorldPosition;
#endif
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
#ifdef USE_TRANSMISSION
	vWorldPosition = worldPosition.xyz;
#endif
}`, Cy = `#define STANDARD
#ifdef PHYSICAL
	#define IOR
	#define USE_SPECULAR
#endif
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float roughness;
uniform float metalness;
uniform float opacity;
#ifdef IOR
	uniform float ior;
#endif
#ifdef USE_SPECULAR
	uniform float specularIntensity;
	uniform vec3 specularColor;
	#ifdef USE_SPECULAR_COLORMAP
		uniform sampler2D specularColorMap;
	#endif
	#ifdef USE_SPECULAR_INTENSITYMAP
		uniform sampler2D specularIntensityMap;
	#endif
#endif
#ifdef USE_CLEARCOAT
	uniform float clearcoat;
	uniform float clearcoatRoughness;
#endif
#ifdef USE_DISPERSION
	uniform float dispersion;
#endif
#ifdef USE_IRIDESCENCE
	uniform float iridescence;
	uniform float iridescenceIOR;
	uniform float iridescenceThicknessMinimum;
	uniform float iridescenceThicknessMaximum;
#endif
#ifdef USE_SHEEN
	uniform vec3 sheenColor;
	uniform float sheenRoughness;
	#ifdef USE_SHEEN_COLORMAP
		uniform sampler2D sheenColorMap;
	#endif
	#ifdef USE_SHEEN_ROUGHNESSMAP
		uniform sampler2D sheenRoughnessMap;
	#endif
#endif
#ifdef USE_ANISOTROPY
	uniform vec2 anisotropyVector;
	#ifdef USE_ANISOTROPYMAP
		uniform sampler2D anisotropyMap;
	#endif
#endif
varying vec3 vViewPosition;
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <iridescence_fragment>
#include <cube_uv_reflection_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_physical_pars_fragment>
#include <fog_pars_fragment>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_physical_pars_fragment>
#include <transmission_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <clearcoat_pars_fragment>
#include <iridescence_pars_fragment>
#include <roughnessmap_pars_fragment>
#include <metalnessmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <roughnessmap_fragment>
	#include <metalnessmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <clearcoat_normal_fragment_begin>
	#include <clearcoat_normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_physical_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;
	vec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;
	#include <transmission_fragment>
	vec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;
	#ifdef USE_SHEEN
 
		outgoingLight = outgoingLight + sheenSpecularDirect + sheenSpecularIndirect;
 
 	#endif
	#ifdef USE_CLEARCOAT
		float dotNVcc = saturate( dot( geometryClearcoatNormal, geometryViewDir ) );
		vec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );
		outgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + ( clearcoatSpecularDirect + clearcoatSpecularIndirect ) * material.clearcoat;
	#endif
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, Iy = `#define TOON
varying vec3 vViewPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, Py = `#define TOON
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float opacity;
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <gradientmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_toon_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_toon_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, Ly = `uniform float size;
uniform float scale;
#include <common>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
#ifdef USE_POINTS_UV
	varying vec2 vUv;
	uniform mat3 uvTransform;
#endif
void main() {
	#ifdef USE_POINTS_UV
		vUv = ( uvTransform * vec3( uv, 1 ) ).xy;
	#endif
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <project_vertex>
	gl_PointSize = size;
	#ifdef USE_SIZEATTENUATION
		bool isPerspective = isPerspectiveMatrix( projectionMatrix );
		if ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );
	#endif
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <worldpos_vertex>
	#include <fog_vertex>
}`, Dy = `uniform vec3 diffuse;
uniform float opacity;
#include <common>
#include <color_pars_fragment>
#include <map_particle_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	vec3 outgoingLight = vec3( 0.0 );
	#include <logdepthbuf_fragment>
	#include <map_particle_fragment>
	#include <color_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
}`, Ny = `#include <common>
#include <batching_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <shadowmap_pars_vertex>
void main() {
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphinstance_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, Oy = `uniform vec3 color;
uniform float opacity;
#include <common>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <logdepthbuf_pars_fragment>
#include <shadowmap_pars_fragment>
#include <shadowmask_pars_fragment>
void main() {
	#include <logdepthbuf_fragment>
	gl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
}`, Uy = `uniform float rotation;
uniform vec2 center;
#include <common>
#include <uv_pars_vertex>
#include <fog_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	vec4 mvPosition = modelViewMatrix[ 3 ];
	vec2 scale = vec2( length( modelMatrix[ 0 ].xyz ), length( modelMatrix[ 1 ].xyz ) );
	#ifndef USE_SIZEATTENUATION
		bool isPerspective = isPerspectiveMatrix( projectionMatrix );
		if ( isPerspective ) scale *= - mvPosition.z;
	#endif
	vec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;
	vec2 rotatedPosition;
	rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;
	rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;
	mvPosition.xy += rotatedPosition;
	gl_Position = projectionMatrix * mvPosition;
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
}`, Fy = `uniform vec3 diffuse;
uniform float opacity;
#include <common>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	vec3 outgoingLight = vec3( 0.0 );
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
}`, ke = {
  alphahash_fragment: r0,
  alphahash_pars_fragment: a0,
  alphamap_fragment: o0,
  alphamap_pars_fragment: l0,
  alphatest_fragment: c0,
  alphatest_pars_fragment: h0,
  aomap_fragment: d0,
  aomap_pars_fragment: u0,
  batching_pars_vertex: f0,
  batching_vertex: p0,
  begin_vertex: m0,
  beginnormal_vertex: g0,
  bsdfs: v0,
  iridescence_fragment: _0,
  bumpmap_pars_fragment: x0,
  clipping_planes_fragment: y0,
  clipping_planes_pars_fragment: b0,
  clipping_planes_pars_vertex: w0,
  clipping_planes_vertex: S0,
  color_fragment: M0,
  color_pars_fragment: T0,
  color_pars_vertex: E0,
  color_vertex: A0,
  common: R0,
  cube_uv_reflection_fragment: C0,
  defaultnormal_vertex: I0,
  displacementmap_pars_vertex: P0,
  displacementmap_vertex: L0,
  emissivemap_fragment: D0,
  emissivemap_pars_fragment: N0,
  colorspace_fragment: O0,
  colorspace_pars_fragment: U0,
  envmap_fragment: F0,
  envmap_common_pars_fragment: B0,
  envmap_pars_fragment: k0,
  envmap_pars_vertex: z0,
  envmap_physical_pars_fragment: Z0,
  envmap_vertex: V0,
  fog_vertex: H0,
  fog_pars_vertex: $0,
  fog_fragment: G0,
  fog_pars_fragment: q0,
  gradientmap_pars_fragment: W0,
  lightmap_pars_fragment: X0,
  lights_lambert_fragment: j0,
  lights_lambert_pars_fragment: Y0,
  lights_pars_begin: K0,
  lights_toon_fragment: J0,
  lights_toon_pars_fragment: Q0,
  lights_phong_fragment: ex,
  lights_phong_pars_fragment: tx,
  lights_physical_fragment: ix,
  lights_physical_pars_fragment: nx,
  lights_fragment_begin: sx,
  lights_fragment_maps: rx,
  lights_fragment_end: ax,
  logdepthbuf_fragment: ox,
  logdepthbuf_pars_fragment: lx,
  logdepthbuf_pars_vertex: cx,
  logdepthbuf_vertex: hx,
  map_fragment: dx,
  map_pars_fragment: ux,
  map_particle_fragment: fx,
  map_particle_pars_fragment: px,
  metalnessmap_fragment: mx,
  metalnessmap_pars_fragment: gx,
  morphinstance_vertex: vx,
  morphcolor_vertex: _x,
  morphnormal_vertex: xx,
  morphtarget_pars_vertex: yx,
  morphtarget_vertex: bx,
  normal_fragment_begin: wx,
  normal_fragment_maps: Sx,
  normal_pars_fragment: Mx,
  normal_pars_vertex: Tx,
  normal_vertex: Ex,
  normalmap_pars_fragment: Ax,
  clearcoat_normal_fragment_begin: Rx,
  clearcoat_normal_fragment_maps: Cx,
  clearcoat_pars_fragment: Ix,
  iridescence_pars_fragment: Px,
  opaque_fragment: Lx,
  packing: Dx,
  premultiplied_alpha_fragment: Nx,
  project_vertex: Ox,
  dithering_fragment: Ux,
  dithering_pars_fragment: Fx,
  roughnessmap_fragment: Bx,
  roughnessmap_pars_fragment: kx,
  shadowmap_pars_fragment: zx,
  shadowmap_pars_vertex: Vx,
  shadowmap_vertex: Hx,
  shadowmask_pars_fragment: $x,
  skinbase_vertex: Gx,
  skinning_pars_vertex: qx,
  skinning_vertex: Wx,
  skinnormal_vertex: Xx,
  specularmap_fragment: jx,
  specularmap_pars_fragment: Yx,
  tonemapping_fragment: Kx,
  tonemapping_pars_fragment: Zx,
  transmission_fragment: Jx,
  transmission_pars_fragment: Qx,
  uv_pars_fragment: ey,
  uv_pars_vertex: ty,
  uv_vertex: iy,
  worldpos_vertex: ny,
  background_vert: sy,
  background_frag: ry,
  backgroundCube_vert: ay,
  backgroundCube_frag: oy,
  cube_vert: ly,
  cube_frag: cy,
  depth_vert: hy,
  depth_frag: dy,
  distance_vert: uy,
  distance_frag: fy,
  equirect_vert: py,
  equirect_frag: my,
  linedashed_vert: gy,
  linedashed_frag: vy,
  meshbasic_vert: _y,
  meshbasic_frag: xy,
  meshlambert_vert: yy,
  meshlambert_frag: by,
  meshmatcap_vert: wy,
  meshmatcap_frag: Sy,
  meshnormal_vert: My,
  meshnormal_frag: Ty,
  meshphong_vert: Ey,
  meshphong_frag: Ay,
  meshphysical_vert: Ry,
  meshphysical_frag: Cy,
  meshtoon_vert: Iy,
  meshtoon_frag: Py,
  points_vert: Ly,
  points_frag: Dy,
  shadow_vert: Ny,
  shadow_frag: Oy,
  sprite_vert: Uy,
  sprite_frag: Fy
}, ce = {
  common: {
    diffuse: { value: /* @__PURE__ */ new Ne(16777215) },
    opacity: { value: 1 },
    map: { value: null },
    mapTransform: { value: /* @__PURE__ */ new Be() },
    alphaMap: { value: null },
    alphaMapTransform: { value: /* @__PURE__ */ new Be() },
    alphaTest: { value: 0 }
  },
  specularmap: {
    specularMap: { value: null },
    specularMapTransform: { value: /* @__PURE__ */ new Be() }
  },
  envmap: {
    envMap: { value: null },
    envMapRotation: { value: /* @__PURE__ */ new Be() },
    flipEnvMap: { value: -1 },
    reflectivity: { value: 1 },
    // basic, lambert, phong
    ior: { value: 1.5 },
    // physical
    refractionRatio: { value: 0.98 },
    // basic, lambert, phong
    dfgLUT: { value: null }
    // DFG LUT for physically-based rendering
  },
  aomap: {
    aoMap: { value: null },
    aoMapIntensity: { value: 1 },
    aoMapTransform: { value: /* @__PURE__ */ new Be() }
  },
  lightmap: {
    lightMap: { value: null },
    lightMapIntensity: { value: 1 },
    lightMapTransform: { value: /* @__PURE__ */ new Be() }
  },
  bumpmap: {
    bumpMap: { value: null },
    bumpMapTransform: { value: /* @__PURE__ */ new Be() },
    bumpScale: { value: 1 }
  },
  normalmap: {
    normalMap: { value: null },
    normalMapTransform: { value: /* @__PURE__ */ new Be() },
    normalScale: { value: /* @__PURE__ */ new Ye(1, 1) }
  },
  displacementmap: {
    displacementMap: { value: null },
    displacementMapTransform: { value: /* @__PURE__ */ new Be() },
    displacementScale: { value: 1 },
    displacementBias: { value: 0 }
  },
  emissivemap: {
    emissiveMap: { value: null },
    emissiveMapTransform: { value: /* @__PURE__ */ new Be() }
  },
  metalnessmap: {
    metalnessMap: { value: null },
    metalnessMapTransform: { value: /* @__PURE__ */ new Be() }
  },
  roughnessmap: {
    roughnessMap: { value: null },
    roughnessMapTransform: { value: /* @__PURE__ */ new Be() }
  },
  gradientmap: {
    gradientMap: { value: null }
  },
  fog: {
    fogDensity: { value: 25e-5 },
    fogNear: { value: 1 },
    fogFar: { value: 2e3 },
    fogColor: { value: /* @__PURE__ */ new Ne(16777215) }
  },
  lights: {
    ambientLightColor: { value: [] },
    lightProbe: { value: [] },
    directionalLights: { value: [], properties: {
      direction: {},
      color: {}
    } },
    directionalLightShadows: { value: [], properties: {
      shadowIntensity: 1,
      shadowBias: {},
      shadowNormalBias: {},
      shadowRadius: {},
      shadowMapSize: {}
    } },
    directionalShadowMap: { value: [] },
    directionalShadowMatrix: { value: [] },
    spotLights: { value: [], properties: {
      color: {},
      position: {},
      direction: {},
      distance: {},
      coneCos: {},
      penumbraCos: {},
      decay: {}
    } },
    spotLightShadows: { value: [], properties: {
      shadowIntensity: 1,
      shadowBias: {},
      shadowNormalBias: {},
      shadowRadius: {},
      shadowMapSize: {}
    } },
    spotLightMap: { value: [] },
    spotShadowMap: { value: [] },
    spotLightMatrix: { value: [] },
    pointLights: { value: [], properties: {
      color: {},
      position: {},
      decay: {},
      distance: {}
    } },
    pointLightShadows: { value: [], properties: {
      shadowIntensity: 1,
      shadowBias: {},
      shadowNormalBias: {},
      shadowRadius: {},
      shadowMapSize: {},
      shadowCameraNear: {},
      shadowCameraFar: {}
    } },
    pointShadowMap: { value: [] },
    pointShadowMatrix: { value: [] },
    hemisphereLights: { value: [], properties: {
      direction: {},
      skyColor: {},
      groundColor: {}
    } },
    // TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
    rectAreaLights: { value: [], properties: {
      color: {},
      position: {},
      width: {},
      height: {}
    } },
    ltc_1: { value: null },
    ltc_2: { value: null }
  },
  points: {
    diffuse: { value: /* @__PURE__ */ new Ne(16777215) },
    opacity: { value: 1 },
    size: { value: 1 },
    scale: { value: 1 },
    map: { value: null },
    alphaMap: { value: null },
    alphaMapTransform: { value: /* @__PURE__ */ new Be() },
    alphaTest: { value: 0 },
    uvTransform: { value: /* @__PURE__ */ new Be() }
  },
  sprite: {
    diffuse: { value: /* @__PURE__ */ new Ne(16777215) },
    opacity: { value: 1 },
    center: { value: /* @__PURE__ */ new Ye(0.5, 0.5) },
    rotation: { value: 0 },
    map: { value: null },
    mapTransform: { value: /* @__PURE__ */ new Be() },
    alphaMap: { value: null },
    alphaMapTransform: { value: /* @__PURE__ */ new Be() },
    alphaTest: { value: 0 }
  }
}, Ui = {
  basic: {
    uniforms: /* @__PURE__ */ $t([
      ce.common,
      ce.specularmap,
      ce.envmap,
      ce.aomap,
      ce.lightmap,
      ce.fog
    ]),
    vertexShader: ke.meshbasic_vert,
    fragmentShader: ke.meshbasic_frag
  },
  lambert: {
    uniforms: /* @__PURE__ */ $t([
      ce.common,
      ce.specularmap,
      ce.envmap,
      ce.aomap,
      ce.lightmap,
      ce.emissivemap,
      ce.bumpmap,
      ce.normalmap,
      ce.displacementmap,
      ce.fog,
      ce.lights,
      {
        emissive: { value: /* @__PURE__ */ new Ne(0) }
      }
    ]),
    vertexShader: ke.meshlambert_vert,
    fragmentShader: ke.meshlambert_frag
  },
  phong: {
    uniforms: /* @__PURE__ */ $t([
      ce.common,
      ce.specularmap,
      ce.envmap,
      ce.aomap,
      ce.lightmap,
      ce.emissivemap,
      ce.bumpmap,
      ce.normalmap,
      ce.displacementmap,
      ce.fog,
      ce.lights,
      {
        emissive: { value: /* @__PURE__ */ new Ne(0) },
        specular: { value: /* @__PURE__ */ new Ne(1118481) },
        shininess: { value: 30 }
      }
    ]),
    vertexShader: ke.meshphong_vert,
    fragmentShader: ke.meshphong_frag
  },
  standard: {
    uniforms: /* @__PURE__ */ $t([
      ce.common,
      ce.envmap,
      ce.aomap,
      ce.lightmap,
      ce.emissivemap,
      ce.bumpmap,
      ce.normalmap,
      ce.displacementmap,
      ce.roughnessmap,
      ce.metalnessmap,
      ce.fog,
      ce.lights,
      {
        emissive: { value: /* @__PURE__ */ new Ne(0) },
        roughness: { value: 1 },
        metalness: { value: 0 },
        envMapIntensity: { value: 1 }
      }
    ]),
    vertexShader: ke.meshphysical_vert,
    fragmentShader: ke.meshphysical_frag
  },
  toon: {
    uniforms: /* @__PURE__ */ $t([
      ce.common,
      ce.aomap,
      ce.lightmap,
      ce.emissivemap,
      ce.bumpmap,
      ce.normalmap,
      ce.displacementmap,
      ce.gradientmap,
      ce.fog,
      ce.lights,
      {
        emissive: { value: /* @__PURE__ */ new Ne(0) }
      }
    ]),
    vertexShader: ke.meshtoon_vert,
    fragmentShader: ke.meshtoon_frag
  },
  matcap: {
    uniforms: /* @__PURE__ */ $t([
      ce.common,
      ce.bumpmap,
      ce.normalmap,
      ce.displacementmap,
      ce.fog,
      {
        matcap: { value: null }
      }
    ]),
    vertexShader: ke.meshmatcap_vert,
    fragmentShader: ke.meshmatcap_frag
  },
  points: {
    uniforms: /* @__PURE__ */ $t([
      ce.points,
      ce.fog
    ]),
    vertexShader: ke.points_vert,
    fragmentShader: ke.points_frag
  },
  dashed: {
    uniforms: /* @__PURE__ */ $t([
      ce.common,
      ce.fog,
      {
        scale: { value: 1 },
        dashSize: { value: 1 },
        totalSize: { value: 2 }
      }
    ]),
    vertexShader: ke.linedashed_vert,
    fragmentShader: ke.linedashed_frag
  },
  depth: {
    uniforms: /* @__PURE__ */ $t([
      ce.common,
      ce.displacementmap
    ]),
    vertexShader: ke.depth_vert,
    fragmentShader: ke.depth_frag
  },
  normal: {
    uniforms: /* @__PURE__ */ $t([
      ce.common,
      ce.bumpmap,
      ce.normalmap,
      ce.displacementmap,
      {
        opacity: { value: 1 }
      }
    ]),
    vertexShader: ke.meshnormal_vert,
    fragmentShader: ke.meshnormal_frag
  },
  sprite: {
    uniforms: /* @__PURE__ */ $t([
      ce.sprite,
      ce.fog
    ]),
    vertexShader: ke.sprite_vert,
    fragmentShader: ke.sprite_frag
  },
  background: {
    uniforms: {
      uvTransform: { value: /* @__PURE__ */ new Be() },
      t2D: { value: null },
      backgroundIntensity: { value: 1 }
    },
    vertexShader: ke.background_vert,
    fragmentShader: ke.background_frag
  },
  backgroundCube: {
    uniforms: {
      envMap: { value: null },
      flipEnvMap: { value: -1 },
      backgroundBlurriness: { value: 0 },
      backgroundIntensity: { value: 1 },
      backgroundRotation: { value: /* @__PURE__ */ new Be() }
    },
    vertexShader: ke.backgroundCube_vert,
    fragmentShader: ke.backgroundCube_frag
  },
  cube: {
    uniforms: {
      tCube: { value: null },
      tFlip: { value: -1 },
      opacity: { value: 1 }
    },
    vertexShader: ke.cube_vert,
    fragmentShader: ke.cube_frag
  },
  equirect: {
    uniforms: {
      tEquirect: { value: null }
    },
    vertexShader: ke.equirect_vert,
    fragmentShader: ke.equirect_frag
  },
  distance: {
    uniforms: /* @__PURE__ */ $t([
      ce.common,
      ce.displacementmap,
      {
        referencePosition: { value: /* @__PURE__ */ new O() },
        nearDistance: { value: 1 },
        farDistance: { value: 1e3 }
      }
    ]),
    vertexShader: ke.distance_vert,
    fragmentShader: ke.distance_frag
  },
  shadow: {
    uniforms: /* @__PURE__ */ $t([
      ce.lights,
      ce.fog,
      {
        color: { value: /* @__PURE__ */ new Ne(0) },
        opacity: { value: 1 }
      }
    ]),
    vertexShader: ke.shadow_vert,
    fragmentShader: ke.shadow_frag
  }
};
Ui.physical = {
  uniforms: /* @__PURE__ */ $t([
    Ui.standard.uniforms,
    {
      clearcoat: { value: 0 },
      clearcoatMap: { value: null },
      clearcoatMapTransform: { value: /* @__PURE__ */ new Be() },
      clearcoatNormalMap: { value: null },
      clearcoatNormalMapTransform: { value: /* @__PURE__ */ new Be() },
      clearcoatNormalScale: { value: /* @__PURE__ */ new Ye(1, 1) },
      clearcoatRoughness: { value: 0 },
      clearcoatRoughnessMap: { value: null },
      clearcoatRoughnessMapTransform: { value: /* @__PURE__ */ new Be() },
      dispersion: { value: 0 },
      iridescence: { value: 0 },
      iridescenceMap: { value: null },
      iridescenceMapTransform: { value: /* @__PURE__ */ new Be() },
      iridescenceIOR: { value: 1.3 },
      iridescenceThicknessMinimum: { value: 100 },
      iridescenceThicknessMaximum: { value: 400 },
      iridescenceThicknessMap: { value: null },
      iridescenceThicknessMapTransform: { value: /* @__PURE__ */ new Be() },
      sheen: { value: 0 },
      sheenColor: { value: /* @__PURE__ */ new Ne(0) },
      sheenColorMap: { value: null },
      sheenColorMapTransform: { value: /* @__PURE__ */ new Be() },
      sheenRoughness: { value: 1 },
      sheenRoughnessMap: { value: null },
      sheenRoughnessMapTransform: { value: /* @__PURE__ */ new Be() },
      transmission: { value: 0 },
      transmissionMap: { value: null },
      transmissionMapTransform: { value: /* @__PURE__ */ new Be() },
      transmissionSamplerSize: { value: /* @__PURE__ */ new Ye() },
      transmissionSamplerMap: { value: null },
      thickness: { value: 0 },
      thicknessMap: { value: null },
      thicknessMapTransform: { value: /* @__PURE__ */ new Be() },
      attenuationDistance: { value: 0 },
      attenuationColor: { value: /* @__PURE__ */ new Ne(0) },
      specularColor: { value: /* @__PURE__ */ new Ne(1, 1, 1) },
      specularColorMap: { value: null },
      specularColorMapTransform: { value: /* @__PURE__ */ new Be() },
      specularIntensity: { value: 1 },
      specularIntensityMap: { value: null },
      specularIntensityMapTransform: { value: /* @__PURE__ */ new Be() },
      anisotropyVector: { value: /* @__PURE__ */ new Ye() },
      anisotropyMap: { value: null },
      anisotropyMapTransform: { value: /* @__PURE__ */ new Be() }
    }
  ]),
  vertexShader: ke.meshphysical_vert,
  fragmentShader: ke.meshphysical_frag
};
const ga = { r: 0, b: 0, g: 0 }, Hn = /* @__PURE__ */ new kt(), By = /* @__PURE__ */ new ze();
function ky(s, e, t, i, n, r, a) {
  const o = new Ne(0);
  let l = r === !0 ? 0 : 1, c, h, d = null, u = 0, f = null;
  function g(M) {
    let T = M.isScene === !0 ? M.background : null;
    return T && T.isTexture && (T = (M.backgroundBlurriness > 0 ? t : e).get(T)), T;
  }
  function v(M) {
    let T = !1;
    const E = g(M);
    E === null ? p(o, l) : E && E.isColor && (p(E, 1), T = !0);
    const A = s.xr.getEnvironmentBlendMode();
    A === "additive" ? i.buffers.color.setClear(0, 0, 0, 1, a) : A === "alpha-blend" && i.buffers.color.setClear(0, 0, 0, 0, a), (s.autoClear || T) && (i.buffers.depth.setTest(!0), i.buffers.depth.setMask(!0), i.buffers.color.setMask(!0), s.clear(s.autoClearColor, s.autoClearDepth, s.autoClearStencil));
  }
  function m(M, T) {
    const E = g(T);
    E && (E.isCubeTexture || E.mapping === ho) ? (h === void 0 && (h = new zt(
      new Fr(1, 1, 1),
      new oi({
        name: "BackgroundCubeMaterial",
        uniforms: ks(Ui.backgroundCube.uniforms),
        vertexShader: Ui.backgroundCube.vertexShader,
        fragmentShader: Ui.backgroundCube.fragmentShader,
        side: Kt,
        depthTest: !1,
        depthWrite: !1,
        fog: !1,
        allowOverride: !1
      })
    ), h.geometry.deleteAttribute("normal"), h.geometry.deleteAttribute("uv"), h.onBeforeRender = function(A, R, F) {
      this.matrixWorld.copyPosition(F.matrixWorld);
    }, Object.defineProperty(h.material, "envMap", {
      get: function() {
        return this.uniforms.envMap.value;
      }
    }), n.update(h)), Hn.copy(T.backgroundRotation), Hn.x *= -1, Hn.y *= -1, Hn.z *= -1, E.isCubeTexture && E.isRenderTargetTexture === !1 && (Hn.y *= -1, Hn.z *= -1), h.material.uniforms.envMap.value = E, h.material.uniforms.flipEnvMap.value = E.isCubeTexture && E.isRenderTargetTexture === !1 ? -1 : 1, h.material.uniforms.backgroundBlurriness.value = T.backgroundBlurriness, h.material.uniforms.backgroundIntensity.value = T.backgroundIntensity, h.material.uniforms.backgroundRotation.value.setFromMatrix4(By.makeRotationFromEuler(Hn)), h.material.toneMapped = Ke.getTransfer(E.colorSpace) !== lt, (d !== E || u !== E.version || f !== s.toneMapping) && (h.material.needsUpdate = !0, d = E, u = E.version, f = s.toneMapping), h.layers.enableAll(), M.unshift(h, h.geometry, h.material, 0, 0, null)) : E && E.isTexture && (c === void 0 && (c = new zt(
      new Br(2, 2),
      new oi({
        name: "BackgroundMaterial",
        uniforms: ks(Ui.background.uniforms),
        vertexShader: Ui.background.vertexShader,
        fragmentShader: Ui.background.fragmentShader,
        side: hn,
        depthTest: !1,
        depthWrite: !1,
        fog: !1,
        allowOverride: !1
      })
    ), c.geometry.deleteAttribute("normal"), Object.defineProperty(c.material, "map", {
      get: function() {
        return this.uniforms.t2D.value;
      }
    }), n.update(c)), c.material.uniforms.t2D.value = E, c.material.uniforms.backgroundIntensity.value = T.backgroundIntensity, c.material.toneMapped = Ke.getTransfer(E.colorSpace) !== lt, E.matrixAutoUpdate === !0 && E.updateMatrix(), c.material.uniforms.uvTransform.value.copy(E.matrix), (d !== E || u !== E.version || f !== s.toneMapping) && (c.material.needsUpdate = !0, d = E, u = E.version, f = s.toneMapping), c.layers.enableAll(), M.unshift(c, c.geometry, c.material, 0, 0, null));
  }
  function p(M, T) {
    M.getRGB(ga, sf(s)), i.buffers.color.setClear(ga.r, ga.g, ga.b, T, a);
  }
  function w() {
    h !== void 0 && (h.geometry.dispose(), h.material.dispose(), h = void 0), c !== void 0 && (c.geometry.dispose(), c.material.dispose(), c = void 0);
  }
  return {
    getClearColor: function() {
      return o;
    },
    setClearColor: function(M, T = 1) {
      o.set(M), l = T, p(o, l);
    },
    getClearAlpha: function() {
      return l;
    },
    setClearAlpha: function(M) {
      l = M, p(o, l);
    },
    render: v,
    addToRenderList: m,
    dispose: w
  };
}
function zy(s, e) {
  const t = s.getParameter(s.MAX_VERTEX_ATTRIBS), i = {}, n = u(null);
  let r = n, a = !1;
  function o(b, P, H, V, Y) {
    let X = !1;
    const q = d(V, H, P);
    r !== q && (r = q, c(r.object)), X = f(b, V, H, Y), X && g(b, V, H, Y), Y !== null && e.update(Y, s.ELEMENT_ARRAY_BUFFER), (X || a) && (a = !1, T(b, P, H, V), Y !== null && s.bindBuffer(s.ELEMENT_ARRAY_BUFFER, e.get(Y).buffer));
  }
  function l() {
    return s.createVertexArray();
  }
  function c(b) {
    return s.bindVertexArray(b);
  }
  function h(b) {
    return s.deleteVertexArray(b);
  }
  function d(b, P, H) {
    const V = H.wireframe === !0;
    let Y = i[b.id];
    Y === void 0 && (Y = {}, i[b.id] = Y);
    let X = Y[P.id];
    X === void 0 && (X = {}, Y[P.id] = X);
    let q = X[V];
    return q === void 0 && (q = u(l()), X[V] = q), q;
  }
  function u(b) {
    const P = [], H = [], V = [];
    for (let Y = 0; Y < t; Y++)
      P[Y] = 0, H[Y] = 0, V[Y] = 0;
    return {
      // for backward compatibility on non-VAO support browser
      geometry: null,
      program: null,
      wireframe: !1,
      newAttributes: P,
      enabledAttributes: H,
      attributeDivisors: V,
      object: b,
      attributes: {},
      index: null
    };
  }
  function f(b, P, H, V) {
    const Y = r.attributes, X = P.attributes;
    let q = 0;
    const z = H.getAttributes();
    for (const J in z)
      if (z[J].location >= 0) {
        const le = Y[J];
        let fe = X[J];
        if (fe === void 0 && (J === "instanceMatrix" && b.instanceMatrix && (fe = b.instanceMatrix), J === "instanceColor" && b.instanceColor && (fe = b.instanceColor)), le === void 0 || le.attribute !== fe || fe && le.data !== fe.data) return !0;
        q++;
      }
    return r.attributesNum !== q || r.index !== V;
  }
  function g(b, P, H, V) {
    const Y = {}, X = P.attributes;
    let q = 0;
    const z = H.getAttributes();
    for (const J in z)
      if (z[J].location >= 0) {
        let le = X[J];
        le === void 0 && (J === "instanceMatrix" && b.instanceMatrix && (le = b.instanceMatrix), J === "instanceColor" && b.instanceColor && (le = b.instanceColor));
        const fe = {};
        fe.attribute = le, le && le.data && (fe.data = le.data), Y[J] = fe, q++;
      }
    r.attributes = Y, r.attributesNum = q, r.index = V;
  }
  function v() {
    const b = r.newAttributes;
    for (let P = 0, H = b.length; P < H; P++)
      b[P] = 0;
  }
  function m(b) {
    p(b, 0);
  }
  function p(b, P) {
    const H = r.newAttributes, V = r.enabledAttributes, Y = r.attributeDivisors;
    H[b] = 1, V[b] === 0 && (s.enableVertexAttribArray(b), V[b] = 1), Y[b] !== P && (s.vertexAttribDivisor(b, P), Y[b] = P);
  }
  function w() {
    const b = r.newAttributes, P = r.enabledAttributes;
    for (let H = 0, V = P.length; H < V; H++)
      P[H] !== b[H] && (s.disableVertexAttribArray(H), P[H] = 0);
  }
  function M(b, P, H, V, Y, X, q) {
    q === !0 ? s.vertexAttribIPointer(b, P, H, Y, X) : s.vertexAttribPointer(b, P, H, V, Y, X);
  }
  function T(b, P, H, V) {
    v();
    const Y = V.attributes, X = H.getAttributes(), q = P.defaultAttributeValues;
    for (const z in X) {
      const J = X[z];
      if (J.location >= 0) {
        let ue = Y[z];
        if (ue === void 0 && (z === "instanceMatrix" && b.instanceMatrix && (ue = b.instanceMatrix), z === "instanceColor" && b.instanceColor && (ue = b.instanceColor)), ue !== void 0) {
          const le = ue.normalized, fe = ue.itemSize, Ge = e.get(ue);
          if (Ge === void 0) continue;
          const Ve = Ge.buffer, yt = Ge.type, vt = Ge.bytesPerElement, j = yt === s.INT || yt === s.UNSIGNED_INT || ue.gpuType === zc;
          if (ue.isInterleavedBufferAttribute) {
            const Q = ue.data, ge = Q.stride, Fe = ue.offset;
            if (Q.isInstancedInterleavedBuffer) {
              for (let xe = 0; xe < J.locationSize; xe++)
                p(J.location + xe, Q.meshPerAttribute);
              b.isInstancedMesh !== !0 && V._maxInstanceCount === void 0 && (V._maxInstanceCount = Q.meshPerAttribute * Q.count);
            } else
              for (let xe = 0; xe < J.locationSize; xe++)
                m(J.location + xe);
            s.bindBuffer(s.ARRAY_BUFFER, Ve);
            for (let xe = 0; xe < J.locationSize; xe++)
              M(
                J.location + xe,
                fe / J.locationSize,
                yt,
                le,
                ge * vt,
                (Fe + fe / J.locationSize * xe) * vt,
                j
              );
          } else {
            if (ue.isInstancedBufferAttribute) {
              for (let Q = 0; Q < J.locationSize; Q++)
                p(J.location + Q, ue.meshPerAttribute);
              b.isInstancedMesh !== !0 && V._maxInstanceCount === void 0 && (V._maxInstanceCount = ue.meshPerAttribute * ue.count);
            } else
              for (let Q = 0; Q < J.locationSize; Q++)
                m(J.location + Q);
            s.bindBuffer(s.ARRAY_BUFFER, Ve);
            for (let Q = 0; Q < J.locationSize; Q++)
              M(
                J.location + Q,
                fe / J.locationSize,
                yt,
                le,
                fe * vt,
                fe / J.locationSize * Q * vt,
                j
              );
          }
        } else if (q !== void 0) {
          const le = q[z];
          if (le !== void 0)
            switch (le.length) {
              case 2:
                s.vertexAttrib2fv(J.location, le);
                break;
              case 3:
                s.vertexAttrib3fv(J.location, le);
                break;
              case 4:
                s.vertexAttrib4fv(J.location, le);
                break;
              default:
                s.vertexAttrib1fv(J.location, le);
            }
        }
      }
    }
    w();
  }
  function E() {
    F();
    for (const b in i) {
      const P = i[b];
      for (const H in P) {
        const V = P[H];
        for (const Y in V)
          h(V[Y].object), delete V[Y];
        delete P[H];
      }
      delete i[b];
    }
  }
  function A(b) {
    if (i[b.id] === void 0) return;
    const P = i[b.id];
    for (const H in P) {
      const V = P[H];
      for (const Y in V)
        h(V[Y].object), delete V[Y];
      delete P[H];
    }
    delete i[b.id];
  }
  function R(b) {
    for (const P in i) {
      const H = i[P];
      if (H[b.id] === void 0) continue;
      const V = H[b.id];
      for (const Y in V)
        h(V[Y].object), delete V[Y];
      delete H[b.id];
    }
  }
  function F() {
    y(), a = !0, r !== n && (r = n, c(r.object));
  }
  function y() {
    n.geometry = null, n.program = null, n.wireframe = !1;
  }
  return {
    setup: o,
    reset: F,
    resetDefaultState: y,
    dispose: E,
    releaseStatesOfGeometry: A,
    releaseStatesOfProgram: R,
    initAttributes: v,
    enableAttribute: m,
    disableUnusedAttributes: w
  };
}
function Vy(s, e, t) {
  let i;
  function n(c) {
    i = c;
  }
  function r(c, h) {
    s.drawArrays(i, c, h), t.update(h, i, 1);
  }
  function a(c, h, d) {
    d !== 0 && (s.drawArraysInstanced(i, c, h, d), t.update(h, i, d));
  }
  function o(c, h, d) {
    if (d === 0) return;
    e.get("WEBGL_multi_draw").multiDrawArraysWEBGL(i, c, 0, h, 0, d);
    let f = 0;
    for (let g = 0; g < d; g++)
      f += h[g];
    t.update(f, i, 1);
  }
  function l(c, h, d, u) {
    if (d === 0) return;
    const f = e.get("WEBGL_multi_draw");
    if (f === null)
      for (let g = 0; g < c.length; g++)
        a(c[g], h[g], u[g]);
    else {
      f.multiDrawArraysInstancedWEBGL(i, c, 0, h, 0, u, 0, d);
      let g = 0;
      for (let v = 0; v < d; v++)
        g += h[v] * u[v];
      t.update(g, i, 1);
    }
  }
  this.setMode = n, this.render = r, this.renderInstances = a, this.renderMultiDraw = o, this.renderMultiDrawInstances = l;
}
function Hy(s, e, t, i) {
  let n;
  function r() {
    if (n !== void 0) return n;
    if (e.has("EXT_texture_filter_anisotropic") === !0) {
      const R = e.get("EXT_texture_filter_anisotropic");
      n = s.getParameter(R.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
    } else
      n = 0;
    return n;
  }
  function a(R) {
    return !(R !== mi && i.convert(R) !== s.getParameter(s.IMPLEMENTATION_COLOR_READ_FORMAT));
  }
  function o(R) {
    const F = R === Ai && (e.has("EXT_color_buffer_half_float") || e.has("EXT_color_buffer_float"));
    return !(R !== ii && i.convert(R) !== s.getParameter(s.IMPLEMENTATION_COLOR_READ_TYPE) && // Edge and Chrome Mac < 52 (#9513)
    R !== pi && !F);
  }
  function l(R) {
    if (R === "highp") {
      if (s.getShaderPrecisionFormat(s.VERTEX_SHADER, s.HIGH_FLOAT).precision > 0 && s.getShaderPrecisionFormat(s.FRAGMENT_SHADER, s.HIGH_FLOAT).precision > 0)
        return "highp";
      R = "mediump";
    }
    return R === "mediump" && s.getShaderPrecisionFormat(s.VERTEX_SHADER, s.MEDIUM_FLOAT).precision > 0 && s.getShaderPrecisionFormat(s.FRAGMENT_SHADER, s.MEDIUM_FLOAT).precision > 0 ? "mediump" : "lowp";
  }
  let c = t.precision !== void 0 ? t.precision : "highp";
  const h = l(c);
  h !== c && (Te("WebGLRenderer:", c, "not supported, using", h, "instead."), c = h);
  const d = t.logarithmicDepthBuffer === !0, u = t.reversedDepthBuffer === !0 && e.has("EXT_clip_control"), f = s.getParameter(s.MAX_TEXTURE_IMAGE_UNITS), g = s.getParameter(s.MAX_VERTEX_TEXTURE_IMAGE_UNITS), v = s.getParameter(s.MAX_TEXTURE_SIZE), m = s.getParameter(s.MAX_CUBE_MAP_TEXTURE_SIZE), p = s.getParameter(s.MAX_VERTEX_ATTRIBS), w = s.getParameter(s.MAX_VERTEX_UNIFORM_VECTORS), M = s.getParameter(s.MAX_VARYING_VECTORS), T = s.getParameter(s.MAX_FRAGMENT_UNIFORM_VECTORS), E = s.getParameter(s.MAX_SAMPLES), A = s.getParameter(s.SAMPLES);
  return {
    isWebGL2: !0,
    // keeping this for backwards compatibility
    getMaxAnisotropy: r,
    getMaxPrecision: l,
    textureFormatReadable: a,
    textureTypeReadable: o,
    precision: c,
    logarithmicDepthBuffer: d,
    reversedDepthBuffer: u,
    maxTextures: f,
    maxVertexTextures: g,
    maxTextureSize: v,
    maxCubemapSize: m,
    maxAttributes: p,
    maxVertexUniforms: w,
    maxVaryings: M,
    maxFragmentUniforms: T,
    maxSamples: E,
    samples: A
  };
}
function $y(s) {
  const e = this;
  let t = null, i = 0, n = !1, r = !1;
  const a = new qn(), o = new Be(), l = { value: null, needsUpdate: !1 };
  this.uniform = l, this.numPlanes = 0, this.numIntersection = 0, this.init = function(d, u) {
    const f = d.length !== 0 || u || // enable state of previous frame - the clipping code has to
    // run another frame in order to reset the state:
    i !== 0 || n;
    return n = u, i = d.length, f;
  }, this.beginShadows = function() {
    r = !0, h(null);
  }, this.endShadows = function() {
    r = !1;
  }, this.setGlobalState = function(d, u) {
    t = h(d, u, 0);
  }, this.setState = function(d, u, f) {
    const g = d.clippingPlanes, v = d.clipIntersection, m = d.clipShadows, p = s.get(d);
    if (!n || g === null || g.length === 0 || r && !m)
      r ? h(null) : c();
    else {
      const w = r ? 0 : i, M = w * 4;
      let T = p.clippingState || null;
      l.value = T, T = h(g, u, M, f);
      for (let E = 0; E !== M; ++E)
        T[E] = t[E];
      p.clippingState = T, this.numIntersection = v ? this.numPlanes : 0, this.numPlanes += w;
    }
  };
  function c() {
    l.value !== t && (l.value = t, l.needsUpdate = i > 0), e.numPlanes = i, e.numIntersection = 0;
  }
  function h(d, u, f, g) {
    const v = d !== null ? d.length : 0;
    let m = null;
    if (v !== 0) {
      if (m = l.value, g !== !0 || m === null) {
        const p = f + v * 4, w = u.matrixWorldInverse;
        o.getNormalMatrix(w), (m === null || m.length < p) && (m = new Float32Array(p));
        for (let M = 0, T = f; M !== v; ++M, T += 4)
          a.copy(d[M]).applyMatrix4(w, o), a.normal.toArray(m, T), m[T + 3] = a.constant;
      }
      l.value = m, l.needsUpdate = !0;
    }
    return e.numPlanes = v, e.numIntersection = 0, m;
  }
}
function Gy(s) {
  let e = /* @__PURE__ */ new WeakMap();
  function t(a, o) {
    return o === Al ? a.mapping = ts : o === Rl && (a.mapping = Os), a;
  }
  function i(a) {
    if (a && a.isTexture) {
      const o = a.mapping;
      if (o === Al || o === Rl)
        if (e.has(a)) {
          const l = e.get(a).texture;
          return t(l, a.mapping);
        } else {
          const l = a.image;
          if (l && l.height > 0) {
            const c = new of(l.height);
            return c.fromEquirectangularTexture(s, a), e.set(a, c), a.addEventListener("dispose", n), t(c.texture, a.mapping);
          } else
            return null;
        }
    }
    return a;
  }
  function n(a) {
    const o = a.target;
    o.removeEventListener("dispose", n);
    const l = e.get(o);
    l !== void 0 && (e.delete(o), l.dispose());
  }
  function r() {
    e = /* @__PURE__ */ new WeakMap();
  }
  return {
    get: i,
    dispose: r
  };
}
const Tn = 4, Dd = [0.125, 0.215, 0.35, 0.446, 0.526, 0.582], Xn = 20, qy = 256, or = /* @__PURE__ */ new zr(), Nd = /* @__PURE__ */ new Ne();
let Ko = null, Zo = 0, Jo = 0, Qo = !1;
const Wy = /* @__PURE__ */ new O();
class Od {
  /**
   * Constructs a new PMREM generator.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   */
  constructor(e) {
    this._renderer = e, this._pingPongRenderTarget = null, this._lodMax = 0, this._cubeSize = 0, this._sizeLods = [], this._sigmas = [], this._lodMeshes = [], this._backgroundBox = null, this._cubemapMaterial = null, this._equirectMaterial = null, this._blurMaterial = null, this._ggxMaterial = null;
  }
  /**
   * Generates a PMREM from a supplied Scene, which can be faster than using an
   * image if networking bandwidth is low. Optional sigma specifies a blur radius
   * in radians to be applied to the scene before PMREM generation. Optional near
   * and far planes ensure the scene is rendered in its entirety.
   *
   * @param {Scene} scene - The scene to be captured.
   * @param {number} [sigma=0] - The blur radius in radians.
   * @param {number} [near=0.1] - The near plane distance.
   * @param {number} [far=100] - The far plane distance.
   * @param {Object} [options={}] - The configuration options.
   * @param {number} [options.size=256] - The texture size of the PMREM.
   * @param {Vector3} [options.position=origin] - The position of the internal cube camera that renders the scene.
   * @return {WebGLRenderTarget} The resulting PMREM.
   */
  fromScene(e, t = 0, i = 0.1, n = 100, r = {}) {
    const {
      size: a = 256,
      position: o = Wy
    } = r;
    Ko = this._renderer.getRenderTarget(), Zo = this._renderer.getActiveCubeFace(), Jo = this._renderer.getActiveMipmapLevel(), Qo = this._renderer.xr.enabled, this._renderer.xr.enabled = !1, this._setSize(a);
    const l = this._allocateTargets();
    return l.depthBuffer = !0, this._sceneToCubeUV(e, i, n, l, o), t > 0 && this._blur(l, 0, 0, t), this._applyPMREM(l), this._cleanup(l), l;
  }
  /**
   * Generates a PMREM from an equirectangular texture, which can be either LDR
   * or HDR. The ideal input image size is 1k (1024 x 512),
   * as this matches best with the 256 x 256 cubemap output.
   *
   * @param {Texture} equirectangular - The equirectangular texture to be converted.
   * @param {?WebGLRenderTarget} [renderTarget=null] - The render target to use.
   * @return {WebGLRenderTarget} The resulting PMREM.
   */
  fromEquirectangular(e, t = null) {
    return this._fromTexture(e, t);
  }
  /**
   * Generates a PMREM from an cubemap texture, which can be either LDR
   * or HDR. The ideal input cube size is 256 x 256,
   * as this matches best with the 256 x 256 cubemap output.
   *
   * @param {Texture} cubemap - The cubemap texture to be converted.
   * @param {?WebGLRenderTarget} [renderTarget=null] - The render target to use.
   * @return {WebGLRenderTarget} The resulting PMREM.
   */
  fromCubemap(e, t = null) {
    return this._fromTexture(e, t);
  }
  /**
   * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
   * your texture's network fetch for increased concurrency.
   */
  compileCubemapShader() {
    this._cubemapMaterial === null && (this._cubemapMaterial = Bd(), this._compileMaterial(this._cubemapMaterial));
  }
  /**
   * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
   * your texture's network fetch for increased concurrency.
   */
  compileEquirectangularShader() {
    this._equirectMaterial === null && (this._equirectMaterial = Fd(), this._compileMaterial(this._equirectMaterial));
  }
  /**
   * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
   * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
   * one of them will cause any others to also become unusable.
   */
  dispose() {
    this._dispose(), this._cubemapMaterial !== null && this._cubemapMaterial.dispose(), this._equirectMaterial !== null && this._equirectMaterial.dispose(), this._backgroundBox !== null && (this._backgroundBox.geometry.dispose(), this._backgroundBox.material.dispose());
  }
  // private interface
  _setSize(e) {
    this._lodMax = Math.floor(Math.log2(e)), this._cubeSize = Math.pow(2, this._lodMax);
  }
  _dispose() {
    this._blurMaterial !== null && this._blurMaterial.dispose(), this._ggxMaterial !== null && this._ggxMaterial.dispose(), this._pingPongRenderTarget !== null && this._pingPongRenderTarget.dispose();
    for (let e = 0; e < this._lodMeshes.length; e++)
      this._lodMeshes[e].geometry.dispose();
  }
  _cleanup(e) {
    this._renderer.setRenderTarget(Ko, Zo, Jo), this._renderer.xr.enabled = Qo, e.scissorTest = !1, ws(e, 0, 0, e.width, e.height);
  }
  _fromTexture(e, t) {
    e.mapping === ts || e.mapping === Os ? this._setSize(e.image.length === 0 ? 16 : e.image[0].width || e.image[0].image.width) : this._setSize(e.image.width / 4), Ko = this._renderer.getRenderTarget(), Zo = this._renderer.getActiveCubeFace(), Jo = this._renderer.getActiveMipmapLevel(), Qo = this._renderer.xr.enabled, this._renderer.xr.enabled = !1;
    const i = t || this._allocateTargets();
    return this._textureToCubeUV(e, i), this._applyPMREM(i), this._cleanup(i), i;
  }
  _allocateTargets() {
    const e = 3 * Math.max(this._cubeSize, 112), t = 4 * this._cubeSize, i = {
      magFilter: bt,
      minFilter: bt,
      generateMipmaps: !1,
      type: Ai,
      format: mi,
      colorSpace: Wt,
      depthBuffer: !1
    }, n = Ud(e, t, i);
    if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== e || this._pingPongRenderTarget.height !== t) {
      this._pingPongRenderTarget !== null && this._dispose(), this._pingPongRenderTarget = Ud(e, t, i);
      const { _lodMax: r } = this;
      ({ lodMeshes: this._lodMeshes, sizeLods: this._sizeLods, sigmas: this._sigmas } = Xy(r)), this._blurMaterial = Yy(r, e, t), this._ggxMaterial = jy(r, e, t);
    }
    return n;
  }
  _compileMaterial(e) {
    const t = new zt(new ci(), e);
    this._renderer.compile(t, or);
  }
  _sceneToCubeUV(e, t, i, n, r) {
    const l = new Gt(90, 1, t, i), c = [1, -1, 1, 1, 1, 1], h = [1, 1, 1, -1, -1, -1], d = this._renderer, u = d.autoClear, f = d.toneMapping;
    d.getClearColor(Nd), d.toneMapping = zi, d.autoClear = !1, d.state.buffers.depth.getReversed() && (d.setRenderTarget(n), d.clearDepth(), d.setRenderTarget(null)), this._backgroundBox === null && (this._backgroundBox = new zt(
      new Fr(),
      new sn({
        name: "PMREM.Background",
        side: Kt,
        depthWrite: !1,
        depthTest: !1
      })
    ));
    const v = this._backgroundBox, m = v.material;
    let p = !1;
    const w = e.background;
    w ? w.isColor && (m.color.copy(w), e.background = null, p = !0) : (m.color.copy(Nd), p = !0);
    for (let M = 0; M < 6; M++) {
      const T = M % 3;
      T === 0 ? (l.up.set(0, c[M], 0), l.position.set(r.x, r.y, r.z), l.lookAt(r.x + h[M], r.y, r.z)) : T === 1 ? (l.up.set(0, 0, c[M]), l.position.set(r.x, r.y, r.z), l.lookAt(r.x, r.y + h[M], r.z)) : (l.up.set(0, c[M], 0), l.position.set(r.x, r.y, r.z), l.lookAt(r.x, r.y, r.z + h[M]));
      const E = this._cubeSize;
      ws(n, T * E, M > 2 ? E : 0, E, E), d.setRenderTarget(n), p && d.render(v, l), d.render(e, l);
    }
    d.toneMapping = f, d.autoClear = u, e.background = w;
  }
  _textureToCubeUV(e, t) {
    const i = this._renderer, n = e.mapping === ts || e.mapping === Os;
    n ? (this._cubemapMaterial === null && (this._cubemapMaterial = Bd()), this._cubemapMaterial.uniforms.flipEnvMap.value = e.isRenderTargetTexture === !1 ? -1 : 1) : this._equirectMaterial === null && (this._equirectMaterial = Fd());
    const r = n ? this._cubemapMaterial : this._equirectMaterial, a = this._lodMeshes[0];
    a.material = r;
    const o = r.uniforms;
    o.envMap.value = e;
    const l = this._cubeSize;
    ws(t, 0, 0, 3 * l, 2 * l), i.setRenderTarget(t), i.render(a, or);
  }
  _applyPMREM(e) {
    const t = this._renderer, i = t.autoClear;
    t.autoClear = !1;
    const n = this._lodMeshes.length;
    for (let r = 1; r < n; r++)
      this._applyGGXFilter(e, r - 1, r);
    t.autoClear = i;
  }
  /**
   * Applies GGX VNDF importance sampling filter to generate a prefiltered environment map.
   * Uses Monte Carlo integration with VNDF importance sampling to accurately represent the
   * GGX BRDF for physically-based rendering. Reads from the previous LOD level and
   * applies incremental roughness filtering to avoid over-blurring.
   *
   * @private
   * @param {WebGLRenderTarget} cubeUVRenderTarget
   * @param {number} lodIn - Source LOD level to read from
   * @param {number} lodOut - Target LOD level to write to
   */
  _applyGGXFilter(e, t, i) {
    const n = this._renderer, r = this._pingPongRenderTarget, a = this._ggxMaterial, o = this._lodMeshes[i];
    o.material = a;
    const l = a.uniforms, c = i / (this._lodMeshes.length - 1), h = t / (this._lodMeshes.length - 1), d = Math.sqrt(c * c - h * h), u = 0 + c * 1.25, f = d * u, { _lodMax: g } = this, v = this._sizeLods[i], m = 3 * v * (i > g - Tn ? i - g + Tn : 0), p = 4 * (this._cubeSize - v);
    l.envMap.value = e.texture, l.roughness.value = f, l.mipInt.value = g - t, ws(r, m, p, 3 * v, 2 * v), n.setRenderTarget(r), n.render(o, or), l.envMap.value = r.texture, l.roughness.value = 0, l.mipInt.value = g - i, ws(e, m, p, 3 * v, 2 * v), n.setRenderTarget(e), n.render(o, or);
  }
  /**
   * This is a two-pass Gaussian blur for a cubemap. Normally this is done
   * vertically and horizontally, but this breaks down on a cube. Here we apply
   * the blur latitudinally (around the poles), and then longitudinally (towards
   * the poles) to approximate the orthogonally-separable blur. It is least
   * accurate at the poles, but still does a decent job.
   *
   * Used for initial scene blur in fromScene() method when sigma > 0.
   *
   * @private
   * @param {WebGLRenderTarget} cubeUVRenderTarget
   * @param {number} lodIn
   * @param {number} lodOut
   * @param {number} sigma
   * @param {Vector3} [poleAxis]
   */
  _blur(e, t, i, n, r) {
    const a = this._pingPongRenderTarget;
    this._halfBlur(
      e,
      a,
      t,
      i,
      n,
      "latitudinal",
      r
    ), this._halfBlur(
      a,
      e,
      i,
      i,
      n,
      "longitudinal",
      r
    );
  }
  _halfBlur(e, t, i, n, r, a, o) {
    const l = this._renderer, c = this._blurMaterial;
    a !== "latitudinal" && a !== "longitudinal" && Ce(
      "blur direction must be either latitudinal or longitudinal!"
    );
    const h = 3, d = this._lodMeshes[n];
    d.material = c;
    const u = c.uniforms, f = this._sizeLods[i] - 1, g = isFinite(r) ? Math.PI / (2 * f) : 2 * Math.PI / (2 * Xn - 1), v = r / g, m = isFinite(r) ? 1 + Math.floor(h * v) : Xn;
    m > Xn && Te(`sigmaRadians, ${r}, is too large and will clip, as it requested ${m} samples when the maximum is set to ${Xn}`);
    const p = [];
    let w = 0;
    for (let R = 0; R < Xn; ++R) {
      const F = R / v, y = Math.exp(-F * F / 2);
      p.push(y), R === 0 ? w += y : R < m && (w += 2 * y);
    }
    for (let R = 0; R < p.length; R++)
      p[R] = p[R] / w;
    u.envMap.value = e.texture, u.samples.value = m, u.weights.value = p, u.latitudinal.value = a === "latitudinal", o && (u.poleAxis.value = o);
    const { _lodMax: M } = this;
    u.dTheta.value = g, u.mipInt.value = M - i;
    const T = this._sizeLods[n], E = 3 * T * (n > M - Tn ? n - M + Tn : 0), A = 4 * (this._cubeSize - T);
    ws(t, E, A, 3 * T, 2 * T), l.setRenderTarget(t), l.render(d, or);
  }
}
function Xy(s) {
  const e = [], t = [], i = [];
  let n = s;
  const r = s - Tn + 1 + Dd.length;
  for (let a = 0; a < r; a++) {
    const o = Math.pow(2, n);
    e.push(o);
    let l = 1 / o;
    a > s - Tn ? l = Dd[a - s + Tn - 1] : a === 0 && (l = 0), t.push(l);
    const c = 1 / (o - 2), h = -c, d = 1 + c, u = [h, h, d, h, d, d, h, h, d, d, h, d], f = 6, g = 6, v = 3, m = 2, p = 1, w = new Float32Array(v * g * f), M = new Float32Array(m * g * f), T = new Float32Array(p * g * f);
    for (let A = 0; A < f; A++) {
      const R = A % 3 * 2 / 3 - 1, F = A > 2 ? 0 : -1, y = [
        R,
        F,
        0,
        R + 2 / 3,
        F,
        0,
        R + 2 / 3,
        F + 1,
        0,
        R,
        F,
        0,
        R + 2 / 3,
        F + 1,
        0,
        R,
        F + 1,
        0
      ];
      w.set(y, v * g * A), M.set(u, m * g * A);
      const b = [A, A, A, A, A, A];
      T.set(b, p * g * A);
    }
    const E = new ci();
    E.setAttribute("position", new qt(w, v)), E.setAttribute("uv", new qt(M, m)), E.setAttribute("faceIndex", new qt(T, p)), i.push(new zt(E, null)), n > Tn && n--;
  }
  return { lodMeshes: i, sizeLods: e, sigmas: t };
}
function Ud(s, e, t) {
  const i = new gi(s, e, t);
  return i.texture.mapping = ho, i.texture.name = "PMREM.cubeUv", i.scissorTest = !0, i;
}
function ws(s, e, t, i, n) {
  s.viewport.set(e, t, i, n), s.scissor.set(e, t, i, n);
}
function jy(s, e, t) {
  return new oi({
    name: "PMREMGGXConvolution",
    defines: {
      GGX_SAMPLES: qy,
      CUBEUV_TEXEL_WIDTH: 1 / e,
      CUBEUV_TEXEL_HEIGHT: 1 / t,
      CUBEUV_MAX_MIP: `${s}.0`
    },
    uniforms: {
      envMap: { value: null },
      roughness: { value: 0 },
      mipInt: { value: 0 }
    },
    vertexShader: po(),
    fragmentShader: (
      /* glsl */
      `

			precision highp float;
			precision highp int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform float roughness;
			uniform float mipInt;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			#define PI 3.14159265359

			// Van der Corput radical inverse
			float radicalInverse_VdC(uint bits) {
				bits = (bits << 16u) | (bits >> 16u);
				bits = ((bits & 0x55555555u) << 1u) | ((bits & 0xAAAAAAAAu) >> 1u);
				bits = ((bits & 0x33333333u) << 2u) | ((bits & 0xCCCCCCCCu) >> 2u);
				bits = ((bits & 0x0F0F0F0Fu) << 4u) | ((bits & 0xF0F0F0F0u) >> 4u);
				bits = ((bits & 0x00FF00FFu) << 8u) | ((bits & 0xFF00FF00u) >> 8u);
				return float(bits) * 2.3283064365386963e-10; // / 0x100000000
			}

			// Hammersley sequence
			vec2 hammersley(uint i, uint N) {
				return vec2(float(i) / float(N), radicalInverse_VdC(i));
			}

			// GGX VNDF importance sampling (Eric Heitz 2018)
			// "Sampling the GGX Distribution of Visible Normals"
			// https://jcgt.org/published/0007/04/01/
			vec3 importanceSampleGGX_VNDF(vec2 Xi, vec3 V, float roughness) {
				float alpha = roughness * roughness;

				// Section 3.2: Transform view direction to hemisphere configuration
				vec3 Vh = normalize(vec3(alpha * V.x, alpha * V.y, V.z));

				// Section 4.1: Orthonormal basis
				float lensq = Vh.x * Vh.x + Vh.y * Vh.y;
				vec3 T1 = lensq > 0.0 ? vec3(-Vh.y, Vh.x, 0.0) / sqrt(lensq) : vec3(1.0, 0.0, 0.0);
				vec3 T2 = cross(Vh, T1);

				// Section 4.2: Parameterization of projected area
				float r = sqrt(Xi.x);
				float phi = 2.0 * PI * Xi.y;
				float t1 = r * cos(phi);
				float t2 = r * sin(phi);
				float s = 0.5 * (1.0 + Vh.z);
				t2 = (1.0 - s) * sqrt(1.0 - t1 * t1) + s * t2;

				// Section 4.3: Reprojection onto hemisphere
				vec3 Nh = t1 * T1 + t2 * T2 + sqrt(max(0.0, 1.0 - t1 * t1 - t2 * t2)) * Vh;

				// Section 3.4: Transform back to ellipsoid configuration
				return normalize(vec3(alpha * Nh.x, alpha * Nh.y, max(0.0, Nh.z)));
			}

			void main() {
				vec3 N = normalize(vOutputDirection);
				vec3 V = N; // Assume view direction equals normal for pre-filtering

				vec3 prefilteredColor = vec3(0.0);
				float totalWeight = 0.0;

				// For very low roughness, just sample the environment directly
				if (roughness < 0.001) {
					gl_FragColor = vec4(bilinearCubeUV(envMap, N, mipInt), 1.0);
					return;
				}

				// Tangent space basis for VNDF sampling
				vec3 up = abs(N.z) < 0.999 ? vec3(0.0, 0.0, 1.0) : vec3(1.0, 0.0, 0.0);
				vec3 tangent = normalize(cross(up, N));
				vec3 bitangent = cross(N, tangent);

				for(uint i = 0u; i < uint(GGX_SAMPLES); i++) {
					vec2 Xi = hammersley(i, uint(GGX_SAMPLES));

					// For PMREM, V = N, so in tangent space V is always (0, 0, 1)
					vec3 H_tangent = importanceSampleGGX_VNDF(Xi, vec3(0.0, 0.0, 1.0), roughness);

					// Transform H back to world space
					vec3 H = normalize(tangent * H_tangent.x + bitangent * H_tangent.y + N * H_tangent.z);
					vec3 L = normalize(2.0 * dot(V, H) * H - V);

					float NdotL = max(dot(N, L), 0.0);

					if(NdotL > 0.0) {
						// Sample environment at fixed mip level
						// VNDF importance sampling handles the distribution filtering
						vec3 sampleColor = bilinearCubeUV(envMap, L, mipInt);

						// Weight by NdotL for the split-sum approximation
						// VNDF PDF naturally accounts for the visible microfacet distribution
						prefilteredColor += sampleColor * NdotL;
						totalWeight += NdotL;
					}
				}

				if (totalWeight > 0.0) {
					prefilteredColor = prefilteredColor / totalWeight;
				}

				gl_FragColor = vec4(prefilteredColor, 1.0);
			}
		`
    ),
    blending: ki,
    depthTest: !1,
    depthWrite: !1
  });
}
function Yy(s, e, t) {
  const i = new Float32Array(Xn), n = new O(0, 1, 0);
  return new oi({
    name: "SphericalGaussianBlur",
    defines: {
      n: Xn,
      CUBEUV_TEXEL_WIDTH: 1 / e,
      CUBEUV_TEXEL_HEIGHT: 1 / t,
      CUBEUV_MAX_MIP: `${s}.0`
    },
    uniforms: {
      envMap: { value: null },
      samples: { value: 1 },
      weights: { value: i },
      latitudinal: { value: !1 },
      dTheta: { value: 0 },
      mipInt: { value: 0 },
      poleAxis: { value: n }
    },
    vertexShader: po(),
    fragmentShader: (
      /* glsl */
      `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

			}
		`
    ),
    blending: ki,
    depthTest: !1,
    depthWrite: !1
  });
}
function Fd() {
  return new oi({
    name: "EquirectangularToCubeUV",
    uniforms: {
      envMap: { value: null }
    },
    vertexShader: po(),
    fragmentShader: (
      /* glsl */
      `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;

			#include <common>

			void main() {

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );

			}
		`
    ),
    blending: ki,
    depthTest: !1,
    depthWrite: !1
  });
}
function Bd() {
  return new oi({
    name: "CubemapToCubeUV",
    uniforms: {
      envMap: { value: null },
      flipEnvMap: { value: -1 }
    },
    vertexShader: po(),
    fragmentShader: (
      /* glsl */
      `

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`
    ),
    blending: ki,
    depthTest: !1,
    depthWrite: !1
  });
}
function po() {
  return (
    /* glsl */
    `

		precision mediump float;
		precision mediump int;

		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`
  );
}
function Ky(s) {
  let e = /* @__PURE__ */ new WeakMap(), t = null;
  function i(o) {
    if (o && o.isTexture) {
      const l = o.mapping, c = l === Al || l === Rl, h = l === ts || l === Os;
      if (c || h) {
        let d = e.get(o);
        const u = d !== void 0 ? d.texture.pmremVersion : 0;
        if (o.isRenderTargetTexture && o.pmremVersion !== u)
          return t === null && (t = new Od(s)), d = c ? t.fromEquirectangular(o, d) : t.fromCubemap(o, d), d.texture.pmremVersion = o.pmremVersion, e.set(o, d), d.texture;
        if (d !== void 0)
          return d.texture;
        {
          const f = o.image;
          return c && f && f.height > 0 || h && f && n(f) ? (t === null && (t = new Od(s)), d = c ? t.fromEquirectangular(o) : t.fromCubemap(o), d.texture.pmremVersion = o.pmremVersion, e.set(o, d), o.addEventListener("dispose", r), d.texture) : null;
        }
      }
    }
    return o;
  }
  function n(o) {
    let l = 0;
    const c = 6;
    for (let h = 0; h < c; h++)
      o[h] !== void 0 && l++;
    return l === c;
  }
  function r(o) {
    const l = o.target;
    l.removeEventListener("dispose", r);
    const c = e.get(l);
    c !== void 0 && (e.delete(l), c.dispose());
  }
  function a() {
    e = /* @__PURE__ */ new WeakMap(), t !== null && (t.dispose(), t = null);
  }
  return {
    get: i,
    dispose: a
  };
}
function Zy(s) {
  const e = {};
  function t(i) {
    if (e[i] !== void 0)
      return e[i];
    const n = s.getExtension(i);
    return e[i] = n, n;
  }
  return {
    has: function(i) {
      return t(i) !== null;
    },
    init: function() {
      t("EXT_color_buffer_float"), t("WEBGL_clip_cull_distance"), t("OES_texture_float_linear"), t("EXT_color_buffer_half_float"), t("WEBGL_multisampled_render_to_texture"), t("WEBGL_render_shared_exponent");
    },
    get: function(i) {
      const n = t(i);
      return n === null && Cr("WebGLRenderer: " + i + " extension not supported."), n;
    }
  };
}
function Jy(s, e, t, i) {
  const n = {}, r = /* @__PURE__ */ new WeakMap();
  function a(d) {
    const u = d.target;
    u.index !== null && e.remove(u.index);
    for (const g in u.attributes)
      e.remove(u.attributes[g]);
    u.removeEventListener("dispose", a), delete n[u.id];
    const f = r.get(u);
    f && (e.remove(f), r.delete(u)), i.releaseStatesOfGeometry(u), u.isInstancedBufferGeometry === !0 && delete u._maxInstanceCount, t.memory.geometries--;
  }
  function o(d, u) {
    return n[u.id] === !0 || (u.addEventListener("dispose", a), n[u.id] = !0, t.memory.geometries++), u;
  }
  function l(d) {
    const u = d.attributes;
    for (const f in u)
      e.update(u[f], s.ARRAY_BUFFER);
  }
  function c(d) {
    const u = [], f = d.index, g = d.attributes.position;
    let v = 0;
    if (f !== null) {
      const w = f.array;
      v = f.version;
      for (let M = 0, T = w.length; M < T; M += 3) {
        const E = w[M + 0], A = w[M + 1], R = w[M + 2];
        u.push(E, A, A, R, R, E);
      }
    } else if (g !== void 0) {
      const w = g.array;
      v = g.version;
      for (let M = 0, T = w.length / 3 - 1; M < T; M += 3) {
        const E = M + 0, A = M + 1, R = M + 2;
        u.push(E, A, A, R, R, E);
      }
    } else
      return;
    const m = new (Zu(u) ? nf : tf)(u, 1);
    m.version = v;
    const p = r.get(d);
    p && e.remove(p), r.set(d, m);
  }
  function h(d) {
    const u = r.get(d);
    if (u) {
      const f = d.index;
      f !== null && u.version < f.version && c(d);
    } else
      c(d);
    return r.get(d);
  }
  return {
    get: o,
    update: l,
    getWireframeAttribute: h
  };
}
function Qy(s, e, t) {
  let i;
  function n(u) {
    i = u;
  }
  let r, a;
  function o(u) {
    r = u.type, a = u.bytesPerElement;
  }
  function l(u, f) {
    s.drawElements(i, f, r, u * a), t.update(f, i, 1);
  }
  function c(u, f, g) {
    g !== 0 && (s.drawElementsInstanced(i, f, r, u * a, g), t.update(f, i, g));
  }
  function h(u, f, g) {
    if (g === 0) return;
    e.get("WEBGL_multi_draw").multiDrawElementsWEBGL(i, f, 0, r, u, 0, g);
    let m = 0;
    for (let p = 0; p < g; p++)
      m += f[p];
    t.update(m, i, 1);
  }
  function d(u, f, g, v) {
    if (g === 0) return;
    const m = e.get("WEBGL_multi_draw");
    if (m === null)
      for (let p = 0; p < u.length; p++)
        c(u[p] / a, f[p], v[p]);
    else {
      m.multiDrawElementsInstancedWEBGL(i, f, 0, r, u, 0, v, 0, g);
      let p = 0;
      for (let w = 0; w < g; w++)
        p += f[w] * v[w];
      t.update(p, i, 1);
    }
  }
  this.setMode = n, this.setIndex = o, this.render = l, this.renderInstances = c, this.renderMultiDraw = h, this.renderMultiDrawInstances = d;
}
function eb(s) {
  const e = {
    geometries: 0,
    textures: 0
  }, t = {
    frame: 0,
    calls: 0,
    triangles: 0,
    points: 0,
    lines: 0
  };
  function i(r, a, o) {
    switch (t.calls++, a) {
      case s.TRIANGLES:
        t.triangles += o * (r / 3);
        break;
      case s.LINES:
        t.lines += o * (r / 2);
        break;
      case s.LINE_STRIP:
        t.lines += o * (r - 1);
        break;
      case s.LINE_LOOP:
        t.lines += o * r;
        break;
      case s.POINTS:
        t.points += o * r;
        break;
      default:
        Ce("WebGLInfo: Unknown draw mode:", a);
        break;
    }
  }
  function n() {
    t.calls = 0, t.triangles = 0, t.points = 0, t.lines = 0;
  }
  return {
    memory: e,
    render: t,
    programs: null,
    autoReset: !0,
    reset: n,
    update: i
  };
}
function tb(s, e, t) {
  const i = /* @__PURE__ */ new WeakMap(), n = new _t();
  function r(a, o, l) {
    const c = a.morphTargetInfluences, h = o.morphAttributes.position || o.morphAttributes.normal || o.morphAttributes.color, d = h !== void 0 ? h.length : 0;
    let u = i.get(o);
    if (u === void 0 || u.count !== d) {
      let b = function() {
        F.dispose(), i.delete(o), o.removeEventListener("dispose", b);
      };
      var f = b;
      u !== void 0 && u.texture.dispose();
      const g = o.morphAttributes.position !== void 0, v = o.morphAttributes.normal !== void 0, m = o.morphAttributes.color !== void 0, p = o.morphAttributes.position || [], w = o.morphAttributes.normal || [], M = o.morphAttributes.color || [];
      let T = 0;
      g === !0 && (T = 1), v === !0 && (T = 2), m === !0 && (T = 3);
      let E = o.attributes.position.count * T, A = 1;
      E > e.maxTextureSize && (A = Math.ceil(E / e.maxTextureSize), E = e.maxTextureSize);
      const R = new Float32Array(E * A * 4 * d), F = new Ju(R, E, A, d);
      F.type = pi, F.needsUpdate = !0;
      const y = T * 4;
      for (let P = 0; P < d; P++) {
        const H = p[P], V = w[P], Y = M[P], X = E * A * 4 * P;
        for (let q = 0; q < H.count; q++) {
          const z = q * y;
          g === !0 && (n.fromBufferAttribute(H, q), R[X + z + 0] = n.x, R[X + z + 1] = n.y, R[X + z + 2] = n.z, R[X + z + 3] = 0), v === !0 && (n.fromBufferAttribute(V, q), R[X + z + 4] = n.x, R[X + z + 5] = n.y, R[X + z + 6] = n.z, R[X + z + 7] = 0), m === !0 && (n.fromBufferAttribute(Y, q), R[X + z + 8] = n.x, R[X + z + 9] = n.y, R[X + z + 10] = n.z, R[X + z + 11] = Y.itemSize === 4 ? n.w : 1);
        }
      }
      u = {
        count: d,
        texture: F,
        size: new Ye(E, A)
      }, i.set(o, u), o.addEventListener("dispose", b);
    }
    if (a.isInstancedMesh === !0 && a.morphTexture !== null)
      l.getUniforms().setValue(s, "morphTexture", a.morphTexture, t);
    else {
      let g = 0;
      for (let m = 0; m < c.length; m++)
        g += c[m];
      const v = o.morphTargetsRelative ? 1 : 1 - g;
      l.getUniforms().setValue(s, "morphTargetBaseInfluence", v), l.getUniforms().setValue(s, "morphTargetInfluences", c);
    }
    l.getUniforms().setValue(s, "morphTargetsTexture", u.texture, t), l.getUniforms().setValue(s, "morphTargetsTextureSize", u.size);
  }
  return {
    update: r
  };
}
function ib(s, e, t, i) {
  let n = /* @__PURE__ */ new WeakMap();
  function r(l) {
    const c = i.render.frame, h = l.geometry, d = e.get(l, h);
    if (n.get(d) !== c && (e.update(d), n.set(d, c)), l.isInstancedMesh && (l.hasEventListener("dispose", o) === !1 && l.addEventListener("dispose", o), n.get(l) !== c && (t.update(l.instanceMatrix, s.ARRAY_BUFFER), l.instanceColor !== null && t.update(l.instanceColor, s.ARRAY_BUFFER), n.set(l, c))), l.isSkinnedMesh) {
      const u = l.skeleton;
      n.get(u) !== c && (u.update(), n.set(u, c));
    }
    return d;
  }
  function a() {
    n = /* @__PURE__ */ new WeakMap();
  }
  function o(l) {
    const c = l.target;
    c.removeEventListener("dispose", o), t.remove(c.instanceMatrix), c.instanceColor !== null && t.remove(c.instanceColor);
  }
  return {
    update: r,
    dispose: a
  };
}
const nb = {
  [Nu]: "LINEAR_TONE_MAPPING",
  [Ou]: "REINHARD_TONE_MAPPING",
  [Uu]: "CINEON_TONE_MAPPING",
  [Fu]: "ACES_FILMIC_TONE_MAPPING",
  [ku]: "AGX_TONE_MAPPING",
  [zu]: "NEUTRAL_TONE_MAPPING",
  [Bu]: "CUSTOM_TONE_MAPPING"
};
function sb(s, e, t, i, n) {
  const r = new gi(e, t, {
    type: s,
    depthBuffer: i,
    stencilBuffer: n
  }), a = new gi(e, t, {
    type: Ai,
    depthBuffer: !1,
    stencilBuffer: !1
  }), o = new ci();
  o.setAttribute("position", new ri([-1, 3, 0, -1, -1, 0, 3, -1, 0], 3)), o.setAttribute("uv", new ri([0, 2, 0, 0, 2, 0], 2));
  const l = new S_({
    uniforms: {
      tDiffuse: { value: null }
    },
    vertexShader: (
      /* glsl */
      `
			precision highp float;

			uniform mat4 modelViewMatrix;
			uniform mat4 projectionMatrix;

			attribute vec3 position;
			attribute vec2 uv;

			varying vec2 vUv;

			void main() {
				vUv = uv;
				gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
			}`
    ),
    fragmentShader: (
      /* glsl */
      `
			precision highp float;

			uniform sampler2D tDiffuse;

			varying vec2 vUv;

			#include <tonemapping_pars_fragment>
			#include <colorspace_pars_fragment>

			void main() {
				gl_FragColor = texture2D( tDiffuse, vUv );

				#ifdef LINEAR_TONE_MAPPING
					gl_FragColor.rgb = LinearToneMapping( gl_FragColor.rgb );
				#elif defined( REINHARD_TONE_MAPPING )
					gl_FragColor.rgb = ReinhardToneMapping( gl_FragColor.rgb );
				#elif defined( CINEON_TONE_MAPPING )
					gl_FragColor.rgb = CineonToneMapping( gl_FragColor.rgb );
				#elif defined( ACES_FILMIC_TONE_MAPPING )
					gl_FragColor.rgb = ACESFilmicToneMapping( gl_FragColor.rgb );
				#elif defined( AGX_TONE_MAPPING )
					gl_FragColor.rgb = AgXToneMapping( gl_FragColor.rgb );
				#elif defined( NEUTRAL_TONE_MAPPING )
					gl_FragColor.rgb = NeutralToneMapping( gl_FragColor.rgb );
				#elif defined( CUSTOM_TONE_MAPPING )
					gl_FragColor.rgb = CustomToneMapping( gl_FragColor.rgb );
				#endif

				#ifdef SRGB_TRANSFER
					gl_FragColor = sRGBTransferOETF( gl_FragColor );
				#endif
			}`
    ),
    depthTest: !1,
    depthWrite: !1
  }), c = new zt(o, l), h = new zr(-1, 1, 1, -1, 0, 1);
  let d = null, u = null, f = !1, g, v = null, m = [], p = !1;
  this.setSize = function(w, M) {
    r.setSize(w, M), a.setSize(w, M);
    for (let T = 0; T < m.length; T++) {
      const E = m[T];
      E.setSize && E.setSize(w, M);
    }
  }, this.setEffects = function(w) {
    m = w, p = m.length > 0 && m[0].isRenderPass === !0;
    const M = r.width, T = r.height;
    for (let E = 0; E < m.length; E++) {
      const A = m[E];
      A.setSize && A.setSize(M, T);
    }
  }, this.begin = function(w, M) {
    if (f || w.toneMapping === zi && m.length === 0) return !1;
    if (v = M, M !== null) {
      const T = M.width, E = M.height;
      (r.width !== T || r.height !== E) && this.setSize(T, E);
    }
    return p === !1 && w.setRenderTarget(r), g = w.toneMapping, w.toneMapping = zi, !0;
  }, this.hasRenderPass = function() {
    return p;
  }, this.end = function(w, M) {
    w.toneMapping = g, f = !0;
    let T = r, E = a;
    for (let A = 0; A < m.length; A++) {
      const R = m[A];
      if (R.enabled !== !1 && (R.render(w, E, T, M), R.needsSwap !== !1)) {
        const F = T;
        T = E, E = F;
      }
    }
    if (d !== w.outputColorSpace || u !== w.toneMapping) {
      d = w.outputColorSpace, u = w.toneMapping, l.defines = {}, Ke.getTransfer(d) === lt && (l.defines.SRGB_TRANSFER = "");
      const A = nb[u];
      A && (l.defines[A] = ""), l.needsUpdate = !0;
    }
    l.uniforms.tDiffuse.value = T.texture, w.setRenderTarget(v), w.render(c, h), v = null, f = !1;
  }, this.isCompositing = function() {
    return f;
  }, this.dispose = function() {
    r.dispose(), a.dispose(), o.dispose(), l.dispose();
  };
}
const xf = /* @__PURE__ */ new Ot(), pc = /* @__PURE__ */ new Ir(1, 1), yf = /* @__PURE__ */ new Ju(), bf = /* @__PURE__ */ new Wv(), wf = /* @__PURE__ */ new af(), kd = [], zd = [], Vd = new Float32Array(16), Hd = new Float32Array(9), $d = new Float32Array(4);
function Ys(s, e, t) {
  const i = s[0];
  if (i <= 0 || i > 0) return s;
  const n = e * t;
  let r = kd[n];
  if (r === void 0 && (r = new Float32Array(n), kd[n] = r), e !== 0) {
    i.toArray(r, 0);
    for (let a = 1, o = 0; a !== e; ++a)
      o += t, s[a].toArray(r, o);
  }
  return r;
}
function Pt(s, e) {
  if (s.length !== e.length) return !1;
  for (let t = 0, i = s.length; t < i; t++)
    if (s[t] !== e[t]) return !1;
  return !0;
}
function Lt(s, e) {
  for (let t = 0, i = e.length; t < i; t++)
    s[t] = e[t];
}
function mo(s, e) {
  let t = zd[e];
  t === void 0 && (t = new Int32Array(e), zd[e] = t);
  for (let i = 0; i !== e; ++i)
    t[i] = s.allocateTextureUnit();
  return t;
}
function rb(s, e) {
  const t = this.cache;
  t[0] !== e && (s.uniform1f(this.addr, e), t[0] = e);
}
function ab(s, e) {
  const t = this.cache;
  if (e.x !== void 0)
    (t[0] !== e.x || t[1] !== e.y) && (s.uniform2f(this.addr, e.x, e.y), t[0] = e.x, t[1] = e.y);
  else {
    if (Pt(t, e)) return;
    s.uniform2fv(this.addr, e), Lt(t, e);
  }
}
function ob(s, e) {
  const t = this.cache;
  if (e.x !== void 0)
    (t[0] !== e.x || t[1] !== e.y || t[2] !== e.z) && (s.uniform3f(this.addr, e.x, e.y, e.z), t[0] = e.x, t[1] = e.y, t[2] = e.z);
  else if (e.r !== void 0)
    (t[0] !== e.r || t[1] !== e.g || t[2] !== e.b) && (s.uniform3f(this.addr, e.r, e.g, e.b), t[0] = e.r, t[1] = e.g, t[2] = e.b);
  else {
    if (Pt(t, e)) return;
    s.uniform3fv(this.addr, e), Lt(t, e);
  }
}
function lb(s, e) {
  const t = this.cache;
  if (e.x !== void 0)
    (t[0] !== e.x || t[1] !== e.y || t[2] !== e.z || t[3] !== e.w) && (s.uniform4f(this.addr, e.x, e.y, e.z, e.w), t[0] = e.x, t[1] = e.y, t[2] = e.z, t[3] = e.w);
  else {
    if (Pt(t, e)) return;
    s.uniform4fv(this.addr, e), Lt(t, e);
  }
}
function cb(s, e) {
  const t = this.cache, i = e.elements;
  if (i === void 0) {
    if (Pt(t, e)) return;
    s.uniformMatrix2fv(this.addr, !1, e), Lt(t, e);
  } else {
    if (Pt(t, i)) return;
    $d.set(i), s.uniformMatrix2fv(this.addr, !1, $d), Lt(t, i);
  }
}
function hb(s, e) {
  const t = this.cache, i = e.elements;
  if (i === void 0) {
    if (Pt(t, e)) return;
    s.uniformMatrix3fv(this.addr, !1, e), Lt(t, e);
  } else {
    if (Pt(t, i)) return;
    Hd.set(i), s.uniformMatrix3fv(this.addr, !1, Hd), Lt(t, i);
  }
}
function db(s, e) {
  const t = this.cache, i = e.elements;
  if (i === void 0) {
    if (Pt(t, e)) return;
    s.uniformMatrix4fv(this.addr, !1, e), Lt(t, e);
  } else {
    if (Pt(t, i)) return;
    Vd.set(i), s.uniformMatrix4fv(this.addr, !1, Vd), Lt(t, i);
  }
}
function ub(s, e) {
  const t = this.cache;
  t[0] !== e && (s.uniform1i(this.addr, e), t[0] = e);
}
function fb(s, e) {
  const t = this.cache;
  if (e.x !== void 0)
    (t[0] !== e.x || t[1] !== e.y) && (s.uniform2i(this.addr, e.x, e.y), t[0] = e.x, t[1] = e.y);
  else {
    if (Pt(t, e)) return;
    s.uniform2iv(this.addr, e), Lt(t, e);
  }
}
function pb(s, e) {
  const t = this.cache;
  if (e.x !== void 0)
    (t[0] !== e.x || t[1] !== e.y || t[2] !== e.z) && (s.uniform3i(this.addr, e.x, e.y, e.z), t[0] = e.x, t[1] = e.y, t[2] = e.z);
  else {
    if (Pt(t, e)) return;
    s.uniform3iv(this.addr, e), Lt(t, e);
  }
}
function mb(s, e) {
  const t = this.cache;
  if (e.x !== void 0)
    (t[0] !== e.x || t[1] !== e.y || t[2] !== e.z || t[3] !== e.w) && (s.uniform4i(this.addr, e.x, e.y, e.z, e.w), t[0] = e.x, t[1] = e.y, t[2] = e.z, t[3] = e.w);
  else {
    if (Pt(t, e)) return;
    s.uniform4iv(this.addr, e), Lt(t, e);
  }
}
function gb(s, e) {
  const t = this.cache;
  t[0] !== e && (s.uniform1ui(this.addr, e), t[0] = e);
}
function vb(s, e) {
  const t = this.cache;
  if (e.x !== void 0)
    (t[0] !== e.x || t[1] !== e.y) && (s.uniform2ui(this.addr, e.x, e.y), t[0] = e.x, t[1] = e.y);
  else {
    if (Pt(t, e)) return;
    s.uniform2uiv(this.addr, e), Lt(t, e);
  }
}
function _b(s, e) {
  const t = this.cache;
  if (e.x !== void 0)
    (t[0] !== e.x || t[1] !== e.y || t[2] !== e.z) && (s.uniform3ui(this.addr, e.x, e.y, e.z), t[0] = e.x, t[1] = e.y, t[2] = e.z);
  else {
    if (Pt(t, e)) return;
    s.uniform3uiv(this.addr, e), Lt(t, e);
  }
}
function xb(s, e) {
  const t = this.cache;
  if (e.x !== void 0)
    (t[0] !== e.x || t[1] !== e.y || t[2] !== e.z || t[3] !== e.w) && (s.uniform4ui(this.addr, e.x, e.y, e.z, e.w), t[0] = e.x, t[1] = e.y, t[2] = e.z, t[3] = e.w);
  else {
    if (Pt(t, e)) return;
    s.uniform4uiv(this.addr, e), Lt(t, e);
  }
}
function yb(s, e, t) {
  const i = this.cache, n = t.allocateTextureUnit();
  i[0] !== n && (s.uniform1i(this.addr, n), i[0] = n);
  let r;
  this.type === s.SAMPLER_2D_SHADOW ? (pc.compareFunction = t.isReversedDepthBuffer() ? Yc : jc, r = pc) : r = xf, t.setTexture2D(e || r, n);
}
function bb(s, e, t) {
  const i = this.cache, n = t.allocateTextureUnit();
  i[0] !== n && (s.uniform1i(this.addr, n), i[0] = n), t.setTexture3D(e || bf, n);
}
function wb(s, e, t) {
  const i = this.cache, n = t.allocateTextureUnit();
  i[0] !== n && (s.uniform1i(this.addr, n), i[0] = n), t.setTextureCube(e || wf, n);
}
function Sb(s, e, t) {
  const i = this.cache, n = t.allocateTextureUnit();
  i[0] !== n && (s.uniform1i(this.addr, n), i[0] = n), t.setTexture2DArray(e || yf, n);
}
function Mb(s) {
  switch (s) {
    case 5126:
      return rb;
    // FLOAT
    case 35664:
      return ab;
    // _VEC2
    case 35665:
      return ob;
    // _VEC3
    case 35666:
      return lb;
    // _VEC4
    case 35674:
      return cb;
    // _MAT2
    case 35675:
      return hb;
    // _MAT3
    case 35676:
      return db;
    // _MAT4
    case 5124:
    case 35670:
      return ub;
    // INT, BOOL
    case 35667:
    case 35671:
      return fb;
    // _VEC2
    case 35668:
    case 35672:
      return pb;
    // _VEC3
    case 35669:
    case 35673:
      return mb;
    // _VEC4
    case 5125:
      return gb;
    // UINT
    case 36294:
      return vb;
    // _VEC2
    case 36295:
      return _b;
    // _VEC3
    case 36296:
      return xb;
    // _VEC4
    case 35678:
    // SAMPLER_2D
    case 36198:
    // SAMPLER_EXTERNAL_OES
    case 36298:
    // INT_SAMPLER_2D
    case 36306:
    // UNSIGNED_INT_SAMPLER_2D
    case 35682:
      return yb;
    case 35679:
    // SAMPLER_3D
    case 36299:
    // INT_SAMPLER_3D
    case 36307:
      return bb;
    case 35680:
    // SAMPLER_CUBE
    case 36300:
    // INT_SAMPLER_CUBE
    case 36308:
    // UNSIGNED_INT_SAMPLER_CUBE
    case 36293:
      return wb;
    case 36289:
    // SAMPLER_2D_ARRAY
    case 36303:
    // INT_SAMPLER_2D_ARRAY
    case 36311:
    // UNSIGNED_INT_SAMPLER_2D_ARRAY
    case 36292:
      return Sb;
  }
}
function Tb(s, e) {
  s.uniform1fv(this.addr, e);
}
function Eb(s, e) {
  const t = Ys(e, this.size, 2);
  s.uniform2fv(this.addr, t);
}
function Ab(s, e) {
  const t = Ys(e, this.size, 3);
  s.uniform3fv(this.addr, t);
}
function Rb(s, e) {
  const t = Ys(e, this.size, 4);
  s.uniform4fv(this.addr, t);
}
function Cb(s, e) {
  const t = Ys(e, this.size, 4);
  s.uniformMatrix2fv(this.addr, !1, t);
}
function Ib(s, e) {
  const t = Ys(e, this.size, 9);
  s.uniformMatrix3fv(this.addr, !1, t);
}
function Pb(s, e) {
  const t = Ys(e, this.size, 16);
  s.uniformMatrix4fv(this.addr, !1, t);
}
function Lb(s, e) {
  s.uniform1iv(this.addr, e);
}
function Db(s, e) {
  s.uniform2iv(this.addr, e);
}
function Nb(s, e) {
  s.uniform3iv(this.addr, e);
}
function Ob(s, e) {
  s.uniform4iv(this.addr, e);
}
function Ub(s, e) {
  s.uniform1uiv(this.addr, e);
}
function Fb(s, e) {
  s.uniform2uiv(this.addr, e);
}
function Bb(s, e) {
  s.uniform3uiv(this.addr, e);
}
function kb(s, e) {
  s.uniform4uiv(this.addr, e);
}
function zb(s, e, t) {
  const i = this.cache, n = e.length, r = mo(t, n);
  Pt(i, r) || (s.uniform1iv(this.addr, r), Lt(i, r));
  let a;
  this.type === s.SAMPLER_2D_SHADOW ? a = pc : a = xf;
  for (let o = 0; o !== n; ++o)
    t.setTexture2D(e[o] || a, r[o]);
}
function Vb(s, e, t) {
  const i = this.cache, n = e.length, r = mo(t, n);
  Pt(i, r) || (s.uniform1iv(this.addr, r), Lt(i, r));
  for (let a = 0; a !== n; ++a)
    t.setTexture3D(e[a] || bf, r[a]);
}
function Hb(s, e, t) {
  const i = this.cache, n = e.length, r = mo(t, n);
  Pt(i, r) || (s.uniform1iv(this.addr, r), Lt(i, r));
  for (let a = 0; a !== n; ++a)
    t.setTextureCube(e[a] || wf, r[a]);
}
function $b(s, e, t) {
  const i = this.cache, n = e.length, r = mo(t, n);
  Pt(i, r) || (s.uniform1iv(this.addr, r), Lt(i, r));
  for (let a = 0; a !== n; ++a)
    t.setTexture2DArray(e[a] || yf, r[a]);
}
function Gb(s) {
  switch (s) {
    case 5126:
      return Tb;
    // FLOAT
    case 35664:
      return Eb;
    // _VEC2
    case 35665:
      return Ab;
    // _VEC3
    case 35666:
      return Rb;
    // _VEC4
    case 35674:
      return Cb;
    // _MAT2
    case 35675:
      return Ib;
    // _MAT3
    case 35676:
      return Pb;
    // _MAT4
    case 5124:
    case 35670:
      return Lb;
    // INT, BOOL
    case 35667:
    case 35671:
      return Db;
    // _VEC2
    case 35668:
    case 35672:
      return Nb;
    // _VEC3
    case 35669:
    case 35673:
      return Ob;
    // _VEC4
    case 5125:
      return Ub;
    // UINT
    case 36294:
      return Fb;
    // _VEC2
    case 36295:
      return Bb;
    // _VEC3
    case 36296:
      return kb;
    // _VEC4
    case 35678:
    // SAMPLER_2D
    case 36198:
    // SAMPLER_EXTERNAL_OES
    case 36298:
    // INT_SAMPLER_2D
    case 36306:
    // UNSIGNED_INT_SAMPLER_2D
    case 35682:
      return zb;
    case 35679:
    // SAMPLER_3D
    case 36299:
    // INT_SAMPLER_3D
    case 36307:
      return Vb;
    case 35680:
    // SAMPLER_CUBE
    case 36300:
    // INT_SAMPLER_CUBE
    case 36308:
    // UNSIGNED_INT_SAMPLER_CUBE
    case 36293:
      return Hb;
    case 36289:
    // SAMPLER_2D_ARRAY
    case 36303:
    // INT_SAMPLER_2D_ARRAY
    case 36311:
    // UNSIGNED_INT_SAMPLER_2D_ARRAY
    case 36292:
      return $b;
  }
}
class qb {
  constructor(e, t, i) {
    this.id = e, this.addr = i, this.cache = [], this.type = t.type, this.setValue = Mb(t.type);
  }
}
class Wb {
  constructor(e, t, i) {
    this.id = e, this.addr = i, this.cache = [], this.type = t.type, this.size = t.size, this.setValue = Gb(t.type);
  }
}
class Xb {
  constructor(e) {
    this.id = e, this.seq = [], this.map = {};
  }
  setValue(e, t, i) {
    const n = this.seq;
    for (let r = 0, a = n.length; r !== a; ++r) {
      const o = n[r];
      o.setValue(e, t[o.id], i);
    }
  }
}
const el = /(\w+)(\])?(\[|\.)?/g;
function Gd(s, e) {
  s.seq.push(e), s.map[e.id] = e;
}
function jb(s, e, t) {
  const i = s.name, n = i.length;
  for (el.lastIndex = 0; ; ) {
    const r = el.exec(i), a = el.lastIndex;
    let o = r[1];
    const l = r[2] === "]", c = r[3];
    if (l && (o = o | 0), c === void 0 || c === "[" && a + 2 === n) {
      Gd(t, c === void 0 ? new qb(o, s, e) : new Wb(o, s, e));
      break;
    } else {
      let d = t.map[o];
      d === void 0 && (d = new Xb(o), Gd(t, d)), t = d;
    }
  }
}
class Ia {
  constructor(e, t) {
    this.seq = [], this.map = {};
    const i = e.getProgramParameter(t, e.ACTIVE_UNIFORMS);
    for (let a = 0; a < i; ++a) {
      const o = e.getActiveUniform(t, a), l = e.getUniformLocation(t, o.name);
      jb(o, l, this);
    }
    const n = [], r = [];
    for (const a of this.seq)
      a.type === e.SAMPLER_2D_SHADOW || a.type === e.SAMPLER_CUBE_SHADOW || a.type === e.SAMPLER_2D_ARRAY_SHADOW ? n.push(a) : r.push(a);
    n.length > 0 && (this.seq = n.concat(r));
  }
  setValue(e, t, i, n) {
    const r = this.map[t];
    r !== void 0 && r.setValue(e, i, n);
  }
  setOptional(e, t, i) {
    const n = t[i];
    n !== void 0 && this.setValue(e, i, n);
  }
  static upload(e, t, i, n) {
    for (let r = 0, a = t.length; r !== a; ++r) {
      const o = t[r], l = i[o.id];
      l.needsUpdate !== !1 && o.setValue(e, l.value, n);
    }
  }
  static seqWithValue(e, t) {
    const i = [];
    for (let n = 0, r = e.length; n !== r; ++n) {
      const a = e[n];
      a.id in t && i.push(a);
    }
    return i;
  }
}
function qd(s, e, t) {
  const i = s.createShader(e);
  return s.shaderSource(i, t), s.compileShader(i), i;
}
const Yb = 37297;
let Kb = 0;
function Zb(s, e) {
  const t = s.split(`
`), i = [], n = Math.max(e - 6, 0), r = Math.min(e + 6, t.length);
  for (let a = n; a < r; a++) {
    const o = a + 1;
    i.push(`${o === e ? ">" : " "} ${o}: ${t[a]}`);
  }
  return i.join(`
`);
}
const Wd = /* @__PURE__ */ new Be();
function Jb(s) {
  Ke._getMatrix(Wd, Ke.workingColorSpace, s);
  const e = `mat3( ${Wd.elements.map((t) => t.toFixed(4))} )`;
  switch (Ke.getTransfer(s)) {
    case Ga:
      return [e, "LinearTransferOETF"];
    case lt:
      return [e, "sRGBTransferOETF"];
    default:
      return Te("WebGLProgram: Unsupported color space: ", s), [e, "LinearTransferOETF"];
  }
}
function Xd(s, e, t) {
  const i = s.getShaderParameter(e, s.COMPILE_STATUS), r = (s.getShaderInfoLog(e) || "").trim();
  if (i && r === "") return "";
  const a = /ERROR: 0:(\d+)/.exec(r);
  if (a) {
    const o = parseInt(a[1]);
    return t.toUpperCase() + `

` + r + `

` + Zb(s.getShaderSource(e), o);
  } else
    return r;
}
function Qb(s, e) {
  const t = Jb(e);
  return [
    `vec4 ${s}( vec4 value ) {`,
    `	return ${t[1]}( vec4( value.rgb * ${t[0]}, value.a ) );`,
    "}"
  ].join(`
`);
}
const ew = {
  [Nu]: "Linear",
  [Ou]: "Reinhard",
  [Uu]: "Cineon",
  [Fu]: "ACESFilmic",
  [ku]: "AgX",
  [zu]: "Neutral",
  [Bu]: "Custom"
};
function tw(s, e) {
  const t = ew[e];
  return t === void 0 ? (Te("WebGLProgram: Unsupported toneMapping:", e), "vec3 " + s + "( vec3 color ) { return LinearToneMapping( color ); }") : "vec3 " + s + "( vec3 color ) { return " + t + "ToneMapping( color ); }";
}
const va = /* @__PURE__ */ new O();
function iw() {
  Ke.getLuminanceCoefficients(va);
  const s = va.x.toFixed(4), e = va.y.toFixed(4), t = va.z.toFixed(4);
  return [
    "float luminance( const in vec3 rgb ) {",
    `	const vec3 weights = vec3( ${s}, ${e}, ${t} );`,
    "	return dot( weights, rgb );",
    "}"
  ].join(`
`);
}
function nw(s) {
  return [
    s.extensionClipCullDistance ? "#extension GL_ANGLE_clip_cull_distance : require" : "",
    s.extensionMultiDraw ? "#extension GL_ANGLE_multi_draw : require" : ""
  ].filter(ur).join(`
`);
}
function sw(s) {
  const e = [];
  for (const t in s) {
    const i = s[t];
    i !== !1 && e.push("#define " + t + " " + i);
  }
  return e.join(`
`);
}
function rw(s, e) {
  const t = {}, i = s.getProgramParameter(e, s.ACTIVE_ATTRIBUTES);
  for (let n = 0; n < i; n++) {
    const r = s.getActiveAttrib(e, n), a = r.name;
    let o = 1;
    r.type === s.FLOAT_MAT2 && (o = 2), r.type === s.FLOAT_MAT3 && (o = 3), r.type === s.FLOAT_MAT4 && (o = 4), t[a] = {
      type: r.type,
      location: s.getAttribLocation(e, a),
      locationSize: o
    };
  }
  return t;
}
function ur(s) {
  return s !== "";
}
function jd(s, e) {
  const t = e.numSpotLightShadows + e.numSpotLightMaps - e.numSpotLightShadowsWithMaps;
  return s.replace(/NUM_DIR_LIGHTS/g, e.numDirLights).replace(/NUM_SPOT_LIGHTS/g, e.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, e.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, t).replace(/NUM_RECT_AREA_LIGHTS/g, e.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, e.numPointLights).replace(/NUM_HEMI_LIGHTS/g, e.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, e.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, e.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, e.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, e.numPointLightShadows);
}
function Yd(s, e) {
  return s.replace(/NUM_CLIPPING_PLANES/g, e.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, e.numClippingPlanes - e.numClipIntersection);
}
const aw = /^[ \t]*#include +<([\w\d./]+)>/gm;
function mc(s) {
  return s.replace(aw, lw);
}
const ow = /* @__PURE__ */ new Map();
function lw(s, e) {
  let t = ke[e];
  if (t === void 0) {
    const i = ow.get(e);
    if (i !== void 0)
      t = ke[i], Te('WebGLRenderer: Shader chunk "%s" has been deprecated. Use "%s" instead.', e, i);
    else
      throw new Error("Can not resolve #include <" + e + ">");
  }
  return mc(t);
}
const cw = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function Kd(s) {
  return s.replace(cw, hw);
}
function hw(s, e, t, i) {
  let n = "";
  for (let r = parseInt(e); r < parseInt(t); r++)
    n += i.replace(/\[\s*i\s*\]/g, "[ " + r + " ]").replace(/UNROLLED_LOOP_INDEX/g, r);
  return n;
}
function Zd(s) {
  let e = `precision ${s.precision} float;
	precision ${s.precision} int;
	precision ${s.precision} sampler2D;
	precision ${s.precision} samplerCube;
	precision ${s.precision} sampler3D;
	precision ${s.precision} sampler2DArray;
	precision ${s.precision} sampler2DShadow;
	precision ${s.precision} samplerCubeShadow;
	precision ${s.precision} sampler2DArrayShadow;
	precision ${s.precision} isampler2D;
	precision ${s.precision} isampler3D;
	precision ${s.precision} isamplerCube;
	precision ${s.precision} isampler2DArray;
	precision ${s.precision} usampler2D;
	precision ${s.precision} usampler3D;
	precision ${s.precision} usamplerCube;
	precision ${s.precision} usampler2DArray;
	`;
  return s.precision === "highp" ? e += `
#define HIGH_PRECISION` : s.precision === "mediump" ? e += `
#define MEDIUM_PRECISION` : s.precision === "lowp" && (e += `
#define LOW_PRECISION`), e;
}
const dw = {
  [Sa]: "SHADOWMAP_TYPE_PCF",
  [hr]: "SHADOWMAP_TYPE_VSM"
};
function uw(s) {
  return dw[s.shadowMapType] || "SHADOWMAP_TYPE_BASIC";
}
const fw = {
  [ts]: "ENVMAP_TYPE_CUBE",
  [Os]: "ENVMAP_TYPE_CUBE",
  [ho]: "ENVMAP_TYPE_CUBE_UV"
};
function pw(s) {
  return s.envMap === !1 ? "ENVMAP_TYPE_CUBE" : fw[s.envMapMode] || "ENVMAP_TYPE_CUBE";
}
const mw = {
  [Os]: "ENVMAP_MODE_REFRACTION"
};
function gw(s) {
  return s.envMap === !1 ? "ENVMAP_MODE_REFLECTION" : mw[s.envMapMode] || "ENVMAP_MODE_REFLECTION";
}
const vw = {
  [Du]: "ENVMAP_BLENDING_MULTIPLY",
  [ov]: "ENVMAP_BLENDING_MIX",
  [lv]: "ENVMAP_BLENDING_ADD"
};
function _w(s) {
  return s.envMap === !1 ? "ENVMAP_BLENDING_NONE" : vw[s.combine] || "ENVMAP_BLENDING_NONE";
}
function xw(s) {
  const e = s.envMapCubeUVHeight;
  if (e === null) return null;
  const t = Math.log2(e) - 2, i = 1 / e;
  return { texelWidth: 1 / (3 * Math.max(Math.pow(2, t), 112)), texelHeight: i, maxMip: t };
}
function yw(s, e, t, i) {
  const n = s.getContext(), r = t.defines;
  let a = t.vertexShader, o = t.fragmentShader;
  const l = uw(t), c = pw(t), h = gw(t), d = _w(t), u = xw(t), f = nw(t), g = sw(r), v = n.createProgram();
  let m, p, w = t.glslVersion ? "#version " + t.glslVersion + `
` : "";
  t.isRawShaderMaterial ? (m = [
    "#define SHADER_TYPE " + t.shaderType,
    "#define SHADER_NAME " + t.shaderName,
    g
  ].filter(ur).join(`
`), m.length > 0 && (m += `
`), p = [
    "#define SHADER_TYPE " + t.shaderType,
    "#define SHADER_NAME " + t.shaderName,
    g
  ].filter(ur).join(`
`), p.length > 0 && (p += `
`)) : (m = [
    Zd(t),
    "#define SHADER_TYPE " + t.shaderType,
    "#define SHADER_NAME " + t.shaderName,
    g,
    t.extensionClipCullDistance ? "#define USE_CLIP_DISTANCE" : "",
    t.batching ? "#define USE_BATCHING" : "",
    t.batchingColor ? "#define USE_BATCHING_COLOR" : "",
    t.instancing ? "#define USE_INSTANCING" : "",
    t.instancingColor ? "#define USE_INSTANCING_COLOR" : "",
    t.instancingMorph ? "#define USE_INSTANCING_MORPH" : "",
    t.useFog && t.fog ? "#define USE_FOG" : "",
    t.useFog && t.fogExp2 ? "#define FOG_EXP2" : "",
    t.map ? "#define USE_MAP" : "",
    t.envMap ? "#define USE_ENVMAP" : "",
    t.envMap ? "#define " + h : "",
    t.lightMap ? "#define USE_LIGHTMAP" : "",
    t.aoMap ? "#define USE_AOMAP" : "",
    t.bumpMap ? "#define USE_BUMPMAP" : "",
    t.normalMap ? "#define USE_NORMALMAP" : "",
    t.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
    t.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
    t.displacementMap ? "#define USE_DISPLACEMENTMAP" : "",
    t.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
    t.anisotropy ? "#define USE_ANISOTROPY" : "",
    t.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
    t.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
    t.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
    t.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
    t.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
    t.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
    t.specularMap ? "#define USE_SPECULARMAP" : "",
    t.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
    t.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
    t.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
    t.metalnessMap ? "#define USE_METALNESSMAP" : "",
    t.alphaMap ? "#define USE_ALPHAMAP" : "",
    t.alphaHash ? "#define USE_ALPHAHASH" : "",
    t.transmission ? "#define USE_TRANSMISSION" : "",
    t.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
    t.thicknessMap ? "#define USE_THICKNESSMAP" : "",
    t.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
    t.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
    //
    t.mapUv ? "#define MAP_UV " + t.mapUv : "",
    t.alphaMapUv ? "#define ALPHAMAP_UV " + t.alphaMapUv : "",
    t.lightMapUv ? "#define LIGHTMAP_UV " + t.lightMapUv : "",
    t.aoMapUv ? "#define AOMAP_UV " + t.aoMapUv : "",
    t.emissiveMapUv ? "#define EMISSIVEMAP_UV " + t.emissiveMapUv : "",
    t.bumpMapUv ? "#define BUMPMAP_UV " + t.bumpMapUv : "",
    t.normalMapUv ? "#define NORMALMAP_UV " + t.normalMapUv : "",
    t.displacementMapUv ? "#define DISPLACEMENTMAP_UV " + t.displacementMapUv : "",
    t.metalnessMapUv ? "#define METALNESSMAP_UV " + t.metalnessMapUv : "",
    t.roughnessMapUv ? "#define ROUGHNESSMAP_UV " + t.roughnessMapUv : "",
    t.anisotropyMapUv ? "#define ANISOTROPYMAP_UV " + t.anisotropyMapUv : "",
    t.clearcoatMapUv ? "#define CLEARCOATMAP_UV " + t.clearcoatMapUv : "",
    t.clearcoatNormalMapUv ? "#define CLEARCOAT_NORMALMAP_UV " + t.clearcoatNormalMapUv : "",
    t.clearcoatRoughnessMapUv ? "#define CLEARCOAT_ROUGHNESSMAP_UV " + t.clearcoatRoughnessMapUv : "",
    t.iridescenceMapUv ? "#define IRIDESCENCEMAP_UV " + t.iridescenceMapUv : "",
    t.iridescenceThicknessMapUv ? "#define IRIDESCENCE_THICKNESSMAP_UV " + t.iridescenceThicknessMapUv : "",
    t.sheenColorMapUv ? "#define SHEEN_COLORMAP_UV " + t.sheenColorMapUv : "",
    t.sheenRoughnessMapUv ? "#define SHEEN_ROUGHNESSMAP_UV " + t.sheenRoughnessMapUv : "",
    t.specularMapUv ? "#define SPECULARMAP_UV " + t.specularMapUv : "",
    t.specularColorMapUv ? "#define SPECULAR_COLORMAP_UV " + t.specularColorMapUv : "",
    t.specularIntensityMapUv ? "#define SPECULAR_INTENSITYMAP_UV " + t.specularIntensityMapUv : "",
    t.transmissionMapUv ? "#define TRANSMISSIONMAP_UV " + t.transmissionMapUv : "",
    t.thicknessMapUv ? "#define THICKNESSMAP_UV " + t.thicknessMapUv : "",
    //
    t.vertexTangents && t.flatShading === !1 ? "#define USE_TANGENT" : "",
    t.vertexColors ? "#define USE_COLOR" : "",
    t.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
    t.vertexUv1s ? "#define USE_UV1" : "",
    t.vertexUv2s ? "#define USE_UV2" : "",
    t.vertexUv3s ? "#define USE_UV3" : "",
    t.pointsUvs ? "#define USE_POINTS_UV" : "",
    t.flatShading ? "#define FLAT_SHADED" : "",
    t.skinning ? "#define USE_SKINNING" : "",
    t.morphTargets ? "#define USE_MORPHTARGETS" : "",
    t.morphNormals && t.flatShading === !1 ? "#define USE_MORPHNORMALS" : "",
    t.morphColors ? "#define USE_MORPHCOLORS" : "",
    t.morphTargetsCount > 0 ? "#define MORPHTARGETS_TEXTURE_STRIDE " + t.morphTextureStride : "",
    t.morphTargetsCount > 0 ? "#define MORPHTARGETS_COUNT " + t.morphTargetsCount : "",
    t.doubleSided ? "#define DOUBLE_SIDED" : "",
    t.flipSided ? "#define FLIP_SIDED" : "",
    t.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
    t.shadowMapEnabled ? "#define " + l : "",
    t.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "",
    t.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
    t.logarithmicDepthBuffer ? "#define USE_LOGARITHMIC_DEPTH_BUFFER" : "",
    t.reversedDepthBuffer ? "#define USE_REVERSED_DEPTH_BUFFER" : "",
    "uniform mat4 modelMatrix;",
    "uniform mat4 modelViewMatrix;",
    "uniform mat4 projectionMatrix;",
    "uniform mat4 viewMatrix;",
    "uniform mat3 normalMatrix;",
    "uniform vec3 cameraPosition;",
    "uniform bool isOrthographic;",
    "#ifdef USE_INSTANCING",
    "	attribute mat4 instanceMatrix;",
    "#endif",
    "#ifdef USE_INSTANCING_COLOR",
    "	attribute vec3 instanceColor;",
    "#endif",
    "#ifdef USE_INSTANCING_MORPH",
    "	uniform sampler2D morphTexture;",
    "#endif",
    "attribute vec3 position;",
    "attribute vec3 normal;",
    "attribute vec2 uv;",
    "#ifdef USE_UV1",
    "	attribute vec2 uv1;",
    "#endif",
    "#ifdef USE_UV2",
    "	attribute vec2 uv2;",
    "#endif",
    "#ifdef USE_UV3",
    "	attribute vec2 uv3;",
    "#endif",
    "#ifdef USE_TANGENT",
    "	attribute vec4 tangent;",
    "#endif",
    "#if defined( USE_COLOR_ALPHA )",
    "	attribute vec4 color;",
    "#elif defined( USE_COLOR )",
    "	attribute vec3 color;",
    "#endif",
    "#ifdef USE_SKINNING",
    "	attribute vec4 skinIndex;",
    "	attribute vec4 skinWeight;",
    "#endif",
    `
`
  ].filter(ur).join(`
`), p = [
    Zd(t),
    "#define SHADER_TYPE " + t.shaderType,
    "#define SHADER_NAME " + t.shaderName,
    g,
    t.useFog && t.fog ? "#define USE_FOG" : "",
    t.useFog && t.fogExp2 ? "#define FOG_EXP2" : "",
    t.alphaToCoverage ? "#define ALPHA_TO_COVERAGE" : "",
    t.map ? "#define USE_MAP" : "",
    t.matcap ? "#define USE_MATCAP" : "",
    t.envMap ? "#define USE_ENVMAP" : "",
    t.envMap ? "#define " + c : "",
    t.envMap ? "#define " + h : "",
    t.envMap ? "#define " + d : "",
    u ? "#define CUBEUV_TEXEL_WIDTH " + u.texelWidth : "",
    u ? "#define CUBEUV_TEXEL_HEIGHT " + u.texelHeight : "",
    u ? "#define CUBEUV_MAX_MIP " + u.maxMip + ".0" : "",
    t.lightMap ? "#define USE_LIGHTMAP" : "",
    t.aoMap ? "#define USE_AOMAP" : "",
    t.bumpMap ? "#define USE_BUMPMAP" : "",
    t.normalMap ? "#define USE_NORMALMAP" : "",
    t.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
    t.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
    t.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
    t.anisotropy ? "#define USE_ANISOTROPY" : "",
    t.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
    t.clearcoat ? "#define USE_CLEARCOAT" : "",
    t.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
    t.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
    t.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
    t.dispersion ? "#define USE_DISPERSION" : "",
    t.iridescence ? "#define USE_IRIDESCENCE" : "",
    t.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
    t.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
    t.specularMap ? "#define USE_SPECULARMAP" : "",
    t.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
    t.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
    t.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
    t.metalnessMap ? "#define USE_METALNESSMAP" : "",
    t.alphaMap ? "#define USE_ALPHAMAP" : "",
    t.alphaTest ? "#define USE_ALPHATEST" : "",
    t.alphaHash ? "#define USE_ALPHAHASH" : "",
    t.sheen ? "#define USE_SHEEN" : "",
    t.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
    t.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
    t.transmission ? "#define USE_TRANSMISSION" : "",
    t.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
    t.thicknessMap ? "#define USE_THICKNESSMAP" : "",
    t.vertexTangents && t.flatShading === !1 ? "#define USE_TANGENT" : "",
    t.vertexColors || t.instancingColor || t.batchingColor ? "#define USE_COLOR" : "",
    t.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
    t.vertexUv1s ? "#define USE_UV1" : "",
    t.vertexUv2s ? "#define USE_UV2" : "",
    t.vertexUv3s ? "#define USE_UV3" : "",
    t.pointsUvs ? "#define USE_POINTS_UV" : "",
    t.gradientMap ? "#define USE_GRADIENTMAP" : "",
    t.flatShading ? "#define FLAT_SHADED" : "",
    t.doubleSided ? "#define DOUBLE_SIDED" : "",
    t.flipSided ? "#define FLIP_SIDED" : "",
    t.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
    t.shadowMapEnabled ? "#define " + l : "",
    t.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "",
    t.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
    t.decodeVideoTexture ? "#define DECODE_VIDEO_TEXTURE" : "",
    t.decodeVideoTextureEmissive ? "#define DECODE_VIDEO_TEXTURE_EMISSIVE" : "",
    t.logarithmicDepthBuffer ? "#define USE_LOGARITHMIC_DEPTH_BUFFER" : "",
    t.reversedDepthBuffer ? "#define USE_REVERSED_DEPTH_BUFFER" : "",
    "uniform mat4 viewMatrix;",
    "uniform vec3 cameraPosition;",
    "uniform bool isOrthographic;",
    t.toneMapping !== zi ? "#define TONE_MAPPING" : "",
    t.toneMapping !== zi ? ke.tonemapping_pars_fragment : "",
    // this code is required here because it is used by the toneMapping() function defined below
    t.toneMapping !== zi ? tw("toneMapping", t.toneMapping) : "",
    t.dithering ? "#define DITHERING" : "",
    t.opaque ? "#define OPAQUE" : "",
    ke.colorspace_pars_fragment,
    // this code is required here because it is used by the various encoding/decoding function defined below
    Qb("linearToOutputTexel", t.outputColorSpace),
    iw(),
    t.useDepthPacking ? "#define DEPTH_PACKING " + t.depthPacking : "",
    `
`
  ].filter(ur).join(`
`)), a = mc(a), a = jd(a, t), a = Yd(a, t), o = mc(o), o = jd(o, t), o = Yd(o, t), a = Kd(a), o = Kd(o), t.isRawShaderMaterial !== !0 && (w = `#version 300 es
`, m = [
    f,
    "#define attribute in",
    "#define varying out",
    "#define texture2D texture"
  ].join(`
`) + `
` + m, p = [
    "#define varying in",
    t.glslVersion === Kh ? "" : "layout(location = 0) out highp vec4 pc_fragColor;",
    t.glslVersion === Kh ? "" : "#define gl_FragColor pc_fragColor",
    "#define gl_FragDepthEXT gl_FragDepth",
    "#define texture2D texture",
    "#define textureCube texture",
    "#define texture2DProj textureProj",
    "#define texture2DLodEXT textureLod",
    "#define texture2DProjLodEXT textureProjLod",
    "#define textureCubeLodEXT textureLod",
    "#define texture2DGradEXT textureGrad",
    "#define texture2DProjGradEXT textureProjGrad",
    "#define textureCubeGradEXT textureGrad"
  ].join(`
`) + `
` + p);
  const M = w + m + a, T = w + p + o, E = qd(n, n.VERTEX_SHADER, M), A = qd(n, n.FRAGMENT_SHADER, T);
  n.attachShader(v, E), n.attachShader(v, A), t.index0AttributeName !== void 0 ? n.bindAttribLocation(v, 0, t.index0AttributeName) : t.morphTargets === !0 && n.bindAttribLocation(v, 0, "position"), n.linkProgram(v);
  function R(P) {
    if (s.debug.checkShaderErrors) {
      const H = n.getProgramInfoLog(v) || "", V = n.getShaderInfoLog(E) || "", Y = n.getShaderInfoLog(A) || "", X = H.trim(), q = V.trim(), z = Y.trim();
      let J = !0, ue = !0;
      if (n.getProgramParameter(v, n.LINK_STATUS) === !1)
        if (J = !1, typeof s.debug.onShaderError == "function")
          s.debug.onShaderError(n, v, E, A);
        else {
          const le = Xd(n, E, "vertex"), fe = Xd(n, A, "fragment");
          Ce(
            "THREE.WebGLProgram: Shader Error " + n.getError() + " - VALIDATE_STATUS " + n.getProgramParameter(v, n.VALIDATE_STATUS) + `

Material Name: ` + P.name + `
Material Type: ` + P.type + `

Program Info Log: ` + X + `
` + le + `
` + fe
          );
        }
      else X !== "" ? Te("WebGLProgram: Program Info Log:", X) : (q === "" || z === "") && (ue = !1);
      ue && (P.diagnostics = {
        runnable: J,
        programLog: X,
        vertexShader: {
          log: q,
          prefix: m
        },
        fragmentShader: {
          log: z,
          prefix: p
        }
      });
    }
    n.deleteShader(E), n.deleteShader(A), F = new Ia(n, v), y = rw(n, v);
  }
  let F;
  this.getUniforms = function() {
    return F === void 0 && R(this), F;
  };
  let y;
  this.getAttributes = function() {
    return y === void 0 && R(this), y;
  };
  let b = t.rendererExtensionParallelShaderCompile === !1;
  return this.isReady = function() {
    return b === !1 && (b = n.getProgramParameter(v, Yb)), b;
  }, this.destroy = function() {
    i.releaseStatesOfProgram(this), n.deleteProgram(v), this.program = void 0;
  }, this.type = t.shaderType, this.name = t.shaderName, this.id = Kb++, this.cacheKey = e, this.usedTimes = 1, this.program = v, this.vertexShader = E, this.fragmentShader = A, this;
}
let bw = 0;
class ww {
  constructor() {
    this.shaderCache = /* @__PURE__ */ new Map(), this.materialCache = /* @__PURE__ */ new Map();
  }
  update(e) {
    const t = e.vertexShader, i = e.fragmentShader, n = this._getShaderStage(t), r = this._getShaderStage(i), a = this._getShaderCacheForMaterial(e);
    return a.has(n) === !1 && (a.add(n), n.usedTimes++), a.has(r) === !1 && (a.add(r), r.usedTimes++), this;
  }
  remove(e) {
    const t = this.materialCache.get(e);
    for (const i of t)
      i.usedTimes--, i.usedTimes === 0 && this.shaderCache.delete(i.code);
    return this.materialCache.delete(e), this;
  }
  getVertexShaderID(e) {
    return this._getShaderStage(e.vertexShader).id;
  }
  getFragmentShaderID(e) {
    return this._getShaderStage(e.fragmentShader).id;
  }
  dispose() {
    this.shaderCache.clear(), this.materialCache.clear();
  }
  _getShaderCacheForMaterial(e) {
    const t = this.materialCache;
    let i = t.get(e);
    return i === void 0 && (i = /* @__PURE__ */ new Set(), t.set(e, i)), i;
  }
  _getShaderStage(e) {
    const t = this.shaderCache;
    let i = t.get(e);
    return i === void 0 && (i = new Sw(e), t.set(e, i)), i;
  }
}
class Sw {
  constructor(e) {
    this.id = bw++, this.code = e, this.usedTimes = 0;
  }
}
function Mw(s, e, t, i, n, r, a) {
  const o = new Qu(), l = new ww(), c = /* @__PURE__ */ new Set(), h = [], d = /* @__PURE__ */ new Map(), u = n.logarithmicDepthBuffer;
  let f = n.precision;
  const g = {
    MeshDepthMaterial: "depth",
    MeshDistanceMaterial: "distance",
    MeshNormalMaterial: "normal",
    MeshBasicMaterial: "basic",
    MeshLambertMaterial: "lambert",
    MeshPhongMaterial: "phong",
    MeshToonMaterial: "toon",
    MeshStandardMaterial: "physical",
    MeshPhysicalMaterial: "physical",
    MeshMatcapMaterial: "matcap",
    LineBasicMaterial: "basic",
    LineDashedMaterial: "dashed",
    PointsMaterial: "points",
    ShadowMaterial: "shadow",
    SpriteMaterial: "sprite"
  };
  function v(y) {
    return c.add(y), y === 0 ? "uv" : `uv${y}`;
  }
  function m(y, b, P, H, V) {
    const Y = H.fog, X = V.geometry, q = y.isMeshStandardMaterial ? H.environment : null, z = (y.isMeshStandardMaterial ? t : e).get(y.envMap || q), J = z && z.mapping === ho ? z.image.height : null, ue = g[y.type];
    y.precision !== null && (f = n.getMaxPrecision(y.precision), f !== y.precision && Te("WebGLProgram.getParameters:", y.precision, "not supported, using", f, "instead."));
    const le = X.morphAttributes.position || X.morphAttributes.normal || X.morphAttributes.color, fe = le !== void 0 ? le.length : 0;
    let Ge = 0;
    X.morphAttributes.position !== void 0 && (Ge = 1), X.morphAttributes.normal !== void 0 && (Ge = 2), X.morphAttributes.color !== void 0 && (Ge = 3);
    let Ve, yt, vt, j;
    if (ue) {
      const at = Ui[ue];
      Ve = at.vertexShader, yt = at.fragmentShader;
    } else
      Ve = y.vertexShader, yt = y.fragmentShader, l.update(y), vt = l.getVertexShaderID(y), j = l.getFragmentShaderID(y);
    const Q = s.getRenderTarget(), ge = s.state.buffers.depth.getReversed(), Fe = V.isInstancedMesh === !0, xe = V.isBatchedMesh === !0, tt = !!y.map, Dt = !!y.matcap, et = !!z, rt = !!y.aoMap, dt = !!y.lightMap, He = !!y.bumpMap, Et = !!y.normalMap, C = !!y.displacementMap, At = !!y.emissiveMap, nt = !!y.metalnessMap, pt = !!y.roughnessMap, be = y.anisotropy > 0, S = y.clearcoat > 0, _ = y.dispersion > 0, L = y.iridescence > 0, W = y.sheen > 0, Z = y.transmission > 0, G = be && !!y.anisotropyMap, Se = S && !!y.clearcoatMap, se = S && !!y.clearcoatNormalMap, ye = S && !!y.clearcoatRoughnessMap, Pe = L && !!y.iridescenceMap, te = L && !!y.iridescenceThicknessMap, ae = W && !!y.sheenColorMap, _e = W && !!y.sheenRoughnessMap, we = !!y.specularMap, re = !!y.specularColorMap, $e = !!y.specularIntensityMap, I = Z && !!y.transmissionMap, de = Z && !!y.thicknessMap, ie = !!y.gradientMap, pe = !!y.alphaMap, ee = y.alphaTest > 0, K = !!y.alphaHash, ne = !!y.extensions;
    let De = zi;
    y.toneMapped && (Q === null || Q.isXRRenderTarget === !0) && (De = s.toneMapping);
    const mt = {
      shaderID: ue,
      shaderType: y.type,
      shaderName: y.name,
      vertexShader: Ve,
      fragmentShader: yt,
      defines: y.defines,
      customVertexShaderID: vt,
      customFragmentShaderID: j,
      isRawShaderMaterial: y.isRawShaderMaterial === !0,
      glslVersion: y.glslVersion,
      precision: f,
      batching: xe,
      batchingColor: xe && V._colorsTexture !== null,
      instancing: Fe,
      instancingColor: Fe && V.instanceColor !== null,
      instancingMorph: Fe && V.morphTexture !== null,
      outputColorSpace: Q === null ? s.outputColorSpace : Q.isXRRenderTarget === !0 ? Q.texture.colorSpace : Wt,
      alphaToCoverage: !!y.alphaToCoverage,
      map: tt,
      matcap: Dt,
      envMap: et,
      envMapMode: et && z.mapping,
      envMapCubeUVHeight: J,
      aoMap: rt,
      lightMap: dt,
      bumpMap: He,
      normalMap: Et,
      displacementMap: C,
      emissiveMap: At,
      normalMapObjectSpace: Et && y.normalMapType === mv,
      normalMapTangentSpace: Et && y.normalMapType === Ku,
      metalnessMap: nt,
      roughnessMap: pt,
      anisotropy: be,
      anisotropyMap: G,
      clearcoat: S,
      clearcoatMap: Se,
      clearcoatNormalMap: se,
      clearcoatRoughnessMap: ye,
      dispersion: _,
      iridescence: L,
      iridescenceMap: Pe,
      iridescenceThicknessMap: te,
      sheen: W,
      sheenColorMap: ae,
      sheenRoughnessMap: _e,
      specularMap: we,
      specularColorMap: re,
      specularIntensityMap: $e,
      transmission: Z,
      transmissionMap: I,
      thicknessMap: de,
      gradientMap: ie,
      opaque: y.transparent === !1 && y.blending === Kn && y.alphaToCoverage === !1,
      alphaMap: pe,
      alphaTest: ee,
      alphaHash: K,
      combine: y.combine,
      //
      mapUv: tt && v(y.map.channel),
      aoMapUv: rt && v(y.aoMap.channel),
      lightMapUv: dt && v(y.lightMap.channel),
      bumpMapUv: He && v(y.bumpMap.channel),
      normalMapUv: Et && v(y.normalMap.channel),
      displacementMapUv: C && v(y.displacementMap.channel),
      emissiveMapUv: At && v(y.emissiveMap.channel),
      metalnessMapUv: nt && v(y.metalnessMap.channel),
      roughnessMapUv: pt && v(y.roughnessMap.channel),
      anisotropyMapUv: G && v(y.anisotropyMap.channel),
      clearcoatMapUv: Se && v(y.clearcoatMap.channel),
      clearcoatNormalMapUv: se && v(y.clearcoatNormalMap.channel),
      clearcoatRoughnessMapUv: ye && v(y.clearcoatRoughnessMap.channel),
      iridescenceMapUv: Pe && v(y.iridescenceMap.channel),
      iridescenceThicknessMapUv: te && v(y.iridescenceThicknessMap.channel),
      sheenColorMapUv: ae && v(y.sheenColorMap.channel),
      sheenRoughnessMapUv: _e && v(y.sheenRoughnessMap.channel),
      specularMapUv: we && v(y.specularMap.channel),
      specularColorMapUv: re && v(y.specularColorMap.channel),
      specularIntensityMapUv: $e && v(y.specularIntensityMap.channel),
      transmissionMapUv: I && v(y.transmissionMap.channel),
      thicknessMapUv: de && v(y.thicknessMap.channel),
      alphaMapUv: pe && v(y.alphaMap.channel),
      //
      vertexTangents: !!X.attributes.tangent && (Et || be),
      vertexColors: y.vertexColors,
      vertexAlphas: y.vertexColors === !0 && !!X.attributes.color && X.attributes.color.itemSize === 4,
      pointsUvs: V.isPoints === !0 && !!X.attributes.uv && (tt || pe),
      fog: !!Y,
      useFog: y.fog === !0,
      fogExp2: !!Y && Y.isFogExp2,
      flatShading: y.flatShading === !0 && y.wireframe === !1,
      sizeAttenuation: y.sizeAttenuation === !0,
      logarithmicDepthBuffer: u,
      reversedDepthBuffer: ge,
      skinning: V.isSkinnedMesh === !0,
      morphTargets: X.morphAttributes.position !== void 0,
      morphNormals: X.morphAttributes.normal !== void 0,
      morphColors: X.morphAttributes.color !== void 0,
      morphTargetsCount: fe,
      morphTextureStride: Ge,
      numDirLights: b.directional.length,
      numPointLights: b.point.length,
      numSpotLights: b.spot.length,
      numSpotLightMaps: b.spotLightMap.length,
      numRectAreaLights: b.rectArea.length,
      numHemiLights: b.hemi.length,
      numDirLightShadows: b.directionalShadowMap.length,
      numPointLightShadows: b.pointShadowMap.length,
      numSpotLightShadows: b.spotShadowMap.length,
      numSpotLightShadowsWithMaps: b.numSpotLightShadowsWithMaps,
      numLightProbes: b.numLightProbes,
      numClippingPlanes: a.numPlanes,
      numClipIntersection: a.numIntersection,
      dithering: y.dithering,
      shadowMapEnabled: s.shadowMap.enabled && P.length > 0,
      shadowMapType: s.shadowMap.type,
      toneMapping: De,
      decodeVideoTexture: tt && y.map.isVideoTexture === !0 && Ke.getTransfer(y.map.colorSpace) === lt,
      decodeVideoTextureEmissive: At && y.emissiveMap.isVideoTexture === !0 && Ke.getTransfer(y.emissiveMap.colorSpace) === lt,
      premultipliedAlpha: y.premultipliedAlpha,
      doubleSided: y.side === fi,
      flipSided: y.side === Kt,
      useDepthPacking: y.depthPacking >= 0,
      depthPacking: y.depthPacking || 0,
      index0AttributeName: y.index0AttributeName,
      extensionClipCullDistance: ne && y.extensions.clipCullDistance === !0 && i.has("WEBGL_clip_cull_distance"),
      extensionMultiDraw: (ne && y.extensions.multiDraw === !0 || xe) && i.has("WEBGL_multi_draw"),
      rendererExtensionParallelShaderCompile: i.has("KHR_parallel_shader_compile"),
      customProgramCacheKey: y.customProgramCacheKey()
    };
    return mt.vertexUv1s = c.has(1), mt.vertexUv2s = c.has(2), mt.vertexUv3s = c.has(3), c.clear(), mt;
  }
  function p(y) {
    const b = [];
    if (y.shaderID ? b.push(y.shaderID) : (b.push(y.customVertexShaderID), b.push(y.customFragmentShaderID)), y.defines !== void 0)
      for (const P in y.defines)
        b.push(P), b.push(y.defines[P]);
    return y.isRawShaderMaterial === !1 && (w(b, y), M(b, y), b.push(s.outputColorSpace)), b.push(y.customProgramCacheKey), b.join();
  }
  function w(y, b) {
    y.push(b.precision), y.push(b.outputColorSpace), y.push(b.envMapMode), y.push(b.envMapCubeUVHeight), y.push(b.mapUv), y.push(b.alphaMapUv), y.push(b.lightMapUv), y.push(b.aoMapUv), y.push(b.bumpMapUv), y.push(b.normalMapUv), y.push(b.displacementMapUv), y.push(b.emissiveMapUv), y.push(b.metalnessMapUv), y.push(b.roughnessMapUv), y.push(b.anisotropyMapUv), y.push(b.clearcoatMapUv), y.push(b.clearcoatNormalMapUv), y.push(b.clearcoatRoughnessMapUv), y.push(b.iridescenceMapUv), y.push(b.iridescenceThicknessMapUv), y.push(b.sheenColorMapUv), y.push(b.sheenRoughnessMapUv), y.push(b.specularMapUv), y.push(b.specularColorMapUv), y.push(b.specularIntensityMapUv), y.push(b.transmissionMapUv), y.push(b.thicknessMapUv), y.push(b.combine), y.push(b.fogExp2), y.push(b.sizeAttenuation), y.push(b.morphTargetsCount), y.push(b.morphAttributeCount), y.push(b.numDirLights), y.push(b.numPointLights), y.push(b.numSpotLights), y.push(b.numSpotLightMaps), y.push(b.numHemiLights), y.push(b.numRectAreaLights), y.push(b.numDirLightShadows), y.push(b.numPointLightShadows), y.push(b.numSpotLightShadows), y.push(b.numSpotLightShadowsWithMaps), y.push(b.numLightProbes), y.push(b.shadowMapType), y.push(b.toneMapping), y.push(b.numClippingPlanes), y.push(b.numClipIntersection), y.push(b.depthPacking);
  }
  function M(y, b) {
    o.disableAll(), b.instancing && o.enable(0), b.instancingColor && o.enable(1), b.instancingMorph && o.enable(2), b.matcap && o.enable(3), b.envMap && o.enable(4), b.normalMapObjectSpace && o.enable(5), b.normalMapTangentSpace && o.enable(6), b.clearcoat && o.enable(7), b.iridescence && o.enable(8), b.alphaTest && o.enable(9), b.vertexColors && o.enable(10), b.vertexAlphas && o.enable(11), b.vertexUv1s && o.enable(12), b.vertexUv2s && o.enable(13), b.vertexUv3s && o.enable(14), b.vertexTangents && o.enable(15), b.anisotropy && o.enable(16), b.alphaHash && o.enable(17), b.batching && o.enable(18), b.dispersion && o.enable(19), b.batchingColor && o.enable(20), b.gradientMap && o.enable(21), y.push(o.mask), o.disableAll(), b.fog && o.enable(0), b.useFog && o.enable(1), b.flatShading && o.enable(2), b.logarithmicDepthBuffer && o.enable(3), b.reversedDepthBuffer && o.enable(4), b.skinning && o.enable(5), b.morphTargets && o.enable(6), b.morphNormals && o.enable(7), b.morphColors && o.enable(8), b.premultipliedAlpha && o.enable(9), b.shadowMapEnabled && o.enable(10), b.doubleSided && o.enable(11), b.flipSided && o.enable(12), b.useDepthPacking && o.enable(13), b.dithering && o.enable(14), b.transmission && o.enable(15), b.sheen && o.enable(16), b.opaque && o.enable(17), b.pointsUvs && o.enable(18), b.decodeVideoTexture && o.enable(19), b.decodeVideoTextureEmissive && o.enable(20), b.alphaToCoverage && o.enable(21), y.push(o.mask);
  }
  function T(y) {
    const b = g[y.type];
    let P;
    if (b) {
      const H = Ui[b];
      P = Jc.clone(H.uniforms);
    } else
      P = y.uniforms;
    return P;
  }
  function E(y, b) {
    let P = d.get(b);
    return P !== void 0 ? ++P.usedTimes : (P = new yw(s, b, y, r), h.push(P), d.set(b, P)), P;
  }
  function A(y) {
    if (--y.usedTimes === 0) {
      const b = h.indexOf(y);
      h[b] = h[h.length - 1], h.pop(), d.delete(y.cacheKey), y.destroy();
    }
  }
  function R(y) {
    l.remove(y);
  }
  function F() {
    l.dispose();
  }
  return {
    getParameters: m,
    getProgramCacheKey: p,
    getUniforms: T,
    acquireProgram: E,
    releaseProgram: A,
    releaseShaderCache: R,
    // Exposed for resource monitoring & error feedback via renderer.info:
    programs: h,
    dispose: F
  };
}
function Tw() {
  let s = /* @__PURE__ */ new WeakMap();
  function e(a) {
    return s.has(a);
  }
  function t(a) {
    let o = s.get(a);
    return o === void 0 && (o = {}, s.set(a, o)), o;
  }
  function i(a) {
    s.delete(a);
  }
  function n(a, o, l) {
    s.get(a)[o] = l;
  }
  function r() {
    s = /* @__PURE__ */ new WeakMap();
  }
  return {
    has: e,
    get: t,
    remove: i,
    update: n,
    dispose: r
  };
}
function Ew(s, e) {
  return s.groupOrder !== e.groupOrder ? s.groupOrder - e.groupOrder : s.renderOrder !== e.renderOrder ? s.renderOrder - e.renderOrder : s.material.id !== e.material.id ? s.material.id - e.material.id : s.z !== e.z ? s.z - e.z : s.id - e.id;
}
function Jd(s, e) {
  return s.groupOrder !== e.groupOrder ? s.groupOrder - e.groupOrder : s.renderOrder !== e.renderOrder ? s.renderOrder - e.renderOrder : s.z !== e.z ? e.z - s.z : s.id - e.id;
}
function Qd() {
  const s = [];
  let e = 0;
  const t = [], i = [], n = [];
  function r() {
    e = 0, t.length = 0, i.length = 0, n.length = 0;
  }
  function a(d, u, f, g, v, m) {
    let p = s[e];
    return p === void 0 ? (p = {
      id: d.id,
      object: d,
      geometry: u,
      material: f,
      groupOrder: g,
      renderOrder: d.renderOrder,
      z: v,
      group: m
    }, s[e] = p) : (p.id = d.id, p.object = d, p.geometry = u, p.material = f, p.groupOrder = g, p.renderOrder = d.renderOrder, p.z = v, p.group = m), e++, p;
  }
  function o(d, u, f, g, v, m) {
    const p = a(d, u, f, g, v, m);
    f.transmission > 0 ? i.push(p) : f.transparent === !0 ? n.push(p) : t.push(p);
  }
  function l(d, u, f, g, v, m) {
    const p = a(d, u, f, g, v, m);
    f.transmission > 0 ? i.unshift(p) : f.transparent === !0 ? n.unshift(p) : t.unshift(p);
  }
  function c(d, u) {
    t.length > 1 && t.sort(d || Ew), i.length > 1 && i.sort(u || Jd), n.length > 1 && n.sort(u || Jd);
  }
  function h() {
    for (let d = e, u = s.length; d < u; d++) {
      const f = s[d];
      if (f.id === null) break;
      f.id = null, f.object = null, f.geometry = null, f.material = null, f.group = null;
    }
  }
  return {
    opaque: t,
    transmissive: i,
    transparent: n,
    init: r,
    push: o,
    unshift: l,
    finish: h,
    sort: c
  };
}
function Aw() {
  let s = /* @__PURE__ */ new WeakMap();
  function e(i, n) {
    const r = s.get(i);
    let a;
    return r === void 0 ? (a = new Qd(), s.set(i, [a])) : n >= r.length ? (a = new Qd(), r.push(a)) : a = r[n], a;
  }
  function t() {
    s = /* @__PURE__ */ new WeakMap();
  }
  return {
    get: e,
    dispose: t
  };
}
function Rw() {
  const s = {};
  return {
    get: function(e) {
      if (s[e.id] !== void 0)
        return s[e.id];
      let t;
      switch (e.type) {
        case "DirectionalLight":
          t = {
            direction: new O(),
            color: new Ne()
          };
          break;
        case "SpotLight":
          t = {
            position: new O(),
            direction: new O(),
            color: new Ne(),
            distance: 0,
            coneCos: 0,
            penumbraCos: 0,
            decay: 0
          };
          break;
        case "PointLight":
          t = {
            position: new O(),
            color: new Ne(),
            distance: 0,
            decay: 0
          };
          break;
        case "HemisphereLight":
          t = {
            direction: new O(),
            skyColor: new Ne(),
            groundColor: new Ne()
          };
          break;
        case "RectAreaLight":
          t = {
            color: new Ne(),
            position: new O(),
            halfWidth: new O(),
            halfHeight: new O()
          };
          break;
      }
      return s[e.id] = t, t;
    }
  };
}
function Cw() {
  const s = {};
  return {
    get: function(e) {
      if (s[e.id] !== void 0)
        return s[e.id];
      let t;
      switch (e.type) {
        case "DirectionalLight":
          t = {
            shadowIntensity: 1,
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new Ye()
          };
          break;
        case "SpotLight":
          t = {
            shadowIntensity: 1,
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new Ye()
          };
          break;
        case "PointLight":
          t = {
            shadowIntensity: 1,
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new Ye(),
            shadowCameraNear: 1,
            shadowCameraFar: 1e3
          };
          break;
      }
      return s[e.id] = t, t;
    }
  };
}
let Iw = 0;
function Pw(s, e) {
  return (e.castShadow ? 2 : 0) - (s.castShadow ? 2 : 0) + (e.map ? 1 : 0) - (s.map ? 1 : 0);
}
function Lw(s) {
  const e = new Rw(), t = Cw(), i = {
    version: 0,
    hash: {
      directionalLength: -1,
      pointLength: -1,
      spotLength: -1,
      rectAreaLength: -1,
      hemiLength: -1,
      numDirectionalShadows: -1,
      numPointShadows: -1,
      numSpotShadows: -1,
      numSpotMaps: -1,
      numLightProbes: -1
    },
    ambient: [0, 0, 0],
    probe: [],
    directional: [],
    directionalShadow: [],
    directionalShadowMap: [],
    directionalShadowMatrix: [],
    spot: [],
    spotLightMap: [],
    spotShadow: [],
    spotShadowMap: [],
    spotLightMatrix: [],
    rectArea: [],
    rectAreaLTC1: null,
    rectAreaLTC2: null,
    point: [],
    pointShadow: [],
    pointShadowMap: [],
    pointShadowMatrix: [],
    hemi: [],
    numSpotLightShadowsWithMaps: 0,
    numLightProbes: 0
  };
  for (let c = 0; c < 9; c++) i.probe.push(new O());
  const n = new O(), r = new ze(), a = new ze();
  function o(c) {
    let h = 0, d = 0, u = 0;
    for (let y = 0; y < 9; y++) i.probe[y].set(0, 0, 0);
    let f = 0, g = 0, v = 0, m = 0, p = 0, w = 0, M = 0, T = 0, E = 0, A = 0, R = 0;
    c.sort(Pw);
    for (let y = 0, b = c.length; y < b; y++) {
      const P = c[y], H = P.color, V = P.intensity, Y = P.distance;
      let X = null;
      if (P.shadow && P.shadow.map && (P.shadow.map.texture.format === Fs ? X = P.shadow.map.texture : X = P.shadow.map.depthTexture || P.shadow.map.texture), P.isAmbientLight)
        h += H.r * V, d += H.g * V, u += H.b * V;
      else if (P.isLightProbe) {
        for (let q = 0; q < 9; q++)
          i.probe[q].addScaledVector(P.sh.coefficients[q], V);
        R++;
      } else if (P.isDirectionalLight) {
        const q = e.get(P);
        if (q.color.copy(P.color).multiplyScalar(P.intensity), P.castShadow) {
          const z = P.shadow, J = t.get(P);
          J.shadowIntensity = z.intensity, J.shadowBias = z.bias, J.shadowNormalBias = z.normalBias, J.shadowRadius = z.radius, J.shadowMapSize = z.mapSize, i.directionalShadow[f] = J, i.directionalShadowMap[f] = X, i.directionalShadowMatrix[f] = P.shadow.matrix, w++;
        }
        i.directional[f] = q, f++;
      } else if (P.isSpotLight) {
        const q = e.get(P);
        q.position.setFromMatrixPosition(P.matrixWorld), q.color.copy(H).multiplyScalar(V), q.distance = Y, q.coneCos = Math.cos(P.angle), q.penumbraCos = Math.cos(P.angle * (1 - P.penumbra)), q.decay = P.decay, i.spot[v] = q;
        const z = P.shadow;
        if (P.map && (i.spotLightMap[E] = P.map, E++, z.updateMatrices(P), P.castShadow && A++), i.spotLightMatrix[v] = z.matrix, P.castShadow) {
          const J = t.get(P);
          J.shadowIntensity = z.intensity, J.shadowBias = z.bias, J.shadowNormalBias = z.normalBias, J.shadowRadius = z.radius, J.shadowMapSize = z.mapSize, i.spotShadow[v] = J, i.spotShadowMap[v] = X, T++;
        }
        v++;
      } else if (P.isRectAreaLight) {
        const q = e.get(P);
        q.color.copy(H).multiplyScalar(V), q.halfWidth.set(P.width * 0.5, 0, 0), q.halfHeight.set(0, P.height * 0.5, 0), i.rectArea[m] = q, m++;
      } else if (P.isPointLight) {
        const q = e.get(P);
        if (q.color.copy(P.color).multiplyScalar(P.intensity), q.distance = P.distance, q.decay = P.decay, P.castShadow) {
          const z = P.shadow, J = t.get(P);
          J.shadowIntensity = z.intensity, J.shadowBias = z.bias, J.shadowNormalBias = z.normalBias, J.shadowRadius = z.radius, J.shadowMapSize = z.mapSize, J.shadowCameraNear = z.camera.near, J.shadowCameraFar = z.camera.far, i.pointShadow[g] = J, i.pointShadowMap[g] = X, i.pointShadowMatrix[g] = P.shadow.matrix, M++;
        }
        i.point[g] = q, g++;
      } else if (P.isHemisphereLight) {
        const q = e.get(P);
        q.skyColor.copy(P.color).multiplyScalar(V), q.groundColor.copy(P.groundColor).multiplyScalar(V), i.hemi[p] = q, p++;
      }
    }
    m > 0 && (s.has("OES_texture_float_linear") === !0 ? (i.rectAreaLTC1 = ce.LTC_FLOAT_1, i.rectAreaLTC2 = ce.LTC_FLOAT_2) : (i.rectAreaLTC1 = ce.LTC_HALF_1, i.rectAreaLTC2 = ce.LTC_HALF_2)), i.ambient[0] = h, i.ambient[1] = d, i.ambient[2] = u;
    const F = i.hash;
    (F.directionalLength !== f || F.pointLength !== g || F.spotLength !== v || F.rectAreaLength !== m || F.hemiLength !== p || F.numDirectionalShadows !== w || F.numPointShadows !== M || F.numSpotShadows !== T || F.numSpotMaps !== E || F.numLightProbes !== R) && (i.directional.length = f, i.spot.length = v, i.rectArea.length = m, i.point.length = g, i.hemi.length = p, i.directionalShadow.length = w, i.directionalShadowMap.length = w, i.pointShadow.length = M, i.pointShadowMap.length = M, i.spotShadow.length = T, i.spotShadowMap.length = T, i.directionalShadowMatrix.length = w, i.pointShadowMatrix.length = M, i.spotLightMatrix.length = T + E - A, i.spotLightMap.length = E, i.numSpotLightShadowsWithMaps = A, i.numLightProbes = R, F.directionalLength = f, F.pointLength = g, F.spotLength = v, F.rectAreaLength = m, F.hemiLength = p, F.numDirectionalShadows = w, F.numPointShadows = M, F.numSpotShadows = T, F.numSpotMaps = E, F.numLightProbes = R, i.version = Iw++);
  }
  function l(c, h) {
    let d = 0, u = 0, f = 0, g = 0, v = 0;
    const m = h.matrixWorldInverse;
    for (let p = 0, w = c.length; p < w; p++) {
      const M = c[p];
      if (M.isDirectionalLight) {
        const T = i.directional[d];
        T.direction.setFromMatrixPosition(M.matrixWorld), n.setFromMatrixPosition(M.target.matrixWorld), T.direction.sub(n), T.direction.transformDirection(m), d++;
      } else if (M.isSpotLight) {
        const T = i.spot[f];
        T.position.setFromMatrixPosition(M.matrixWorld), T.position.applyMatrix4(m), T.direction.setFromMatrixPosition(M.matrixWorld), n.setFromMatrixPosition(M.target.matrixWorld), T.direction.sub(n), T.direction.transformDirection(m), f++;
      } else if (M.isRectAreaLight) {
        const T = i.rectArea[g];
        T.position.setFromMatrixPosition(M.matrixWorld), T.position.applyMatrix4(m), a.identity(), r.copy(M.matrixWorld), r.premultiply(m), a.extractRotation(r), T.halfWidth.set(M.width * 0.5, 0, 0), T.halfHeight.set(0, M.height * 0.5, 0), T.halfWidth.applyMatrix4(a), T.halfHeight.applyMatrix4(a), g++;
      } else if (M.isPointLight) {
        const T = i.point[u];
        T.position.setFromMatrixPosition(M.matrixWorld), T.position.applyMatrix4(m), u++;
      } else if (M.isHemisphereLight) {
        const T = i.hemi[v];
        T.direction.setFromMatrixPosition(M.matrixWorld), T.direction.transformDirection(m), v++;
      }
    }
  }
  return {
    setup: o,
    setupView: l,
    state: i
  };
}
function eu(s) {
  const e = new Lw(s), t = [], i = [];
  function n(h) {
    c.camera = h, t.length = 0, i.length = 0;
  }
  function r(h) {
    t.push(h);
  }
  function a(h) {
    i.push(h);
  }
  function o() {
    e.setup(t);
  }
  function l(h) {
    e.setupView(t, h);
  }
  const c = {
    lightsArray: t,
    shadowsArray: i,
    camera: null,
    lights: e,
    transmissionRenderTarget: {}
  };
  return {
    init: n,
    state: c,
    setupLights: o,
    setupLightsView: l,
    pushLight: r,
    pushShadow: a
  };
}
function Dw(s) {
  let e = /* @__PURE__ */ new WeakMap();
  function t(n, r = 0) {
    const a = e.get(n);
    let o;
    return a === void 0 ? (o = new eu(s), e.set(n, [o])) : r >= a.length ? (o = new eu(s), a.push(o)) : o = a[r], o;
  }
  function i() {
    e = /* @__PURE__ */ new WeakMap();
  }
  return {
    get: t,
    dispose: i
  };
}
const Nw = `void main() {
	gl_Position = vec4( position, 1.0 );
}`, Ow = `uniform sampler2D shadow_pass;
uniform vec2 resolution;
uniform float radius;
void main() {
	const float samples = float( VSM_SAMPLES );
	float mean = 0.0;
	float squared_mean = 0.0;
	float uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );
	float uvStart = samples <= 1.0 ? 0.0 : - 1.0;
	for ( float i = 0.0; i < samples; i ++ ) {
		float uvOffset = uvStart + i * uvStride;
		#ifdef HORIZONTAL_PASS
			vec2 distribution = texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ).rg;
			mean += distribution.x;
			squared_mean += distribution.y * distribution.y + distribution.x * distribution.x;
		#else
			float depth = texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ).r;
			mean += depth;
			squared_mean += depth * depth;
		#endif
	}
	mean = mean / samples;
	squared_mean = squared_mean / samples;
	float std_dev = sqrt( max( 0.0, squared_mean - mean * mean ) );
	gl_FragColor = vec4( mean, std_dev, 0.0, 1.0 );
}`, Uw = [
  /* @__PURE__ */ new O(1, 0, 0),
  /* @__PURE__ */ new O(-1, 0, 0),
  /* @__PURE__ */ new O(0, 1, 0),
  /* @__PURE__ */ new O(0, -1, 0),
  /* @__PURE__ */ new O(0, 0, 1),
  /* @__PURE__ */ new O(0, 0, -1)
], Fw = [
  /* @__PURE__ */ new O(0, -1, 0),
  /* @__PURE__ */ new O(0, -1, 0),
  /* @__PURE__ */ new O(0, 0, 1),
  /* @__PURE__ */ new O(0, 0, -1),
  /* @__PURE__ */ new O(0, -1, 0),
  /* @__PURE__ */ new O(0, -1, 0)
], tu = /* @__PURE__ */ new ze(), lr = /* @__PURE__ */ new O(), tl = /* @__PURE__ */ new O();
function Bw(s, e, t) {
  let i = new ih();
  const n = new Ye(), r = new Ye(), a = new _t(), o = new M_(), l = new T_(), c = {}, h = t.maxTextureSize, d = { [hn]: Kt, [Kt]: hn, [fi]: fi }, u = new oi({
    defines: {
      VSM_SAMPLES: 8
    },
    uniforms: {
      shadow_pass: { value: null },
      resolution: { value: new Ye() },
      radius: { value: 4 }
    },
    vertexShader: Nw,
    fragmentShader: Ow
  }), f = u.clone();
  f.defines.HORIZONTAL_PASS = 1;
  const g = new ci();
  g.setAttribute(
    "position",
    new qt(
      new Float32Array([-1, -1, 0.5, 3, -1, 0.5, -1, 3, 0.5]),
      3
    )
  );
  const v = new zt(g, u), m = this;
  this.enabled = !1, this.autoUpdate = !0, this.needsUpdate = !1, this.type = Sa;
  let p = this.type;
  this.render = function(A, R, F) {
    if (m.enabled === !1 || m.autoUpdate === !1 && m.needsUpdate === !1 || A.length === 0) return;
    A.type === Hg && (Te("WebGLShadowMap: PCFSoftShadowMap has been deprecated. Using PCFShadowMap instead."), A.type = Sa);
    const y = s.getRenderTarget(), b = s.getActiveCubeFace(), P = s.getActiveMipmapLevel(), H = s.state;
    H.setBlending(ki), H.buffers.depth.getReversed() === !0 ? H.buffers.color.setClear(0, 0, 0, 0) : H.buffers.color.setClear(1, 1, 1, 1), H.buffers.depth.setTest(!0), H.setScissorTest(!1);
    const V = p !== this.type;
    V && R.traverse(function(Y) {
      Y.material && (Array.isArray(Y.material) ? Y.material.forEach((X) => X.needsUpdate = !0) : Y.material.needsUpdate = !0);
    });
    for (let Y = 0, X = A.length; Y < X; Y++) {
      const q = A[Y], z = q.shadow;
      if (z === void 0) {
        Te("WebGLShadowMap:", q, "has no shadow.");
        continue;
      }
      if (z.autoUpdate === !1 && z.needsUpdate === !1) continue;
      n.copy(z.mapSize);
      const J = z.getFrameExtents();
      if (n.multiply(J), r.copy(z.mapSize), (n.x > h || n.y > h) && (n.x > h && (r.x = Math.floor(h / J.x), n.x = r.x * J.x, z.mapSize.x = r.x), n.y > h && (r.y = Math.floor(h / J.y), n.y = r.y * J.y, z.mapSize.y = r.y)), z.map === null || V === !0) {
        if (z.map !== null && (z.map.depthTexture !== null && (z.map.depthTexture.dispose(), z.map.depthTexture = null), z.map.dispose()), this.type === hr) {
          if (q.isPointLight) {
            Te("WebGLShadowMap: VSM shadow maps are not supported for PointLights. Use PCF or BasicShadowMap instead.");
            continue;
          }
          z.map = new gi(n.x, n.y, {
            format: Fs,
            type: Ai,
            minFilter: bt,
            magFilter: bt,
            generateMipmaps: !1
          }), z.map.texture.name = q.name + ".shadowMap", z.map.depthTexture = new Ir(n.x, n.y, pi), z.map.depthTexture.name = q.name + ".shadowMapDepth", z.map.depthTexture.format = dn, z.map.depthTexture.compareFunction = null, z.map.depthTexture.minFilter = It, z.map.depthTexture.magFilter = It;
        } else {
          q.isPointLight ? (z.map = new of(n.x), z.map.depthTexture = new w_(n.x, Hi)) : (z.map = new gi(n.x, n.y), z.map.depthTexture = new Ir(n.x, n.y, Hi)), z.map.depthTexture.name = q.name + ".shadowMap", z.map.depthTexture.format = dn;
          const le = s.state.buffers.depth.getReversed();
          this.type === Sa ? (z.map.depthTexture.compareFunction = le ? Yc : jc, z.map.depthTexture.minFilter = bt, z.map.depthTexture.magFilter = bt) : (z.map.depthTexture.compareFunction = null, z.map.depthTexture.minFilter = It, z.map.depthTexture.magFilter = It);
        }
        z.camera.updateProjectionMatrix();
      }
      const ue = z.map.isWebGLCubeRenderTarget ? 6 : 1;
      for (let le = 0; le < ue; le++) {
        if (z.map.isWebGLCubeRenderTarget)
          s.setRenderTarget(z.map, le), s.clear();
        else {
          le === 0 && (s.setRenderTarget(z.map), s.clear());
          const fe = z.getViewport(le);
          a.set(
            r.x * fe.x,
            r.y * fe.y,
            r.x * fe.z,
            r.y * fe.w
          ), H.viewport(a);
        }
        if (q.isPointLight) {
          const fe = z.camera, Ge = z.matrix, Ve = q.distance || fe.far;
          Ve !== fe.far && (fe.far = Ve, fe.updateProjectionMatrix()), lr.setFromMatrixPosition(q.matrixWorld), fe.position.copy(lr), tl.copy(fe.position), tl.add(Uw[le]), fe.up.copy(Fw[le]), fe.lookAt(tl), fe.updateMatrixWorld(), Ge.makeTranslation(-lr.x, -lr.y, -lr.z), tu.multiplyMatrices(fe.projectionMatrix, fe.matrixWorldInverse), z._frustum.setFromProjectionMatrix(tu, fe.coordinateSystem, fe.reversedDepth);
        } else
          z.updateMatrices(q);
        i = z.getFrustum(), T(R, F, z.camera, q, this.type);
      }
      z.isPointLightShadow !== !0 && this.type === hr && w(z, F), z.needsUpdate = !1;
    }
    p = this.type, m.needsUpdate = !1, s.setRenderTarget(y, b, P);
  };
  function w(A, R) {
    const F = e.update(v);
    u.defines.VSM_SAMPLES !== A.blurSamples && (u.defines.VSM_SAMPLES = A.blurSamples, f.defines.VSM_SAMPLES = A.blurSamples, u.needsUpdate = !0, f.needsUpdate = !0), A.mapPass === null && (A.mapPass = new gi(n.x, n.y, {
      format: Fs,
      type: Ai
    })), u.uniforms.shadow_pass.value = A.map.depthTexture, u.uniforms.resolution.value = A.mapSize, u.uniforms.radius.value = A.radius, s.setRenderTarget(A.mapPass), s.clear(), s.renderBufferDirect(R, null, F, u, v, null), f.uniforms.shadow_pass.value = A.mapPass.texture, f.uniforms.resolution.value = A.mapSize, f.uniforms.radius.value = A.radius, s.setRenderTarget(A.map), s.clear(), s.renderBufferDirect(R, null, F, f, v, null);
  }
  function M(A, R, F, y) {
    let b = null;
    const P = F.isPointLight === !0 ? A.customDistanceMaterial : A.customDepthMaterial;
    if (P !== void 0)
      b = P;
    else if (b = F.isPointLight === !0 ? l : o, s.localClippingEnabled && R.clipShadows === !0 && Array.isArray(R.clippingPlanes) && R.clippingPlanes.length !== 0 || R.displacementMap && R.displacementScale !== 0 || R.alphaMap && R.alphaTest > 0 || R.map && R.alphaTest > 0 || R.alphaToCoverage === !0) {
      const H = b.uuid, V = R.uuid;
      let Y = c[H];
      Y === void 0 && (Y = {}, c[H] = Y);
      let X = Y[V];
      X === void 0 && (X = b.clone(), Y[V] = X, R.addEventListener("dispose", E)), b = X;
    }
    if (b.visible = R.visible, b.wireframe = R.wireframe, y === hr ? b.side = R.shadowSide !== null ? R.shadowSide : R.side : b.side = R.shadowSide !== null ? R.shadowSide : d[R.side], b.alphaMap = R.alphaMap, b.alphaTest = R.alphaToCoverage === !0 ? 0.5 : R.alphaTest, b.map = R.map, b.clipShadows = R.clipShadows, b.clippingPlanes = R.clippingPlanes, b.clipIntersection = R.clipIntersection, b.displacementMap = R.displacementMap, b.displacementScale = R.displacementScale, b.displacementBias = R.displacementBias, b.wireframeLinewidth = R.wireframeLinewidth, b.linewidth = R.linewidth, F.isPointLight === !0 && b.isMeshDistanceMaterial === !0) {
      const H = s.properties.get(b);
      H.light = F;
    }
    return b;
  }
  function T(A, R, F, y, b) {
    if (A.visible === !1) return;
    if (A.layers.test(R.layers) && (A.isMesh || A.isLine || A.isPoints) && (A.castShadow || A.receiveShadow && b === hr) && (!A.frustumCulled || i.intersectsObject(A))) {
      A.modelViewMatrix.multiplyMatrices(F.matrixWorldInverse, A.matrixWorld);
      const V = e.update(A), Y = A.material;
      if (Array.isArray(Y)) {
        const X = V.groups;
        for (let q = 0, z = X.length; q < z; q++) {
          const J = X[q], ue = Y[J.materialIndex];
          if (ue && ue.visible) {
            const le = M(A, ue, y, b);
            A.onBeforeShadow(s, A, R, F, V, le, J), s.renderBufferDirect(F, null, V, le, A, J), A.onAfterShadow(s, A, R, F, V, le, J);
          }
        }
      } else if (Y.visible) {
        const X = M(A, Y, y, b);
        A.onBeforeShadow(s, A, R, F, V, X, null), s.renderBufferDirect(F, null, V, X, A, null), A.onAfterShadow(s, A, R, F, V, X, null);
      }
    }
    const H = A.children;
    for (let V = 0, Y = H.length; V < Y; V++)
      T(H[V], R, F, y, b);
  }
  function E(A) {
    A.target.removeEventListener("dispose", E);
    for (const F in c) {
      const y = c[F], b = A.target.uuid;
      b in y && (y[b].dispose(), delete y[b]);
    }
  }
}
const kw = {
  [yl]: bl,
  [wl]: Tl,
  [Sl]: El,
  [Ns]: Ml,
  [bl]: yl,
  [Tl]: wl,
  [El]: Sl,
  [Ml]: Ns
};
function zw(s, e) {
  function t() {
    let I = !1;
    const de = new _t();
    let ie = null;
    const pe = new _t(0, 0, 0, 0);
    return {
      setMask: function(ee) {
        ie !== ee && !I && (s.colorMask(ee, ee, ee, ee), ie = ee);
      },
      setLocked: function(ee) {
        I = ee;
      },
      setClear: function(ee, K, ne, De, mt) {
        mt === !0 && (ee *= De, K *= De, ne *= De), de.set(ee, K, ne, De), pe.equals(de) === !1 && (s.clearColor(ee, K, ne, De), pe.copy(de));
      },
      reset: function() {
        I = !1, ie = null, pe.set(-1, 0, 0, 0);
      }
    };
  }
  function i() {
    let I = !1, de = !1, ie = null, pe = null, ee = null;
    return {
      setReversed: function(K) {
        if (de !== K) {
          const ne = e.get("EXT_clip_control");
          K ? ne.clipControlEXT(ne.LOWER_LEFT_EXT, ne.ZERO_TO_ONE_EXT) : ne.clipControlEXT(ne.LOWER_LEFT_EXT, ne.NEGATIVE_ONE_TO_ONE_EXT), de = K;
          const De = ee;
          ee = null, this.setClear(De);
        }
      },
      getReversed: function() {
        return de;
      },
      setTest: function(K) {
        K ? Q(s.DEPTH_TEST) : ge(s.DEPTH_TEST);
      },
      setMask: function(K) {
        ie !== K && !I && (s.depthMask(K), ie = K);
      },
      setFunc: function(K) {
        if (de && (K = kw[K]), pe !== K) {
          switch (K) {
            case yl:
              s.depthFunc(s.NEVER);
              break;
            case bl:
              s.depthFunc(s.ALWAYS);
              break;
            case wl:
              s.depthFunc(s.LESS);
              break;
            case Ns:
              s.depthFunc(s.LEQUAL);
              break;
            case Sl:
              s.depthFunc(s.EQUAL);
              break;
            case Ml:
              s.depthFunc(s.GEQUAL);
              break;
            case Tl:
              s.depthFunc(s.GREATER);
              break;
            case El:
              s.depthFunc(s.NOTEQUAL);
              break;
            default:
              s.depthFunc(s.LEQUAL);
          }
          pe = K;
        }
      },
      setLocked: function(K) {
        I = K;
      },
      setClear: function(K) {
        ee !== K && (de && (K = 1 - K), s.clearDepth(K), ee = K);
      },
      reset: function() {
        I = !1, ie = null, pe = null, ee = null, de = !1;
      }
    };
  }
  function n() {
    let I = !1, de = null, ie = null, pe = null, ee = null, K = null, ne = null, De = null, mt = null;
    return {
      setTest: function(at) {
        I || (at ? Q(s.STENCIL_TEST) : ge(s.STENCIL_TEST));
      },
      setMask: function(at) {
        de !== at && !I && (s.stencilMask(at), de = at);
      },
      setFunc: function(at, Di, Yi) {
        (ie !== at || pe !== Di || ee !== Yi) && (s.stencilFunc(at, Di, Yi), ie = at, pe = Di, ee = Yi);
      },
      setOp: function(at, Di, Yi) {
        (K !== at || ne !== Di || De !== Yi) && (s.stencilOp(at, Di, Yi), K = at, ne = Di, De = Yi);
      },
      setLocked: function(at) {
        I = at;
      },
      setClear: function(at) {
        mt !== at && (s.clearStencil(at), mt = at);
      },
      reset: function() {
        I = !1, de = null, ie = null, pe = null, ee = null, K = null, ne = null, De = null, mt = null;
      }
    };
  }
  const r = new t(), a = new i(), o = new n(), l = /* @__PURE__ */ new WeakMap(), c = /* @__PURE__ */ new WeakMap();
  let h = {}, d = {}, u = /* @__PURE__ */ new WeakMap(), f = [], g = null, v = !1, m = null, p = null, w = null, M = null, T = null, E = null, A = null, R = new Ne(0, 0, 0), F = 0, y = !1, b = null, P = null, H = null, V = null, Y = null;
  const X = s.getParameter(s.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
  let q = !1, z = 0;
  const J = s.getParameter(s.VERSION);
  J.indexOf("WebGL") !== -1 ? (z = parseFloat(/^WebGL (\d)/.exec(J)[1]), q = z >= 1) : J.indexOf("OpenGL ES") !== -1 && (z = parseFloat(/^OpenGL ES (\d)/.exec(J)[1]), q = z >= 2);
  let ue = null, le = {};
  const fe = s.getParameter(s.SCISSOR_BOX), Ge = s.getParameter(s.VIEWPORT), Ve = new _t().fromArray(fe), yt = new _t().fromArray(Ge);
  function vt(I, de, ie, pe) {
    const ee = new Uint8Array(4), K = s.createTexture();
    s.bindTexture(I, K), s.texParameteri(I, s.TEXTURE_MIN_FILTER, s.NEAREST), s.texParameteri(I, s.TEXTURE_MAG_FILTER, s.NEAREST);
    for (let ne = 0; ne < ie; ne++)
      I === s.TEXTURE_3D || I === s.TEXTURE_2D_ARRAY ? s.texImage3D(de, 0, s.RGBA, 1, 1, pe, 0, s.RGBA, s.UNSIGNED_BYTE, ee) : s.texImage2D(de + ne, 0, s.RGBA, 1, 1, 0, s.RGBA, s.UNSIGNED_BYTE, ee);
    return K;
  }
  const j = {};
  j[s.TEXTURE_2D] = vt(s.TEXTURE_2D, s.TEXTURE_2D, 1), j[s.TEXTURE_CUBE_MAP] = vt(s.TEXTURE_CUBE_MAP, s.TEXTURE_CUBE_MAP_POSITIVE_X, 6), j[s.TEXTURE_2D_ARRAY] = vt(s.TEXTURE_2D_ARRAY, s.TEXTURE_2D_ARRAY, 1, 1), j[s.TEXTURE_3D] = vt(s.TEXTURE_3D, s.TEXTURE_3D, 1, 1), r.setClear(0, 0, 0, 1), a.setClear(1), o.setClear(0), Q(s.DEPTH_TEST), a.setFunc(Ns), He(!1), Et(qh), Q(s.CULL_FACE), rt(ki);
  function Q(I) {
    h[I] !== !0 && (s.enable(I), h[I] = !0);
  }
  function ge(I) {
    h[I] !== !1 && (s.disable(I), h[I] = !1);
  }
  function Fe(I, de) {
    return d[I] !== de ? (s.bindFramebuffer(I, de), d[I] = de, I === s.DRAW_FRAMEBUFFER && (d[s.FRAMEBUFFER] = de), I === s.FRAMEBUFFER && (d[s.DRAW_FRAMEBUFFER] = de), !0) : !1;
  }
  function xe(I, de) {
    let ie = f, pe = !1;
    if (I) {
      ie = u.get(de), ie === void 0 && (ie = [], u.set(de, ie));
      const ee = I.textures;
      if (ie.length !== ee.length || ie[0] !== s.COLOR_ATTACHMENT0) {
        for (let K = 0, ne = ee.length; K < ne; K++)
          ie[K] = s.COLOR_ATTACHMENT0 + K;
        ie.length = ee.length, pe = !0;
      }
    } else
      ie[0] !== s.BACK && (ie[0] = s.BACK, pe = !0);
    pe && s.drawBuffers(ie);
  }
  function tt(I) {
    return g !== I ? (s.useProgram(I), g = I, !0) : !1;
  }
  const Dt = {
    [Wn]: s.FUNC_ADD,
    [Gg]: s.FUNC_SUBTRACT,
    [qg]: s.FUNC_REVERSE_SUBTRACT
  };
  Dt[Wg] = s.MIN, Dt[Xg] = s.MAX;
  const et = {
    [jg]: s.ZERO,
    [Yg]: s.ONE,
    [Kg]: s.SRC_COLOR,
    [_l]: s.SRC_ALPHA,
    [iv]: s.SRC_ALPHA_SATURATE,
    [ev]: s.DST_COLOR,
    [Jg]: s.DST_ALPHA,
    [Zg]: s.ONE_MINUS_SRC_COLOR,
    [xl]: s.ONE_MINUS_SRC_ALPHA,
    [tv]: s.ONE_MINUS_DST_COLOR,
    [Qg]: s.ONE_MINUS_DST_ALPHA,
    [nv]: s.CONSTANT_COLOR,
    [sv]: s.ONE_MINUS_CONSTANT_COLOR,
    [rv]: s.CONSTANT_ALPHA,
    [av]: s.ONE_MINUS_CONSTANT_ALPHA
  };
  function rt(I, de, ie, pe, ee, K, ne, De, mt, at) {
    if (I === ki) {
      v === !0 && (ge(s.BLEND), v = !1);
      return;
    }
    if (v === !1 && (Q(s.BLEND), v = !0), I !== $g) {
      if (I !== m || at !== y) {
        if ((p !== Wn || T !== Wn) && (s.blendEquation(s.FUNC_ADD), p = Wn, T = Wn), at)
          switch (I) {
            case Kn:
              s.blendFuncSeparate(s.ONE, s.ONE_MINUS_SRC_ALPHA, s.ONE, s.ONE_MINUS_SRC_ALPHA);
              break;
            case vl:
              s.blendFunc(s.ONE, s.ONE);
              break;
            case Wh:
              s.blendFuncSeparate(s.ZERO, s.ONE_MINUS_SRC_COLOR, s.ZERO, s.ONE);
              break;
            case Xh:
              s.blendFuncSeparate(s.DST_COLOR, s.ONE_MINUS_SRC_ALPHA, s.ZERO, s.ONE);
              break;
            default:
              Ce("WebGLState: Invalid blending: ", I);
              break;
          }
        else
          switch (I) {
            case Kn:
              s.blendFuncSeparate(s.SRC_ALPHA, s.ONE_MINUS_SRC_ALPHA, s.ONE, s.ONE_MINUS_SRC_ALPHA);
              break;
            case vl:
              s.blendFuncSeparate(s.SRC_ALPHA, s.ONE, s.ONE, s.ONE);
              break;
            case Wh:
              Ce("WebGLState: SubtractiveBlending requires material.premultipliedAlpha = true");
              break;
            case Xh:
              Ce("WebGLState: MultiplyBlending requires material.premultipliedAlpha = true");
              break;
            default:
              Ce("WebGLState: Invalid blending: ", I);
              break;
          }
        w = null, M = null, E = null, A = null, R.set(0, 0, 0), F = 0, m = I, y = at;
      }
      return;
    }
    ee = ee || de, K = K || ie, ne = ne || pe, (de !== p || ee !== T) && (s.blendEquationSeparate(Dt[de], Dt[ee]), p = de, T = ee), (ie !== w || pe !== M || K !== E || ne !== A) && (s.blendFuncSeparate(et[ie], et[pe], et[K], et[ne]), w = ie, M = pe, E = K, A = ne), (De.equals(R) === !1 || mt !== F) && (s.blendColor(De.r, De.g, De.b, mt), R.copy(De), F = mt), m = I, y = !1;
  }
  function dt(I, de) {
    I.side === fi ? ge(s.CULL_FACE) : Q(s.CULL_FACE);
    let ie = I.side === Kt;
    de && (ie = !ie), He(ie), I.blending === Kn && I.transparent === !1 ? rt(ki) : rt(I.blending, I.blendEquation, I.blendSrc, I.blendDst, I.blendEquationAlpha, I.blendSrcAlpha, I.blendDstAlpha, I.blendColor, I.blendAlpha, I.premultipliedAlpha), a.setFunc(I.depthFunc), a.setTest(I.depthTest), a.setMask(I.depthWrite), r.setMask(I.colorWrite);
    const pe = I.stencilWrite;
    o.setTest(pe), pe && (o.setMask(I.stencilWriteMask), o.setFunc(I.stencilFunc, I.stencilRef, I.stencilFuncMask), o.setOp(I.stencilFail, I.stencilZFail, I.stencilZPass)), At(I.polygonOffset, I.polygonOffsetFactor, I.polygonOffsetUnits), I.alphaToCoverage === !0 ? Q(s.SAMPLE_ALPHA_TO_COVERAGE) : ge(s.SAMPLE_ALPHA_TO_COVERAGE);
  }
  function He(I) {
    b !== I && (I ? s.frontFace(s.CW) : s.frontFace(s.CCW), b = I);
  }
  function Et(I) {
    I !== zg ? (Q(s.CULL_FACE), I !== P && (I === qh ? s.cullFace(s.BACK) : I === Vg ? s.cullFace(s.FRONT) : s.cullFace(s.FRONT_AND_BACK))) : ge(s.CULL_FACE), P = I;
  }
  function C(I) {
    I !== H && (q && s.lineWidth(I), H = I);
  }
  function At(I, de, ie) {
    I ? (Q(s.POLYGON_OFFSET_FILL), (V !== de || Y !== ie) && (s.polygonOffset(de, ie), V = de, Y = ie)) : ge(s.POLYGON_OFFSET_FILL);
  }
  function nt(I) {
    I ? Q(s.SCISSOR_TEST) : ge(s.SCISSOR_TEST);
  }
  function pt(I) {
    I === void 0 && (I = s.TEXTURE0 + X - 1), ue !== I && (s.activeTexture(I), ue = I);
  }
  function be(I, de, ie) {
    ie === void 0 && (ue === null ? ie = s.TEXTURE0 + X - 1 : ie = ue);
    let pe = le[ie];
    pe === void 0 && (pe = { type: void 0, texture: void 0 }, le[ie] = pe), (pe.type !== I || pe.texture !== de) && (ue !== ie && (s.activeTexture(ie), ue = ie), s.bindTexture(I, de || j[I]), pe.type = I, pe.texture = de);
  }
  function S() {
    const I = le[ue];
    I !== void 0 && I.type !== void 0 && (s.bindTexture(I.type, null), I.type = void 0, I.texture = void 0);
  }
  function _() {
    try {
      s.compressedTexImage2D(...arguments);
    } catch (I) {
      Ce("WebGLState:", I);
    }
  }
  function L() {
    try {
      s.compressedTexImage3D(...arguments);
    } catch (I) {
      Ce("WebGLState:", I);
    }
  }
  function W() {
    try {
      s.texSubImage2D(...arguments);
    } catch (I) {
      Ce("WebGLState:", I);
    }
  }
  function Z() {
    try {
      s.texSubImage3D(...arguments);
    } catch (I) {
      Ce("WebGLState:", I);
    }
  }
  function G() {
    try {
      s.compressedTexSubImage2D(...arguments);
    } catch (I) {
      Ce("WebGLState:", I);
    }
  }
  function Se() {
    try {
      s.compressedTexSubImage3D(...arguments);
    } catch (I) {
      Ce("WebGLState:", I);
    }
  }
  function se() {
    try {
      s.texStorage2D(...arguments);
    } catch (I) {
      Ce("WebGLState:", I);
    }
  }
  function ye() {
    try {
      s.texStorage3D(...arguments);
    } catch (I) {
      Ce("WebGLState:", I);
    }
  }
  function Pe() {
    try {
      s.texImage2D(...arguments);
    } catch (I) {
      Ce("WebGLState:", I);
    }
  }
  function te() {
    try {
      s.texImage3D(...arguments);
    } catch (I) {
      Ce("WebGLState:", I);
    }
  }
  function ae(I) {
    Ve.equals(I) === !1 && (s.scissor(I.x, I.y, I.z, I.w), Ve.copy(I));
  }
  function _e(I) {
    yt.equals(I) === !1 && (s.viewport(I.x, I.y, I.z, I.w), yt.copy(I));
  }
  function we(I, de) {
    let ie = c.get(de);
    ie === void 0 && (ie = /* @__PURE__ */ new WeakMap(), c.set(de, ie));
    let pe = ie.get(I);
    pe === void 0 && (pe = s.getUniformBlockIndex(de, I.name), ie.set(I, pe));
  }
  function re(I, de) {
    const pe = c.get(de).get(I);
    l.get(de) !== pe && (s.uniformBlockBinding(de, pe, I.__bindingPointIndex), l.set(de, pe));
  }
  function $e() {
    s.disable(s.BLEND), s.disable(s.CULL_FACE), s.disable(s.DEPTH_TEST), s.disable(s.POLYGON_OFFSET_FILL), s.disable(s.SCISSOR_TEST), s.disable(s.STENCIL_TEST), s.disable(s.SAMPLE_ALPHA_TO_COVERAGE), s.blendEquation(s.FUNC_ADD), s.blendFunc(s.ONE, s.ZERO), s.blendFuncSeparate(s.ONE, s.ZERO, s.ONE, s.ZERO), s.blendColor(0, 0, 0, 0), s.colorMask(!0, !0, !0, !0), s.clearColor(0, 0, 0, 0), s.depthMask(!0), s.depthFunc(s.LESS), a.setReversed(!1), s.clearDepth(1), s.stencilMask(4294967295), s.stencilFunc(s.ALWAYS, 0, 4294967295), s.stencilOp(s.KEEP, s.KEEP, s.KEEP), s.clearStencil(0), s.cullFace(s.BACK), s.frontFace(s.CCW), s.polygonOffset(0, 0), s.activeTexture(s.TEXTURE0), s.bindFramebuffer(s.FRAMEBUFFER, null), s.bindFramebuffer(s.DRAW_FRAMEBUFFER, null), s.bindFramebuffer(s.READ_FRAMEBUFFER, null), s.useProgram(null), s.lineWidth(1), s.scissor(0, 0, s.canvas.width, s.canvas.height), s.viewport(0, 0, s.canvas.width, s.canvas.height), h = {}, ue = null, le = {}, d = {}, u = /* @__PURE__ */ new WeakMap(), f = [], g = null, v = !1, m = null, p = null, w = null, M = null, T = null, E = null, A = null, R = new Ne(0, 0, 0), F = 0, y = !1, b = null, P = null, H = null, V = null, Y = null, Ve.set(0, 0, s.canvas.width, s.canvas.height), yt.set(0, 0, s.canvas.width, s.canvas.height), r.reset(), a.reset(), o.reset();
  }
  return {
    buffers: {
      color: r,
      depth: a,
      stencil: o
    },
    enable: Q,
    disable: ge,
    bindFramebuffer: Fe,
    drawBuffers: xe,
    useProgram: tt,
    setBlending: rt,
    setMaterial: dt,
    setFlipSided: He,
    setCullFace: Et,
    setLineWidth: C,
    setPolygonOffset: At,
    setScissorTest: nt,
    activeTexture: pt,
    bindTexture: be,
    unbindTexture: S,
    compressedTexImage2D: _,
    compressedTexImage3D: L,
    texImage2D: Pe,
    texImage3D: te,
    updateUBOMapping: we,
    uniformBlockBinding: re,
    texStorage2D: se,
    texStorage3D: ye,
    texSubImage2D: W,
    texSubImage3D: Z,
    compressedTexSubImage2D: G,
    compressedTexSubImage3D: Se,
    scissor: ae,
    viewport: _e,
    reset: $e
  };
}
function Vw(s, e, t, i, n, r, a) {
  const o = e.has("WEBGL_multisampled_render_to_texture") ? e.get("WEBGL_multisampled_render_to_texture") : null, l = typeof navigator > "u" ? !1 : /OculusBrowser/g.test(navigator.userAgent), c = new Ye(), h = /* @__PURE__ */ new WeakMap();
  let d;
  const u = /* @__PURE__ */ new WeakMap();
  let f = !1;
  try {
    f = typeof OffscreenCanvas < "u" && new OffscreenCanvas(1, 1).getContext("2d") !== null;
  } catch {
  }
  function g(S, _) {
    return f ? new OffscreenCanvas(S, _) : Rr("canvas");
  }
  function v(S, _, L) {
    let W = 1;
    const Z = be(S);
    if ((Z.width > L || Z.height > L) && (W = L / Math.max(Z.width, Z.height)), W < 1)
      if (typeof HTMLImageElement < "u" && S instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && S instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && S instanceof ImageBitmap || typeof VideoFrame < "u" && S instanceof VideoFrame) {
        const G = Math.floor(W * Z.width), Se = Math.floor(W * Z.height);
        d === void 0 && (d = g(G, Se));
        const se = _ ? g(G, Se) : d;
        return se.width = G, se.height = Se, se.getContext("2d").drawImage(S, 0, 0, G, Se), Te("WebGLRenderer: Texture has been resized from (" + Z.width + "x" + Z.height + ") to (" + G + "x" + Se + ")."), se;
      } else
        return "data" in S && Te("WebGLRenderer: Image in DataTexture is too big (" + Z.width + "x" + Z.height + ")."), S;
    return S;
  }
  function m(S) {
    return S.generateMipmaps;
  }
  function p(S) {
    s.generateMipmap(S);
  }
  function w(S) {
    return S.isWebGLCubeRenderTarget ? s.TEXTURE_CUBE_MAP : S.isWebGL3DRenderTarget ? s.TEXTURE_3D : S.isWebGLArrayRenderTarget || S.isCompressedArrayTexture ? s.TEXTURE_2D_ARRAY : s.TEXTURE_2D;
  }
  function M(S, _, L, W, Z = !1) {
    if (S !== null) {
      if (s[S] !== void 0) return s[S];
      Te("WebGLRenderer: Attempt to use non-existing WebGL internal format '" + S + "'");
    }
    let G = _;
    if (_ === s.RED && (L === s.FLOAT && (G = s.R32F), L === s.HALF_FLOAT && (G = s.R16F), L === s.UNSIGNED_BYTE && (G = s.R8)), _ === s.RED_INTEGER && (L === s.UNSIGNED_BYTE && (G = s.R8UI), L === s.UNSIGNED_SHORT && (G = s.R16UI), L === s.UNSIGNED_INT && (G = s.R32UI), L === s.BYTE && (G = s.R8I), L === s.SHORT && (G = s.R16I), L === s.INT && (G = s.R32I)), _ === s.RG && (L === s.FLOAT && (G = s.RG32F), L === s.HALF_FLOAT && (G = s.RG16F), L === s.UNSIGNED_BYTE && (G = s.RG8)), _ === s.RG_INTEGER && (L === s.UNSIGNED_BYTE && (G = s.RG8UI), L === s.UNSIGNED_SHORT && (G = s.RG16UI), L === s.UNSIGNED_INT && (G = s.RG32UI), L === s.BYTE && (G = s.RG8I), L === s.SHORT && (G = s.RG16I), L === s.INT && (G = s.RG32I)), _ === s.RGB_INTEGER && (L === s.UNSIGNED_BYTE && (G = s.RGB8UI), L === s.UNSIGNED_SHORT && (G = s.RGB16UI), L === s.UNSIGNED_INT && (G = s.RGB32UI), L === s.BYTE && (G = s.RGB8I), L === s.SHORT && (G = s.RGB16I), L === s.INT && (G = s.RGB32I)), _ === s.RGBA_INTEGER && (L === s.UNSIGNED_BYTE && (G = s.RGBA8UI), L === s.UNSIGNED_SHORT && (G = s.RGBA16UI), L === s.UNSIGNED_INT && (G = s.RGBA32UI), L === s.BYTE && (G = s.RGBA8I), L === s.SHORT && (G = s.RGBA16I), L === s.INT && (G = s.RGBA32I)), _ === s.RGB && (L === s.UNSIGNED_INT_5_9_9_9_REV && (G = s.RGB9_E5), L === s.UNSIGNED_INT_10F_11F_11F_REV && (G = s.R11F_G11F_B10F)), _ === s.RGBA) {
      const Se = Z ? Ga : Ke.getTransfer(W);
      L === s.FLOAT && (G = s.RGBA32F), L === s.HALF_FLOAT && (G = s.RGBA16F), L === s.UNSIGNED_BYTE && (G = Se === lt ? s.SRGB8_ALPHA8 : s.RGBA8), L === s.UNSIGNED_SHORT_4_4_4_4 && (G = s.RGBA4), L === s.UNSIGNED_SHORT_5_5_5_1 && (G = s.RGB5_A1);
    }
    return (G === s.R16F || G === s.R32F || G === s.RG16F || G === s.RG32F || G === s.RGBA16F || G === s.RGBA32F) && e.get("EXT_color_buffer_float"), G;
  }
  function T(S, _) {
    let L;
    return S ? _ === null || _ === Hi || _ === Tr ? L = s.DEPTH24_STENCIL8 : _ === pi ? L = s.DEPTH32F_STENCIL8 : _ === Mr && (L = s.DEPTH24_STENCIL8, Te("DepthTexture: 16 bit depth attachment is not supported with stencil. Using 24-bit attachment.")) : _ === null || _ === Hi || _ === Tr ? L = s.DEPTH_COMPONENT24 : _ === pi ? L = s.DEPTH_COMPONENT32F : _ === Mr && (L = s.DEPTH_COMPONENT16), L;
  }
  function E(S, _) {
    return m(S) === !0 || S.isFramebufferTexture && S.minFilter !== It && S.minFilter !== bt ? Math.log2(Math.max(_.width, _.height)) + 1 : S.mipmaps !== void 0 && S.mipmaps.length > 0 ? S.mipmaps.length : S.isCompressedTexture && Array.isArray(S.image) ? _.mipmaps.length : 1;
  }
  function A(S) {
    const _ = S.target;
    _.removeEventListener("dispose", A), F(_), _.isVideoTexture && h.delete(_);
  }
  function R(S) {
    const _ = S.target;
    _.removeEventListener("dispose", R), b(_);
  }
  function F(S) {
    const _ = i.get(S);
    if (_.__webglInit === void 0) return;
    const L = S.source, W = u.get(L);
    if (W) {
      const Z = W[_.__cacheKey];
      Z.usedTimes--, Z.usedTimes === 0 && y(S), Object.keys(W).length === 0 && u.delete(L);
    }
    i.remove(S);
  }
  function y(S) {
    const _ = i.get(S);
    s.deleteTexture(_.__webglTexture);
    const L = S.source, W = u.get(L);
    delete W[_.__cacheKey], a.memory.textures--;
  }
  function b(S) {
    const _ = i.get(S);
    if (S.depthTexture && (S.depthTexture.dispose(), i.remove(S.depthTexture)), S.isWebGLCubeRenderTarget)
      for (let W = 0; W < 6; W++) {
        if (Array.isArray(_.__webglFramebuffer[W]))
          for (let Z = 0; Z < _.__webglFramebuffer[W].length; Z++) s.deleteFramebuffer(_.__webglFramebuffer[W][Z]);
        else
          s.deleteFramebuffer(_.__webglFramebuffer[W]);
        _.__webglDepthbuffer && s.deleteRenderbuffer(_.__webglDepthbuffer[W]);
      }
    else {
      if (Array.isArray(_.__webglFramebuffer))
        for (let W = 0; W < _.__webglFramebuffer.length; W++) s.deleteFramebuffer(_.__webglFramebuffer[W]);
      else
        s.deleteFramebuffer(_.__webglFramebuffer);
      if (_.__webglDepthbuffer && s.deleteRenderbuffer(_.__webglDepthbuffer), _.__webglMultisampledFramebuffer && s.deleteFramebuffer(_.__webglMultisampledFramebuffer), _.__webglColorRenderbuffer)
        for (let W = 0; W < _.__webglColorRenderbuffer.length; W++)
          _.__webglColorRenderbuffer[W] && s.deleteRenderbuffer(_.__webglColorRenderbuffer[W]);
      _.__webglDepthRenderbuffer && s.deleteRenderbuffer(_.__webglDepthRenderbuffer);
    }
    const L = S.textures;
    for (let W = 0, Z = L.length; W < Z; W++) {
      const G = i.get(L[W]);
      G.__webglTexture && (s.deleteTexture(G.__webglTexture), a.memory.textures--), i.remove(L[W]);
    }
    i.remove(S);
  }
  let P = 0;
  function H() {
    P = 0;
  }
  function V() {
    const S = P;
    return S >= n.maxTextures && Te("WebGLTextures: Trying to use " + S + " texture units while this GPU supports only " + n.maxTextures), P += 1, S;
  }
  function Y(S) {
    const _ = [];
    return _.push(S.wrapS), _.push(S.wrapT), _.push(S.wrapR || 0), _.push(S.magFilter), _.push(S.minFilter), _.push(S.anisotropy), _.push(S.internalFormat), _.push(S.format), _.push(S.type), _.push(S.generateMipmaps), _.push(S.premultiplyAlpha), _.push(S.flipY), _.push(S.unpackAlignment), _.push(S.colorSpace), _.join();
  }
  function X(S, _) {
    const L = i.get(S);
    if (S.isVideoTexture && nt(S), S.isRenderTargetTexture === !1 && S.isExternalTexture !== !0 && S.version > 0 && L.__version !== S.version) {
      const W = S.image;
      if (W === null)
        Te("WebGLRenderer: Texture marked for update but no image data found.");
      else if (W.complete === !1)
        Te("WebGLRenderer: Texture marked for update but image is incomplete");
      else {
        j(L, S, _);
        return;
      }
    } else S.isExternalTexture && (L.__webglTexture = S.sourceTexture ? S.sourceTexture : null);
    t.bindTexture(s.TEXTURE_2D, L.__webglTexture, s.TEXTURE0 + _);
  }
  function q(S, _) {
    const L = i.get(S);
    if (S.isRenderTargetTexture === !1 && S.version > 0 && L.__version !== S.version) {
      j(L, S, _);
      return;
    } else S.isExternalTexture && (L.__webglTexture = S.sourceTexture ? S.sourceTexture : null);
    t.bindTexture(s.TEXTURE_2D_ARRAY, L.__webglTexture, s.TEXTURE0 + _);
  }
  function z(S, _) {
    const L = i.get(S);
    if (S.isRenderTargetTexture === !1 && S.version > 0 && L.__version !== S.version) {
      j(L, S, _);
      return;
    }
    t.bindTexture(s.TEXTURE_3D, L.__webglTexture, s.TEXTURE0 + _);
  }
  function J(S, _) {
    const L = i.get(S);
    if (S.isCubeDepthTexture !== !0 && S.version > 0 && L.__version !== S.version) {
      Q(L, S, _);
      return;
    }
    t.bindTexture(s.TEXTURE_CUBE_MAP, L.__webglTexture, s.TEXTURE0 + _);
  }
  const ue = {
    [Us]: s.REPEAT,
    [Fi]: s.CLAMP_TO_EDGE,
    [Ha]: s.MIRRORED_REPEAT
  }, le = {
    [It]: s.NEAREST,
    [Hu]: s.NEAREST_MIPMAP_NEAREST,
    [dr]: s.NEAREST_MIPMAP_LINEAR,
    [bt]: s.LINEAR,
    [Ma]: s.LINEAR_MIPMAP_NEAREST,
    [nn]: s.LINEAR_MIPMAP_LINEAR
  }, fe = {
    [gv]: s.NEVER,
    [bv]: s.ALWAYS,
    [vv]: s.LESS,
    [jc]: s.LEQUAL,
    [_v]: s.EQUAL,
    [Yc]: s.GEQUAL,
    [xv]: s.GREATER,
    [yv]: s.NOTEQUAL
  };
  function Ge(S, _) {
    if (_.type === pi && e.has("OES_texture_float_linear") === !1 && (_.magFilter === bt || _.magFilter === Ma || _.magFilter === dr || _.magFilter === nn || _.minFilter === bt || _.minFilter === Ma || _.minFilter === dr || _.minFilter === nn) && Te("WebGLRenderer: Unable to use linear filtering with floating point textures. OES_texture_float_linear not supported on this device."), s.texParameteri(S, s.TEXTURE_WRAP_S, ue[_.wrapS]), s.texParameteri(S, s.TEXTURE_WRAP_T, ue[_.wrapT]), (S === s.TEXTURE_3D || S === s.TEXTURE_2D_ARRAY) && s.texParameteri(S, s.TEXTURE_WRAP_R, ue[_.wrapR]), s.texParameteri(S, s.TEXTURE_MAG_FILTER, le[_.magFilter]), s.texParameteri(S, s.TEXTURE_MIN_FILTER, le[_.minFilter]), _.compareFunction && (s.texParameteri(S, s.TEXTURE_COMPARE_MODE, s.COMPARE_REF_TO_TEXTURE), s.texParameteri(S, s.TEXTURE_COMPARE_FUNC, fe[_.compareFunction])), e.has("EXT_texture_filter_anisotropic") === !0) {
      if (_.magFilter === It || _.minFilter !== dr && _.minFilter !== nn || _.type === pi && e.has("OES_texture_float_linear") === !1) return;
      if (_.anisotropy > 1 || i.get(_).__currentAnisotropy) {
        const L = e.get("EXT_texture_filter_anisotropic");
        s.texParameterf(S, L.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(_.anisotropy, n.getMaxAnisotropy())), i.get(_).__currentAnisotropy = _.anisotropy;
      }
    }
  }
  function Ve(S, _) {
    let L = !1;
    S.__webglInit === void 0 && (S.__webglInit = !0, _.addEventListener("dispose", A));
    const W = _.source;
    let Z = u.get(W);
    Z === void 0 && (Z = {}, u.set(W, Z));
    const G = Y(_);
    if (G !== S.__cacheKey) {
      Z[G] === void 0 && (Z[G] = {
        texture: s.createTexture(),
        usedTimes: 0
      }, a.memory.textures++, L = !0), Z[G].usedTimes++;
      const Se = Z[S.__cacheKey];
      Se !== void 0 && (Z[S.__cacheKey].usedTimes--, Se.usedTimes === 0 && y(_)), S.__cacheKey = G, S.__webglTexture = Z[G].texture;
    }
    return L;
  }
  function yt(S, _, L) {
    return Math.floor(Math.floor(S / L) / _);
  }
  function vt(S, _, L, W) {
    const G = S.updateRanges;
    if (G.length === 0)
      t.texSubImage2D(s.TEXTURE_2D, 0, 0, 0, _.width, _.height, L, W, _.data);
    else {
      G.sort((te, ae) => te.start - ae.start);
      let Se = 0;
      for (let te = 1; te < G.length; te++) {
        const ae = G[Se], _e = G[te], we = ae.start + ae.count, re = yt(_e.start, _.width, 4), $e = yt(ae.start, _.width, 4);
        _e.start <= we + 1 && re === $e && yt(_e.start + _e.count - 1, _.width, 4) === re ? ae.count = Math.max(
          ae.count,
          _e.start + _e.count - ae.start
        ) : (++Se, G[Se] = _e);
      }
      G.length = Se + 1;
      const se = s.getParameter(s.UNPACK_ROW_LENGTH), ye = s.getParameter(s.UNPACK_SKIP_PIXELS), Pe = s.getParameter(s.UNPACK_SKIP_ROWS);
      s.pixelStorei(s.UNPACK_ROW_LENGTH, _.width);
      for (let te = 0, ae = G.length; te < ae; te++) {
        const _e = G[te], we = Math.floor(_e.start / 4), re = Math.ceil(_e.count / 4), $e = we % _.width, I = Math.floor(we / _.width), de = re, ie = 1;
        s.pixelStorei(s.UNPACK_SKIP_PIXELS, $e), s.pixelStorei(s.UNPACK_SKIP_ROWS, I), t.texSubImage2D(s.TEXTURE_2D, 0, $e, I, de, ie, L, W, _.data);
      }
      S.clearUpdateRanges(), s.pixelStorei(s.UNPACK_ROW_LENGTH, se), s.pixelStorei(s.UNPACK_SKIP_PIXELS, ye), s.pixelStorei(s.UNPACK_SKIP_ROWS, Pe);
    }
  }
  function j(S, _, L) {
    let W = s.TEXTURE_2D;
    (_.isDataArrayTexture || _.isCompressedArrayTexture) && (W = s.TEXTURE_2D_ARRAY), _.isData3DTexture && (W = s.TEXTURE_3D);
    const Z = Ve(S, _), G = _.source;
    t.bindTexture(W, S.__webglTexture, s.TEXTURE0 + L);
    const Se = i.get(G);
    if (G.version !== Se.__version || Z === !0) {
      t.activeTexture(s.TEXTURE0 + L);
      const se = Ke.getPrimaries(Ke.workingColorSpace), ye = _.colorSpace === Sn ? null : Ke.getPrimaries(_.colorSpace), Pe = _.colorSpace === Sn || se === ye ? s.NONE : s.BROWSER_DEFAULT_WEBGL;
      s.pixelStorei(s.UNPACK_FLIP_Y_WEBGL, _.flipY), s.pixelStorei(s.UNPACK_PREMULTIPLY_ALPHA_WEBGL, _.premultiplyAlpha), s.pixelStorei(s.UNPACK_ALIGNMENT, _.unpackAlignment), s.pixelStorei(s.UNPACK_COLORSPACE_CONVERSION_WEBGL, Pe);
      let te = v(_.image, !1, n.maxTextureSize);
      te = pt(_, te);
      const ae = r.convert(_.format, _.colorSpace), _e = r.convert(_.type);
      let we = M(_.internalFormat, ae, _e, _.colorSpace, _.isVideoTexture);
      Ge(W, _);
      let re;
      const $e = _.mipmaps, I = _.isVideoTexture !== !0, de = Se.__version === void 0 || Z === !0, ie = G.dataReady, pe = E(_, te);
      if (_.isDepthTexture)
        we = T(_.format === Yn, _.type), de && (I ? t.texStorage2D(s.TEXTURE_2D, 1, we, te.width, te.height) : t.texImage2D(s.TEXTURE_2D, 0, we, te.width, te.height, 0, ae, _e, null));
      else if (_.isDataTexture)
        if ($e.length > 0) {
          I && de && t.texStorage2D(s.TEXTURE_2D, pe, we, $e[0].width, $e[0].height);
          for (let ee = 0, K = $e.length; ee < K; ee++)
            re = $e[ee], I ? ie && t.texSubImage2D(s.TEXTURE_2D, ee, 0, 0, re.width, re.height, ae, _e, re.data) : t.texImage2D(s.TEXTURE_2D, ee, we, re.width, re.height, 0, ae, _e, re.data);
          _.generateMipmaps = !1;
        } else
          I ? (de && t.texStorage2D(s.TEXTURE_2D, pe, we, te.width, te.height), ie && vt(_, te, ae, _e)) : t.texImage2D(s.TEXTURE_2D, 0, we, te.width, te.height, 0, ae, _e, te.data);
      else if (_.isCompressedTexture)
        if (_.isCompressedArrayTexture) {
          I && de && t.texStorage3D(s.TEXTURE_2D_ARRAY, pe, we, $e[0].width, $e[0].height, te.depth);
          for (let ee = 0, K = $e.length; ee < K; ee++)
            if (re = $e[ee], _.format !== mi)
              if (ae !== null)
                if (I) {
                  if (ie)
                    if (_.layerUpdates.size > 0) {
                      const ne = Ld(re.width, re.height, _.format, _.type);
                      for (const De of _.layerUpdates) {
                        const mt = re.data.subarray(
                          De * ne / re.data.BYTES_PER_ELEMENT,
                          (De + 1) * ne / re.data.BYTES_PER_ELEMENT
                        );
                        t.compressedTexSubImage3D(s.TEXTURE_2D_ARRAY, ee, 0, 0, De, re.width, re.height, 1, ae, mt);
                      }
                      _.clearLayerUpdates();
                    } else
                      t.compressedTexSubImage3D(s.TEXTURE_2D_ARRAY, ee, 0, 0, 0, re.width, re.height, te.depth, ae, re.data);
                } else
                  t.compressedTexImage3D(s.TEXTURE_2D_ARRAY, ee, we, re.width, re.height, te.depth, 0, re.data, 0, 0);
              else
                Te("WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()");
            else
              I ? ie && t.texSubImage3D(s.TEXTURE_2D_ARRAY, ee, 0, 0, 0, re.width, re.height, te.depth, ae, _e, re.data) : t.texImage3D(s.TEXTURE_2D_ARRAY, ee, we, re.width, re.height, te.depth, 0, ae, _e, re.data);
        } else {
          I && de && t.texStorage2D(s.TEXTURE_2D, pe, we, $e[0].width, $e[0].height);
          for (let ee = 0, K = $e.length; ee < K; ee++)
            re = $e[ee], _.format !== mi ? ae !== null ? I ? ie && t.compressedTexSubImage2D(s.TEXTURE_2D, ee, 0, 0, re.width, re.height, ae, re.data) : t.compressedTexImage2D(s.TEXTURE_2D, ee, we, re.width, re.height, 0, re.data) : Te("WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()") : I ? ie && t.texSubImage2D(s.TEXTURE_2D, ee, 0, 0, re.width, re.height, ae, _e, re.data) : t.texImage2D(s.TEXTURE_2D, ee, we, re.width, re.height, 0, ae, _e, re.data);
        }
      else if (_.isDataArrayTexture)
        if (I) {
          if (de && t.texStorage3D(s.TEXTURE_2D_ARRAY, pe, we, te.width, te.height, te.depth), ie)
            if (_.layerUpdates.size > 0) {
              const ee = Ld(te.width, te.height, _.format, _.type);
              for (const K of _.layerUpdates) {
                const ne = te.data.subarray(
                  K * ee / te.data.BYTES_PER_ELEMENT,
                  (K + 1) * ee / te.data.BYTES_PER_ELEMENT
                );
                t.texSubImage3D(s.TEXTURE_2D_ARRAY, 0, 0, 0, K, te.width, te.height, 1, ae, _e, ne);
              }
              _.clearLayerUpdates();
            } else
              t.texSubImage3D(s.TEXTURE_2D_ARRAY, 0, 0, 0, 0, te.width, te.height, te.depth, ae, _e, te.data);
        } else
          t.texImage3D(s.TEXTURE_2D_ARRAY, 0, we, te.width, te.height, te.depth, 0, ae, _e, te.data);
      else if (_.isData3DTexture)
        I ? (de && t.texStorage3D(s.TEXTURE_3D, pe, we, te.width, te.height, te.depth), ie && t.texSubImage3D(s.TEXTURE_3D, 0, 0, 0, 0, te.width, te.height, te.depth, ae, _e, te.data)) : t.texImage3D(s.TEXTURE_3D, 0, we, te.width, te.height, te.depth, 0, ae, _e, te.data);
      else if (_.isFramebufferTexture) {
        if (de)
          if (I)
            t.texStorage2D(s.TEXTURE_2D, pe, we, te.width, te.height);
          else {
            let ee = te.width, K = te.height;
            for (let ne = 0; ne < pe; ne++)
              t.texImage2D(s.TEXTURE_2D, ne, we, ee, K, 0, ae, _e, null), ee >>= 1, K >>= 1;
          }
      } else if ($e.length > 0) {
        if (I && de) {
          const ee = be($e[0]);
          t.texStorage2D(s.TEXTURE_2D, pe, we, ee.width, ee.height);
        }
        for (let ee = 0, K = $e.length; ee < K; ee++)
          re = $e[ee], I ? ie && t.texSubImage2D(s.TEXTURE_2D, ee, 0, 0, ae, _e, re) : t.texImage2D(s.TEXTURE_2D, ee, we, ae, _e, re);
        _.generateMipmaps = !1;
      } else if (I) {
        if (de) {
          const ee = be(te);
          t.texStorage2D(s.TEXTURE_2D, pe, we, ee.width, ee.height);
        }
        ie && t.texSubImage2D(s.TEXTURE_2D, 0, 0, 0, ae, _e, te);
      } else
        t.texImage2D(s.TEXTURE_2D, 0, we, ae, _e, te);
      m(_) && p(W), Se.__version = G.version, _.onUpdate && _.onUpdate(_);
    }
    S.__version = _.version;
  }
  function Q(S, _, L) {
    if (_.image.length !== 6) return;
    const W = Ve(S, _), Z = _.source;
    t.bindTexture(s.TEXTURE_CUBE_MAP, S.__webglTexture, s.TEXTURE0 + L);
    const G = i.get(Z);
    if (Z.version !== G.__version || W === !0) {
      t.activeTexture(s.TEXTURE0 + L);
      const Se = Ke.getPrimaries(Ke.workingColorSpace), se = _.colorSpace === Sn ? null : Ke.getPrimaries(_.colorSpace), ye = _.colorSpace === Sn || Se === se ? s.NONE : s.BROWSER_DEFAULT_WEBGL;
      s.pixelStorei(s.UNPACK_FLIP_Y_WEBGL, _.flipY), s.pixelStorei(s.UNPACK_PREMULTIPLY_ALPHA_WEBGL, _.premultiplyAlpha), s.pixelStorei(s.UNPACK_ALIGNMENT, _.unpackAlignment), s.pixelStorei(s.UNPACK_COLORSPACE_CONVERSION_WEBGL, ye);
      const Pe = _.isCompressedTexture || _.image[0].isCompressedTexture, te = _.image[0] && _.image[0].isDataTexture, ae = [];
      for (let K = 0; K < 6; K++)
        !Pe && !te ? ae[K] = v(_.image[K], !0, n.maxCubemapSize) : ae[K] = te ? _.image[K].image : _.image[K], ae[K] = pt(_, ae[K]);
      const _e = ae[0], we = r.convert(_.format, _.colorSpace), re = r.convert(_.type), $e = M(_.internalFormat, we, re, _.colorSpace), I = _.isVideoTexture !== !0, de = G.__version === void 0 || W === !0, ie = Z.dataReady;
      let pe = E(_, _e);
      Ge(s.TEXTURE_CUBE_MAP, _);
      let ee;
      if (Pe) {
        I && de && t.texStorage2D(s.TEXTURE_CUBE_MAP, pe, $e, _e.width, _e.height);
        for (let K = 0; K < 6; K++) {
          ee = ae[K].mipmaps;
          for (let ne = 0; ne < ee.length; ne++) {
            const De = ee[ne];
            _.format !== mi ? we !== null ? I ? ie && t.compressedTexSubImage2D(s.TEXTURE_CUBE_MAP_POSITIVE_X + K, ne, 0, 0, De.width, De.height, we, De.data) : t.compressedTexImage2D(s.TEXTURE_CUBE_MAP_POSITIVE_X + K, ne, $e, De.width, De.height, 0, De.data) : Te("WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()") : I ? ie && t.texSubImage2D(s.TEXTURE_CUBE_MAP_POSITIVE_X + K, ne, 0, 0, De.width, De.height, we, re, De.data) : t.texImage2D(s.TEXTURE_CUBE_MAP_POSITIVE_X + K, ne, $e, De.width, De.height, 0, we, re, De.data);
          }
        }
      } else {
        if (ee = _.mipmaps, I && de) {
          ee.length > 0 && pe++;
          const K = be(ae[0]);
          t.texStorage2D(s.TEXTURE_CUBE_MAP, pe, $e, K.width, K.height);
        }
        for (let K = 0; K < 6; K++)
          if (te) {
            I ? ie && t.texSubImage2D(s.TEXTURE_CUBE_MAP_POSITIVE_X + K, 0, 0, 0, ae[K].width, ae[K].height, we, re, ae[K].data) : t.texImage2D(s.TEXTURE_CUBE_MAP_POSITIVE_X + K, 0, $e, ae[K].width, ae[K].height, 0, we, re, ae[K].data);
            for (let ne = 0; ne < ee.length; ne++) {
              const mt = ee[ne].image[K].image;
              I ? ie && t.texSubImage2D(s.TEXTURE_CUBE_MAP_POSITIVE_X + K, ne + 1, 0, 0, mt.width, mt.height, we, re, mt.data) : t.texImage2D(s.TEXTURE_CUBE_MAP_POSITIVE_X + K, ne + 1, $e, mt.width, mt.height, 0, we, re, mt.data);
            }
          } else {
            I ? ie && t.texSubImage2D(s.TEXTURE_CUBE_MAP_POSITIVE_X + K, 0, 0, 0, we, re, ae[K]) : t.texImage2D(s.TEXTURE_CUBE_MAP_POSITIVE_X + K, 0, $e, we, re, ae[K]);
            for (let ne = 0; ne < ee.length; ne++) {
              const De = ee[ne];
              I ? ie && t.texSubImage2D(s.TEXTURE_CUBE_MAP_POSITIVE_X + K, ne + 1, 0, 0, we, re, De.image[K]) : t.texImage2D(s.TEXTURE_CUBE_MAP_POSITIVE_X + K, ne + 1, $e, we, re, De.image[K]);
            }
          }
      }
      m(_) && p(s.TEXTURE_CUBE_MAP), G.__version = Z.version, _.onUpdate && _.onUpdate(_);
    }
    S.__version = _.version;
  }
  function ge(S, _, L, W, Z, G) {
    const Se = r.convert(L.format, L.colorSpace), se = r.convert(L.type), ye = M(L.internalFormat, Se, se, L.colorSpace), Pe = i.get(_), te = i.get(L);
    if (te.__renderTarget = _, !Pe.__hasExternalTextures) {
      const ae = Math.max(1, _.width >> G), _e = Math.max(1, _.height >> G);
      Z === s.TEXTURE_3D || Z === s.TEXTURE_2D_ARRAY ? t.texImage3D(Z, G, ye, ae, _e, _.depth, 0, Se, se, null) : t.texImage2D(Z, G, ye, ae, _e, 0, Se, se, null);
    }
    t.bindFramebuffer(s.FRAMEBUFFER, S), At(_) ? o.framebufferTexture2DMultisampleEXT(s.FRAMEBUFFER, W, Z, te.__webglTexture, 0, C(_)) : (Z === s.TEXTURE_2D || Z >= s.TEXTURE_CUBE_MAP_POSITIVE_X && Z <= s.TEXTURE_CUBE_MAP_NEGATIVE_Z) && s.framebufferTexture2D(s.FRAMEBUFFER, W, Z, te.__webglTexture, G), t.bindFramebuffer(s.FRAMEBUFFER, null);
  }
  function Fe(S, _, L) {
    if (s.bindRenderbuffer(s.RENDERBUFFER, S), _.depthBuffer) {
      const W = _.depthTexture, Z = W && W.isDepthTexture ? W.type : null, G = T(_.stencilBuffer, Z), Se = _.stencilBuffer ? s.DEPTH_STENCIL_ATTACHMENT : s.DEPTH_ATTACHMENT;
      At(_) ? o.renderbufferStorageMultisampleEXT(s.RENDERBUFFER, C(_), G, _.width, _.height) : L ? s.renderbufferStorageMultisample(s.RENDERBUFFER, C(_), G, _.width, _.height) : s.renderbufferStorage(s.RENDERBUFFER, G, _.width, _.height), s.framebufferRenderbuffer(s.FRAMEBUFFER, Se, s.RENDERBUFFER, S);
    } else {
      const W = _.textures;
      for (let Z = 0; Z < W.length; Z++) {
        const G = W[Z], Se = r.convert(G.format, G.colorSpace), se = r.convert(G.type), ye = M(G.internalFormat, Se, se, G.colorSpace);
        At(_) ? o.renderbufferStorageMultisampleEXT(s.RENDERBUFFER, C(_), ye, _.width, _.height) : L ? s.renderbufferStorageMultisample(s.RENDERBUFFER, C(_), ye, _.width, _.height) : s.renderbufferStorage(s.RENDERBUFFER, ye, _.width, _.height);
      }
    }
    s.bindRenderbuffer(s.RENDERBUFFER, null);
  }
  function xe(S, _, L) {
    const W = _.isWebGLCubeRenderTarget === !0;
    if (t.bindFramebuffer(s.FRAMEBUFFER, S), !(_.depthTexture && _.depthTexture.isDepthTexture))
      throw new Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture");
    const Z = i.get(_.depthTexture);
    if (Z.__renderTarget = _, (!Z.__webglTexture || _.depthTexture.image.width !== _.width || _.depthTexture.image.height !== _.height) && (_.depthTexture.image.width = _.width, _.depthTexture.image.height = _.height, _.depthTexture.needsUpdate = !0), W) {
      if (Z.__webglInit === void 0 && (Z.__webglInit = !0, _.depthTexture.addEventListener("dispose", A)), Z.__webglTexture === void 0) {
        Z.__webglTexture = s.createTexture(), t.bindTexture(s.TEXTURE_CUBE_MAP, Z.__webglTexture), Ge(s.TEXTURE_CUBE_MAP, _.depthTexture);
        const Pe = r.convert(_.depthTexture.format), te = r.convert(_.depthTexture.type);
        let ae;
        _.depthTexture.format === dn ? ae = s.DEPTH_COMPONENT24 : _.depthTexture.format === Yn && (ae = s.DEPTH24_STENCIL8);
        for (let _e = 0; _e < 6; _e++)
          s.texImage2D(s.TEXTURE_CUBE_MAP_POSITIVE_X + _e, 0, ae, _.width, _.height, 0, Pe, te, null);
      }
    } else
      X(_.depthTexture, 0);
    const G = Z.__webglTexture, Se = C(_), se = W ? s.TEXTURE_CUBE_MAP_POSITIVE_X + L : s.TEXTURE_2D, ye = _.depthTexture.format === Yn ? s.DEPTH_STENCIL_ATTACHMENT : s.DEPTH_ATTACHMENT;
    if (_.depthTexture.format === dn)
      At(_) ? o.framebufferTexture2DMultisampleEXT(s.FRAMEBUFFER, ye, se, G, 0, Se) : s.framebufferTexture2D(s.FRAMEBUFFER, ye, se, G, 0);
    else if (_.depthTexture.format === Yn)
      At(_) ? o.framebufferTexture2DMultisampleEXT(s.FRAMEBUFFER, ye, se, G, 0, Se) : s.framebufferTexture2D(s.FRAMEBUFFER, ye, se, G, 0);
    else
      throw new Error("Unknown depthTexture format");
  }
  function tt(S) {
    const _ = i.get(S), L = S.isWebGLCubeRenderTarget === !0;
    if (_.__boundDepthTexture !== S.depthTexture) {
      const W = S.depthTexture;
      if (_.__depthDisposeCallback && _.__depthDisposeCallback(), W) {
        const Z = () => {
          delete _.__boundDepthTexture, delete _.__depthDisposeCallback, W.removeEventListener("dispose", Z);
        };
        W.addEventListener("dispose", Z), _.__depthDisposeCallback = Z;
      }
      _.__boundDepthTexture = W;
    }
    if (S.depthTexture && !_.__autoAllocateDepthBuffer)
      if (L)
        for (let W = 0; W < 6; W++)
          xe(_.__webglFramebuffer[W], S, W);
      else {
        const W = S.texture.mipmaps;
        W && W.length > 0 ? xe(_.__webglFramebuffer[0], S, 0) : xe(_.__webglFramebuffer, S, 0);
      }
    else if (L) {
      _.__webglDepthbuffer = [];
      for (let W = 0; W < 6; W++)
        if (t.bindFramebuffer(s.FRAMEBUFFER, _.__webglFramebuffer[W]), _.__webglDepthbuffer[W] === void 0)
          _.__webglDepthbuffer[W] = s.createRenderbuffer(), Fe(_.__webglDepthbuffer[W], S, !1);
        else {
          const Z = S.stencilBuffer ? s.DEPTH_STENCIL_ATTACHMENT : s.DEPTH_ATTACHMENT, G = _.__webglDepthbuffer[W];
          s.bindRenderbuffer(s.RENDERBUFFER, G), s.framebufferRenderbuffer(s.FRAMEBUFFER, Z, s.RENDERBUFFER, G);
        }
    } else {
      const W = S.texture.mipmaps;
      if (W && W.length > 0 ? t.bindFramebuffer(s.FRAMEBUFFER, _.__webglFramebuffer[0]) : t.bindFramebuffer(s.FRAMEBUFFER, _.__webglFramebuffer), _.__webglDepthbuffer === void 0)
        _.__webglDepthbuffer = s.createRenderbuffer(), Fe(_.__webglDepthbuffer, S, !1);
      else {
        const Z = S.stencilBuffer ? s.DEPTH_STENCIL_ATTACHMENT : s.DEPTH_ATTACHMENT, G = _.__webglDepthbuffer;
        s.bindRenderbuffer(s.RENDERBUFFER, G), s.framebufferRenderbuffer(s.FRAMEBUFFER, Z, s.RENDERBUFFER, G);
      }
    }
    t.bindFramebuffer(s.FRAMEBUFFER, null);
  }
  function Dt(S, _, L) {
    const W = i.get(S);
    _ !== void 0 && ge(W.__webglFramebuffer, S, S.texture, s.COLOR_ATTACHMENT0, s.TEXTURE_2D, 0), L !== void 0 && tt(S);
  }
  function et(S) {
    const _ = S.texture, L = i.get(S), W = i.get(_);
    S.addEventListener("dispose", R);
    const Z = S.textures, G = S.isWebGLCubeRenderTarget === !0, Se = Z.length > 1;
    if (Se || (W.__webglTexture === void 0 && (W.__webglTexture = s.createTexture()), W.__version = _.version, a.memory.textures++), G) {
      L.__webglFramebuffer = [];
      for (let se = 0; se < 6; se++)
        if (_.mipmaps && _.mipmaps.length > 0) {
          L.__webglFramebuffer[se] = [];
          for (let ye = 0; ye < _.mipmaps.length; ye++)
            L.__webglFramebuffer[se][ye] = s.createFramebuffer();
        } else
          L.__webglFramebuffer[se] = s.createFramebuffer();
    } else {
      if (_.mipmaps && _.mipmaps.length > 0) {
        L.__webglFramebuffer = [];
        for (let se = 0; se < _.mipmaps.length; se++)
          L.__webglFramebuffer[se] = s.createFramebuffer();
      } else
        L.__webglFramebuffer = s.createFramebuffer();
      if (Se)
        for (let se = 0, ye = Z.length; se < ye; se++) {
          const Pe = i.get(Z[se]);
          Pe.__webglTexture === void 0 && (Pe.__webglTexture = s.createTexture(), a.memory.textures++);
        }
      if (S.samples > 0 && At(S) === !1) {
        L.__webglMultisampledFramebuffer = s.createFramebuffer(), L.__webglColorRenderbuffer = [], t.bindFramebuffer(s.FRAMEBUFFER, L.__webglMultisampledFramebuffer);
        for (let se = 0; se < Z.length; se++) {
          const ye = Z[se];
          L.__webglColorRenderbuffer[se] = s.createRenderbuffer(), s.bindRenderbuffer(s.RENDERBUFFER, L.__webglColorRenderbuffer[se]);
          const Pe = r.convert(ye.format, ye.colorSpace), te = r.convert(ye.type), ae = M(ye.internalFormat, Pe, te, ye.colorSpace, S.isXRRenderTarget === !0), _e = C(S);
          s.renderbufferStorageMultisample(s.RENDERBUFFER, _e, ae, S.width, S.height), s.framebufferRenderbuffer(s.FRAMEBUFFER, s.COLOR_ATTACHMENT0 + se, s.RENDERBUFFER, L.__webglColorRenderbuffer[se]);
        }
        s.bindRenderbuffer(s.RENDERBUFFER, null), S.depthBuffer && (L.__webglDepthRenderbuffer = s.createRenderbuffer(), Fe(L.__webglDepthRenderbuffer, S, !0)), t.bindFramebuffer(s.FRAMEBUFFER, null);
      }
    }
    if (G) {
      t.bindTexture(s.TEXTURE_CUBE_MAP, W.__webglTexture), Ge(s.TEXTURE_CUBE_MAP, _);
      for (let se = 0; se < 6; se++)
        if (_.mipmaps && _.mipmaps.length > 0)
          for (let ye = 0; ye < _.mipmaps.length; ye++)
            ge(L.__webglFramebuffer[se][ye], S, _, s.COLOR_ATTACHMENT0, s.TEXTURE_CUBE_MAP_POSITIVE_X + se, ye);
        else
          ge(L.__webglFramebuffer[se], S, _, s.COLOR_ATTACHMENT0, s.TEXTURE_CUBE_MAP_POSITIVE_X + se, 0);
      m(_) && p(s.TEXTURE_CUBE_MAP), t.unbindTexture();
    } else if (Se) {
      for (let se = 0, ye = Z.length; se < ye; se++) {
        const Pe = Z[se], te = i.get(Pe);
        let ae = s.TEXTURE_2D;
        (S.isWebGL3DRenderTarget || S.isWebGLArrayRenderTarget) && (ae = S.isWebGL3DRenderTarget ? s.TEXTURE_3D : s.TEXTURE_2D_ARRAY), t.bindTexture(ae, te.__webglTexture), Ge(ae, Pe), ge(L.__webglFramebuffer, S, Pe, s.COLOR_ATTACHMENT0 + se, ae, 0), m(Pe) && p(ae);
      }
      t.unbindTexture();
    } else {
      let se = s.TEXTURE_2D;
      if ((S.isWebGL3DRenderTarget || S.isWebGLArrayRenderTarget) && (se = S.isWebGL3DRenderTarget ? s.TEXTURE_3D : s.TEXTURE_2D_ARRAY), t.bindTexture(se, W.__webglTexture), Ge(se, _), _.mipmaps && _.mipmaps.length > 0)
        for (let ye = 0; ye < _.mipmaps.length; ye++)
          ge(L.__webglFramebuffer[ye], S, _, s.COLOR_ATTACHMENT0, se, ye);
      else
        ge(L.__webglFramebuffer, S, _, s.COLOR_ATTACHMENT0, se, 0);
      m(_) && p(se), t.unbindTexture();
    }
    S.depthBuffer && tt(S);
  }
  function rt(S) {
    const _ = S.textures;
    for (let L = 0, W = _.length; L < W; L++) {
      const Z = _[L];
      if (m(Z)) {
        const G = w(S), Se = i.get(Z).__webglTexture;
        t.bindTexture(G, Se), p(G), t.unbindTexture();
      }
    }
  }
  const dt = [], He = [];
  function Et(S) {
    if (S.samples > 0) {
      if (At(S) === !1) {
        const _ = S.textures, L = S.width, W = S.height;
        let Z = s.COLOR_BUFFER_BIT;
        const G = S.stencilBuffer ? s.DEPTH_STENCIL_ATTACHMENT : s.DEPTH_ATTACHMENT, Se = i.get(S), se = _.length > 1;
        if (se)
          for (let Pe = 0; Pe < _.length; Pe++)
            t.bindFramebuffer(s.FRAMEBUFFER, Se.__webglMultisampledFramebuffer), s.framebufferRenderbuffer(s.FRAMEBUFFER, s.COLOR_ATTACHMENT0 + Pe, s.RENDERBUFFER, null), t.bindFramebuffer(s.FRAMEBUFFER, Se.__webglFramebuffer), s.framebufferTexture2D(s.DRAW_FRAMEBUFFER, s.COLOR_ATTACHMENT0 + Pe, s.TEXTURE_2D, null, 0);
        t.bindFramebuffer(s.READ_FRAMEBUFFER, Se.__webglMultisampledFramebuffer);
        const ye = S.texture.mipmaps;
        ye && ye.length > 0 ? t.bindFramebuffer(s.DRAW_FRAMEBUFFER, Se.__webglFramebuffer[0]) : t.bindFramebuffer(s.DRAW_FRAMEBUFFER, Se.__webglFramebuffer);
        for (let Pe = 0; Pe < _.length; Pe++) {
          if (S.resolveDepthBuffer && (S.depthBuffer && (Z |= s.DEPTH_BUFFER_BIT), S.stencilBuffer && S.resolveStencilBuffer && (Z |= s.STENCIL_BUFFER_BIT)), se) {
            s.framebufferRenderbuffer(s.READ_FRAMEBUFFER, s.COLOR_ATTACHMENT0, s.RENDERBUFFER, Se.__webglColorRenderbuffer[Pe]);
            const te = i.get(_[Pe]).__webglTexture;
            s.framebufferTexture2D(s.DRAW_FRAMEBUFFER, s.COLOR_ATTACHMENT0, s.TEXTURE_2D, te, 0);
          }
          s.blitFramebuffer(0, 0, L, W, 0, 0, L, W, Z, s.NEAREST), l === !0 && (dt.length = 0, He.length = 0, dt.push(s.COLOR_ATTACHMENT0 + Pe), S.depthBuffer && S.resolveDepthBuffer === !1 && (dt.push(G), He.push(G), s.invalidateFramebuffer(s.DRAW_FRAMEBUFFER, He)), s.invalidateFramebuffer(s.READ_FRAMEBUFFER, dt));
        }
        if (t.bindFramebuffer(s.READ_FRAMEBUFFER, null), t.bindFramebuffer(s.DRAW_FRAMEBUFFER, null), se)
          for (let Pe = 0; Pe < _.length; Pe++) {
            t.bindFramebuffer(s.FRAMEBUFFER, Se.__webglMultisampledFramebuffer), s.framebufferRenderbuffer(s.FRAMEBUFFER, s.COLOR_ATTACHMENT0 + Pe, s.RENDERBUFFER, Se.__webglColorRenderbuffer[Pe]);
            const te = i.get(_[Pe]).__webglTexture;
            t.bindFramebuffer(s.FRAMEBUFFER, Se.__webglFramebuffer), s.framebufferTexture2D(s.DRAW_FRAMEBUFFER, s.COLOR_ATTACHMENT0 + Pe, s.TEXTURE_2D, te, 0);
          }
        t.bindFramebuffer(s.DRAW_FRAMEBUFFER, Se.__webglMultisampledFramebuffer);
      } else if (S.depthBuffer && S.resolveDepthBuffer === !1 && l) {
        const _ = S.stencilBuffer ? s.DEPTH_STENCIL_ATTACHMENT : s.DEPTH_ATTACHMENT;
        s.invalidateFramebuffer(s.DRAW_FRAMEBUFFER, [_]);
      }
    }
  }
  function C(S) {
    return Math.min(n.maxSamples, S.samples);
  }
  function At(S) {
    const _ = i.get(S);
    return S.samples > 0 && e.has("WEBGL_multisampled_render_to_texture") === !0 && _.__useRenderToTexture !== !1;
  }
  function nt(S) {
    const _ = a.render.frame;
    h.get(S) !== _ && (h.set(S, _), S.update());
  }
  function pt(S, _) {
    const L = S.colorSpace, W = S.format, Z = S.type;
    return S.isCompressedTexture === !0 || S.isVideoTexture === !0 || L !== Wt && L !== Sn && (Ke.getTransfer(L) === lt ? (W !== mi || Z !== ii) && Te("WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.") : Ce("WebGLTextures: Unsupported texture color space:", L)), _;
  }
  function be(S) {
    return typeof HTMLImageElement < "u" && S instanceof HTMLImageElement ? (c.width = S.naturalWidth || S.width, c.height = S.naturalHeight || S.height) : typeof VideoFrame < "u" && S instanceof VideoFrame ? (c.width = S.displayWidth, c.height = S.displayHeight) : (c.width = S.width, c.height = S.height), c;
  }
  this.allocateTextureUnit = V, this.resetTextureUnits = H, this.setTexture2D = X, this.setTexture2DArray = q, this.setTexture3D = z, this.setTextureCube = J, this.rebindTextures = Dt, this.setupRenderTarget = et, this.updateRenderTargetMipmap = rt, this.updateMultisampleRenderTarget = Et, this.setupDepthRenderbuffer = tt, this.setupFrameBufferTexture = ge, this.useMultisampledRTT = At, this.isReversedDepthBuffer = function() {
    return t.buffers.depth.getReversed();
  };
}
function Hw(s, e) {
  function t(i, n = Sn) {
    let r;
    const a = Ke.getTransfer(n);
    if (i === ii) return s.UNSIGNED_BYTE;
    if (i === Vc) return s.UNSIGNED_SHORT_4_4_4_4;
    if (i === Hc) return s.UNSIGNED_SHORT_5_5_5_1;
    if (i === qu) return s.UNSIGNED_INT_5_9_9_9_REV;
    if (i === Wu) return s.UNSIGNED_INT_10F_11F_11F_REV;
    if (i === $u) return s.BYTE;
    if (i === Gu) return s.SHORT;
    if (i === Mr) return s.UNSIGNED_SHORT;
    if (i === zc) return s.INT;
    if (i === Hi) return s.UNSIGNED_INT;
    if (i === pi) return s.FLOAT;
    if (i === Ai) return s.HALF_FLOAT;
    if (i === Xu) return s.ALPHA;
    if (i === ju) return s.RGB;
    if (i === mi) return s.RGBA;
    if (i === dn) return s.DEPTH_COMPONENT;
    if (i === Yn) return s.DEPTH_STENCIL;
    if (i === $c) return s.RED;
    if (i === Gc) return s.RED_INTEGER;
    if (i === Fs) return s.RG;
    if (i === qc) return s.RG_INTEGER;
    if (i === Wc) return s.RGBA_INTEGER;
    if (i === Ta || i === Ea || i === Aa || i === Ra)
      if (a === lt)
        if (r = e.get("WEBGL_compressed_texture_s3tc_srgb"), r !== null) {
          if (i === Ta) return r.COMPRESSED_SRGB_S3TC_DXT1_EXT;
          if (i === Ea) return r.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
          if (i === Aa) return r.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
          if (i === Ra) return r.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
        } else
          return null;
      else if (r = e.get("WEBGL_compressed_texture_s3tc"), r !== null) {
        if (i === Ta) return r.COMPRESSED_RGB_S3TC_DXT1_EXT;
        if (i === Ea) return r.COMPRESSED_RGBA_S3TC_DXT1_EXT;
        if (i === Aa) return r.COMPRESSED_RGBA_S3TC_DXT3_EXT;
        if (i === Ra) return r.COMPRESSED_RGBA_S3TC_DXT5_EXT;
      } else
        return null;
    if (i === Cl || i === Il || i === Pl || i === Ll)
      if (r = e.get("WEBGL_compressed_texture_pvrtc"), r !== null) {
        if (i === Cl) return r.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
        if (i === Il) return r.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
        if (i === Pl) return r.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
        if (i === Ll) return r.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
      } else
        return null;
    if (i === Dl || i === Nl || i === Ol || i === Ul || i === Fl || i === Bl || i === kl)
      if (r = e.get("WEBGL_compressed_texture_etc"), r !== null) {
        if (i === Dl || i === Nl) return a === lt ? r.COMPRESSED_SRGB8_ETC2 : r.COMPRESSED_RGB8_ETC2;
        if (i === Ol) return a === lt ? r.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : r.COMPRESSED_RGBA8_ETC2_EAC;
        if (i === Ul) return r.COMPRESSED_R11_EAC;
        if (i === Fl) return r.COMPRESSED_SIGNED_R11_EAC;
        if (i === Bl) return r.COMPRESSED_RG11_EAC;
        if (i === kl) return r.COMPRESSED_SIGNED_RG11_EAC;
      } else
        return null;
    if (i === zl || i === Vl || i === Hl || i === $l || i === Gl || i === ql || i === Wl || i === Xl || i === jl || i === Yl || i === Kl || i === Zl || i === Jl || i === Ql)
      if (r = e.get("WEBGL_compressed_texture_astc"), r !== null) {
        if (i === zl) return a === lt ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : r.COMPRESSED_RGBA_ASTC_4x4_KHR;
        if (i === Vl) return a === lt ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : r.COMPRESSED_RGBA_ASTC_5x4_KHR;
        if (i === Hl) return a === lt ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : r.COMPRESSED_RGBA_ASTC_5x5_KHR;
        if (i === $l) return a === lt ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : r.COMPRESSED_RGBA_ASTC_6x5_KHR;
        if (i === Gl) return a === lt ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : r.COMPRESSED_RGBA_ASTC_6x6_KHR;
        if (i === ql) return a === lt ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : r.COMPRESSED_RGBA_ASTC_8x5_KHR;
        if (i === Wl) return a === lt ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : r.COMPRESSED_RGBA_ASTC_8x6_KHR;
        if (i === Xl) return a === lt ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : r.COMPRESSED_RGBA_ASTC_8x8_KHR;
        if (i === jl) return a === lt ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : r.COMPRESSED_RGBA_ASTC_10x5_KHR;
        if (i === Yl) return a === lt ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : r.COMPRESSED_RGBA_ASTC_10x6_KHR;
        if (i === Kl) return a === lt ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : r.COMPRESSED_RGBA_ASTC_10x8_KHR;
        if (i === Zl) return a === lt ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : r.COMPRESSED_RGBA_ASTC_10x10_KHR;
        if (i === Jl) return a === lt ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : r.COMPRESSED_RGBA_ASTC_12x10_KHR;
        if (i === Ql) return a === lt ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : r.COMPRESSED_RGBA_ASTC_12x12_KHR;
      } else
        return null;
    if (i === ec || i === tc || i === ic)
      if (r = e.get("EXT_texture_compression_bptc"), r !== null) {
        if (i === ec) return a === lt ? r.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : r.COMPRESSED_RGBA_BPTC_UNORM_EXT;
        if (i === tc) return r.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT;
        if (i === ic) return r.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT;
      } else
        return null;
    if (i === nc || i === sc || i === rc || i === ac)
      if (r = e.get("EXT_texture_compression_rgtc"), r !== null) {
        if (i === nc) return r.COMPRESSED_RED_RGTC1_EXT;
        if (i === sc) return r.COMPRESSED_SIGNED_RED_RGTC1_EXT;
        if (i === rc) return r.COMPRESSED_RED_GREEN_RGTC2_EXT;
        if (i === ac) return r.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
      } else
        return null;
    return i === Tr ? s.UNSIGNED_INT_24_8 : s[i] !== void 0 ? s[i] : null;
  }
  return { convert: t };
}
const $w = `
void main() {

	gl_Position = vec4( position, 1.0 );

}`, Gw = `
uniform sampler2DArray depthColor;
uniform float depthWidth;
uniform float depthHeight;

void main() {

	vec2 coord = vec2( gl_FragCoord.x / depthWidth, gl_FragCoord.y / depthHeight );

	if ( coord.x >= 1.0 ) {

		gl_FragDepth = texture( depthColor, vec3( coord.x - 1.0, coord.y, 1 ) ).r;

	} else {

		gl_FragDepth = texture( depthColor, vec3( coord.x, coord.y, 0 ) ).r;

	}

}`;
class qw {
  /**
   * Constructs a new depth sensing module.
   */
  constructor() {
    this.texture = null, this.mesh = null, this.depthNear = 0, this.depthFar = 0;
  }
  /**
   * Inits the depth sensing module
   *
   * @param {XRWebGLDepthInformation} depthData - The XR depth data.
   * @param {XRRenderState} renderState - The XR render state.
   */
  init(e, t) {
    if (this.texture === null) {
      const i = new df(e.texture);
      (e.depthNear !== t.depthNear || e.depthFar !== t.depthFar) && (this.depthNear = e.depthNear, this.depthFar = e.depthFar), this.texture = i;
    }
  }
  /**
   * Returns a plane mesh that visualizes the depth texture.
   *
   * @param {ArrayCamera} cameraXR - The XR camera.
   * @return {?Mesh} The plane mesh.
   */
  getMesh(e) {
    if (this.texture !== null && this.mesh === null) {
      const t = e.cameras[0].viewport, i = new oi({
        vertexShader: $w,
        fragmentShader: Gw,
        uniforms: {
          depthColor: { value: this.texture },
          depthWidth: { value: t.z },
          depthHeight: { value: t.w }
        }
      });
      this.mesh = new zt(new Br(20, 20), i);
    }
    return this.mesh;
  }
  /**
   * Resets the module
   */
  reset() {
    this.texture = null, this.mesh = null;
  }
  /**
   * Returns a texture representing the depth of the user's environment.
   *
   * @return {?ExternalTexture} The depth texture.
   */
  getDepthTexture() {
    return this.texture;
  }
}
class Ww extends ss {
  /**
   * Constructs a new WebGL renderer.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGL2RenderingContext} gl - The rendering context.
   */
  constructor(e, t) {
    super();
    const i = this;
    let n = null, r = 1, a = null, o = "local-floor", l = 1, c = null, h = null, d = null, u = null, f = null, g = null;
    const v = typeof XRWebGLBinding < "u", m = new qw(), p = {}, w = t.getContextAttributes();
    let M = null, T = null;
    const E = [], A = [], R = new Ye();
    let F = null;
    const y = new Gt();
    y.viewport = new _t();
    const b = new Gt();
    b.viewport = new _t();
    const P = [y, b], H = new $_();
    let V = null, Y = null;
    this.cameraAutoUpdate = !0, this.enabled = !1, this.isPresenting = !1, this.getController = function(j) {
      let Q = E[j];
      return Q === void 0 && (Q = new $o(), E[j] = Q), Q.getTargetRaySpace();
    }, this.getControllerGrip = function(j) {
      let Q = E[j];
      return Q === void 0 && (Q = new $o(), E[j] = Q), Q.getGripSpace();
    }, this.getHand = function(j) {
      let Q = E[j];
      return Q === void 0 && (Q = new $o(), E[j] = Q), Q.getHandSpace();
    };
    function X(j) {
      const Q = A.indexOf(j.inputSource);
      if (Q === -1)
        return;
      const ge = E[Q];
      ge !== void 0 && (ge.update(j.inputSource, j.frame, c || a), ge.dispatchEvent({ type: j.type, data: j.inputSource }));
    }
    function q() {
      n.removeEventListener("select", X), n.removeEventListener("selectstart", X), n.removeEventListener("selectend", X), n.removeEventListener("squeeze", X), n.removeEventListener("squeezestart", X), n.removeEventListener("squeezeend", X), n.removeEventListener("end", q), n.removeEventListener("inputsourceschange", z);
      for (let j = 0; j < E.length; j++) {
        const Q = A[j];
        Q !== null && (A[j] = null, E[j].disconnect(Q));
      }
      V = null, Y = null, m.reset();
      for (const j in p)
        delete p[j];
      e.setRenderTarget(M), f = null, u = null, d = null, n = null, T = null, vt.stop(), i.isPresenting = !1, e.setPixelRatio(F), e.setSize(R.width, R.height, !1), i.dispatchEvent({ type: "sessionend" });
    }
    this.setFramebufferScaleFactor = function(j) {
      r = j, i.isPresenting === !0 && Te("WebXRManager: Cannot change framebuffer scale while presenting.");
    }, this.setReferenceSpaceType = function(j) {
      o = j, i.isPresenting === !0 && Te("WebXRManager: Cannot change reference space type while presenting.");
    }, this.getReferenceSpace = function() {
      return c || a;
    }, this.setReferenceSpace = function(j) {
      c = j;
    }, this.getBaseLayer = function() {
      return u !== null ? u : f;
    }, this.getBinding = function() {
      return d === null && v && (d = new XRWebGLBinding(n, t)), d;
    }, this.getFrame = function() {
      return g;
    }, this.getSession = function() {
      return n;
    }, this.setSession = async function(j) {
      if (n = j, n !== null) {
        if (M = e.getRenderTarget(), n.addEventListener("select", X), n.addEventListener("selectstart", X), n.addEventListener("selectend", X), n.addEventListener("squeeze", X), n.addEventListener("squeezestart", X), n.addEventListener("squeezeend", X), n.addEventListener("end", q), n.addEventListener("inputsourceschange", z), w.xrCompatible !== !0 && await t.makeXRCompatible(), F = e.getPixelRatio(), e.getSize(R), v && "createProjectionLayer" in XRWebGLBinding.prototype) {
          let ge = null, Fe = null, xe = null;
          w.depth && (xe = w.stencil ? t.DEPTH24_STENCIL8 : t.DEPTH_COMPONENT24, ge = w.stencil ? Yn : dn, Fe = w.stencil ? Tr : Hi);
          const tt = {
            colorFormat: t.RGBA8,
            depthFormat: xe,
            scaleFactor: r
          };
          d = this.getBinding(), u = d.createProjectionLayer(tt), n.updateRenderState({ layers: [u] }), e.setPixelRatio(1), e.setSize(u.textureWidth, u.textureHeight, !1), T = new gi(
            u.textureWidth,
            u.textureHeight,
            {
              format: mi,
              type: ii,
              depthTexture: new Ir(u.textureWidth, u.textureHeight, Fe, void 0, void 0, void 0, void 0, void 0, void 0, ge),
              stencilBuffer: w.stencil,
              colorSpace: e.outputColorSpace,
              samples: w.antialias ? 4 : 0,
              resolveDepthBuffer: u.ignoreDepthValues === !1,
              resolveStencilBuffer: u.ignoreDepthValues === !1
            }
          );
        } else {
          const ge = {
            antialias: w.antialias,
            alpha: !0,
            depth: w.depth,
            stencil: w.stencil,
            framebufferScaleFactor: r
          };
          f = new XRWebGLLayer(n, t, ge), n.updateRenderState({ baseLayer: f }), e.setPixelRatio(1), e.setSize(f.framebufferWidth, f.framebufferHeight, !1), T = new gi(
            f.framebufferWidth,
            f.framebufferHeight,
            {
              format: mi,
              type: ii,
              colorSpace: e.outputColorSpace,
              stencilBuffer: w.stencil,
              resolveDepthBuffer: f.ignoreDepthValues === !1,
              resolveStencilBuffer: f.ignoreDepthValues === !1
            }
          );
        }
        T.isXRRenderTarget = !0, this.setFoveation(l), c = null, a = await n.requestReferenceSpace(o), vt.setContext(n), vt.start(), i.isPresenting = !0, i.dispatchEvent({ type: "sessionstart" });
      }
    }, this.getEnvironmentBlendMode = function() {
      if (n !== null)
        return n.environmentBlendMode;
    }, this.getDepthTexture = function() {
      return m.getDepthTexture();
    };
    function z(j) {
      for (let Q = 0; Q < j.removed.length; Q++) {
        const ge = j.removed[Q], Fe = A.indexOf(ge);
        Fe >= 0 && (A[Fe] = null, E[Fe].disconnect(ge));
      }
      for (let Q = 0; Q < j.added.length; Q++) {
        const ge = j.added[Q];
        let Fe = A.indexOf(ge);
        if (Fe === -1) {
          for (let tt = 0; tt < E.length; tt++)
            if (tt >= A.length) {
              A.push(ge), Fe = tt;
              break;
            } else if (A[tt] === null) {
              A[tt] = ge, Fe = tt;
              break;
            }
          if (Fe === -1) break;
        }
        const xe = E[Fe];
        xe && xe.connect(ge);
      }
    }
    const J = new O(), ue = new O();
    function le(j, Q, ge) {
      J.setFromMatrixPosition(Q.matrixWorld), ue.setFromMatrixPosition(ge.matrixWorld);
      const Fe = J.distanceTo(ue), xe = Q.projectionMatrix.elements, tt = ge.projectionMatrix.elements, Dt = xe[14] / (xe[10] - 1), et = xe[14] / (xe[10] + 1), rt = (xe[9] + 1) / xe[5], dt = (xe[9] - 1) / xe[5], He = (xe[8] - 1) / xe[0], Et = (tt[8] + 1) / tt[0], C = Dt * He, At = Dt * Et, nt = Fe / (-He + Et), pt = nt * -He;
      if (Q.matrixWorld.decompose(j.position, j.quaternion, j.scale), j.translateX(pt), j.translateZ(nt), j.matrixWorld.compose(j.position, j.quaternion, j.scale), j.matrixWorldInverse.copy(j.matrixWorld).invert(), xe[10] === -1)
        j.projectionMatrix.copy(Q.projectionMatrix), j.projectionMatrixInverse.copy(Q.projectionMatrixInverse);
      else {
        const be = Dt + nt, S = et + nt, _ = C - pt, L = At + (Fe - pt), W = rt * et / S * be, Z = dt * et / S * be;
        j.projectionMatrix.makePerspective(_, L, W, Z, be, S), j.projectionMatrixInverse.copy(j.projectionMatrix).invert();
      }
    }
    function fe(j, Q) {
      Q === null ? j.matrixWorld.copy(j.matrix) : j.matrixWorld.multiplyMatrices(Q.matrixWorld, j.matrix), j.matrixWorldInverse.copy(j.matrixWorld).invert();
    }
    this.updateCamera = function(j) {
      if (n === null) return;
      let Q = j.near, ge = j.far;
      m.texture !== null && (m.depthNear > 0 && (Q = m.depthNear), m.depthFar > 0 && (ge = m.depthFar)), H.near = b.near = y.near = Q, H.far = b.far = y.far = ge, (V !== H.near || Y !== H.far) && (n.updateRenderState({
        depthNear: H.near,
        depthFar: H.far
      }), V = H.near, Y = H.far), H.layers.mask = j.layers.mask | 6, y.layers.mask = H.layers.mask & 3, b.layers.mask = H.layers.mask & 5;
      const Fe = j.parent, xe = H.cameras;
      fe(H, Fe);
      for (let tt = 0; tt < xe.length; tt++)
        fe(xe[tt], Fe);
      xe.length === 2 ? le(H, y, b) : H.projectionMatrix.copy(y.projectionMatrix), Ge(j, H, Fe);
    };
    function Ge(j, Q, ge) {
      ge === null ? j.matrix.copy(Q.matrixWorld) : (j.matrix.copy(ge.matrixWorld), j.matrix.invert(), j.matrix.multiply(Q.matrixWorld)), j.matrix.decompose(j.position, j.quaternion, j.scale), j.updateMatrixWorld(!0), j.projectionMatrix.copy(Q.projectionMatrix), j.projectionMatrixInverse.copy(Q.projectionMatrixInverse), j.isPerspectiveCamera && (j.fov = Bs * 2 * Math.atan(1 / j.projectionMatrix.elements[5]), j.zoom = 1);
    }
    this.getCamera = function() {
      return H;
    }, this.getFoveation = function() {
      if (!(u === null && f === null))
        return l;
    }, this.setFoveation = function(j) {
      l = j, u !== null && (u.fixedFoveation = j), f !== null && f.fixedFoveation !== void 0 && (f.fixedFoveation = j);
    }, this.hasDepthSensing = function() {
      return m.texture !== null;
    }, this.getDepthSensingMesh = function() {
      return m.getMesh(H);
    }, this.getCameraTexture = function(j) {
      return p[j];
    };
    let Ve = null;
    function yt(j, Q) {
      if (h = Q.getViewerPose(c || a), g = Q, h !== null) {
        const ge = h.views;
        f !== null && (e.setRenderTargetFramebuffer(T, f.framebuffer), e.setRenderTarget(T));
        let Fe = !1;
        ge.length !== H.cameras.length && (H.cameras.length = 0, Fe = !0);
        for (let et = 0; et < ge.length; et++) {
          const rt = ge[et];
          let dt = null;
          if (f !== null)
            dt = f.getViewport(rt);
          else {
            const Et = d.getViewSubImage(u, rt);
            dt = Et.viewport, et === 0 && (e.setRenderTargetTextures(
              T,
              Et.colorTexture,
              Et.depthStencilTexture
            ), e.setRenderTarget(T));
          }
          let He = P[et];
          He === void 0 && (He = new Gt(), He.layers.enable(et), He.viewport = new _t(), P[et] = He), He.matrix.fromArray(rt.transform.matrix), He.matrix.decompose(He.position, He.quaternion, He.scale), He.projectionMatrix.fromArray(rt.projectionMatrix), He.projectionMatrixInverse.copy(He.projectionMatrix).invert(), He.viewport.set(dt.x, dt.y, dt.width, dt.height), et === 0 && (H.matrix.copy(He.matrix), H.matrix.decompose(H.position, H.quaternion, H.scale)), Fe === !0 && H.cameras.push(He);
        }
        const xe = n.enabledFeatures;
        if (xe && xe.includes("depth-sensing") && n.depthUsage == "gpu-optimized" && v) {
          d = i.getBinding();
          const et = d.getDepthInformation(ge[0]);
          et && et.isValid && et.texture && m.init(et, n.renderState);
        }
        if (xe && xe.includes("camera-access") && v) {
          e.state.unbindTexture(), d = i.getBinding();
          for (let et = 0; et < ge.length; et++) {
            const rt = ge[et].camera;
            if (rt) {
              let dt = p[rt];
              dt || (dt = new df(), p[rt] = dt);
              const He = d.getCameraImage(rt);
              dt.sourceTexture = He;
            }
          }
        }
      }
      for (let ge = 0; ge < E.length; ge++) {
        const Fe = A[ge], xe = E[ge];
        Fe !== null && xe !== void 0 && xe.update(Fe, Q, c || a);
      }
      Ve && Ve(j, Q), Q.detectedPlanes && i.dispatchEvent({ type: "planesdetected", data: Q }), g = null;
    }
    const vt = new _f();
    vt.setAnimationLoop(yt), this.setAnimationLoop = function(j) {
      Ve = j;
    }, this.dispose = function() {
    };
  }
}
const $n = /* @__PURE__ */ new kt(), Xw = /* @__PURE__ */ new ze();
function jw(s, e) {
  function t(m, p) {
    m.matrixAutoUpdate === !0 && m.updateMatrix(), p.value.copy(m.matrix);
  }
  function i(m, p) {
    p.color.getRGB(m.fogColor.value, sf(s)), p.isFog ? (m.fogNear.value = p.near, m.fogFar.value = p.far) : p.isFogExp2 && (m.fogDensity.value = p.density);
  }
  function n(m, p, w, M, T) {
    p.isMeshBasicMaterial || p.isMeshLambertMaterial ? r(m, p) : p.isMeshToonMaterial ? (r(m, p), d(m, p)) : p.isMeshPhongMaterial ? (r(m, p), h(m, p)) : p.isMeshStandardMaterial ? (r(m, p), u(m, p), p.isMeshPhysicalMaterial && f(m, p, T)) : p.isMeshMatcapMaterial ? (r(m, p), g(m, p)) : p.isMeshDepthMaterial ? r(m, p) : p.isMeshDistanceMaterial ? (r(m, p), v(m, p)) : p.isMeshNormalMaterial ? r(m, p) : p.isLineBasicMaterial ? (a(m, p), p.isLineDashedMaterial && o(m, p)) : p.isPointsMaterial ? l(m, p, w, M) : p.isSpriteMaterial ? c(m, p) : p.isShadowMaterial ? (m.color.value.copy(p.color), m.opacity.value = p.opacity) : p.isShaderMaterial && (p.uniformsNeedUpdate = !1);
  }
  function r(m, p) {
    m.opacity.value = p.opacity, p.color && m.diffuse.value.copy(p.color), p.emissive && m.emissive.value.copy(p.emissive).multiplyScalar(p.emissiveIntensity), p.map && (m.map.value = p.map, t(p.map, m.mapTransform)), p.alphaMap && (m.alphaMap.value = p.alphaMap, t(p.alphaMap, m.alphaMapTransform)), p.bumpMap && (m.bumpMap.value = p.bumpMap, t(p.bumpMap, m.bumpMapTransform), m.bumpScale.value = p.bumpScale, p.side === Kt && (m.bumpScale.value *= -1)), p.normalMap && (m.normalMap.value = p.normalMap, t(p.normalMap, m.normalMapTransform), m.normalScale.value.copy(p.normalScale), p.side === Kt && m.normalScale.value.negate()), p.displacementMap && (m.displacementMap.value = p.displacementMap, t(p.displacementMap, m.displacementMapTransform), m.displacementScale.value = p.displacementScale, m.displacementBias.value = p.displacementBias), p.emissiveMap && (m.emissiveMap.value = p.emissiveMap, t(p.emissiveMap, m.emissiveMapTransform)), p.specularMap && (m.specularMap.value = p.specularMap, t(p.specularMap, m.specularMapTransform)), p.alphaTest > 0 && (m.alphaTest.value = p.alphaTest);
    const w = e.get(p), M = w.envMap, T = w.envMapRotation;
    M && (m.envMap.value = M, $n.copy(T), $n.x *= -1, $n.y *= -1, $n.z *= -1, M.isCubeTexture && M.isRenderTargetTexture === !1 && ($n.y *= -1, $n.z *= -1), m.envMapRotation.value.setFromMatrix4(Xw.makeRotationFromEuler($n)), m.flipEnvMap.value = M.isCubeTexture && M.isRenderTargetTexture === !1 ? -1 : 1, m.reflectivity.value = p.reflectivity, m.ior.value = p.ior, m.refractionRatio.value = p.refractionRatio), p.lightMap && (m.lightMap.value = p.lightMap, m.lightMapIntensity.value = p.lightMapIntensity, t(p.lightMap, m.lightMapTransform)), p.aoMap && (m.aoMap.value = p.aoMap, m.aoMapIntensity.value = p.aoMapIntensity, t(p.aoMap, m.aoMapTransform));
  }
  function a(m, p) {
    m.diffuse.value.copy(p.color), m.opacity.value = p.opacity, p.map && (m.map.value = p.map, t(p.map, m.mapTransform));
  }
  function o(m, p) {
    m.dashSize.value = p.dashSize, m.totalSize.value = p.dashSize + p.gapSize, m.scale.value = p.scale;
  }
  function l(m, p, w, M) {
    m.diffuse.value.copy(p.color), m.opacity.value = p.opacity, m.size.value = p.size * w, m.scale.value = M * 0.5, p.map && (m.map.value = p.map, t(p.map, m.uvTransform)), p.alphaMap && (m.alphaMap.value = p.alphaMap, t(p.alphaMap, m.alphaMapTransform)), p.alphaTest > 0 && (m.alphaTest.value = p.alphaTest);
  }
  function c(m, p) {
    m.diffuse.value.copy(p.color), m.opacity.value = p.opacity, m.rotation.value = p.rotation, p.map && (m.map.value = p.map, t(p.map, m.mapTransform)), p.alphaMap && (m.alphaMap.value = p.alphaMap, t(p.alphaMap, m.alphaMapTransform)), p.alphaTest > 0 && (m.alphaTest.value = p.alphaTest);
  }
  function h(m, p) {
    m.specular.value.copy(p.specular), m.shininess.value = Math.max(p.shininess, 1e-4);
  }
  function d(m, p) {
    p.gradientMap && (m.gradientMap.value = p.gradientMap);
  }
  function u(m, p) {
    m.metalness.value = p.metalness, p.metalnessMap && (m.metalnessMap.value = p.metalnessMap, t(p.metalnessMap, m.metalnessMapTransform)), m.roughness.value = p.roughness, p.roughnessMap && (m.roughnessMap.value = p.roughnessMap, t(p.roughnessMap, m.roughnessMapTransform)), p.envMap && (m.envMapIntensity.value = p.envMapIntensity);
  }
  function f(m, p, w) {
    m.ior.value = p.ior, p.sheen > 0 && (m.sheenColor.value.copy(p.sheenColor).multiplyScalar(p.sheen), m.sheenRoughness.value = p.sheenRoughness, p.sheenColorMap && (m.sheenColorMap.value = p.sheenColorMap, t(p.sheenColorMap, m.sheenColorMapTransform)), p.sheenRoughnessMap && (m.sheenRoughnessMap.value = p.sheenRoughnessMap, t(p.sheenRoughnessMap, m.sheenRoughnessMapTransform))), p.clearcoat > 0 && (m.clearcoat.value = p.clearcoat, m.clearcoatRoughness.value = p.clearcoatRoughness, p.clearcoatMap && (m.clearcoatMap.value = p.clearcoatMap, t(p.clearcoatMap, m.clearcoatMapTransform)), p.clearcoatRoughnessMap && (m.clearcoatRoughnessMap.value = p.clearcoatRoughnessMap, t(p.clearcoatRoughnessMap, m.clearcoatRoughnessMapTransform)), p.clearcoatNormalMap && (m.clearcoatNormalMap.value = p.clearcoatNormalMap, t(p.clearcoatNormalMap, m.clearcoatNormalMapTransform), m.clearcoatNormalScale.value.copy(p.clearcoatNormalScale), p.side === Kt && m.clearcoatNormalScale.value.negate())), p.dispersion > 0 && (m.dispersion.value = p.dispersion), p.iridescence > 0 && (m.iridescence.value = p.iridescence, m.iridescenceIOR.value = p.iridescenceIOR, m.iridescenceThicknessMinimum.value = p.iridescenceThicknessRange[0], m.iridescenceThicknessMaximum.value = p.iridescenceThicknessRange[1], p.iridescenceMap && (m.iridescenceMap.value = p.iridescenceMap, t(p.iridescenceMap, m.iridescenceMapTransform)), p.iridescenceThicknessMap && (m.iridescenceThicknessMap.value = p.iridescenceThicknessMap, t(p.iridescenceThicknessMap, m.iridescenceThicknessMapTransform))), p.transmission > 0 && (m.transmission.value = p.transmission, m.transmissionSamplerMap.value = w.texture, m.transmissionSamplerSize.value.set(w.width, w.height), p.transmissionMap && (m.transmissionMap.value = p.transmissionMap, t(p.transmissionMap, m.transmissionMapTransform)), m.thickness.value = p.thickness, p.thicknessMap && (m.thicknessMap.value = p.thicknessMap, t(p.thicknessMap, m.thicknessMapTransform)), m.attenuationDistance.value = p.attenuationDistance, m.attenuationColor.value.copy(p.attenuationColor)), p.anisotropy > 0 && (m.anisotropyVector.value.set(p.anisotropy * Math.cos(p.anisotropyRotation), p.anisotropy * Math.sin(p.anisotropyRotation)), p.anisotropyMap && (m.anisotropyMap.value = p.anisotropyMap, t(p.anisotropyMap, m.anisotropyMapTransform))), m.specularIntensity.value = p.specularIntensity, m.specularColor.value.copy(p.specularColor), p.specularColorMap && (m.specularColorMap.value = p.specularColorMap, t(p.specularColorMap, m.specularColorMapTransform)), p.specularIntensityMap && (m.specularIntensityMap.value = p.specularIntensityMap, t(p.specularIntensityMap, m.specularIntensityMapTransform));
  }
  function g(m, p) {
    p.matcap && (m.matcap.value = p.matcap);
  }
  function v(m, p) {
    const w = e.get(p).light;
    m.referencePosition.value.setFromMatrixPosition(w.matrixWorld), m.nearDistance.value = w.shadow.camera.near, m.farDistance.value = w.shadow.camera.far;
  }
  return {
    refreshFogUniforms: i,
    refreshMaterialUniforms: n
  };
}
function Yw(s, e, t, i) {
  let n = {}, r = {}, a = [];
  const o = s.getParameter(s.MAX_UNIFORM_BUFFER_BINDINGS);
  function l(w, M) {
    const T = M.program;
    i.uniformBlockBinding(w, T);
  }
  function c(w, M) {
    let T = n[w.id];
    T === void 0 && (g(w), T = h(w), n[w.id] = T, w.addEventListener("dispose", m));
    const E = M.program;
    i.updateUBOMapping(w, E);
    const A = e.render.frame;
    r[w.id] !== A && (u(w), r[w.id] = A);
  }
  function h(w) {
    const M = d();
    w.__bindingPointIndex = M;
    const T = s.createBuffer(), E = w.__size, A = w.usage;
    return s.bindBuffer(s.UNIFORM_BUFFER, T), s.bufferData(s.UNIFORM_BUFFER, E, A), s.bindBuffer(s.UNIFORM_BUFFER, null), s.bindBufferBase(s.UNIFORM_BUFFER, M, T), T;
  }
  function d() {
    for (let w = 0; w < o; w++)
      if (a.indexOf(w) === -1)
        return a.push(w), w;
    return Ce("WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached."), 0;
  }
  function u(w) {
    const M = n[w.id], T = w.uniforms, E = w.__cache;
    s.bindBuffer(s.UNIFORM_BUFFER, M);
    for (let A = 0, R = T.length; A < R; A++) {
      const F = Array.isArray(T[A]) ? T[A] : [T[A]];
      for (let y = 0, b = F.length; y < b; y++) {
        const P = F[y];
        if (f(P, A, y, E) === !0) {
          const H = P.__offset, V = Array.isArray(P.value) ? P.value : [P.value];
          let Y = 0;
          for (let X = 0; X < V.length; X++) {
            const q = V[X], z = v(q);
            typeof q == "number" || typeof q == "boolean" ? (P.__data[0] = q, s.bufferSubData(s.UNIFORM_BUFFER, H + Y, P.__data)) : q.isMatrix3 ? (P.__data[0] = q.elements[0], P.__data[1] = q.elements[1], P.__data[2] = q.elements[2], P.__data[3] = 0, P.__data[4] = q.elements[3], P.__data[5] = q.elements[4], P.__data[6] = q.elements[5], P.__data[7] = 0, P.__data[8] = q.elements[6], P.__data[9] = q.elements[7], P.__data[10] = q.elements[8], P.__data[11] = 0) : (q.toArray(P.__data, Y), Y += z.storage / Float32Array.BYTES_PER_ELEMENT);
          }
          s.bufferSubData(s.UNIFORM_BUFFER, H, P.__data);
        }
      }
    }
    s.bindBuffer(s.UNIFORM_BUFFER, null);
  }
  function f(w, M, T, E) {
    const A = w.value, R = M + "_" + T;
    if (E[R] === void 0)
      return typeof A == "number" || typeof A == "boolean" ? E[R] = A : E[R] = A.clone(), !0;
    {
      const F = E[R];
      if (typeof A == "number" || typeof A == "boolean") {
        if (F !== A)
          return E[R] = A, !0;
      } else if (F.equals(A) === !1)
        return F.copy(A), !0;
    }
    return !1;
  }
  function g(w) {
    const M = w.uniforms;
    let T = 0;
    const E = 16;
    for (let R = 0, F = M.length; R < F; R++) {
      const y = Array.isArray(M[R]) ? M[R] : [M[R]];
      for (let b = 0, P = y.length; b < P; b++) {
        const H = y[b], V = Array.isArray(H.value) ? H.value : [H.value];
        for (let Y = 0, X = V.length; Y < X; Y++) {
          const q = V[Y], z = v(q), J = T % E, ue = J % z.boundary, le = J + ue;
          T += ue, le !== 0 && E - le < z.storage && (T += E - le), H.__data = new Float32Array(z.storage / Float32Array.BYTES_PER_ELEMENT), H.__offset = T, T += z.storage;
        }
      }
    }
    const A = T % E;
    return A > 0 && (T += E - A), w.__size = T, w.__cache = {}, this;
  }
  function v(w) {
    const M = {
      boundary: 0,
      // bytes
      storage: 0
      // bytes
    };
    return typeof w == "number" || typeof w == "boolean" ? (M.boundary = 4, M.storage = 4) : w.isVector2 ? (M.boundary = 8, M.storage = 8) : w.isVector3 || w.isColor ? (M.boundary = 16, M.storage = 12) : w.isVector4 ? (M.boundary = 16, M.storage = 16) : w.isMatrix3 ? (M.boundary = 48, M.storage = 48) : w.isMatrix4 ? (M.boundary = 64, M.storage = 64) : w.isTexture ? Te("WebGLRenderer: Texture samplers can not be part of an uniforms group.") : Te("WebGLRenderer: Unsupported uniform value type.", w), M;
  }
  function m(w) {
    const M = w.target;
    M.removeEventListener("dispose", m);
    const T = a.indexOf(M.__bindingPointIndex);
    a.splice(T, 1), s.deleteBuffer(n[M.id]), delete n[M.id], delete r[M.id];
  }
  function p() {
    for (const w in n)
      s.deleteBuffer(n[w]);
    a = [], n = {}, r = {};
  }
  return {
    bind: l,
    update: c,
    dispose: p
  };
}
const Kw = new Uint16Array([
  12469,
  15057,
  12620,
  14925,
  13266,
  14620,
  13807,
  14376,
  14323,
  13990,
  14545,
  13625,
  14713,
  13328,
  14840,
  12882,
  14931,
  12528,
  14996,
  12233,
  15039,
  11829,
  15066,
  11525,
  15080,
  11295,
  15085,
  10976,
  15082,
  10705,
  15073,
  10495,
  13880,
  14564,
  13898,
  14542,
  13977,
  14430,
  14158,
  14124,
  14393,
  13732,
  14556,
  13410,
  14702,
  12996,
  14814,
  12596,
  14891,
  12291,
  14937,
  11834,
  14957,
  11489,
  14958,
  11194,
  14943,
  10803,
  14921,
  10506,
  14893,
  10278,
  14858,
  9960,
  14484,
  14039,
  14487,
  14025,
  14499,
  13941,
  14524,
  13740,
  14574,
  13468,
  14654,
  13106,
  14743,
  12678,
  14818,
  12344,
  14867,
  11893,
  14889,
  11509,
  14893,
  11180,
  14881,
  10751,
  14852,
  10428,
  14812,
  10128,
  14765,
  9754,
  14712,
  9466,
  14764,
  13480,
  14764,
  13475,
  14766,
  13440,
  14766,
  13347,
  14769,
  13070,
  14786,
  12713,
  14816,
  12387,
  14844,
  11957,
  14860,
  11549,
  14868,
  11215,
  14855,
  10751,
  14825,
  10403,
  14782,
  10044,
  14729,
  9651,
  14666,
  9352,
  14599,
  9029,
  14967,
  12835,
  14966,
  12831,
  14963,
  12804,
  14954,
  12723,
  14936,
  12564,
  14917,
  12347,
  14900,
  11958,
  14886,
  11569,
  14878,
  11247,
  14859,
  10765,
  14828,
  10401,
  14784,
  10011,
  14727,
  9600,
  14660,
  9289,
  14586,
  8893,
  14508,
  8533,
  15111,
  12234,
  15110,
  12234,
  15104,
  12216,
  15092,
  12156,
  15067,
  12010,
  15028,
  11776,
  14981,
  11500,
  14942,
  11205,
  14902,
  10752,
  14861,
  10393,
  14812,
  9991,
  14752,
  9570,
  14682,
  9252,
  14603,
  8808,
  14519,
  8445,
  14431,
  8145,
  15209,
  11449,
  15208,
  11451,
  15202,
  11451,
  15190,
  11438,
  15163,
  11384,
  15117,
  11274,
  15055,
  10979,
  14994,
  10648,
  14932,
  10343,
  14871,
  9936,
  14803,
  9532,
  14729,
  9218,
  14645,
  8742,
  14556,
  8381,
  14461,
  8020,
  14365,
  7603,
  15273,
  10603,
  15272,
  10607,
  15267,
  10619,
  15256,
  10631,
  15231,
  10614,
  15182,
  10535,
  15118,
  10389,
  15042,
  10167,
  14963,
  9787,
  14883,
  9447,
  14800,
  9115,
  14710,
  8665,
  14615,
  8318,
  14514,
  7911,
  14411,
  7507,
  14279,
  7198,
  15314,
  9675,
  15313,
  9683,
  15309,
  9712,
  15298,
  9759,
  15277,
  9797,
  15229,
  9773,
  15166,
  9668,
  15084,
  9487,
  14995,
  9274,
  14898,
  8910,
  14800,
  8539,
  14697,
  8234,
  14590,
  7790,
  14479,
  7409,
  14367,
  7067,
  14178,
  6621,
  15337,
  8619,
  15337,
  8631,
  15333,
  8677,
  15325,
  8769,
  15305,
  8871,
  15264,
  8940,
  15202,
  8909,
  15119,
  8775,
  15022,
  8565,
  14916,
  8328,
  14804,
  8009,
  14688,
  7614,
  14569,
  7287,
  14448,
  6888,
  14321,
  6483,
  14088,
  6171,
  15350,
  7402,
  15350,
  7419,
  15347,
  7480,
  15340,
  7613,
  15322,
  7804,
  15287,
  7973,
  15229,
  8057,
  15148,
  8012,
  15046,
  7846,
  14933,
  7611,
  14810,
  7357,
  14682,
  7069,
  14552,
  6656,
  14421,
  6316,
  14251,
  5948,
  14007,
  5528,
  15356,
  5942,
  15356,
  5977,
  15353,
  6119,
  15348,
  6294,
  15332,
  6551,
  15302,
  6824,
  15249,
  7044,
  15171,
  7122,
  15070,
  7050,
  14949,
  6861,
  14818,
  6611,
  14679,
  6349,
  14538,
  6067,
  14398,
  5651,
  14189,
  5311,
  13935,
  4958,
  15359,
  4123,
  15359,
  4153,
  15356,
  4296,
  15353,
  4646,
  15338,
  5160,
  15311,
  5508,
  15263,
  5829,
  15188,
  6042,
  15088,
  6094,
  14966,
  6001,
  14826,
  5796,
  14678,
  5543,
  14527,
  5287,
  14377,
  4985,
  14133,
  4586,
  13869,
  4257,
  15360,
  1563,
  15360,
  1642,
  15358,
  2076,
  15354,
  2636,
  15341,
  3350,
  15317,
  4019,
  15273,
  4429,
  15203,
  4732,
  15105,
  4911,
  14981,
  4932,
  14836,
  4818,
  14679,
  4621,
  14517,
  4386,
  14359,
  4156,
  14083,
  3795,
  13808,
  3437,
  15360,
  122,
  15360,
  137,
  15358,
  285,
  15355,
  636,
  15344,
  1274,
  15322,
  2177,
  15281,
  2765,
  15215,
  3223,
  15120,
  3451,
  14995,
  3569,
  14846,
  3567,
  14681,
  3466,
  14511,
  3305,
  14344,
  3121,
  14037,
  2800,
  13753,
  2467,
  15360,
  0,
  15360,
  1,
  15359,
  21,
  15355,
  89,
  15346,
  253,
  15325,
  479,
  15287,
  796,
  15225,
  1148,
  15133,
  1492,
  15008,
  1749,
  14856,
  1882,
  14685,
  1886,
  14506,
  1783,
  14324,
  1608,
  13996,
  1398,
  13702,
  1183
]);
let Ni = null;
function Zw() {
  return Ni === null && (Ni = new eh(Kw, 16, 16, Fs, Ai), Ni.name = "DFG_LUT", Ni.minFilter = bt, Ni.magFilter = bt, Ni.wrapS = Fi, Ni.wrapT = Fi, Ni.generateMipmaps = !1, Ni.needsUpdate = !0), Ni;
}
class Jw {
  /**
   * Constructs a new WebGL renderer.
   *
   * @param {WebGLRenderer~Options} [parameters] - The configuration parameter.
   */
  constructor(e = {}) {
    const {
      canvas: t = Sv(),
      context: i = null,
      depth: n = !0,
      stencil: r = !1,
      alpha: a = !1,
      antialias: o = !1,
      premultipliedAlpha: l = !0,
      preserveDrawingBuffer: c = !1,
      powerPreference: h = "default",
      failIfMajorPerformanceCaveat: d = !1,
      reversedDepthBuffer: u = !1,
      outputBufferType: f = ii
    } = e;
    this.isWebGLRenderer = !0;
    let g;
    if (i !== null) {
      if (typeof WebGLRenderingContext < "u" && i instanceof WebGLRenderingContext)
        throw new Error("THREE.WebGLRenderer: WebGL 1 is not supported since r163.");
      g = i.getContextAttributes().alpha;
    } else
      g = a;
    const v = f, m = /* @__PURE__ */ new Set([
      Wc,
      qc,
      Gc
    ]), p = /* @__PURE__ */ new Set([
      ii,
      Hi,
      Mr,
      Tr,
      Vc,
      Hc
    ]), w = new Uint32Array(4), M = new Int32Array(4);
    let T = null, E = null;
    const A = [], R = [];
    let F = null;
    this.domElement = t, this.debug = {
      /**
       * Enables error checking and reporting when shader programs are being compiled.
       * @type {boolean}
       */
      checkShaderErrors: !0,
      /**
       * Callback for custom error reporting.
       * @type {?Function}
       */
      onShaderError: null
    }, this.autoClear = !0, this.autoClearColor = !0, this.autoClearDepth = !0, this.autoClearStencil = !0, this.sortObjects = !0, this.clippingPlanes = [], this.localClippingEnabled = !1, this.toneMapping = zi, this.toneMappingExposure = 1, this.transmissionResolutionScale = 1;
    const y = this;
    let b = !1;
    this._outputColorSpace = Ct;
    let P = 0, H = 0, V = null, Y = -1, X = null;
    const q = new _t(), z = new _t();
    let J = null;
    const ue = new Ne(0);
    let le = 0, fe = t.width, Ge = t.height, Ve = 1, yt = null, vt = null;
    const j = new _t(0, 0, fe, Ge), Q = new _t(0, 0, fe, Ge);
    let ge = !1;
    const Fe = new ih();
    let xe = !1, tt = !1;
    const Dt = new ze(), et = new O(), rt = new _t(), dt = { background: null, fog: null, environment: null, overrideMaterial: null, isScene: !0 };
    let He = !1;
    function Et() {
      return V === null ? Ve : 1;
    }
    let C = i;
    function At(x, N) {
      return t.getContext(x, N);
    }
    try {
      const x = {
        alpha: !0,
        depth: n,
        stencil: r,
        antialias: o,
        premultipliedAlpha: l,
        preserveDrawingBuffer: c,
        powerPreference: h,
        failIfMajorPerformanceCaveat: d
      };
      if ("setAttribute" in t && t.setAttribute("data-engine", `three.js r${kc}`), t.addEventListener("webglcontextlost", De, !1), t.addEventListener("webglcontextrestored", mt, !1), t.addEventListener("webglcontextcreationerror", at, !1), C === null) {
        const N = "webgl2";
        if (C = At(N, x), C === null)
          throw At(N) ? new Error("Error creating WebGL context with your selected attributes.") : new Error("Error creating WebGL context.");
      }
    } catch (x) {
      throw Ce("WebGLRenderer: " + x.message), x;
    }
    let nt, pt, be, S, _, L, W, Z, G, Se, se, ye, Pe, te, ae, _e, we, re, $e, I, de, ie, pe, ee;
    function K() {
      nt = new Zy(C), nt.init(), ie = new Hw(C, nt), pt = new Hy(C, nt, e, ie), be = new zw(C, nt), pt.reversedDepthBuffer && u && be.buffers.depth.setReversed(!0), S = new eb(C), _ = new Tw(), L = new Vw(C, nt, be, _, pt, ie, S), W = new Gy(y), Z = new Ky(y), G = new s0(C), pe = new zy(C, G), Se = new Jy(C, G, S, pe), se = new ib(C, Se, G, S), $e = new tb(C, pt, L), _e = new $y(_), ye = new Mw(y, W, Z, nt, pt, pe, _e), Pe = new jw(y, _), te = new Aw(), ae = new Dw(nt), re = new ky(y, W, Z, be, se, g, l), we = new Bw(y, se, pt), ee = new Yw(C, S, pt, be), I = new Vy(C, nt, S), de = new Qy(C, nt, S), S.programs = ye.programs, y.capabilities = pt, y.extensions = nt, y.properties = _, y.renderLists = te, y.shadowMap = we, y.state = be, y.info = S;
    }
    K(), v !== ii && (F = new sb(v, t.width, t.height, n, r));
    const ne = new Ww(y, C);
    this.xr = ne, this.getContext = function() {
      return C;
    }, this.getContextAttributes = function() {
      return C.getContextAttributes();
    }, this.forceContextLoss = function() {
      const x = nt.get("WEBGL_lose_context");
      x && x.loseContext();
    }, this.forceContextRestore = function() {
      const x = nt.get("WEBGL_lose_context");
      x && x.restoreContext();
    }, this.getPixelRatio = function() {
      return Ve;
    }, this.setPixelRatio = function(x) {
      x !== void 0 && (Ve = x, this.setSize(fe, Ge, !1));
    }, this.getSize = function(x) {
      return x.set(fe, Ge);
    }, this.setSize = function(x, N, k = !0) {
      if (ne.isPresenting) {
        Te("WebGLRenderer: Can't change size while VR device is presenting.");
        return;
      }
      fe = x, Ge = N, t.width = Math.floor(x * Ve), t.height = Math.floor(N * Ve), k === !0 && (t.style.width = x + "px", t.style.height = N + "px"), F !== null && F.setSize(t.width, t.height), this.setViewport(0, 0, x, N);
    }, this.getDrawingBufferSize = function(x) {
      return x.set(fe * Ve, Ge * Ve).floor();
    }, this.setDrawingBufferSize = function(x, N, k) {
      fe = x, Ge = N, Ve = k, t.width = Math.floor(x * k), t.height = Math.floor(N * k), this.setViewport(0, 0, x, N);
    }, this.setEffects = function(x) {
      if (v === ii) {
        console.error("THREE.WebGLRenderer: setEffects() requires outputBufferType set to HalfFloatType or FloatType.");
        return;
      }
      if (x) {
        for (let N = 0; N < x.length; N++)
          if (x[N].isOutputPass === !0) {
            console.warn("THREE.WebGLRenderer: OutputPass is not needed in setEffects(). Tone mapping and color space conversion are applied automatically.");
            break;
          }
      }
      F.setEffects(x || []);
    }, this.getCurrentViewport = function(x) {
      return x.copy(q);
    }, this.getViewport = function(x) {
      return x.copy(j);
    }, this.setViewport = function(x, N, k, B) {
      x.isVector4 ? j.set(x.x, x.y, x.z, x.w) : j.set(x, N, k, B), be.viewport(q.copy(j).multiplyScalar(Ve).round());
    }, this.getScissor = function(x) {
      return x.copy(Q);
    }, this.setScissor = function(x, N, k, B) {
      x.isVector4 ? Q.set(x.x, x.y, x.z, x.w) : Q.set(x, N, k, B), be.scissor(z.copy(Q).multiplyScalar(Ve).round());
    }, this.getScissorTest = function() {
      return ge;
    }, this.setScissorTest = function(x) {
      be.setScissorTest(ge = x);
    }, this.setOpaqueSort = function(x) {
      yt = x;
    }, this.setTransparentSort = function(x) {
      vt = x;
    }, this.getClearColor = function(x) {
      return x.copy(re.getClearColor());
    }, this.setClearColor = function() {
      re.setClearColor(...arguments);
    }, this.getClearAlpha = function() {
      return re.getClearAlpha();
    }, this.setClearAlpha = function() {
      re.setClearAlpha(...arguments);
    }, this.clear = function(x = !0, N = !0, k = !0) {
      let B = 0;
      if (x) {
        let U = !1;
        if (V !== null) {
          const oe = V.texture.format;
          U = m.has(oe);
        }
        if (U) {
          const oe = V.texture.type, me = p.has(oe), he = re.getClearColor(), ve = re.getClearAlpha(), Me = he.r, Re = he.g, Ee = he.b;
          me ? (w[0] = Me, w[1] = Re, w[2] = Ee, w[3] = ve, C.clearBufferuiv(C.COLOR, 0, w)) : (M[0] = Me, M[1] = Re, M[2] = Ee, M[3] = ve, C.clearBufferiv(C.COLOR, 0, M));
        } else
          B |= C.COLOR_BUFFER_BIT;
      }
      N && (B |= C.DEPTH_BUFFER_BIT), k && (B |= C.STENCIL_BUFFER_BIT, this.state.buffers.stencil.setMask(4294967295)), C.clear(B);
    }, this.clearColor = function() {
      this.clear(!0, !1, !1);
    }, this.clearDepth = function() {
      this.clear(!1, !0, !1);
    }, this.clearStencil = function() {
      this.clear(!1, !1, !0);
    }, this.dispose = function() {
      t.removeEventListener("webglcontextlost", De, !1), t.removeEventListener("webglcontextrestored", mt, !1), t.removeEventListener("webglcontextcreationerror", at, !1), re.dispose(), te.dispose(), ae.dispose(), _.dispose(), W.dispose(), Z.dispose(), se.dispose(), pe.dispose(), ee.dispose(), ye.dispose(), ne.dispose(), ne.removeEventListener("sessionstart", gh), ne.removeEventListener("sessionend", vh), Dn.stop();
    };
    function De(x) {
      x.preventDefault(), Wa("WebGLRenderer: Context Lost."), b = !0;
    }
    function mt() {
      Wa("WebGLRenderer: Context Restored."), b = !1;
      const x = S.autoReset, N = we.enabled, k = we.autoUpdate, B = we.needsUpdate, U = we.type;
      K(), S.autoReset = x, we.enabled = N, we.autoUpdate = k, we.needsUpdate = B, we.type = U;
    }
    function at(x) {
      Ce("WebGLRenderer: A WebGL context could not be created. Reason: ", x.statusMessage);
    }
    function Di(x) {
      const N = x.target;
      N.removeEventListener("dispose", Di), Yi(N);
    }
    function Yi(x) {
      Lf(x), _.remove(x);
    }
    function Lf(x) {
      const N = _.get(x).programs;
      N !== void 0 && (N.forEach(function(k) {
        ye.releaseProgram(k);
      }), x.isShaderMaterial && ye.releaseShaderCache(x));
    }
    this.renderBufferDirect = function(x, N, k, B, U, oe) {
      N === null && (N = dt);
      const me = U.isMesh && U.matrixWorld.determinant() < 0, he = Nf(x, N, k, B, U);
      be.setMaterial(B, me);
      let ve = k.index, Me = 1;
      if (B.wireframe === !0) {
        if (ve = Se.getWireframeAttribute(k), ve === void 0) return;
        Me = 2;
      }
      const Re = k.drawRange, Ee = k.attributes.position;
      let qe = Re.start * Me, ht = (Re.start + Re.count) * Me;
      oe !== null && (qe = Math.max(qe, oe.start * Me), ht = Math.min(ht, (oe.start + oe.count) * Me)), ve !== null ? (qe = Math.max(qe, 0), ht = Math.min(ht, ve.count)) : Ee != null && (qe = Math.max(qe, 0), ht = Math.min(ht, Ee.count));
      const St = ht - qe;
      if (St < 0 || St === 1 / 0) return;
      pe.setup(U, B, he, k, ve);
      let Mt, ut = I;
      if (ve !== null && (Mt = G.get(ve), ut = de, ut.setIndex(Mt)), U.isMesh)
        B.wireframe === !0 ? (be.setLineWidth(B.wireframeLinewidth * Et()), ut.setMode(C.LINES)) : ut.setMode(C.TRIANGLES);
      else if (U.isLine) {
        let Ae = B.linewidth;
        Ae === void 0 && (Ae = 1), be.setLineWidth(Ae * Et()), U.isLineSegments ? ut.setMode(C.LINES) : U.isLineLoop ? ut.setMode(C.LINE_LOOP) : ut.setMode(C.LINE_STRIP);
      } else U.isPoints ? ut.setMode(C.POINTS) : U.isSprite && ut.setMode(C.TRIANGLES);
      if (U.isBatchedMesh)
        if (U._multiDrawInstances !== null)
          Cr("WebGLRenderer: renderMultiDrawInstances has been deprecated and will be removed in r184. Append to renderMultiDraw arguments and use indirection."), ut.renderMultiDrawInstances(U._multiDrawStarts, U._multiDrawCounts, U._multiDrawCount, U._multiDrawInstances);
        else if (nt.get("WEBGL_multi_draw"))
          ut.renderMultiDraw(U._multiDrawStarts, U._multiDrawCounts, U._multiDrawCount);
        else {
          const Ae = U._multiDrawStarts, ot = U._multiDrawCounts, it = U._multiDrawCount, Jt = ve ? G.get(ve).bytesPerElement : 1, as = _.get(B).currentProgram.getUniforms();
          for (let Qt = 0; Qt < it; Qt++)
            as.setValue(C, "_gl_DrawID", Qt), ut.render(Ae[Qt] / Jt, ot[Qt]);
        }
      else if (U.isInstancedMesh)
        ut.renderInstances(qe, St, U.count);
      else if (k.isInstancedBufferGeometry) {
        const Ae = k._maxInstanceCount !== void 0 ? k._maxInstanceCount : 1 / 0, ot = Math.min(k.instanceCount, Ae);
        ut.renderInstances(qe, St, ot);
      } else
        ut.render(qe, St);
    };
    function mh(x, N, k) {
      x.transparent === !0 && x.side === fi && x.forceSinglePass === !1 ? (x.side = Kt, x.needsUpdate = !0, Hr(x, N, k), x.side = hn, x.needsUpdate = !0, Hr(x, N, k), x.side = fi) : Hr(x, N, k);
    }
    this.compile = function(x, N, k = null) {
      k === null && (k = x), E = ae.get(k), E.init(N), R.push(E), k.traverseVisible(function(U) {
        U.isLight && U.layers.test(N.layers) && (E.pushLight(U), U.castShadow && E.pushShadow(U));
      }), x !== k && x.traverseVisible(function(U) {
        U.isLight && U.layers.test(N.layers) && (E.pushLight(U), U.castShadow && E.pushShadow(U));
      }), E.setupLights();
      const B = /* @__PURE__ */ new Set();
      return x.traverse(function(U) {
        if (!(U.isMesh || U.isPoints || U.isLine || U.isSprite))
          return;
        const oe = U.material;
        if (oe)
          if (Array.isArray(oe))
            for (let me = 0; me < oe.length; me++) {
              const he = oe[me];
              mh(he, k, U), B.add(he);
            }
          else
            mh(oe, k, U), B.add(oe);
      }), E = R.pop(), B;
    }, this.compileAsync = function(x, N, k = null) {
      const B = this.compile(x, N, k);
      return new Promise((U) => {
        function oe() {
          if (B.forEach(function(me) {
            _.get(me).currentProgram.isReady() && B.delete(me);
          }), B.size === 0) {
            U(x);
            return;
          }
          setTimeout(oe, 10);
        }
        nt.get("KHR_parallel_shader_compile") !== null ? oe() : setTimeout(oe, 10);
      });
    };
    let _o = null;
    function Df(x) {
      _o && _o(x);
    }
    function gh() {
      Dn.stop();
    }
    function vh() {
      Dn.start();
    }
    const Dn = new _f();
    Dn.setAnimationLoop(Df), typeof self < "u" && Dn.setContext(self), this.setAnimationLoop = function(x) {
      _o = x, ne.setAnimationLoop(x), x === null ? Dn.stop() : Dn.start();
    }, ne.addEventListener("sessionstart", gh), ne.addEventListener("sessionend", vh), this.render = function(x, N) {
      if (N !== void 0 && N.isCamera !== !0) {
        Ce("WebGLRenderer.render: camera is not an instance of THREE.Camera.");
        return;
      }
      if (b === !0) return;
      const k = ne.enabled === !0 && ne.isPresenting === !0, B = F !== null && (V === null || k) && F.begin(y, V);
      if (x.matrixWorldAutoUpdate === !0 && x.updateMatrixWorld(), N.parent === null && N.matrixWorldAutoUpdate === !0 && N.updateMatrixWorld(), ne.enabled === !0 && ne.isPresenting === !0 && (F === null || F.isCompositing() === !1) && (ne.cameraAutoUpdate === !0 && ne.updateCamera(N), N = ne.getCamera()), x.isScene === !0 && x.onBeforeRender(y, x, N, V), E = ae.get(x, R.length), E.init(N), R.push(E), Dt.multiplyMatrices(N.projectionMatrix, N.matrixWorldInverse), Fe.setFromProjectionMatrix(Dt, Bi, N.reversedDepth), tt = this.localClippingEnabled, xe = _e.init(this.clippingPlanes, tt), T = te.get(x, A.length), T.init(), A.push(T), ne.enabled === !0 && ne.isPresenting === !0) {
        const me = y.xr.getDepthSensingMesh();
        me !== null && xo(me, N, -1 / 0, y.sortObjects);
      }
      xo(x, N, 0, y.sortObjects), T.finish(), y.sortObjects === !0 && T.sort(yt, vt), He = ne.enabled === !1 || ne.isPresenting === !1 || ne.hasDepthSensing() === !1, He && re.addToRenderList(T, x), this.info.render.frame++, xe === !0 && _e.beginShadows();
      const U = E.state.shadowsArray;
      if (we.render(U, x, N), xe === !0 && _e.endShadows(), this.info.autoReset === !0 && this.info.reset(), (B && F.hasRenderPass()) === !1) {
        const me = T.opaque, he = T.transmissive;
        if (E.setupLights(), N.isArrayCamera) {
          const ve = N.cameras;
          if (he.length > 0)
            for (let Me = 0, Re = ve.length; Me < Re; Me++) {
              const Ee = ve[Me];
              xh(me, he, x, Ee);
            }
          He && re.render(x);
          for (let Me = 0, Re = ve.length; Me < Re; Me++) {
            const Ee = ve[Me];
            _h(T, x, Ee, Ee.viewport);
          }
        } else
          he.length > 0 && xh(me, he, x, N), He && re.render(x), _h(T, x, N);
      }
      V !== null && H === 0 && (L.updateMultisampleRenderTarget(V), L.updateRenderTargetMipmap(V)), B && F.end(y), x.isScene === !0 && x.onAfterRender(y, x, N), pe.resetDefaultState(), Y = -1, X = null, R.pop(), R.length > 0 ? (E = R[R.length - 1], xe === !0 && _e.setGlobalState(y.clippingPlanes, E.state.camera)) : E = null, A.pop(), A.length > 0 ? T = A[A.length - 1] : T = null;
    };
    function xo(x, N, k, B) {
      if (x.visible === !1) return;
      if (x.layers.test(N.layers)) {
        if (x.isGroup)
          k = x.renderOrder;
        else if (x.isLOD)
          x.autoUpdate === !0 && x.update(N);
        else if (x.isLight)
          E.pushLight(x), x.castShadow && E.pushShadow(x);
        else if (x.isSprite) {
          if (!x.frustumCulled || Fe.intersectsSprite(x)) {
            B && rt.setFromMatrixPosition(x.matrixWorld).applyMatrix4(Dt);
            const me = se.update(x), he = x.material;
            he.visible && T.push(x, me, he, k, rt.z, null);
          }
        } else if ((x.isMesh || x.isLine || x.isPoints) && (!x.frustumCulled || Fe.intersectsObject(x))) {
          const me = se.update(x), he = x.material;
          if (B && (x.boundingSphere !== void 0 ? (x.boundingSphere === null && x.computeBoundingSphere(), rt.copy(x.boundingSphere.center)) : (me.boundingSphere === null && me.computeBoundingSphere(), rt.copy(me.boundingSphere.center)), rt.applyMatrix4(x.matrixWorld).applyMatrix4(Dt)), Array.isArray(he)) {
            const ve = me.groups;
            for (let Me = 0, Re = ve.length; Me < Re; Me++) {
              const Ee = ve[Me], qe = he[Ee.materialIndex];
              qe && qe.visible && T.push(x, me, qe, k, rt.z, Ee);
            }
          } else he.visible && T.push(x, me, he, k, rt.z, null);
        }
      }
      const oe = x.children;
      for (let me = 0, he = oe.length; me < he; me++)
        xo(oe[me], N, k, B);
    }
    function _h(x, N, k, B) {
      const { opaque: U, transmissive: oe, transparent: me } = x;
      E.setupLightsView(k), xe === !0 && _e.setGlobalState(y.clippingPlanes, k), B && be.viewport(q.copy(B)), U.length > 0 && Vr(U, N, k), oe.length > 0 && Vr(oe, N, k), me.length > 0 && Vr(me, N, k), be.buffers.depth.setTest(!0), be.buffers.depth.setMask(!0), be.buffers.color.setMask(!0), be.setPolygonOffset(!1);
    }
    function xh(x, N, k, B) {
      if ((k.isScene === !0 ? k.overrideMaterial : null) !== null)
        return;
      if (E.state.transmissionRenderTarget[B.id] === void 0) {
        const qe = nt.has("EXT_color_buffer_half_float") || nt.has("EXT_color_buffer_float");
        E.state.transmissionRenderTarget[B.id] = new gi(1, 1, {
          generateMipmaps: !0,
          type: qe ? Ai : ii,
          minFilter: nn,
          samples: pt.samples,
          stencilBuffer: r,
          resolveDepthBuffer: !1,
          resolveStencilBuffer: !1,
          colorSpace: Ke.workingColorSpace
        });
      }
      const oe = E.state.transmissionRenderTarget[B.id], me = B.viewport || q;
      oe.setSize(me.z * y.transmissionResolutionScale, me.w * y.transmissionResolutionScale);
      const he = y.getRenderTarget(), ve = y.getActiveCubeFace(), Me = y.getActiveMipmapLevel();
      y.setRenderTarget(oe), y.getClearColor(ue), le = y.getClearAlpha(), le < 1 && y.setClearColor(16777215, 0.5), y.clear(), He && re.render(k);
      const Re = y.toneMapping;
      y.toneMapping = zi;
      const Ee = B.viewport;
      if (B.viewport !== void 0 && (B.viewport = void 0), E.setupLightsView(B), xe === !0 && _e.setGlobalState(y.clippingPlanes, B), Vr(x, k, B), L.updateMultisampleRenderTarget(oe), L.updateRenderTargetMipmap(oe), nt.has("WEBGL_multisampled_render_to_texture") === !1) {
        let qe = !1;
        for (let ht = 0, St = N.length; ht < St; ht++) {
          const Mt = N[ht], { object: ut, geometry: Ae, material: ot, group: it } = Mt;
          if (ot.side === fi && ut.layers.test(B.layers)) {
            const Jt = ot.side;
            ot.side = Kt, ot.needsUpdate = !0, yh(ut, k, B, Ae, ot, it), ot.side = Jt, ot.needsUpdate = !0, qe = !0;
          }
        }
        qe === !0 && (L.updateMultisampleRenderTarget(oe), L.updateRenderTargetMipmap(oe));
      }
      y.setRenderTarget(he, ve, Me), y.setClearColor(ue, le), Ee !== void 0 && (B.viewport = Ee), y.toneMapping = Re;
    }
    function Vr(x, N, k) {
      const B = N.isScene === !0 ? N.overrideMaterial : null;
      for (let U = 0, oe = x.length; U < oe; U++) {
        const me = x[U], { object: he, geometry: ve, group: Me } = me;
        let Re = me.material;
        Re.allowOverride === !0 && B !== null && (Re = B), he.layers.test(k.layers) && yh(he, N, k, ve, Re, Me);
      }
    }
    function yh(x, N, k, B, U, oe) {
      x.onBeforeRender(y, N, k, B, U, oe), x.modelViewMatrix.multiplyMatrices(k.matrixWorldInverse, x.matrixWorld), x.normalMatrix.getNormalMatrix(x.modelViewMatrix), U.onBeforeRender(y, N, k, B, x, oe), U.transparent === !0 && U.side === fi && U.forceSinglePass === !1 ? (U.side = Kt, U.needsUpdate = !0, y.renderBufferDirect(k, N, B, U, x, oe), U.side = hn, U.needsUpdate = !0, y.renderBufferDirect(k, N, B, U, x, oe), U.side = fi) : y.renderBufferDirect(k, N, B, U, x, oe), x.onAfterRender(y, N, k, B, U, oe);
    }
    function Hr(x, N, k) {
      N.isScene !== !0 && (N = dt);
      const B = _.get(x), U = E.state.lights, oe = E.state.shadowsArray, me = U.state.version, he = ye.getParameters(x, U.state, oe, N, k), ve = ye.getProgramCacheKey(he);
      let Me = B.programs;
      B.environment = x.isMeshStandardMaterial ? N.environment : null, B.fog = N.fog, B.envMap = (x.isMeshStandardMaterial ? Z : W).get(x.envMap || B.environment), B.envMapRotation = B.environment !== null && x.envMap === null ? N.environmentRotation : x.envMapRotation, Me === void 0 && (x.addEventListener("dispose", Di), Me = /* @__PURE__ */ new Map(), B.programs = Me);
      let Re = Me.get(ve);
      if (Re !== void 0) {
        if (B.currentProgram === Re && B.lightsStateVersion === me)
          return wh(x, he), Re;
      } else
        he.uniforms = ye.getUniforms(x), x.onBeforeCompile(he, y), Re = ye.acquireProgram(he, ve), Me.set(ve, Re), B.uniforms = he.uniforms;
      const Ee = B.uniforms;
      return (!x.isShaderMaterial && !x.isRawShaderMaterial || x.clipping === !0) && (Ee.clippingPlanes = _e.uniform), wh(x, he), B.needsLights = Uf(x), B.lightsStateVersion = me, B.needsLights && (Ee.ambientLightColor.value = U.state.ambient, Ee.lightProbe.value = U.state.probe, Ee.directionalLights.value = U.state.directional, Ee.directionalLightShadows.value = U.state.directionalShadow, Ee.spotLights.value = U.state.spot, Ee.spotLightShadows.value = U.state.spotShadow, Ee.rectAreaLights.value = U.state.rectArea, Ee.ltc_1.value = U.state.rectAreaLTC1, Ee.ltc_2.value = U.state.rectAreaLTC2, Ee.pointLights.value = U.state.point, Ee.pointLightShadows.value = U.state.pointShadow, Ee.hemisphereLights.value = U.state.hemi, Ee.directionalShadowMap.value = U.state.directionalShadowMap, Ee.directionalShadowMatrix.value = U.state.directionalShadowMatrix, Ee.spotShadowMap.value = U.state.spotShadowMap, Ee.spotLightMatrix.value = U.state.spotLightMatrix, Ee.spotLightMap.value = U.state.spotLightMap, Ee.pointShadowMap.value = U.state.pointShadowMap, Ee.pointShadowMatrix.value = U.state.pointShadowMatrix), B.currentProgram = Re, B.uniformsList = null, Re;
    }
    function bh(x) {
      if (x.uniformsList === null) {
        const N = x.currentProgram.getUniforms();
        x.uniformsList = Ia.seqWithValue(N.seq, x.uniforms);
      }
      return x.uniformsList;
    }
    function wh(x, N) {
      const k = _.get(x);
      k.outputColorSpace = N.outputColorSpace, k.batching = N.batching, k.batchingColor = N.batchingColor, k.instancing = N.instancing, k.instancingColor = N.instancingColor, k.instancingMorph = N.instancingMorph, k.skinning = N.skinning, k.morphTargets = N.morphTargets, k.morphNormals = N.morphNormals, k.morphColors = N.morphColors, k.morphTargetsCount = N.morphTargetsCount, k.numClippingPlanes = N.numClippingPlanes, k.numIntersection = N.numClipIntersection, k.vertexAlphas = N.vertexAlphas, k.vertexTangents = N.vertexTangents, k.toneMapping = N.toneMapping;
    }
    function Nf(x, N, k, B, U) {
      N.isScene !== !0 && (N = dt), L.resetTextureUnits();
      const oe = N.fog, me = B.isMeshStandardMaterial ? N.environment : null, he = V === null ? y.outputColorSpace : V.isXRRenderTarget === !0 ? V.texture.colorSpace : Wt, ve = (B.isMeshStandardMaterial ? Z : W).get(B.envMap || me), Me = B.vertexColors === !0 && !!k.attributes.color && k.attributes.color.itemSize === 4, Re = !!k.attributes.tangent && (!!B.normalMap || B.anisotropy > 0), Ee = !!k.morphAttributes.position, qe = !!k.morphAttributes.normal, ht = !!k.morphAttributes.color;
      let St = zi;
      B.toneMapped && (V === null || V.isXRRenderTarget === !0) && (St = y.toneMapping);
      const Mt = k.morphAttributes.position || k.morphAttributes.normal || k.morphAttributes.color, ut = Mt !== void 0 ? Mt.length : 0, Ae = _.get(B), ot = E.state.lights;
      if (xe === !0 && (tt === !0 || x !== X)) {
        const Vt = x === X && B.id === Y;
        _e.setState(B, x, Vt);
      }
      let it = !1;
      B.version === Ae.__version ? (Ae.needsLights && Ae.lightsStateVersion !== ot.state.version || Ae.outputColorSpace !== he || U.isBatchedMesh && Ae.batching === !1 || !U.isBatchedMesh && Ae.batching === !0 || U.isBatchedMesh && Ae.batchingColor === !0 && U.colorTexture === null || U.isBatchedMesh && Ae.batchingColor === !1 && U.colorTexture !== null || U.isInstancedMesh && Ae.instancing === !1 || !U.isInstancedMesh && Ae.instancing === !0 || U.isSkinnedMesh && Ae.skinning === !1 || !U.isSkinnedMesh && Ae.skinning === !0 || U.isInstancedMesh && Ae.instancingColor === !0 && U.instanceColor === null || U.isInstancedMesh && Ae.instancingColor === !1 && U.instanceColor !== null || U.isInstancedMesh && Ae.instancingMorph === !0 && U.morphTexture === null || U.isInstancedMesh && Ae.instancingMorph === !1 && U.morphTexture !== null || Ae.envMap !== ve || B.fog === !0 && Ae.fog !== oe || Ae.numClippingPlanes !== void 0 && (Ae.numClippingPlanes !== _e.numPlanes || Ae.numIntersection !== _e.numIntersection) || Ae.vertexAlphas !== Me || Ae.vertexTangents !== Re || Ae.morphTargets !== Ee || Ae.morphNormals !== qe || Ae.morphColors !== ht || Ae.toneMapping !== St || Ae.morphTargetsCount !== ut) && (it = !0) : (it = !0, Ae.__version = B.version);
      let Jt = Ae.currentProgram;
      it === !0 && (Jt = Hr(B, N, U));
      let as = !1, Qt = !1, Js = !1;
      const gt = Jt.getUniforms(), Xt = Ae.uniforms;
      if (be.useProgram(Jt.program) && (as = !0, Qt = !0, Js = !0), B.id !== Y && (Y = B.id, Qt = !0), as || X !== x) {
        be.buffers.depth.getReversed() && x.reversedDepth !== !0 && (x._reversedDepth = !0, x.updateProjectionMatrix()), gt.setValue(C, "projectionMatrix", x.projectionMatrix), gt.setValue(C, "viewMatrix", x.matrixWorldInverse);
        const jt = gt.map.cameraPosition;
        jt !== void 0 && jt.setValue(C, et.setFromMatrixPosition(x.matrixWorld)), pt.logarithmicDepthBuffer && gt.setValue(
          C,
          "logDepthBufFC",
          2 / (Math.log(x.far + 1) / Math.LN2)
        ), (B.isMeshPhongMaterial || B.isMeshToonMaterial || B.isMeshLambertMaterial || B.isMeshBasicMaterial || B.isMeshStandardMaterial || B.isShaderMaterial) && gt.setValue(C, "isOrthographic", x.isOrthographicCamera === !0), X !== x && (X = x, Qt = !0, Js = !0);
      }
      if (Ae.needsLights && (ot.state.directionalShadowMap.length > 0 && gt.setValue(C, "directionalShadowMap", ot.state.directionalShadowMap, L), ot.state.spotShadowMap.length > 0 && gt.setValue(C, "spotShadowMap", ot.state.spotShadowMap, L), ot.state.pointShadowMap.length > 0 && gt.setValue(C, "pointShadowMap", ot.state.pointShadowMap, L)), U.isSkinnedMesh) {
        gt.setOptional(C, U, "bindMatrix"), gt.setOptional(C, U, "bindMatrixInverse");
        const Vt = U.skeleton;
        Vt && (Vt.boneTexture === null && Vt.computeBoneTexture(), gt.setValue(C, "boneTexture", Vt.boneTexture, L));
      }
      U.isBatchedMesh && (gt.setOptional(C, U, "batchingTexture"), gt.setValue(C, "batchingTexture", U._matricesTexture, L), gt.setOptional(C, U, "batchingIdTexture"), gt.setValue(C, "batchingIdTexture", U._indirectTexture, L), gt.setOptional(C, U, "batchingColorTexture"), U._colorsTexture !== null && gt.setValue(C, "batchingColorTexture", U._colorsTexture, L));
      const hi = k.morphAttributes;
      if ((hi.position !== void 0 || hi.normal !== void 0 || hi.color !== void 0) && $e.update(U, k, Jt), (Qt || Ae.receiveShadow !== U.receiveShadow) && (Ae.receiveShadow = U.receiveShadow, gt.setValue(C, "receiveShadow", U.receiveShadow)), B.isMeshGouraudMaterial && B.envMap !== null && (Xt.envMap.value = ve, Xt.flipEnvMap.value = ve.isCubeTexture && ve.isRenderTargetTexture === !1 ? -1 : 1), B.isMeshStandardMaterial && B.envMap === null && N.environment !== null && (Xt.envMapIntensity.value = N.environmentIntensity), Xt.dfgLUT !== void 0 && (Xt.dfgLUT.value = Zw()), Qt && (gt.setValue(C, "toneMappingExposure", y.toneMappingExposure), Ae.needsLights && Of(Xt, Js), oe && B.fog === !0 && Pe.refreshFogUniforms(Xt, oe), Pe.refreshMaterialUniforms(Xt, B, Ve, Ge, E.state.transmissionRenderTarget[x.id]), Ia.upload(C, bh(Ae), Xt, L)), B.isShaderMaterial && B.uniformsNeedUpdate === !0 && (Ia.upload(C, bh(Ae), Xt, L), B.uniformsNeedUpdate = !1), B.isSpriteMaterial && gt.setValue(C, "center", U.center), gt.setValue(C, "modelViewMatrix", U.modelViewMatrix), gt.setValue(C, "normalMatrix", U.normalMatrix), gt.setValue(C, "modelMatrix", U.matrixWorld), B.isShaderMaterial || B.isRawShaderMaterial) {
        const Vt = B.uniformsGroups;
        for (let jt = 0, yo = Vt.length; jt < yo; jt++) {
          const Nn = Vt[jt];
          ee.update(Nn, Jt), ee.bind(Nn, Jt);
        }
      }
      return Jt;
    }
    function Of(x, N) {
      x.ambientLightColor.needsUpdate = N, x.lightProbe.needsUpdate = N, x.directionalLights.needsUpdate = N, x.directionalLightShadows.needsUpdate = N, x.pointLights.needsUpdate = N, x.pointLightShadows.needsUpdate = N, x.spotLights.needsUpdate = N, x.spotLightShadows.needsUpdate = N, x.rectAreaLights.needsUpdate = N, x.hemisphereLights.needsUpdate = N;
    }
    function Uf(x) {
      return x.isMeshLambertMaterial || x.isMeshToonMaterial || x.isMeshPhongMaterial || x.isMeshStandardMaterial || x.isShadowMaterial || x.isShaderMaterial && x.lights === !0;
    }
    this.getActiveCubeFace = function() {
      return P;
    }, this.getActiveMipmapLevel = function() {
      return H;
    }, this.getRenderTarget = function() {
      return V;
    }, this.setRenderTargetTextures = function(x, N, k) {
      const B = _.get(x);
      B.__autoAllocateDepthBuffer = x.resolveDepthBuffer === !1, B.__autoAllocateDepthBuffer === !1 && (B.__useRenderToTexture = !1), _.get(x.texture).__webglTexture = N, _.get(x.depthTexture).__webglTexture = B.__autoAllocateDepthBuffer ? void 0 : k, B.__hasExternalTextures = !0;
    }, this.setRenderTargetFramebuffer = function(x, N) {
      const k = _.get(x);
      k.__webglFramebuffer = N, k.__useDefaultFramebuffer = N === void 0;
    };
    const Ff = C.createFramebuffer();
    this.setRenderTarget = function(x, N = 0, k = 0) {
      V = x, P = N, H = k;
      let B = null, U = !1, oe = !1;
      if (x) {
        const he = _.get(x);
        if (he.__useDefaultFramebuffer !== void 0) {
          be.bindFramebuffer(C.FRAMEBUFFER, he.__webglFramebuffer), q.copy(x.viewport), z.copy(x.scissor), J = x.scissorTest, be.viewport(q), be.scissor(z), be.setScissorTest(J), Y = -1;
          return;
        } else if (he.__webglFramebuffer === void 0)
          L.setupRenderTarget(x);
        else if (he.__hasExternalTextures)
          L.rebindTextures(x, _.get(x.texture).__webglTexture, _.get(x.depthTexture).__webglTexture);
        else if (x.depthBuffer) {
          const Re = x.depthTexture;
          if (he.__boundDepthTexture !== Re) {
            if (Re !== null && _.has(Re) && (x.width !== Re.image.width || x.height !== Re.image.height))
              throw new Error("WebGLRenderTarget: Attached DepthTexture is initialized to the incorrect size.");
            L.setupDepthRenderbuffer(x);
          }
        }
        const ve = x.texture;
        (ve.isData3DTexture || ve.isDataArrayTexture || ve.isCompressedArrayTexture) && (oe = !0);
        const Me = _.get(x).__webglFramebuffer;
        x.isWebGLCubeRenderTarget ? (Array.isArray(Me[N]) ? B = Me[N][k] : B = Me[N], U = !0) : x.samples > 0 && L.useMultisampledRTT(x) === !1 ? B = _.get(x).__webglMultisampledFramebuffer : Array.isArray(Me) ? B = Me[k] : B = Me, q.copy(x.viewport), z.copy(x.scissor), J = x.scissorTest;
      } else
        q.copy(j).multiplyScalar(Ve).floor(), z.copy(Q).multiplyScalar(Ve).floor(), J = ge;
      if (k !== 0 && (B = Ff), be.bindFramebuffer(C.FRAMEBUFFER, B) && be.drawBuffers(x, B), be.viewport(q), be.scissor(z), be.setScissorTest(J), U) {
        const he = _.get(x.texture);
        C.framebufferTexture2D(C.FRAMEBUFFER, C.COLOR_ATTACHMENT0, C.TEXTURE_CUBE_MAP_POSITIVE_X + N, he.__webglTexture, k);
      } else if (oe) {
        const he = N;
        for (let ve = 0; ve < x.textures.length; ve++) {
          const Me = _.get(x.textures[ve]);
          C.framebufferTextureLayer(C.FRAMEBUFFER, C.COLOR_ATTACHMENT0 + ve, Me.__webglTexture, k, he);
        }
      } else if (x !== null && k !== 0) {
        const he = _.get(x.texture);
        C.framebufferTexture2D(C.FRAMEBUFFER, C.COLOR_ATTACHMENT0, C.TEXTURE_2D, he.__webglTexture, k);
      }
      Y = -1;
    }, this.readRenderTargetPixels = function(x, N, k, B, U, oe, me, he = 0) {
      if (!(x && x.isWebGLRenderTarget)) {
        Ce("WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
        return;
      }
      let ve = _.get(x).__webglFramebuffer;
      if (x.isWebGLCubeRenderTarget && me !== void 0 && (ve = ve[me]), ve) {
        be.bindFramebuffer(C.FRAMEBUFFER, ve);
        try {
          const Me = x.textures[he], Re = Me.format, Ee = Me.type;
          if (!pt.textureFormatReadable(Re)) {
            Ce("WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");
            return;
          }
          if (!pt.textureTypeReadable(Ee)) {
            Ce("WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");
            return;
          }
          N >= 0 && N <= x.width - B && k >= 0 && k <= x.height - U && (x.textures.length > 1 && C.readBuffer(C.COLOR_ATTACHMENT0 + he), C.readPixels(N, k, B, U, ie.convert(Re), ie.convert(Ee), oe));
        } finally {
          const Me = V !== null ? _.get(V).__webglFramebuffer : null;
          be.bindFramebuffer(C.FRAMEBUFFER, Me);
        }
      }
    }, this.readRenderTargetPixelsAsync = async function(x, N, k, B, U, oe, me, he = 0) {
      if (!(x && x.isWebGLRenderTarget))
        throw new Error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
      let ve = _.get(x).__webglFramebuffer;
      if (x.isWebGLCubeRenderTarget && me !== void 0 && (ve = ve[me]), ve)
        if (N >= 0 && N <= x.width - B && k >= 0 && k <= x.height - U) {
          be.bindFramebuffer(C.FRAMEBUFFER, ve);
          const Me = x.textures[he], Re = Me.format, Ee = Me.type;
          if (!pt.textureFormatReadable(Re))
            throw new Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in RGBA or implementation defined format.");
          if (!pt.textureTypeReadable(Ee))
            throw new Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in UnsignedByteType or implementation defined type.");
          const qe = C.createBuffer();
          C.bindBuffer(C.PIXEL_PACK_BUFFER, qe), C.bufferData(C.PIXEL_PACK_BUFFER, oe.byteLength, C.STREAM_READ), x.textures.length > 1 && C.readBuffer(C.COLOR_ATTACHMENT0 + he), C.readPixels(N, k, B, U, ie.convert(Re), ie.convert(Ee), 0);
          const ht = V !== null ? _.get(V).__webglFramebuffer : null;
          be.bindFramebuffer(C.FRAMEBUFFER, ht);
          const St = C.fenceSync(C.SYNC_GPU_COMMANDS_COMPLETE, 0);
          return C.flush(), await Mv(C, St, 4), C.bindBuffer(C.PIXEL_PACK_BUFFER, qe), C.getBufferSubData(C.PIXEL_PACK_BUFFER, 0, oe), C.deleteBuffer(qe), C.deleteSync(St), oe;
        } else
          throw new Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: requested read bounds are out of range.");
    }, this.copyFramebufferToTexture = function(x, N = null, k = 0) {
      const B = Math.pow(2, -k), U = Math.floor(x.image.width * B), oe = Math.floor(x.image.height * B), me = N !== null ? N.x : 0, he = N !== null ? N.y : 0;
      L.setTexture2D(x, 0), C.copyTexSubImage2D(C.TEXTURE_2D, k, 0, 0, me, he, U, oe), be.unbindTexture();
    };
    const Bf = C.createFramebuffer(), kf = C.createFramebuffer();
    this.copyTextureToTexture = function(x, N, k = null, B = null, U = 0, oe = null) {
      oe === null && (U !== 0 ? (Cr("WebGLRenderer: copyTextureToTexture function signature has changed to support src and dst mipmap levels."), oe = U, U = 0) : oe = 0);
      let me, he, ve, Me, Re, Ee, qe, ht, St;
      const Mt = x.isCompressedTexture ? x.mipmaps[oe] : x.image;
      if (k !== null)
        me = k.max.x - k.min.x, he = k.max.y - k.min.y, ve = k.isBox3 ? k.max.z - k.min.z : 1, Me = k.min.x, Re = k.min.y, Ee = k.isBox3 ? k.min.z : 0;
      else {
        const hi = Math.pow(2, -U);
        me = Math.floor(Mt.width * hi), he = Math.floor(Mt.height * hi), x.isDataArrayTexture ? ve = Mt.depth : x.isData3DTexture ? ve = Math.floor(Mt.depth * hi) : ve = 1, Me = 0, Re = 0, Ee = 0;
      }
      B !== null ? (qe = B.x, ht = B.y, St = B.z) : (qe = 0, ht = 0, St = 0);
      const ut = ie.convert(N.format), Ae = ie.convert(N.type);
      let ot;
      N.isData3DTexture ? (L.setTexture3D(N, 0), ot = C.TEXTURE_3D) : N.isDataArrayTexture || N.isCompressedArrayTexture ? (L.setTexture2DArray(N, 0), ot = C.TEXTURE_2D_ARRAY) : (L.setTexture2D(N, 0), ot = C.TEXTURE_2D), C.pixelStorei(C.UNPACK_FLIP_Y_WEBGL, N.flipY), C.pixelStorei(C.UNPACK_PREMULTIPLY_ALPHA_WEBGL, N.premultiplyAlpha), C.pixelStorei(C.UNPACK_ALIGNMENT, N.unpackAlignment);
      const it = C.getParameter(C.UNPACK_ROW_LENGTH), Jt = C.getParameter(C.UNPACK_IMAGE_HEIGHT), as = C.getParameter(C.UNPACK_SKIP_PIXELS), Qt = C.getParameter(C.UNPACK_SKIP_ROWS), Js = C.getParameter(C.UNPACK_SKIP_IMAGES);
      C.pixelStorei(C.UNPACK_ROW_LENGTH, Mt.width), C.pixelStorei(C.UNPACK_IMAGE_HEIGHT, Mt.height), C.pixelStorei(C.UNPACK_SKIP_PIXELS, Me), C.pixelStorei(C.UNPACK_SKIP_ROWS, Re), C.pixelStorei(C.UNPACK_SKIP_IMAGES, Ee);
      const gt = x.isDataArrayTexture || x.isData3DTexture, Xt = N.isDataArrayTexture || N.isData3DTexture;
      if (x.isDepthTexture) {
        const hi = _.get(x), Vt = _.get(N), jt = _.get(hi.__renderTarget), yo = _.get(Vt.__renderTarget);
        be.bindFramebuffer(C.READ_FRAMEBUFFER, jt.__webglFramebuffer), be.bindFramebuffer(C.DRAW_FRAMEBUFFER, yo.__webglFramebuffer);
        for (let Nn = 0; Nn < ve; Nn++)
          gt && (C.framebufferTextureLayer(C.READ_FRAMEBUFFER, C.COLOR_ATTACHMENT0, _.get(x).__webglTexture, U, Ee + Nn), C.framebufferTextureLayer(C.DRAW_FRAMEBUFFER, C.COLOR_ATTACHMENT0, _.get(N).__webglTexture, oe, St + Nn)), C.blitFramebuffer(Me, Re, me, he, qe, ht, me, he, C.DEPTH_BUFFER_BIT, C.NEAREST);
        be.bindFramebuffer(C.READ_FRAMEBUFFER, null), be.bindFramebuffer(C.DRAW_FRAMEBUFFER, null);
      } else if (U !== 0 || x.isRenderTargetTexture || _.has(x)) {
        const hi = _.get(x), Vt = _.get(N);
        be.bindFramebuffer(C.READ_FRAMEBUFFER, Bf), be.bindFramebuffer(C.DRAW_FRAMEBUFFER, kf);
        for (let jt = 0; jt < ve; jt++)
          gt ? C.framebufferTextureLayer(C.READ_FRAMEBUFFER, C.COLOR_ATTACHMENT0, hi.__webglTexture, U, Ee + jt) : C.framebufferTexture2D(C.READ_FRAMEBUFFER, C.COLOR_ATTACHMENT0, C.TEXTURE_2D, hi.__webglTexture, U), Xt ? C.framebufferTextureLayer(C.DRAW_FRAMEBUFFER, C.COLOR_ATTACHMENT0, Vt.__webglTexture, oe, St + jt) : C.framebufferTexture2D(C.DRAW_FRAMEBUFFER, C.COLOR_ATTACHMENT0, C.TEXTURE_2D, Vt.__webglTexture, oe), U !== 0 ? C.blitFramebuffer(Me, Re, me, he, qe, ht, me, he, C.COLOR_BUFFER_BIT, C.NEAREST) : Xt ? C.copyTexSubImage3D(ot, oe, qe, ht, St + jt, Me, Re, me, he) : C.copyTexSubImage2D(ot, oe, qe, ht, Me, Re, me, he);
        be.bindFramebuffer(C.READ_FRAMEBUFFER, null), be.bindFramebuffer(C.DRAW_FRAMEBUFFER, null);
      } else
        Xt ? x.isDataTexture || x.isData3DTexture ? C.texSubImage3D(ot, oe, qe, ht, St, me, he, ve, ut, Ae, Mt.data) : N.isCompressedArrayTexture ? C.compressedTexSubImage3D(ot, oe, qe, ht, St, me, he, ve, ut, Mt.data) : C.texSubImage3D(ot, oe, qe, ht, St, me, he, ve, ut, Ae, Mt) : x.isDataTexture ? C.texSubImage2D(C.TEXTURE_2D, oe, qe, ht, me, he, ut, Ae, Mt.data) : x.isCompressedTexture ? C.compressedTexSubImage2D(C.TEXTURE_2D, oe, qe, ht, Mt.width, Mt.height, ut, Mt.data) : C.texSubImage2D(C.TEXTURE_2D, oe, qe, ht, me, he, ut, Ae, Mt);
      C.pixelStorei(C.UNPACK_ROW_LENGTH, it), C.pixelStorei(C.UNPACK_IMAGE_HEIGHT, Jt), C.pixelStorei(C.UNPACK_SKIP_PIXELS, as), C.pixelStorei(C.UNPACK_SKIP_ROWS, Qt), C.pixelStorei(C.UNPACK_SKIP_IMAGES, Js), oe === 0 && N.generateMipmaps && C.generateMipmap(ot), be.unbindTexture();
    }, this.initRenderTarget = function(x) {
      _.get(x).__webglFramebuffer === void 0 && L.setupRenderTarget(x);
    }, this.initTexture = function(x) {
      x.isCubeTexture ? L.setTextureCube(x, 0) : x.isData3DTexture ? L.setTexture3D(x, 0) : x.isDataArrayTexture || x.isCompressedArrayTexture ? L.setTexture2DArray(x, 0) : L.setTexture2D(x, 0), be.unbindTexture();
    }, this.resetState = function() {
      P = 0, H = 0, V = null, be.reset(), pe.reset();
    }, typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", { detail: this }));
  }
  /**
   * Defines the coordinate system of the renderer.
   *
   * In `WebGLRenderer`, the value is always `WebGLCoordinateSystem`.
   *
   * @type {WebGLCoordinateSystem|WebGPUCoordinateSystem}
   * @default WebGLCoordinateSystem
   * @readonly
   */
  get coordinateSystem() {
    return Bi;
  }
  /**
   * Defines the output color space of the renderer.
   *
   * @type {SRGBColorSpace|LinearSRGBColorSpace}
   * @default SRGBColorSpace
   */
  get outputColorSpace() {
    return this._outputColorSpace;
  }
  set outputColorSpace(e) {
    this._outputColorSpace = e;
    const t = this.getContext();
    t.drawingBufferColorSpace = Ke._getDrawingBufferColorSpace(e), t.unpackColorSpace = Ke._getUnpackColorSpace();
  }
}
const ni = [
  {
    label: "",
    view: "front",
    // View doesn't matter for idle
    textAngle: 0,
    modelRotationY: 0,
    description: "",
    hidden: !0,
    isIdle: !0,
    header: {
      title: "<strong><em>Truth</em></strong> Powers <strong><em>Better Health</em></strong>",
      features: ["Full Disclosure, Always.", "No Proprietary Blends, Ever."],
      body: "Clean, science-backed supplements—so you can stop stressing and start living."
    }
  },
  {
    label: "Full Disclosure Labeling",
    view: "back",
    textAngle: 52,
    modelRotationY: 200,
    highlightWidth: 1,
    description: "Explore your favorite products—from ingredient functions and sources to version numbers and scientific support. Every label has a story, and we’re not keeping it to ourselves, even if that means sharing our formulas with the world.",
    callout: {
      start: { x: 0, y: 45 },
      horizontalLength: 205,
      cardYOffset: 60
    },
    header: {
      title: "<strong><em>What’s</em></strong> Inside & <strong><em>Why</em></strong>"
    }
  },
  {
    label: "No Proprietary Blends",
    view: "front",
    textAngle: 120,
    highlightWidth: 0.9,
    modelRotationY: 220,
    description: "At Vibrant Health, we never use proprietary blends because we believe you deserve to know exactly what’s in your supplements. Full transparency empowers you to make confident, informed choices about your health.",
    callout: {
      start: { x: 20, y: 52 },
      horizontalLength: 200,
      cardYOffset: 80
    },
    header: {
      title: "<strong><em>What’s</em></strong> Inside & <strong><em>Why</em></strong>"
    }
  },
  {
    label: "Non-GMO Certified",
    view: "left",
    textAngle: 182,
    highlightWidth: 0.8,
    modelRotationY: 0,
    description: "Our Non-GMO Certification reflects our commitment to clean, responsibly sourced ingredients. It ensures what you’re putting into your body is as close to nature as possible, without genetic modification.",
    callout: {
      start: { x: 7, y: -38 },
      horizontalLength: 200,
      cardYOffset: 30
    },
    header: {
      title: "<strong><em>What’s</em></strong> Inside & <strong><em>Why</em></strong>"
    }
  },
  {
    label: "Clinically Formulated",
    view: "left",
    textAngle: 242,
    highlightWidth: 0.9,
    modelRotationY: 350,
    description: "Our products are clinically formulated using science-backed ingredients and research. Green Vibrance has been continuously improved more than 50 times since 1992. Every refinement is driven by evolving research to deliver real, measurable results you can trust.",
    callout: {
      start: { x: 32, y: 105 },
      horizontalLength: 200,
      cardYOffset: 80
    },
    header: {
      title: "<em>What’s</em> Inside <em>& Why</em>"
    }
  },
  {
    label: "Most Award-Winning",
    view: "right",
    textAngle: 302,
    modelRotationY: 220,
    highlightWidth: 0.9,
    description: "With more than 60 industry awards, Vibrant Health is one of the most recognized brands in the natural products industry—honored for quality, innovation, and science-first formulation.",
    callout: {
      start: { x: 9, y: -140 },
      horizontalLength: 200,
      cardYOffset: 70
    },
    header: {
      title: "<strong><em>What’s</em></strong> Inside & <strong><em>Why</em></strong>"
    }
  },
  {
    label: "Made in USA",
    view: "right",
    textAngle: 356,
    modelRotationY: 0,
    highlightWidth: 0.7,
    description: "Our products are proudly made in the USA using the highest-quality ingredients sourced from trusted partners around the world. This approach ensures rigorous standards, exceptional quality, and globally informed formulations.",
    callout: {
      start: { x: 7, y: -90 },
      horizontalLength: 250,
      cardYOffset: 30
    },
    header: {
      title: "<strong><em>What’s</em></strong> Inside & <strong><em>Why</em></strong>"
    }
  },
  {
    label: "",
    view: "top",
    textAngle: 0,
    description: "",
    hidden: !0,
    header: {
      title: "<em>Dynamic</em> by Design<sup>TM</sup>",
      body: "Science doesn’t stand still, and neither should your health. Every 18–24 months, we collaborate with scientists and suppliers to review the latest research and upgrade our products, something we call formula obsolescence. That’s why you’ll always see version numbers on our packaging—it’s our promise to keep evolving."
      // ctaLabel: "Track Our Formula Updates",
      // ctaUrl: "#",
    },
    multiCallouts: [
      {
        label: "14",
        subLabel: "Anti-oxidants",
        start: { x: -50, y: -60 },
        end: { x: -300, y: -195 },
        horizontalLength: 40,
        align: "left"
      },
      {
        label: "12",
        subLabel: "Probiotic Strains",
        start: { x: -60, y: 60 },
        end: { x: -300, y: 165 },
        horizontalLength: 50,
        align: "left"
      },
      {
        label: "25",
        subLabel: "Billion Probiotics",
        start: { x: 70, y: -60 },
        end: { x: 325, y: -245 },
        horizontalLength: 110,
        align: "right"
      },
      {
        label: "65",
        subLabel: "Functional Foods",
        start: { x: 20, y: 40 },
        end: { x: 360, y: 65 },
        horizontalLength: 340,
        align: "right"
      }
    ]
  }
], Qw = 0, eS = ni.length - 1, Sf = Array.from(
  { length: ni.length - 2 },
  (s, e) => e + 1
), tS = ni[Qw].header, iS = ni[Sf[0]].header?.title ?? "What's Inside & Why", iu = Sf.map((s) => ({
  title: ni[s].label,
  text: ni[s].description
})), nS = ni[eS].header, sS = [
  { number: "14", text: "Antioxidants", threshold: 10 },
  { number: "65", text: "Functional<br>Foods", threshold: 35 },
  { number: "12", text: "Probiotic<br>Strains", threshold: 60 },
  { number: "25", text: "Billion<br>Probiotics", threshold: 85 }
];
function nu(s, e) {
  if (e === fv)
    return console.warn("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Geometry already defined as triangles."), s;
  if (e === lc || e === Yu) {
    let t = s.getIndex();
    if (t === null) {
      const a = [], o = s.getAttribute("position");
      if (o !== void 0) {
        for (let l = 0; l < o.count; l++)
          a.push(l);
        s.setIndex(a), t = s.getIndex();
      } else
        return console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Undefined position attribute. Processing not possible."), s;
    }
    const i = t.count - 2, n = [];
    if (e === lc)
      for (let a = 1; a <= i; a++)
        n.push(t.getX(0)), n.push(t.getX(a)), n.push(t.getX(a + 1));
    else
      for (let a = 0; a < i; a++)
        a % 2 === 0 ? (n.push(t.getX(a)), n.push(t.getX(a + 1)), n.push(t.getX(a + 2))) : (n.push(t.getX(a + 2)), n.push(t.getX(a + 1)), n.push(t.getX(a)));
    n.length / 3 !== i && console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unable to generate correct amount of triangles.");
    const r = s.clone();
    return r.setIndex(n), r.clearGroups(), r;
  } else
    return console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unknown draw mode:", e), s;
}
class rS extends js {
  /**
   * Constructs a new glTF loader.
   *
   * @param {LoadingManager} [manager] - The loading manager.
   */
  constructor(e) {
    super(e), this.dracoLoader = null, this.ktx2Loader = null, this.meshoptDecoder = null, this.pluginCallbacks = [], this.register(function(t) {
      return new hS(t);
    }), this.register(function(t) {
      return new dS(t);
    }), this.register(function(t) {
      return new yS(t);
    }), this.register(function(t) {
      return new bS(t);
    }), this.register(function(t) {
      return new wS(t);
    }), this.register(function(t) {
      return new fS(t);
    }), this.register(function(t) {
      return new pS(t);
    }), this.register(function(t) {
      return new mS(t);
    }), this.register(function(t) {
      return new gS(t);
    }), this.register(function(t) {
      return new cS(t);
    }), this.register(function(t) {
      return new vS(t);
    }), this.register(function(t) {
      return new uS(t);
    }), this.register(function(t) {
      return new xS(t);
    }), this.register(function(t) {
      return new _S(t);
    }), this.register(function(t) {
      return new oS(t);
    }), this.register(function(t) {
      return new SS(t);
    }), this.register(function(t) {
      return new MS(t);
    });
  }
  /**
   * Starts loading from the given URL and passes the loaded glTF asset
   * to the `onLoad()` callback.
   *
   * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
   * @param {function(GLTFLoader~LoadObject)} onLoad - Executed when the loading process has been finished.
   * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
   * @param {onErrorCallback} onError - Executed when errors occur.
   */
  load(e, t, i, n) {
    const r = this;
    let a;
    if (this.resourcePath !== "")
      a = this.resourcePath;
    else if (this.path !== "") {
      const c = gr.extractUrlBase(e);
      a = gr.resolveURL(c, this.path);
    } else
      a = gr.extractUrlBase(e);
    this.manager.itemStart(e);
    const o = function(c) {
      n ? n(c) : console.error(c), r.manager.itemError(e), r.manager.itemEnd(e);
    }, l = new mf(this.manager);
    l.setPath(this.path), l.setResponseType("arraybuffer"), l.setRequestHeader(this.requestHeader), l.setWithCredentials(this.withCredentials), l.load(e, function(c) {
      try {
        r.parse(c, a, function(h) {
          t(h), r.manager.itemEnd(e);
        }, o);
      } catch (h) {
        o(h);
      }
    }, i, o);
  }
  /**
   * Sets the given Draco loader to this loader. Required for decoding assets
   * compressed with the `KHR_draco_mesh_compression` extension.
   *
   * @param {DRACOLoader} dracoLoader - The Draco loader to set.
   * @return {GLTFLoader} A reference to this loader.
   */
  setDRACOLoader(e) {
    return this.dracoLoader = e, this;
  }
  /**
   * Sets the given KTX2 loader to this loader. Required for loading KTX2
   * compressed textures.
   *
   * @param {KTX2Loader} ktx2Loader - The KTX2 loader to set.
   * @return {GLTFLoader} A reference to this loader.
   */
  setKTX2Loader(e) {
    return this.ktx2Loader = e, this;
  }
  /**
   * Sets the given meshopt decoder. Required for decoding assets
   * compressed with the `EXT_meshopt_compression` extension.
   *
   * @param {Object} meshoptDecoder - The meshopt decoder to set.
   * @return {GLTFLoader} A reference to this loader.
   */
  setMeshoptDecoder(e) {
    return this.meshoptDecoder = e, this;
  }
  /**
   * Registers a plugin callback. This API is internally used to implement the various
   * glTF extensions but can also used by third-party code to add additional logic
   * to the loader.
   *
   * @param {function(parser:GLTFParser)} callback - The callback function to register.
   * @return {GLTFLoader} A reference to this loader.
   */
  register(e) {
    return this.pluginCallbacks.indexOf(e) === -1 && this.pluginCallbacks.push(e), this;
  }
  /**
   * Unregisters a plugin callback.
   *
   * @param {Function} callback - The callback function to unregister.
   * @return {GLTFLoader} A reference to this loader.
   */
  unregister(e) {
    return this.pluginCallbacks.indexOf(e) !== -1 && this.pluginCallbacks.splice(this.pluginCallbacks.indexOf(e), 1), this;
  }
  /**
   * Parses the given FBX data and returns the resulting group.
   *
   * @param {string|ArrayBuffer} data - The raw glTF data.
   * @param {string} path - The URL base path.
   * @param {function(GLTFLoader~LoadObject)} onLoad - Executed when the loading process has been finished.
   * @param {onErrorCallback} onError - Executed when errors occur.
   */
  parse(e, t, i, n) {
    let r;
    const a = {}, o = {}, l = new TextDecoder();
    if (typeof e == "string")
      r = JSON.parse(e);
    else if (e instanceof ArrayBuffer)
      if (l.decode(new Uint8Array(e, 0, 4)) === Mf) {
        try {
          a[je.KHR_BINARY_GLTF] = new TS(e);
        } catch (d) {
          n && n(d);
          return;
        }
        r = JSON.parse(a[je.KHR_BINARY_GLTF].content);
      } else
        r = JSON.parse(l.decode(e));
    else
      r = e;
    if (r.asset === void 0 || r.asset.version[0] < 2) {
      n && n(new Error("THREE.GLTFLoader: Unsupported asset. glTF versions >=2.0 are supported."));
      return;
    }
    const c = new BS(r, {
      path: t || this.resourcePath || "",
      crossOrigin: this.crossOrigin,
      requestHeader: this.requestHeader,
      manager: this.manager,
      ktx2Loader: this.ktx2Loader,
      meshoptDecoder: this.meshoptDecoder
    });
    c.fileLoader.setRequestHeader(this.requestHeader);
    for (let h = 0; h < this.pluginCallbacks.length; h++) {
      const d = this.pluginCallbacks[h](c);
      d.name || console.error("THREE.GLTFLoader: Invalid plugin found: missing name"), o[d.name] = d, a[d.name] = !0;
    }
    if (r.extensionsUsed)
      for (let h = 0; h < r.extensionsUsed.length; ++h) {
        const d = r.extensionsUsed[h], u = r.extensionsRequired || [];
        switch (d) {
          case je.KHR_MATERIALS_UNLIT:
            a[d] = new lS();
            break;
          case je.KHR_DRACO_MESH_COMPRESSION:
            a[d] = new ES(r, this.dracoLoader);
            break;
          case je.KHR_TEXTURE_TRANSFORM:
            a[d] = new AS();
            break;
          case je.KHR_MESH_QUANTIZATION:
            a[d] = new RS();
            break;
          default:
            u.indexOf(d) >= 0 && o[d] === void 0 && console.warn('THREE.GLTFLoader: Unknown extension "' + d + '".');
        }
      }
    c.setExtensions(a), c.setPlugins(o), c.parse(i, n);
  }
  /**
   * Async version of {@link GLTFLoader#parse}.
   *
   * @async
   * @param {string|ArrayBuffer} data - The raw glTF data.
   * @param {string} path - The URL base path.
   * @return {Promise<GLTFLoader~LoadObject>} A Promise that resolves with the loaded glTF when the parsing has been finished.
   */
  parseAsync(e, t) {
    const i = this;
    return new Promise(function(n, r) {
      i.parse(e, t, n, r);
    });
  }
}
function aS() {
  let s = {};
  return {
    get: function(e) {
      return s[e];
    },
    add: function(e, t) {
      s[e] = t;
    },
    remove: function(e) {
      delete s[e];
    },
    removeAll: function() {
      s = {};
    }
  };
}
const je = {
  KHR_BINARY_GLTF: "KHR_binary_glTF",
  KHR_DRACO_MESH_COMPRESSION: "KHR_draco_mesh_compression",
  KHR_LIGHTS_PUNCTUAL: "KHR_lights_punctual",
  KHR_MATERIALS_CLEARCOAT: "KHR_materials_clearcoat",
  KHR_MATERIALS_DISPERSION: "KHR_materials_dispersion",
  KHR_MATERIALS_IOR: "KHR_materials_ior",
  KHR_MATERIALS_SHEEN: "KHR_materials_sheen",
  KHR_MATERIALS_SPECULAR: "KHR_materials_specular",
  KHR_MATERIALS_TRANSMISSION: "KHR_materials_transmission",
  KHR_MATERIALS_IRIDESCENCE: "KHR_materials_iridescence",
  KHR_MATERIALS_ANISOTROPY: "KHR_materials_anisotropy",
  KHR_MATERIALS_UNLIT: "KHR_materials_unlit",
  KHR_MATERIALS_VOLUME: "KHR_materials_volume",
  KHR_TEXTURE_BASISU: "KHR_texture_basisu",
  KHR_TEXTURE_TRANSFORM: "KHR_texture_transform",
  KHR_MESH_QUANTIZATION: "KHR_mesh_quantization",
  KHR_MATERIALS_EMISSIVE_STRENGTH: "KHR_materials_emissive_strength",
  EXT_MATERIALS_BUMP: "EXT_materials_bump",
  EXT_TEXTURE_WEBP: "EXT_texture_webp",
  EXT_TEXTURE_AVIF: "EXT_texture_avif",
  EXT_MESHOPT_COMPRESSION: "EXT_meshopt_compression",
  EXT_MESH_GPU_INSTANCING: "EXT_mesh_gpu_instancing"
};
class oS {
  constructor(e) {
    this.parser = e, this.name = je.KHR_LIGHTS_PUNCTUAL, this.cache = { refs: {}, uses: {} };
  }
  _markDefs() {
    const e = this.parser, t = this.parser.json.nodes || [];
    for (let i = 0, n = t.length; i < n; i++) {
      const r = t[i];
      r.extensions && r.extensions[this.name] && r.extensions[this.name].light !== void 0 && e._addNodeRef(this.cache, r.extensions[this.name].light);
    }
  }
  _loadLight(e) {
    const t = this.parser, i = "light:" + e;
    let n = t.cache.get(i);
    if (n) return n;
    const r = t.json, l = ((r.extensions && r.extensions[this.name] || {}).lights || [])[e];
    let c;
    const h = new Ne(16777215);
    l.color !== void 0 && h.setRGB(l.color[0], l.color[1], l.color[2], Wt);
    const d = l.range !== void 0 ? l.range : 0;
    switch (l.type) {
      case "directional":
        c = new Ca(h), c.target.position.set(0, 0, -1), c.add(c.target);
        break;
      case "point":
        c = new k_(h), c.distance = d;
        break;
      case "spot":
        c = new F_(h), c.distance = d, l.spot = l.spot || {}, l.spot.innerConeAngle = l.spot.innerConeAngle !== void 0 ? l.spot.innerConeAngle : 0, l.spot.outerConeAngle = l.spot.outerConeAngle !== void 0 ? l.spot.outerConeAngle : Math.PI / 4, c.angle = l.spot.outerConeAngle, c.penumbra = 1 - l.spot.innerConeAngle / l.spot.outerConeAngle, c.target.position.set(0, 0, -1), c.add(c.target);
        break;
      default:
        throw new Error("THREE.GLTFLoader: Unexpected light type: " + l.type);
    }
    return c.position.set(0, 0, 0), Oi(c, l), l.intensity !== void 0 && (c.intensity = l.intensity), c.name = t.createUniqueName(l.name || "light_" + e), n = Promise.resolve(c), t.cache.add(i, n), n;
  }
  getDependency(e, t) {
    if (e === "light")
      return this._loadLight(t);
  }
  createNodeAttachment(e) {
    const t = this, i = this.parser, r = i.json.nodes[e], o = (r.extensions && r.extensions[this.name] || {}).light;
    return o === void 0 ? null : this._loadLight(o).then(function(l) {
      return i._getNodeRef(t.cache, o, l);
    });
  }
}
class lS {
  constructor() {
    this.name = je.KHR_MATERIALS_UNLIT;
  }
  getMaterialType() {
    return sn;
  }
  extendParams(e, t, i) {
    const n = [];
    e.color = new Ne(1, 1, 1), e.opacity = 1;
    const r = t.pbrMetallicRoughness;
    if (r) {
      if (Array.isArray(r.baseColorFactor)) {
        const a = r.baseColorFactor;
        e.color.setRGB(a[0], a[1], a[2], Wt), e.opacity = a[3];
      }
      r.baseColorTexture !== void 0 && n.push(i.assignTexture(e, "map", r.baseColorTexture, Ct));
    }
    return Promise.all(n);
  }
}
class cS {
  constructor(e) {
    this.parser = e, this.name = je.KHR_MATERIALS_EMISSIVE_STRENGTH;
  }
  extendMaterialParams(e, t) {
    const n = this.parser.json.materials[e];
    if (!n.extensions || !n.extensions[this.name])
      return Promise.resolve();
    const r = n.extensions[this.name].emissiveStrength;
    return r !== void 0 && (t.emissiveIntensity = r), Promise.resolve();
  }
}
class hS {
  constructor(e) {
    this.parser = e, this.name = je.KHR_MATERIALS_CLEARCOAT;
  }
  getMaterialType(e) {
    const i = this.parser.json.materials[e];
    return !i.extensions || !i.extensions[this.name] ? null : Xi;
  }
  extendMaterialParams(e, t) {
    const i = this.parser, n = i.json.materials[e];
    if (!n.extensions || !n.extensions[this.name])
      return Promise.resolve();
    const r = [], a = n.extensions[this.name];
    if (a.clearcoatFactor !== void 0 && (t.clearcoat = a.clearcoatFactor), a.clearcoatTexture !== void 0 && r.push(i.assignTexture(t, "clearcoatMap", a.clearcoatTexture)), a.clearcoatRoughnessFactor !== void 0 && (t.clearcoatRoughness = a.clearcoatRoughnessFactor), a.clearcoatRoughnessTexture !== void 0 && r.push(i.assignTexture(t, "clearcoatRoughnessMap", a.clearcoatRoughnessTexture)), a.clearcoatNormalTexture !== void 0 && (r.push(i.assignTexture(t, "clearcoatNormalMap", a.clearcoatNormalTexture)), a.clearcoatNormalTexture.scale !== void 0)) {
      const o = a.clearcoatNormalTexture.scale;
      t.clearcoatNormalScale = new Ye(o, o);
    }
    return Promise.all(r);
  }
}
class dS {
  constructor(e) {
    this.parser = e, this.name = je.KHR_MATERIALS_DISPERSION;
  }
  getMaterialType(e) {
    const i = this.parser.json.materials[e];
    return !i.extensions || !i.extensions[this.name] ? null : Xi;
  }
  extendMaterialParams(e, t) {
    const n = this.parser.json.materials[e];
    if (!n.extensions || !n.extensions[this.name])
      return Promise.resolve();
    const r = n.extensions[this.name];
    return t.dispersion = r.dispersion !== void 0 ? r.dispersion : 0, Promise.resolve();
  }
}
class uS {
  constructor(e) {
    this.parser = e, this.name = je.KHR_MATERIALS_IRIDESCENCE;
  }
  getMaterialType(e) {
    const i = this.parser.json.materials[e];
    return !i.extensions || !i.extensions[this.name] ? null : Xi;
  }
  extendMaterialParams(e, t) {
    const i = this.parser, n = i.json.materials[e];
    if (!n.extensions || !n.extensions[this.name])
      return Promise.resolve();
    const r = [], a = n.extensions[this.name];
    return a.iridescenceFactor !== void 0 && (t.iridescence = a.iridescenceFactor), a.iridescenceTexture !== void 0 && r.push(i.assignTexture(t, "iridescenceMap", a.iridescenceTexture)), a.iridescenceIor !== void 0 && (t.iridescenceIOR = a.iridescenceIor), t.iridescenceThicknessRange === void 0 && (t.iridescenceThicknessRange = [100, 400]), a.iridescenceThicknessMinimum !== void 0 && (t.iridescenceThicknessRange[0] = a.iridescenceThicknessMinimum), a.iridescenceThicknessMaximum !== void 0 && (t.iridescenceThicknessRange[1] = a.iridescenceThicknessMaximum), a.iridescenceThicknessTexture !== void 0 && r.push(i.assignTexture(t, "iridescenceThicknessMap", a.iridescenceThicknessTexture)), Promise.all(r);
  }
}
class fS {
  constructor(e) {
    this.parser = e, this.name = je.KHR_MATERIALS_SHEEN;
  }
  getMaterialType(e) {
    const i = this.parser.json.materials[e];
    return !i.extensions || !i.extensions[this.name] ? null : Xi;
  }
  extendMaterialParams(e, t) {
    const i = this.parser, n = i.json.materials[e];
    if (!n.extensions || !n.extensions[this.name])
      return Promise.resolve();
    const r = [];
    t.sheenColor = new Ne(0, 0, 0), t.sheenRoughness = 0, t.sheen = 1;
    const a = n.extensions[this.name];
    if (a.sheenColorFactor !== void 0) {
      const o = a.sheenColorFactor;
      t.sheenColor.setRGB(o[0], o[1], o[2], Wt);
    }
    return a.sheenRoughnessFactor !== void 0 && (t.sheenRoughness = a.sheenRoughnessFactor), a.sheenColorTexture !== void 0 && r.push(i.assignTexture(t, "sheenColorMap", a.sheenColorTexture, Ct)), a.sheenRoughnessTexture !== void 0 && r.push(i.assignTexture(t, "sheenRoughnessMap", a.sheenRoughnessTexture)), Promise.all(r);
  }
}
class pS {
  constructor(e) {
    this.parser = e, this.name = je.KHR_MATERIALS_TRANSMISSION;
  }
  getMaterialType(e) {
    const i = this.parser.json.materials[e];
    return !i.extensions || !i.extensions[this.name] ? null : Xi;
  }
  extendMaterialParams(e, t) {
    const i = this.parser, n = i.json.materials[e];
    if (!n.extensions || !n.extensions[this.name])
      return Promise.resolve();
    const r = [], a = n.extensions[this.name];
    return a.transmissionFactor !== void 0 && (t.transmission = a.transmissionFactor), a.transmissionTexture !== void 0 && r.push(i.assignTexture(t, "transmissionMap", a.transmissionTexture)), Promise.all(r);
  }
}
class mS {
  constructor(e) {
    this.parser = e, this.name = je.KHR_MATERIALS_VOLUME;
  }
  getMaterialType(e) {
    const i = this.parser.json.materials[e];
    return !i.extensions || !i.extensions[this.name] ? null : Xi;
  }
  extendMaterialParams(e, t) {
    const i = this.parser, n = i.json.materials[e];
    if (!n.extensions || !n.extensions[this.name])
      return Promise.resolve();
    const r = [], a = n.extensions[this.name];
    t.thickness = a.thicknessFactor !== void 0 ? a.thicknessFactor : 0, a.thicknessTexture !== void 0 && r.push(i.assignTexture(t, "thicknessMap", a.thicknessTexture)), t.attenuationDistance = a.attenuationDistance || 1 / 0;
    const o = a.attenuationColor || [1, 1, 1];
    return t.attenuationColor = new Ne().setRGB(o[0], o[1], o[2], Wt), Promise.all(r);
  }
}
class gS {
  constructor(e) {
    this.parser = e, this.name = je.KHR_MATERIALS_IOR;
  }
  getMaterialType(e) {
    const i = this.parser.json.materials[e];
    return !i.extensions || !i.extensions[this.name] ? null : Xi;
  }
  extendMaterialParams(e, t) {
    const n = this.parser.json.materials[e];
    if (!n.extensions || !n.extensions[this.name])
      return Promise.resolve();
    const r = n.extensions[this.name];
    return t.ior = r.ior !== void 0 ? r.ior : 1.5, Promise.resolve();
  }
}
class vS {
  constructor(e) {
    this.parser = e, this.name = je.KHR_MATERIALS_SPECULAR;
  }
  getMaterialType(e) {
    const i = this.parser.json.materials[e];
    return !i.extensions || !i.extensions[this.name] ? null : Xi;
  }
  extendMaterialParams(e, t) {
    const i = this.parser, n = i.json.materials[e];
    if (!n.extensions || !n.extensions[this.name])
      return Promise.resolve();
    const r = [], a = n.extensions[this.name];
    t.specularIntensity = a.specularFactor !== void 0 ? a.specularFactor : 1, a.specularTexture !== void 0 && r.push(i.assignTexture(t, "specularIntensityMap", a.specularTexture));
    const o = a.specularColorFactor || [1, 1, 1];
    return t.specularColor = new Ne().setRGB(o[0], o[1], o[2], Wt), a.specularColorTexture !== void 0 && r.push(i.assignTexture(t, "specularColorMap", a.specularColorTexture, Ct)), Promise.all(r);
  }
}
class _S {
  constructor(e) {
    this.parser = e, this.name = je.EXT_MATERIALS_BUMP;
  }
  getMaterialType(e) {
    const i = this.parser.json.materials[e];
    return !i.extensions || !i.extensions[this.name] ? null : Xi;
  }
  extendMaterialParams(e, t) {
    const i = this.parser, n = i.json.materials[e];
    if (!n.extensions || !n.extensions[this.name])
      return Promise.resolve();
    const r = [], a = n.extensions[this.name];
    return t.bumpScale = a.bumpFactor !== void 0 ? a.bumpFactor : 1, a.bumpTexture !== void 0 && r.push(i.assignTexture(t, "bumpMap", a.bumpTexture)), Promise.all(r);
  }
}
class xS {
  constructor(e) {
    this.parser = e, this.name = je.KHR_MATERIALS_ANISOTROPY;
  }
  getMaterialType(e) {
    const i = this.parser.json.materials[e];
    return !i.extensions || !i.extensions[this.name] ? null : Xi;
  }
  extendMaterialParams(e, t) {
    const i = this.parser, n = i.json.materials[e];
    if (!n.extensions || !n.extensions[this.name])
      return Promise.resolve();
    const r = [], a = n.extensions[this.name];
    return a.anisotropyStrength !== void 0 && (t.anisotropy = a.anisotropyStrength), a.anisotropyRotation !== void 0 && (t.anisotropyRotation = a.anisotropyRotation), a.anisotropyTexture !== void 0 && r.push(i.assignTexture(t, "anisotropyMap", a.anisotropyTexture)), Promise.all(r);
  }
}
class yS {
  constructor(e) {
    this.parser = e, this.name = je.KHR_TEXTURE_BASISU;
  }
  loadTexture(e) {
    const t = this.parser, i = t.json, n = i.textures[e];
    if (!n.extensions || !n.extensions[this.name])
      return null;
    const r = n.extensions[this.name], a = t.options.ktx2Loader;
    if (!a) {
      if (i.extensionsRequired && i.extensionsRequired.indexOf(this.name) >= 0)
        throw new Error("THREE.GLTFLoader: setKTX2Loader must be called before loading KTX2 textures");
      return null;
    }
    return t.loadTextureImage(e, r.source, a);
  }
}
class bS {
  constructor(e) {
    this.parser = e, this.name = je.EXT_TEXTURE_WEBP;
  }
  loadTexture(e) {
    const t = this.name, i = this.parser, n = i.json, r = n.textures[e];
    if (!r.extensions || !r.extensions[t])
      return null;
    const a = r.extensions[t], o = n.images[a.source];
    let l = i.textureLoader;
    if (o.uri) {
      const c = i.options.manager.getHandler(o.uri);
      c !== null && (l = c);
    }
    return i.loadTextureImage(e, a.source, l);
  }
}
class wS {
  constructor(e) {
    this.parser = e, this.name = je.EXT_TEXTURE_AVIF;
  }
  loadTexture(e) {
    const t = this.name, i = this.parser, n = i.json, r = n.textures[e];
    if (!r.extensions || !r.extensions[t])
      return null;
    const a = r.extensions[t], o = n.images[a.source];
    let l = i.textureLoader;
    if (o.uri) {
      const c = i.options.manager.getHandler(o.uri);
      c !== null && (l = c);
    }
    return i.loadTextureImage(e, a.source, l);
  }
}
class SS {
  constructor(e) {
    this.name = je.EXT_MESHOPT_COMPRESSION, this.parser = e;
  }
  loadBufferView(e) {
    const t = this.parser.json, i = t.bufferViews[e];
    if (i.extensions && i.extensions[this.name]) {
      const n = i.extensions[this.name], r = this.parser.getDependency("buffer", n.buffer), a = this.parser.options.meshoptDecoder;
      if (!a || !a.supported) {
        if (t.extensionsRequired && t.extensionsRequired.indexOf(this.name) >= 0)
          throw new Error("THREE.GLTFLoader: setMeshoptDecoder must be called before loading compressed files");
        return null;
      }
      return r.then(function(o) {
        const l = n.byteOffset || 0, c = n.byteLength || 0, h = n.count, d = n.byteStride, u = new Uint8Array(o, l, c);
        return a.decodeGltfBufferAsync ? a.decodeGltfBufferAsync(h, d, u, n.mode, n.filter).then(function(f) {
          return f.buffer;
        }) : a.ready.then(function() {
          const f = new ArrayBuffer(h * d);
          return a.decodeGltfBuffer(new Uint8Array(f), h, d, u, n.mode, n.filter), f;
        });
      });
    } else
      return null;
  }
}
class MS {
  constructor(e) {
    this.name = je.EXT_MESH_GPU_INSTANCING, this.parser = e;
  }
  createNodeMesh(e) {
    const t = this.parser.json, i = t.nodes[e];
    if (!i.extensions || !i.extensions[this.name] || i.mesh === void 0)
      return null;
    const n = t.meshes[i.mesh];
    for (const c of n.primitives)
      if (c.mode !== ui.TRIANGLES && c.mode !== ui.TRIANGLE_STRIP && c.mode !== ui.TRIANGLE_FAN && c.mode !== void 0)
        return null;
    const a = i.extensions[this.name].attributes, o = [], l = {};
    for (const c in a)
      o.push(this.parser.getDependency("accessor", a[c]).then((h) => (l[c] = h, l[c])));
    return o.length < 1 ? null : (o.push(this.parser.createNodeMesh(e)), Promise.all(o).then((c) => {
      const h = c.pop(), d = h.isGroup ? h.children : [h], u = c[0].count, f = [];
      for (const g of d) {
        const v = new ze(), m = new O(), p = new si(), w = new O(1, 1, 1), M = new m_(g.geometry, g.material, u);
        for (let T = 0; T < u; T++)
          l.TRANSLATION && m.fromBufferAttribute(l.TRANSLATION, T), l.ROTATION && p.fromBufferAttribute(l.ROTATION, T), l.SCALE && w.fromBufferAttribute(l.SCALE, T), M.setMatrixAt(T, v.compose(m, p, w));
        for (const T in l)
          if (T === "_COLOR_0") {
            const E = l[T];
            M.instanceColor = new dc(E.array, E.itemSize, E.normalized);
          } else T !== "TRANSLATION" && T !== "ROTATION" && T !== "SCALE" && g.geometry.setAttribute(T, l[T]);
        wt.prototype.copy.call(M, g), this.parser.assignFinalMaterial(M), f.push(M);
      }
      return h.isGroup ? (h.clear(), h.add(...f), h) : f[0];
    }));
  }
}
const Mf = "glTF", cr = 12, su = { JSON: 1313821514, BIN: 5130562 };
class TS {
  constructor(e) {
    this.name = je.KHR_BINARY_GLTF, this.content = null, this.body = null;
    const t = new DataView(e, 0, cr), i = new TextDecoder();
    if (this.header = {
      magic: i.decode(new Uint8Array(e.slice(0, 4))),
      version: t.getUint32(4, !0),
      length: t.getUint32(8, !0)
    }, this.header.magic !== Mf)
      throw new Error("THREE.GLTFLoader: Unsupported glTF-Binary header.");
    if (this.header.version < 2)
      throw new Error("THREE.GLTFLoader: Legacy binary file detected.");
    const n = this.header.length - cr, r = new DataView(e, cr);
    let a = 0;
    for (; a < n; ) {
      const o = r.getUint32(a, !0);
      a += 4;
      const l = r.getUint32(a, !0);
      if (a += 4, l === su.JSON) {
        const c = new Uint8Array(e, cr + a, o);
        this.content = i.decode(c);
      } else if (l === su.BIN) {
        const c = cr + a;
        this.body = e.slice(c, c + o);
      }
      a += o;
    }
    if (this.content === null)
      throw new Error("THREE.GLTFLoader: JSON content not found.");
  }
}
class ES {
  constructor(e, t) {
    if (!t)
      throw new Error("THREE.GLTFLoader: No DRACOLoader instance provided.");
    this.name = je.KHR_DRACO_MESH_COMPRESSION, this.json = e, this.dracoLoader = t, this.dracoLoader.preload();
  }
  decodePrimitive(e, t) {
    const i = this.json, n = this.dracoLoader, r = e.extensions[this.name].bufferView, a = e.extensions[this.name].attributes, o = {}, l = {}, c = {};
    for (const h in a) {
      const d = gc[h] || h.toLowerCase();
      o[d] = a[h];
    }
    for (const h in e.attributes) {
      const d = gc[h] || h.toLowerCase();
      if (a[h] !== void 0) {
        const u = i.accessors[e.attributes[h]], f = As[u.componentType];
        c[d] = f.name, l[d] = u.normalized === !0;
      }
    }
    return t.getDependency("bufferView", r).then(function(h) {
      return new Promise(function(d, u) {
        n.decodeDracoFile(h, function(f) {
          for (const g in f.attributes) {
            const v = f.attributes[g], m = l[g];
            m !== void 0 && (v.normalized = m);
          }
          d(f);
        }, o, c, Wt, u);
      });
    });
  }
}
class AS {
  constructor() {
    this.name = je.KHR_TEXTURE_TRANSFORM;
  }
  extendTexture(e, t) {
    return (t.texCoord === void 0 || t.texCoord === e.channel) && t.offset === void 0 && t.rotation === void 0 && t.scale === void 0 || (e = e.clone(), t.texCoord !== void 0 && (e.channel = t.texCoord), t.offset !== void 0 && e.offset.fromArray(t.offset), t.rotation !== void 0 && (e.rotation = t.rotation), t.scale !== void 0 && e.repeat.fromArray(t.scale), e.needsUpdate = !0), e;
  }
}
class RS {
  constructor() {
    this.name = je.KHR_MESH_QUANTIZATION;
  }
}
class Tf extends kr {
  constructor(e, t, i, n) {
    super(e, t, i, n);
  }
  copySampleValue_(e) {
    const t = this.resultBuffer, i = this.sampleValues, n = this.valueSize, r = e * n * 3 + n;
    for (let a = 0; a !== n; a++)
      t[a] = i[r + a];
    return t;
  }
  interpolate_(e, t, i, n) {
    const r = this.resultBuffer, a = this.sampleValues, o = this.valueSize, l = o * 2, c = o * 3, h = n - t, d = (i - t) / h, u = d * d, f = u * d, g = e * c, v = g - c, m = -2 * f + 3 * u, p = f - u, w = 1 - m, M = p - u + d;
    for (let T = 0; T !== o; T++) {
      const E = a[v + T + o], A = a[v + T + l] * h, R = a[g + T + o], F = a[g + T] * h;
      r[T] = w * E + M * A + m * R + p * F;
    }
    return r;
  }
}
const CS = new si();
class IS extends Tf {
  interpolate_(e, t, i, n) {
    const r = super.interpolate_(e, t, i, n);
    return CS.fromArray(r).normalize().toArray(r), r;
  }
}
const ui = {
  POINTS: 0,
  LINES: 1,
  LINE_LOOP: 2,
  LINE_STRIP: 3,
  TRIANGLES: 4,
  TRIANGLE_STRIP: 5,
  TRIANGLE_FAN: 6
}, As = {
  5120: Int8Array,
  5121: Uint8Array,
  5122: Int16Array,
  5123: Uint16Array,
  5125: Uint32Array,
  5126: Float32Array
}, ru = {
  9728: It,
  9729: bt,
  9984: Hu,
  9985: Ma,
  9986: dr,
  9987: nn
}, au = {
  33071: Fi,
  33648: Ha,
  10497: Us
}, il = {
  SCALAR: 1,
  VEC2: 2,
  VEC3: 3,
  VEC4: 4,
  MAT2: 4,
  MAT3: 9,
  MAT4: 16
}, gc = {
  POSITION: "position",
  NORMAL: "normal",
  TANGENT: "tangent",
  TEXCOORD_0: "uv",
  TEXCOORD_1: "uv1",
  TEXCOORD_2: "uv2",
  TEXCOORD_3: "uv3",
  COLOR_0: "color",
  WEIGHTS_0: "skinWeight",
  JOINTS_0: "skinIndex"
}, bn = {
  scale: "scale",
  translation: "position",
  rotation: "quaternion",
  weights: "morphTargetInfluences"
}, PS = {
  CUBICSPLINE: void 0,
  // We use a custom interpolant (GLTFCubicSplineInterpolation) for CUBICSPLINE tracks. Each
  // keyframe track will be initialized with a default interpolation type, then modified.
  LINEAR: Ar,
  STEP: Er
}, nl = {
  OPAQUE: "OPAQUE",
  MASK: "MASK",
  BLEND: "BLEND"
};
function LS(s) {
  return s.DefaultMaterial === void 0 && (s.DefaultMaterial = new Pr({
    color: 16777215,
    emissive: 0,
    metalness: 1,
    roughness: 1,
    transparent: !1,
    depthTest: !0,
    side: hn
  })), s.DefaultMaterial;
}
function Gn(s, e, t) {
  for (const i in t.extensions)
    s[i] === void 0 && (e.userData.gltfExtensions = e.userData.gltfExtensions || {}, e.userData.gltfExtensions[i] = t.extensions[i]);
}
function Oi(s, e) {
  e.extras !== void 0 && (typeof e.extras == "object" ? Object.assign(s.userData, e.extras) : console.warn("THREE.GLTFLoader: Ignoring primitive type .extras, " + e.extras));
}
function DS(s, e, t) {
  let i = !1, n = !1, r = !1;
  for (let c = 0, h = e.length; c < h; c++) {
    const d = e[c];
    if (d.POSITION !== void 0 && (i = !0), d.NORMAL !== void 0 && (n = !0), d.COLOR_0 !== void 0 && (r = !0), i && n && r) break;
  }
  if (!i && !n && !r) return Promise.resolve(s);
  const a = [], o = [], l = [];
  for (let c = 0, h = e.length; c < h; c++) {
    const d = e[c];
    if (i) {
      const u = d.POSITION !== void 0 ? t.getDependency("accessor", d.POSITION) : s.attributes.position;
      a.push(u);
    }
    if (n) {
      const u = d.NORMAL !== void 0 ? t.getDependency("accessor", d.NORMAL) : s.attributes.normal;
      o.push(u);
    }
    if (r) {
      const u = d.COLOR_0 !== void 0 ? t.getDependency("accessor", d.COLOR_0) : s.attributes.color;
      l.push(u);
    }
  }
  return Promise.all([
    Promise.all(a),
    Promise.all(o),
    Promise.all(l)
  ]).then(function(c) {
    const h = c[0], d = c[1], u = c[2];
    return i && (s.morphAttributes.position = h), n && (s.morphAttributes.normal = d), r && (s.morphAttributes.color = u), s.morphTargetsRelative = !0, s;
  });
}
function NS(s, e) {
  if (s.updateMorphTargets(), e.weights !== void 0)
    for (let t = 0, i = e.weights.length; t < i; t++)
      s.morphTargetInfluences[t] = e.weights[t];
  if (e.extras && Array.isArray(e.extras.targetNames)) {
    const t = e.extras.targetNames;
    if (s.morphTargetInfluences.length === t.length) {
      s.morphTargetDictionary = {};
      for (let i = 0, n = t.length; i < n; i++)
        s.morphTargetDictionary[t[i]] = i;
    } else
      console.warn("THREE.GLTFLoader: Invalid extras.targetNames length. Ignoring names.");
  }
}
function OS(s) {
  let e;
  const t = s.extensions && s.extensions[je.KHR_DRACO_MESH_COMPRESSION];
  if (t ? e = "draco:" + t.bufferView + ":" + t.indices + ":" + sl(t.attributes) : e = s.indices + ":" + sl(s.attributes) + ":" + s.mode, s.targets !== void 0)
    for (let i = 0, n = s.targets.length; i < n; i++)
      e += ":" + sl(s.targets[i]);
  return e;
}
function sl(s) {
  let e = "";
  const t = Object.keys(s).sort();
  for (let i = 0, n = t.length; i < n; i++)
    e += t[i] + ":" + s[t[i]] + ";";
  return e;
}
function vc(s) {
  switch (s) {
    case Int8Array:
      return 1 / 127;
    case Uint8Array:
      return 1 / 255;
    case Int16Array:
      return 1 / 32767;
    case Uint16Array:
      return 1 / 65535;
    default:
      throw new Error("THREE.GLTFLoader: Unsupported normalized accessor component type.");
  }
}
function US(s) {
  return s.search(/\.jpe?g($|\?)/i) > 0 || s.search(/^data\:image\/jpeg/) === 0 ? "image/jpeg" : s.search(/\.webp($|\?)/i) > 0 || s.search(/^data\:image\/webp/) === 0 ? "image/webp" : s.search(/\.ktx2($|\?)/i) > 0 || s.search(/^data\:image\/ktx2/) === 0 ? "image/ktx2" : "image/png";
}
const FS = new ze();
class BS {
  constructor(e = {}, t = {}) {
    this.json = e, this.extensions = {}, this.plugins = {}, this.options = t, this.cache = new aS(), this.associations = /* @__PURE__ */ new Map(), this.primitiveCache = {}, this.nodeCache = {}, this.meshCache = { refs: {}, uses: {} }, this.cameraCache = { refs: {}, uses: {} }, this.lightCache = { refs: {}, uses: {} }, this.sourceCache = {}, this.textureCache = {}, this.nodeNamesUsed = {};
    let i = !1, n = -1, r = !1, a = -1;
    if (typeof navigator < "u") {
      const o = navigator.userAgent;
      i = /^((?!chrome|android).)*safari/i.test(o) === !0;
      const l = o.match(/Version\/(\d+)/);
      n = i && l ? parseInt(l[1], 10) : -1, r = o.indexOf("Firefox") > -1, a = r ? o.match(/Firefox\/([0-9]+)\./)[1] : -1;
    }
    typeof createImageBitmap > "u" || i && n < 17 || r && a < 98 ? this.textureLoader = new gf(this.options.manager) : this.textureLoader = new H_(this.options.manager), this.textureLoader.setCrossOrigin(this.options.crossOrigin), this.textureLoader.setRequestHeader(this.options.requestHeader), this.fileLoader = new mf(this.options.manager), this.fileLoader.setResponseType("arraybuffer"), this.options.crossOrigin === "use-credentials" && this.fileLoader.setWithCredentials(!0);
  }
  setExtensions(e) {
    this.extensions = e;
  }
  setPlugins(e) {
    this.plugins = e;
  }
  parse(e, t) {
    const i = this, n = this.json, r = this.extensions;
    this.cache.removeAll(), this.nodeCache = {}, this._invokeAll(function(a) {
      return a._markDefs && a._markDefs();
    }), Promise.all(this._invokeAll(function(a) {
      return a.beforeRoot && a.beforeRoot();
    })).then(function() {
      return Promise.all([
        i.getDependencies("scene"),
        i.getDependencies("animation"),
        i.getDependencies("camera")
      ]);
    }).then(function(a) {
      const o = {
        scene: a[0][n.scene || 0],
        scenes: a[0],
        animations: a[1],
        cameras: a[2],
        asset: n.asset,
        parser: i,
        userData: {}
      };
      return Gn(r, o, n), Oi(o, n), Promise.all(i._invokeAll(function(l) {
        return l.afterRoot && l.afterRoot(o);
      })).then(function() {
        for (const l of o.scenes)
          l.updateMatrixWorld();
        e(o);
      });
    }).catch(t);
  }
  /**
   * Marks the special nodes/meshes in json for efficient parse.
   *
   * @private
   */
  _markDefs() {
    const e = this.json.nodes || [], t = this.json.skins || [], i = this.json.meshes || [];
    for (let n = 0, r = t.length; n < r; n++) {
      const a = t[n].joints;
      for (let o = 0, l = a.length; o < l; o++)
        e[a[o]].isBone = !0;
    }
    for (let n = 0, r = e.length; n < r; n++) {
      const a = e[n];
      a.mesh !== void 0 && (this._addNodeRef(this.meshCache, a.mesh), a.skin !== void 0 && (i[a.mesh].isSkinnedMesh = !0)), a.camera !== void 0 && this._addNodeRef(this.cameraCache, a.camera);
    }
  }
  /**
   * Counts references to shared node / Object3D resources. These resources
   * can be reused, or "instantiated", at multiple nodes in the scene
   * hierarchy. Mesh, Camera, and Light instances are instantiated and must
   * be marked. Non-scenegraph resources (like Materials, Geometries, and
   * Textures) can be reused directly and are not marked here.
   *
   * Example: CesiumMilkTruck sample model reuses "Wheel" meshes.
   *
   * @private
   * @param {Object} cache
   * @param {Object3D} index
   */
  _addNodeRef(e, t) {
    t !== void 0 && (e.refs[t] === void 0 && (e.refs[t] = e.uses[t] = 0), e.refs[t]++);
  }
  /**
   * Returns a reference to a shared resource, cloning it if necessary.
   *
   * @private
   * @param {Object} cache
   * @param {number} index
   * @param {Object} object
   * @return {Object}
   */
  _getNodeRef(e, t, i) {
    if (e.refs[t] <= 1) return i;
    const n = i.clone(), r = (a, o) => {
      const l = this.associations.get(a);
      l != null && this.associations.set(o, l);
      for (const [c, h] of a.children.entries())
        r(h, o.children[c]);
    };
    return r(i, n), n.name += "_instance_" + e.uses[t]++, n;
  }
  _invokeOne(e) {
    const t = Object.values(this.plugins);
    t.push(this);
    for (let i = 0; i < t.length; i++) {
      const n = e(t[i]);
      if (n) return n;
    }
    return null;
  }
  _invokeAll(e) {
    const t = Object.values(this.plugins);
    t.unshift(this);
    const i = [];
    for (let n = 0; n < t.length; n++) {
      const r = e(t[n]);
      r && i.push(r);
    }
    return i;
  }
  /**
   * Requests the specified dependency asynchronously, with caching.
   *
   * @private
   * @param {string} type
   * @param {number} index
   * @return {Promise<Object3D|Material|Texture|AnimationClip|ArrayBuffer|Object>}
   */
  getDependency(e, t) {
    const i = e + ":" + t;
    let n = this.cache.get(i);
    if (!n) {
      switch (e) {
        case "scene":
          n = this.loadScene(t);
          break;
        case "node":
          n = this._invokeOne(function(r) {
            return r.loadNode && r.loadNode(t);
          });
          break;
        case "mesh":
          n = this._invokeOne(function(r) {
            return r.loadMesh && r.loadMesh(t);
          });
          break;
        case "accessor":
          n = this.loadAccessor(t);
          break;
        case "bufferView":
          n = this._invokeOne(function(r) {
            return r.loadBufferView && r.loadBufferView(t);
          });
          break;
        case "buffer":
          n = this.loadBuffer(t);
          break;
        case "material":
          n = this._invokeOne(function(r) {
            return r.loadMaterial && r.loadMaterial(t);
          });
          break;
        case "texture":
          n = this._invokeOne(function(r) {
            return r.loadTexture && r.loadTexture(t);
          });
          break;
        case "skin":
          n = this.loadSkin(t);
          break;
        case "animation":
          n = this._invokeOne(function(r) {
            return r.loadAnimation && r.loadAnimation(t);
          });
          break;
        case "camera":
          n = this.loadCamera(t);
          break;
        default:
          if (n = this._invokeOne(function(r) {
            return r != this && r.getDependency && r.getDependency(e, t);
          }), !n)
            throw new Error("Unknown type: " + e);
          break;
      }
      this.cache.add(i, n);
    }
    return n;
  }
  /**
   * Requests all dependencies of the specified type asynchronously, with caching.
   *
   * @private
   * @param {string} type
   * @return {Promise<Array<Object>>}
   */
  getDependencies(e) {
    let t = this.cache.get(e);
    if (!t) {
      const i = this, n = this.json[e + (e === "mesh" ? "es" : "s")] || [];
      t = Promise.all(n.map(function(r, a) {
        return i.getDependency(e, a);
      })), this.cache.add(e, t);
    }
    return t;
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
   *
   * @private
   * @param {number} bufferIndex
   * @return {Promise<ArrayBuffer>}
   */
  loadBuffer(e) {
    const t = this.json.buffers[e], i = this.fileLoader;
    if (t.type && t.type !== "arraybuffer")
      throw new Error("THREE.GLTFLoader: " + t.type + " buffer type is not supported.");
    if (t.uri === void 0 && e === 0)
      return Promise.resolve(this.extensions[je.KHR_BINARY_GLTF].body);
    const n = this.options;
    return new Promise(function(r, a) {
      i.load(gr.resolveURL(t.uri, n.path), r, void 0, function() {
        a(new Error('THREE.GLTFLoader: Failed to load buffer "' + t.uri + '".'));
      });
    });
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
   *
   * @private
   * @param {number} bufferViewIndex
   * @return {Promise<ArrayBuffer>}
   */
  loadBufferView(e) {
    const t = this.json.bufferViews[e];
    return this.getDependency("buffer", t.buffer).then(function(i) {
      const n = t.byteLength || 0, r = t.byteOffset || 0;
      return i.slice(r, r + n);
    });
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#accessors
   *
   * @private
   * @param {number} accessorIndex
   * @return {Promise<BufferAttribute|InterleavedBufferAttribute>}
   */
  loadAccessor(e) {
    const t = this, i = this.json, n = this.json.accessors[e];
    if (n.bufferView === void 0 && n.sparse === void 0) {
      const a = il[n.type], o = As[n.componentType], l = n.normalized === !0, c = new o(n.count * a);
      return Promise.resolve(new qt(c, a, l));
    }
    const r = [];
    return n.bufferView !== void 0 ? r.push(this.getDependency("bufferView", n.bufferView)) : r.push(null), n.sparse !== void 0 && (r.push(this.getDependency("bufferView", n.sparse.indices.bufferView)), r.push(this.getDependency("bufferView", n.sparse.values.bufferView))), Promise.all(r).then(function(a) {
      const o = a[0], l = il[n.type], c = As[n.componentType], h = c.BYTES_PER_ELEMENT, d = h * l, u = n.byteOffset || 0, f = n.bufferView !== void 0 ? i.bufferViews[n.bufferView].byteStride : void 0, g = n.normalized === !0;
      let v, m;
      if (f && f !== d) {
        const p = Math.floor(u / f), w = "InterleavedBuffer:" + n.bufferView + ":" + n.componentType + ":" + p + ":" + n.count;
        let M = t.cache.get(w);
        M || (v = new c(o, p * f, n.count * f / h), M = new h_(v, f / h), t.cache.add(w, M)), m = new Qc(M, l, u % f / h, g);
      } else
        o === null ? v = new c(n.count * l) : v = new c(o, u, n.count * l), m = new qt(v, l, g);
      if (n.sparse !== void 0) {
        const p = il.SCALAR, w = As[n.sparse.indices.componentType], M = n.sparse.indices.byteOffset || 0, T = n.sparse.values.byteOffset || 0, E = new w(a[1], M, n.sparse.count * p), A = new c(a[2], T, n.sparse.count * l);
        o !== null && (m = new qt(m.array.slice(), m.itemSize, m.normalized)), m.normalized = !1;
        for (let R = 0, F = E.length; R < F; R++) {
          const y = E[R];
          if (m.setX(y, A[R * l]), l >= 2 && m.setY(y, A[R * l + 1]), l >= 3 && m.setZ(y, A[R * l + 2]), l >= 4 && m.setW(y, A[R * l + 3]), l >= 5) throw new Error("THREE.GLTFLoader: Unsupported itemSize in sparse BufferAttribute.");
        }
        m.normalized = g;
      }
      return m;
    });
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#textures
   *
   * @private
   * @param {number} textureIndex
   * @return {Promise<?Texture>}
   */
  loadTexture(e) {
    const t = this.json, i = this.options, r = t.textures[e].source, a = t.images[r];
    let o = this.textureLoader;
    if (a.uri) {
      const l = i.manager.getHandler(a.uri);
      l !== null && (o = l);
    }
    return this.loadTextureImage(e, r, o);
  }
  loadTextureImage(e, t, i) {
    const n = this, r = this.json, a = r.textures[e], o = r.images[t], l = (o.uri || o.bufferView) + ":" + a.sampler;
    if (this.textureCache[l])
      return this.textureCache[l];
    const c = this.loadImageSource(t, i).then(function(h) {
      h.flipY = !1, h.name = a.name || o.name || "", h.name === "" && typeof o.uri == "string" && o.uri.startsWith("data:image/") === !1 && (h.name = o.uri);
      const u = (r.samplers || {})[a.sampler] || {};
      return h.magFilter = ru[u.magFilter] || bt, h.minFilter = ru[u.minFilter] || nn, h.wrapS = au[u.wrapS] || Us, h.wrapT = au[u.wrapT] || Us, h.generateMipmaps = !h.isCompressedTexture && h.minFilter !== It && h.minFilter !== bt, n.associations.set(h, { textures: e }), h;
    }).catch(function() {
      return null;
    });
    return this.textureCache[l] = c, c;
  }
  loadImageSource(e, t) {
    const i = this, n = this.json, r = this.options;
    if (this.sourceCache[e] !== void 0)
      return this.sourceCache[e].then((d) => d.clone());
    const a = n.images[e], o = self.URL || self.webkitURL;
    let l = a.uri || "", c = !1;
    if (a.bufferView !== void 0)
      l = i.getDependency("bufferView", a.bufferView).then(function(d) {
        c = !0;
        const u = new Blob([d], { type: a.mimeType });
        return l = o.createObjectURL(u), l;
      });
    else if (a.uri === void 0)
      throw new Error("THREE.GLTFLoader: Image " + e + " is missing URI and bufferView");
    const h = Promise.resolve(l).then(function(d) {
      return new Promise(function(u, f) {
        let g = u;
        t.isImageBitmapLoader === !0 && (g = function(v) {
          const m = new Ot(v);
          m.needsUpdate = !0, u(m);
        }), t.load(gr.resolveURL(d, r.path), g, void 0, f);
      });
    }).then(function(d) {
      return c === !0 && o.revokeObjectURL(l), Oi(d, a), d.userData.mimeType = a.mimeType || US(a.uri), d;
    }).catch(function(d) {
      throw console.error("THREE.GLTFLoader: Couldn't load texture", l), d;
    });
    return this.sourceCache[e] = h, h;
  }
  /**
   * Asynchronously assigns a texture to the given material parameters.
   *
   * @private
   * @param {Object} materialParams
   * @param {string} mapName
   * @param {Object} mapDef
   * @param {string} [colorSpace]
   * @return {Promise<Texture>}
   */
  assignTexture(e, t, i, n) {
    const r = this;
    return this.getDependency("texture", i.index).then(function(a) {
      if (!a) return null;
      if (i.texCoord !== void 0 && i.texCoord > 0 && (a = a.clone(), a.channel = i.texCoord), r.extensions[je.KHR_TEXTURE_TRANSFORM]) {
        const o = i.extensions !== void 0 ? i.extensions[je.KHR_TEXTURE_TRANSFORM] : void 0;
        if (o) {
          const l = r.associations.get(a);
          a = r.extensions[je.KHR_TEXTURE_TRANSFORM].extendTexture(a, o), r.associations.set(a, l);
        }
      }
      return n !== void 0 && (a.colorSpace = n), e[t] = a, a;
    });
  }
  /**
   * Assigns final material to a Mesh, Line, or Points instance. The instance
   * already has a material (generated from the glTF material options alone)
   * but reuse of the same glTF material may require multiple threejs materials
   * to accommodate different primitive types, defines, etc. New materials will
   * be created if necessary, and reused from a cache.
   *
   * @private
   * @param {Object3D} mesh Mesh, Line, or Points instance.
   */
  assignFinalMaterial(e) {
    const t = e.geometry;
    let i = e.material;
    const n = t.attributes.tangent === void 0, r = t.attributes.color !== void 0, a = t.attributes.normal === void 0;
    if (e.isPoints) {
      const o = "PointsMaterial:" + i.uuid;
      let l = this.cache.get(o);
      l || (l = new hf(), Yt.prototype.copy.call(l, i), l.color.copy(i.color), l.map = i.map, l.sizeAttenuation = !1, this.cache.add(o, l)), i = l;
    } else if (e.isLine) {
      const o = "LineBasicMaterial:" + i.uuid;
      let l = this.cache.get(o);
      l || (l = new cf(), Yt.prototype.copy.call(l, i), l.color.copy(i.color), l.map = i.map, this.cache.add(o, l)), i = l;
    }
    if (n || r || a) {
      let o = "ClonedMaterial:" + i.uuid + ":";
      n && (o += "derivative-tangents:"), r && (o += "vertex-colors:"), a && (o += "flat-shading:");
      let l = this.cache.get(o);
      l || (l = i.clone(), r && (l.vertexColors = !0), a && (l.flatShading = !0), n && (l.normalScale && (l.normalScale.y *= -1), l.clearcoatNormalScale && (l.clearcoatNormalScale.y *= -1)), this.cache.add(o, l), this.associations.set(l, this.associations.get(i))), i = l;
    }
    e.material = i;
  }
  getMaterialType() {
    return Pr;
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#materials
   *
   * @private
   * @param {number} materialIndex
   * @return {Promise<Material>}
   */
  loadMaterial(e) {
    const t = this, i = this.json, n = this.extensions, r = i.materials[e];
    let a;
    const o = {}, l = r.extensions || {}, c = [];
    if (l[je.KHR_MATERIALS_UNLIT]) {
      const d = n[je.KHR_MATERIALS_UNLIT];
      a = d.getMaterialType(), c.push(d.extendParams(o, r, t));
    } else {
      const d = r.pbrMetallicRoughness || {};
      if (o.color = new Ne(1, 1, 1), o.opacity = 1, Array.isArray(d.baseColorFactor)) {
        const u = d.baseColorFactor;
        o.color.setRGB(u[0], u[1], u[2], Wt), o.opacity = u[3];
      }
      d.baseColorTexture !== void 0 && c.push(t.assignTexture(o, "map", d.baseColorTexture, Ct)), o.metalness = d.metallicFactor !== void 0 ? d.metallicFactor : 1, o.roughness = d.roughnessFactor !== void 0 ? d.roughnessFactor : 1, d.metallicRoughnessTexture !== void 0 && (c.push(t.assignTexture(o, "metalnessMap", d.metallicRoughnessTexture)), c.push(t.assignTexture(o, "roughnessMap", d.metallicRoughnessTexture))), a = this._invokeOne(function(u) {
        return u.getMaterialType && u.getMaterialType(e);
      }), c.push(Promise.all(this._invokeAll(function(u) {
        return u.extendMaterialParams && u.extendMaterialParams(e, o);
      })));
    }
    r.doubleSided === !0 && (o.side = fi);
    const h = r.alphaMode || nl.OPAQUE;
    if (h === nl.BLEND ? (o.transparent = !0, o.depthWrite = !1) : (o.transparent = !1, h === nl.MASK && (o.alphaTest = r.alphaCutoff !== void 0 ? r.alphaCutoff : 0.5)), r.normalTexture !== void 0 && a !== sn && (c.push(t.assignTexture(o, "normalMap", r.normalTexture)), o.normalScale = new Ye(1, 1), r.normalTexture.scale !== void 0)) {
      const d = r.normalTexture.scale;
      o.normalScale.set(d, d);
    }
    if (r.occlusionTexture !== void 0 && a !== sn && (c.push(t.assignTexture(o, "aoMap", r.occlusionTexture)), r.occlusionTexture.strength !== void 0 && (o.aoMapIntensity = r.occlusionTexture.strength)), r.emissiveFactor !== void 0 && a !== sn) {
      const d = r.emissiveFactor;
      o.emissive = new Ne().setRGB(d[0], d[1], d[2], Wt);
    }
    return r.emissiveTexture !== void 0 && a !== sn && c.push(t.assignTexture(o, "emissiveMap", r.emissiveTexture, Ct)), Promise.all(c).then(function() {
      const d = new a(o);
      return r.name && (d.name = r.name), Oi(d, r), t.associations.set(d, { materials: e }), r.extensions && Gn(n, d, r), d;
    });
  }
  /**
   * When Object3D instances are targeted by animation, they need unique names.
   *
   * @private
   * @param {string} originalName
   * @return {string}
   */
  createUniqueName(e) {
    const t = st.sanitizeNodeName(e || "");
    return t in this.nodeNamesUsed ? t + "_" + ++this.nodeNamesUsed[t] : (this.nodeNamesUsed[t] = 0, t);
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#geometry
   *
   * Creates BufferGeometries from primitives.
   *
   * @private
   * @param {Array<GLTF.Primitive>} primitives
   * @return {Promise<Array<BufferGeometry>>}
   */
  loadGeometries(e) {
    const t = this, i = this.extensions, n = this.primitiveCache;
    function r(o) {
      return i[je.KHR_DRACO_MESH_COMPRESSION].decodePrimitive(o, t).then(function(l) {
        return ou(l, o, t);
      });
    }
    const a = [];
    for (let o = 0, l = e.length; o < l; o++) {
      const c = e[o], h = OS(c), d = n[h];
      if (d)
        a.push(d.promise);
      else {
        let u;
        c.extensions && c.extensions[je.KHR_DRACO_MESH_COMPRESSION] ? u = r(c) : u = ou(new ci(), c, t), n[h] = { primitive: c, promise: u }, a.push(u);
      }
    }
    return Promise.all(a);
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#meshes
   *
   * @private
   * @param {number} meshIndex
   * @return {Promise<Group|Mesh|SkinnedMesh|Line|Points>}
   */
  loadMesh(e) {
    const t = this, i = this.json, n = this.extensions, r = i.meshes[e], a = r.primitives, o = [];
    for (let l = 0, c = a.length; l < c; l++) {
      const h = a[l].material === void 0 ? LS(this.cache) : this.getDependency("material", a[l].material);
      o.push(h);
    }
    return o.push(t.loadGeometries(a)), Promise.all(o).then(function(l) {
      const c = l.slice(0, l.length - 1), h = l[l.length - 1], d = [];
      for (let f = 0, g = h.length; f < g; f++) {
        const v = h[f], m = a[f];
        let p;
        const w = c[f];
        if (m.mode === ui.TRIANGLES || m.mode === ui.TRIANGLE_STRIP || m.mode === ui.TRIANGLE_FAN || m.mode === void 0)
          p = r.isSkinnedMesh === !0 ? new u_(v, w) : new zt(v, w), p.isSkinnedMesh === !0 && p.normalizeSkinWeights(), m.mode === ui.TRIANGLE_STRIP ? p.geometry = nu(p.geometry, Yu) : m.mode === ui.TRIANGLE_FAN && (p.geometry = nu(p.geometry, lc));
        else if (m.mode === ui.LINES)
          p = new x_(v, w);
        else if (m.mode === ui.LINE_STRIP)
          p = new nh(v, w);
        else if (m.mode === ui.LINE_LOOP)
          p = new y_(v, w);
        else if (m.mode === ui.POINTS)
          p = new b_(v, w);
        else
          throw new Error("THREE.GLTFLoader: Primitive mode unsupported: " + m.mode);
        Object.keys(p.geometry.morphAttributes).length > 0 && NS(p, r), p.name = t.createUniqueName(r.name || "mesh_" + e), Oi(p, r), m.extensions && Gn(n, p, m), t.assignFinalMaterial(p), d.push(p);
      }
      for (let f = 0, g = d.length; f < g; f++)
        t.associations.set(d[f], {
          meshes: e,
          primitives: f
        });
      if (d.length === 1)
        return r.extensions && Gn(n, d[0], r), d[0];
      const u = new Mn();
      r.extensions && Gn(n, u, r), t.associations.set(u, { meshes: e });
      for (let f = 0, g = d.length; f < g; f++)
        u.add(d[f]);
      return u;
    });
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#cameras
   *
   * @private
   * @param {number} cameraIndex
   * @return {Promise<Camera>|undefined}
   */
  loadCamera(e) {
    let t;
    const i = this.json.cameras[e], n = i[i.type];
    if (!n) {
      console.warn("THREE.GLTFLoader: Missing camera parameters.");
      return;
    }
    return i.type === "perspective" ? t = new Gt(hc.radToDeg(n.yfov), n.aspectRatio || 1, n.znear || 1, n.zfar || 2e6) : i.type === "orthographic" && (t = new zr(-n.xmag, n.xmag, n.ymag, -n.ymag, n.znear, n.zfar)), i.name && (t.name = this.createUniqueName(i.name)), Oi(t, i), Promise.resolve(t);
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#skins
   *
   * @private
   * @param {number} skinIndex
   * @return {Promise<Skeleton>}
   */
  loadSkin(e) {
    const t = this.json.skins[e], i = [];
    for (let n = 0, r = t.joints.length; n < r; n++)
      i.push(this._loadNodeShallow(t.joints[n]));
    return t.inverseBindMatrices !== void 0 ? i.push(this.getDependency("accessor", t.inverseBindMatrices)) : i.push(null), Promise.all(i).then(function(n) {
      const r = n.pop(), a = n, o = [], l = [];
      for (let c = 0, h = a.length; c < h; c++) {
        const d = a[c];
        if (d) {
          o.push(d);
          const u = new ze();
          r !== null && u.fromArray(r.array, c * 16), l.push(u);
        } else
          console.warn('THREE.GLTFLoader: Joint "%s" could not be found.', t.joints[c]);
      }
      return new th(o, l);
    });
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#animations
   *
   * @private
   * @param {number} animationIndex
   * @return {Promise<AnimationClip>}
   */
  loadAnimation(e) {
    const t = this.json, i = this, n = t.animations[e], r = n.name ? n.name : "animation_" + e, a = [], o = [], l = [], c = [], h = [];
    for (let d = 0, u = n.channels.length; d < u; d++) {
      const f = n.channels[d], g = n.samplers[f.sampler], v = f.target, m = v.node, p = n.parameters !== void 0 ? n.parameters[g.input] : g.input, w = n.parameters !== void 0 ? n.parameters[g.output] : g.output;
      v.node !== void 0 && (a.push(this.getDependency("node", m)), o.push(this.getDependency("accessor", p)), l.push(this.getDependency("accessor", w)), c.push(g), h.push(v));
    }
    return Promise.all([
      Promise.all(a),
      Promise.all(o),
      Promise.all(l),
      Promise.all(c),
      Promise.all(h)
    ]).then(function(d) {
      const u = d[0], f = d[1], g = d[2], v = d[3], m = d[4], p = [];
      for (let M = 0, T = u.length; M < T; M++) {
        const E = u[M], A = f[M], R = g[M], F = v[M], y = m[M];
        if (E === void 0) continue;
        E.updateMatrix && E.updateMatrix();
        const b = i._createAnimationTracks(E, A, R, F, y);
        if (b)
          for (let P = 0; P < b.length; P++)
            p.push(b[P]);
      }
      const w = new fc(r, void 0, p);
      return Oi(w, n), w;
    });
  }
  createNodeMesh(e) {
    const t = this.json, i = this, n = t.nodes[e];
    return n.mesh === void 0 ? null : i.getDependency("mesh", n.mesh).then(function(r) {
      const a = i._getNodeRef(i.meshCache, n.mesh, r);
      return n.weights !== void 0 && a.traverse(function(o) {
        if (o.isMesh)
          for (let l = 0, c = n.weights.length; l < c; l++)
            o.morphTargetInfluences[l] = n.weights[l];
      }), a;
    });
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#nodes-and-hierarchy
   *
   * @private
   * @param {number} nodeIndex
   * @return {Promise<Object3D>}
   */
  loadNode(e) {
    const t = this.json, i = this, n = t.nodes[e], r = i._loadNodeShallow(e), a = [], o = n.children || [];
    for (let c = 0, h = o.length; c < h; c++)
      a.push(i.getDependency("node", o[c]));
    const l = n.skin === void 0 ? Promise.resolve(null) : i.getDependency("skin", n.skin);
    return Promise.all([
      r,
      Promise.all(a),
      l
    ]).then(function(c) {
      const h = c[0], d = c[1], u = c[2];
      u !== null && h.traverse(function(f) {
        f.isSkinnedMesh && f.bind(u, FS);
      });
      for (let f = 0, g = d.length; f < g; f++)
        h.add(d[f]);
      return h;
    });
  }
  // ._loadNodeShallow() parses a single node.
  // skin and child nodes are created and added in .loadNode() (no '_' prefix).
  _loadNodeShallow(e) {
    const t = this.json, i = this.extensions, n = this;
    if (this.nodeCache[e] !== void 0)
      return this.nodeCache[e];
    const r = t.nodes[e], a = r.name ? n.createUniqueName(r.name) : "", o = [], l = n._invokeOne(function(c) {
      return c.createNodeMesh && c.createNodeMesh(e);
    });
    return l && o.push(l), r.camera !== void 0 && o.push(n.getDependency("camera", r.camera).then(function(c) {
      return n._getNodeRef(n.cameraCache, r.camera, c);
    })), n._invokeAll(function(c) {
      return c.createNodeAttachment && c.createNodeAttachment(e);
    }).forEach(function(c) {
      o.push(c);
    }), this.nodeCache[e] = Promise.all(o).then(function(c) {
      let h;
      if (r.isBone === !0 ? h = new lf() : c.length > 1 ? h = new Mn() : c.length === 1 ? h = c[0] : h = new wt(), h !== c[0])
        for (let d = 0, u = c.length; d < u; d++)
          h.add(c[d]);
      if (r.name && (h.userData.name = r.name, h.name = a), Oi(h, r), r.extensions && Gn(i, h, r), r.matrix !== void 0) {
        const d = new ze();
        d.fromArray(r.matrix), h.applyMatrix4(d);
      } else
        r.translation !== void 0 && h.position.fromArray(r.translation), r.rotation !== void 0 && h.quaternion.fromArray(r.rotation), r.scale !== void 0 && h.scale.fromArray(r.scale);
      if (!n.associations.has(h))
        n.associations.set(h, {});
      else if (r.mesh !== void 0 && n.meshCache.refs[r.mesh] > 1) {
        const d = n.associations.get(h);
        n.associations.set(h, { ...d });
      }
      return n.associations.get(h).nodes = e, h;
    }), this.nodeCache[e];
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#scenes
   *
   * @private
   * @param {number} sceneIndex
   * @return {Promise<Group>}
   */
  loadScene(e) {
    const t = this.extensions, i = this.json.scenes[e], n = this, r = new Mn();
    i.name && (r.name = n.createUniqueName(i.name)), Oi(r, i), i.extensions && Gn(t, r, i);
    const a = i.nodes || [], o = [];
    for (let l = 0, c = a.length; l < c; l++)
      o.push(n.getDependency("node", a[l]));
    return Promise.all(o).then(function(l) {
      for (let h = 0, d = l.length; h < d; h++)
        r.add(l[h]);
      const c = (h) => {
        const d = /* @__PURE__ */ new Map();
        for (const [u, f] of n.associations)
          (u instanceof Yt || u instanceof Ot) && d.set(u, f);
        return h.traverse((u) => {
          const f = n.associations.get(u);
          f != null && d.set(u, f);
        }), d;
      };
      return n.associations = c(r), r;
    });
  }
  _createAnimationTracks(e, t, i, n, r) {
    const a = [], o = e.name ? e.name : e.uuid, l = [];
    bn[r.path] === bn.weights ? e.traverse(function(u) {
      u.morphTargetInfluences && l.push(u.name ? u.name : u.uuid);
    }) : l.push(o);
    let c;
    switch (bn[r.path]) {
      case bn.weights:
        c = zs;
        break;
      case bn.rotation:
        c = Vs;
        break;
      case bn.translation:
      case bn.scale:
        c = Hs;
        break;
      default:
        i.itemSize === 1 ? c = zs : c = Hs;
        break;
    }
    const h = n.interpolation !== void 0 ? PS[n.interpolation] : Ar, d = this._getArrayFromAccessor(i);
    for (let u = 0, f = l.length; u < f; u++) {
      const g = new c(
        l[u] + "." + bn[r.path],
        t.array,
        d,
        h
      );
      n.interpolation === "CUBICSPLINE" && this._createCubicSplineTrackInterpolant(g), a.push(g);
    }
    return a;
  }
  _getArrayFromAccessor(e) {
    let t = e.array;
    if (e.normalized) {
      const i = vc(t.constructor), n = new Float32Array(t.length);
      for (let r = 0, a = t.length; r < a; r++)
        n[r] = t[r] * i;
      t = n;
    }
    return t;
  }
  _createCubicSplineTrackInterpolant(e) {
    e.createInterpolant = function(i) {
      const n = this instanceof Vs ? IS : Tf;
      return new n(this.times, this.values, this.getValueSize() / 3, i);
    }, e.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline = !0;
  }
}
function kS(s, e, t) {
  const i = e.attributes, n = new qi();
  if (i.POSITION !== void 0) {
    const o = t.json.accessors[i.POSITION], l = o.min, c = o.max;
    if (l !== void 0 && c !== void 0) {
      if (n.set(
        new O(l[0], l[1], l[2]),
        new O(c[0], c[1], c[2])
      ), o.normalized) {
        const h = vc(As[o.componentType]);
        n.min.multiplyScalar(h), n.max.multiplyScalar(h);
      }
    } else {
      console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
      return;
    }
  } else
    return;
  const r = e.targets;
  if (r !== void 0) {
    const o = new O(), l = new O();
    for (let c = 0, h = r.length; c < h; c++) {
      const d = r[c];
      if (d.POSITION !== void 0) {
        const u = t.json.accessors[d.POSITION], f = u.min, g = u.max;
        if (f !== void 0 && g !== void 0) {
          if (l.setX(Math.max(Math.abs(f[0]), Math.abs(g[0]))), l.setY(Math.max(Math.abs(f[1]), Math.abs(g[1]))), l.setZ(Math.max(Math.abs(f[2]), Math.abs(g[2]))), u.normalized) {
            const v = vc(As[u.componentType]);
            l.multiplyScalar(v);
          }
          o.max(l);
        } else
          console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
      }
    }
    n.expandByVector(o);
  }
  s.boundingBox = n;
  const a = new Wi();
  n.getCenter(a.center), a.radius = n.min.distanceTo(n.max) / 2, s.boundingSphere = a;
}
function ou(s, e, t) {
  const i = e.attributes, n = [];
  function r(a, o) {
    return t.getDependency("accessor", a).then(function(l) {
      s.setAttribute(o, l);
    });
  }
  for (const a in i) {
    const o = gc[a] || a.toLowerCase();
    o in s.attributes || n.push(r(i[a], o));
  }
  if (e.indices !== void 0 && !s.index) {
    const a = t.getDependency("accessor", e.indices).then(function(o) {
      s.setIndex(o);
    });
    n.push(a);
  }
  return Ke.workingColorSpace !== Wt && "COLOR_0" in i && console.warn(`THREE.GLTFLoader: Converting vertex colors from "srgb-linear" to "${Ke.workingColorSpace}" not supported.`), Oi(s, e), kS(s, e, t), Promise.all(n).then(function() {
    return e.targets !== void 0 ? DS(s, e.targets, t) : s;
  });
}
const Pa = {
  name: "CopyShader",
  uniforms: {
    tDiffuse: { value: null },
    opacity: { value: 1 }
  },
  vertexShader: (
    /* glsl */
    `

		varying vec2 vUv;

		void main() {

			vUv = uv;
			gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );

		}`
  ),
  fragmentShader: (
    /* glsl */
    `

		uniform float opacity;

		uniform sampler2D tDiffuse;

		varying vec2 vUv;

		void main() {

			vec4 texel = texture2D( tDiffuse, vUv );
			gl_FragColor = opacity * texel;


		}`
  )
};
class go {
  /**
   * Constructs a new pass.
   */
  constructor() {
    this.isPass = !0, this.enabled = !0, this.needsSwap = !0, this.clear = !1, this.renderToScreen = !1;
  }
  /**
   * Sets the size of the pass.
   *
   * @abstract
   * @param {number} width - The width to set.
   * @param {number} height - The height to set.
   */
  setSize() {
  }
  /**
   * This method holds the render logic of a pass. It must be implemented in all derived classes.
   *
   * @abstract
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} writeBuffer - The write buffer. This buffer is intended as the rendering
   * destination for the pass.
   * @param {WebGLRenderTarget} readBuffer - The read buffer. The pass can access the result from the
   * previous pass from this buffer.
   * @param {number} deltaTime - The delta time in seconds.
   * @param {boolean} maskActive - Whether masking is active or not.
   */
  render() {
    console.error("THREE.Pass: .render() must be implemented in derived pass.");
  }
  /**
   * Frees the GPU-related resources allocated by this instance. Call this
   * method whenever the pass is no longer used in your app.
   *
   * @abstract
   */
  dispose() {
  }
}
const zS = new zr(-1, 1, 1, -1, 0, 1);
class VS extends ci {
  constructor() {
    super(), this.setAttribute("position", new ri([-1, 3, 0, -1, -1, 0, 3, -1, 0], 3)), this.setAttribute("uv", new ri([0, 2, 0, 0, 2, 0], 2));
  }
}
const HS = new VS();
class Ef {
  /**
   * Constructs a new full screen quad.
   *
   * @param {?Material} material - The material to render te full screen quad with.
   */
  constructor(e) {
    this._mesh = new zt(HS, e);
  }
  /**
   * Frees the GPU-related resources allocated by this instance. Call this
   * method whenever the instance is no longer used in your app.
   */
  dispose() {
    this._mesh.geometry.dispose();
  }
  /**
   * Renders the full screen quad.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   */
  render(e) {
    e.render(this._mesh, zS);
  }
  /**
   * The quad's material.
   *
   * @type {?Material}
   */
  get material() {
    return this._mesh.material;
  }
  set material(e) {
    this._mesh.material = e;
  }
}
class Af extends go {
  /**
   * Constructs a new shader pass.
   *
   * @param {Object|ShaderMaterial} [shader] - A shader object holding vertex and fragment shader as well as
   * defines and uniforms. It's also valid to pass a custom shader material.
   * @param {string} [textureID='tDiffuse'] - The name of the texture uniform that should sample
   * the read buffer.
   */
  constructor(e, t = "tDiffuse") {
    super(), this.textureID = t, this.uniforms = null, this.material = null, e instanceof oi ? (this.uniforms = e.uniforms, this.material = e) : e && (this.uniforms = Jc.clone(e.uniforms), this.material = new oi({
      name: e.name !== void 0 ? e.name : "unspecified",
      defines: Object.assign({}, e.defines),
      uniforms: this.uniforms,
      vertexShader: e.vertexShader,
      fragmentShader: e.fragmentShader
    })), this._fsQuad = new Ef(this.material);
  }
  /**
   * Performs the shader pass.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} writeBuffer - The write buffer. This buffer is intended as the rendering
   * destination for the pass.
   * @param {WebGLRenderTarget} readBuffer - The read buffer. The pass can access the result from the
   * previous pass from this buffer.
   * @param {number} deltaTime - The delta time in seconds.
   * @param {boolean} maskActive - Whether masking is active or not.
   */
  render(e, t, i) {
    this.uniforms[this.textureID] && (this.uniforms[this.textureID].value = i.texture), this._fsQuad.material = this.material, this.renderToScreen ? (e.setRenderTarget(null), this._fsQuad.render(e)) : (e.setRenderTarget(t), this.clear && e.clear(e.autoClearColor, e.autoClearDepth, e.autoClearStencil), this._fsQuad.render(e));
  }
  /**
   * Frees the GPU-related resources allocated by this instance. Call this
   * method whenever the pass is no longer used in your app.
   */
  dispose() {
    this.material.dispose(), this._fsQuad.dispose();
  }
}
class lu extends go {
  /**
   * Constructs a new mask pass.
   *
   * @param {Scene} scene - The 3D objects in this scene will define the mask.
   * @param {Camera} camera - The camera.
   */
  constructor(e, t) {
    super(), this.scene = e, this.camera = t, this.clear = !0, this.needsSwap = !1, this.inverse = !1;
  }
  /**
   * Performs a mask pass with the configured scene and camera.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} writeBuffer - The write buffer. This buffer is intended as the rendering
   * destination for the pass.
   * @param {WebGLRenderTarget} readBuffer - The read buffer. The pass can access the result from the
   * previous pass from this buffer.
   * @param {number} deltaTime - The delta time in seconds.
   * @param {boolean} maskActive - Whether masking is active or not.
   */
  render(e, t, i) {
    const n = e.getContext(), r = e.state;
    r.buffers.color.setMask(!1), r.buffers.depth.setMask(!1), r.buffers.color.setLocked(!0), r.buffers.depth.setLocked(!0);
    let a, o;
    this.inverse ? (a = 0, o = 1) : (a = 1, o = 0), r.buffers.stencil.setTest(!0), r.buffers.stencil.setOp(n.REPLACE, n.REPLACE, n.REPLACE), r.buffers.stencil.setFunc(n.ALWAYS, a, 4294967295), r.buffers.stencil.setClear(o), r.buffers.stencil.setLocked(!0), e.setRenderTarget(i), this.clear && e.clear(), e.render(this.scene, this.camera), e.setRenderTarget(t), this.clear && e.clear(), e.render(this.scene, this.camera), r.buffers.color.setLocked(!1), r.buffers.depth.setLocked(!1), r.buffers.color.setMask(!0), r.buffers.depth.setMask(!0), r.buffers.stencil.setLocked(!1), r.buffers.stencil.setFunc(n.EQUAL, 1, 4294967295), r.buffers.stencil.setOp(n.KEEP, n.KEEP, n.KEEP), r.buffers.stencil.setLocked(!0);
  }
}
class $S extends go {
  /**
   * Constructs a new clear mask pass.
   */
  constructor() {
    super(), this.needsSwap = !1;
  }
  /**
   * Performs the clear of the currently defined mask.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} writeBuffer - The write buffer. This buffer is intended as the rendering
   * destination for the pass.
   * @param {WebGLRenderTarget} readBuffer - The read buffer. The pass can access the result from the
   * previous pass from this buffer.
   * @param {number} deltaTime - The delta time in seconds.
   * @param {boolean} maskActive - Whether masking is active or not.
   */
  render(e) {
    e.state.buffers.stencil.setLocked(!1), e.state.buffers.stencil.setTest(!1);
  }
}
class GS {
  /**
   * Constructs a new effect composer.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} [renderTarget] - This render target and a clone will
   * be used as the internal read and write buffers. If not given, the composer creates
   * the buffers automatically.
   */
  constructor(e, t) {
    if (this.renderer = e, this._pixelRatio = e.getPixelRatio(), t === void 0) {
      const i = e.getSize(new Ye());
      this._width = i.width, this._height = i.height, t = new gi(this._width * this._pixelRatio, this._height * this._pixelRatio, { type: Ai }), t.texture.name = "EffectComposer.rt1";
    } else
      this._width = t.width, this._height = t.height;
    this.renderTarget1 = t, this.renderTarget2 = t.clone(), this.renderTarget2.texture.name = "EffectComposer.rt2", this.writeBuffer = this.renderTarget1, this.readBuffer = this.renderTarget2, this.renderToScreen = !0, this.passes = [], this.copyPass = new Af(Pa), this.copyPass.material.blending = ki, this.clock = new vf();
  }
  /**
   * Swaps the internal read/write buffers.
   */
  swapBuffers() {
    const e = this.readBuffer;
    this.readBuffer = this.writeBuffer, this.writeBuffer = e;
  }
  /**
   * Adds the given pass to the pass chain.
   *
   * @param {Pass} pass - The pass to add.
   */
  addPass(e) {
    this.passes.push(e), e.setSize(this._width * this._pixelRatio, this._height * this._pixelRatio);
  }
  /**
   * Inserts the given pass at a given index.
   *
   * @param {Pass} pass - The pass to insert.
   * @param {number} index - The index into the pass chain.
   */
  insertPass(e, t) {
    this.passes.splice(t, 0, e), e.setSize(this._width * this._pixelRatio, this._height * this._pixelRatio);
  }
  /**
   * Removes the given pass from the pass chain.
   *
   * @param {Pass} pass - The pass to remove.
   */
  removePass(e) {
    const t = this.passes.indexOf(e);
    t !== -1 && this.passes.splice(t, 1);
  }
  /**
   * Returns `true` if the pass for the given index is the last enabled pass in the pass chain.
   *
   * @param {number} passIndex - The pass index.
   * @return {boolean} Whether the pass for the given index is the last pass in the pass chain.
   */
  isLastEnabledPass(e) {
    for (let t = e + 1; t < this.passes.length; t++)
      if (this.passes[t].enabled)
        return !1;
    return !0;
  }
  /**
   * Executes all enabled post-processing passes in order to produce the final frame.
   *
   * @param {number} deltaTime - The delta time in seconds. If not given, the composer computes
   * its own time delta value.
   */
  render(e) {
    e === void 0 && (e = this.clock.getDelta());
    const t = this.renderer.getRenderTarget();
    let i = !1;
    for (let n = 0, r = this.passes.length; n < r; n++) {
      const a = this.passes[n];
      if (a.enabled !== !1) {
        if (a.renderToScreen = this.renderToScreen && this.isLastEnabledPass(n), a.render(this.renderer, this.writeBuffer, this.readBuffer, e, i), a.needsSwap) {
          if (i) {
            const o = this.renderer.getContext(), l = this.renderer.state.buffers.stencil;
            l.setFunc(o.NOTEQUAL, 1, 4294967295), this.copyPass.render(this.renderer, this.writeBuffer, this.readBuffer, e), l.setFunc(o.EQUAL, 1, 4294967295);
          }
          this.swapBuffers();
        }
        lu !== void 0 && (a instanceof lu ? i = !0 : a instanceof $S && (i = !1));
      }
    }
    this.renderer.setRenderTarget(t);
  }
  /**
   * Resets the internal state of the EffectComposer.
   *
   * @param {WebGLRenderTarget} [renderTarget] - This render target has the same purpose like
   * the one from the constructor. If set, it is used to setup the read and write buffers.
   */
  reset(e) {
    if (e === void 0) {
      const t = this.renderer.getSize(new Ye());
      this._pixelRatio = this.renderer.getPixelRatio(), this._width = t.width, this._height = t.height, e = this.renderTarget1.clone(), e.setSize(this._width * this._pixelRatio, this._height * this._pixelRatio);
    }
    this.renderTarget1.dispose(), this.renderTarget2.dispose(), this.renderTarget1 = e, this.renderTarget2 = e.clone(), this.writeBuffer = this.renderTarget1, this.readBuffer = this.renderTarget2;
  }
  /**
   * Resizes the internal read and write buffers as well as all passes. Similar to {@link WebGLRenderer#setSize},
   * this method honors the current pixel ration.
   *
   * @param {number} width - The width in logical pixels.
   * @param {number} height - The height in logical pixels.
   */
  setSize(e, t) {
    this._width = e, this._height = t;
    const i = this._width * this._pixelRatio, n = this._height * this._pixelRatio;
    this.renderTarget1.setSize(i, n), this.renderTarget2.setSize(i, n);
    for (let r = 0; r < this.passes.length; r++)
      this.passes[r].setSize(i, n);
  }
  /**
   * Sets device pixel ratio. This is usually used for HiDPI device to prevent blurring output.
   * Setting the pixel ratio will automatically resize the composer.
   *
   * @param {number} pixelRatio - The pixel ratio to set.
   */
  setPixelRatio(e) {
    this._pixelRatio = e, this.setSize(this._width, this._height);
  }
  /**
   * Frees the GPU-related resources allocated by this instance. Call this
   * method whenever the composer is no longer used in your app.
   */
  dispose() {
    this.renderTarget1.dispose(), this.renderTarget2.dispose(), this.copyPass.dispose();
  }
}
class qS extends go {
  /**
   * Constructs a new SSAA render pass.
   *
   * @param {Scene} scene - The scene to render.
   * @param {Camera} camera - The camera.
   * @param {?(number|Color|string)} [clearColor=0x000000] - The clear color of the render pass.
   * @param {?number} [clearAlpha=0] - The clear alpha of the render pass.
   */
  constructor(e, t, i = 0, n = 0) {
    super(), this.scene = e, this.camera = t, this.sampleLevel = 4, this.unbiased = !0, this.stencilBuffer = !1, this.clearColor = i, this.clearAlpha = n, this._sampleRenderTarget = null, this._oldClearColor = new Ne(), this._copyUniforms = Jc.clone(Pa.uniforms), this._copyMaterial = new oi({
      uniforms: this._copyUniforms,
      vertexShader: Pa.vertexShader,
      fragmentShader: Pa.fragmentShader,
      transparent: !0,
      depthTest: !1,
      depthWrite: !1,
      premultipliedAlpha: !0,
      blending: vl
    }), this._fsQuad = new Ef(this._copyMaterial);
  }
  /**
   * Frees the GPU-related resources allocated by this instance. Call this
   * method whenever the pass is no longer used in your app.
   */
  dispose() {
    this._sampleRenderTarget && (this._sampleRenderTarget.dispose(), this._sampleRenderTarget = null), this._copyMaterial.dispose(), this._fsQuad.dispose();
  }
  /**
   * Sets the size of the pass.
   *
   * @param {number} width - The width to set.
   * @param {number} height - The height to set.
   */
  setSize(e, t) {
    this._sampleRenderTarget && this._sampleRenderTarget.setSize(e, t);
  }
  /**
   * Performs the SSAA render pass.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} writeBuffer - The write buffer. This buffer is intended as the rendering
   * destination for the pass.
   * @param {WebGLRenderTarget} readBuffer - The read buffer. The pass can access the result from the
   * previous pass from this buffer.
   * @param {number} deltaTime - The delta time in seconds.
   * @param {boolean} maskActive - Whether masking is active or not.
   */
  render(e, t, i) {
    this._sampleRenderTarget || (this._sampleRenderTarget = new gi(i.width, i.height, { type: Ai, stencilBuffer: this.stencilBuffer }), this._sampleRenderTarget.texture.name = "SSAARenderPass.sample");
    const n = WS[Math.max(0, Math.min(this.sampleLevel, 5))], r = e.autoClear;
    e.autoClear = !1, e.getClearColor(this._oldClearColor);
    const a = e.getClearAlpha(), o = 1 / n.length, l = 1 / 32;
    this._copyUniforms.tDiffuse.value = this._sampleRenderTarget.texture;
    const c = {
      fullWidth: i.width,
      fullHeight: i.height,
      offsetX: 0,
      offsetY: 0,
      width: i.width,
      height: i.height
    }, h = Object.assign({}, this.camera.view);
    h.enabled && Object.assign(c, h);
    for (let d = 0; d < n.length; d++) {
      const u = n[d];
      this.camera.setViewOffset && this.camera.setViewOffset(
        c.fullWidth,
        c.fullHeight,
        c.offsetX + u[0] * 0.0625,
        c.offsetY + u[1] * 0.0625,
        // 0.0625 = 1 / 16
        c.width,
        c.height
      );
      let f = o;
      if (this.unbiased) {
        const g = -0.5 + (d + 0.5) / n.length;
        f += l * g;
      }
      this._copyUniforms.opacity.value = f, e.setClearColor(this.clearColor, this.clearAlpha), e.setRenderTarget(this._sampleRenderTarget), e.clear(), e.render(this.scene, this.camera), e.setRenderTarget(this.renderToScreen ? null : t), d === 0 && (e.setClearColor(0, 0), e.clear()), this._fsQuad.render(e);
    }
    this.camera.setViewOffset && h.enabled ? this.camera.setViewOffset(
      h.fullWidth,
      h.fullHeight,
      h.offsetX,
      h.offsetY,
      h.width,
      h.height
    ) : this.camera.clearViewOffset && this.camera.clearViewOffset(), e.autoClear = r, e.setClearColor(this._oldClearColor, a);
  }
}
const WS = [
  [
    [0, 0]
  ],
  [
    [4, 4],
    [-4, -4]
  ],
  [
    [-2, -6],
    [6, -2],
    [-6, 2],
    [2, 6]
  ],
  [
    [1, -3],
    [-1, 3],
    [5, 1],
    [-3, -5],
    [-5, 5],
    [-7, -1],
    [3, 7],
    [7, -7]
  ],
  [
    [1, 1],
    [-1, -3],
    [-3, 2],
    [4, -1],
    [-5, -2],
    [2, 5],
    [5, 3],
    [3, -5],
    [-2, 6],
    [0, -7],
    [-4, -6],
    [-6, 4],
    [-8, 0],
    [7, -4],
    [6, 7],
    [-7, -8]
  ],
  [
    [-4, -7],
    [-7, -5],
    [-3, -5],
    [-5, -4],
    [-1, -4],
    [-2, -2],
    [-6, -1],
    [-4, 0],
    [-7, 1],
    [-1, 2],
    [-6, 3],
    [-3, 3],
    [-7, 6],
    [-3, 6],
    [-5, 7],
    [-1, 7],
    [5, -7],
    [1, -6],
    [6, -5],
    [4, -4],
    [2, -3],
    [7, -2],
    [1, -1],
    [4, -1],
    [2, 1],
    [6, 2],
    [0, 4],
    [4, 4],
    [2, 5],
    [7, 5],
    [5, 6],
    [3, 7]
  ]
], XS = {
  name: "GammaCorrectionShader",
  uniforms: {
    tDiffuse: { value: null }
  },
  vertexShader: (
    /* glsl */
    `

		varying vec2 vUv;

		void main() {

			vUv = uv;
			gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );

		}`
  ),
  fragmentShader: (
    /* glsl */
    `

		uniform sampler2D tDiffuse;

		varying vec2 vUv;

		void main() {

			vec4 tex = texture2D( tDiffuse, vUv );

			gl_FragColor = sRGBTransferOETF( tex );

		}`
  )
};
class jS {
  constructor(e, t, i) {
    this.rawModel = null, this.powderMesh = null, this.clock = new vf(), this.mixer = null, this.animationAction = null, this.capMesh = null, this.capMaxY = 0, this.capStartY = 0, this.pendingRotationIndex = -1, this.isAutoRotating = !0, this.targetQuaternion = null, this.targetZoom = 1, this.baseScale = 1, this.currentModelZoom = 1, this.animationId = null, this.animationTimeout = null, this.currentSectionIndex = -1, this.hasLeftIdle = !1, this.targetPowderOpacity = 0, this.powderTimeout = null, this.ambientLight = null, this.keyLight = null, this.fillLight = null, this.backLight = null, this.handleResize = () => {
      if (!this.container || !this.camera || !this.renderer) return;
      const n = this.container.clientWidth, r = this.container.clientHeight;
      this.camera.aspect = n / r, this.camera.updateProjectionMatrix(), this.renderer.setSize(n, r), this.composer.setSize(n, r);
    }, this.pendingRotationCallback = null, this.animate = () => {
      this.animationId = requestAnimationFrame(this.animate);
      const n = this.clock.getDelta();
      if (this.mixer && (this.mixer.update(n), this.capMesh && this.capMesh.material instanceof Yt)) {
        const a = this.capMesh.position.y, o = this.capStartY, l = this.capMaxY > o ? this.capMaxY : o + 1, c = o + (l - o) * 0.05, h = o + (l - o) * 0.5, d = hc.clamp(
          (a - c) / (h - c),
          0,
          1
        );
        this.capMesh.material.opacity = 1 - d, this.pendingRotationIndex !== -1 && d > 0.4 && (this.rotateToSection(this.pendingRotationIndex), this.pendingRotationCallback && (this.pendingRotationCallback(), this.pendingRotationCallback = null), this.pendingRotationIndex = -1);
      }
      if (this.modelContainer) {
        if (this.isAutoRotating) {
          const a = this.hasLeftIdle ? -0.3 : 0.3;
          this.modelContainer.rotation.y += a * n;
        } else if (this.targetQuaternion) {
          const a = 1 - Math.exp(-5 * n);
          this.modelContainer.quaternion.slerp(
            this.targetQuaternion,
            a
          );
        }
      }
      const r = this.targetZoom - this.currentModelZoom;
      if (Math.abs(r) > 1e-3) {
        const a = 1 - Math.exp(-3 * n);
        if (this.currentModelZoom += r * a, this.modelContainer && this.baseScale > 0) {
          const o = this.baseScale * this.currentModelZoom;
          this.modelContainer.scale.set(o, o, o);
        }
      }
      if (this.powderMesh) {
        const a = this.targetPowderOpacity, o = this.powderMesh.material.opacity, l = a - o;
        if (Math.abs(l) > 1e-3) {
          const c = 1 - Math.exp(-2 * n);
          this.powderMesh.material.opacity += l * c;
        }
      }
      this.composer.render();
    }, this.container = e, this.desktopPowderImageUrl = i, this.init(t);
  }
  init(e) {
    const t = this.container.clientWidth, i = this.container.clientHeight;
    this.scene = new c_();
    const n = t / i, r = 45;
    this.camera = new Gt(r, n, 0.1, 100), this.camera.position.set(0, 0, 11), this.camera.lookAt(0, 0, 0), this.renderer = new Jw({ antialias: !0, alpha: !0 }), this.renderer.setSize(t, i), this.renderer.setPixelRatio(window.devicePixelRatio), this.renderer.outputColorSpace = Ct, this.container.appendChild(this.renderer.domElement), this.composer = new GS(this.renderer);
    const a = new qS(this.scene, this.camera, 0, 0);
    a.sampleLevel = 2, this.composer.addPass(a);
    const o = new Af(XS);
    this.composer.addPass(o), this.composer.setSize(t, i), this.composer.setPixelRatio(window.devicePixelRatio), this.ambientLight = new V_(16777215, 1.2), this.scene.add(this.ambientLight), this.keyLight = new Ca(16777215, 2), this.keyLight.position.set(-10, 10, 10), this.scene.add(this.keyLight), this.fillLight = new Ca(16777215, 0.6), this.fillLight.position.set(10, 5, 10), this.scene.add(this.fillLight), this.backLight = new Ca(16777215, 1), this.backLight.position.set(0, 5, -10), this.scene.add(this.backLight), this.modelContainer = new Mn(), this.modelContainer.rotation.y = Math.PI, this.scene.add(this.modelContainer), this.loadPowder(), this.loadModel(e), this.animate(), window.addEventListener("resize", this.handleResize);
  }
  updateLights(e, t, i, n, r, a, o) {
    this.ambientLight && (this.ambientLight.intensity = e), this.keyLight && (this.keyLight.intensity = t, this.keyLight.position.copy(i)), this.fillLight && (this.fillLight.intensity = n, this.fillLight.position.copy(r)), this.backLight && (this.backLight.intensity = a, this.backLight.position.copy(o));
  }
  updatePowderTexture(e, t) {
    ((n) => {
      if (n) {
        const r = n.material;
        (r instanceof Pr || r instanceof sn) && r.map && (r.map.offset.set(e.x, e.y), r.map.repeat.set(t.x, t.y), r.map.needsUpdate = !0);
      }
    })(this.powderMesh);
  }
  disposePowderOverlay() {
    if (!this.powderMesh) return;
    this.scene.remove(this.powderMesh);
    const e = this.powderMesh.material;
    e.map?.dispose(), e.dispose(), this.powderMesh.geometry.dispose(), this.powderMesh = null;
  }
  createPowderOverlayFromTexture(e) {
    e.colorSpace = Ct, e.anisotropy = this.renderer.capabilities.getMaxAnisotropy(), e.minFilter = bt, e.magFilter = bt;
    const t = e.image, i = t?.width ?? 1, n = t?.height ?? 1, r = i > 0 && n > 0 ? i / n : 1, a = 5, o = a * r, l = new Br(o, a), c = new sn({
      map: e,
      transparent: !0,
      opacity: 0,
      side: fi,
      depthWrite: !1,
      blending: Kn
    });
    this.powderMesh = new zt(l, c), this.powderMesh.position.set(0.06, -0.05, 3.77), this.scene.add(this.powderMesh);
  }
  loadPowderTexture(e) {
    return e ? new Promise((t, i) => {
      new gf().load(
        e,
        (r) => {
          this.createPowderOverlayFromTexture(r), t();
        },
        void 0,
        (r) => {
          console.error("Failed to load desktop powder texture", r), i(r);
        }
      );
    }) : Promise.resolve();
  }
  loadPowder() {
    this.loadPowderTexture(this.desktopPowderImageUrl);
  }
  setDesktopPowderImage(e) {
    return this.desktopPowderImageUrl = e, this.disposePowderOverlay(), this.loadPowderTexture(e);
  }
  loadModel(e) {
    new rS().load(
      e,
      (i) => {
        if (this.rawModel = i.scene, i.animations && i.animations.length > 0) {
          this.mixer = new i0(this.rawModel);
          const l = i.animations[0];
          this.animationAction = this.mixer.clipAction(l), this.animationAction.setLoop(oc, 1), this.animationAction.clampWhenFinished = !0, this.animationAction.timeScale = 4, l.tracks.forEach((c) => {
            if (c.name.toLowerCase().includes(".position"))
              for (let h = 1; h < c.values.length; h += 3)
                c.values[h] > this.capMaxY && (this.capMaxY = c.values[h]);
          });
        }
        const n = new qi().setFromObject(this.rawModel), r = n.getSize(new O()), a = n.getCenter(new O());
        this.rawModel.position.sub(a), this.modelContainer.add(this.rawModel);
        const o = Math.max(r.x, r.y, r.z);
        if (o > 0) {
          const l = 6 / o;
          this.baseScale = l, this.modelContainer.scale.set(l, l, l);
        }
        this.modelContainer.rotation.y = Math.PI, this.rawModel.traverse((l) => {
          if (l instanceof zt) {
            l.name.toLowerCase().includes("cap") && (this.capMesh = l, this.capMesh.material instanceof Yt && (this.capMesh.material.transparent = !0, this.capMesh.material.opacity = 1, this.capStartY = this.capMesh.position.y)), l.name === "Powder" && l.material instanceof Yt && (l.material.transparent = !0, l.material.opacity = 1, l.material.depthWrite = !0, l.material.side = fi, l.material instanceof Pr && (l.material.needsUpdate = !0));
            const c = l.material;
            if (c) {
              const h = (d) => {
                d && (d.anisotropy = this.renderer.capabilities.getMaxAnisotropy(), d.minFilter = bt, d.magFilter = bt, d.needsUpdate = !0);
              };
              h(c.map), h(c.emissiveMap), h(c.roughnessMap), h(c.metalnessMap), h(c.normalMap), c.normalMap && (c.normalMap.flipY = !1), h(c.alphaMap), h(c.aoMap), h(c.clearcoatMap), h(c.clearcoatRoughnessMap), h(c.transmissionMap);
            }
          }
        });
      },
      void 0,
      (i) => {
        console.error("An error happened loading the GLB", i);
      }
    );
  }
  setSection(e, t) {
    if (this.isAutoRotating = !1, !this.modelContainer) return;
    const i = e === ni.length - 1, n = this.currentSectionIndex === ni.length - 1;
    if (i) {
      if (this.animationAction) {
        this.animationAction.reset(), this.animationAction.timeScale = 8, this.animationAction.play(), this.animationTimeout && (clearTimeout(this.animationTimeout), this.animationTimeout = null), this.pendingRotationIndex = e, this.pendingRotationCallback = t || null;
        return;
      }
    } else n ? (this.animationAction && (this.animationAction.paused = !1, this.animationAction.timeScale = -6, this.animationAction.setLoop(oc, 1), this.animationAction.clampWhenFinished = !0, this.animationAction.play()), this.pendingRotationIndex = -1) : (this.animationAction && (this.animationAction.stop(), this.capMesh && (this.capMesh.position.y = this.capStartY, this.capMesh.material instanceof Yt && (this.capMesh.material.opacity = 1))), this.pendingRotationIndex = -1);
    this.currentSectionIndex = e, e > 0 && !ni[e].isIdle && (this.hasLeftIdle = !0), this.rotateToSection(e);
  }
  rotateToSection(e) {
    this.updateModelTarget(e);
  }
  updateModelTarget(e) {
    if (!this.modelContainer) return;
    const t = ni[e];
    if (t.isIdle) {
      this.isAutoRotating = !0, this.targetQuaternion = null;
      return;
    }
    const i = t.view, r = new kt().setFromQuaternion(
      this.modelContainer.quaternion,
      "YXZ"
    ).y, a = new si().setFromAxisAngle(
      new O(0, 1, 0),
      r
    ), o = new si();
    if (t.modelRotationY !== void 0) {
      const l = hc.degToRad(t.modelRotationY);
      o.setFromEuler(new kt(0, l, 0));
    } else
      switch (i) {
        case "front":
          o.setFromEuler(new kt(0, 0, 0));
          break;
        case "back":
          o.setFromEuler(new kt(0, Math.PI, 0));
          break;
        case "left":
          o.setFromEuler(new kt(0, -Math.PI / 2, 0));
          break;
        case "right":
          o.setFromEuler(new kt(0, Math.PI / 2, 0));
          break;
        case "top":
          o.setFromAxisAngle(new O(1, 0, 0), Math.PI / 2).multiply(a);
          break;
        case "bottom":
          o.setFromAxisAngle(new O(1, 0, 0), -Math.PI / 2).multiply(a);
          break;
      }
    this.targetQuaternion = o, i === "top" || i === "bottom" || e === ni.length - 1 ? this.targetZoom = 1.25 : this.targetZoom = 1, this.powderTimeout && (clearTimeout(this.powderTimeout), this.powderTimeout = null), i === "top" ? (this.targetPowderOpacity = 0, this.powderTimeout = window.setTimeout(() => {
      this.targetPowderOpacity = 1;
    }, 750)) : (this.targetPowderOpacity = 0, this.powderMesh && (this.powderMesh.material.opacity = 0));
  }
  dispose() {
    this.animationId && cancelAnimationFrame(this.animationId), window.removeEventListener("resize", this.handleResize), this.renderer.dispose();
  }
}
const YS = '@keyframes slideInRight{0%{opacity:0;transform:translate(30px)}to{opacity:1;transform:translate(0)}}:host{display:block;width:100%;position:relative;font-family:var(--vh-font-poppins)}.wrapper{position:relative;width:100%;max-width:1440px;margin:0 auto}.model-wrapper{position:relative;width:100%;height:100%;min-width:0;z-index:10}.vh-microsite-interactive-model{width:min(600px,100%,100cqh);height:min(600px,100%,100cqh);box-sizing:border-box;position:absolute;top:0;left:50%;transform:translate(-50%);overflow:hidden}.vh-microsite-interactive-model canvas{display:block;width:100%!important;height:100%!important}.rings-container{width:min(600px,100%,100cqh);height:min(600px,100%,100cqh);box-sizing:border-box;position:absolute;top:0;left:50%;transform:translate(-50%);pointer-events:none;z-index:0;transition:transform 1.2s cubic-bezier(.16,1,.3,1),z-index 0s 1.2s}.rings-container.top-view{z-index:15;transform:translate(-50%);transition:transform 1.2s cubic-bezier(.16,1,.3,1),z-index 0s 0s}.rings-container .ring{position:absolute;top:0;left:0;width:100%;height:100%;display:flex;align-items:center;justify-content:center}.rings-container .ring img{display:block;object-fit:contain}.rings-container .ring.outer{z-index:1;width:100%;height:100%}.rings-container .ring.text-layer{z-index:2;transform:rotate(var(--ring-rotation, 0deg));transition:transform 1.2s cubic-bezier(.16,1,.3,1)}.rings-container .ring.text-layer .base{opacity:.6;filter:brightness(.7)}.rings-container .ring.text-layer .highlight-overlay{position:absolute;top:0;left:0;width:100%;height:100%;display:flex;align-items:center;justify-content:center;transition:opacity .4s ease;mask-image:conic-gradient(from calc(var(--highlight-angle) - var(--highlight-width) / 2),transparent 0deg,black 0deg,black var(--highlight-width),transparent var(--highlight-width));-webkit-mask-image:conic-gradient(from calc(var(--highlight-angle) - var(--highlight-width) / 2),transparent 0deg,black 0deg,black var(--highlight-width),transparent var(--highlight-width))}.rings-container .ring.text-layer .highlight-overlay img{filter:brightness(0) saturate(100%) invert(13%) sepia(10%) saturate(3036%) hue-rotate(170deg) brightness(96%) contrast(97%)}.rings-container .ring.inner{z-index:3}.section{width:100%;min-height:80vh;scroll-snap-align:start;position:relative;z-index:1}.section[data-index="0"]{min-height:10vh;height:10vh}.section:last-of-type{min-height:200vh}.content-overlay{position:fixed;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:20}.controls-wrapper{position:absolute;top:300px;left:40px;transform:translateY(-50%);z-index:10;opacity:0;pointer-events:none;transition:opacity .6s ease}.controls-wrapper.visible{opacity:1;pointer-events:auto}.swipe-hint{display:none}.controls-list{display:flex;flex-direction:column;gap:16px}.control-item{background:transparent;border:none;padding:2px 25px 2px 2px;border-radius:50px;display:flex;align-items:center;gap:8px;cursor:pointer;transition:all .3s ease;text-align:left;outline:none;width:fit-content}.control-item .icon{width:24px;height:24px;display:flex;align-items:center;justify-content:center;opacity:1;transition:filter .3s ease}.control-item .icon img{width:100%;height:100%;display:block}.control-item .label{font-family:var(--vh-font-poppins);font-size:16px;font-style:normal;font-weight:400;line-height:1.5;color:var(--vh-color-navy);opacity:.7;transition:color .3s ease,opacity .3s ease}.control-item:hover .label{opacity:1}.control-item.active{background-color:var(--vh-color-light-green)}.control-item.active .icon{filter:brightness(0) invert(1)}.control-item.active .label{color:var(--vh-color-white);opacity:1;font-weight:600}.controls{position:absolute;top:300px;left:20px;transform:translateY(-50%);display:flex;flex-direction:column;gap:12px;z-index:10;pointer-events:none}.controls button{pointer-events:auto;padding:12px 24px;background:#ffffffe6;border:1px solid rgba(0,0,0,.1);border-radius:8px;font-family:var(--vh-font-poppins);font-size:14px;color:#333;cursor:pointer;transition:all .2s ease;box-shadow:0 4px 6px #0000000d;font-weight:500;text-align:center;width:160px}.controls button:hover{background:var(--vh-color-white);transform:translate(4px);box-shadow:0 6px 12px #0000001a}.controls button:active{transform:translate(2px);box-shadow:0 2px 4px #0000000d}.info-card{position:absolute;top:240px;right:40px;transform:translateY(-50%);width:261px;background-color:#f0fdf4;border-radius:12px;padding:24px;box-shadow:0 4px 20px #0000000d;z-index:10;font-family:var(--vh-font-poppins);opacity:0;pointer-events:none;transition:opacity .6s ease}.info-card.mobile-card{display:none!important}.info-card.info-card--no-label{transition:none!important;opacity:0!important;pointer-events:none}.info-card.visible{opacity:1;pointer-events:auto}.info-card .card-header{display:flex;align-items:center;gap:10px;margin-bottom:12px}.info-card .card-header img{width:20px;height:20px;display:block}.info-card .card-header h3{margin:0;font-family:var(--vh-font-poppins);font-size:18px;font-style:normal;font-weight:400;line-height:1.2;font-weight:600;color:var(--vh-color-navy)}.info-card p{margin:0;font-family:var(--vh-font-poppins);font-size:14px;font-style:normal;font-weight:300;line-height:1.3;color:#334155}.section-overlays{position:absolute;inset:0;pointer-events:none;z-index:15}.section-overlay{position:absolute;inset:0;width:100%;height:100%}.callout-overlay{position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:15;opacity:0}@keyframes drawLine{to{stroke-dashoffset:0}}.callout-overlay .single-callout-dot{opacity:0}.callout-overlay.visible{opacity:1;transition:opacity .4s ease}.callout-overlay.visible .single-callout-line{opacity:1;animation:drawLine .5s ease-out forwards}.callout-overlay.visible .single-callout-dot{animation:fadeIn .3s ease-out forwards;animation-delay:.4s}.callout-overlay path{transition:d .1s linear}.header-overlay{grid-area:stack;position:relative;margin:0 auto;top:auto;bottom:auto;width:100%;max-width:900px;z-index:20;text-align:center;display:flex;flex-direction:column;align-items:center;gap:16px;pointer-events:none;transition:none}.header-overlay.has-body{top:auto}.header-overlay .title{margin:0;color:var(--vh-color-navy);text-align:center;font-family:var(--vh-font-feature-display-condensed);font-size:62px;font-style:normal;font-weight:400;line-height:100%;opacity:0;animation:slideInRight .8s ease-out forwards;animation-delay:0ms}.header-overlay .title em{font-family:var(--vh-font-feature-display-condensed);font-size:62px;font-style:italic;font-weight:700;line-height:100%;color:var(--vh-color-navy)}.header-overlay .title sup{font-size:.19em;position:relative;top:-14px;vertical-align:super;line-height:0}.header-overlay .features{display:flex;align-items:center;justify-content:center;gap:24px;margin-top:8px}.header-overlay .features .feature-item{display:flex;align-items:center;gap:8px}.header-overlay .features .feature-item .check-icon{display:flex;align-items:center;justify-content:center}.header-overlay .features .feature-item span{font-family:var(--vh-font-poppins);font-size:16px;font-style:normal;font-weight:400;line-height:1.5;color:var(--vh-color-navy)}.header-overlay .features .feature-item{opacity:0;animation:slideInRight .8s ease-out forwards;animation-delay:.3s}.header-overlay .body-text{margin:0;font-family:var(--vh-font-poppins);font-style:normal;font-weight:400;line-height:1.5;font-size:16px;color:var(--vh-color-navy);max-width:900px;text-align:center;opacity:0;animation:slideInRight .8s ease-out forwards;animation-delay:.6s}.header-overlay .cta-link{pointer-events:auto;display:flex;align-items:center;gap:8px;text-decoration:none;color:var(--vh-color-navy);font-family:var(--vh-font-poppins);font-size:18px;font-style:normal;font-weight:400;line-height:1.2;font-weight:600;transition:opacity .2s ease;opacity:0;animation:slideInRight .8s ease-out forwards;animation-delay:.9s}.header-overlay .cta-link:hover{opacity:.8}.header-overlay.last-section .title{animation-delay:1.5s}.header-overlay.last-section .features .feature-item{animation-delay:1.8s}.header-overlay.last-section .body-text{animation-delay:2.1s}.header-overlay.last-section .cta-link{animation-delay:2.4s}.header-overlay.exiting{pointer-events:none;animation:fadeOut .8s ease-out forwards;animation-delay:.8s;z-index:10}.header-overlay.exiting .title,.header-overlay.exiting .features .feature-item,.header-overlay.exiting .body-text,.header-overlay.exiting .cta-link{animation:none;opacity:1;transform:none}.header-stack{display:grid;grid-template-areas:"stack";width:100%;min-height:150px;align-items:center}@keyframes fadeOut{0%{opacity:1}to{opacity:0}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}.header-area{position:relative;width:100%;padding-top:30px;flex:0 0 auto;z-index:20;pointer-events:none;box-sizing:border-box;background-color:#ffffffbf}.sticky-content{position:sticky;top:92px;height:100vh;display:flex;flex-direction:column;overflow:hidden;z-index:10}.interactive-area{position:relative;width:100%;min-width:0;min-height:0;flex:1;display:flex;flex-direction:column;z-index:10;margin-top:20px}.multi-callout-group{opacity:0}.callout-overlay.visible .multi-callout-group{animation:fadeIn .6s ease-out forwards;animation-delay:calc(var(--i, 0) * .4s + .2s)}.multi-callout-labels{position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:20}.callout-label{display:flex;flex-direction:row;align-items:center;gap:8px;color:var(--vh-color-navy);white-space:nowrap;opacity:0;animation:fadeIn .6s ease-out forwards;animation-delay:calc(var(--i, 0) * .4s + .2s)}.callout-label.left{justify-content:flex-end;padding-right:12px}.callout-label.right{justify-content:flex-start;padding-left:12px}.callout-label .number{color:var(--vh-color-navy);font-family:var(--vh-font-poppins);font-weight:200;font-size:52px;font-style:normal;line-height:100%;letter-spacing:-2.08px;margin-bottom:0}.callout-label .text{color:var(--vh-color-navy);font-family:var(--vh-font-poppins);font-size:16px;font-style:normal;font-weight:400;line-height:120%;text-align:inherit;white-space:normal;max-width:min-content}@keyframes fadeIn{to{opacity:1}}', KS = ".pulse-dot{--pulse-dot-size: 200px;display:flex;align-items:center;justify-content:center;width:var(--pulse-dot-size);height:var(--pulse-dot-size)}.pulse-dot__svg{width:100%;height:100%;display:block}";
var ZS = Object.defineProperty, JS = Object.getOwnPropertyDescriptor, oh = (s, e, t, i) => {
  for (var n = i > 1 ? void 0 : i ? JS(e, t) : e, r = s.length - 1, a; r >= 0; r--)
    (a = s[r]) && (n = (i ? a(e, t, n) : a(n)) || n);
  return i && n && ZS(e, t, n), n;
};
let Lr = class extends Ie {
  constructor() {
    super(...arguments), this.stroke = "#002C4E", this.size = 200;
  }
  render() {
    const s = this.stroke;
    return $`
      <div class="pulse-dot" style="--pulse-dot-size: ${this.size}px;">
        <svg
          class="pulse-dot__svg"
          width="40"
          height="40"
          viewBox="0 0 40 40"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="20"
            cy="20"
            fill="none"
            r="10"
            stroke="${s}"
            stroke-width="2"
          >
            <animate
              attributeName="r"
              from="8"
              to="20"
              dur="1.5s"
              begin="0s"
              repeatCount="indefinite"
            />
            <animate
              attributeName="opacity"
              from="1"
              to="0"
              dur="1.5s"
              begin="0s"
              repeatCount="indefinite"
            />
          </circle>
        </svg>
      </div>
    `;
  }
};
Lr.styles = Je`
    ${We(KS)}
  `;
oh([
  D({ type: String })
], Lr.prototype, "stroke", 2);
oh([
  D({ type: Number })
], Lr.prototype, "size", 2);
Lr = oh([
  Oe("vh-microsite-pulse-dot")
], Lr);
const QS = '@charset "UTF-8";:host{display:block;width:100%;position:relative;font-family:var(--vh-font-poppins);box-sizing:border-box}.wrapper{position:relative;padding:80px 16px;display:flex;flex-direction:column;align-items:center;overflow:hidden}.header-overlay{text-align:center;display:flex;flex-direction:column;align-items:center;gap:16px;max-width:100%}.header-overlay .title{margin:0;color:var(--vh-color-navy);text-align:center;font-family:var(--vh-font-feature-display-condensed);font-size:54px;font-style:normal;font-weight:400;line-height:1;letter-spacing:-1px;max-width:350px}.header-overlay .title em{font-family:var(--vh-font-feature-display-condensed);font-size:54px;font-style:italic;font-weight:700;line-height:1;color:var(--vh-color-navy)}.header-overlay .title sup{font-size:.19em;position:relative;top:-14px;vertical-align:super;line-height:0}.header-overlay .features-container{display:flex;justify-content:center;width:100%;margin-top:16px}.header-overlay .features{display:flex;flex-direction:column;align-items:flex-start;gap:12px}.header-overlay .features .feature-item{display:flex;align-items:center;gap:8px}.header-overlay .features .feature-item .check-icon{display:flex;align-items:center;justify-content:center;width:24px;height:24px}.header-overlay .features .feature-item .check-icon img{width:100%;height:100%}.header-overlay .features .feature-item span{font-family:var(--vh-font-poppins);font-style:normal;font-weight:400;line-height:1.5;color:var(--vh-color-navy);font-size:16px}.header-overlay .body-text{margin:16px 0 0;font-family:var(--vh-font-poppins);font-style:normal;font-weight:400;line-height:1.5;font-size:16px;color:var(--vh-color-navy);text-align:center;max-width:100%}.image-wrapper{margin-bottom:80px;width:100%;display:flex;justify-content:center;position:relative}.image-wrapper .mobile-idle-image{max-width:100%;height:auto;object-fit:contain;display:block;opacity:0;animation:fadeInSoft .6s ease-out .15s forwards}@media(max-width:400px){.image-wrapper .mobile-idle-image{transform:scale(1)}}.gallery-section{width:100%;margin-bottom:40px;display:flex;flex-direction:column;align-items:center}.gallery-container{width:calc(100% + 32px);margin-left:-16px;margin-right:-16px;position:relative}.gallery-header{margin-left:-16px;margin-right:-16px;margin-bottom:-24px}.gallery-images-display{position:relative;width:100%;height:400px;display:flex;justify-content:center;align-items:center;margin-bottom:40px}.gallery-image-block{display:inline-block;position:relative;width:375px;height:400px}.gallery-image-block img{width:100%;height:400px}.gallery-pulse-dot{position:absolute;left:var(--pulse-dot-left, 50%);top:var(--pulse-dot-top, 50%);transform:translate(-50%,-50%);pointer-events:none;z-index:5;opacity:0}.gallery-pulse-dot.active{opacity:1;transition:opacity 1s ease-in-out}.gallery-image{width:100%;height:auto;object-fit:contain;border-radius:8px;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);opacity:0;transition:opacity 1s ease-in-out;z-index:1}.gallery-image.active{opacity:1;z-index:2}.gallery-scroll{position:absolute;top:0;left:0;width:100%;height:400px;display:flex;overflow-x:auto;scroll-snap-type:x mandatory;scroll-behavior:smooth;-webkit-overflow-scrolling:touch;scrollbar-width:none;z-index:10;opacity:0}.gallery-scroll::-webkit-scrollbar{display:none}.gallery-item{flex:0 0 100%;width:100%;height:100%;scroll-snap-align:center}@media(min-width:600px){.image-wrapper .mobile-idle-image{transform:scale(1.35);max-width:400px}.header-overlay .dynamic-text{max-width:500px!important}}.swipe-hint{color:color-mix(in srgb,var(--vh-color-navy) 65%,transparent);text-align:center;font-family:var(--vh-font-ibm-plex-sans);font-style:normal;line-height:1.2;font-size:12px;font-weight:700;margin-top:8px;text-transform:uppercase}.gallery-dots-container{display:flex;width:calc(100vw - 32px);gap:16px;margin-top:16px;padding:0 16px 32px;overflow-x:auto;scroll-snap-type:x mandatory;scroll-behavior:smooth;-webkit-overflow-scrolling:touch;scrollbar-width:none}.gallery-dots-container::-webkit-scrollbar{display:none}.gallery-dot{flex-shrink:0;border-radius:50px;scroll-snap-align:center;background-color:transparent;border:1px solid #E5E7EB;color:var(--vh-color-navy);font-family:var(--vh-font-poppins);font-size:14px;font-style:normal;font-weight:300;line-height:1.3;font-size:16px;font-weight:600;display:flex;align-items:center;justify-content:center;gap:12px;padding:8px 12px 8px 8px;cursor:pointer;transition:background-color .3s ease,border-color .3s ease,color .3s ease,transform .3s ease,opacity .3s ease}.gallery-dot .check-icon{display:flex;align-items:center;justify-content:center;width:24px;height:24px;flex-shrink:0}.gallery-dot .check-icon svg path{transition:stroke .3s ease}.gallery-dot.active{background-color:var(--vh-color-light-green);border-color:var(--vh-color-light-green);color:var(--vh-color-white);opacity:1}.gallery-dot:not(.active){opacity:.7}.info-card-container{min-height:200px;display:grid;padding:0 16px}.info-card{grid-area:1/1;background-color:#f4f7ee;border-radius:12px;padding:24px;display:flex;flex-direction:column;gap:16px;opacity:0;animation:fadeInInfoCard .3s ease-out forwards;margin:0 auto}.info-card .info-card-header{display:flex;align-items:center;gap:8px}.info-card .info-card-header .check-icon{display:flex;align-items:center;justify-content:center;width:24px;height:24px;flex-shrink:0}.info-card .info-card-header .info-card-title{margin:0;font-family:var(--vh-font-poppins);font-style:normal;font-weight:400;line-height:1.2;color:var(--vh-color-navy);font-size:18px;font-weight:700}.info-card .info-card-text{margin:0;font-family:var(--vh-font-poppins);font-style:normal;font-weight:300;line-height:1.3;color:var(--vh-color-navy);font-size:14px;line-height:1.5}.dynamic-design-section{width:100%;margin-top:80px;display:flex;flex-direction:column;align-items:center}.dynamic-design-section.pre-animate .dynamic-title,.dynamic-design-section.pre-animate .dynamic-text,.dynamic-design-section.pre-animate .cta-link{opacity:0}.dynamic-design-section.animate .dynamic-title{opacity:0;animation:fadeInFromRight .5s ease-out forwards}.dynamic-design-section.animate .dynamic-text{opacity:0;animation:fadeInFromRight .5s ease-out forwards;animation-delay:.6s}.dynamic-design-section.animate .cta-link{opacity:0;animation:fadeInFromRight .5s ease-out forwards;animation-delay:.7s}.dynamic-design-section .header-overlay{text-align:center;max-width:100%;display:flex;flex-direction:column;align-items:center;gap:24px}.dynamic-design-section .header-overlay .dynamic-text{color:var(--vh-color-navy);max-width:340px;margin:0 auto;font-family:var(--vh-font-poppins);font-size:16px;font-style:normal;font-weight:400;line-height:1.5}.dynamic-design-section .header-overlay .cta-link{display:flex;align-items:center;justify-content:center;gap:8px;color:var(--vh-color-navy);font-family:var(--vh-font-poppins);font-size:18px;font-style:normal;font-weight:400;line-height:1.2;font-weight:600;text-decoration:none;text-transform:capitalize}.dynamic-design-section .header-overlay .cta-link svg{flex-shrink:0}.dynamic-design-section .powder-image-wrapper{margin-top:80px;width:100%;display:flex;justify-content:center}.dynamic-design-section .powder-image-wrapper .powder-image{max-width:100%;height:auto;object-fit:contain}.dynamic-design-section .scroll-timeline{position:relative;padding:40px 0 0;margin:0 auto;width:100%;max-width:320px;display:flex;flex-direction:column}.dynamic-design-section .scroll-timeline .timeline-line-track{position:absolute;left:50%;top:0;bottom:60px;width:2px;transform:translate(-50%)}.dynamic-design-section .scroll-timeline .timeline-line-bg{position:absolute;inset:0;width:2px;background-color:var(--vh-color-navy);opacity:0}.dynamic-design-section .scroll-timeline .timeline-line-progress{position:absolute;left:0;top:0;width:2px;height:100%;background-color:var(--vh-color-navy);transition:height .1s linear}.dynamic-design-section .scroll-timeline .timeline-row{position:relative;display:flex;align-items:center;opacity:0;transition:opacity .5s ease,transform .5s ease;height:120px;transform:translateY(10px)}.dynamic-design-section .scroll-timeline .timeline-row.active{opacity:1;transform:translateY(0)}.dynamic-design-section .scroll-timeline .timeline-row.active .timeline-dot{transform:scale(1);opacity:1}.dynamic-design-section .scroll-timeline .timeline-row .timeline-number{flex:1;text-align:right;padding-right:24px;color:var(--vh-color-navy);font-family:var(--vh-font-ibm-plex-sans);font-size:72px;font-style:normal;font-weight:300;line-height:100%;letter-spacing:-2.88px}.dynamic-design-section .scroll-timeline .timeline-row .timeline-dot{width:8px;height:8px;border-radius:50%;background-color:var(--vh-color-navy);z-index:2;flex-shrink:0;transform:scale(0);opacity:0;transition:transform .4s ease .2s,opacity .4s ease .2s}.dynamic-design-section .scroll-timeline .timeline-row .timeline-text{flex:1;text-align:left;padding-left:24px;color:var(--vh-color-navy);font-family:var(--vh-font-poppins);font-size:20px;font-style:normal;font-weight:400;line-height:1.2}@keyframes fadeInSoft{0%{opacity:0}to{opacity:1}}@keyframes fadeInFromRight{0%{opacity:0;transform:translate(50px)}to{opacity:1;transform:translate(0)}}@keyframes fadeInInfoCard{0%{opacity:0}30%{opacity:0}to{opacity:1}}';
var e1 = Object.defineProperty, t1 = Object.getOwnPropertyDescriptor, yi = (s, e, t, i) => {
  for (var n = i > 1 ? void 0 : i ? t1(e, t) : e, r = s.length - 1, a; r >= 0; r--)
    (a = s[r]) && (n = (i ? a(e, t, n) : a(n)) || n);
  return i && n && e1(e, t, n), n;
};
const _a = {
  left: "50%",
  top: "50%",
  size: 80
};
let Zt = class extends Ie {
  constructor() {
    super(...arguments), this.selectedGalleryIndex = 0, this.isDynamicVisible = !1, this.timelineProgress = 0, this.imageHeader = "", this.imagePowder = "", this.idleHeader = null, this.galleryHeaderTitle = "What's Inside & Why", this.galleryImages = [
      { image: "", pulseDot: { ..._a }, title: "", text: "" },
      { image: "", pulseDot: { ..._a }, title: "", text: "" },
      { image: "", pulseDot: { ..._a }, title: "", text: "" }
    ], this.dynamicHeader = null, this.timelineItems = [], this.handleWindowScroll = () => {
      const s = this.shadowRoot?.querySelector(
        ".scroll-timeline"
      );
      if (!s) return;
      const e = s.getBoundingClientRect(), t = window.innerHeight, i = t * 0.7, n = t - e.height, r = i - n, o = (i - e.top) / r * 100;
      this.timelineProgress = Math.max(0, Math.min(100, o));
    };
  }
  connectedCallback() {
    super.connectedCallback(), window.addEventListener("scroll", this.handleWindowScroll), this.dynamicObserver = new IntersectionObserver(
      (s) => {
        s.forEach((e) => {
          e.isIntersecting && !this.isDynamicVisible && (this.isDynamicVisible = !0);
        });
      },
      { threshold: 0.1 }
    );
  }
  disconnectedCallback() {
    super.disconnectedCallback(), window.removeEventListener("scroll", this.handleWindowScroll), this.dynamicObserver?.disconnect();
  }
  firstUpdated() {
    const s = this.shadowRoot?.querySelector(
      ".dynamic-design-section"
    );
    s && this.dynamicObserver && this.dynamicObserver.observe(s);
  }
  handleGalleryScroll() {
    if (!this.galleryScroll) return;
    const s = this.galleryScroll.scrollLeft, e = this.galleryScroll.offsetWidth, t = Math.round(s / e);
    this.selectedGalleryIndex !== t && (this.selectedGalleryIndex = t, this.scrollActiveDotIntoView());
  }
  handleDotClick(s) {
    if (!this.galleryScroll) return;
    const e = this.galleryScroll.offsetWidth;
    this.galleryScroll.scrollTo({
      left: e * s,
      behavior: "smooth"
    }), this.selectedGalleryIndex = s, this.scrollActiveDotIntoView();
  }
  async scrollActiveDotIntoView() {
    await this.updateComplete;
    const e = this.shadowRoot?.querySelector(
      ".gallery-dots-container"
    )?.querySelector(".gallery-dot.active");
    e && e.scrollIntoView({
      behavior: "smooth",
      inline: "center",
      block: "nearest"
    });
  }
  render() {
    const s = this.idleHeader, e = this.dynamicHeader;
    return $`
      <div class="wrapper">
        <vh-microsite-tout
          heading="${s?.title ?? ""}"
          .headingLevel=${2}
          .list=${s?.features ?? []}
          body="${s?.body ?? ""}"
          animateIn
        ></vh-microsite-tout>
          
        <div class="image-wrapper">
          <img src="${this.imageHeader}" class="mobile-idle-image" alt="Truth Powers Better Health - Green Vibrance" />
        </div>

        <div class="gallery-section">
          <div class="gallery-header">
            <vh-microsite-tout
              heading="${this.galleryHeaderTitle}"
              .headingLevel=${2}
              animateIn
            ></vh-microsite-tout>
          </div>
            
          <div class="gallery-container">
            <div class="gallery-images-display">
              <div class="gallery-image-block">
                ${this.galleryImages.map(
      (t, i) => $`
                    <img
                      src="${t.image}"
                      class="gallery-image ${this.selectedGalleryIndex === i ? "active" : ""}"
                      alt="Label ${i + 1}"
                    />
                  `
    )}

                ${this.galleryImages.map((t, i) => {
      const n = t.pulseDot ?? _a, r = n.size ?? 80;
      return $`
                      <div
                        class="gallery-pulse-dot ${this.selectedGalleryIndex === i ? "active" : ""}"
                        style="--pulse-dot-left: ${n.left}; --pulse-dot-top: ${n.top};"
                      >
                        <vh-microsite-pulse-dot
                          stroke="#002C4E"
                          size="${r}"
                        ></vh-microsite-pulse-dot>
                      </div>
                    `;
    })}
              </div>

              <div class="gallery-scroll" @scroll="${this.handleGalleryScroll}">
                ${this.galleryImages.map(
      () => $`<div class="gallery-item"></div>`
    )}
              </div>
            </div>
                
            <div class="swipe-hint">SWIPE THROUGH OUR TRUTHS</div>
            <div class="gallery-dots-container">
              ${this.galleryImages.map(
      (t, i) => $`
              <button 
                class="gallery-dot ${this.selectedGalleryIndex === i ? "active" : ""}"
                @click="${() => this.handleDotClick(i)}"
                aria-label="Go to slide ${i + 1}"
              >
                  <div class="check-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="${this.selectedGalleryIndex === i ? "#ffffff" : "#84C12F"}" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M9 12L11 14L15 10" stroke="${this.selectedGalleryIndex === i ? "#ffffff" : "#84C12F"}" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                  <span>${t.title}</span>
              </button>
              `
    )}
            </div>

            ${(() => {
      const t = this.galleryImages[this.selectedGalleryIndex];
      return t ? $`<div class="info-card-container">${Lu(
        this.selectedGalleryIndex,
        $`
                  <div class="info-card">
                    <div class="info-card-header">
                      <div class="check-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="#84c12f" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10"/><path stroke="#84c12f" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m9 12 2 2 4-4"/></svg>
                      </div>
                      <h3 class="info-card-title">${t.title}</h3>
                    </div>
                    <p class="info-card-text">${t.text}</p>
                  </div>
                `
      )}</div>` : $`<div class="info-card-container"></div>`;
    })()}
          </div>
        </div>

        <div class="dynamic-design-section ${this.isDynamicVisible ? "animate" : "pre-animate"}">
          <div class="header-overlay">
            <h2 class="title dynamic-title">${e?.title ? Qe(e.title) : ""}</h2>
            <p class="body-text dynamic-text">${e?.body ?? ""}</p>
            
            ${e?.ctaLabel && e?.ctaUrl ? $`<a href="${e.ctaUrl}" class="cta-link">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="#76b729" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 12h14M12 5l7 7-7 7"/></svg>
                  ${e.ctaLabel}
                </a>` : ""}
          </div>
          
          <div class="powder-image-wrapper">
            <img src="${this.imagePowder}" alt="Dynamic by Design Powder" class="powder-image" />
          </div>

          <div class="scroll-timeline">
            <div class="timeline-line-track">
              <div class="timeline-line-bg"></div>
              <div class="timeline-line-progress" style="height: ${this.timelineProgress}%;"></div>
            </div>
            ${this.timelineItems.map(
      (t) => $`
                <div class="timeline-row ${this.timelineProgress > t.threshold ? "active" : ""}">
                  <div class="timeline-number">${t.number}</div>
                  <div class="timeline-dot"></div>
                  <div class="timeline-text">${Qe(t.text)}</div>
                </div>
              `
    )}
          </div>
        </div>
      </div>
    `;
  }
};
Zt.styles = Je`
    ${We(QS)}
  `;
yi([
  ft()
], Zt.prototype, "selectedGalleryIndex", 2);
yi([
  ft()
], Zt.prototype, "isDynamicVisible", 2);
yi([
  ft()
], Zt.prototype, "timelineProgress", 2);
yi([
  Gs(".gallery-scroll")
], Zt.prototype, "galleryScroll", 2);
yi([
  D({ type: String })
], Zt.prototype, "imageHeader", 2);
yi([
  D({ type: String })
], Zt.prototype, "imagePowder", 2);
yi([
  D({ type: Object })
], Zt.prototype, "idleHeader", 2);
yi([
  D({ type: String })
], Zt.prototype, "galleryHeaderTitle", 2);
yi([
  D({ type: Array })
], Zt.prototype, "galleryImages", 2);
yi([
  D({ type: Object })
], Zt.prototype, "dynamicHeader", 2);
yi([
  D({ type: Array })
], Zt.prototype, "timelineItems", 2);
Zt = yi([
  Oe("vh-microsite-interactive-model-mobile")
], Zt);
var i1 = Object.defineProperty, n1 = Object.getOwnPropertyDescriptor, Ue = (s, e, t, i) => {
  for (var n = i > 1 ? void 0 : i ? n1(e, t) : e, r = s.length - 1, a; r >= 0; r--)
    (a = s[r]) && (n = (i ? a(e, t, n) : a(n)) || n);
  return i && n && i1(e, t, n), n;
};
const s1 = 900, r1 = 50, cu = 100, hu = 400, a1 = 1e3;
let Le = class extends Ie {
  constructor() {
    super(...arguments), this.modelPath = "", this.imagePath = "", this.mobileImageHeader = "", this.mobileImagePowder = "", this.desktopImagePowder = "/images/vh-microsite-green-powder-v2.png", this.galleryImages = [], this.currentSectionIndex = 0, this.controlsVisible = !1, this.sectionCallouts = {}, this.sectionMultiCallouts = {}, this.isCalloutFading = !1, this.isCardVisible = !1, this.ringRotation = 0, this.highlightAngle = 0, this.showHighlight = !1, this.highlightWidth = 0.8, this.isTopView = !1, this.disableRingTransition = !1, this.rafId = 0, this.ambientIntensity = 1.2, this.keyLightIntensity = 2, this.keyLightX = -10, this.keyLightY = 10, this.keyLightZ = 10, this.fillLightIntensity = 0.8, this.fillLightX = 10, this.fillLightY = 5, this.fillLightZ = 10, this.backLightIntensity = 1, this.backLightX = 0, this.backLightY = 5, this.backLightZ = -10, this.powderOffsetX = 0.08, this.powderOffsetY = -0.14, this.powderRepeatX = 1, this.powderRepeatY = 1, this.sceneManager = null, this.sections = ni, this.previousSectionIndex = -1, this.observer = null, this.isProgrammaticScroll = !1, this.scrollTimeout = null, this.resizeTimeout = null, this.touchStartX = 0, this.touchEndX = 0, this.touchStartY = 0, this.touchEndY = 0, this.isMobile = !1, this.mediaQuery = typeof window < "u" ? window.matchMedia(`(max-width: ${s1}px)`) : null, this.boundMediaHandler = () => this.updateMobile(), this.calloutTimeout = null, this.cardTimeout = null, this.handleResize = () => {
      this.isMobile || (this.resizeTimeout && window.clearTimeout(this.resizeTimeout), this.resizeTimeout = window.setTimeout(() => {
        this.sceneManager && this.sceneManager.handleResize(), this.updateCalloutPath(), this.centerActiveControl(this.currentSectionIndex);
      }, cu));
    }, this.updateCalloutPath = () => {
      if (!this.infoCard || !this.modelWrapper || !this.container) return;
      const s = this.currentSection, e = s?.callout, t = s?.multiCallouts, i = this.container.getBoundingClientRect(), n = this.modelWrapper.getBoundingClientRect(), r = window.innerHeight, a = window.innerWidth;
      let o = 1;
      r <= 800 ? o = 0.75 : r <= 900 && (o = 0.85);
      let l = o ** 3;
      a < 1300 && (l *= 0.7);
      const c = i.left - n.left + i.width / 2, h = i.top - n.top + i.height / 2;
      if (e) {
        const d = this.infoCard.getBoundingClientRect(), u = c + e.start.x * o, f = h + e.start.y * o, g = d.left - n.left - 16, v = d.top - n.top + e.cardYOffset, m = g - e.horizontalLength * l, w = `M ${u} ${f} L ${m} ${v} L ${g} ${v}`;
        this.sectionCallouts = {
          ...this.sectionCallouts,
          [this.currentSectionIndex]: {
            path: w,
            start: { x: u, y: f },
            end: { x: g, y: v }
          }
        };
      } else
        this.sectionCallouts = {
          ...this.sectionCallouts,
          [this.currentSectionIndex]: null
        };
      if (t) {
        const d = t.map((u) => {
          const f = c + u.start.x * o, g = h + u.start.y * o, v = c + u.end.x * o, m = h + u.end.y * o, p = u.horizontalLength * l;
          let w = v;
          u.align === "left" ? w = v + p : w = v - p;
          const T = `M ${f} ${g} L ${w} ${m} L ${v} ${m}`;
          return {
            ...u,
            path: T,
            start: { x: f, y: g },
            end: { x: v, y: m }
          };
        });
        this.sectionMultiCallouts = {
          ...this.sectionMultiCallouts,
          [this.currentSectionIndex]: d
        };
      } else
        this.sectionMultiCallouts = {
          ...this.sectionMultiCallouts,
          [this.currentSectionIndex]: null
        };
    };
  }
  get currentSection() {
    return this.sections[this.currentSectionIndex] || this.sections[0];
  }
  connectedCallback() {
    super.connectedCallback(), this.mediaQuery && (this.isMobile = this.mediaQuery.matches, this.mediaQuery.addEventListener("change", this.boundMediaHandler));
  }
  updateMobile() {
    this.mediaQuery && (this.isMobile = this.mediaQuery.matches);
  }
  initDesktopScene() {
    !this.container || this.sceneManager || (this.sceneManager = new jS(
      this.container,
      this.modelPath,
      this.desktopImagePowder
    ), this.sceneManager.setSection(0), this.updateSceneLights(), this.updateScenePowder(), this.setupObserver(), setTimeout(() => {
      this.updateCalloutPath(), this.centerActiveControl(this.currentSectionIndex);
    }, cu));
  }
  firstUpdated() {
    window.addEventListener("resize", this.handleResize), this.isMobile || this.initDesktopScene();
  }
  async updated(s) {
    s.has("isMobile") && (this.isMobile ? (this.sceneManager && (this.sceneManager.dispose(), this.sceneManager = null), this.observer?.disconnect()) : (await this.updateComplete, this.initDesktopScene())), (s.has("ambientIntensity") || s.has("keyLightIntensity") || s.has("keyLightX") || s.has("keyLightY") || s.has("keyLightZ") || s.has("fillLightIntensity") || s.has("fillLightX") || s.has("fillLightY") || s.has("fillLightZ") || s.has("backLightIntensity") || s.has("backLightX") || s.has("backLightY") || s.has("backLightZ")) && this.updateSceneLights(), s.has("desktopImagePowder") && this.sceneManager && this.sceneManager.setDesktopPowderImage(this.desktopImagePowder).then(() => this.updateScenePowder()), (s.has("powderOffsetX") || s.has("powderOffsetY") || s.has("powderRepeatX") || s.has("powderRepeatY")) && this.sceneManager && this.sceneManager.updatePowderTexture(
      { x: this.powderOffsetX, y: this.powderOffsetY },
      { x: this.powderRepeatX, y: this.powderRepeatY }
    ), s.has("controlsVisible") && this.controlsVisible && (await this.updateComplete, setTimeout(() => this.updateCalloutPath(), r1)), (s.has("sectionCallouts") || s.has("currentSectionIndex") || s.has("isCardVisible") || s.has("isCalloutFading")) && (await this.updateComplete, this.measureSingleCallout()), s.has("currentSectionIndex") && (this.sections[this.currentSectionIndex]?.isIdle ? this.startIdleRotation() : (this.stopIdleRotation(), this.currentSectionIndex !== this.sections.length - 1 && this.updateRings()), this.centerActiveControl(this.currentSectionIndex));
  }
  async centerActiveControl(s) {
    await this.updateComplete;
    const e = this.shadowRoot?.querySelectorAll(".control-item");
    if (!e || !e[s] || window.innerWidth > 900) return;
    const t = e[s];
    t && t.scrollIntoView({
      behavior: "smooth",
      inline: "center",
      block: "nearest"
    });
  }
  updateSceneLights() {
    this.sceneManager && this.sceneManager.updateLights(
      this.ambientIntensity,
      this.keyLightIntensity,
      new O(this.keyLightX, this.keyLightY, this.keyLightZ),
      this.fillLightIntensity,
      new O(this.fillLightX, this.fillLightY, this.fillLightZ),
      this.backLightIntensity,
      new O(this.backLightX, this.backLightY, this.backLightZ)
    );
  }
  updateScenePowder() {
    this.sceneManager && this.sceneManager.updatePowderTexture(
      { x: this.powderOffsetX, y: this.powderOffsetY },
      { x: this.powderRepeatX, y: this.powderRepeatY }
    );
  }
  setupObserver() {
    const s = {
      root: null,
      rootMargin: "-50% 0px -50% 0px",
      threshold: 0
    };
    this.observer = new IntersectionObserver((e) => {
      this.isProgrammaticScroll || e.forEach((t) => {
        if (t.isIntersecting) {
          const i = Number(t.target.getAttribute("data-index"));
          if (!Number.isNaN(i)) {
            const n = this.sections[i]?.hidden, r = !this.controlsVisible;
            r && !n ? this.controlsVisible = !0 : n && (this.controlsVisible = !1), (r || this.currentSectionIndex !== i) && this.changeSection(i);
          }
        }
      });
    }, s), this.sectionElements.forEach((e) => {
      this.observer?.observe(e);
    });
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.mediaQuery?.removeEventListener("change", this.boundMediaHandler), window.removeEventListener("resize", this.handleResize), this.sceneManager && this.sceneManager.dispose(), this.observer && this.observer.disconnect();
  }
  changeSection(s) {
    if (this.currentSectionIndex === s && !this.isCalloutFading) return;
    this.calloutTimeout && clearTimeout(this.calloutTimeout), this.cardTimeout && clearTimeout(this.cardTimeout), this.sectionCallouts = { ...this.sectionCallouts, [s]: null }, this.sectionMultiCallouts = { ...this.sectionMultiCallouts, [s]: null }, this.cardTimeout && clearTimeout(this.cardTimeout), this.isCalloutFading = !0, this.isCardVisible = !1, s === this.sections.length - 1 ? (this.previousSectionIndex = this.currentSectionIndex, this.currentSectionIndex = s, this.isCalloutFading = !1, this.cardTimeout = window.setTimeout(() => {
      this.isCardVisible = !0;
    }, hu)) : (this.previousSectionIndex = -1, this.cardTimeout = window.setTimeout(() => {
      this.isCalloutFading = !1, this.isCardVisible = !0;
    }, hu)), this.currentSectionIndex = s, this.isTopView = s === this.sections.length - 1, this.sceneManager ? s === this.sections.length - 1 ? (this.showHighlight = !1, this.sceneManager.setSection(s, () => {
      this.updateRings(), setTimeout(() => {
        this.updateCalloutPath();
      }, 1200);
    })) : (this.sceneManager.setSection(s), this.updateCalloutPath()) : this.updateCalloutPath();
  }
  measureSingleCallout() {
    this.shadowRoot?.querySelectorAll(".single-callout-line")?.forEach((e) => {
      const t = e, i = t.getTotalLength();
      t.style.strokeDasharray = `${i}px`, t.style.strokeDashoffset = `${i}px`;
    });
  }
  handleSectionClick(s) {
    if (this.currentSectionIndex === s) return;
    this.isProgrammaticScroll = !0, this.scrollTimeout && clearTimeout(this.scrollTimeout), this.changeSection(s);
    const e = this.sectionElements[s];
    e && e.scrollIntoView({ behavior: "smooth" }), this.scrollTimeout = window.setTimeout(() => {
      this.isProgrammaticScroll = !1;
    }, a1);
  }
  handleTouchStart(s) {
    this.touchStartX = s.changedTouches[0].screenX, this.touchStartY = s.changedTouches[0].screenY;
  }
  handleTouchEnd(s) {
    this.touchEndX = s.changedTouches[0].screenX, this.touchEndY = s.changedTouches[0].screenY, this.handleSwipeGesture();
  }
  handleSwipeGesture() {
    const t = this.touchEndX - this.touchStartX, i = this.touchEndY - this.touchStartY;
    if (Math.abs(t) > 50 && Math.abs(i) < 50) {
      let n = this.currentSectionIndex;
      if (t > 0)
        do
          n--;
        while (n >= 0 && this.sections[n].hidden);
      else
        do
          n++;
        while (n < this.sections.length && this.sections[n].hidden);
      n >= 0 && n < this.sections.length && this.handleSectionClick(n);
    }
  }
  get mobileGalleryImages() {
    const s = {
      left: "50%",
      top: "50%",
      size: 80
    };
    return this.galleryImages.map((e, t) => ({
      image: e.image,
      pulseDot: e.pulseDot ?? { ...s },
      title: iu[t]?.title ?? "",
      text: iu[t]?.text ?? ""
    }));
  }
  render() {
    return this.isMobile ? $`<vh-microsite-interactive-model-mobile
        .imageHeader=${this.mobileImageHeader}
        .imagePowder=${this.mobileImagePowder}
        .idleHeader=${tS}
        .galleryHeaderTitle=${iS}
        .galleryImages=${this.mobileGalleryImages}
        .dynamicHeader=${nS}
        .timelineItems=${sS}
      ></vh-microsite-interactive-model-mobile>` : $`
      <div class="wrapper">
        <div class="sticky-content">
          <div class="header-area">
            ${this.renderHeader()}
          </div>
      
          <div class="interactive-area"
            @touchstart=${this.handleTouchStart}
            @touchend=${this.handleTouchEnd}
          >
            <div class="model-wrapper">
              <div class="vh-microsite-interactive-model ${this.isTopView ? "top-view" : ""}"></div>
              ${this.renderRings()}
              ${this.renderControls()}
              ${this.renderOverlays()}
              ${this.renderInfoCard()}
            </div>
          </div>
        </div>

        ${this.renderScrollSections()}
      </div>
      `;
  }
  renderHeader() {
    const s = (e, t) => {
      const n = this.sections[e]?.header;
      if (!n) return null;
      const r = !!n.body, a = e === this.sections.length - 1;
      return Lu(
        n.title + (t ? "-exit" : ""),
        $`
            <div class="header-overlay ${r ? "has-body" : ""} ${a ? "last-section" : ""} ${t ? "exiting" : ""}">
                <h2 class="title">${Qe(n.title)}</h2>
                
                ${n.features ? $`
                    <div class="features">
                      ${n.features.map(
          (o) => $`
                          <div class="feature-item">
                              <div class="check-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="#84c12f" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10"/><path stroke="#84c12f" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m9 12 2 2 4-4"/></svg>
                              </div>
                              <span>${o}</span>
                          </div>
                      `
        )}
                    </div>
                ` : ""}

                ${n.body ? $`
                    <p class="body-text">${Qe(n.body)}</p>
                ` : ""}

                ${n.ctaLabel ? $`
                    <a href="${n.ctaUrl || "#"}" class="cta-link">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5 12H19" stroke="#76B729" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M12 5L19 12L12 19" stroke="#76B729" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        ${n.ctaLabel}
                    </a>
                ` : null}
            </div>
        `
      );
    };
    return $`
      <div class="header-stack">
        ${this.previousSectionIndex !== -1 ? s(this.previousSectionIndex, !0) : null}
        ${s(this.currentSectionIndex, !1)}
      </div>
    `;
  }
  startIdleRotation() {
    if (this.rafId) return;
    this.disableRingTransition = !0;
    const s = () => {
      this.ringRotation += 0.05, this.rafId = requestAnimationFrame(s);
    };
    this.rafId = requestAnimationFrame(s);
    const e = this.sections[this.currentSectionIndex];
    e && (this.isTopView = e.view === "top", this.showHighlight = !1);
  }
  stopIdleRotation() {
    this.rafId && (cancelAnimationFrame(this.rafId), this.rafId = 0), this.disableRingTransition = !1;
  }
  updateRings() {
    if (this.currentSectionIndex === -1) return;
    const s = this.sections[this.currentSectionIndex], e = s.view === "top", t = -s.textAngle, i = this.ringRotation;
    let n = i;
    if (e) {
      let r = (t - i) % 360;
      r > 180 && (r -= 360), r < -180 && (r += 360), n = i + r - 180;
    } else {
      let r = (t - i) % 360;
      r > 180 && (r -= 360), r < -180 && (r += 360), n = i + r;
    }
    this.ringRotation = n, this.isTopView = e, this.highlightAngle = s.textAngle, s.highlightWidth !== void 0 && (this.highlightWidth = s.highlightWidth), this.showHighlight = !s.isIdle && !e;
  }
  renderControls() {
    return $`
      <div class="controls-wrapper ${this.controlsVisible ? "visible" : ""} ${this.isTopView ? "top-view" : ""}">
        <div class="swipe-hint">SWIPE THROUGH OUR TRUTHS</div>
        <div class="controls-list">
          ${this.sections.map((s, e) => s.hidden ? null : $`
              <button 
                class="control-item ${this.currentSectionIndex === e ? "active" : ""}"
                @click=${() => this.handleSectionClick(e)}
              >
                <div class="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="#84c12f" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10"/><path stroke="#84c12f" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m9 12 2 2 4-4"/></svg>
                </div>
                <span class="label">${s.label}</span>
              </button>
            `)}
        </div>
      </div>
      `;
  }
  renderOverlays() {
    return $`
      <div class="section-overlays ${this.isTopView ? "top-view" : ""}">
        ${this.sections.map((s, e) => {
      const t = e === this.currentSectionIndex, i = s.callout || s.multiCallouts, n = i && t && !this.isCalloutFading, r = this.sectionCallouts[e], a = this.sectionMultiCallouts[e];
      return i ? $`
            <div class="section-overlay" data-section="${e}">
              <svg class="callout-overlay ${n ? "visible" : ""}">
                ${r ? Dh`
                    <path
                        class="single-callout-line"
                        d="${r.path}"
                        stroke="#002C4E"
                        stroke-width="2"
                        fill="none"
                    />
                    <circle
                        class="single-callout-dot start"
                        cx="${r.start.x}"
                        cy="${r.start.y}"
                        r="4"
                        fill="#002C4E"
                    />
                    <circle
                        class="single-callout-dot end"
                        cx="${r.end.x}"
                        cy="${r.end.y}"
                        r="4"
                        fill="#002C4E"
                    />
                ` : null}
                
                ${a ? a.map(
        (o, l) => Dh`
                    <g class="multi-callout-group" style="--i: ${l}">
                      <path
                        d="${o.path}"
                        stroke="#002C4E"
                        stroke-width="2"
                        fill="none"
                      />
                      <circle
                        cx="${o.start.x}"
                        cy="${o.start.y}"
                        r="4"
                        fill="#002C4E"
                      />
                      <circle
                        cx="${o.end.x}"
                        cy="${o.end.y}"
                        r="4"
                        fill="#002C4E"
                      />
                    </g>
                 `
      ) : null}
            </svg>
            
            <!-- Render Multi-Callout Labels (only when label or subLabel is non-empty) -->
            ${a && n ? (() => {
        const o = a.filter(
          (l) => l.label != null && String(l.label).trim() !== "" || l.subLabel != null && String(l.subLabel).trim() !== ""
        );
        return o.length === 0 ? null : $`
                <div class="multi-callout-labels">
                    ${o.map(
          (l, c) => $`
                        <div class="callout-label ${l.align}" style="
                          position: absolute; 
                          left: ${l.end.x}px; 
                          top: ${l.end.y}px; 
                          transform: translate(${l.align === "left" ? "-100%" : "0"}, -50%);
                          --i: ${c};
                        ">
                          ${l.label != null && String(l.label).trim() !== "" ? $`<span class="number">${l.label}</span>` : ""}
                          ${l.subLabel != null && String(l.subLabel).trim() !== "" ? $`<span class="text">${l.subLabel}</span>` : ""}
                        </div>
                    `
        )}
                </div>
            `;
      })() : null}
        </div>
    ` : null;
    })}
    </div>`;
  }
  renderInfoCard() {
    return $`
      <div class="info-card ${this.controlsVisible && this.isCardVisible && (this.currentSection?.label ?? "").trim() !== "" ? "visible" : ""} ${(this.currentSection?.label ?? "").trim() === "" ? "info-card--no-label" : ""} ${this.isTopView ? "top-view" : ""}">
        <div class="card-header">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="#84c12f" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10"/><path stroke="#84c12f" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m9 12 2 2 4-4"/></svg>
          <h3>${this.currentSection.label}</h3>
        </div>
        <p>${this.currentSection.description}</p>
      </div>
    `;
  }
  renderScrollSections() {
    return $`
      ${this.sections.map(
      (s, e) => $`
          <div class="section" data-index="${e}"></div>
        `
    )}
    `;
  }
  renderRings() {
    const s = this.disableRingTransition ? "none" : this.isTopView ? "transform 3s ease-in-out" : "";
    return $`
      <div 
        class="rings-container ${this.isTopView ? "top-view" : ""} ${this.currentSection.isIdle ? "idle" : ""}" 
        style="--ring-rotation: ${this.ringRotation}deg; --highlight-angle: ${this.highlightAngle}deg; --highlight-width: ${this.highlightWidth * 57.29}deg; transition: ${s}"
      >
        <div class="ring outer">
          <svg xmlns="http://www.w3.org/2000/svg" width="607" height="606" fill="none" viewBox="0 0 607 606"><path stroke="#84c12f" stroke-width=".925" d="M.463 302.578C.463 135.725 135.93.463 303.04.463s302.578 135.262 302.578 302.115-135.468 302.115-302.578 302.115S.463 469.431.463 302.578Z"/></svg>
        </div>

        <div class="ring text-layer" style="transition: ${this.disableRingTransition ? "none" : ""}">
          <!-- Base Grey Text Ring -->
          <img class="base" src="${this.imagePath}" alt="" />

          <!-- Highlighted Blue Overlay (Masked) -->
          <div class="highlight-overlay" style="opacity: ${this.showHighlight ? 1 : 0}">
            <img src="${this.imagePath}" alt="" />
          </div>
        </div>

        <div class="ring inner">
          <svg xmlns="http://www.w3.org/2000/svg" width="538" height="538" fill="none" viewBox="0 0 538 538"><circle cx="268.804" cy="268.804" r="268.341" stroke="#84c12f" stroke-width=".925" transform="rotate(-90 268.804 268.804)"/></svg>
        </div>
      </div>
    `;
  }
};
Le.styles = Je`
    ${We(YS)}
  `;
Ue([
  D({ type: String })
], Le.prototype, "modelPath", 2);
Ue([
  D({ type: String })
], Le.prototype, "imagePath", 2);
Ue([
  D({ type: String })
], Le.prototype, "mobileImageHeader", 2);
Ue([
  D({ type: String })
], Le.prototype, "mobileImagePowder", 2);
Ue([
  D({ type: String })
], Le.prototype, "desktopImagePowder", 2);
Ue([
  D({ type: Array })
], Le.prototype, "galleryImages", 2);
Ue([
  Gs(".vh-microsite-interactive-model")
], Le.prototype, "container", 2);
Ue([
  Gs(".header-area")
], Le.prototype, "headerArea", 2);
Ue([
  Gs(".info-card")
], Le.prototype, "infoCard", 2);
Ue([
  Gs(".model-wrapper")
], Le.prototype, "modelWrapper", 2);
Ue([
  dp(".section")
], Le.prototype, "sectionElements", 2);
Ue([
  ft()
], Le.prototype, "currentSectionIndex", 2);
Ue([
  ft()
], Le.prototype, "controlsVisible", 2);
Ue([
  ft()
], Le.prototype, "sectionCallouts", 2);
Ue([
  ft()
], Le.prototype, "sectionMultiCallouts", 2);
Ue([
  ft()
], Le.prototype, "isCalloutFading", 2);
Ue([
  ft()
], Le.prototype, "isCardVisible", 2);
Ue([
  ft()
], Le.prototype, "ringRotation", 2);
Ue([
  ft()
], Le.prototype, "highlightAngle", 2);
Ue([
  ft()
], Le.prototype, "showHighlight", 2);
Ue([
  ft()
], Le.prototype, "highlightWidth", 2);
Ue([
  ft()
], Le.prototype, "isTopView", 2);
Ue([
  ft()
], Le.prototype, "disableRingTransition", 2);
Ue([
  D({ type: Number })
], Le.prototype, "ambientIntensity", 2);
Ue([
  D({ type: Number })
], Le.prototype, "keyLightIntensity", 2);
Ue([
  D({ type: Number })
], Le.prototype, "keyLightX", 2);
Ue([
  D({ type: Number })
], Le.prototype, "keyLightY", 2);
Ue([
  D({ type: Number })
], Le.prototype, "keyLightZ", 2);
Ue([
  D({ type: Number })
], Le.prototype, "fillLightIntensity", 2);
Ue([
  D({ type: Number })
], Le.prototype, "fillLightX", 2);
Ue([
  D({ type: Number })
], Le.prototype, "fillLightY", 2);
Ue([
  D({ type: Number })
], Le.prototype, "fillLightZ", 2);
Ue([
  D({ type: Number })
], Le.prototype, "backLightIntensity", 2);
Ue([
  D({ type: Number })
], Le.prototype, "backLightX", 2);
Ue([
  D({ type: Number })
], Le.prototype, "backLightY", 2);
Ue([
  D({ type: Number })
], Le.prototype, "backLightZ", 2);
Ue([
  D({ type: Number })
], Le.prototype, "powderOffsetX", 2);
Ue([
  D({ type: Number })
], Le.prototype, "powderOffsetY", 2);
Ue([
  D({ type: Number })
], Le.prototype, "powderRepeatX", 2);
Ue([
  D({ type: Number })
], Le.prototype, "powderRepeatY", 2);
Ue([
  ft()
], Le.prototype, "previousSectionIndex", 2);
Ue([
  ft()
], Le.prototype, "isMobile", 2);
Le = Ue([
  Oe("vh-microsite-interactive-model")
], Le);
const o1 = ".vh-microsite-quiz{display:flex;flex-direction:column;align-items:center;gap:40px;padding:80px 0;max-width:var(--vh-max-width-medium);margin:0 auto}@media screen and (min-width:810px){.vh-microsite-quiz{gap:100px;padding:100px 24px}}.vh-microsite-quiz__header{background:var(--vh-color-white);max-width:100%;box-sizing:border-box}@media screen and (min-width:810px){.vh-microsite-quiz__header{overflow:visible;position:relative;display:flex;align-items:center;justify-content:space-between;gap:200px}}@media screen and (min-width:1440px){.vh-microsite-quiz__header{gap:260px}}.vh-microsite-quiz__header-left{letter-spacing:-4px;text-align:center}@media screen and (min-width:810px){.vh-microsite-quiz__header-left{text-align:left}}.vh-microsite-quiz__header-right{letter-spacing:-40px;text-align:center;margin-left:-58px;margin-top:-56px;position:relative;z-index:1}@media screen and (min-width:810px){.vh-microsite-quiz__header-right{padding-right:60px;text-align:left;margin-left:0;margin-top:0;z-index:1}}@media screen and (min-width:1440px){.vh-microsite-quiz__header-right{padding-right:140px;letter-spacing:-80px}}.vh-microsite-quiz__letter--spacing{letter-spacing:-26px}@media screen and (min-width:1440px){.vh-microsite-quiz__letter--spacing{letter-spacing:-56px}}.vh-microsite-quiz__letter{font-family:var(--vh-font-feature-display-condensed);font-style:italic;font-weight:800;line-height:1;text-transform:uppercase;mix-blend-mode:multiply;font-size:240px;opacity:0}@media screen and (max-width:400px){.vh-microsite-quiz__letter{font-size:200px}}@media screen and (min-width:810px){.vh-microsite-quiz__letter{font-size:230px}}@media screen and (min-width:1280px){.vh-microsite-quiz__letter{font-size:240px}}@media screen and (min-width:1440px){.vh-microsite-quiz__letter{font-size:400px}}.vh-microsite-quiz__letter--light-green{color:var(--vh-color-light-green)}.vh-microsite-quiz__letter--green{color:var(--vh-color-green)}.vh-microsite-quiz__letter--animate{opacity:0;animation:fadeInFromRight 1.6s ease-out forwards;animation-delay:calc(var(--animation-order) * .15s)}@keyframes fadeInFromRight{0%{opacity:0;transform:translate(50px)}to{opacity:1;transform:translate(0)}}.vh-microsite-quiz__header-circle{position:relative;z-index:2;display:flex;justify-content:center;margin-top:-70px;max-width:100%;overflow:hidden}@media screen and (min-width:810px){.vh-microsite-quiz__header-circle{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);margin-top:0}}.vh-microsite-quiz__form{padding:0 24px}@media screen and (min-width:810px){.vh-microsite-quiz__form{padding:0}}";
var l1 = Object.defineProperty, c1 = Object.getOwnPropertyDescriptor, Ks = (s, e, t, i) => {
  for (var n = i > 1 ? void 0 : i ? c1(e, t) : e, r = s.length - 1, a; r >= 0; r--)
    (a = s[r]) && (n = (i ? a(e, t, n) : a(n)) || n);
  return i && n && l1(e, t, n), n;
};
let Cn = class extends Ie {
  constructor() {
    super(...arguments), this.questions = [], this.badgeText = "", this.submitText = "", this.isVisible = !1;
  }
  connectedCallback() {
    super.connectedCallback(), this.setupIntersectionObserver();
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.observer?.disconnect();
  }
  setupIntersectionObserver() {
    this.observer = new IntersectionObserver(
      (s) => {
        s.forEach((e) => {
          e.isIntersecting && !this.isVisible && (this.isVisible = !0);
        });
      },
      {
        threshold: 0.5
      }
    );
  }
  firstUpdated() {
    const s = this.shadowRoot?.querySelector(".vh-microsite-quiz__header");
    s && this.observer && this.observer.observe(s);
  }
  render() {
    const s = () => Ze({
      "vh-microsite-quiz__letter": !0,
      "vh-microsite-quiz__letter--animate": this.isVisible
    });
    return $`
      <div class="vh-microsite-quiz">
        <div class="vh-microsite-quiz__header">
          <div class="vh-microsite-quiz__header-left">
            <span class="vh-microsite-quiz__letter--spacing">
              <span class="${s()} vh-microsite-quiz__letter--light-green" style="--animation-order: 1">2</span>
              <span class="${s()} vh-microsite-quiz__letter--light-green" style="--animation-order: 2">0</span>
              <span class="${s()} vh-microsite-quiz__letter--green" style="--animation-order: 3">%</span>
            </span>
          </div>
          <div class="vh-microsite-quiz__header-circle">
            <vh-microsite-badge .text=${this.badgeText}></vh-microsite-badge>
          </div>
          <div class="vh-microsite-quiz__header-right">
            <span class="${s()} vh-microsite-quiz__letter--light-green" style="--animation-order: 4">O</span>
            <span class="${s()} vh-microsite-quiz__letter--green" style="--animation-order: 5">F</span>
            <span class="${s()} vh-microsite-quiz__letter--light-green" style="--animation-order: 6">F</span>
          </div>
        </div>

        <div class="vh-microsite-quiz__form">
          <vh-microsite-quiz-form
            .questions=${this.questions}
            .submitText=${this.submitText}
            .modal=${this.modal}
          ></vh-microsite-quiz-form>
        </div>
      </div>
    `;
  }
};
Cn.styles = Je`
    ${We(o1)}
  `;
Ks([
  D({ type: Array })
], Cn.prototype, "questions", 2);
Ks([
  D({ type: String })
], Cn.prototype, "badgeText", 2);
Ks([
  D({ type: String })
], Cn.prototype, "submitText", 2);
Ks([
  D({ type: Object })
], Cn.prototype, "modal", 2);
Ks([
  D({ type: Boolean })
], Cn.prototype, "isVisible", 2);
Cn = Ks([
  Oe("vh-microsite-quiz")
], Cn);
const h1 = ":host{display:block;width:100%}.vh-microsite-quiz-form{display:flex;flex-direction:column;gap:24px}.vh-microsite-quiz-form .vh-microsite-quiz-form__button{width:100%}@media screen and (min-width:810px){.vh-microsite-quiz-form .vh-microsite-quiz-form__button{width:auto}}.vh-microsite-quiz-form__submit-container{margin-top:20px;display:flex;align-items:center;flex-direction:column;justify-content:center;gap:40px}.vh-microsite-quiz-form__footer{font-family:var(--vh-font-poppins);font-size:16px;font-style:normal;font-weight:400;line-height:1.5}";
var d1 = Object.defineProperty, u1 = Object.getOwnPropertyDescriptor, Zs = (s, e, t, i) => {
  for (var n = i > 1 ? void 0 : i ? u1(e, t) : e, r = s.length - 1, a; r >= 0; r--)
    (a = s[r]) && (n = (i ? a(e, t, n) : a(n)) || n);
  return i && n && d1(e, t, n), n;
};
let In = class extends Ie {
  constructor() {
    super(...arguments), this.questions = [], this.submitText = "", this.selectedAnswers = /* @__PURE__ */ new Map(), this.showModal = !1;
  }
  handleAnswerChange(s, e) {
    this.selectedAnswers.set(s, e), this.requestUpdate();
  }
  get allQuestionsAnswered() {
    const s = this.questions?.length || 0;
    return this.selectedAnswers.size === s;
  }
  handleSubmit(s) {
    s.preventDefault(), this.showModal = !0;
  }
  handleModalClose() {
    this.showModal = !1;
  }
  render() {
    return $`
      <div class="vh-microsite-quiz-form">
        ${this.questions?.map(
      (s, e) => $`
            <vh-microsite-quiz-question
              .questionId=${s.questionId}
              .question=${s.question}
              .options=${s.options}
              .index=${e}
              .answerReason=${s.answerReason}
              .incorrectReason=${s.incorrectReason}
              .answerIndex=${s.answerIndex}
              .selectedAnswer=${this.selectedAnswers.get(s.questionId)}
              .onAnswerChange=${this.handleAnswerChange.bind(this)}
            ></vh-microsite-quiz-question>
          `
    )}

        <div class="vh-microsite-quiz-form__submit-container">
          <button
            ?disabled=${!this.allQuestionsAnswered}
            @click=${this.handleSubmit}
            class=${Ze({
      "vh-microsite-button": !0,
      "vh-microsite-button--green": !0,
      "vh-microsite-quiz-form__button": !0
    })}
          >
            ${Qe(this.submitText)}
          </button>
          <div class="vh-microsite-quiz-form__footer">
            ${this.selectedAnswers.size} of ${this.questions?.length || 0}
            correct answers
          </div>
        </div>
      </div>
      ${this.showModal && this.modal ? $`
            <vh-microsite-quiz-modal
              .headline=${this.modal.headline}
              .text=${this.modal.text}
              .couponCode=${this.modal.couponCode}
              .disclaimerText=${this.modal.disclaimerText}
              .backgroundImage=${this.modal.backgroundImage}
              .balloons=${this.modal.balloons}
              .balloonsTotal=${this.modal.balloonsTotal}
              .onClose=${() => this.handleModalClose()}
            ></vh-microsite-quiz-modal>
          ` : ""}
    `;
  }
};
In.styles = Je`
    ${We(h1)}
    ${We(Cc)}
  `;
Zs([
  D({ type: Array })
], In.prototype, "questions", 2);
Zs([
  D({ type: String })
], In.prototype, "submitText", 2);
Zs([
  D({ type: Object })
], In.prototype, "modal", 2);
Zs([
  ft()
], In.prototype, "selectedAnswers", 2);
Zs([
  ft()
], In.prototype, "showModal", 2);
In = Zs([
  Oe("vh-microsite-quiz-form")
], In);
var Rf = { success: { pattern: [{ duration: 30, intensity: 0.5 }, { delay: 60, duration: 40, intensity: 1 }] }, warning: { pattern: [{ duration: 40, intensity: 0.8 }, { delay: 100, duration: 40, intensity: 0.6 }] }, error: { pattern: [{ duration: 40, intensity: 0.9 }, { delay: 40, duration: 40, intensity: 0.9 }, { delay: 40, duration: 40, intensity: 0.9 }] }, light: { pattern: [{ duration: 15, intensity: 0.4 }] }, medium: { pattern: [{ duration: 25, intensity: 0.7 }] }, heavy: { pattern: [{ duration: 35, intensity: 1 }] }, soft: { pattern: [{ duration: 40, intensity: 0.5 }] }, rigid: { pattern: [{ duration: 10, intensity: 1 }] }, selection: { pattern: [{ duration: 8, intensity: 0.3 }] }, nudge: { pattern: [{ duration: 80, intensity: 0.8 }, { delay: 80, duration: 50, intensity: 0.3 }] }, buzz: { pattern: [{ duration: 1e3, intensity: 1 }] } }, f1 = 16, p1 = 184, du = 1e3, xa = 20;
function m1(s) {
  if (typeof s == "number") return { vibrations: [{ duration: s }] };
  if (typeof s == "string") {
    let e = Rf[s];
    return e ? { vibrations: e.pattern.map((t) => ({ ...t })) } : (console.warn(`[web-haptics] Unknown preset: "${s}"`), null);
  }
  if (Array.isArray(s)) {
    if (s.length === 0) return { vibrations: [] };
    if (typeof s[0] == "number") {
      let e = s, t = [];
      for (let i = 0; i < e.length; i += 2) {
        let n = i > 0 ? e[i - 1] : 0;
        t.push({ ...n > 0 && { delay: n }, duration: e[i] });
      }
      return { vibrations: t };
    }
    return { vibrations: s.map((e) => ({ ...e })) };
  }
  return { vibrations: s.pattern.map((e) => ({ ...e })) };
}
function g1(s, e) {
  if (e >= 1) return [s];
  if (e <= 0) return [];
  let t = Math.max(1, Math.round(xa * e)), i = xa - t, n = [], r = s;
  for (; r >= xa; ) n.push(t), n.push(i), r -= xa;
  if (r > 0) {
    let a = Math.max(1, Math.round(r * e));
    n.push(a);
    let o = r - a;
    o > 0 && n.push(o);
  }
  return n;
}
function v1(s, e) {
  let t = [];
  for (let i = 0; i < s.length; i++) {
    let n = s[i], r = Math.max(0, Math.min(1, n.intensity ?? e)), a = n.delay ?? 0;
    a > 0 && (t.length > 0 && t.length % 2 === 0 ? t[t.length - 1] += a : (t.length === 0 && t.push(0), t.push(a)));
    let o = g1(n.duration, r);
    if (o.length === 0) {
      t.length > 0 && t.length % 2 === 0 ? t[t.length - 1] += n.duration : n.duration > 0 && (t.push(0), t.push(n.duration));
      continue;
    }
    for (let l of o) t.push(l);
  }
  return t;
}
var _1 = 0, x1 = class La {
  hapticLabel = null;
  domInitialized = !1;
  instanceId;
  debug;
  showSwitch;
  rafId = null;
  patternResolve = null;
  audioCtx = null;
  audioFilter = null;
  audioGain = null;
  audioBuffer = null;
  constructor(e) {
    this.instanceId = ++_1, this.debug = e?.debug ?? !1, this.showSwitch = e?.showSwitch ?? !1;
  }
  static isSupported = typeof navigator < "u" && typeof navigator.vibrate == "function";
  async trigger(e = [{ duration: 25, intensity: 0.7 }], t) {
    let i = m1(e);
    if (!i) return;
    let { vibrations: n } = i;
    if (n.length === 0) return;
    let r = Math.max(0, Math.min(1, t?.intensity ?? 0.5));
    for (let a of n) if (a.duration > du && (a.duration = du), !Number.isFinite(a.duration) || a.duration < 0 || a.delay !== void 0 && (!Number.isFinite(a.delay) || a.delay < 0)) {
      console.warn("[web-haptics] Invalid vibration values. Durations and delays must be finite non-negative numbers.");
      return;
    }
    if (La.isSupported && navigator.vibrate(v1(n, r)), !La.isSupported || this.debug) {
      if (this.ensureDOM(), !this.hapticLabel) return;
      this.debug && await this.ensureAudio(), this.stopPattern();
      let a = (n[0]?.delay ?? 0) === 0;
      if (a && (this.hapticLabel.click(), this.debug && this.audioCtx)) {
        let o = Math.max(0, Math.min(1, n[0].intensity ?? r));
        this.playClick(o);
      }
      await this.runPattern(n, r, a);
    }
  }
  cancel() {
    this.stopPattern(), La.isSupported && navigator.vibrate(0);
  }
  destroy() {
    this.stopPattern(), this.hapticLabel && (this.hapticLabel.remove(), this.hapticLabel = null, this.domInitialized = !1), this.audioCtx && (this.audioCtx.close(), this.audioCtx = null, this.audioFilter = null, this.audioGain = null, this.audioBuffer = null);
  }
  setDebug(e) {
    this.debug = e, !e && this.audioCtx && (this.audioCtx.close(), this.audioCtx = null, this.audioFilter = null, this.audioGain = null, this.audioBuffer = null);
  }
  setShowSwitch(e) {
    if (this.showSwitch = e, this.hapticLabel) {
      let t = this.hapticLabel.querySelector("input");
      this.hapticLabel.style.display = e ? "" : "none", t && (t.style.display = e ? "" : "none");
    }
  }
  stopPattern() {
    this.rafId !== null && (cancelAnimationFrame(this.rafId), this.rafId = null), this.patternResolve?.(), this.patternResolve = null;
  }
  runPattern(e, t, i) {
    return new Promise((n) => {
      this.patternResolve = n;
      let r = [], a = 0;
      for (let d of e) {
        let u = Math.max(0, Math.min(1, d.intensity ?? t)), f = d.delay ?? 0;
        f > 0 && (a += f, r.push({ end: a, isOn: !1, intensity: 0 })), a += d.duration, r.push({ end: a, isOn: !0, intensity: u });
      }
      let o = a, l = 0, c = -1, h = (d) => {
        l === 0 && (l = d);
        let u = d - l;
        if (u >= o) {
          this.rafId = null, this.patternResolve = null, n();
          return;
        }
        let f = r[0];
        for (let g of r) if (u < g.end) {
          f = g;
          break;
        }
        if (f.isOn) {
          let g = f1 + (1 - f.intensity) * p1;
          c === -1 ? (c = d, i || (this.hapticLabel?.click(), this.debug && this.audioCtx && this.playClick(f.intensity), i = !0)) : d - c >= g && (this.hapticLabel?.click(), this.debug && this.audioCtx && this.playClick(f.intensity), c = d);
        }
        this.rafId = requestAnimationFrame(h);
      };
      this.rafId = requestAnimationFrame(h);
    });
  }
  playClick(e) {
    if (!this.audioCtx || !this.audioFilter || !this.audioGain || !this.audioBuffer) return;
    let t = this.audioBuffer.getChannelData(0);
    for (let a = 0; a < t.length; a++) t[a] = (Math.random() * 2 - 1) * Math.exp(-a / 25);
    this.audioGain.gain.value = 0.5 * e;
    let i = 2e3 + e * 2e3, n = 1 + (Math.random() - 0.5) * 0.3;
    this.audioFilter.frequency.value = i * n;
    let r = this.audioCtx.createBufferSource();
    r.buffer = this.audioBuffer, r.connect(this.audioFilter), r.onended = () => r.disconnect(), r.start();
  }
  async ensureAudio() {
    if (!this.audioCtx && typeof AudioContext < "u") {
      this.audioCtx = new AudioContext(), this.audioFilter = this.audioCtx.createBiquadFilter(), this.audioFilter.type = "bandpass", this.audioFilter.frequency.value = 4e3, this.audioFilter.Q.value = 8, this.audioGain = this.audioCtx.createGain(), this.audioFilter.connect(this.audioGain), this.audioGain.connect(this.audioCtx.destination);
      let e = 4e-3;
      this.audioBuffer = this.audioCtx.createBuffer(1, this.audioCtx.sampleRate * e, this.audioCtx.sampleRate);
      let t = this.audioBuffer.getChannelData(0);
      for (let i = 0; i < t.length; i++) t[i] = (Math.random() * 2 - 1) * Math.exp(-i / 25);
    }
    this.audioCtx?.state === "suspended" && await this.audioCtx.resume();
  }
  ensureDOM() {
    if (this.domInitialized || typeof document > "u") return;
    let e = `web-haptics-${this.instanceId}`, t = document.createElement("label");
    t.setAttribute("for", e), t.textContent = "Haptic feedback", t.style.position = "fixed", t.style.bottom = "10px", t.style.left = "10px", t.style.padding = "5px 10px", t.style.backgroundColor = "rgba(0, 0, 0, 0.7)", t.style.color = "white", t.style.fontFamily = "sans-serif", t.style.fontSize = "14px", t.style.borderRadius = "4px", t.style.zIndex = "9999", t.style.userSelect = "none", this.hapticLabel = t;
    let i = document.createElement("input");
    i.type = "checkbox", i.setAttribute("switch", ""), i.id = e, i.style.all = "initial", i.style.appearance = "auto", this.showSwitch || (t.style.display = "none", i.style.display = "none"), t.appendChild(i), document.body.appendChild(t), this.domInitialized = !0;
  }
};
const y1 = '@keyframes horizontal-shaking{0%{transform:translate(0)}25%{transform:translate(5px)}50%{transform:translate(-5px)}75%{transform:translate(5px)}to{transform:translate(0)}}.vh-microsite-quiz-question{display:grid;gap:12px;position:relative}@media screen and (min-width:1280px){.vh-microsite-quiz-question{gap:24px}.vh-microsite-quiz-question--odd{grid-template-columns:1fr 448px}.vh-microsite-quiz-question--odd .vh-microsite-quiz-question__number-card{order:2}.vh-microsite-quiz-question--odd .vh-microsite-quiz-question__card{order:1}.vh-microsite-quiz-question--even{grid-template-columns:448px 1fr}}.vh-microsite-quiz-question__number-card{display:flex;align-items:center;justify-content:flex-start;border-radius:16px;padding:0 24px}@media screen and (min-width:1280px){.vh-microsite-quiz-question__number-card{padding:80px 40px 40px;align-items:flex-end;justify-content:flex-start;min-height:224px;display:flex}}.vh-microsite-quiz-question__number{font-family:var(--vh-font-feature-display-condensed);font-size:160px;font-style:italic;font-weight:800;line-height:1;background:linear-gradient(180deg,#c5e86c 15.26%,#78ba1f);background-clip:text;-webkit-background-clip:text;-webkit-text-fill-color:transparent;mix-blend-mode:multiply;margin:0}@media screen and (min-width:1280px){.vh-microsite-quiz-question__number{padding-left:10px;font-size:340px;line-height:270px}}.vh-microsite-quiz-question__flip-card{display:flex;perspective:1000px}.vh-microsite-quiz-question--answered-wrong .vh-microsite-quiz-question__flip-card{animation:horizontal-shaking .3s ease}.vh-microsite-quiz-question--flipped .vh-microsite-quiz-question__flip-card-inner{transform:rotateX(180deg)}.vh-microsite-quiz-question__flip-card-inner{position:relative;display:flex;width:100%;transition:transform .8s;transform-style:preserve-3d;-moz-backface-visibility:hidden}.vh-microsite-quiz-question__card{position:relative;display:flex;flex-direction:column;gap:42px;padding:40px 24px;border-radius:16px;justify-content:space-between;width:100%;-webkit-backface-visibility:hidden;backface-visibility:hidden}@media screen and (min-width:1280px){.vh-microsite-quiz-question__card{padding:40px}}.vh-microsite-quiz-question--answered-wrong .vh-microsite-quiz-question__card--front{pointer-events:none}.vh-microsite-quiz-question__answer-reason{display:flex;flex-direction:column;gap:16px;margin-bottom:auto}@media screen and (min-width:810px){.vh-microsite-quiz-question__answer-reason{gap:0}}.vh-microsite-quiz-question__card--back{position:absolute;width:100%;height:100%;transform:rotateX(180deg);box-sizing:border-box}.vh-microsite-quiz-question--even .vh-microsite-quiz-question__number-card,.vh-microsite-quiz-question--even .vh-microsite-quiz-question__card{background:linear-gradient(310deg,#c5e86c 4.72%,#e9f9c1 104.65%)}.vh-microsite-quiz-question--odd .vh-microsite-quiz-question__number-card,.vh-microsite-quiz-question--odd .vh-microsite-quiz-question__card{background:var(--vh-color-white);border:2px solid var(--vh-color-light-green)}.vh-microsite-quiz-question__text{font-family:var(--vh-font-poppins);font-size:24px;font-style:normal;font-weight:400;line-height:1.2;color:var(--vh-color-navy);margin:0}.vh-microsite-quiz-question__options-list{display:flex;flex-direction:column;gap:16px}.vh-microsite-quiz-question__option-label{display:flex;align-items:center;gap:8px;cursor:pointer}@media screen and (min-width:810px){.vh-microsite-quiz-question__option-label:hover .vh-microsite-quiz-question__option-text{color:var(--vh-color-green)}}.vh-microsite-quiz-question__option-input{appearance:none;margin:0;width:24px;height:24px;flex-shrink:0;cursor:pointer;border:3px solid var(--vh-color-light-green);border-radius:50%;background:transparent;position:relative;transition:all .2s ease;display:flex;justify-content:center;align-items:center}.vh-microsite-quiz-question__option-input:checked{border-color:var(--vh-color-green);background:var(--vh-color-green)}.vh-microsite-quiz-question__option-input:checked:after{content:"";width:8px;height:8px;border-radius:50%;background:var(--vh-color-white)}@media screen and (min-width:810px){.vh-microsite-quiz-question__option-input:hover{border-color:var(--vh-color-green)}}.vh-microsite-quiz-question__option-text{font-family:var(--vh-font-poppins);font-size:16px;font-style:normal;font-weight:400;line-height:1.5;color:var(--vh-color-navy);transition:color .2s ease}.vh-microsite-quiz-question__answer-reason-heading{display:flex;gap:20px}.vh-microsite-quiz-question__answer-reason-title{font-family:var(--vh-font-poppins);font-size:16px;font-style:normal;font-weight:700;line-height:1.5;color:var(--vh-color-navy);flex:1}.vh-microsite-quiz-question__answer-reason-content{font-family:var(--vh-font-poppins);font-size:16px;font-style:normal;font-weight:400;line-height:1.5;color:var(--vh-color-navy);margin-left:50px}@media screen and (min-width:810px){.vh-microsite-quiz-question__try-again{margin-top:42px;margin-left:50px}}.vh-microsite-quiz-question__answer-reason-icon{width:30px}.vh-microsite-quiz-question__answer-reason--right .vh-microsite-quiz-question__answer-reason-icon{width:50px}.vh-microsite-quiz-question__answer-reason--right .vh-microsite-quiz-question__answer-reason-content{margin-left:70px}.vh-microsite-quiz-question__answer-reason--wrong .vh-microsite-quiz-question__answer-reason-icon{width:30px}';
var b1 = Object.defineProperty, w1 = Object.getOwnPropertyDescriptor, Li = (s, e, t, i) => {
  for (var n = i > 1 ? void 0 : i ? w1(e, t) : e, r = s.length - 1, a; r >= 0; r--)
    (a = s[r]) && (n = (i ? a(e, t, n) : a(n)) || n);
  return i && n && b1(e, t, n), n;
};
const S1 = new x1();
let li = class extends Ie {
  constructor() {
    super(...arguments), this.answered = "NONE", this.flipped = !1, this.questionId = 0, this.question = "", this.options = [], this.index = 0, this.answerIndex = 0, this.answerReason = "", this.incorrectReason = "";
  }
  handleChange(s) {
    s === this.answerIndex ? (this.answered = "RIGHT", this.flipped = !0, this.onAnswerChange && this.onAnswerChange(this.questionId, s)) : (this.answered = "WRONG", S1.trigger(Rf.buzz));
  }
  handleTryAgain() {
    this.answered = "NONE", this.flipped = !1;
  }
  updated(s) {
    s.has("answered") && this.answered === "WRONG" && setTimeout(() => {
      this.flipped = !0;
    }, 500);
  }
  render() {
    const s = this.index % 2 === 0, e = {
      "vh-microsite-quiz-question--even": s,
      "vh-microsite-quiz-question--odd": !s,
      "vh-microsite-quiz-question--answered-wrong": this.answered === "WRONG",
      "vh-microsite-quiz-question--flipped": this.flipped
    };
    return $`
      <div class="vh-microsite-quiz-question ${Ze(e)}">
        <div class="vh-microsite-quiz-question__number-card">
          <p class="vh-microsite-quiz-question__number">${this.questionId}.</p>
        </div>
        <div class="vh-microsite-quiz-question__flip-card">
          <div class="vh-microsite-quiz-question__flip-card-inner">
            <div class="vh-microsite-quiz-question__card vh-microsite-quiz-question__card--front">
              <p class="vh-microsite-quiz-question__text">${this.question}</p>
              <div class="vh-microsite-quiz-question__options-list">
                ${this.options.map(
      (t, i) => $`
                    <label class="vh-microsite-quiz-question__option-label">
                      <input
                        type="radio"
                        name="question-${this.questionId}"
                        value="${i}"
                        @change=${() => this.handleChange(i)}
                        class="vh-microsite-quiz-question__option-input"
                      />
                      <span class="vh-microsite-quiz-question__option-text">${t}</span>
                    </label>
                  `
    )}
              </div>
            </div>
            <div class="vh-microsite-quiz-question__card vh-microsite-quiz-question__card--back">
              <p class="vh-microsite-quiz-question__text">${this.question}</p>
              <div class="${Ze({
      "vh-microsite-quiz-question__answer-reason": !0,
      "vh-microsite-quiz-question__answer-reason--right": this.answered === "RIGHT",
      "vh-microsite-quiz-question__answer-reason--wrong": this.answered === "WRONG"
    })}">
                <div class="vh-microsite-quiz-question__answer-reason-heading">
                  <div class="vh-microsite-quiz-question__answer-reason-icon">
                    ${this.answered === "RIGHT" ? $`<vh-icon-correct></vh-icon-correct>` : $`<vh-icon-incorrect></vh-icon-incorrect>`}
                  </div>
                  <div class="vh-microsite-quiz-question__answer-reason-title">
                    ${this.answered === "RIGHT" ? this.options[this.answerIndex ?? 0] : "Not quite right."}
                  </div>
                </div>
                <div class="vh-microsite-quiz-question__answer-reason-content">
                  ${this.answered === "RIGHT" ? this.answerReason : this.incorrectReason}
                </div>
                ${this.answered === "WRONG" ? $`<div class="vh-microsite-quiz-question__try-again">
              <vh-microsite-button
                label="Try Again"
                color="transparent"
                size="small"
                @button-click=${this.handleTryAgain}>
              ></vh-microsite-button>
                  </div>` : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
  }
};
li.styles = Je`
    ${We(y1)}
  `;
Li([
  ft()
], li.prototype, "answered", 2);
Li([
  ft()
], li.prototype, "flipped", 2);
Li([
  D({ type: Number })
], li.prototype, "questionId", 2);
Li([
  D({ type: String })
], li.prototype, "question", 2);
Li([
  D({ type: Array })
], li.prototype, "options", 2);
Li([
  D({ type: Number })
], li.prototype, "index", 2);
Li([
  D({ type: Number })
], li.prototype, "answerIndex", 2);
Li([
  D({ type: String })
], li.prototype, "answerReason", 2);
Li([
  D({ type: String })
], li.prototype, "incorrectReason", 2);
Li([
  D({ type: Object })
], li.prototype, "onAnswerChange", 2);
li = Li([
  Oe("vh-microsite-quiz-question")
], li);
const M1 = "@keyframes fadeIn{0%{opacity:0}to{opacity:1}}@keyframes fadeOut{0%{opacity:1}to{opacity:0}}.vh-microsite-quiz-modal{position:fixed;inset:0;z-index:1000;display:flex;align-items:center;justify-content:center;padding:24px;animation:fadeIn .3s ease-out}.vh-microsite-quiz-modal.closing{animation:fadeOut .3s ease-out}.vh-microsite-quiz-modal__overlay{position:absolute;inset:0;background:#00000080;-webkit-backdrop-filter:blur(4px);backdrop-filter:blur(4px);animation:fadeIn .3s ease-out}.vh-microsite-quiz-modal.closing .vh-microsite-quiz-modal__overlay{animation:fadeOut .3s ease-out}@keyframes scaleIn{0%{opacity:0;transform:scale(.95)}to{opacity:1;transform:scale(1)}}@keyframes scaleOut{0%{opacity:1;transform:scale(1)}to{opacity:0;transform:scale(.95)}}.vh-microsite-quiz-modal__content{position:relative;width:100%;border-radius:16px;box-shadow:0 4px 40px #00000040;padding:84px 24px 125px;display:flex;flex-direction:column;align-items:center;background-repeat:no-repeat;background-size:cover;background-position:center;max-width:1156px;margin:0 auto;animation:scaleIn .3s ease-out;box-sizing:border-box;z-index:9999}.vh-microsite-quiz-modal.closing .vh-microsite-quiz-modal__content{animation:scaleOut .3s ease-out}.vh-microsite-quiz-modal__close{position:absolute;top:20px;right:20px;width:48px;height:48px;border-radius:50px;border:1px solid var(--vh-color-navy);background:transparent;cursor:pointer;display:flex;align-items:center;justify-content:center}.vh-microsite-quiz-modal__title{font-family:var(--vh-font-feature-display-condensed);font-style:italic;font-weight:800;line-height:1;background:linear-gradient(90deg,#9dd43e,#16325b);background-clip:text;-webkit-background-clip:text;-webkit-text-fill-color:transparent;margin:0;width:100%;text-align:center;font-size:80px;letter-spacing:-3px}@media screen and (min-width:810px){.vh-microsite-quiz-modal__title{font-size:150px;letter-spacing:-6px}}@media screen and (min-width:1280px){.vh-microsite-quiz-modal__title{font-size:240px;line-height:1.2;letter-spacing:-9.6px}}.vh-microsite-quiz-modal__text-content{display:inline-flex;padding:32px 40px;flex-direction:column;align-items:center;gap:30px;border-radius:8px;border:3px solid var(--vh-color-white);background:#84c12f0d;-webkit-backdrop-filter:blur(20px);backdrop-filter:blur(20px);box-sizing:border-box;margin-top:-4px}@media screen and (min-width:810px){.vh-microsite-quiz-modal__text-content{margin-top:-10px}}@media screen and (min-width:1280px){.vh-microsite-quiz-modal__text-content{margin-top:-40px}}.vh-microsite-quiz-modal__text{font-family:var(--vh-font-poppins);font-size:28px;font-style:normal;font-weight:500;line-height:1}@media screen and (min-width:810px){.vh-microsite-quiz-modal__text{font-size:32px}}.vh-microsite-quiz-modal__text{color:var(--vh-color-navy);text-align:center}@media screen and (min-width:810px){.vh-microsite-quiz-modal__text{font-size:36px}}.vh-microsite-quiz-modal__coupon{display:flex;align-items:center;gap:24px;justify-content:center}.vh-microsite-quiz-modal__coupon span{font-family:var(--vh-font-feature-display-condensed);font-size:44px;font-style:normal;font-weight:400;line-height:1.1}@media screen and (min-width:810px){.vh-microsite-quiz-modal__coupon span{font-size:48px}}.vh-microsite-quiz-modal__coupon span{color:var(--vh-color-navy);font-weight:700;text-align:center;line-height:1}.vh-microsite-quiz-modal__coupon vh-icon-copy{cursor:pointer;height:32px;width:32px}.vh-microsite-quiz-modal__disclaimer{font-family:var(--vh-font-poppins);font-style:normal;line-height:1.5;color:var(--vh-color-navy);text-align:center;font-size:16px;font-weight:400}";
var T1 = Object.defineProperty, E1 = Object.getOwnPropertyDescriptor, ji = (s, e, t, i) => {
  for (var n = i > 1 ? void 0 : i ? E1(e, t) : e, r = s.length - 1, a; r >= 0; r--)
    (a = s[r]) && (n = (i ? a(e, t, n) : a(n)) || n);
  return i && n && T1(e, t, n), n;
};
let xi = class extends Ie {
  constructor() {
    super(...arguments), this.headline = "", this.text = "", this.disclaimerText = "", this.couponCode = "", this.backgroundImage = "", this.isClosing = !1;
  }
  handleClose() {
    this.isClosing = !0, setTimeout(() => {
      this.onClose && this.onClose(), this.isClosing = !1;
    }, 300);
  }
  handleCopy() {
    navigator.clipboard.writeText(this.couponCode);
  }
  render() {
    return $`
      <div
        class=${Ze({
      "vh-microsite-quiz-modal": !0,
      closing: this.isClosing
    })}
      >
        <vh-microsite-balloons
          .images=${this.balloons}
          .total=${this.balloonsTotal ?? 67}
        ></vh-microsite-balloons>
        <div
          class="vh-microsite-quiz-modal__overlay"
          @click=${this.handleClose}
        ></div>
        <div
          class="vh-microsite-quiz-modal__content"
          style="background-image: url(${this.backgroundImage});"
        >
          <button
            class="vh-microsite-quiz-modal__close"
            @click=${this.handleClose}
            aria-label="Close"
          >
            <vh-icon-close
              size="24"
              color="var(--vh-color-navy)"
            ></vh-icon-close>
          </button>
          <div class="vh-microsite-quiz-modal__title">${this.headline}</div>
          <div class="vh-microsite-quiz-modal__text-content">
            <div class="vh-microsite-quiz-modal__text">
              ${Qe(this.text)}
            </div>
            <div class="vh-microsite-quiz-modal__coupon">
              <span>${this.couponCode}</span>
              <vh-icon-copy
                size="32"
                color="var(--vh-color-navy)"
                @click=${this.handleCopy}
                title="Copy coupon code"
              ></vh-icon-copy>
            </div>
            <div class="vh-microsite-quiz-modal__disclaimer">
              ${Qe(this.disclaimerText)}
            </div>
          </div>
        </div>
      </div>
    `;
  }
};
xi.styles = Je`
    ${We(M1)}
  `;
ji([
  D({ type: String })
], xi.prototype, "headline", 2);
ji([
  D({ type: String })
], xi.prototype, "text", 2);
ji([
  D({ type: String })
], xi.prototype, "disclaimerText", 2);
ji([
  D({ type: String })
], xi.prototype, "couponCode", 2);
ji([
  D({ type: String })
], xi.prototype, "backgroundImage", 2);
ji([
  D({ type: Object })
], xi.prototype, "onClose", 2);
ji([
  ft()
], xi.prototype, "isClosing", 2);
ji([
  D({ type: Number })
], xi.prototype, "balloonsTotal", 2);
ji([
  D({ type: Array })
], xi.prototype, "balloons", 2);
xi = ji([
  Oe("vh-microsite-quiz-modal")
], xi);
const A1 = ".vh-microsite-newsletter{background:linear-gradient(191.34deg,#fcfdff4d 40.1%,#91f2ec2e 96.91%)}.vh-microsite-newsletter__inner{display:flex;flex-direction:column;gap:40px;align-items:center;padding:40px 24px;max-width:var(--vh-max-width-medium);margin:0 auto}@media screen and (min-width:810px){.vh-microsite-newsletter__inner{gap:60px;padding:60px 40px}}@media screen and (min-width:1280px){.vh-microsite-newsletter__inner{flex-direction:row;gap:100px;padding:100px 120px}}.vh-microsite-newsletter__image{width:100%;max-width:400px;height:auto;aspect-ratio:562/528;flex-shrink:0;position:relative}@media screen and (min-width:1280px){.vh-microsite-newsletter__image{width:562px;height:528px;max-width:none;aspect-ratio:auto}}.vh-microsite-newsletter__image img{width:100%;height:100%;object-fit:cover;mix-blend-mode:multiply}.vh-microsite-newsletter__content{flex:1;display:flex;flex-direction:column;gap:40px;align-items:center;justify-content:center;max-width:100%;box-sizing:border-box}.vh-microsite-newsletter__text{display:flex;flex-direction:column;gap:40px;align-items:center;text-align:center;width:100%}.vh-microsite-newsletter__heading{font-family:var(--vh-font-feature-display-condensed);font-size:48px;font-style:normal;font-weight:400;line-height:1}@media screen and (min-width:810px){.vh-microsite-newsletter__heading{font-size:52px}}.vh-microsite-newsletter__heading{color:var(--vh-color-navy);max-width:300px}.vh-microsite-newsletter__description{font-family:var(--vh-font-poppins);font-size:16px;font-style:normal;font-weight:400;line-height:1.5;color:var(--vh-color-navy);margin:0}.vh-microsite-newsletter__form{display:flex;flex-direction:column;gap:24px;width:100%;padding:0}@media screen and (min-width:810px){.vh-microsite-newsletter__form{padding:0 40px}}.vh-microsite-newsletter__field{display:flex;flex-direction:column;gap:8px;width:100%}.vh-microsite-newsletter__label{font-family:var(--vh-font-poppins);font-size:16px;font-style:normal;font-weight:400;line-height:1.5;color:var(--vh-color-navy)}.vh-microsite-newsletter__input{width:100%;padding:12px 16px;background:var(--vh-color-white);border:1px solid var(--vh-color-gray);border-radius:4px;font-family:var(--vh-font-poppins);font-size:14px;font-style:normal;font-weight:300;line-height:1.3;color:var(--vh-color-navy);box-sizing:border-box}.vh-microsite-newsletter__input::placeholder{color:#002c4e80}.vh-microsite-newsletter__input:focus{outline:none;border-color:var(--vh-color-navy)}.vh-microsite-newsletter__button{display:flex;justify-content:center}.vh-microsite-newsletter__confirmation{font-family:var(--vh-font-feature-display-condensed);font-size:48px;font-style:normal;font-weight:400;line-height:1}@media screen and (min-width:810px){.vh-microsite-newsletter__confirmation{font-size:52px}}.vh-microsite-newsletter__confirmation{color:var(--vh-color-navy);text-align:center}";
var R1 = Object.defineProperty, C1 = Object.getOwnPropertyDescriptor, fn = (s, e, t, i) => {
  for (var n = i > 1 ? void 0 : i ? C1(e, t) : e, r = s.length - 1, a; r >= 0; r--)
    (a = s[r]) && (n = (i ? a(e, t, n) : a(n)) || n);
  return i && n && R1(e, t, n), n;
};
let Ri = class extends Ie {
  constructor() {
    super(...arguments), this.heading = "", this.description = "", this.namePlaceholder = "", this.emailPlaceholder = "", this.buttonText = "", this.imageUrl = "", this.submitted = !1;
  }
  handleSubmit(s) {
    s.preventDefault();
    const e = s.target, t = new FormData(e), i = {
      name: t.get("name"),
      email: t.get("email")
    };
    this.onSubmit && this.onSubmit(i), e.reset(), this.submitted = !0;
  }
  render() {
    return $`
      <div class="vh-microsite-newsletter">
        <div class="vh-microsite-newsletter__inner">
          <div class="vh-microsite-newsletter__image">
            <img src="${this.imageUrl}" alt="Vibrant Health Products" />
          </div>
          <div class="vh-microsite-newsletter__content">
            <div class="vh-microsite-newsletter__text">
              <div class="vh-microsite-newsletter__heading">
                ${Qe(this.heading)}
              </div>
              <p class="vh-microsite-newsletter__description">${this.description}</p>
            </div>
            ${this.submitted ? $`<div class="vh-microsite-newsletter__confirmation">Thanks for Joining</div>` : $`<form class="vh-microsite-newsletter__form" @submit=${this.handleSubmit}>
              <div class="vh-microsite-newsletter__field">
                <label class="vh-microsite-newsletter__label" for="name">Name</label>
                <input
                  id="name"
                  name="name"
                  type="text"
                  class="vh-microsite-newsletter__input"
                  placeholder="${this.namePlaceholder}"
                  required
                />
              </div>
              <div class="vh-microsite-newsletter__field">
                <label class="vh-microsite-newsletter__label" for="email">Email</label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  class="vh-microsite-newsletter__input"
                  placeholder="${this.emailPlaceholder}"
                  required
                />
              </div>
              <div class="vh-microsite-newsletter__button">
                <button
                  type="submit"
                  class=${Ze({
      "vh-microsite-button": !0,
      "vh-microsite-button--navy": !0,
      "vh-microsite-button--with-arrow": !0
    })}
                >
                  ${Qe(this.buttonText)}
                </button>
              </div>
            </form>`}
          </div>
        </div>
      </div>
    `;
  }
};
Ri.styles = Je`
    ${We(A1)}
    ${We(Cc)}
  `;
fn([
  D({ type: String })
], Ri.prototype, "heading", 2);
fn([
  D({ type: String })
], Ri.prototype, "description", 2);
fn([
  D({ type: String })
], Ri.prototype, "namePlaceholder", 2);
fn([
  D({ type: String })
], Ri.prototype, "emailPlaceholder", 2);
fn([
  D({ type: String })
], Ri.prototype, "buttonText", 2);
fn([
  D({ type: String })
], Ri.prototype, "imageUrl", 2);
fn([
  D({ type: Object })
], Ri.prototype, "onSubmit", 2);
fn([
  ft()
], Ri.prototype, "submitted", 2);
Ri = fn([
  Oe("vh-microsite-newsletter")
], Ri);
const I1 = '.vh-microsite-faq{display:flex;flex-direction:column;align-items:center;gap:40px;padding:0 24px 40px;max-width:var(--vh-max-width-medium);margin:0 auto;overflow:hidden;background:var(--vh-color-white)}@media screen and (min-width:810px){.vh-microsite-faq{overflow:visible;gap:100px;padding:0 24px 100px}}.vh-microsite-faq__header{position:relative;display:flex;flex-direction:column;align-items:center;justify-content:center;max-width:100%;box-sizing:border-box}@media screen and (min-width:810px){.vh-microsite-faq__header{flex-direction:row}}@keyframes lineWidth{0%{width:0}to{width:calc(100% + var(--vh-faq-line-width))}}.vh-microsite-faq__image-wrapper{position:relative;--vh-faq-line-width: 0px}@media screen and (min-width:810px){.vh-microsite-faq__image-wrapper{--vh-faq-line-width: 60px}}@media screen and (min-width:1280px){.vh-microsite-faq__image-wrapper{--vh-faq-line-width: 90px}}.vh-microsite-faq__image-wrapper:after{content:" ";width:0;height:2px;background-color:var(--vh-color-light-green);position:absolute;bottom:2px;left:0}[data-visible=true] .vh-microsite-faq__image-wrapper{animation:fadeInFromRight .7s ease-out forwards}[data-visible=true] .vh-microsite-faq__image-wrapper:after{animation:lineWidth .4s ease-in forwards}[data-visible=true] .vh-microsite-faq__letter{animation:fadeInFromRight .7s ease-out forwards;animation-delay:calc(var(--animation-order) * .15s)}.vh-microsite-faq__image{width:100%}@media screen and (min-width:810px){.vh-microsite-faq__image{width:200px}}@media screen and (min-width:1280px){.vh-microsite-faq__image{width:320px}}.vh-microsite-faq__text{display:flex;align-items:center;justify-content:center;position:relative;z-index:2;padding-right:62px;margin-top:20px}@media screen and (min-width:810px){.vh-microsite-faq__text{padding-right:16px}}@media screen and (min-width:1280px){.vh-microsite-faq__text{padding-right:24px}}.vh-microsite-faq__letter{font-family:var(--vh-font-feature-display-condensed);font-style:italic;font-weight:800;line-height:1;text-transform:uppercase;mix-blend-mode:multiply;font-size:240px;letter-spacing:-62px;opacity:0}@media screen and (min-width:1280px){.vh-microsite-faq__letter{font-size:400px;letter-spacing:-104px}}.vh-microsite-faq__letter--light-green{color:var(--vh-color-light-green)}.vh-microsite-faq__letter--green{color:var(--vh-color-green)}@keyframes fadeInFromRight{0%{opacity:0;transform:translate(50px)}to{opacity:1;transform:translate(0)}}.vh-microsite-faq__badge{width:340px;height:340px;border-radius:50%;background:#84c12f1a;border:4px solid var(--vh-color-white);display:flex;align-items:center;justify-content:center;flex-direction:column;-webkit-backdrop-filter:blur(40px);backdrop-filter:blur(40px);padding:40px;box-sizing:border-box;max-width:100%;z-index:2;margin-top:-80px}@media screen and (min-width:810px){.vh-microsite-faq__badge{margin-top:0}}@media screen and (min-width:1280px){.vh-microsite-faq__badge{width:400px;height:400px}}.vh-microsite-faq__badge-content{display:flex;flex-direction:column;align-items:center;text-align:center;gap:8px}@media screen and (min-width:1280px){.vh-microsite-faq__badge-content{gap:22px}}.vh-microsite-faq__badge-label{font-family:var(--vh-font-ibm-plex-sans);font-size:12px;font-weight:700;line-height:1.2;text-transform:uppercase;color:var(--vh-color-navy)}.vh-microsite-faq__badge-title-container{border-top:1px solid var(--vh-color-white);border-bottom:1px solid var(--vh-color-white);padding:6px 4px;width:100%}@media screen and (min-width:1280px){.vh-microsite-faq__badge-title-container{padding:16px 10px}}.vh-microsite-faq__badge-title{font-family:var(--vh-font-feature-display-condensed);font-size:44px;font-style:normal;font-weight:400;line-height:1.1}@media screen and (min-width:810px){.vh-microsite-faq__badge-title{font-size:48px}}.vh-microsite-faq__badge-title{color:var(--vh-color-navy);font-weight:700}.vh-microsite-faq__badge-description{font-family:var(--vh-font-poppins);font-size:16px;font-style:normal;font-weight:400;line-height:1.5;color:var(--vh-color-navy)}';
var P1 = Object.defineProperty, L1 = Object.getOwnPropertyDescriptor, rs = (s, e, t, i) => {
  for (var n = i > 1 ? void 0 : i ? L1(e, t) : e, r = s.length - 1, a; r >= 0; r--)
    (a = s[r]) && (n = (i ? a(e, t, n) : a(n)) || n);
  return i && n && P1(e, t, n), n;
};
let un = class extends Ie {
  constructor() {
    super(...arguments), this.badgeLabel = "", this.badgeTitle = "", this.badgeDescription = "", this.items = [], this.isVisible = !1;
  }
  connectedCallback() {
    super.connectedCallback(), this.setupIntersectionObserver();
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.observer?.disconnect();
  }
  setupIntersectionObserver() {
    this.observer = new IntersectionObserver(
      (s) => {
        s.forEach((e) => {
          e.isIntersecting && !this.isVisible && (this.isVisible = !0);
        });
      },
      {
        threshold: 0.5
      }
    );
  }
  firstUpdated() {
    const s = this.shadowRoot?.querySelector(".vh-microsite-faq__header");
    s && this.observer && this.observer.observe(s);
  }
  render() {
    const s = () => Ze({
      "vh-microsite-faq__letter": !0
    });
    return $`
      <div class="vh-microsite-faq" data-visible=${this.isVisible}>
        <div class="vh-microsite-faq__header">
          ${this.image ? $`<div class="vh-microsite-faq__image-wrapper">
            <img src="${this.image}" alt="" class="vh-microsite-faq__image" />
          </div>` : ""}
          
          <div class="vh-microsite-faq__text">
            <span class="${s()} vh-microsite-faq__letter--light-green" style="--animation-order: 1">Q</span>
            <span class="${s()} vh-microsite-faq__letter--green" style="--animation-order: 2">&</span>
            <span class="${s()} vh-microsite-faq__letter--light-green" style="--animation-order: 3">A</span>
          </div>
          
          <div class="vh-microsite-faq__badge">
            <div class="vh-microsite-faq__badge-content">
              <div class="vh-microsite-faq__badge-label">${this.badgeLabel}</div>
              <div class="vh-microsite-faq__badge-title-container">
                <div class="vh-microsite-faq__badge-title">${this.badgeTitle}</div>
              </div>
              <div class="vh-microsite-faq__badge-description">${this.badgeDescription}</div>
            </div>
          </div>
        </div>

        <vh-microsite-faq-cards .items=${this.items}></vh-microsite-faq-cards>
      </div>
    `;
  }
};
un.styles = Je`
    ${We(I1)}
  `;
rs([
  D()
], un.prototype, "image", 2);
rs([
  D()
], un.prototype, "badgeLabel", 2);
rs([
  D()
], un.prototype, "badgeTitle", 2);
rs([
  D()
], un.prototype, "badgeDescription", 2);
rs([
  D({ type: Array })
], un.prototype, "items", 2);
rs([
  D({ type: Boolean })
], un.prototype, "isVisible", 2);
un = rs([
  Oe("vh-microsite-faq")
], un);
const D1 = ":host{display:block;width:100%}.vh-microsite-faq-cards{display:flex;flex-direction:column;gap:24px;width:100%}.vh-microsite-faq-card{display:grid;gap:24px}@media screen and (min-width:1280px){.vh-microsite-faq-card--right{grid-template-columns:1fr var(--vh-faq-cards-desktop-question-width)}.vh-microsite-faq-card--right .vh-microsite-faq-card__number-card{order:2}.vh-microsite-faq-card--right .vh-microsite-faq-card__card{order:1}.vh-microsite-faq-card--left{grid-template-columns:var(--vh-faq-cards-desktop-question-width) 1fr}}.vh-microsite-faq-card__number-card{padding:40px 24px;display:flex;border-radius:16px;flex-direction:column;gap:24px;overflow:hidden}@media screen and (min-width:810px){.vh-microsite-faq-card__number-card{padding:40px;gap:0;flex-direction:row}}.vh-microsite-faq-card__number{display:block;font-family:var(--vh-font-poppins);font-size:24px;font-style:normal;font-weight:400;line-height:1.2}@media screen and (min-width:810px){.vh-microsite-faq-card__number{width:100px}.vh-microsite-faq-card__number--answer{display:flex;flex-direction:column;justify-content:flex-end}}.vh-microsite-faq-card__card{display:flex;padding:40px 24px;border-radius:16px;flex-direction:column;gap:24px}@media screen and (min-width:810px){.vh-microsite-faq-card__card{padding:40px;gap:0;flex-direction:row}}.vh-microsite-faq-card--left .vh-microsite-faq-card__number-card,.vh-microsite-faq-card--left .vh-microsite-faq-card__card{background:linear-gradient(310deg,#c5e86c 4.72%,#e9f9c1 104.65%)}.vh-microsite-faq-card--right .vh-microsite-faq-card__number-card,.vh-microsite-faq-card--right .vh-microsite-faq-card__card{background:var(--vh-color-white);border:2px solid var(--vh-color-light-green)}.vh-microsite-faq-card__question{font-family:var(--vh-font-feature-display-condensed);font-size:54px;font-style:normal;font-weight:400;line-height:1}@media screen and (min-width:810px){.vh-microsite-faq-card__question{font-size:62px}}.vh-microsite-faq-card__question{color:var(--vh-color-navy);flex:1}.vh-microsite-faq-card__answer{font-family:var(--vh-font-poppins);font-size:18px;font-style:normal;font-weight:400;line-height:1.2;color:var(--vh-color-navy);font-weight:300;line-height:1.4;flex:1}.vh-microsite-faq-card__answer strong{font-weight:600}.vh-microsite-faq-card__answer p{margin-top:0}.vh-microsite-faq-card--pre-animate .vh-microsite-faq-card__number-card,.vh-microsite-faq-card--pre-animate .vh-microsite-faq-card__card{opacity:0}.vh-microsite-faq-card--animate.vh-microsite-faq-card--left .vh-microsite-faq-card__number-card{opacity:0;animation:fadeIn .3s ease-out forwards,slideFromLeft .5s ease-out forwards}.vh-microsite-faq-card--animate.vh-microsite-faq-card--left .vh-microsite-faq-card__card,.vh-microsite-faq-card--animate.vh-microsite-faq-card--right .vh-microsite-faq-card__number-card{opacity:0;animation:fadeIn .3s ease-out forwards,slideFromRight .5s ease-out forwards}.vh-microsite-faq-card--animate.vh-microsite-faq-card--right .vh-microsite-faq-card__card,.vh-microsite-faq-card__number-card--mobile-animate{opacity:0;animation:fadeIn .3s ease-out forwards,slideFromLeft .5s ease-out forwards}.vh-microsite-faq-card__card--mobile-animate{opacity:0;animation:fadeIn .3s ease-out forwards,slideFromRight .5s ease-out forwards}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}@keyframes slideFromLeft{0%{transform:translate(-50px)}to{transform:translate(0)}}@keyframes slideFromRight{0%{transform:translate(50px)}to{transform:translate(0)}}";
var N1 = Object.defineProperty, O1 = Object.getOwnPropertyDescriptor, lh = (s, e, t, i) => {
  for (var n = i > 1 ? void 0 : i ? O1(e, t) : e, r = s.length - 1, a; r >= 0; r--)
    (a = s[r]) && (n = (i ? a(e, t, n) : a(n)) || n);
  return i && n && N1(e, t, n), n;
};
let Dr = class extends Ie {
  constructor() {
    super(...arguments), this.items = [], this.cardObservers = [], this.visibleRows = /* @__PURE__ */ new Set(), this.visibleCards = /* @__PURE__ */ new Set(), this.isMobile = !1, this.mediaHandler = (s) => {
      this.isMobile = !s.matches;
    };
  }
  connectedCallback() {
    super.connectedCallback(), this.mediaQuery = window.matchMedia("(min-width: 1280px)"), this.isMobile = !this.mediaQuery.matches, this.mediaQuery.addEventListener("change", this.mediaHandler), this.observer = new IntersectionObserver(
      (s) => {
        s.forEach((e) => {
          if (e.isIntersecting) {
            const t = Number(
              e.target.dataset.rowIndex
            );
            this.visibleRows.has(t) || (this.visibleRows.add(t), this.requestUpdate());
          }
        });
      },
      { threshold: 0.5 }
    );
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.observer?.disconnect(), this.cardObservers.forEach((s) => {
      s.disconnect();
    }), this.mediaQuery?.removeEventListener("change", this.mediaHandler);
  }
  setupCardObservers() {
    this.cardObservers.forEach((e) => {
      e.disconnect();
    }), this.cardObservers = [];
    const s = this.shadowRoot?.querySelectorAll(
      ".vh-microsite-faq-card__number-card, .vh-microsite-faq-card__card"
    );
    s && s.forEach((e) => {
      const t = new IntersectionObserver(
        (i) => {
          i.forEach((n) => {
            if (n.isIntersecting) {
              const r = n.target.dataset.cardKey;
              r && !this.visibleCards.has(r) && (this.visibleCards.add(r), this.requestUpdate());
            }
          });
        },
        { threshold: 0.3 }
      );
      t.observe(e), this.cardObservers.push(t);
    });
  }
  firstUpdated() {
    this.shadowRoot?.querySelectorAll(".vh-microsite-faq-card")?.forEach((e) => {
      this.observer?.observe(e);
    }), this.setupCardObservers();
  }
  updated() {
    this.shadowRoot?.querySelectorAll(".vh-microsite-faq-card")?.forEach((e) => {
      e.getAttribute("data-observed") || (e.setAttribute("data-observed", "true"), this.observer?.observe(e));
    });
  }
  render() {
    return $`
      <div class="vh-microsite-faq-cards">
        ${this.items.map((s, e) => {
      const t = this.visibleRows.has(e), i = `${e}-question`, n = `${e}-answer`, r = this.isMobile ? this.visibleCards.has(i) : t, a = this.isMobile ? this.visibleCards.has(n) : t;
      return $`
            <div class="${Ze({
        "vh-microsite-faq-card": !0,
        "vh-microsite-faq-card--left": !!s.questionLeft,
        "vh-microsite-faq-card--right": !s.questionLeft,
        "vh-microsite-faq-card--pre-animate": !0,
        "vh-microsite-faq-card--animate": !this.isMobile && t
      })}" style="--vh-faq-cards-desktop-question-width: ${s.desktopQuestionWidth || "448px"}" data-row-index="${e}">
              <div class=${Ze({
        "vh-microsite-faq-card__number-card": !0,
        "vh-microsite-faq-card__number-card--mobile-animate": this.isMobile && r
      })} data-card-key="${i}">
                <div class="vh-microsite-faq-card__number vh-microsite-faq-card__number--question" >${s.number}</div>
                <div class="vh-microsite-faq-card__question">${Qe(s.question)}</div>
              </div>
              <div class=${Ze({
        "vh-microsite-faq-card__card": !0,
        "vh-microsite-faq-card__card--mobile-animate": this.isMobile && a
      })} data-card-key="${n}">
                <div class="vh-microsite-faq-card__number vh-microsite-faq-card__number--answer">${s.number}</div>
                <div class="vh-microsite-faq-card__answer">${Qe(s.answer)}</div>
              </div>
            </div>
          `;
    })}
      </div>
    `;
  }
};
Dr.styles = Je`
    ${We(D1)}
  `;
lh([
  D({ type: Array })
], Dr.prototype, "items", 2);
lh([
  D({ type: Boolean })
], Dr.prototype, "isMobile", 2);
Dr = lh([
  Oe("vh-microsite-faq-cards")
], Dr);
const U1 = ".scroll-continue{position:fixed;bottom:40px;right:40px;z-index:100;display:flex;flex-direction:column;align-items:center;gap:16px;opacity:1;transition:opacity .4s ease-out;pointer-events:none}@media screen and (max-width:600px){.scroll-continue{display:none}}.scroll-continue vh-icon-scroll{animation:bounce .5s ease-in-out infinite}@keyframes bounce{0%,to{transform:translateY(0)}50%{transform:translateY(-8px)}}.scroll-continue--hidden{opacity:0}.scroll-continue__label{font-family:var(--vh-font-poppins);font-size:14px;font-style:normal;font-weight:300;line-height:1.3;font-weight:600;line-height:1.2;color:var(--vh-color-navy);text-align:center;border:1px solid rgba(255,255,255,.5);padding:9px;border-radius:20px;background-color:#ffffff80}";
var F1 = Object.defineProperty, B1 = Object.getOwnPropertyDescriptor, Cf = (s, e, t, i) => {
  for (var n = i > 1 ? void 0 : i ? B1(e, t) : e, r = s.length - 1, a; r >= 0; r--)
    (a = s[r]) && (n = (i ? a(e, t, n) : a(n)) || n);
  return i && n && F1(e, t, n), n;
};
let Ya = class extends Ie {
  constructor() {
    super(...arguments), this.isHidden = !1, this.scrollHandler = () => {
      !this.isHidden && window.scrollY > 0 && (this.isHidden = !0);
    };
  }
  connectedCallback() {
    super.connectedCallback(), window.addEventListener("scroll", this.scrollHandler, { passive: !0 });
  }
  disconnectedCallback() {
    super.disconnectedCallback(), window.removeEventListener("scroll", this.scrollHandler);
  }
  render() {
    return $`
      <div class="scroll-continue ${this.isHidden ? "scroll-continue--hidden" : ""}">
        <vh-icon-scroll size="48" color="var(--vh-color-light-green)"></vh-icon-scroll>
        <span class="scroll-continue__label">Scroll to Continue</span>
      </div>
    `;
  }
};
Ya.styles = Je`
    ${We(U1)}
  `;
Cf([
  D({ type: Boolean })
], Ya.prototype, "isHidden", 2);
Ya = Cf([
  Oe("vh-microsite-scroll-continue")
], Ya);
const k1 = ".vh-microsite-image-details{padding:80px 24px;overflow:hidden}@media screen and (min-width:810px){.vh-microsite-image-details{overflow:visible;padding:100px 24px}}.vh-microsite-image-details__inner{margin:0 auto;text-align:center;display:flex;flex-direction:column;gap:24px;max-width:960px}@media screen and (min-width:810px){.vh-microsite-image-details__inner{gap:40px}}.vh-microsite-image-details--image{background-color:var(--vh-color-light-gray);max-width:none;padding:80px 0 0}.vh-microsite-image-details--image .vh-microsite-image-details__heading,.vh-microsite-image-details--image .vh-microsite-image-details__content{padding:0 24px}.vh-microsite-image-details--image .vh-microsite-image-details__inner{max-width:var(--vh-max-width-medium)}.vh-microsite-image-details__heading{font-family:var(--vh-font-feature-display-condensed);font-size:54px;font-style:normal;font-weight:400;line-height:1}@media screen and (min-width:810px){.vh-microsite-image-details__heading{font-size:62px}}.vh-microsite-image-details__heading{color:var(--vh-color-navy);margin:0;padding:0}.vh-microsite-image-details__heading strong{font-style:italic}h1.vh-microsite-image-details__heading{font-family:var(--vh-font-feature-display-condensed);font-size:44px;font-style:normal;font-weight:400;line-height:1}@media screen and (min-width:810px){h1.vh-microsite-image-details__heading{font-size:92px}}.vh-microsite-image-details__body{color:var(--vh-color-navy);font-family:var(--vh-font-poppins);font-size:16px;font-style:normal;font-weight:400;line-height:1.5}.vh-microsite-image-details__body p{margin-top:0}.vh-microsite-image-details__content{display:flex;flex-direction:column;gap:16px}.vh-microsite-image-details__list{list-style:none;padding:0;margin:0;display:flex;flex-direction:column;gap:8px;align-items:center}@media screen and (min-width:810px){.vh-microsite-image-details__list{gap:16px;flex-direction:row;justify-content:center}}.vh-microsite-image-details__list-item{font-family:var(--vh-font-poppins);font-size:16px;font-style:normal;font-weight:400;line-height:1.5;display:flex;align-items:center;gap:8px;color:var(--vh-color-navy)}.vh-microsite-image-details__image-wrapper{position:relative}.vh-microsite-image-details__image{width:100%;display:block}.vh-microsite-image-details__image--pre-animate{opacity:0}.vh-microsite-image-details__image--animate{opacity:0;animation:fadeInFromLeft 1s ease-out forwards;animation-delay:.3s}.vh-microsite-image-details__image img{width:100%;display:block}.vh-microsite-image-details__details{position:absolute;top:0;left:0;aspect-ratio:1;opacity:0;z-index:1;transition:opacity .3s ease-in-out;display:none;justify-content:center;align-items:center}.vh-microsite-image-details__details:hover{opacity:.9}.vh-microsite-image-details__details vh-icon-details{display:block;width:22px;height:22px}@media screen and (min-width:811px){.vh-microsite-image-details__details{display:flex}}.vh-microsite-image-details__details-text{font-family:var(--vh-font-poppins);font-size:16px;font-style:normal;font-weight:400;line-height:1.5;font-weight:600;color:var(--vh-color-navy);background-color:var(--vh-color-white);border-radius:8px;padding:16px;display:inline-flex;gap:8px;justify-content:center;align-items:center;text-align:left}@media screen and (min-width:1280px){.vh-microsite-image-details__details-text{font-family:var(--vh-font-poppins);font-size:18px;font-style:normal;font-weight:400;line-height:1.2;font-weight:600;padding:24px}}.vh-microsite-image-details__inner--pre-animate .vh-microsite-image-details__heading,.vh-microsite-image-details__inner--pre-animate .vh-microsite-image-details__body,.vh-microsite-image-details__inner--pre-animate .vh-microsite-image-details__list-item{opacity:0}.vh-microsite-image-details__list-item--animate{opacity:0;animation:fadeInFromRight 1s ease-out forwards;animation-delay:calc(.5s + var(--animation-order) * .2s)}.vh-microsite-image-details__inner--animate-text .vh-microsite-image-details__heading{opacity:0;animation:fadeInFromRight 1s ease-out forwards}.vh-microsite-image-details__inner--animate-text .vh-microsite-image-details__body{opacity:0;animation:fadeInFromRight 1s ease-out forwards;animation-delay:1.2s}@keyframes fadeInFromRight{0%{opacity:0;transform:translate(50px)}to{opacity:1;transform:translate(0)}}@keyframes fadeInFromLeft{0%{opacity:0;transform:translate(-50px)}to{opacity:1;transform:translate(0)}}";
var z1 = Object.defineProperty, V1 = Object.getOwnPropertyDescriptor, pn = (s, e, t, i) => {
  for (var n = i > 1 ? void 0 : i ? V1(e, t) : e, r = s.length - 1, a; r >= 0; r--)
    (a = s[r]) && (n = (i ? a(e, t, n) : a(n)) || n);
  return i && n && z1(e, t, n), n;
};
let Ci = class extends Ie {
  constructor() {
    super(...arguments), this.isVisible = !1, this.isImageVisible = !1;
  }
  connectedCallback() {
    super.connectedCallback(), this.setupIntersectionObserver();
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.observer?.disconnect(), this.imageObserver?.disconnect();
  }
  setupIntersectionObserver() {
    this.observer = new IntersectionObserver(
      (s) => {
        s.forEach((e) => {
          e.isIntersecting && !this.isVisible && (this.isVisible = !0);
        });
      },
      {
        threshold: 0.3
      }
    ), this.imageObserver = new IntersectionObserver(
      (s) => {
        s.forEach((e) => {
          e.isIntersecting && !this.isImageVisible && (this.isImageVisible = !0);
        });
      },
      { threshold: 0.3 }
    );
  }
  firstUpdated() {
    const s = this.shadowRoot?.querySelector(
      ".vh-microsite-image-details"
    );
    s && this.observer && this.observer.observe(s);
    const e = this.shadowRoot?.querySelector(
      ".vh-microsite-image-details__image"
    );
    e && this.imageObserver && this.imageObserver.observe(e);
  }
  render() {
    const s = this.isVisible;
    return $`
      <section class=${Ze({
      "vh-microsite-image-details": !0,
      "vh-microsite-image-details--image": !!this.image
    })}>
      <div class=${Ze({
      "vh-microsite-image-details__inner": !0,
      "vh-microsite-image-details__inner--pre-animate": !0,
      "vh-microsite-image-details__inner--animate-text": s
    })}>
        <h2 class="vh-microsite-image-details__heading">${Qe(this.heading)}</h2>
          <div class="vh-microsite-image-details__content">
            ${this.list?.length ? $`<ul class="vh-microsite-image-details__list">${this.list.map((e, t) => $`<li class=${Ze({ "vh-microsite-image-details__list-item": !0, "vh-microsite-image-details__list-item--animate": s })} style="--animation-order: ${t + 1}"><vh-icon-checkmark></vh-icon-checkmark> ${Qe(e)}</li>`)}</ul>` : ""}
            <div class="vh-microsite-image-details__body">${Qe(this.body)}</div>
          </div>
          <div class="vh-microsite-image-details__image-wrapper">
            ${this.imageMap?.map(
      (e) => $`
              <div class="vh-microsite-image-details__details" style="top: ${e.top}; left: ${e.left}; width: ${e.width};">
                <div class="vh-microsite-image-details__details-text">
                  <vh-icon-details></vh-icon-details>
                  <span>${e.text}</span>
                </div>
              </div>`
    )}
            ${this.image ? $`
              <picture class=${Ze({
      "vh-microsite-image-details__image": !0,
      "vh-microsite-image-details__image--pre-animate": !0,
      "vh-microsite-image-details__image--animate": this.isImageVisible
    })}>
                <source srcset="${this.imageMobile || this.image}" media="(max-width: 810px)">
                <source srcset="${this.image}" media="(min-width: 811px)">
                <img src="${this.image}" alt="">
              </picture>` : ""}
        </div>
      </div>
      </section>
    `;
  }
};
Ci.styles = Je`
    ${We(k1)}
  `;
pn([
  D()
], Ci.prototype, "heading", 2);
pn([
  D({ type: Array })
], Ci.prototype, "list", 2);
pn([
  D()
], Ci.prototype, "body", 2);
pn([
  D()
], Ci.prototype, "image", 2);
pn([
  D()
], Ci.prototype, "imageMobile", 2);
pn([
  D({ type: Array })
], Ci.prototype, "imageMap", 2);
pn([
  D({ type: Boolean })
], Ci.prototype, "isVisible", 2);
pn([
  D({ type: Boolean })
], Ci.prototype, "isImageVisible", 2);
Ci = pn([
  Oe("vh-microsite-image-details")
], Ci);
const H1 = ':host{display:block}.timeline-gallery{position:relative;width:100%}.timeline-gallery__sections-inner{overflow:hidden;padding-bottom:var(--vh-spacing-2xl, 50vh)}.timeline-gallery__sticky-sentinel{height:1px;margin:0;padding:0;pointer-events:none;visibility:hidden}.timeline-gallery__sticky-slot{position:sticky;top:calc((100vh - 584px)/2);overflow:visible;z-index:10;transition:top .35s ease-out;margin-bottom:calc(85vh - 560px)}.timeline-gallery__sticky-box{width:100%;max-width:695px;margin:0 auto;padding:0 24px;box-sizing:border-box;pointer-events:none;transition:transform .35s ease-out;opacity:0}.timeline-gallery__sticky-slot[data-box-in-view] .timeline-gallery__sticky-box{animation:timeline-gallery-box-fade-in 2s ease-out forwards}@keyframes timeline-gallery-box-fade-in{0%{opacity:0}to{opacity:1}}.timeline-gallery__sticky-box vh-microsite-timeline-box{pointer-events:auto}.gallery-section{position:relative;display:flex;flex-direction:column;height:100vh;max-height:960px;width:100%;max-width:1600px;margin-left:auto;margin-right:auto;overflow:visible}.gallery-section:first-of-type{position:absolute;top:0;left:50%;transform:translate(-50%);width:100%;max-width:1600px}.gallery-section__copy{display:none;flex:0 0 auto;width:100%;max-width:695px;margin:0 auto;background-color:#ffffffb3;box-sizing:border-box}.gallery-section__year{text-align:center;margin:0;padding:0;font-variant-numeric:tabular-nums;color:var(--VH-Light-Green, #84c12f);font-family:var(--vh-font-feature-display-condensed, "Feature Display Condensed"),sans-serif;font-size:30vw;font-style:italic;font-weight:800;line-height:100%;letter-spacing:-.04em}.gallery-section__description{box-sizing:border-box;background-color:#fff9;border-top:1px solid var(--vh-color-light-green);border-bottom:1px solid var(--vh-color-light-green);display:flex;align-items:center;justify-content:center;padding:24px;width:100%}@media screen and (min-width:600px){.gallery-section__description{padding:40px 32px}}.gallery-section__text{font-family:var(--vh-font-poppins);font-size:20px;font-style:normal;font-weight:400;line-height:1.2;font-size:14px;color:var(--vh-color-navy);text-align:center;margin:0}.gallery-section__text strong{font-weight:600}.gallery-section__media{position:relative;flex:1;min-height:0}.gallery-section__slider-wrapper{position:absolute;left:50%;transform:translate(-50%);width:var(--vh-fullscreen-max-width);top:0;bottom:0;z-index:0;perspective:1400px}.gallery-section__slider{width:100%;height:67%;object-fit:cover;object-position:right center;opacity:0}.gallery-section.in-view .gallery-section__slider{animation:timeline-gallery-fade-in 1.5s ease-out forwards,timeline-gallery-slow-scroll 50s ease-in-out 1s infinite}.gallery-section__quadrants{position:absolute;inset:0;z-index:1;pointer-events:none;display:grid;grid-template-columns:1fr 1fr;grid-template-rows:1fr 1fr;overflow:visible}.quadrant{position:relative;width:100%;height:100%;overflow:visible}.quadrant-img{position:absolute;height:auto;opacity:0;transform-style:preserve-3d}.quadrant-img--from-left{transform:translate(-80px) scale(.98) translateZ(-5px)}.gallery-section.in-view .quadrant-img--from-left{animation:timeline-gallery-slide-in-from-left 2s ease-out forwards}.quadrant-img--from-right{transform:translate(80px) scale(.98) translateZ(-5px)}.gallery-section.in-view .quadrant-img--from-right{animation:timeline-gallery-slide-in-from-right 2s ease-out forwards}@keyframes timeline-gallery-fade-in{0%{opacity:0}to{opacity:1}}@keyframes timeline-gallery-slow-scroll{0%{object-position:100% center}50%{object-position:0% center}to{object-position:100% center}}@keyframes timeline-gallery-slide-in-from-right{0%{opacity:0;transform:translate(80px) scale(.98) translateZ(-5px)}40%{opacity:1;transform:translate(0) scale(.98) translateZ(-5px)}to{opacity:1;transform:translate(0) scale(1) translateZ(0)}}@keyframes timeline-gallery-slide-in-from-left{0%{opacity:0;transform:translate(-80px) scale(.98) translateZ(-5px)}40%{opacity:1;transform:translate(0) scale(.98) translateZ(-5px)}to{opacity:1;transform:translate(0) scale(1) translateZ(0)}}@media(min-width:601px)and (max-width:860px){.quadrant-img{width:90%!important}}@media(max-width:600px){.timeline-gallery__sticky-slot,.timeline-gallery__sticky-sentinel{display:none}.gallery-section__quadrants{display:flex;flex-direction:column;position:relative}.quadrant{width:100%;min-height:0}.quadrant-img{position:relative!important;width:100%!important;max-width:100%;inset:auto!important;transform:none!important}.gallery-section{height:auto;min-height:auto;max-height:none}.gallery-section:first-of-type{position:relative;width:100%}.gallery-section__media{flex:none}.gallery-section__slider-wrapper{position:relative;width:100%;height:420px}.gallery-section__slider{width:100%;height:100%;object-fit:cover;object-position:center center}.gallery-section.in-view .gallery-section__slider{animation:none;opacity:1}.gallery-section__copy{display:block;width:100%;max-width:none}.timeline-gallery__sections-inner{padding-bottom:60px}}';
var $1 = Object.defineProperty, G1 = Object.getOwnPropertyDescriptor, vo = (s, e, t, i) => {
  for (var n = i > 1 ? void 0 : i ? G1(e, t) : e, r = s.length - 1, a; r >= 0; r--)
    (a = s[r]) && (n = (i ? a(e, t, n) : a(n)) || n);
  return i && n && $1(e, t, n), n;
};
let $s = class extends Ie {
  constructor() {
    super(...arguments), this.sections = [], this._activeSectionIndex = 0, this._boxInView = !1, this._inViewObserver = null, this._activeObserver = null, this._boxInViewObserver = null, this._sectionRatios = /* @__PURE__ */ new Map();
  }
  connectedCallback() {
    super.connectedCallback();
  }
  firstUpdated() {
    const s = this.shadowRoot;
    if (!s) return;
    const e = s.querySelector(
      ".timeline-gallery__sticky-slot"
    );
    e && (this._boxInViewObserver = new IntersectionObserver(
      (r) => {
        r[0]?.isIntersecting && (this._boxInView = !0, this._boxInViewObserver?.disconnect());
      },
      { threshold: 0, rootMargin: "0px" }
    ), this._boxInViewObserver.observe(e));
    const t = s.querySelectorAll(
      "[data-gallery-section]"
    );
    if (!t.length) return;
    const i = { threshold: 0.15, rootMargin: "0px" };
    this._inViewObserver = new IntersectionObserver((r) => {
      for (const a of r)
        a.isIntersecting && (a.target.classList.add("in-view"), this._inViewObserver?.unobserve(a.target));
    }, i), t.forEach((r) => this._inViewObserver.observe(r));
    const n = {
      threshold: [0, 0.25, 0.5, 0.75, 1],
      rootMargin: "0px"
    };
    this._activeObserver = new IntersectionObserver((r) => {
      for (const l of r) {
        const c = l.target, h = parseInt(
          c.getAttribute("data-gallery-section") ?? "-1",
          10
        );
        h >= 0 && this._sectionRatios.set(h, l.intersectionRatio);
      }
      let a = 0, o = 0;
      this._sectionRatios.forEach((l, c) => {
        l > o && (o = l, a = c);
      }), a !== this._activeSectionIndex && (this._activeSectionIndex = a);
    }, n), t.forEach((r) => this._activeObserver.observe(r));
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this._inViewObserver?.disconnect(), this._inViewObserver = null, this._activeObserver?.disconnect(), this._activeObserver = null, this._boxInViewObserver?.disconnect(), this._boxInViewObserver = null;
  }
  renderSlider(s) {
    const e = s.sliderBackgroundImage;
    return e ? $`
      <div class="gallery-section__slider-wrapper">
        <img
          class="gallery-section__slider"
          src="${e.src}"
          alt="${e.alt}"
        />
      </div>
    ` : null;
  }
  /** Position image relative to its quadrant (offsetX/offsetY in % from that quadrant’s corner). Width in % or auto. */
  quadrantStyle(s, e) {
    const { width: t, offsetX: i, offsetY: n } = s, r = t === "auto" ? "width: auto;" : `width: ${t}%;`;
    switch (e) {
      case "q1":
        return `${r} height: auto; left: ${i}%; top: ${n}%;`;
      case "q2":
        return `${r} height: auto; right: ${i}%; top: ${n}%;`;
      case "q3":
        return `${r} height: auto; left: ${i}%; bottom: ${n}%;`;
      case "q4":
        return `${r} height: auto; right: ${i}%; bottom: ${n}%;`;
    }
  }
  /** Stagger index for each quadrant in this section (0 = first image, 1 = second, …). Only quadrants with an image get an index. */
  getStaggerIndices(s) {
    const e = {};
    let t = 0;
    return s.q1Image && (e.q1 = t++), s.q2Image && (e.q2 = t++), s.q3Image && (e.q3 = t++), s.q4Image && (e.q4 = t++), e;
  }
  renderQuadrantImage(s, e, t) {
    if (!s) return null;
    const i = e === "q1" || e === "q3", n = t !== void 0 ? `${0.5 + t * 0.5}s` : "0s", r = `${this.quadrantStyle(s, e)} animation-delay: ${n};`;
    return $`
      <img
        class="quadrant-img quadrant-img--${e} ${i ? "quadrant-img--from-left" : "quadrant-img--from-right"}"
        src="${s.src}"
        alt="${s.alt}"
        style="${r}"
        loading="lazy"
      />
    `;
  }
  get _currentEvent() {
    const s = this.sections[this._activeSectionIndex];
    return s ? { year: s.year, description: s.description } : { year: "", description: "" };
  }
  render() {
    return $`
      <div class="timeline-gallery">
        <div class="timeline-gallery__sticky-slot" ?data-box-in-view=${this._boxInView}>
          <div class="timeline-gallery__sticky-box">
            <vh-microsite-timeline-box
              .events=${[this._currentEvent]}
              ?animateIn=${!0}
            ></vh-microsite-timeline-box>
          </div>
        </div>
        <div class="timeline-gallery__sticky-sentinel" data-sticky-sentinel aria-hidden="true"></div>
        <div class="timeline-gallery__sections">
          <div class="timeline-gallery__sections-inner">
            ${this.sections.map((s, e) => {
      const t = this.getStaggerIndices(s);
      return $`
                <div
                  class="gallery-section"
                  data-gallery-section="${e}"
                >
                  <div class="gallery-section__copy">
                    <div class="gallery-section__year">${s.year}</div>
                    <div class="gallery-section__description">
                      <p class="gallery-section__text">${Qe(s.description)}</p>
                    </div>
                  </div>
                  <div class="gallery-section__media">
                    ${this.renderSlider(s)}
                    <div class="gallery-section__quadrants">
                      <div class="quadrant quadrant--q1">${this.renderQuadrantImage(s.q1Image, "q1", t.q1)}</div>
                      <div class="quadrant quadrant--q2">${this.renderQuadrantImage(s.q2Image, "q2", t.q2)}</div>
                      <div class="quadrant quadrant--q3">${this.renderQuadrantImage(s.q3Image, "q3", t.q3)}</div>
                      <div class="quadrant quadrant--q4">${this.renderQuadrantImage(s.q4Image, "q4", t.q4)}</div>
                    </div>
                  </div>
                </div>
              `;
    })}
          </div>
        </div>
      </div>
    `;
  }
};
$s.styles = Je`
    ${We(H1)}
  `;
vo([
  D({ type: Array })
], $s.prototype, "sections", 2);
vo([
  ft()
], $s.prototype, "_activeSectionIndex", 2);
vo([
  ft()
], $s.prototype, "_boxInView", 2);
$s = vo([
  Oe("vh-microsite-timeline-gallery")
], $s);
var q1 = Object.defineProperty, W1 = Object.getOwnPropertyDescriptor, ch = (s, e, t, i) => {
  for (var n = i > 1 ? void 0 : i ? W1(e, t) : e, r = s.length - 1, a; r >= 0; r--)
    (a = s[r]) && (n = (i ? a(e, t, n) : a(n)) || n);
  return i && n && q1(e, t, n), n;
};
let Ka = class extends Ie {
  constructor() {
    super(...arguments), this.size = 22, this.color = "#84C12F";
  }
  render() {
    return $`
      <svg xmlns="http://www.w3.org/2000/svg" width="${this.size}" height="${this.size}" fill="none" style="display:block" viewBox="0 0 24 24"><path stroke="${this.color}" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10"/><path stroke="${this.color}" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m9 12 2 2 4-4"/></svg>
    `;
  }
};
ch([
  D({ type: Number })
], Ka.prototype, "size", 2);
ch([
  D({ type: String })
], Ka.prototype, "color", 2);
Ka = ch([
  Oe("vh-icon-checkmark")
], Ka);
var X1 = Object.defineProperty, j1 = Object.getOwnPropertyDescriptor, hh = (s, e, t, i) => {
  for (var n = i > 1 ? void 0 : i ? j1(e, t) : e, r = s.length - 1, a; r >= 0; r--)
    (a = s[r]) && (n = (i ? a(e, t, n) : a(n)) || n);
  return i && n && X1(e, t, n), n;
};
let Za = class extends Ie {
  constructor() {
    super(...arguments), this.size = 22, this.color = "#84C12F";
  }
  render() {
    return $`
      <svg xmlns="http://www.w3.org/2000/svg" width="${this.size}" height="${this.size}" fill="none" style="display:block" viewBox="0 0 24 24"><path stroke="${this.color}" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76"/><path stroke="var(--vh-color-navy)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m9 12 2 2 4-4"/></svg>
    `;
  }
};
hh([
  D({ type: Number })
], Za.prototype, "size", 2);
hh([
  D({ type: String })
], Za.prototype, "color", 2);
Za = hh([
  Oe("vh-icon-guarantee")
], Za);
var Y1 = Object.defineProperty, K1 = Object.getOwnPropertyDescriptor, dh = (s, e, t, i) => {
  for (var n = i > 1 ? void 0 : i ? K1(e, t) : e, r = s.length - 1, a; r >= 0; r--)
    (a = s[r]) && (n = (i ? a(e, t, n) : a(n)) || n);
  return i && n && Y1(e, t, n), n;
};
let Ja = class extends Ie {
  constructor() {
    super(...arguments), this.size = 16, this.color = "#025F1D";
  }
  render() {
    return $`
      <svg xmlns="http://www.w3.org/2000/svg" width="${this.size}" height="${this.size}" style="display:block" fill="none" viewBox="0 0 24 24"><path stroke="${this.color}" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 6 6 18M6 6l12 12"/></svg>
    `;
  }
};
dh([
  D({ type: Number })
], Ja.prototype, "size", 2);
dh([
  D({ type: String })
], Ja.prototype, "color", 2);
Ja = dh([
  Oe("vh-icon-close")
], Ja);
var Z1 = Object.defineProperty, J1 = Object.getOwnPropertyDescriptor, uh = (s, e, t, i) => {
  for (var n = i > 1 ? void 0 : i ? J1(e, t) : e, r = s.length - 1, a; r >= 0; r--)
    (a = s[r]) && (n = (i ? a(e, t, n) : a(n)) || n);
  return i && n && Z1(e, t, n), n;
};
let Qa = class extends Ie {
  constructor() {
    super(...arguments), this.size = 32, this.color = "#002C4E";
  }
  render() {
    return $`
      <svg xmlns="http://www.w3.org/2000/svg" width="${this.size}" height="${this.size}" fill="none" viewBox="0 0 32 32"><path stroke="${this.color}" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M26.667 10.667H13.333a2.667 2.667 0 0 0-2.667 2.666v13.333a2.667 2.667 0 0 0 2.667 2.667h13.333a2.667 2.667 0 0 0 2.667-2.666V13.333a2.667 2.667 0 0 0-2.666-2.667"/><path stroke="${this.color}" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5.333 21.333a2.675 2.675 0 0 1-2.666-2.666V5.333c0-1.467 1.2-2.666 2.666-2.666h13.334c1.466 0 2.666 1.2 2.666 2.666"/></svg>
    `;
  }
};
uh([
  D({ type: Number })
], Qa.prototype, "size", 2);
uh([
  D({ type: String })
], Qa.prototype, "color", 2);
Qa = uh([
  Oe("vh-icon-copy")
], Qa);
var Q1 = Object.defineProperty, eM = Object.getOwnPropertyDescriptor, If = (s, e, t, i) => {
  for (var n = i > 1 ? void 0 : i ? eM(e, t) : e, r = s.length - 1, a; r >= 0; r--)
    (a = s[r]) && (n = (i ? a(e, t, n) : a(n)) || n);
  return i && n && Q1(e, t, n), n;
};
let _c = class extends Ie {
  constructor() {
    super(...arguments), this.color = "var(--vh-color-light-green)";
  }
  render() {
    return $`
      <svg xmlns="http://www.w3.org/2000/svg" style="width: 100%; height: auto;" fill="none" viewBox="0 0 50 50"><path fill="${this.color}" d="M25 0a25 25 0 1 0 0 50 25 25 0 0 0 0-50m-3.571 34.982L12.5 26.054l2.84-2.84 6.089 6.09L34.66 16.07l2.85 2.833z"/></svg>
    `;
  }
};
If([
  D({ type: String })
], _c.prototype, "color", 2);
_c = If([
  Oe("vh-icon-correct")
], _c);
var tM = Object.defineProperty, iM = Object.getOwnPropertyDescriptor, Pf = (s, e, t, i) => {
  for (var n = i > 1 ? void 0 : i ? iM(e, t) : e, r = s.length - 1, a; r >= 0; r--)
    (a = s[r]) && (n = (i ? a(e, t, n) : a(n)) || n);
  return i && n && tM(e, t, n), n;
};
let xc = class extends Ie {
  constructor() {
    super(...arguments), this.color = "var(--vh-color-orange)";
  }
  render() {
    return $`
      <svg xmlns="http://www.w3.org/2000/svg" style="width: 100%; height: auto;" fill="none" viewBox="0 0 50 50"><path fill="var(--vh-color-white)" d="M25 0a25 25 0 1 1 0 50 25 25 0 0 1 0-50m-.541 21.845-9.586-9.586-2.828 2.828 9.586 9.586-9.587 9.588 2.829 2.827 9.586-9.587 9.588 9.588 2.828-2.828-9.588-9.588 9.587-9.587-2.828-2.828z"/><path fill="${this.color}" d="M25 0a25 25 0 1 1 0 50 25 25 0 0 1 0-50m-.541 21.845-9.586-9.586-2.828 2.828 9.586 9.586-9.587 9.588 2.829 2.827 9.586-9.587 9.588 9.588 2.828-2.828-9.588-9.588 9.587-9.587-2.828-2.828z"/></svg>
    `;
  }
};
Pf([
  D({ type: String })
], xc.prototype, "color", 2);
xc = Pf([
  Oe("vh-icon-incorrect")
], xc);
var nM = Object.defineProperty, sM = Object.getOwnPropertyDescriptor, fh = (s, e, t, i) => {
  for (var n = i > 1 ? void 0 : i ? sM(e, t) : e, r = s.length - 1, a; r >= 0; r--)
    (a = s[r]) && (n = (i ? a(e, t, n) : a(n)) || n);
  return i && n && nM(e, t, n), n;
};
let eo = class extends Ie {
  constructor() {
    super(...arguments), this.size = 22, this.color = "#84C12F";
  }
  render() {
    return $`
      <svg xmlns="http://www.w3.org/2000/svg" width="${this.size}" height="${this.size}" fill="none" viewBox="0 0 24 24"><path stroke="${this.color}" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3 7V5a2 2 0 0 1 2-2h2M17 3h2a2 2 0 0 1 2 2v2M21 17v2a2 2 0 0 1-2 2h-2M7 21H5a2 2 0 0 1-2-2v-2M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6M16 16l-1.9-1.9"/></svg>
    `;
  }
};
fh([
  D({ type: Number })
], eo.prototype, "size", 2);
fh([
  D({ type: String })
], eo.prototype, "color", 2);
eo = fh([
  Oe("vh-icon-details")
], eo);
var rM = Object.defineProperty, aM = Object.getOwnPropertyDescriptor, ph = (s, e, t, i) => {
  for (var n = i > 1 ? void 0 : i ? aM(e, t) : e, r = s.length - 1, a; r >= 0; r--)
    (a = s[r]) && (n = (i ? a(e, t, n) : a(n)) || n);
  return i && n && rM(e, t, n), n;
};
let to = class extends Ie {
  constructor() {
    super(...arguments), this.size = 48, this.color = "#84C12F";
  }
  render() {
    return $`
      <svg xmlns="http://www.w3.org/2000/svg" width="${this.size}" height="${this.size}" fill="none" viewBox="0 0 48 48"><path stroke="${this.color}" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M38 18c0-7.732-6.268-14-14-14s-14 6.268-14 14v12c0 7.732 6.268 14 14 14s14-6.268 14-14zM24 12v8"/></svg>
    `;
  }
};
ph([
  D({ type: Number })
], to.prototype, "size", 2);
ph([
  D({ type: String })
], to.prototype, "color", 2);
to = ph([
  Oe("vh-icon-scroll")
], to);
console.log("JS Bundle Loaded - Version 2.0.0");
